/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		156: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/ 		script.crossOrigin = "anonymous";
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + chunkId + "." + {"0":"bd9895ddfe1900cd55a8","1":"4b7e5d7c6e09a3562145","2":"c454a303332d40ca86b8","3":"40ae27b3db23a3cb3098","4":"e3273b6470bd6e7606c1","5":"15cbcc0e2363bd3e217a","6":"1fa7f3e5696518e597c9","7":"04c6faa0bfdbda59890c","8":"862d966ea1e66a3088be","9":"471d98f885e88dac3ab0","10":"ab9371284f2eb34bc83f","11":"c3f227ebb74ae441a054","12":"9ae7cfb1755d4154a6ae","13":"43e1be2a3f9d8ecc7496","14":"47492d96fd76c9e147b9","15":"8cd9167dff7b2d41702c","16":"fe39e4062fdf413ef287","17":"cdae514a3f2ab0623b03","18":"89e6bc4d809bf4366d2f","19":"21ca1d7b7084489e68b7","20":"f30cd9549a645cc7c254","21":"9de6e3dda01952cf606d","22":"5af8c4f761bb4da603b0","23":"43a689c1013cc4df7498","24":"1d8f0357e21e8aaf3d16","25":"bd55d02f440aad29be77","26":"6ab9ddc617fc29ebb7e9","27":"3529232bae3e64adcd5a","28":"d313640209289b64d410","29":"a74f397e71b6b395b034","30":"63c78e92667d1eb98bb4","31":"300f9a5f345954cf9323","32":"f3e77fd55a13d90a9ebc","33":"ced3b3f4965cda82137f","34":"f398d3ac5ed837f28ca2","35":"e61341bf6fcc4314fadf","36":"5f849a0989a386223e8d","37":"017535189859d25c73b3","38":"08bdfa7ce0afb71d63a5","39":"b1bce238a6b8cfdd98e7","40":"2e47d5677fa180a32aa6","41":"e3b008821e9f8a1e0665","42":"f8d2288f359e65a4e08b","43":"62e945bb3cb57571b83d","44":"3841a532b6a9235eac14","45":"1618fd59339ef837b5bd","46":"dd5fb7b39d2114a2a45e","47":"54ddd7b813af78acc443","48":"de56e4b2e2f7f444d122","49":"f78fc2a1fde0805fcdaf","50":"c2b5ec40791fdc432185","51":"2543ef1c8afda0a913e1","52":"d225c4f65f57289260b3","53":"5d2a9294663c2398f91c","54":"65f52568f7f64831971f","55":"6c11eeb57b8b5272fd8a","56":"ad5e3dfd3423e6894dcc","57":"1db983b05b99f4d00da8","58":"e30d26750e77955843da","59":"a4cee744f3817a3b09ea","60":"982012bd52a9785710dc","61":"daa8b1a3b4fee7d0b253","62":"1fe09407d7228d025cc7","63":"5aac594a49aabddeb532","64":"f9610a4ed9f081f7c94f","65":"ddadf2e58d14f5fa37b9","66":"a810ab7a6b10d743c88d","67":"9adc4353b605e97dbbef","68":"0c000fbe1fc20f8513b3","69":"9ddeffac8b3dcbb616e0","70":"0a60cb770daaa28be0f8","71":"40ac232cb3aef82c57e8","72":"cf52cc6bcce84a6e9237","73":"11680dc977aca0bcfa14","74":"04da4a0cf2aba82d3654","75":"ff00639a18c6af23a55a","76":"5a08afdef5f9797a0477","77":"cc8e8af1b87351b60eec","78":"a4de8c884388769092e3","79":"225eb93c8724acd01442","80":"048a6bf6aa932ef888c7","81":"7d729c9ceeb015cab519","82":"a41462084121aff442c8","83":"522b8c043d3218178a63","84":"4e9a4186625b270ec853","85":"62c4653d604351d4e302","86":"0d93d454622314c5fcab","87":"20b8aa5099aa85cc38f9","88":"53104de1cfe78aafefa8","89":"0b4ebc2344cb5b912e3e","90":"76dfccadc363fbf57630","91":"5bbe94ed9876e288cb5c","92":"1b26e267077ff011d041","93":"b948e660f8b68258fb19","94":"33506a7fe24d0c79a950","95":"38c17f579c654706d861","96":"5b42da44cce895058959","97":"4fe438aee5ec67c3db85","98":"10ea23b3e2fbbff0bba0","99":"fdd7bbd336e9357bd55b","100":"2e9f4f68501508a5114a","101":"b9032821f51d38c46a63","102":"94c14434c4c0443d4a5a","103":"9f8dc48fc44f1efe8b22","104":"8548881d30e342736c89","105":"767d7ccc0441d8076797","106":"97c945ceb568408c36f8","107":"05d12bee877601eda199","108":"9b604ae74d8b5fd96117","109":"004570f2a232c002fe7f","110":"8925098e79049c14a7a5","111":"e0bb846679276c22d015","112":"500f7115f2c56836fff8","113":"5048bd1646130d644970","114":"5ac5183b1a4b548b3d67","115":"24fa49c4353e0719c093","116":"61c3529323e89a4f5da6","117":"af64c595a483191fc979","118":"1863f832b29a55398a6c","119":"a1ecaabca903b8e859fe","120":"9fb28891afbb99ea186b","121":"6a8b0d02051d4d23ed16","122":"395dd59d3edd9d41f809","123":"bc54a48e3ed2b808a685","124":"9f813a8e9ec23fbb752b","125":"b5e1a77b1f47a6985193","126":"a4f2f6740a0d7de3a969","127":"b7182d25510ff063b1f8","128":"68b5e994ef47500a2c18","129":"1526f6b55790aa1ee2bf","130":"63ff3053b7e42e7bb172","131":"72fa6b39582dc862b659","132":"472fda781ef6ce82db73","133":"560adbf03f409a97edb9","134":"6f3763430d302cc01d12","135":"c241a25364b0bf9cc930","136":"ce16f8dbc3d060d2f4e2","137":"c392bdf1be4183abe1ae","138":"bd283169df40d884dd4f","139":"d486a5a59ec4ba5449d0","140":"d2abd5a68683d38fab97","141":"058723ea09dc52543ab3","142":"2b3b733280b84f53d600","143":"97d1906fd5d13f7daff4","144":"90c39c19b99d4b70390e","145":"bfe38cf1daee61d440a4","146":"4bf32d99a07d4a4ed0f8","147":"a459ffe0dcd3cc8e2c4f","148":"62b321433a4ce02f6d1e","149":"cfc4f75d8f707f0265f2","150":"e4d6055c04ce74a81794","151":"2b82f293d315017d1d83","152":"8fa7b3e4ea6c4adc71ea","153":"57cf8607f2c1ee3c55b9","154":"20a514be31bc1d9a1eb7","155":"4cdb0caf5c2560a11a82"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//static.xinli001.com/cp/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "NHnr");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+2+s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__("Ds5P");
var $at = __webpack_require__("49qz")(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),

/***/ "+CM9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var $indexOf = __webpack_require__("ot5s")(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__("NNrz")($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),

/***/ "+E39":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("S82l")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "+Mt+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("Ds5P");
var core = __webpack_require__("7gX0");
var global = __webpack_require__("OzIq");
var speciesConstructor = __webpack_require__("7O1s");
var promiseResolve = __webpack_require__("nphH");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "+Yiy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+ZMJ":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("lOnJ");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "+ayu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("8Uqm");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),

/***/ "+eAd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_loadingIcon_vue_vue_type_style_index_0_id_488f1a6e_lang_scss_scoped_true___ = __webpack_require__("laHn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_loadingIcon_vue_vue_type_style_index_0_id_488f1a6e_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_loadingIcon_vue_vue_type_style_index_0_id_488f1a6e_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_loadingIcon_vue_vue_type_style_index_0_id_488f1a6e_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "+tPU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("xGkn");
var global = __webpack_require__("7KvD");
var hide = __webpack_require__("hJx8");
var Iterators = __webpack_require__("/bQp");
var TO_STRING_TAG = __webpack_require__("dSzd")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "+vXH":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("77Ug")('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "+yjc":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__("UKM+");

__webpack_require__("3i66")('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),

/***/ "//Fk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("U5ju"), __esModule: true };

/***/ }),

/***/ "/bQp":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "/n6Q":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("zQR9");
__webpack_require__("+tPU");
module.exports = __webpack_require__("Kh4W").f('iterator');


/***/ }),

/***/ "/vy1":
/***/ (function(module, exports) {

module.exports = {"code":"1","msg":"请求接口成功","data":{"algorithmType":1,"answerStyle":0,"curModuleId":590,"goodsType":0,"moduleConnectMode":0,"moduleIntro":"","questionnaireName":"疫情心理修复评估","showTip":false,"uiType":5,"whetherLastModule":true,"whetherMultiModule":false}}

/***/ }),

/***/ "/whu":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "06OY":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("3Eo+")('meta');
var isObject = __webpack_require__("EqjI");
var has = __webpack_require__("D2L2");
var setDesc = __webpack_require__("evD5").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("S82l")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "07k+":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("OzIq");
var hide = __webpack_require__("2p1q");
var uid = __webpack_require__("ulTY");
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),

/***/ "0Rih":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("OzIq");
var $export = __webpack_require__("Ds5P");
var redefine = __webpack_require__("R3AP");
var redefineAll = __webpack_require__("A16L");
var meta = __webpack_require__("1aA0");
var forOf = __webpack_require__("vmSO");
var anInstance = __webpack_require__("9GpA");
var isObject = __webpack_require__("UKM+");
var fails = __webpack_require__("zgIt");
var $iterDetect = __webpack_require__("qkyc");
var setToStringTag = __webpack_require__("yYvK");
var inheritIfRequired = __webpack_require__("kic5");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "0e3M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("+Yiy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "0j1G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("Ds5P");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ "0lbK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("wI4N");
var buildURL = __webpack_require__("PgLq");
var InterceptorManager = __webpack_require__("kTdg");
var dispatchRequest = __webpack_require__("G3K7");
var mergeConfig = __webpack_require__("voum");
var validator = __webpack_require__("ICW8");

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "0pGU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("DIVP");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0qX9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1/KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_count_down_vue_vue_type_style_index_0_id_3a5b6e03_lang_scss_scoped_true___ = __webpack_require__("qubT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_count_down_vue_vue_type_style_index_0_id_3a5b6e03_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_count_down_vue_vue_type_style_index_0_id_3a5b6e03_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_count_down_vue_vue_type_style_index_0_id_3a5b6e03_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "162o":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("mypn");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "1A13":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("49qz")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("uc2A")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "1ETD":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("kkCw")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "1H6C":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("HhN8");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ "1aA0":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("ulTY")('meta');
var isObject = __webpack_require__("UKM+");
var has = __webpack_require__("WBcL");
var setDesc = __webpack_require__("lDLk").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("zgIt")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "1g80":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1ip3":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),

/***/ "1kS7":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "1qR5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("8Uqm");
var bind = __webpack_require__("QRXx");
var Axios = __webpack_require__("bWSI");
var defaults = __webpack_require__("saHn");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("ohSy");
axios.CancelToken = __webpack_require__("2/+R");
axios.isCancel = __webpack_require__("m4Kp");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("l4ZY");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),

/***/ "1uLP":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");
$export($export.G + $export.W + $export.F * !__webpack_require__("07k+").ABV, {
  DataView: __webpack_require__("LrcN").DataView
});


/***/ }),

/***/ "2/+R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("ohSy");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/***/ }),

/***/ "21It":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("FtD3");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "2JP7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_global_ad_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("NdkX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_global_ad_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_global_ad_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_global_ad_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "2KxR":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "2VSL":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__("BbyF");
var repeat = __webpack_require__("xAdt");
var defined = __webpack_require__("/whu");

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),

/***/ "2lCz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2lwE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2p1q":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("lDLk");
var createDesc = __webpack_require__("fU25");
module.exports = __webpack_require__("bUqO") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "32VL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("0pGU");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "33LG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("344C");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "344C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ "3A6m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/imgDialog.vue?vue&type=template&id=1aa710f8&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-img"},[_c('myMask'),_vm._v(" "),_c('div',{staticClass:"modal-img-win flex flex--middle flex--center"},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.closeModal($event)}}},[_c('i',{staticClass:"icon-close"})]),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{ref:"modalContainer",staticClass:"modal-img-container"},[_vm._t("default")],2)],2)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/imgDialog.vue?vue&type=template&id=1aa710f8&

// EXTERNAL MODULE: ./src/components/common/mask.vue + 2 modules
var mask = __webpack_require__("m423");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/imgDialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var imgDialogvue_type_script_lang_js_ = ({
  name: 'modal',
  components: {
    myMask: mask["a" /* default */]
  },
  props: ['hideBtn'],
  data: function data() {
    return {
      testBScroll: null
    };
  },

  methods: {
    closeModal: function closeModal() {
      this.$emit('closeModal');
    }
  }
});
// CONCATENATED MODULE: ./src/components/imgDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_imgDialogvue_type_script_lang_js_ = (imgDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/imgDialog.vue?vue&type=style&index=0&lang=scss&
var imgDialogvue_type_style_index_0_lang_scss_ = __webpack_require__("XXhe");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/imgDialog.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_imgDialogvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var imgDialog = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "3Eo+":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "3QrE":
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__("Ds5P");

$export($export.P, 'Function', { bind: __webpack_require__("ZtwE") });


/***/ }),

/***/ "3fs2":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("RY/4");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var Iterators = __webpack_require__("/bQp");
module.exports = __webpack_require__("FeBl").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "3g/S":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("OzIq");
var core = __webpack_require__("7gX0");
var LIBRARY = __webpack_require__("V3l/");
var wksExt = __webpack_require__("M8WE");
var defineProperty = __webpack_require__("lDLk").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "3i66":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("Ds5P");
var core = __webpack_require__("7gX0");
var fails = __webpack_require__("zgIt");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "3q4u":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("wCso");
var anObject = __webpack_require__("DIVP");
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),

/***/ "3s83":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),

/***/ "3yIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__("Fnm7");
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("f1Eh")(module)))

/***/ }),

/***/ "41xE":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("OzIq");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "49qz":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("oeih");
var defined = __webpack_require__("/whu");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "4IZP":
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ "4M2W":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("A0n/");
__webpack_require__("i68Q");
__webpack_require__("QzLV");
__webpack_require__("Hhm4");
__webpack_require__("C+4B");
__webpack_require__("W4Z6");
__webpack_require__("tJwI");
__webpack_require__("eC2H");
__webpack_require__("VTn2");
__webpack_require__("W/IU");
__webpack_require__("Y5ex");
__webpack_require__("WpPb");
__webpack_require__("+yjc");
__webpack_require__("gPva");
__webpack_require__("n12u");
__webpack_require__("nRs1");
__webpack_require__("jrHM");
__webpack_require__("gYYG");
__webpack_require__("3QrE");
__webpack_require__("EuXz");
__webpack_require__("PbPd");
__webpack_require__("S+E/");
__webpack_require__("EvFb");
__webpack_require__("QBuC");
__webpack_require__("QWLi");
__webpack_require__("ZRJK");
__webpack_require__("Stuz");
__webpack_require__("yuXV");
__webpack_require__("XtiL");
__webpack_require__("LG56");
__webpack_require__("A1ng");
__webpack_require__("WiIn");
__webpack_require__("aJ2J");
__webpack_require__("altv");
__webpack_require__("dULJ");
__webpack_require__("v2lb");
__webpack_require__("7Jvp");
__webpack_require__("lyhN");
__webpack_require__("kBOG");
__webpack_require__("xONB");
__webpack_require__("LlNE");
__webpack_require__("9xIj");
__webpack_require__("m6Yj");
__webpack_require__("wrs0");
__webpack_require__("Lqg1");
__webpack_require__("1ip3");
__webpack_require__("pWGb");
__webpack_require__("N4KQ");
__webpack_require__("Hl+4");
__webpack_require__("MjHD");
__webpack_require__("SRCy");
__webpack_require__("H0mh");
__webpack_require__("bqOW");
__webpack_require__("F3sI");
__webpack_require__("mhn7");
__webpack_require__("1A13");
__webpack_require__("Racj");
__webpack_require__("Y1S0");
__webpack_require__("Gh7F");
__webpack_require__("tqSY");
__webpack_require__("CvWX");
__webpack_require__("8Np7");
__webpack_require__("R4pa");
__webpack_require__("4RlI");
__webpack_require__("iM2X");
__webpack_require__("J+j9");
__webpack_require__("82of");
__webpack_require__("X/Hz");
__webpack_require__("eVIH");
__webpack_require__("UJiG");
__webpack_require__("SU+a");
__webpack_require__("5iw+");
__webpack_require__("EWrS");
__webpack_require__("J2ob");
__webpack_require__("QaEu");
__webpack_require__("8fhx");
__webpack_require__("UbXY");
__webpack_require__("Rk41");
__webpack_require__("4Q0w");
__webpack_require__("IMUI");
__webpack_require__("beEN");
__webpack_require__("xMpm");
__webpack_require__("j42X");
__webpack_require__("81dZ");
__webpack_require__("uDYd");
__webpack_require__("CEO+");
__webpack_require__("w6W7");
__webpack_require__("fOdq");
__webpack_require__("wVdn");
__webpack_require__("Nkrw");
__webpack_require__("wnRD");
__webpack_require__("lkT3");
__webpack_require__("+CM9");
__webpack_require__("oHKp");
__webpack_require__("9vc3");
__webpack_require__("No4x");
__webpack_require__("WpTh");
__webpack_require__("U6qc");
__webpack_require__("Q/CP");
__webpack_require__("WgSQ");
__webpack_require__("lnZN");
__webpack_require__("Jbuy");
__webpack_require__("FaZr");
__webpack_require__("pd+2");
__webpack_require__("MfeA");
__webpack_require__("VjuZ");
__webpack_require__("qwQ3");
__webpack_require__("mJx5");
__webpack_require__("y9m4");
__webpack_require__("MsuQ");
__webpack_require__("dSUw");
__webpack_require__("ZDXm");
__webpack_require__("V/H1");
__webpack_require__("9mmO");
__webpack_require__("1uLP");
__webpack_require__("52Wt");
__webpack_require__("TFWu");
__webpack_require__("MyjO");
__webpack_require__("qtRy");
__webpack_require__("THnP");
__webpack_require__("K0JP");
__webpack_require__("NfZy");
__webpack_require__("dTzs");
__webpack_require__("+vXH");
__webpack_require__("CVR+");
__webpack_require__("vmSu");
__webpack_require__("4ZU1");
__webpack_require__("yx1U");
__webpack_require__("X7aK");
__webpack_require__("SPtU");
__webpack_require__("A52B");
__webpack_require__("PuTd");
__webpack_require__("dm+7");
__webpack_require__("JG34");
__webpack_require__("Rw4K");
__webpack_require__("9mGU");
__webpack_require__("bUY0");
__webpack_require__("mTp7");
__webpack_require__("gbyG");
__webpack_require__("oF0V");
__webpack_require__("v90c");
__webpack_require__("+2+s");
__webpack_require__("smQ+");
__webpack_require__("m8F4");
__webpack_require__("xn9I");
__webpack_require__("LRL/");
__webpack_require__("sc7i");
__webpack_require__("9Yib");
__webpack_require__("vu/c");
__webpack_require__("zmx7");
__webpack_require__("YVn/");
__webpack_require__("FKfb");
__webpack_require__("oYp4");
__webpack_require__("dxQb");
__webpack_require__("xCpI");
__webpack_require__("AkTE");
__webpack_require__("h7Xi");
__webpack_require__("arGp");
__webpack_require__("JJ3w");
__webpack_require__("qZb+");
__webpack_require__("La7N");
__webpack_require__("BOYP");
__webpack_require__("4rmF");
__webpack_require__("Ygg6");
__webpack_require__("6Xxs");
__webpack_require__("qdHU");
__webpack_require__("DQfQ");
__webpack_require__("j/Lv");
__webpack_require__("U+VG");
__webpack_require__("X6NR");
__webpack_require__("W0pi");
__webpack_require__("taNN");
__webpack_require__("vnWP");
__webpack_require__("R3KI");
__webpack_require__("6iMJ");
__webpack_require__("B3Xn");
__webpack_require__("3s83");
__webpack_require__("F1ui");
__webpack_require__("uEEG");
__webpack_require__("i039");
__webpack_require__("H7zx");
__webpack_require__("+Mt+");
__webpack_require__("QcWB");
__webpack_require__("yJ2x");
__webpack_require__("3q4u");
__webpack_require__("NHaJ");
__webpack_require__("v3hU");
__webpack_require__("zZHq");
__webpack_require__("vsh6");
__webpack_require__("8WbS");
__webpack_require__("yOtE");
__webpack_require__("EZ+5");
__webpack_require__("aM0T");
__webpack_require__("nh2o");
__webpack_require__("v8VU");
__webpack_require__("dich");
__webpack_require__("fx22");
module.exports = __webpack_require__("7gX0");


/***/ }),

/***/ "4Q0w":
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__("kkCw")('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__("2p1q")(proto, TO_PRIMITIVE, __webpack_require__("jB26"));


/***/ }),

/***/ "4RlI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__("y325")('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),

/***/ "4ZU1":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__("lDLk");
var $export = __webpack_require__("Ds5P");
var anObject = __webpack_require__("DIVP");
var toPrimitive = __webpack_require__("s4j0");

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__("zgIt")(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "4mcu":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "4rmF":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__("iKpr")('Map');


/***/ }),

/***/ "527X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_globalLimitTimeg_vue_vue_type_style_index_0_id_1d8cbce2_lang_scss_scoped_true___ = __webpack_require__("gMg8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_globalLimitTimeg_vue_vue_type_style_index_0_id_1d8cbce2_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_globalLimitTimeg_vue_vue_type_style_index_0_id_1d8cbce2_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_globalLimitTimeg_vue_vue_type_style_index_0_id_1d8cbce2_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "52Wt":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("77Ug")('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "52gC":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "5FsZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.c813581.png";

/***/ }),

/***/ "5QVw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("BwfY"), __esModule: true };

/***/ }),

/***/ "5VQ+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "5Ya/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_mask_vue_vue_type_style_index_0_id_327be300_lang_scss_scoped_true___ = __webpack_require__("SCxx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_mask_vue_vue_type_style_index_0_id_327be300_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_mask_vue_vue_type_style_index_0_id_327be300_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_mask_vue_vue_type_style_index_0_id_327be300_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "5dnF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var formats = __webpack_require__("uToG");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}();

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if ((typeof source === 'undefined' ? 'undefined' : _typeof(source)) !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || (typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && (typeof targetItem === 'undefined' ? 'undefined' : _typeof(targetItem)) === 'object' && item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function decode(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if ((typeof str === 'undefined' ? 'undefined' : _typeof(str)) === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (c === 0x2D // -
        || c === 0x2E // .
        || c === 0x5F // _
        || c === 0x7E // ~
        || c >= 0x30 && c <= 0x39 // 0-9
        || c >= 0x41 && c <= 0x5A // a-z
        || c >= 0x61 && c <= 0x7A // A-Z
        || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
                out += string.charAt(i);
                continue;
            }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
            continue;
        }

        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};

/***/ }),

/***/ "5iw+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__("y325")('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),

/***/ "5sM3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/scrollview.vue?vue&type=template&id=d43c5b94&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper"},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/common/scrollview.vue?vue&type=template&id=d43c5b94&

// EXTERNAL MODULE: ./node_modules/better-scroll/dist/bscroll.esm.js
var bscroll_esm = __webpack_require__("GQaK");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/scrollview.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//



/* harmony default export */ var scrollviewvue_type_script_lang_js_ = ({
    data: function data() {
        return {
            scroll: null
        };
    },

    props: {
        /**
         * 1 滚动的时候会派发scroll事件，会截流。
         * 2 滚动的时候实时派发scroll事件，不会截流。
         * 3 除了实时派发scroll事件，在swipe的情况下仍然能实时派发scroll事件
         */
        probeType: {
            type: Number,
            default: 1
        },
        /**
         * 默认高度
         */
        startY: {
            type: Number,
            default: 0
        },
        /**
         * 点击列表是否派发click事件
         */
        click: {
            type: Boolean,
            default: true
        },
        /**
         * 是否开启横向滚动
         */
        scrollX: {
            type: Boolean,
            default: false
        },
        /**
         * 是否派发滚动事件
         */
        listenScroll: {
            type: Boolean,
            default: false
        },
        /**
         * 列表的数据
         */
        data: {
            type: Array,
            default: null
        },

        inData: {
            type: String,
            default: null
        },
        /**
         * 是否派发滚动到底部的事件，用于上拉加载
         */
        pullup: {
            type: Boolean,
            default: false
        },
        /**
         * 是否派发顶部下拉的事件，用于下拉刷新
         */
        pulldown: {
            type: Boolean,
            default: false
        },
        /**
         * 是否派发列表滚动开始的事件
         */
        beforeScroll: {
            type: Boolean,
            default: false
        },
        /**
         * 当数据更新后，刷新scroll的延时。
         */
        refreshDelay: {
            type: Number,
            default: 500
        },
        /**
         * 是否开放滚动条
         */
        scrollbar: {
            type: null,
            default: true
        },
        scrollToEndFlag: {
            type: null,
            default: false
        },
        firstToBottom: {
            type: null,
            default: false
        }
    },
    mounted: function mounted() {
        var _this = this;

        // 保证在DOM渲染完毕后初始化better-scroll
        this.$nextTick(function () {
            setTimeout(function () {
                _this._initScroll();
            }, 500);
        });
    },

    // updated(){
    //     this._initScroll()
    // },
    methods: {
        _initScroll: function _initScroll() {
            var _this2 = this;

            if (!this.$refs.wrapper) {
                return;
            }
            // better-scroll的初始化
            this.scroll = new bscroll_esm["a" /* default */](this.$refs.wrapper, {
                probeType: this.probeType,
                click: this.click,
                scrollX: this.scrollX,
                startY: this.startY,
                scrollbar: this.scrollbar
            });

            // 是否派发滚动事件
            if (this.listenScroll) {
                this.scroll.on('scroll', function (pos) {
                    _this2.$emit('scroll', pos);
                });
            }

            // 是否派发滚动到底部事件，用于上拉加载
            if (this.pullup) {
                this.scroll.on('scrollEnd', function () {
                    // 滚动到底部
                    if (_this2.scroll.y <= _this2.scroll.maxScrollY + 50) {
                        _this2.$emit('scrollToEnd');
                    }
                });
            }

            // 是否派发顶部下拉事件，用于下拉刷新
            if (this.pulldown) {
                this.scroll.on('touchend', function (pos) {
                    // 下拉动作
                    if (pos.y > 50) {
                        _this2.$emit('pulldown');
                    }
                });
            }

            // 是否派发列表滚动开始的事件
            if (this.beforeScroll) {
                this.scroll.on('beforeScrollStart', function () {
                    _this2.$emit('beforeScroll');
                });
            }
        },
        disable: function disable() {
            // 代理better-scroll的disable方法
            this.scroll && this.scroll.disable();
        },
        enable: function enable() {
            // 代理better-scroll的enable方法
            this.scroll && this.scroll.enable();
        },
        refresh: function refresh() {
            // 代理better-scroll的refresh方法
            this.scroll && this.scroll.refresh();
        },
        scrollTo: function scrollTo() {
            // 代理better-scroll的scrollTo方法
            this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
        },
        scrollToElement: function scrollToElement() {
            // 代理better-scroll的scrollToElement方法
            this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
        }
    },
    watch: {
        // 监听数据的变化，延时refreshDelay时间后调用refresh方法重新计算，保证滚动效果正常
        data: function data() {
            var _this3 = this;

            setTimeout(function () {
                _this3.refresh();
                if (_this3.scrollToEndFlag) {
                    _this3.scroll.scrollTo(0, _this3.scroll.maxScrollY, 800);
                }
            }, this.refreshDelay);
        },
        inData: function inData() {
            var that = this;
            setTimeout(function () {
                that.refresh();
                that._initScroll();
            }, this.refreshDelay);
        },
        firstToBottom: function firstToBottom() {
            var _this4 = this;

            setTimeout(function () {
                _this4.refresh();
                if (_this4.scrollToEndFlag) {
                    _this4.scroll.scrollTo(0, _this4.scroll.maxScrollY, 800);
                }
            }, this.refreshDelay);
        }
    }
});
// CONCATENATED MODULE: ./src/components/common/scrollview.vue?vue&type=script&lang=js&
 /* harmony default export */ var common_scrollviewvue_type_script_lang_js_ = (scrollviewvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/common/scrollview.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  common_scrollviewvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var scrollview = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "5zde":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("zQR9");
__webpack_require__("qyJz");
module.exports = __webpack_require__("FeBl").Array.from;


/***/ }),

/***/ "63KW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("EKta")
var ieee754 = __webpack_require__("ujcs")
var isArray = __webpack_require__("sOR5")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "65qJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apiConfig__ = __webpack_require__("bn6T");


var APIS = {
  env: __WEBPACK_IMPORTED_MODULE_0__apiConfig__["a" /* default */].env,
  spell: __WEBPACK_IMPORTED_MODULE_0__apiConfig__["a" /* default */].spell,
  // 会员相关接口
  getV4CouponList: __WEBPACK_IMPORTED_MODULE_0__apiConfig__["a" /* default */].LXDOMAIN + 'vip/v4/couponList', // 4.0会员中心-优惠券列表
  receiveCoupon: __WEBPACK_IMPORTED_MODULE_0__apiConfig__["a" /* default */].LXDOMAIN + 'vip/v4/receiveCoupon' // 4.0会员中心-优惠券列表
};

/* harmony default export */ __webpack_exports__["a"] = (APIS);

/***/ }),

/***/ "6PNh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("wI4N");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ "6SyV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "6Xxs":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__("iKpr")('WeakMap');


/***/ }),

/***/ "6iMJ":
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),

/***/ "6obF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("8Uqm");

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),

/***/ "6qEs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addHashParams", function() { return addHashParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addUrlParams", function() { return addUrlParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUrlParams", function() { return getUrlParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);


function typeMatch(param){var url=param.url,type=param.type;try{var allowType=["search","hash"];if(allowType.includes(type.toLowerCase())){var urlObj=new URL(url||location.href);var targetHead="";if(type==="search"){targetHead="?";}else if(type==="hash"){if(urlObj[type]&&urlObj[type].match(/(#\/)?[a-zA-Z0-9-_]+\??/)){urlObj[type].match(/(#\/)?[a-zA-Z0-9-_]+\??/)[0];}else {targetHead="#/?";}}var targetString=urlObj[type].replace(targetHead,"");var targetObj=Object(__WEBPACK_IMPORTED_MODULE_0_qs__["parse"])(targetString);return {urlObj:urlObj,targetObj:targetObj,targetHead:targetHead}}else {return false}}catch(err){console.error(err);}}

function addUrlParams(param){var url=param.url,_type=param.type,type=_type===void 0?"search":_type,params=param.params;var match=typeMatch({url:url,type:type});if(match){var ref=typeMatch({url:url,type:type}),urlObj=ref.urlObj,targetObj=ref.targetObj,targetHead=ref.targetHead;var finalParamsStr=Object(__WEBPACK_IMPORTED_MODULE_0_qs__["stringify"])(Object.assign(targetObj,params));urlObj[type]="".concat(targetHead).concat(finalParamsStr);return urlObj.href}else {return url}}

function addHashParams(param){var url=param.url,params=param.params;return addUrlParams({url:url,type:"hash",params:params})}

function pick(obj,keys){return keys.reduce(function(result,key){if(obj[key]){result[key]=obj[key];}return result},{})}

function getUrlParams(param){var url=param.url,_type=param.type,type=_type===void 0?"search":_type,_params=param.params,params=_params===void 0?[]:_params;var targetObj=typeMatch({url:url,type:type}).targetObj;return pick(targetObj,params)}


//# sourceMappingURL=url.js.map


/***/ }),

/***/ "6vJa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_bannerSwiper_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("SjAY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_bannerSwiper_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_bannerSwiper_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_bannerSwiper_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "7+uW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.11
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.11';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("162o").setImmediate))

/***/ }),

/***/ "72Vn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "73qY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("VWgF")('native-function-to-string', Function.toString);


/***/ }),

/***/ "77Pl":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "77Ug":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__("bUqO")) {
  var LIBRARY = __webpack_require__("V3l/");
  var global = __webpack_require__("OzIq");
  var fails = __webpack_require__("zgIt");
  var $export = __webpack_require__("Ds5P");
  var $typed = __webpack_require__("07k+");
  var $buffer = __webpack_require__("LrcN");
  var ctx = __webpack_require__("rFzY");
  var anInstance = __webpack_require__("9GpA");
  var propertyDesc = __webpack_require__("fU25");
  var hide = __webpack_require__("2p1q");
  var redefineAll = __webpack_require__("A16L");
  var toInteger = __webpack_require__("oeih");
  var toLength = __webpack_require__("BbyF");
  var toIndex = __webpack_require__("8D8H");
  var toAbsoluteIndex = __webpack_require__("zo/l");
  var toPrimitive = __webpack_require__("s4j0");
  var has = __webpack_require__("WBcL");
  var classof = __webpack_require__("wC1N");
  var isObject = __webpack_require__("UKM+");
  var toObject = __webpack_require__("FryR");
  var isArrayIter = __webpack_require__("9vb1");
  var create = __webpack_require__("7ylX");
  var getPrototypeOf = __webpack_require__("KOrd");
  var gOPN = __webpack_require__("WcO1").f;
  var getIterFn = __webpack_require__("SHe9");
  var uid = __webpack_require__("ulTY");
  var wks = __webpack_require__("kkCw");
  var createArrayMethod = __webpack_require__("LhTa");
  var createArrayIncludes = __webpack_require__("ot5s");
  var speciesConstructor = __webpack_require__("7O1s");
  var ArrayIterators = __webpack_require__("WgSQ");
  var Iterators = __webpack_require__("bN1p");
  var $iterDetect = __webpack_require__("qkyc");
  var setSpecies = __webpack_require__("CEne");
  var arrayFill = __webpack_require__("zCYm");
  var arrayCopyWithin = __webpack_require__("DPsE");
  var $DP = __webpack_require__("lDLk");
  var $GOPD = __webpack_require__("x9zv");
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),

/***/ "7B7M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "7GwW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var settle = __webpack_require__("21It");
var buildURL = __webpack_require__("DQCr");
var parseHeaders = __webpack_require__("oJlt");
var isURLSameOrigin = __webpack_require__("GHBc");
var createError = __webpack_require__("FtD3");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("thJu");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("p1b6");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "7Jvp":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__("Ds5P");
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),

/***/ "7KvD":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "7O1s":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("DIVP");
var aFunction = __webpack_require__("XSOZ");
var SPECIES = __webpack_require__("kkCw")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "7Sxt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_cp_dialog_vue_vue_type_style_index_0_id_77f48e62_lang_scss_scoped_true___ = __webpack_require__("AOv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_cp_dialog_vue_vue_type_style_index_0_id_77f48e62_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_cp_dialog_vue_vue_type_style_index_0_id_77f48e62_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_cp_dialog_vue_vue_type_style_index_0_id_77f48e62_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "7UMu":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("R9M2");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "7gX0":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "7ylX":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("DIVP");
var dPs = __webpack_require__("twxM");
var enumBugKeys = __webpack_require__("QKXm");
var IE_PROTO = __webpack_require__("mZON")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("jhxf")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("d075").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "81dZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var html = __webpack_require__("d075");
var cof = __webpack_require__("ydD5");
var toAbsoluteIndex = __webpack_require__("zo/l");
var toLength = __webpack_require__("BbyF");
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__("zgIt")(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),

/***/ "82Mu":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var macrotask = __webpack_require__("L42u").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("R9M2")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "82of":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__("y325")('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),

/***/ "880/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("hJx8");


/***/ }),

/***/ "8D8H":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__("oeih");
var toLength = __webpack_require__("BbyF");
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),

/***/ "8I3j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
  );
};

/***/ }),

/***/ "8Np7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__("y325")('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),

/***/ "8Uqm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var bind = __webpack_require__("QRXx");
var isBuffer = __webpack_require__("a7gV");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (_typeof(result[key]) === 'object' && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

/***/ }),

/***/ "8WbS":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("wCso");
var anObject = __webpack_require__("DIVP");
var getPrototypeOf = __webpack_require__("KOrd");
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),

/***/ "8cTw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("wI4N");
var normalizeHeaderName = __webpack_require__("YTdK");
var enhanceError = __webpack_require__("344C");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("I+pO");
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__("I+pO");
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "8fhx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var toObject = __webpack_require__("FryR");
var toPrimitive = __webpack_require__("s4j0");

$export($export.P + $export.F * __webpack_require__("zgIt")(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),

/***/ "8t38":
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__("OzIq").parseFloat;
var $trim = __webpack_require__("Ymdd").trim;

module.exports = 1 / $parseFloat(__webpack_require__("Xduv") + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),

/***/ "8xno":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-own-property-names.js
var get_own_property_names = __webpack_require__("aFK5");
var get_own_property_names_default = /*#__PURE__*/__webpack_require__.n(get_own_property_names);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/lib/units.js + 2 modules
var units = __webpack_require__("DVdL");

// EXTERNAL MODULE: ./src/lib/wxActions.js
var wxActions = __webpack_require__("LJ7O");

// EXTERNAL MODULE: ./src/frontend-lib/tools/getPlatform.js
var getPlatform = __webpack_require__("hTeI");
var getPlatform_default = /*#__PURE__*/__webpack_require__.n(getPlatform);

// EXTERNAL MODULE: ./src/frontend-lib/lib/Bridge.js
var Bridge = __webpack_require__("wlTy");

// EXTERNAL MODULE: ./src/apis.js
var apis = __webpack_require__("OTud");

// EXTERNAL MODULE: ./src/frontend-lib/component/PageGrayFilter/style.scss
var style = __webpack_require__("XDDC");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./src/frontend-lib/component/PageGrayFilter/index.js


function needGray(_startTime, _endTime) {
  var endTime = _endTime || new Date('2020/04/05 00:00:00').getTime();
  var startTime = _startTime || new Date('2020/04/03 00:00:00').getTime();
  var nowTime = new Date().getTime();
  return nowTime > startTime && nowTime < endTime;
}

/* harmony default export */ var PageGrayFilter = (function (_startTime, _endTime) {
  var $platform = Object(getPlatform["getPlatform"])();
  var notApps = !($platform.isYixinliApp || $platform.isCeShiApp || $platform.isZiXunApp || $platform.museAPPVersion);
  if (needGray(_startTime, _endTime) && notApps) {
    document.querySelector('html').setAttribute('class', 'gray-filter');
  }
});
// CONCATENATED MODULE: ./src/mixins/pageMixin.js















/* harmony default export */ var pageMixin = __webpack_exports__["a"] = ({
    // beforeRouteEnter(to, from, next){
    //     next(() => {
    //         window.lastVistedPage = from;
    //     });
    // },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        // 页面即将离开的时候将自己设置为lastVistedPage, beforeRouteEnter 是在mounted之后发生的，所以无效
        window.lastVistedPage = from;
        next();
    },
    data: function data() {
        var _ref;

        return _ref = {}, defineProperty_default()(_ref, 'ENTER_TIME', null), defineProperty_default()(_ref, 'ALLOW_SHARE', true), defineProperty_default()(_ref, 'ALLOW_APP_SHARE', true), defineProperty_default()(_ref, 'ALLOW_SHARE_WXPYQ', null), defineProperty_default()(_ref, 'PV_BY_SELF', false), defineProperty_default()(_ref, 'HEIGHT_UPDATE', false), _ref;
    },

    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['channelConfig', 'channelId', 'userInfo', 'isWxApp', 'wxMiniAppSessionKey', 'woNiuUnique']), Object(vuex_esm["c" /* mapGetters */])({
        UID: 'COOKIE_UID'
    }), {
        woNiuSourceName: function woNiuSourceName() {
            var r = '';
            var woNiuUnique = JSON.parse(localStorage.getItem('woNiuUnique'));
            var hash = location.hash;
            if (this.woNiuUnique || woNiuUnique) {
                r = this.woNiuUnique ? this.woNiuUnique : woNiuUnique;
            } else if (this.$route.query.unique) {
                r = this.$route.query.unique;
            } else if (hash.indexOf('unique') > -1) {
                var index = hash.indexOf('unique');
                var unique = hash.slice(index).split('&')[0];
                r = unique ? unique.split('=')[1] : '';
            }
            return r;
        },
        PVaddOn: function PVaddOn() {
            return {};
        },
        wxShareConfig: function wxShareConfig() {
            // 配置微信分享的参数, 每个页面应该自行配置，这里是配置一个保底的
            var that = this;
            return {
                title: that.channelConfig.siteName,
                link: '' + location.origin + location.pathname + '?channelId=' + that.channelId + '#' + that.$route.path,
                imgUrl: that.channelConfig.logoUrl ? that.channelConfig.logoUrl : 'http://static.xinli001.com/static-ceping-wz/static/images/logo-brain.png',
                desc: '专业、有趣、好玩的心理测评，用心理学探索未知的自己。',
                success: function success() {
                    // 埋点
                    window.TRACKER.sharePage(that.$route.meta.title);
                },
                cancel: function cancel() {}
            };
        },
        pageWxMiniAppSessionKey: function pageWxMiniAppSessionKey() {
            var result = this.$route.query.sessionKey ? this.$route.query.sessionKey : '';

            return result;
        },
        userKey: function userKey() {
            console.log((this.$route.query.userKey && this.$route.query.userKey != 'null' ? this.$route.query.userKey : '') || localStorage.getItem('yxl_cp_userkey') || '');
            return (this.$route.query.userKey && this.$route.query.userKey != 'null' ? this.$route.query.userKey : '') || localStorage.getItem('yxl_cp_userkey') || '';
        }
    }),
    created: function created() {
        var that = this;
        // 设置UID
        that.setUID(that.$route.query.uid);
        if (this.$route.params.channelId) {
            that.channelIdUpdate(this.$route.params.channelId);
        } else {
            if (Object(units["q" /* isEmpObj */])(that.channelConfig) & that.channelId != null) {
                that.channelIdUpdate(that.channelId === 'null' ? 1 : that.channelId);
            }
        }

        if (this.ALLOW_SHARE_WXPYQ === null) {
            this.ALLOW_SHARE_WXPYQ = this.ALLOW_SHARE;
        };
    },
    mounted: function mounted() {
        var that = this;
        that.ENTER_TIME = new Date();
        // console.log(this.$route)
        if (!this.PV_BY_SELF) {
            this.pageViewTracker({
                from: window.lastVistedPage,
                to: this.$route,
                enterTime: this.ENTER_TIME,
                addOn: this.PVaddOn
            });
        }
        console.log('page mounted');
        //头条快手App不需要更新微信配置 && 微博免登不需要更新
        var IS_FETCH_WX = !this.TOUTIAOAPP && !this.WEIBO_NOTLOGIN && !this.KUAISHOU_APP;
        if (IS_FETCH_WX) {
            if (this.channelId == 3064) {
                return;
            }
            that.pageInitWx();
        }
        if (this.platform.isYixinliApp || this.platform.isCeShiApp) {
            console.log('page mounted, set app share');
            this.appShareInit();
        }
        // 页面加载channelId自检
        var channelId = 1;
        if (this.$route.params.channelId) {
            channelId = this.$route.params.channelId;
        } else {
            if (that.$route.query.channelId) {
                channelId = that.$route.query.channelId && that.$route.query.channelId !== 'null' ? that.$route.query.channelId : 1;
            } else if (Object(units["a" /* GetQueryString */])('channelId')) {
                channelId = Object(units["a" /* GetQueryString */])('channelId') && Object(units["a" /* GetQueryString */])('channelId') !== 'null' ? Object(units["a" /* GetQueryString */])('channelId') : 1;
            }
        }

        if (channelId != null && channelId != this.channelId) {
            that.channelIdUpdate(channelId);
        }

        // 判断是否小程序过来的页面，并且全局保存

        this.checkFromWxApp();
    },
    updated: function updated() {
        var _this = this;

        var el = document.getElementById('app');
        if (!this.HEIGHT_UPDATE) {
            /*
             *  为了兼容IOS，Safari的bug-> 在列表按返回白屏，每次返回都人工滚动1px。
             *  参考资料：https://github.com/vuejs/vue/issues/6954
             */
            this.$nextTick(function () {
                var originHeight = el.getAttribute('oldHeight') ? el.getAttribute('oldHeight') : el.offsetHeight;
                // el.setAttribute('oldHeight', originHeight);
                el.style.height = originHeight + 1 + 'px';

                setTimeout(function () {
                    el.removeAttribute('style');
                    _this.HEIGHT_UPDATE = true;
                }, 200);
            });
        }
    },
    beforeDestroy: function beforeDestroy() {

        this.pageViewTracker({
            from: window.lastVistedPage,
            to: this.$route,
            enterTime: this.ENTER_TIME,
            leaveTime: new Date(),
            addOn: this.PVaddOn,
            isLeave: true
        });
        document.getElementById('app').removeAttribute('style');
    },

    watch: {
        'channelId': function channelId(newVal) {
            var that = this;
            if (newVal == undefined | newVal == 'null') {
                return;
            }
            that.channelIdUpdate(newVal);
        },
        'wxConfig': function wxConfig() {
            this.pageInitWx();
        },
        'wxShareConfig': function wxShareConfig(newVal) {
            this.doWxShareConfig(this.wxShareConfig);
            if (this.platform.isYixinliApp) {
                this.appShareInit();
            }
        },
        '$route.query.uid': function $routeQueryUid(newVal) {
            this.setUID(newVal);
        },
        'ALLOW_SHARE': function ALLOW_SHARE() {
            this.pageInitWx();
        },
        'ALLOW_APP_SHARE': function ALLOW_APP_SHARE() {
            this.pageInitWx();
        }
    },
    methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])(['setIsWxApp', 'setWxMiniAppSessionKey']), {
        checkFromWxApp: function checkFromWxApp() {
            console.log('this.$route.query.appCode', this.$route.query);
            document.addEventListener('UniAppJSBridgeReady', function () {
                uni.postMessage({
                    data: {
                        action: 'message'
                    }
                });
            });
            // 判断是否小程序过来的页面，并且全局保存
            if (this.$route.query.appCode == 16) {
                this.setIsWxApp(true);
            }
            if (this.isWxApp & this.pageWxMiniAppSessionKey != '') {
                console.error(this.pageWxMiniAppSessionKey);
                this.setWxMiniAppSessionKey(this.pageWxMiniAppSessionKey);
                // 非免登
                if (!this.CHANNEL_NOT_LOGIN && !this.isWxApp) {
                    this.getUserInfo(this.channelId);
                }
            }
        },

        pageViewTracker: units["u" /* pageViewTracker */],
        appShareInit: function appShareInit() {
            var _this2 = this;

            var myBridge = new Bridge["a" /* default */]({
                methods: [{
                    method: 'topFuncBtn',
                    callback: function callback(option) {
                        if (option.name === 'shareReportBtn') {
                            myBridge.call('shareReport', {
                                title: _this2.wxShareConfig.title,
                                desc: _this2.wxShareConfig.desc,
                                link: _this2.wxShareConfig.link,
                                imgUrl: _this2.wxShareConfig.imgUrl
                            });

                            if (_this2.appShareCallback && typeof _this2.appShareCallback === 'function') {
                                _this2.appShareCallback();
                            }
                        }
                    }
                }]
            });

            if (this.ALLOW_SHARE && this.ALLOW_APP_SHARE) {
                console.log('设置APP分享', {
                    btnList: [{
                        name: 'shareReportBtn',
                        visible: 1,
                        showName: '分享'
                    }]
                });
                myBridge.call('topFuncBtnConfig', {
                    btnList: [{
                        name: 'shareReportBtn',
                        visible: 1,
                        showName: '分享'
                    }]
                });
            } else {
                console.log('设置APP不要分享', {
                    btnList: []
                });
                myBridge.call('topFuncBtnConfig', {
                    btnList: []
                });
            }
        },
        pageInitWx: function pageInitWx() {
            var _this3 = this;

            console.log('初始化微信分享');
            var that = this;
            var ISN_NONE_SHOW_WX = Object(units["q" /* isEmpObj */])(that.wxConfig) || this.TOUTIAOAPP || this.WEIBO_NOTLOGIN || this.KUAISHOU_APP;
            if ((ISN_NONE_SHOW_WX || this.isAfterTestPay) && !this.isTfWechat) {
                return;
            }
            Object(wxActions["b" /* wxConfig */])(that.wxConfig).then(function () {
                return that.doWxShareConfig(that.wxShareConfig);
            }).then(function () {
                var menuList = ['menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:QZone', "menuItem:openWithSafari", "menuItem:share:appMessage", "menuItem:share:facebook", "menuItem:copyUrl"];

                wx.ready(function () {
                    console.log('ALLOW_SHARE', that.ALLOW_SHARE);
                    if (that.ALLOW_SHARE) {
                        if (!!that.ALLOW_SHARE_WXPYQ) {
                            menuList.push("menuItem:share:timeline");
                        }
                        wx.showMenuItems({
                            menuList: menuList
                        });
                        console.log('showMenuItems', menuList);
                    } else {
                        if (!that.ALLOW_SHARE_WXPYQ) {
                            menuList.push("menuItem:share:timeline");
                        }
                        wx.hideMenuItems({
                            menuList: menuList
                        });
                        // console.log('hideMenuItems',menuList);
                    }
                });
            }).catch(function () {
                that.getWechatData({
                    channelId: that.channelId,
                    query: _this3.$route.query
                }).then(function () {
                    return Object(wxActions["b" /* wxConfig */])(that.$store.state.wxConfig);
                }).then(function () {
                    that.doWxShareConfig(that.wxShareConfig);
                });
            });
        },
        channelIdUpdate: function channelIdUpdate(channelId) {
            var _this4 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                var that, UPDATA_WX;
                return regenerator_default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                that = _this4;

                                console.info('渠道ID发生变化');
                                that.setChannelId(channelId);
                                UPDATA_WX = !_this4.TOUTIAOAPP && (!_this4.WEIBO_NOTLOGIN || _this4.isTfWechat) && !_this4.KUAISHOU_APP;

                                if (UPDATA_WX) {
                                    that.getWechatData({
                                        channelId: channelId,
                                        query: _this4.$route.query
                                    });
                                }
                                that.getChannelMsg({
                                    params: {
                                        channelId: channelId
                                    }
                                }).then(function () {
                                    var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(res) {
                                        return regenerator_default.a.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        console.log('渠道ID res', res);

                                                        if (channelId) {
                                                            _context.next = 3;
                                                            break;
                                                        }

                                                        return _context.abrupt('return');

                                                    case 3:
                                                        if (channelId && res.channelMsg && res.channelMsg.channelType == 8) {
                                                            console.log('当前渠道屏蔽诸葛');
                                                            get_own_property_names_default()(window.TRACKER.__proto__).map(function (key) {
                                                                if (typeof window.TRACKER[key] === 'function') {
                                                                    window.TRACKER[key] = function () {};
                                                                }
                                                            });
                                                        }

                                                        // 等待channelMsg返回才决定调不调userInfo和vipInfo

                                                        if (!(!_this4.CHANNEL_NOT_LOGIN || _this4.isTfWechat)) {
                                                            _context.next = 8;
                                                            break;
                                                        }

                                                        _context.next = 7;
                                                        return that.getUserInfo(channelId);

                                                    case 7:
                                                        that.getVipInfo(channelId);

                                                    case 8:
                                                        _this4.byteDanceAppName = res.channelMsg.name;

                                                    case 9:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this4);
                                    }));

                                    return function (_x) {
                                        return _ref2.apply(this, arguments);
                                    };
                                }());
                                window.TRACKER.setChannelId(channelId);

                                if (channelId * 1 === 1) {
                                    PageGrayFilter();
                                }

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4);
            }))();
        },


        // 获取App的token
        getAppToken: function getAppToken() {
            var _this5 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                var getToken, token;
                return regenerator_default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!_this5.platform.isYixinliApp) {
                                    _context3.next = 7;
                                    break;
                                }

                                getToken = function getToken() {
                                    var bridge = new Bridge["a" /* default */]();

                                    return new promise_default.a(function (resolve) {
                                        var methodName = 'getToken' + new Date().getTime();
                                        window[methodName] = function (jsonStr) {
                                            resolve(JSON.parse(jsonStr).token);
                                        };
                                        bridge.call('getToken', {
                                            callbackName: methodName
                                        });
                                    });
                                };

                                _context3.next = 4;
                                return getToken();

                            case 4:
                                token = _context3.sent;

                                if (!token) {
                                    _context3.next = 7;
                                    break;
                                }

                                return _context3.abrupt('return', token);

                            case 7:
                                return _context3.abrupt('return', '');

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5);
            }))();
        },


        // app、m站获取用户信息
        getAppUserMsg: function getAppUserMsg(token) {
            return this.$http.get('https://m' + apis["a" /* default */].env + '.xinli001.com/ajax/get-user-header', {
                params: { token: token }
            }).then(function (res) {
                return res.data.data.user;
            });
        },


        // 获取平台用户信息
        getPlatformUserInfo: function getPlatformUserInfo(userId, mobile) {
            return this.$http.get(apis["a" /* default */].getUserInfoFromPlatfrom, {
                params: { userId: userId, mobile: mobile }
            }).then(function (result) {
                return result.data.data;
            });
        },


        // app、m站获取userKey
        getAppUserKey: function getAppUserKey(userId, mobile) {
            return this.getUserKeyFromPlatfrom({ userId: userId, mobile: mobile }).then(function (userKey) {
                return userKey;
            });
        },
        _copyText: function _copyText(content, cb) {
            var selection = window.getSelection();
            var range = document.createRange();
            var $code = document.createElement('div');
            $code.display = 'none';
            $code.innerHTML = content;
            document.body.appendChild($code);
            range.selectNodeContents($code);
            selection.removeAllRanges();
            selection.addRange(range);
            if (document.execCommand('copy')) {
                //浏览器是否支持复制
                document.execCommand('copy');
                if (cb) {
                    cb();
                } else {
                    this.setTOASTTEXT('复制成功');
                }
            } else {
                this.setTOASTTEXT('浏览器不支持复制功能');
            }
            selection = null;
            range = null;
            document.body.removeChild($code);
        },
        handleAuth: function handleAuth() {
            this.$http.get(apis["a" /* default */].h5activityAuth, {
                params: {
                    channelId: this.channelId,
                    url: location.href
                }
            }).then(function (res) {
                if (res.data.code === '302') {
                    location.href = res.data.data;
                }
            });
        },


        doWxShareConfig: wxActions["a" /* doWxShareConfig */]
    }, Object(vuex_esm["d" /* mapMutations */])(['setChannelId',
    // 'doWxConfig',
    'setUID']), Object(vuex_esm["b" /* mapActions */])(['getChannelMsg', 'getWechatData', 'promoBind']))

});

/***/ }),

/***/ "94VQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("Yobk");
var descriptor = __webpack_require__("X8DO");
var setToStringTag = __webpack_require__("e6n0");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("hJx8")(IteratorPrototype, __webpack_require__("dSzd")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "9Dx1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("wC1N");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "9GpA":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "9ScX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yxl_half_consult_banner.8ddf5e4.gif";

/***/ }),

/***/ "9WgL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var env = location.host.split('.')[0].match(/(qc|box)\d?/g);
var spell = !!env ? env.length > 0 ? '-' + env[0] : '' : '';
var WXDOMAIN = '//wx' + spell + '.xinli001.com/',
    LXDOMAIN = spell ? '//lingxi' + spell + '.xinli001.com/lingxi/service/' : '//m-lingxi' + spell + '.xinli001.com/lingxi/service/',
    YIAPI = '//yiapi' + spell + '.xinli001.com/v5/yi/',
    APIS = {
    // 免登陆接口
    getScalePrice: LXDOMAIN + 'notLogin/doFirstAfterBuy/getScalePrice', // 免登+先测试后付费（for微博） 获取测评价格
    payOrder: LXDOMAIN + 'notLogin/doFirstAfterBuy/payOrder', // 免登+先测试后付费（for微博） 支付订单
    getQrcode: LXDOMAIN + 'notLogin/doFirstAfterBuy/getQrcode', // 免登+先测试后付费（for微博） 获取二维码
    buyActivityCard: LXDOMAIN + 'notLogin/buyActivityCard', // 免登陆活动卡购买
    payOrderByCoupon: LXDOMAIN + 'notLogin/payOrderByCoupon', // 解锁页支付测评并抵扣虚拟红包
    availableActivityCard: LXDOMAIN + 'activityCard/availableActivityCard', // #获取可用活动卡信息（购买免费测评时用）
    buyActivityCardConsultCombo: LXDOMAIN + 'consult/buyActivityCardConsultCombo', // 组合测评购买咨询（使用活动卡权益购买
    validatePhone: LXDOMAIN + 'notLogin/validatePhone', // 投放手机号验证接口
    cepingVipBindPhone: LXDOMAIN + 'vip/v3/notLogin/bindPhone', // 测评会员绑定手机号
    cepingVipBindPhone4: LXDOMAIN + 'vip/v4/bindPhone', // 测评会员绑定手机号
    cepingVipBindTfPhone4: LXDOMAIN + 'vip/v4/tf/receiveVip', // 测评投放会员绑定手机号
    searchOrderDoAfterBuyNew: LXDOMAIN + 'notLogin/searchOrderDoAfterBuyNew', // 订单查询接口
    existOrder: LXDOMAIN + 'notLogin/existOrder', // 查询用户是否存在订单
    splitFlowType: LXDOMAIN + 'notLogin/splitFlowType', // 获取投放分流类型
    payMbtiOrder: LXDOMAIN + 'notLogin/doFirstAfterBuy/payMbtiOrder', // 先测试后付费 MBTI多题版本 解锁支付订单接口
    payDepressedOrder: LXDOMAIN + 'notLogin/doFirstAfterBuy/payDepressedOrder' // 先测试后付费解锁支付抑郁订单
};

/* harmony default export */ __webpack_exports__["a"] = (APIS);

/***/ }),

/***/ "9Yib":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("3g/S")('asyncIterator');


/***/ }),

/***/ "9bBU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("mClu");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "9cWp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9hGZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("5dnF");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function interpretNumericEntities(str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function parseArrayValue(val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function (encodedVal) {
                return options.decoder(encodedVal, defaults.decoder, charset, 'value');
            });
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function parseObject(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

/***/ }),

/***/ "9mGU":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__("Ds5P");
var anObject = __webpack_require__("DIVP");
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "9mmO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var $typed = __webpack_require__("07k+");
var buffer = __webpack_require__("LrcN");
var anObject = __webpack_require__("DIVP");
var toAbsoluteIndex = __webpack_require__("zo/l");
var toLength = __webpack_require__("BbyF");
var isObject = __webpack_require__("UKM+");
var ArrayBuffer = __webpack_require__("OzIq").ArrayBuffer;
var speciesConstructor = __webpack_require__("7O1s");
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__("zgIt")(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__("CEne")(ARRAY_BUFFER);


/***/ }),

/***/ "9uvj":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, Buffer) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
// THIS FILE IS AUTOMATICALLY GENERATED! DO NOT EDIT BY HAND!
//
;(function (global, factory) {
  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : // cf. https://github.com/dankogai/js-base64/issues/119
  function () {
    // existing version for noConflict()
    var _Base64 = global.Base64;
    var gBase64 = factory();
    gBase64.noConflict = function () {
      global.Base64 = _Base64;
      return gBase64;
    };
    if (global.Meteor) {
      // Meteor.js
      Base64 = gBase64;
    }
    global.Base64 = gBase64;
  }();
})(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : this, function () {
  'use strict';
  /**
   *  base64.ts
   *
   *  Licensed under the BSD 3-Clause License.
   *    http://opensource.org/licenses/BSD-3-Clause
   *
   *  References:
   *    http://en.wikipedia.org/wiki/Base64
   *
   * @author Dan Kogai (https://github.com/dankogai)
   */

  var version = '3.7.2';
  /**
   * @deprecated use lowercase `version`.
   */
  var VERSION = version;
  var _hasatob = typeof atob === 'function';
  var _hasbtoa = typeof btoa === 'function';
  var _hasBuffer = typeof Buffer === 'function';
  var _TD = typeof TextDecoder === 'function' ? new TextDecoder() : undefined;
  var _TE = typeof TextEncoder === 'function' ? new TextEncoder() : undefined;
  var b64ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  var b64chs = Array.prototype.slice.call(b64ch);
  var b64tab = function (a) {
    var tab = {};
    a.forEach(function (c, i) {
      return tab[c] = i;
    });
    return tab;
  }(b64chs);
  var b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
  var _fromCC = String.fromCharCode.bind(String);
  var _U8Afrom = typeof Uint8Array.from === 'function' ? Uint8Array.from.bind(Uint8Array) : function (it, fn) {
    if (fn === void 0) {
      fn = function fn(x) {
        return x;
      };
    }
    return new Uint8Array(Array.prototype.slice.call(it, 0).map(fn));
  };
  var _mkUriSafe = function _mkUriSafe(src) {
    return src.replace(/=/g, '').replace(/[+\/]/g, function (m0) {
      return m0 == '+' ? '-' : '_';
    });
  };
  var _tidyB64 = function _tidyB64(s) {
    return s.replace(/[^A-Za-z0-9\+\/]/g, '');
  };
  /**
   * polyfill version of `btoa`
   */
  var btoaPolyfill = function btoaPolyfill(bin) {
    // console.log('polyfilled');
    var u32,
        c0,
        c1,
        c2,
        asc = '';
    var pad = bin.length % 3;
    for (var i = 0; i < bin.length;) {
      if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError('invalid character found');
      u32 = c0 << 16 | c1 << 8 | c2;
      asc += b64chs[u32 >> 18 & 63] + b64chs[u32 >> 12 & 63] + b64chs[u32 >> 6 & 63] + b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + '==='.substring(pad) : asc;
  };
  /**
   * does what `window.btoa` of web browsers do.
   * @param {String} bin binary string
   * @returns {string} Base64-encoded string
   */
  var _btoa = _hasbtoa ? function (bin) {
    return btoa(bin);
  } : _hasBuffer ? function (bin) {
    return Buffer.from(bin, 'binary').toString('base64');
  } : btoaPolyfill;
  var _fromUint8Array = _hasBuffer ? function (u8a) {
    return Buffer.from(u8a).toString('base64');
  } : function (u8a) {
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    var maxargs = 0x1000;
    var strs = [];
    for (var i = 0, l = u8a.length; i < l; i += maxargs) {
      strs.push(_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    }
    return _btoa(strs.join(''));
  };
  /**
   * converts a Uint8Array to a Base64 string.
   * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
   * @returns {string} Base64 string
   */
  var fromUint8Array = function fromUint8Array(u8a, urlsafe) {
    if (urlsafe === void 0) {
      urlsafe = false;
    }
    return urlsafe ? _mkUriSafe(_fromUint8Array(u8a)) : _fromUint8Array(u8a);
  };
  // This trick is found broken https://github.com/dankogai/js-base64/issues/130
  // const utob = (src: string) => unescape(encodeURIComponent(src));
  // reverting good old fationed regexp
  var cb_utob = function cb_utob(c) {
    if (c.length < 2) {
      var cc = c.charCodeAt(0);
      return cc < 0x80 ? c : cc < 0x800 ? _fromCC(0xc0 | cc >>> 6) + _fromCC(0x80 | cc & 0x3f) : _fromCC(0xe0 | cc >>> 12 & 0x0f) + _fromCC(0x80 | cc >>> 6 & 0x3f) + _fromCC(0x80 | cc & 0x3f);
    } else {
      var cc = 0x10000 + (c.charCodeAt(0) - 0xd800) * 0x400 + (c.charCodeAt(1) - 0xdc00);
      return _fromCC(0xf0 | cc >>> 18 & 0x07) + _fromCC(0x80 | cc >>> 12 & 0x3f) + _fromCC(0x80 | cc >>> 6 & 0x3f) + _fromCC(0x80 | cc & 0x3f);
    }
  };
  var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
  /**
   * @deprecated should have been internal use only.
   * @param {string} src UTF-8 string
   * @returns {string} UTF-16 string
   */
  var utob = function utob(u) {
    return u.replace(re_utob, cb_utob);
  };
  //
  var _encode = _hasBuffer ? function (s) {
    return Buffer.from(s, 'utf8').toString('base64');
  } : _TE ? function (s) {
    return _fromUint8Array(_TE.encode(s));
  } : function (s) {
    return _btoa(utob(s));
  };
  /**
   * converts a UTF-8-encoded string to a Base64 string.
   * @param {boolean} [urlsafe] if `true` make the result URL-safe
   * @returns {string} Base64 string
   */
  var encode = function encode(src, urlsafe) {
    if (urlsafe === void 0) {
      urlsafe = false;
    }
    return urlsafe ? _mkUriSafe(_encode(src)) : _encode(src);
  };
  /**
   * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
   * @returns {string} Base64 string
   */
  var encodeURI = function encodeURI(src) {
    return encode(src, true);
  };
  // This trick is found broken https://github.com/dankogai/js-base64/issues/130
  // const btou = (src: string) => decodeURIComponent(escape(src));
  // reverting good old fationed regexp
  var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
  var cb_btou = function cb_btou(cccc) {
    switch (cccc.length) {
      case 4:
        var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3),
            offset = cp - 0x10000;
        return _fromCC((offset >>> 10) + 0xd800) + _fromCC((offset & 0x3ff) + 0xdc00);
      case 3:
        return _fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
      default:
        return _fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
  };
  /**
   * @deprecated should have been internal use only.
   * @param {string} src UTF-16 string
   * @returns {string} UTF-8 string
   */
  var btou = function btou(b) {
    return b.replace(re_btou, cb_btou);
  };
  /**
   * polyfill version of `atob`
   */
  var atobPolyfill = function atobPolyfill(asc) {
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, '');
    if (!b64re.test(asc)) throw new TypeError('malformed base64.');
    asc += '=='.slice(2 - (asc.length & 3));
    var u24,
        bin = '',
        r1,
        r2;
    for (var i = 0; i < asc.length;) {
      u24 = b64tab[asc.charAt(i++)] << 18 | b64tab[asc.charAt(i++)] << 12 | (r1 = b64tab[asc.charAt(i++)]) << 6 | (r2 = b64tab[asc.charAt(i++)]);
      bin += r1 === 64 ? _fromCC(u24 >> 16 & 255) : r2 === 64 ? _fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : _fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
  };
  /**
   * does what `window.atob` of web browsers do.
   * @param {String} asc Base64-encoded string
   * @returns {string} binary string
   */
  var _atob = _hasatob ? function (asc) {
    return atob(_tidyB64(asc));
  } : _hasBuffer ? function (asc) {
    return Buffer.from(asc, 'base64').toString('binary');
  } : atobPolyfill;
  //
  var _toUint8Array = _hasBuffer ? function (a) {
    return _U8Afrom(Buffer.from(a, 'base64'));
  } : function (a) {
    return _U8Afrom(_atob(a), function (c) {
      return c.charCodeAt(0);
    });
  };
  /**
   * converts a Base64 string to a Uint8Array.
   */
  var toUint8Array = function toUint8Array(a) {
    return _toUint8Array(_unURI(a));
  };
  //
  var _decode = _hasBuffer ? function (a) {
    return Buffer.from(a, 'base64').toString('utf8');
  } : _TD ? function (a) {
    return _TD.decode(_toUint8Array(a));
  } : function (a) {
    return btou(_atob(a));
  };
  var _unURI = function _unURI(a) {
    return _tidyB64(a.replace(/[-_]/g, function (m0) {
      return m0 == '-' ? '+' : '/';
    }));
  };
  /**
   * converts a Base64 string to a UTF-8 string.
   * @param {String} src Base64 string.  Both normal and URL-safe are supported
   * @returns {string} UTF-8 string
   */
  var decode = function decode(src) {
    return _decode(_unURI(src));
  };
  /**
   * check if a value is a valid Base64 string
   * @param {String} src a value to check
   */
  var isValid = function isValid(src) {
    if (typeof src !== 'string') return false;
    var s = src.replace(/\s+/g, '').replace(/={0,2}$/, '');
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
  };
  //
  var _noEnum = function _noEnum(v) {
    return {
      value: v,
      enumerable: false,
      writable: true,
      configurable: true
    };
  };
  /**
   * extend String.prototype with relevant methods
   */
  var extendString = function extendString() {
    var _add = function _add(name, body) {
      return Object.defineProperty(String.prototype, name, _noEnum(body));
    };
    _add('fromBase64', function () {
      return decode(this);
    });
    _add('toBase64', function (urlsafe) {
      return encode(this, urlsafe);
    });
    _add('toBase64URI', function () {
      return encode(this, true);
    });
    _add('toBase64URL', function () {
      return encode(this, true);
    });
    _add('toUint8Array', function () {
      return toUint8Array(this);
    });
  };
  /**
   * extend Uint8Array.prototype with relevant methods
   */
  var extendUint8Array = function extendUint8Array() {
    var _add = function _add(name, body) {
      return Object.defineProperty(Uint8Array.prototype, name, _noEnum(body));
    };
    _add('toBase64', function (urlsafe) {
      return fromUint8Array(this, urlsafe);
    });
    _add('toBase64URI', function () {
      return fromUint8Array(this, true);
    });
    _add('toBase64URL', function () {
      return fromUint8Array(this, true);
    });
  };
  /**
   * extend Builtin prototypes with relevant methods
   */
  var extendBuiltins = function extendBuiltins() {
    extendString();
    extendUint8Array();
  };
  var gBase64 = {
    version: version,
    VERSION: VERSION,
    atob: _atob,
    atobPolyfill: atobPolyfill,
    btoa: _btoa,
    btoaPolyfill: btoaPolyfill,
    fromBase64: decode,
    toBase64: encode,
    encode: encode,
    encodeURI: encodeURI,
    encodeURL: encodeURI,
    utob: utob,
    btou: btou,
    decode: decode,
    isValid: isValid,
    fromUint8Array: fromUint8Array,
    toUint8Array: toUint8Array,
    extendString: extendString,
    extendUint8Array: extendUint8Array,
    extendBuiltins: extendBuiltins
    //
    // export Base64 to the namespace
    //
    // ES5 is yet to have Object.assign() that may make transpilers unhappy.
    // gBase64.Base64 = Object.assign({}, gBase64);
  };gBase64.Base64 = {};
  Object.keys(gBase64).forEach(function (k) {
    return gBase64.Base64[k] = gBase64[k];
  });
  return gBase64;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("63KW").Buffer))

/***/ }),

/***/ "9vb1":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("bN1p");
var ITERATOR = __webpack_require__("kkCw")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "9vc3":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__("Ds5P");

$export($export.P, 'Array', { copyWithin: __webpack_require__("DPsE") });

__webpack_require__("RhFG")('copyWithin');


/***/ }),

/***/ "9xIj":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__("Ds5P");
var $expm1 = __webpack_require__("x78i");

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),

/***/ "A0n/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("OzIq");
var has = __webpack_require__("WBcL");
var DESCRIPTORS = __webpack_require__("bUqO");
var $export = __webpack_require__("Ds5P");
var redefine = __webpack_require__("R3AP");
var META = __webpack_require__("1aA0").KEY;
var $fails = __webpack_require__("zgIt");
var shared = __webpack_require__("VWgF");
var setToStringTag = __webpack_require__("yYvK");
var uid = __webpack_require__("ulTY");
var wks = __webpack_require__("kkCw");
var wksExt = __webpack_require__("M8WE");
var wksDefine = __webpack_require__("3g/S");
var enumKeys = __webpack_require__("C+Ps");
var isArray = __webpack_require__("XO1R");
var anObject = __webpack_require__("DIVP");
var isObject = __webpack_require__("UKM+");
var toObject = __webpack_require__("FryR");
var toIObject = __webpack_require__("PHqh");
var toPrimitive = __webpack_require__("s4j0");
var createDesc = __webpack_require__("fU25");
var _create = __webpack_require__("7ylX");
var gOPNExt = __webpack_require__("bG/2");
var $GOPD = __webpack_require__("x9zv");
var $GOPS = __webpack_require__("Y1N3");
var $DP = __webpack_require__("lDLk");
var $keys = __webpack_require__("Qh14");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("WcO1").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("Y1aA").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("V3l/")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("2p1q")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "A16L":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("R3AP");
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),

/***/ "A1ng":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__("Ds5P");
var isInteger = __webpack_require__("n982");
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),

/***/ "A52B":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__("x9zv");
var $export = __webpack_require__("Ds5P");
var anObject = __webpack_require__("DIVP");

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),

/***/ "A5qe":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 2017 Julian Garnier
 Released under the MIT license
*/
var $jscomp={scope:{}};$jscomp.defineProperty="function"==typeof Object.defineProperties?Object.defineProperty:function(e,r,p){if(p.get||p.set)throw new TypeError("ES3 does not support getters and setters.");e!=Array.prototype&&e!=Object.prototype&&(e[r]=p.value)};$jscomp.getGlobal=function(e){return"undefined"!=typeof window&&window===e?e:"undefined"!=typeof global&&null!=global?global:e};$jscomp.global=$jscomp.getGlobal(this);$jscomp.SYMBOL_PREFIX="jscomp_symbol_";
$jscomp.initSymbol=function(){$jscomp.initSymbol=function(){};$jscomp.global.Symbol||($jscomp.global.Symbol=$jscomp.Symbol)};$jscomp.symbolCounter_=0;$jscomp.Symbol=function(e){return $jscomp.SYMBOL_PREFIX+(e||"")+$jscomp.symbolCounter_++};
$jscomp.initSymbolIterator=function(){$jscomp.initSymbol();var e=$jscomp.global.Symbol.iterator;e||(e=$jscomp.global.Symbol.iterator=$jscomp.global.Symbol("iterator"));"function"!=typeof Array.prototype[e]&&$jscomp.defineProperty(Array.prototype,e,{configurable:!0,writable:!0,value:function(){return $jscomp.arrayIterator(this)}});$jscomp.initSymbolIterator=function(){}};$jscomp.arrayIterator=function(e){var r=0;return $jscomp.iteratorPrototype(function(){return r<e.length?{done:!1,value:e[r++]}:{done:!0}})};
$jscomp.iteratorPrototype=function(e){$jscomp.initSymbolIterator();e={next:e};e[$jscomp.global.Symbol.iterator]=function(){return this};return e};$jscomp.array=$jscomp.array||{};$jscomp.iteratorFromArray=function(e,r){$jscomp.initSymbolIterator();e instanceof String&&(e+="");var p=0,m={next:function(){if(p<e.length){var u=p++;return{value:r(u,e[u]),done:!1}}m.next=function(){return{done:!0,value:void 0}};return m.next()}};m[Symbol.iterator]=function(){return m};return m};
$jscomp.polyfill=function(e,r,p,m){if(r){p=$jscomp.global;e=e.split(".");for(m=0;m<e.length-1;m++){var u=e[m];u in p||(p[u]={});p=p[u]}e=e[e.length-1];m=p[e];r=r(m);r!=m&&null!=r&&$jscomp.defineProperty(p,e,{configurable:!0,writable:!0,value:r})}};$jscomp.polyfill("Array.prototype.keys",function(e){return e?e:function(){return $jscomp.iteratorFromArray(this,function(e){return e})}},"es6-impl","es3");var $jscomp$this=this;
(function(e,r){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (r),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===typeof module&&module.exports?module.exports=r():e.anime=r()})(this,function(){function e(a){if(!h.col(a))try{return document.querySelectorAll(a)}catch(c){}}function r(a,c){for(var d=a.length,b=2<=arguments.length?arguments[1]:void 0,f=[],n=0;n<d;n++)if(n in a){var k=a[n];c.call(b,k,n,a)&&f.push(k)}return f}function p(a){return a.reduce(function(a,d){return a.concat(h.arr(d)?p(d):d)},[])}function m(a){if(h.arr(a))return a;
h.str(a)&&(a=e(a)||a);return a instanceof NodeList||a instanceof HTMLCollection?[].slice.call(a):[a]}function u(a,c){return a.some(function(a){return a===c})}function C(a){var c={},d;for(d in a)c[d]=a[d];return c}function D(a,c){var d=C(a),b;for(b in a)d[b]=c.hasOwnProperty(b)?c[b]:a[b];return d}function z(a,c){var d=C(a),b;for(b in c)d[b]=h.und(a[b])?c[b]:a[b];return d}function T(a){a=a.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,function(a,c,d,k){return c+c+d+d+k+k});var c=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a);
a=parseInt(c[1],16);var d=parseInt(c[2],16),c=parseInt(c[3],16);return"rgba("+a+","+d+","+c+",1)"}function U(a){function c(a,c,b){0>b&&(b+=1);1<b&&--b;return b<1/6?a+6*(c-a)*b:.5>b?c:b<2/3?a+(c-a)*(2/3-b)*6:a}var d=/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(a)||/hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(a);a=parseInt(d[1])/360;var b=parseInt(d[2])/100,f=parseInt(d[3])/100,d=d[4]||1;if(0==b)f=b=a=f;else{var n=.5>f?f*(1+b):f+b-f*b,k=2*f-n,f=c(k,n,a+1/3),b=c(k,n,a);a=c(k,n,a-1/3)}return"rgba("+
255*f+","+255*b+","+255*a+","+d+")"}function y(a){if(a=/([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(a))return a[2]}function V(a){if(-1<a.indexOf("translate")||"perspective"===a)return"px";if(-1<a.indexOf("rotate")||-1<a.indexOf("skew"))return"deg"}function I(a,c){return h.fnc(a)?a(c.target,c.id,c.total):a}function E(a,c){if(c in a.style)return getComputedStyle(a).getPropertyValue(c.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase())||"0"}function J(a,c){if(h.dom(a)&&
u(W,c))return"transform";if(h.dom(a)&&(a.getAttribute(c)||h.svg(a)&&a[c]))return"attribute";if(h.dom(a)&&"transform"!==c&&E(a,c))return"css";if(null!=a[c])return"object"}function X(a,c){var d=V(c),d=-1<c.indexOf("scale")?1:0+d;a=a.style.transform;if(!a)return d;for(var b=[],f=[],n=[],k=/(\w+)\((.+?)\)/g;b=k.exec(a);)f.push(b[1]),n.push(b[2]);a=r(n,function(a,b){return f[b]===c});return a.length?a[0]:d}function K(a,c){switch(J(a,c)){case "transform":return X(a,c);case "css":return E(a,c);case "attribute":return a.getAttribute(c)}return a[c]||
0}function L(a,c){var d=/^(\*=|\+=|-=)/.exec(a);if(!d)return a;var b=y(a)||0;c=parseFloat(c);a=parseFloat(a.replace(d[0],""));switch(d[0][0]){case "+":return c+a+b;case "-":return c-a+b;case "*":return c*a+b}}function F(a,c){return Math.sqrt(Math.pow(c.x-a.x,2)+Math.pow(c.y-a.y,2))}function M(a){a=a.points;for(var c=0,d,b=0;b<a.numberOfItems;b++){var f=a.getItem(b);0<b&&(c+=F(d,f));d=f}return c}function N(a){if(a.getTotalLength)return a.getTotalLength();switch(a.tagName.toLowerCase()){case "circle":return 2*
Math.PI*a.getAttribute("r");case "rect":return 2*a.getAttribute("width")+2*a.getAttribute("height");case "line":return F({x:a.getAttribute("x1"),y:a.getAttribute("y1")},{x:a.getAttribute("x2"),y:a.getAttribute("y2")});case "polyline":return M(a);case "polygon":var c=a.points;return M(a)+F(c.getItem(c.numberOfItems-1),c.getItem(0))}}function Y(a,c){function d(b){b=void 0===b?0:b;return a.el.getPointAtLength(1<=c+b?c+b:0)}var b=d(),f=d(-1),n=d(1);switch(a.property){case "x":return b.x;case "y":return b.y;
case "angle":return 180*Math.atan2(n.y-f.y,n.x-f.x)/Math.PI}}function O(a,c){var d=/-?\d*\.?\d+/g,b;b=h.pth(a)?a.totalLength:a;if(h.col(b))if(h.rgb(b)){var f=/rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(b);b=f?"rgba("+f[1]+",1)":b}else b=h.hex(b)?T(b):h.hsl(b)?U(b):void 0;else f=(f=y(b))?b.substr(0,b.length-f.length):b,b=c&&!/\s/g.test(b)?f+c:f;b+="";return{original:b,numbers:b.match(d)?b.match(d).map(Number):[0],strings:h.str(a)||c?b.split(d):[]}}function P(a){a=a?p(h.arr(a)?a.map(m):m(a)):[];return r(a,
function(a,d,b){return b.indexOf(a)===d})}function Z(a){var c=P(a);return c.map(function(a,b){return{target:a,id:b,total:c.length}})}function aa(a,c){var d=C(c);if(h.arr(a)){var b=a.length;2!==b||h.obj(a[0])?h.fnc(c.duration)||(d.duration=c.duration/b):a={value:a}}return m(a).map(function(a,b){b=b?0:c.delay;a=h.obj(a)&&!h.pth(a)?a:{value:a};h.und(a.delay)&&(a.delay=b);return a}).map(function(a){return z(a,d)})}function ba(a,c){var d={},b;for(b in a){var f=I(a[b],c);h.arr(f)&&(f=f.map(function(a){return I(a,
c)}),1===f.length&&(f=f[0]));d[b]=f}d.duration=parseFloat(d.duration);d.delay=parseFloat(d.delay);return d}function ca(a){return h.arr(a)?A.apply(this,a):Q[a]}function da(a,c){var d;return a.tweens.map(function(b){b=ba(b,c);var f=b.value,e=K(c.target,a.name),k=d?d.to.original:e,k=h.arr(f)?f[0]:k,w=L(h.arr(f)?f[1]:f,k),e=y(w)||y(k)||y(e);b.from=O(k,e);b.to=O(w,e);b.start=d?d.end:a.offset;b.end=b.start+b.delay+b.duration;b.easing=ca(b.easing);b.elasticity=(1E3-Math.min(Math.max(b.elasticity,1),999))/
1E3;b.isPath=h.pth(f);b.isColor=h.col(b.from.original);b.isColor&&(b.round=1);return d=b})}function ea(a,c){return r(p(a.map(function(a){return c.map(function(b){var c=J(a.target,b.name);if(c){var d=da(b,a);b={type:c,property:b.name,animatable:a,tweens:d,duration:d[d.length-1].end,delay:d[0].delay}}else b=void 0;return b})})),function(a){return!h.und(a)})}function R(a,c,d,b){var f="delay"===a;return c.length?(f?Math.min:Math.max).apply(Math,c.map(function(b){return b[a]})):f?b.delay:d.offset+b.delay+
b.duration}function fa(a){var c=D(ga,a),d=D(S,a),b=Z(a.targets),f=[],e=z(c,d),k;for(k in a)e.hasOwnProperty(k)||"targets"===k||f.push({name:k,offset:e.offset,tweens:aa(a[k],d)});a=ea(b,f);return z(c,{children:[],animatables:b,animations:a,duration:R("duration",a,c,d),delay:R("delay",a,c,d)})}function q(a){function c(){return window.Promise&&new Promise(function(a){return p=a})}function d(a){return g.reversed?g.duration-a:a}function b(a){for(var b=0,c={},d=g.animations,f=d.length;b<f;){var e=d[b],
k=e.animatable,h=e.tweens,n=h.length-1,l=h[n];n&&(l=r(h,function(b){return a<b.end})[0]||l);for(var h=Math.min(Math.max(a-l.start-l.delay,0),l.duration)/l.duration,w=isNaN(h)?1:l.easing(h,l.elasticity),h=l.to.strings,p=l.round,n=[],m=void 0,m=l.to.numbers.length,t=0;t<m;t++){var x=void 0,x=l.to.numbers[t],q=l.from.numbers[t],x=l.isPath?Y(l.value,w*x):q+w*(x-q);p&&(l.isColor&&2<t||(x=Math.round(x*p)/p));n.push(x)}if(l=h.length)for(m=h[0],w=0;w<l;w++)p=h[w+1],t=n[w],isNaN(t)||(m=p?m+(t+p):m+(t+" "));
else m=n[0];ha[e.type](k.target,e.property,m,c,k.id);e.currentValue=m;b++}if(b=Object.keys(c).length)for(d=0;d<b;d++)H||(H=E(document.body,"transform")?"transform":"-webkit-transform"),g.animatables[d].target.style[H]=c[d].join(" ");g.currentTime=a;g.progress=a/g.duration*100}function f(a){if(g[a])g[a](g)}function e(){g.remaining&&!0!==g.remaining&&g.remaining--}function k(a){var k=g.duration,n=g.offset,w=n+g.delay,r=g.currentTime,x=g.reversed,q=d(a);if(g.children.length){var u=g.children,v=u.length;
if(q>=g.currentTime)for(var G=0;G<v;G++)u[G].seek(q);else for(;v--;)u[v].seek(q)}if(q>=w||!k)g.began||(g.began=!0,f("begin")),f("run");if(q>n&&q<k)b(q);else if(q<=n&&0!==r&&(b(0),x&&e()),q>=k&&r!==k||!k)b(k),x||e();f("update");a>=k&&(g.remaining?(t=h,"alternate"===g.direction&&(g.reversed=!g.reversed)):(g.pause(),g.completed||(g.completed=!0,f("complete"),"Promise"in window&&(p(),m=c()))),l=0)}a=void 0===a?{}:a;var h,t,l=0,p=null,m=c(),g=fa(a);g.reset=function(){var a=g.direction,c=g.loop;g.currentTime=
0;g.progress=0;g.paused=!0;g.began=!1;g.completed=!1;g.reversed="reverse"===a;g.remaining="alternate"===a&&1===c?2:c;b(0);for(a=g.children.length;a--;)g.children[a].reset()};g.tick=function(a){h=a;t||(t=h);k((l+h-t)*q.speed)};g.seek=function(a){k(d(a))};g.pause=function(){var a=v.indexOf(g);-1<a&&v.splice(a,1);g.paused=!0};g.play=function(){g.paused&&(g.paused=!1,t=0,l=d(g.currentTime),v.push(g),B||ia())};g.reverse=function(){g.reversed=!g.reversed;t=0;l=d(g.currentTime)};g.restart=function(){g.pause();
g.reset();g.play()};g.finished=m;g.reset();g.autoplay&&g.play();return g}var ga={update:void 0,begin:void 0,run:void 0,complete:void 0,loop:1,direction:"normal",autoplay:!0,offset:0},S={duration:1E3,delay:0,easing:"easeOutElastic",elasticity:500,round:0},W="translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),H,h={arr:function(a){return Array.isArray(a)},obj:function(a){return-1<Object.prototype.toString.call(a).indexOf("Object")},
pth:function(a){return h.obj(a)&&a.hasOwnProperty("totalLength")},svg:function(a){return a instanceof SVGElement},dom:function(a){return a.nodeType||h.svg(a)},str:function(a){return"string"===typeof a},fnc:function(a){return"function"===typeof a},und:function(a){return"undefined"===typeof a},hex:function(a){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a)},rgb:function(a){return/^rgb/.test(a)},hsl:function(a){return/^hsl/.test(a)},col:function(a){return h.hex(a)||h.rgb(a)||h.hsl(a)}},A=function(){function a(a,
d,b){return(((1-3*b+3*d)*a+(3*b-6*d))*a+3*d)*a}return function(c,d,b,f){if(0<=c&&1>=c&&0<=b&&1>=b){var e=new Float32Array(11);if(c!==d||b!==f)for(var k=0;11>k;++k)e[k]=a(.1*k,c,b);return function(k){if(c===d&&b===f)return k;if(0===k)return 0;if(1===k)return 1;for(var h=0,l=1;10!==l&&e[l]<=k;++l)h+=.1;--l;var l=h+(k-e[l])/(e[l+1]-e[l])*.1,n=3*(1-3*b+3*c)*l*l+2*(3*b-6*c)*l+3*c;if(.001<=n){for(h=0;4>h;++h){n=3*(1-3*b+3*c)*l*l+2*(3*b-6*c)*l+3*c;if(0===n)break;var m=a(l,c,b)-k,l=l-m/n}k=l}else if(0===
n)k=l;else{var l=h,h=h+.1,g=0;do m=l+(h-l)/2,n=a(m,c,b)-k,0<n?h=m:l=m;while(1e-7<Math.abs(n)&&10>++g);k=m}return a(k,d,f)}}}}(),Q=function(){function a(a,b){return 0===a||1===a?a:-Math.pow(2,10*(a-1))*Math.sin(2*(a-1-b/(2*Math.PI)*Math.asin(1))*Math.PI/b)}var c="Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),d={In:[[.55,.085,.68,.53],[.55,.055,.675,.19],[.895,.03,.685,.22],[.755,.05,.855,.06],[.47,0,.745,.715],[.95,.05,.795,.035],[.6,.04,.98,.335],[.6,-.28,.735,.045],a],Out:[[.25,
.46,.45,.94],[.215,.61,.355,1],[.165,.84,.44,1],[.23,1,.32,1],[.39,.575,.565,1],[.19,1,.22,1],[.075,.82,.165,1],[.175,.885,.32,1.275],function(b,c){return 1-a(1-b,c)}],InOut:[[.455,.03,.515,.955],[.645,.045,.355,1],[.77,0,.175,1],[.86,0,.07,1],[.445,.05,.55,.95],[1,0,0,1],[.785,.135,.15,.86],[.68,-.55,.265,1.55],function(b,c){return.5>b?a(2*b,c)/2:1-a(-2*b+2,c)/2}]},b={linear:A(.25,.25,.75,.75)},f={},e;for(e in d)f.type=e,d[f.type].forEach(function(a){return function(d,f){b["ease"+a.type+c[f]]=h.fnc(d)?
d:A.apply($jscomp$this,d)}}(f)),f={type:f.type};return b}(),ha={css:function(a,c,d){return a.style[c]=d},attribute:function(a,c,d){return a.setAttribute(c,d)},object:function(a,c,d){return a[c]=d},transform:function(a,c,d,b,f){b[f]||(b[f]=[]);b[f].push(c+"("+d+")")}},v=[],B=0,ia=function(){function a(){B=requestAnimationFrame(c)}function c(c){var b=v.length;if(b){for(var d=0;d<b;)v[d]&&v[d].tick(c),d++;a()}else cancelAnimationFrame(B),B=0}return a}();q.version="2.2.0";q.speed=1;q.running=v;q.remove=
function(a){a=P(a);for(var c=v.length;c--;)for(var d=v[c],b=d.animations,f=b.length;f--;)u(a,b[f].animatable.target)&&(b.splice(f,1),b.length||d.pause())};q.getValue=K;q.path=function(a,c){var d=h.str(a)?e(a)[0]:a,b=c||100;return function(a){return{el:d,property:a,totalLength:N(d)*(b/100)}}};q.setDashoffset=function(a){var c=N(a);a.setAttribute("stroke-dasharray",c);return c};q.bezier=A;q.easings=Q;q.timeline=function(a){var c=q(a);c.pause();c.duration=0;c.add=function(d){c.children.forEach(function(a){a.began=
!0;a.completed=!0});m(d).forEach(function(b){var d=z(b,D(S,a||{}));d.targets=d.targets||a.targets;b=c.duration;var e=d.offset;d.autoplay=!1;d.direction=c.direction;d.offset=h.und(e)?b:L(e,b);c.began=!0;c.completed=!0;c.seek(d.offset);d=q(d);d.began=!0;d.completed=!0;d.duration>b&&(c.duration=d.duration);c.children.push(d)});c.seek(0);c.reset();c.autoplay&&c.restart();return c};return c};q.random=function(a,c){return Math.floor(Math.random()*(c-a+1))+a};return q});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "AOv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AkTE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var toObject = __webpack_require__("FryR");
var toPrimitive = __webpack_require__("s4j0");
var getPrototypeOf = __webpack_require__("KOrd");
var getOwnPropertyDescriptor = __webpack_require__("x9zv").f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__("bUqO") && $export($export.P + __webpack_require__("dm6P"), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),

/***/ "B3Xn":
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),

/***/ "BOYP":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__("0j1G")('WeakSet');


/***/ }),

/***/ "BbyF":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("oeih");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "BfSO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_yxyBox_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("cbIB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_yxyBox_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_yxyBox_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_yxyBox_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "Bj/7":
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__("iDEd");
var delegate = __webpack_require__("ZE5A");

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),

/***/ "BwfY":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("fWfb");
__webpack_require__("M6a0");
__webpack_require__("OYls");
__webpack_require__("QWe/");
module.exports = __webpack_require__("FeBl").Symbol;


/***/ }),

/***/ "C+4B":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("PHqh");
var $getOwnPropertyDescriptor = __webpack_require__("x9zv").f;

__webpack_require__("3i66")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ "C+Ps":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("Qh14");
var gOPS = __webpack_require__("Y1N3");
var pIE = __webpack_require__("Y1aA");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "C/Ro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/loadingIcon.vue?vue&type=template&id=488f1a6e&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingIcon_sun"},[_c('svg',{staticStyle:{"width":"100%","height":"100%"},attrs:{"width":"120","height":"120","viewBox":"-50 -50 220 220","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"transform":"translate(32, 32) rotate(270, 28, 28)"}},[_c('path',{staticClass:"loading-svg__path",attrs:{"fill":"none","stroke":"#FFD74F","stroke-width":"8","stroke-linecap":"round","d":"M28.26,3.99 C15.09,3.99 4.41,14.74 4.41,28 C4.41,41.26 15.09,52.01 28.26,52.01 C41.43,52.01 52.11,41.26 52.11,28"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"#FFD74F","transform":"translate(12, 5)"}},[_c('path',{staticClass:"loading-svg__sun",attrs:{"d":"M48.26,26 C64.28,26 77.26,38.98 77.26,55 C77.26,71.02 64.28,84 48.26,84 C32.24,84 19.26,71.02 19.26,55 C19.26,38.98 32.24,26 48.26,26 Z M48.26,15.94 C45.55,15.94 43.35,13.73 43.35,11 L43.35,4.94 C43.35,2.21 45.55,-0 48.26,-0 C50.97,-0 53.17,2.21 53.17,4.94 L53.17,11 C53.17,13.73 50.97,15.94 48.26,15.94 Z M48.26,94 C50.97,94 53.17,96.21 53.17,98.94 L53.17,105 C53.17,107.73 50.97,109.94 48.26,109.94 C45.55,109.94 43.35,107.73 43.35,105 L43.35,98.94 C43.35,96.21 45.55,94 48.26,94 Z M12.64,28.74 C15,30.1 15.81,33.11 14.46,35.46 C13.11,37.8 10.09,38.6 7.73,37.24 L2.48,34.2 C0.12,32.84 -0.7,29.83 0.65,27.49 C2.01,25.14 5.02,24.34 7.38,25.71 L12.64,28.74 Z M94.04,75.74 C96.41,77.1 97.22,80.11 95.87,82.46 C94.51,84.8 91.5,85.6 89.14,84.23 L83.88,81.2 C81.52,79.84 80.71,76.83 82.06,74.48 C83.42,72.14 86.43,71.34 88.79,72.71 L94.04,75.74 Z M7.73,72.71 C10.09,71.34 13.11,72.14 14.46,74.48 C15.81,76.83 15,79.84 12.64,81.2 L7.38,84.23 C5.02,85.6 2.01,84.8 0.65,82.46 C-0.7,80.11 0.12,77.1 2.48,75.74 L7.73,72.71 Z M88.79,37.24 C86.43,38.6 83.41,37.8 82.06,35.46 C80.71,33.11 81.52,30.1 83.88,28.74 L89.14,25.71 C91.5,24.34 94.51,25.14 95.87,27.49 C97.22,29.83 96.4,32.84 94.04,34.2 L88.79,37.24 Z","transform":"scale(0)"}})])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/common/loadingIcon.vue?vue&type=template&id=488f1a6e&scoped=true&

// EXTERNAL MODULE: ./node_modules/animejs/anime.min.js
var anime_min = __webpack_require__("A5qe");
var anime_min_default = /*#__PURE__*/__webpack_require__.n(anime_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/loadingIcon.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// loadingAnimate 已经不用了
// import {drawSvg} from '../../lib/loadingAnimate';


/* harmony default export */ var loadingIconvue_type_script_lang_js_ = ({
    name: 'loadingAnimate',
    mounted: function mounted() {
        this.getAnime = this.startAnimation();
    },

    methods: {
        startAnimation: function startAnimation() {
            var sun = this.$el.querySelector('.loading-svg__sun'),
                line = this.$el.querySelector('.loading-svg__path'),

            // lineCenter = ` ${(line.getBBox().width + 8) / 2}`, // 8是stroke-width
            // sunInfo = sun.getBBox(),
            sunInfo = { width: 96, height: 110 },
                sunObj = { r: 0, s: 0 },
                currentAnime;

            // lineCenter += lineCenter + ')';

            startOneCycle();

            function startOneCycle() {
                currentAnime = anime_min_default()({
                    targets: line,
                    strokeDashoffset: [function (path) {
                        return anime_min_default.a.setDashoffset(path) / 2;
                    }, function (path) {
                        return -anime_min_default.a.setDashoffset(path);
                    }],
                    update: function update(e) {
                        e.animatables[0].target.setAttribute('transform', 'rotate(-' + e.progress * 720 / 100 + ' 28 28)');
                        // e.animatables[0].target.setAttribute('transform', 'rotate(-' + (e.progress * 720 / 100) + lineCenter)
                    },


                    duration: 1000,
                    easing: 'linear',
                    elasticity: 0
                });

                return currentAnime.finished.then(function () {
                    currentAnime = anime_min_default()({
                        targets: sunObj,
                        s: 1,

                        duration: 400,
                        easing: 'linear',
                        elasticity: 0,
                        update: function update(e) {
                            var progress = e.progress / 100;

                            sun.setAttribute('transform', 'translate(' + (1 - progress) * sunInfo.width / 2 + ' ' + (1 - progress) * sunInfo.height / 2 + ') scale(' + progress + ')');
                            // sun.setAttribute('transform', `translate(${(1-progress)*sunInfo.width/2} ${(1-progress)*sunInfo.height/2}) scale(${progress})`);
                        }
                    });

                    return currentAnime.finished;
                }).then(function () {
                    currentAnime = anime_min_default()({
                        targets: sunObj,
                        r: 300,

                        // loop: true,
                        duration: 2400,
                        easing: 'linear',
                        elasticity: 0,
                        update: function update(e) {
                            sun.setAttribute('transform', 'rotate(' + sunObj.r + ' ' + sunInfo.width / 2 + ' ' + sunInfo.height / 2 + ')');
                        }
                    });

                    return currentAnime.finished;
                }).then(function () {
                    sunObj.r = 0;
                    sunObj.s = 0;
                    sun.setAttribute('transform', 'scale(0)');

                    startOneCycle();
                });
            }

            return function () {
                return currentAnime;
            };
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.getAnime && this.getAnime().pause();
        this.getAnime = null;
    }
});
// CONCATENATED MODULE: ./src/components/common/loadingIcon.vue?vue&type=script&lang=js&
 /* harmony default export */ var common_loadingIconvue_type_script_lang_js_ = (loadingIconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/common/loadingIcon.vue?vue&type=style&index=0&id=488f1a6e&lang=scss&scoped=true&
var loadingIconvue_type_style_index_0_id_488f1a6e_lang_scss_scoped_true_ = __webpack_require__("+eAd");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/common/loadingIcon.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  common_loadingIconvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "488f1a6e",
  null
  
)

/* harmony default export */ var loadingIcon = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "C416":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/btn_close.573c40a.png";

/***/ }),

/***/ "C4MV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("9bBU"), __esModule: true };

/***/ }),

/***/ "CEO+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var $forEach = __webpack_require__("LhTa")(0);
var STRICT = __webpack_require__("NNrz")([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "CEne":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("OzIq");
var dP = __webpack_require__("lDLk");
var DESCRIPTORS = __webpack_require__("bUqO");
var SPECIES = __webpack_require__("kkCw")('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "CF4R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("mhrf");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),

/***/ "CVR+":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__("Ds5P");
var aFunction = __webpack_require__("XSOZ");
var anObject = __webpack_require__("DIVP");
var rApply = (__webpack_require__("OzIq").Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__("zgIt")(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),

/***/ "CXw9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("O4g8");
var global = __webpack_require__("7KvD");
var ctx = __webpack_require__("+ZMJ");
var classof = __webpack_require__("RY/4");
var $export = __webpack_require__("kM2E");
var isObject = __webpack_require__("EqjI");
var aFunction = __webpack_require__("lOnJ");
var anInstance = __webpack_require__("2KxR");
var forOf = __webpack_require__("NWt+");
var speciesConstructor = __webpack_require__("t8x9");
var task = __webpack_require__("L42u").set;
var microtask = __webpack_require__("82Mu")();
var newPromiseCapabilityModule = __webpack_require__("qARP");
var perform = __webpack_require__("dNDb");
var userAgent = __webpack_require__("iUbK");
var promiseResolve = __webpack_require__("fJUb");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("dSzd")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("xH/j")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("e6n0")($Promise, PROMISE);
__webpack_require__("bRrM")(PROMISE);
Wrapper = __webpack_require__("FeBl")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("dY0y")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "Cdx3":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("sB3e");
var $keys = __webpack_require__("lktj");

__webpack_require__("uqUo")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "Cmhu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("33LG");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "CpFK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_pageTitle_vue_vue_type_style_index_0_id_765fb3af_lang_scss_scoped_true___ = __webpack_require__("wSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_pageTitle_vue_vue_type_style_index_0_id_765fb3af_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_pageTitle_vue_vue_type_style_index_0_id_765fb3af_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_pageTitle_vue_vue_type_style_index_0_id_765fb3af_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "CvWX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("Ds5P");
var toLength = __webpack_require__("BbyF");
var context = __webpack_require__("kqpo");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("1ETD")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "CwSZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("p8xL");
var formats = __webpack_require__("XgCd");
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    formatter: formats.formatters[formats['default']],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly,
    charset
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = obj.join(',');
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (isArray(obj)) {
            pushToArray(values, stringify(
                obj[key],
                typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix,
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        } else {
            pushToArray(values, stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        }
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.formatter,
            options.encodeValuesOnly,
            options.charset
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ "D2L2":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "D6sz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var GetIntrinsic = __webpack_require__("nSQQ");
var callBound = __webpack_require__("IiB5");
var inspect = __webpack_require__("bqLP");

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function listGetNode(list, key) {
	// eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function listGet(objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function listSet(objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function listHas(objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function assert(key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function get(key) {
			// eslint-disable-line consistent-return
			if ($WeakMap && key && ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) {
					// eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function has(key) {
			if ($WeakMap && key && ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) {
					// eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function set(key, value) {
			if ($WeakMap && key && ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
      * Initialize the linked list as an empty node, so that we don't have
      * to special-case handling of the first node: we can always refer to
      * it as (previous node).next, instead of something like (list).head
      */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};

/***/ }),

/***/ "DDCP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("p8xL");

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset);
            val = options.decoder(part.slice(pos + 1), defaults.decoder, charset);
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (val && options.comma && val.indexOf(',') > -1) {
            val = val.split(',');
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        depth: typeof opts.depth === 'number' ? opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),

/***/ "DIVP":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("UKM+");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "DPOj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DPsE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__("FryR");
var toAbsoluteIndex = __webpack_require__("zo/l");
var toLength = __webpack_require__("BbyF");

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),

/***/ "DQCr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "DQfQ":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__("Ds5P");

$export($export.G, { global: __webpack_require__("OzIq") });


/***/ }),

/***/ "DVdL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./src/store/store.js + 23 modules
var store = __webpack_require__("wtEF");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/xstream/index.js
var xstream = __webpack_require__("ryRw");
var xstream_default = /*#__PURE__*/__webpack_require__.n(xstream);

// CONCATENATED MODULE: ./src/lib/dom.js
var matches = __webpack_require__("pFvp");

var $tmp;

/* harmony default export */ var dom = ({
    matches: matches,
    create: function create(html) {
        var $node;

        if (!$tmp) $tmp = document.createElement('div');

        $tmp.innerHTML = html;
        $node = $tmp.firstChild;
        $tmp.removeChild($node);

        return $node;
    },
    closest: function closest(node, exp) {
        do {
            if (matches(node, exp)) return node;
        } while (node && (node = node.parentNode));

        return false;
    }
});
// CONCATENATED MODULE: ./src/lib/dialog.js






var indexOf = Array.prototype.indexOf;
var extend = assign_default.a;

/**
 * 创建一个stream和模态框，stream的next和compolele由模态框的交互触发
 * @param  {String}          content    模态框内容
 * @param  {String|Function} okText     确认文本，或按钮的工厂函数
 * @param  {String}          cancelText 取消文本
 * @param  {Object}          config     其他配置，比dialog的配置多以下字段
 * @param  {Boolean}         config.reverse      是否反转按钮的布局
 * @param  {*}               config.cancelValue  关闭模态框是也next值
 * @param  {function}        config.onClose  关闭弹窗回调
 *
 * @syntax
 * Stream.dialog(content, okText, cancelText, config)
 * Stream.dialog(content, factory)
 * Stream.dialog(content, factory, config)
 */
xstream["Stream"].dialog = function (content, okText, cancelText, config) {
    return xstream["Stream"].create({
        start: function start(prod) {
            var _dialog, options, _onClose;
            var callbackList = [function (value) {
                prod.next({ value: value, dialog: _dialog });
            }, function () {
                config.hasOwnProperty('cancelValue') ? callbackList[0](config.cancelValue) : prod.complete();
            }];

            options = {
                content: content,
                button: typeof okText === 'function' ? okText.apply(null, callbackList) : [okText, cancelText].filter(function (text) {
                    return typeof text === 'string';
                }).map(function (text, i) {
                    return { text: text, callback: callbackList[i], type: i === 1 ? 'cancel' : 'ok' };
                })
            };

            if (cancelText && (typeof cancelText === 'undefined' ? 'undefined' : typeof_default()(cancelText)) === 'object') {
                config = cancelText;
            }

            _onClose = config && config.onClose;
            config = config || {};

            config = assign_default()(Dialog.defaultConfig, config);
            extend(options, config, {
                onClose: function onClose() {
                    _onClose ? _onClose(callbackList[0]) : callbackList[1]();
                }
            });
            if (options.reverse) {
                options.button.reverse();
            }

            this.dialog = _dialog = dialog_dialog(options);
        },
        stop: function stop() {
            this.dialog.del();
        }
    });
};

var tplReg = /<%([\s\S]*?)%>/g;
var btnTpl = '<a href="#" class="js-dialog-btn <%className%>"><%text%></a>';
var dialogTpl = '<div class="cp-dialog-wrap cp-dialog-wrap--close s-tabcell fs-14" style="display: none;">\n    <div class="cp-dialog">\n        <div class="icon-close-btn js-dialog-close-btn"><i class="icon-close2 d-b"></i></div>\n        <div class="cp-dialog__title"><%title%></div>\n        <div class="cp-dialog__body"><%content%></div>\n        <div class="cp-dialog__footer flex"><%buttons%></div>\n    </div>\n</div>';

var btnTplCF = '<a href="#" class="js-dialog-btn js-dialog-btn-cf <%className%>"><%text%></a>';
var dialogTplCF = '<div class="cp-dialog-wrap cp-dialog-wrap--close s-tabcell fs-14" style="display: none;">\n    <div class="cp-dialog">\n        <div class="icon-close-btn js-dialog-close-btn"><i class="icon-close2 d-b"></i></div>\n        <div class="cp-dialog__title"><%title%></div>\n        <div class="cp-dialog__body"><%content%></div>\n        <div class="cp-dialog__footer_cf"><%buttons%></div>\n    </div>\n</div>';

Dialog.setting = {
    classNameSheet: {
        ok: 'cp-btn cp-btn--yellow flex__item',
        cancel: 'cp-btn flex__item'
    }
};

Dialog.setting_cf = {
    classNameSheet: {
        active: 'cp-btn cp-btn--yellow',
        cancel: 'cp-btn',
        common: 'cp-btn btn-common',
        disabled: 'cp-btn disabled'

    }
};

Dialog.defaultConfig = {
    reverse: false
};

function Dialog(options) {
    var self = this;
    var $dialog,
        buttons = options.button || [];
    var params = {
        content: options.content || '',
        title: options.title || '',
        buttons: buttons.map(function (data) {
            return btnTpl.replace(tplReg, function (_, field) {
                var val = data[field];
                if (!val && !data.isCf && field === 'className') {
                    return Dialog.setting.classNameSheet[data.type || 'ok'];
                }
                if (!val && data.isCf && field === 'className') {
                    if (data.active) {
                        return Dialog.setting_cf.classNameSheet['active'];
                    } else if (data.disabled) {
                        return Dialog.setting_cf.classNameSheet['disabled'];
                    } else {
                        return Dialog.setting_cf.classNameSheet['common'];
                    }
                }

                return val;
            });
        }).join('')

    };
    if (options.button.length === 3) {
        $dialog = dom.create(dialogTplCF.replace(tplReg, function (_, field) {
            return params[field] || '';
        }));
    } else {
        $dialog = dom.create(dialogTpl.replace(tplReg, function (_, field) {
            return params[field] || '';
        }));
    }

    if (!options.useCloseBtn) {
        $dialog.classList.add('cp-dialog-wrap--no-close');
    }

    document.body.appendChild($dialog);
    $dialog.addEventListener('click', self._handler = function (e) {
        var node = e.target;
        var $btn = dom.closest(node, '.js-dialog-btn');

        if ($btn) {
            var cb = self.callbackList[indexOf.call($btn.parentNode.children, $btn)];
            e.preventDefault();
            typeof cb === 'string' ? self[cb]() : cb.call(self, 'success');
        } else if (dom.closest(node, '.js-dialog-close-btn')) {
            self.del(true);
        } else if (options.backdropClose && node === this) {
            self.del(true);
        }
    });

    this.options = options;
    this.$dialog = $dialog;
    this.callbackList = buttons.map(function (data) {
        return data.callback;
    });

    this.show();
}

Dialog.prototype = {
    show: function show() {
        var $dialog = this.$dialog;

        $dialog.style.display = '';
        $dialog.clientHeight;
        $dialog.classList.remove('cp-dialog-wrap--close');
    },
    del: function del(emitCallback) {
        this.close(true, emitCallback);
    },
    close: function close(del, emitCallback) {
        var $dialog = this.$dialog;
        var onClose = this.options.onClose;

        // 防止多次调用close
        if (!$dialog) return;

        if (!emitCallback || onClose && onClose(this, del) !== false) {
            $dialog.classList.add('cp-dialog-wrap--close');
            del && delete this.$dialog;

            setTimeout(function () {
                if (!$dialog.parentNode) return;

                if (del) {
                    $dialog.parentNode.removeChild($dialog);
                    $dialog.removeEventListener('click', this._handler);
                } else {
                    $dialog.style.display = 'none';
                }
            }, 300);
        }
    }
};

/**
 * 创建一个模态框
 * @param  {Object}  options
 * @param  {String}  options.context       模态框的内容
 * @param  {Boolean} options.useCloseBtn   模态框的右上角关闭按钮
 * @param  {Boolean} options.backdropClose 模态框的背景是否可以关闭
 * @param  {Boolean} options.onClose     模态框的关闭回调函数
 * @param  {Array}   options.button      模态框的按钮
 * @param  {String}           options.button[].text       模态框的按钮文本
 * @param  {String|Function}  options.button[].callback   模态框的按钮回调
 *
 * @example
 * dialog('确定要删除？', [
 *   {text: '是', callback: function() {
 *       ajaxDel().then(() => this.del())
 *   }},
 *   {text: '否', callback: 'del'}
 * ])
 */
function dialog_dialog(options) {
    return new Dialog(options);
}

dialog_dialog.promise = function (text, fn) {
    var dialog;
    var pr = new promise_default.a(function (resolve, reject) {
        dialog = dialog({
            title: title,
            content: text,
            button: fn(resolve, reject)
        });
    });

    pr.dialog = dialog;

    return pr;
};
// EXTERNAL MODULE: ./src/scss/dialog.scss
var scss_dialog = __webpack_require__("kJ6Q");
var dialog_default = /*#__PURE__*/__webpack_require__.n(scss_dialog);

// CONCATENATED MODULE: ./src/lib/units.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return isJsonString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return factorArrayToChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NumberAddZero; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isEmpObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return pageViewTracker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getPageName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return dateFormater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return pick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return cutNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return utf16toEntities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeLineToBr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return secondToTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return loadPageFail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return checkRichTextEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getPlatform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return checkPhone; });
/* unused harmony export objToUrlParams */
/* unused harmony export parseExp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IdentityCodeValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getHashParameters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return replaceAllImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return checkPhoneNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return loadScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return copyText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return handleWrap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return handleBold; });




function isJsonString(str) {
  if (typeof str == 'string') {
    try {
      var obj = JSON.parse(str);
      if ((typeof obj === 'undefined' ? 'undefined' : typeof_default()(obj)) == 'object' && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      // console.log('isJsonString error：'+str+'!!!'+e);
      return false;
    }
  }
  console.log('It is not a string!');
}

// 处理换行符
var handleWrap = function handleWrap(value) {
  if (!value) return;
  return value.replace(/\r|\n/g, '<br>');
};

var handleBold = function handleBold(text) {
  text = handleWrap(text);
  var r = '';
  if (!text) {
    return r;
  }
  for (var i = 0; i < text.length; i++) {
    var t = text[i];
    if (t == '<') {
      var start = text.slice(i, i + 3);
      var end = text.slice(i, i + 4);
      if (start == "<b>") {
        r += "<span class='text-bold' style='font-weight: bold'>";
        i += 2;
      } else if (end == "</b>") {
        r += "</span>";
        i += 3;
      } else {
        r += t;
      }
    } else {
      r += t;
    }
  }
  // console.log('转义后的文字', r)
  return r;
};

// 获取URL 中 Query
function GetQueryString(name) {
  console.log(name);
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

// 获取URL 中 hash
function getHashParameters() {
  var arr = (location.hash || "").replace(/^\#/, '').split("&");
  var params = {};
  for (var i = 0; i < arr.length; i++) {
    var data = arr[i].split("=");
    if (data.length == 2) {
      params[data[0]] = data[1];
    }
  }
  var channelIdObj;
  keys_default()(params).forEach(function (item) {
    if (item.indexOf('?')) {
      var getChannelId = item.split("?")[1];
      if (getChannelId == 'channelId') {
        channelIdObj = {
          channelId: params[item]
        };
      }
    }
  });
  params = assign_default()(params, channelIdObj);
  return params;
}

// 判断Object 是否为空
function isEmpObj(obj) {
  var t = void 0;
  for (t in obj) {
    return !1;
  }
  return !0;
};
// 获取scrollTop
function getScrollTop() {
  return document.body.scrollTop | document.documentElement.scrollTop;
}
/**
 *
 * @param dateObj 日期对象 Date Object
 * @param fmt 格式，字符串类型，YY代表年，MM代表月，DD代表日，hh时，mm分，ss秒，SS毫秒
 * @returns {*}
 */
function dateFormater(dateObj, fmt) {
  if (dateObj instanceof Date) {} else if (!(dateObj instanceof Date) && typeof dateObj == 'string') {
    dateObj = new Date(dateObj.replace(/-/g, '/'));
  } else {
    console.error('日期数据格式错误');
    return;
  }
  var o = {
    "M+": dateObj.getMonth() + 1, //月份
    "D+": dateObj.getDate(), //日
    "h+": dateObj.getHours(), //小时
    "m+": dateObj.getMinutes(), //分
    "s+": dateObj.getSeconds(), //秒
    "q+": Math.floor((dateObj.getMonth() + 3) / 3), //季度
    "S": dateObj.getMilliseconds() //毫秒
  };
  if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (dateObj.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  }return fmt;
}

// 首页和详情页用的已测人数转换规则
function cutNum(num) {
  var leval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

  // 因为返回裁剪后的都是以万为单位，所以规定最少是10的4次幂;
  var standard = Math.pow(10, leval > 4 ? leval : 4);
  if (num > standard) {
    // 虽然level不同，但是最后返回的都要多少多少W人为单位
    return (num / 10000).toFixed(1) + 'W';
  } else {
    return num;
  }
}
// 依据产品需求计算停留时间
function countPVStayTime(enterTime, leaveTime) {
  var second = (leaveTime - enterTime) / 1000;
  var timeTxt = '';

  if (second < 30) {
    timeTxt = '<30s';
  } else if (second > 30 & second < 60) {
    timeTxt = '30s~1min';
  } else if (second > 60 & second < 180) {
    timeTxt = '1~3min';
  } else {
    timeTxt = '>3min';
  }
  return timeTxt;
}

function NumberAddZero(s, level) {
  level = level == undefined ? 1 : level;
  return s * 1 < Math.pow(10, level) ? '0' + s : s;
};

// 测评报告页的维度数据，转换成eCharts图表格式的方法
function factorArrayToChart(factorArray) {
  var chartData = {
    data: [],
    pecent: [],
    label: [],
    resultName: [],
    level: [],
    max: [],
    min: []
  };
  for (var i = 0; i < factorArray.length; i++) {
    var curFactor = factorArray[i];
    if (curFactor.actualScore != undefined) {
      chartData.data.push(curFactor.actualScore.toFixed(2));
    }
    if (curFactor.scoringRatio != undefined) {
      chartData.pecent.push(Math.round(curFactor.scoringRatio));
    }
    if (curFactor.factorName != undefined) {
      chartData.label.push(curFactor.factorName);
    }
    if (curFactor.resultName != undefined) {
      chartData.resultName.push(curFactor.resultName);
    }
    if (curFactor.level != undefined) {
      chartData.level.push(curFactor.level);
    }
    if (curFactor.referenceRange != undefined) {
      var min = curFactor.referenceRange.slice(0, curFactor.referenceRange.indexOf('-')) * 1;
      chartData.min.push(min.toFixed(2));
      var max = curFactor.referenceRange.slice(curFactor.referenceRange.lastIndexOf('-') + 1) * 1;
      chartData.max.push(max.toFixed(2));
    }
  }
  return chartData;
};

// PV统计
// PV统计，获取页面名称
function getPageName(_ref) {
  var router = _ref.router,
      useEnterFrom = _ref.useEnterFrom,
      _ref$enterFromRouter = _ref.enterFromRouter,
      enterFromRouter = _ref$enterFromRouter === undefined ? {
    query: {}
  } : _ref$enterFromRouter,
      _ref$fullTitle = _ref.fullTitle,
      fullTitle = _ref$fullTitle === undefined ? false : _ref$fullTitle;

  var zhugeIoVal = '';
  if (!router && !useEnterFrom) {
    zhugeIoVal = '直接访问';
  } else {
    // 页面没有的，需要用enterFrom 处理的
    if (useEnterFrom | (router && router.name == 'testDetail')) {
      if (!!enterFromRouter.query.enterFrom) {
        switch (enterFromRouter.query.enterFrom) {
          case 'shareImg':
            zhugeIoVal = '分享图';
            break;
          case 'shareMe':
            zhugeIoVal = '分享页_我也要测';
            break;
          case 'shareOther':
            zhugeIoVal = '分享页_大家都在测';
            break;
          case 'testDetail':
            zhugeIoVal = '测评详情页';
            break;
          case 'detail':
            zhugeIoVal = '支付完成';
            break;
          case 'readingReport':
            zhugeIoVal = '解读报告';
            break;
          case 'mine':
            zhugeIoVal = '我的测评';
            break;
          case 'reportCombo':
            zhugeIoVal = '套餐报告页';
            break;
          case 'notify':
            zhugeIoVal = '重复购买';
            break;
          case 'report2':
            zhugeIoVal = '报告';
            break;
          case 'banner':
            zhugeIoVal = 'banner图';
            break;
          default:
            zhugeIoVal = '其他';
        }
      } else {
        if (router) {
          zhugeIoVal = router.meta.title ? typeof router.meta.title == 'function' ? router.meta.title.call(router) : router.meta.title : router.name == null ? '直接访问' : router.name;
        } else {
          zhugeIoVal = '直接访问';
        }
      }
    } else if (fullTitle & typeof router.meta.fullTitle == 'function') {
      zhugeIoVal = router.meta.fullTitle.call(router);
    } else {
      zhugeIoVal = router.meta.title ? typeof router.meta.title == 'function' ? router.meta.title.call(router) : router.meta.title : router.name == null ? '直接访问' : router.name;
    }
  }
  return zhugeIoVal;
};
/**
 *
 * @param Obj
 * Obj has 4 params
 * {to, from, enterTime, leaveTime}
 * to Page, vue-router Obj
 * from page, vue-router Obj,
 * enterTime, Date
 * leaveTime, Date
 */
function pageViewTracker(_ref2) {
  var to = _ref2.to,
      from = _ref2.from,
      enterTime = _ref2.enterTime,
      leaveTime = _ref2.leaveTime,
      addOn = _ref2.addOn,
      isLeave = _ref2.isLeave;

  console.log("pageViewTracker");
  /**
   *
   * @param router
   * @returns {{}}
   */
  function getQueryParams(router) {
    var otherOption = {};
    // 分类页的参数
    if (router.query.sort) {
      otherOption['\u680F\u76EE'] = router.query.sort;
    }
    //跟踪标识全局添加
    if (router.query.sourceName) {
      otherOption['\u8DDF\u8E2A\u6807\u8BC6'] = router.query.sourceName;
    }
    if (router.query.sortType) {
      var _sortTypeMap;

      var sortTypeMap = (_sortTypeMap = {}, defineProperty_default()(_sortTypeMap, '1', '\u6309\u70ED\u5EA6'), defineProperty_default()(_sortTypeMap, '2', '\u6309\u65F6\u95F4'), defineProperty_default()(_sortTypeMap, '3', '\u6309\u4EF7\u683C'), _sortTypeMap);
      otherOption['\u6392\u5E8F\u65B9\u5F0F'] = sortTypeMap[router.query.sortType];
    }

    return otherOption;
  }

  function mergeOptions() {
    var obj1 = void 0;
    if (!isLeave) {
      obj1 = assign_default()(getQueryParams(to), defineProperty_default()({}, '\u8BBF\u95EE\u65F6\u95F4', dateFormater(enterTime, 'YY/MM/DD hh:mm:ss')));
    } else {
      var _Object$assign3;

      obj1 = assign_default()(getQueryParams(to), (_Object$assign3 = {}, defineProperty_default()(_Object$assign3, '\u8BBF\u95EE\u65F6\u95F4', dateFormater(enterTime, 'YY/MM/DD hh:mm:ss')), defineProperty_default()(_Object$assign3, '\u79BB\u5F00\u65F6\u95F4', dateFormater(leaveTime, 'YY/MM/DD hh:mm:ss')), defineProperty_default()(_Object$assign3, '\u6D4F\u89C8\u65F6\u957F', countPVStayTime(enterTime, leaveTime)), _Object$assign3));
    }
    return assign_default()(obj1, addOn);
  }

  var fromPage = getPageName({
    router: from,
    useEnterFrom: true,
    enterFromRouter: to
  });
  var toPage = getPageName({
    router: to,
    useEnterFrom: false
  });
  console.info('\u4ECE' + fromPage + '\u8BBF\u95EE' + toPage);
  // 同页面，不算PV, 测评详情页除外
  if (to.name == (from ? from.name : '') & to.name != 'testDetail') {
    return;
  }

  try {
    if (!to.meta.newZhugeTitle) {
      // 诸葛IO 统计
      if (!isLeave) {
        // 访问toPage，来自fromPage
        window.TRACKER.pageView(toPage, fromPage, mergeOptions());
      } else {
        // 离开 fromPage， 前往toPage
        window.TRACKER.pageLeave(fromPage, toPage, mergeOptions());
      }
    } else {
      if (isLeave) {
        window.TRACKER.newPageView(to.meta.newZhugeTitle, toPage, mergeOptions());
      }
    }

    //百度统计
    if (_hmt) {
      _hmt.push(['_trackPageview', location.pathname + '#' + to.path]);
    }
  } catch (err) {
    console.error(err);
  }
}

// lodash.pick的代替品
function pick(obj, keys) {
  return keys.reduce(function (result, key) {
    result[key] = obj[key];
    return result;
  }, {});
}

/**
 * 对多字节 emoji 进行转换 HTML 字符实体的处理
 * @param str
 * @returns {string|*}
 */
function utf16toEntities(str) {
  var patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则
  str = String(str);
  str = str.replace(patt, function (char) {
    var H, L, code;
    if (char.length === 2) {
      H = char.charCodeAt(0); // 取出高位
      L = char.charCodeAt(1); // 取出低位
      code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00; // 转换算法
      return "&#" + code + ";";
    } else {
      return char;
    }
  });
  return str;
}

function objToUrlParams(obj) {
  var paramsStr = '';
  for (var key in obj) {
    if (typeof_default()(obj[key]).toLowerCase() !== 'object') {
      // 除去undefined
      if (obj[key] !== undefined) {
        paramsStr = paramsStr + (key + '=' + obj[key] + '&');
      }
    } else if (obj[key] instanceof Array) {
      paramsStr = paramsStr + (key + '=' + obj[key].join() + '&');
    } else {
      var temp = objToUrlParams(obj[key]);
      paramsStr = paramsStr + temp;
    }
  }
  // 移除最后的那个 & 符号
  return paramsStr.slice(0, paramsStr.length - 1);
}
/**
 * 将字符串内部的/n/r换成<br/>
 * @param str
 */
function changeLineToBr(str) {
  var reg = new RegExp("%0A", "g");

  str = escape(str).replace(reg, "%3Cbr/%3E");

  return str;
}
// 输入秒数，转换成 mm:ss的格式
function secondToTime(second) {
  var sec = NumberAddZero(Math.round(second) % 60, 1);
  var minute = NumberAddZero((second / 60).toFixed(0), 1);
  return minute + ':' + sec;
}





function loadPageFail(_ref3) {
  var pagename = _ref3.pagename,
      err = _ref3.err;

  console.log("loadPageFail");
  window.monitor.stat({
    level: 'watch',
    error: 'File',
    msg: err.message,
    remark: '\u52A0\u8F7D' + pagename + '\u5931\u8D25',
    userKey: store["a" /* default */].state.userInfo.userKey
  });
  var dialogData = {};
  dialogData.title = '\u62B1\u6B49\uFF0C\u6D4B\u8BC4\u541B\u5F00\u4E86\u5C0F\u5DEE';
  dialogData.content = '\u52A0\u8F7D' + pagename + '\u5931\u8D25\uFF0C\u68C0\u67E5\u7F51\u7EDC\u5E76\u5C1D\u8BD5\u5237\u65B0\u4E00\u4E0B\uFF01';
  dialogData.button = [{
    text: '好的',
    callback: 'del'
  }];
  dialog_dialog(dialogData);
}

function checkRichTextEmpty(richTextString) {
  var tempEl = document.createElement("div");
  tempEl.innerHTML = richTextString ? richTextString : '';
  if (tempEl.innerText.trim() == "") {
    return true;
  } else {
    return false;
  }
}

function checkPhoneNumber(str) {
  var phone = parseInt(str);
  var pattern = /^\+?([0-9]+((\s?-?)|(-?\s?)))*$/;
  return pattern.test(phone);
}

function getPlatform() {
  var ua = navigator.userAgent,
      //获取浏览器UA
  isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isWechat = /(?:MicroMessenger)/.test(ua),
      isTablet = /(?:iPad|PlayBook)/.test(ua) || isAndroid && !/(?:Mobile)/.test(ua) || isFireFox && /(?:Tablet)/.test(ua),
      isiPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isiPhone && !isAndroid && !isSymbian,
      isYixinliApp = /(?:yixinliApp)/.test(ua),
      isMamawanApp = /(?:PregnancyHelper)/.test(ua);
  return {
    isWechat: isWechat,
    isTablet: isTablet,
    isiPhone: isiPhone,
    isAndroid: isAndroid,
    isPc: isPc,
    isYixinliApp: isYixinliApp,
    isMamawanApp: isMamawanApp
  };
}

function checkPhone(val) {
  if (!/^1(3|4|5|7|8|6|9)\d{9}$/.test(val)) {
    return false;
  }
  return true;
}

// 身份证号码验证
function IdentityCodeValid(code) {
  var city = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外 "
  };
  var tip = "";
  var pass = true;

  if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
    tip = "身份证号格式错误";
    pass = false;
  } else if (!city[code.substr(0, 2)]) {
    tip = "地址编码错误";
    pass = false;
  } else {
    //18位身份证需要验证最后一位校验位
    if (code.length == 18) {
      code = code.split("");
      //∑(ai×Wi)(mod 11)
      //加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      //校验位
      var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
      var sum = 0;
      var ai = 0;
      var wi = 0;
      for (var i = 0; i < 17; i++) {
        ai = code[i];
        wi = factor[i];
        sum += ai * wi;
      }
      var last = parity[sum % 11];
      if (parity[sum % 11] != code[17]) {
        tip = "校验位错误";
        pass = false;
      }
    }
  }
  return pass;
}

/**
 * 设置/计算上下文值
 * @param  {}       context 上下文对象。
 * @param  {String} exp     字段表达式，以'.'和'[\d+]'分割成字段的访问堆栈
 * @param  {}       val     要设置的值，不传时为get。
 *
 * @example
 *  var data = {
 *      asd: {qwe: 123}
 *  };
 *
 *  parseExp(data, 'asd.qwe', 789);
 */
function parseExp(context, exp, val) {
  var chain = exp.replace(/^\[(\d+)\]/, '$1').replace(/\[(\d+)\]/g, '.$1').split('.'),
      last_key;

  if (arguments.length === 3) {
    last_key = chain.pop();
  }

  for (var i = 0; i < chain.length; i++) {
    if (!context) return;
    context = context[chain[i]];
  }

  if (last_key) {
    context[last_key] = val;
  } else {
    return context;
  }
}

//懒加载
function replaceAllImg(html) {
  var newContent = html.replace(/<img[^>]*>/gi, function (str, capture) {
    var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
    var url = str.match(srcReg);
    var mat = str.replace(/src=\"(.*)\"/gi, 'data-src=' + url[1]);
    return mat;
  });
  return newContent;
}

function loadScript(url, callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.onload = function () {
    script.onload = null;
    if (callback) callback();
  };

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

function copyText(vm, content, cb) {
  var selection = window.getSelection();
  var range = document.createRange();
  var $code = document.createElement('div');
  $code.display = 'none';
  $code.innerHTML = content;
  document.body.appendChild($code);
  range.selectNodeContents($code);
  selection.removeAllRanges();
  selection.addRange(range);
  if (document.execCommand('copy')) {
    //浏览器是否支持复制
    document.execCommand('copy');
    if (cb) {
      cb();
    } else {
      vm.setTOASTTEXT('复制成功');
    }
  } else {
    vm.setTOASTTEXT('浏览器不支持复制功能');
  }
  selection = null;
  range = null;
  document.body.removeChild($code);
}



/* harmony default export */ var units = ({
  isJsonString: isJsonString,
  GetQueryString: GetQueryString,
  isEmpObj: isEmpObj,
  NumberAddZero: NumberAddZero,
  factorArrayToChart: factorArrayToChart,
  pageViewTracker: pageViewTracker,
  getPageName: getPageName,
  dateFormater: dateFormater,
  pick: pick,
  cutNum: cutNum,
  utf16toEntities: utf16toEntities,
  changeLineToBr: changeLineToBr,
  secondToTime: secondToTime,
  loadPageFail: loadPageFail,
  checkRichTextEmpty: checkRichTextEmpty,
  getPlatform: getPlatform,
  checkPhone: checkPhone,
  objToUrlParams: objToUrlParams,
  parseExp: parseExp,
  IdentityCodeValid: IdentityCodeValid,
  getHashParameters: getHashParameters,
  replaceAllImg: replaceAllImg,
  checkPhoneNumber: checkPhoneNumber,
  loadScript: loadScript,
  handleWrap: handleWrap,
  handleBold: handleBold
});

/***/ }),

/***/ "DX9u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("8Uqm");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),

/***/ "DYhr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/earning-tip.2df3348.png";

/***/ }),

/***/ "Dbwr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/btn_close.1d7aca2.png";

/***/ }),

/***/ "Dd8w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "Dgii":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("lDLk").f;
var create = __webpack_require__("7ylX");
var redefineAll = __webpack_require__("A16L");
var ctx = __webpack_require__("rFzY");
var anInstance = __webpack_require__("9GpA");
var forOf = __webpack_require__("vmSO");
var $iterDefine = __webpack_require__("uc2A");
var step = __webpack_require__("KB1o");
var setSpecies = __webpack_require__("CEne");
var DESCRIPTORS = __webpack_require__("bUqO");
var fastKey = __webpack_require__("1aA0").fastKey;
var validate = __webpack_require__("zq/X");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "Ds5P":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("OzIq");
var core = __webpack_require__("7gX0");
var hide = __webpack_require__("2p1q");
var redefine = __webpack_require__("R3AP");
var ctx = __webpack_require__("rFzY");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "EGZi":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "EGdc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_footerNav_vue_vue_type_style_index_0_id_2f14c9b4_lang_scss_scoped_true___ = __webpack_require__("avV3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_footerNav_vue_vue_type_style_index_0_id_2f14c9b4_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_footerNav_vue_vue_type_style_index_0_id_2f14c9b4_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_footerNav_vue_vue_type_style_index_0_id_2f14c9b4_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "EKta":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "EQyZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "EWrS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__("y325")('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),

/***/ "EZ+5":
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__("wCso");
var anObject = __webpack_require__("DIVP");
var aFunction = __webpack_require__("XSOZ");
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),

/***/ "EaTJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-brand.7e430c5.png";

/***/ }),

/***/ "EqBC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("kM2E");
var core = __webpack_require__("FeBl");
var global = __webpack_require__("7KvD");
var speciesConstructor = __webpack_require__("t8x9");
var promiseResolve = __webpack_require__("fJUb");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "EqjI":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "Eqnl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/frontend-lib/lib/Bridge.js
var lib_Bridge = __webpack_require__("wlTy");

// EXTERNAL MODULE: ./src/frontend-lib/tools/getPlatform.js
var getPlatform = __webpack_require__("hTeI");
var getPlatform_default = /*#__PURE__*/__webpack_require__.n(getPlatform);

// EXTERNAL MODULE: ./src/frontend-lib/tools/utils.js + 1 modules
var utils = __webpack_require__("Zt1H");

// CONCATENATED MODULE: ./src/frontend-lib/lib/zxsBridge.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Bridge.js
 * 适应于壹心理js调用native方法
 *
 * ex:
 * var bridge = new Bridge({
 * 	methods:[
 * 		{
 * 			method: "goBack",
 * 			callback: function(param){}
 * 		}
 * 	]
 * });
 *
 * bridge.call("setTitle",{title:"我是标题"});
 * options.disInitAppHook true为不执行AppHookInit
 */

// docs: http://112.124.122.87:8090/pages/viewpage.action?pageId=5570901



// import { isEmpObj } from './index.js'
// 判断Object 是否为空
function isEmpObj(obj) {
  var t = void 0;
  for (t in obj) {
    return !1;
  }
  return !0;
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

function isArray(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
}

function anyToJSON(anythink) {
  if ((typeof anythink === 'undefined' ? 'undefined' : _typeof(anythink)) === 'object') return anythink;
  try {
    var at = JSON.parse(anythink);
    if ((typeof at === 'undefined' ? 'undefined' : _typeof(at)) === 'object') return at;
  } catch (e) {
    console.log(e);
  }
  return anythink;
}

var waitWebViewJavascriptBridgeTimer = null;
var methodArrays = [];

var zxsBridge_Bridge = function () {
  function Bridge(options) {
    _classCallCheck(this, Bridge);

    this.callMethodsResolve = null;
    this.version = '0.1';
    this.platform = Object(getPlatform["getPlatform"])();
    if (!options || options && !options.disInitAppHook) {
      this.AppHookInit();
    }
    this.ready = null;
    this._init(options);

    this.getAppVersionPromise();
  }

  _createClass(Bridge, [{
    key: 'getAppVersionPromise',
    value: function getAppVersionPromise() {
      var _this = this;

      if (typeof this.isNewApp !== 'undefined') return Promise.resolve(this.isNewApp);
      return new Promise(function (resolve) {
        _this.call('getAppVervison', {}, function (version) {
          var isNewApp = Object(utils["e" /* versionfunegt */])(version, _this.platform.isAndroid ? ' 1.3.0' : '1.4.1');
          // window.localStorage.setItem('isNewApp', isNewApp ? '1' : '0')
          _this.isNewApp = isNewApp;
          resolve();
        });
      });
    }
  }, {
    key: '_init',
    value: function _init(options) {
      var self = this;
      this.connectWebViewJavascriptBridge(function (bridge) {
        // bridge.init(function(message, responseCallback) {
        //     console.log('JS got a message', message)
        //     let data = {
        //         'Javascript Responds': '测试中文!'
        //     }
        //     if (responseCallback) {
        //         console.log('JS responding with', data)
        //         responseCallback(data)
        //     }
        // // })
        // if (options && options.methods && options.methods.length) {
        //   let methods = options.methods
        //   for (let i = 0; i < methods.length; i++) {
        //     self.MethodCall(methods[i])
        //   }
        // }
        if (options && options.methods) {
          self.add(options.methods);
        }
      });
    }
  }, {
    key: 'connectWebViewJavascriptBridge',
    value: function connectWebViewJavascriptBridge(callback) {
      var system = this.platform.isiPhone || this.platform.isiPad ? 'Ios' : 'Android';
      if (system === 'Ios') {
        if (window.WebViewJavascriptBridge) {
          return callback(window.WebViewJavascriptBridge);
        }
        if (window.WVJBCallbacks) {
          console.log(window.WVJBCallbacks);
          return window.WVJBCallbacks.push(callback);
        }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () {
          document.documentElement.removeChild(WVJBIframe);
        }, 0);
      } else {
        if (!isEmpObj(window.WebViewJavascriptBridge)) {
          callback(window.WebViewJavascriptBridge);
        } else {
          document.addEventListener('WebViewJavascriptBridgeReady', function () {
            console.log('webview加载回调');
            callback(window.WebViewJavascriptBridge);
          }, false);
        }
      }
    }
  }, {
    key: 'add',
    value: function add(option) {
      var _this2 = this;

      if (isObject(option) && isArray(option.methods)) {
        option = option.methods;
      }
      if (isObject(option) && !isArray(option)) {
        option = [option];
      }

      if (!window.callbackNameMethodsCache) {
        window.callbackNameMethodsCache = {};
      }

      if (Array.isArray(option)) {
        for (var i = 0; i < option.length; i++) {
          var obj = option[i];
          window.callbackNameMethodsCache[obj.method] = obj.callback;
        }
      }

      console.log('window.callbackNameMethodsCache', window.callbackNameMethodsCache);

      this.connectWebViewJavascriptBridge(function () {
        if (!isArray(option)) return;
        _this2.MethodCall({
          method: 'methodForNative',
          callback: function callback(data) {
            var obj = data && JSON.parse(data) || {};
            var param = obj['param'] && obj['param'].includes('{') ? JSON.parse(obj['param']) : {};
            var target = option.find(function (v) {
              return v.method === obj.intention;
            });
            target && target.callback(param);
          },
          responseCallbackData: {
            type: 0
          }
        });
      });
    }
  }, {
    key: 'MethodCall',
    value: function MethodCall(obj) {
      var ERROR_TITLE = '[Bridge.js] error : ';
      // try {
      if (!obj.method) throw ERROR_TITLE + ' method undefined';
      if (!obj.callback) throw ERROR_TITLE + ' callback undefined';

      console.log('\u54A8\u8BE2\u5E08bridge MethodCall \u65B9\u6CD5', obj);
      console.log('window.WebViewJavascriptBridge', window.WebViewJavascriptBridge);

      window.WebViewJavascriptBridge.registerHandler(obj.method, function (data, responseCallback) {
        // console.log('交互方法执行', data, typeof data, JSON.parse(data))
        obj.callback(data);
        if (responseCallback) {
          responseCallback(obj.responseCallbackData);
        }
      });
      // } catch (err) {
      //   console.error(`${ERROR_TITLE} MethodCall register failed`, err)
      // }
    }
    /**
     * public 调用原生方法 js2native
     * @param  {[string]} callName [方法名称]
     * @param  {[object]} options  [参数]
     */

  }, {
    key: 'call',
    value: function call(callName, options, callback) {
      var _this3 = this;

      var self = this;
      if (this.platform.isMobile) {
        // 如果是新的App，就用新的app api
        // if (window.localStorage.getItem('isNewApp') === '1') {
        var waitReady = callName === 'getAppVervison' ? Promise.resolve() : this.getAppVersionPromise();

        console.log('\u54A8\u8BE2\u5E08bridge call \u65B9\u6CD5', callName, options, callback);
        if (!options) {
          options = {};
        }

        console.log('callName\n        options.callbackName &&\n        !callback &&\n        window.callbackNameMethodsCache[options.callbackName]', callName, options.callbackName, !callback, window.callbackNameMethodsCache && window.callbackNameMethodsCache[options.callbackName]);
        if (options.callbackName && !callback) {
          callback = function callback() {
            if (window.callbackNameMethodsCache && typeof window.callbackNameMethodsCache[options.callbackName] === 'function') {
              var _window$callbackNameM;

              console.log('callNamecallName', callName, window.callbackNameMethodsCache[options.callbackName]);
              (_window$callbackNameM = window.callbackNameMethodsCache)[options.callbackName].apply(_window$callbackNameM, arguments);
            }
          };
          console.log('options.callbackName', options.callbackName);
          console.log('options.callbackName', callback);
        }

        waitReady.then(function () {
          if (_this3.isNewApp) {
            _this3.zxsCall(callName, options, callback);
            return;
          }
          if (isEmpObj(window.WebViewJavascriptBridge)) {
            methodArrays.push({
              callName: callName,
              options: options,
              callback: callback
            });
            if (!waitWebViewJavascriptBridgeTimer) {
              waitWebViewJavascriptBridgeTimer = setInterval(function () {
                if (!isEmpObj(window.WebViewJavascriptBridge)) {
                  // 事件释放
                  methodArrays.forEach(function (_ref) {
                    var callName = _ref.callName,
                        options = _ref.options,
                        callback = _ref.callback;

                    window.WebViewJavascriptBridge.callHandler(callName, options, function (responseData) {
                      callback(responseData);
                    });
                  });
                  clearInterval(waitWebViewJavascriptBridgeTimer);
                  waitWebViewJavascriptBridgeTimer = null;
                }
              }, 500);
            }
          } else {
            return new Promise(function (resolve, reject) {
              try {
                window.WebViewJavascriptBridge.callHandler(callName, options, function (responseData) {
                  callback(responseData);
                });
              } catch (err) {
                document.addEventListener('WebViewJavascriptBridgeReady', function () {
                  window.WebViewJavascriptBridge.callHandler(callName, options, function (responseData) {
                    callback(responseData);
                  });
                }, false);
                // console.error(err)
                // reject(err)
              }
              if (options.callbackName) {
                self.callMethodsResolve = resolve;
              } else {
                resolve();
              }
            });
          }
        });
      }
    }
  }, {
    key: 'zxsCall',
    value: function zxsCall(callName, obj, callback) {
      var self = this;
      if (obj && obj.hasOwnProperty('params')) {
        obj.param = obj.params;
        delete obj.params;
      }
      var options = obj;
      if (this.platform.isMobile) {
        if (isEmpObj(window.WebViewJavascriptBridge)) {
          methodArrays.push({
            callName: callName,
            options: options,
            callback: callback
          });
          if (!waitWebViewJavascriptBridgeTimer) {
            waitWebViewJavascriptBridgeTimer = setInterval(function () {
              if (!isEmpObj(window.WebViewJavascriptBridge)) {
                // 事件释放
                methodArrays.forEach(function (_ref2) {
                  var callName = _ref2.callName,
                      options = _ref2.options,
                      callback = _ref2.callback;

                  window.WebViewJavascriptBridge.callHandler('methodForJs', {
                    intention: callName,
                    param: JSON.stringify(options)
                  }, function (responseData) {
                    callback(anyToJSON(responseData));
                  });
                });
                clearInterval(waitWebViewJavascriptBridgeTimer);
                waitWebViewJavascriptBridgeTimer = null;
              }
            }, 500);
          }
        } else {
          return new Promise(function (resolve, reject) {
            try {
              window.WebViewJavascriptBridge.callHandler('methodForJs', {
                intention: callName,
                param: JSON.stringify(options)
              }, function (responseData) {
                callback(anyToJSON(responseData));
              });
            } catch (err) {
              document.addEventListener('WebViewJavascriptBridgeReady', function () {
                window.WebViewJavascriptBridge.callHandler('methodForJs', {
                  intention: callName,
                  param: JSON.stringify(options)
                }, function (responseData) {
                  callback(anyToJSON(responseData));
                });
              }, false);
              // console.error(err)
              // reject(err)
            }
            if (options.callbackName) {
              self.callMethodsResolve = resolve;
            } else {
              resolve();
            }
          });
        }
      }
    }
  }, {
    key: 'ciKeCall',
    value: function ciKeCall(callName, options, callback) {
      var self = this;
      console.log('callName:', callName);
      console.log('options:', options);
      if (this.platform.isMobile) {
        if (isEmpObj(window.WebViewJavascriptBridge)) {
          methodArrays.push({
            callName: callName,
            options: options,
            callback: callback
          });
          if (!waitWebViewJavascriptBridgeTimer) {
            waitWebViewJavascriptBridgeTimer = setInterval(function () {
              if (!isEmpObj(window.WebViewJavascriptBridge)) {
                // 事件释放
                methodArrays.forEach(function (_ref3) {
                  var callName = _ref3.callName,
                      options = _ref3.options,
                      callback = _ref3.callback;

                  window.WebViewJavascriptBridge.callHandler('methodForJs', {
                    intention: callName,
                    param: JSON.stringify(options)
                  }, function (responseData) {
                    console.log('callback---');
                    callback(responseData);
                  });
                });
                clearInterval(waitWebViewJavascriptBridgeTimer);
                waitWebViewJavascriptBridgeTimer = null;
              }
            }, 500);
          }
        } else {
          return new Promise(function (resolve, reject) {
            try {
              window.WebViewJavascriptBridge.callHandler('methodForJs', {
                intention: callName,
                param: JSON.stringify(options)
              }, function (responseData) {
                console.log('callback---');
                callback(responseData);
              });
            } catch (err) {
              document.addEventListener('WebViewJavascriptBridgeReady', function () {
                window.WebViewJavascriptBridge.callHandler('methodForJs', {
                  intention: callName,
                  param: JSON.stringify(options)
                }, function (responseData) {
                  console.log('callback---');
                  callback(responseData);
                });
              }, false);
              // console.error(err)
              // reject(err)
            }
            if (options.callbackName) {
              self.callMethodsResolve = resolve;
            } else {
              resolve();
            }
          });
        }
      }
    }
  }, {
    key: 'AppHookInit',
    value: function AppHookInit() {
      var _this4 = this;

      console.log('初始化APP事件');
      var codeEventMap = {
        appWebviewShow: 'appWebviewShow',
        appWebviewHide: 'appWebviewHide'
      };
      var eventFactory = function eventFactory(code) {
        var eventName = codeEventMap[code];
        return new Event(eventName);
      };

      window.yxlAppCustomEvent = {};
      for (var key in codeEventMap) {
        window.yxlAppCustomEvent[key] = eventFactory(key);
        this.connectWebViewJavascriptBridge(function () {
          _this4.MethodCall({
            method: 'methodForNative',
            callback: function callback(data) {
              var obj = data && JSON.parse(data) || {};
              window.dispatchEvent(window.yxlAppCustomEvent[obj.intention]);
            },
            responseCallbackData: {}
          });
        });
      }
    }
  }]);

  return Bridge;
}();

/* harmony default export */ var zxsBridge = (zxsBridge_Bridge);

/*
 var myBridge = new Bridge({
     methods: [{
         method: "test",
         callback: function(param) {
           alert("hello world");
         }
     }]
 });

 myBridge.call("setTitle",{title:"我是标题"});
 */
// EXTERNAL MODULE: ./src/frontend-lib/tools/objOperation.js
var objOperation = __webpack_require__("ZS9F");

// CONCATENATED MODULE: ./src/frontend-lib/lib/stat/zhugeIO_keys.js
// 配置应用的AppKey
// 壹心理M站 key：be2579193b754fd2900f660a0093fa62
// 壹心理APP key：f6f19cec54894af8990714a597fc09f4
// 口袋心理APP：c6ef6a45ade340999081be514623f29e
// 壹心理学院（kc）：38193a7a6e34415daeef0cb2b0002e54
// 活动汇总项目（kc）：e989fdd0fb8b4af384ec7c87c2d9cfb4
// 咨询师之家: ad1f752ccbb84fc6bbb6a487692e4f8c
// 盘古系统: 6a435dc3efc14485a21a181eba7bf6fe

/* harmony default export */ var zhugeIO_keys = ({
  msite: 'be2579193b754fd2900f660a0093fa62',
  yxlApp: 'f6f19cec54894af8990714a597fc09f4',
  cpApp: 'c6ef6a45ade340999081be514623f29e',
  kc: '38193a7a6e34415daeef0cb2b0002e54',
  yixinliPC: '18f5038ab49c4ae4918641ae36d67496',
  promotion: 'e989fdd0fb8b4af384ec7c87c2d9cfb4',
  homeOfConsultants: 'ad1f752ccbb84fc6bbb6a487692e4f8c',
  pg: '6a435dc3efc14485a21a181eba7bf6fe',
  cp: '954fc7ea2885479cae96792800783191'
});
// CONCATENATED MODULE: ./src/frontend-lib/lib/stat/statFiled.js
function listToMap(list) {
  var obj = {};
  list.forEach(function (item) {
    obj[item.id] = item.name;
  });
  return obj;
}

var businessMap = {
  公共: 1,
  专业: 2,
  精品课: 3,
  测评: 4,
  咨询: 5,
  倾诉: 6,
  鲸选会员: 7,
  读书会: 8,
  心理FM: 9,
  平台: 10,
  此刻: 11,
  盘古: 12,
  咨询师之家: 13,
  文字咨询: 14,
  文章: 15,
  心探教练: 16,
  故事集: 17
};
var businessList = Object.keys(businessMap);

var eventTypeList = [{ id: 1, name: '页面访问' }, { id: 2, name: '交互行为' }, { id: 3, name: '社交行为' }];
var eventTypeMap = listToMap(eventTypeList);

var eventAttributeList = ['页面', '对象'];
var eventAttributeMap = {
  页面: 1,
  对象: 2
};


// CONCATENATED MODULE: ./src/frontend-lib/lib/stat/Stat.js
/* unused harmony export stat */
var Stat__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Stat__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Stat__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * stat.js
 * 统计、埋点
 */

/*
ext:
 stat.init({bridge: new Bridge()});
 stat.send({name:"事件名称",properties{key:value}});
 */



// import { getRunningEnv, getPlatform } from '../../tools/getPlatform'



var getRunningEnv = getPlatform_default.a.getRunningEnv,
    Stat_getPlatform = getPlatform_default.a.getPlatform;



var Stat_stat = function () {
  function stat() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        platform = _ref.platform,
        _ref$globalParams = _ref.globalParams,
        globalParams = _ref$globalParams === undefined ? {} : _ref$globalParams,
        interceptor = _ref.interceptor,
        _ref$customTrackConfi = _ref.customTrackConfig,
        customTrackConfig = _ref$customTrackConfi === undefined ? {} : _ref$customTrackConfi;

    Stat__classCallCheck(this, stat);

    console.log('初始化 Stat 对象：', platform, globalParams);
    this.platform = Stat_getPlatform();
    this.curPlatform = platform || '';
    this.runningEnv = getRunningEnv();
    if (this.platform.isYixinliApp || this.platform.isCeShiApp) {
      this.bridge = new lib_Bridge["a" /* default */]();
    }
    if (this.platform.isZiXunShiApp) {
      this.zxsBridge = new zxsBridge();
    }
    this.globalParams = globalParams;
    this.interceptor = interceptor;
    this.zhugeSDK(platform, customTrackConfig);
  }

  Stat__createClass(stat, [{
    key: 'init',
    value: function init() {
      // 兼容旧代码的init方法写法
      return this;
    }
  }, {
    key: 'setGlobalParams',
    value: function setGlobalParams() {
      var globalParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.globalParams = Object.assign(this.globalParams, globalParams);
    }
  }, {
    key: 'zhugeSDK',
    value: function zhugeSDK(platform, sdkConfig) {
      if (window.zhuge) return;
      window.zhuge = window.zhuge || [];
      window.zhuge.methods = '_init debug identify track getDid getSid getKey setSuperProperty setUserProperties setWxProperties setPlatform'.split(' ');
      // window.zhuge.methods = '_init debug identify track trackLink trackForm page'.split(' ');
      window.zhuge.factory = function (b) {
        return function () {
          var a = Array.prototype.slice.call(arguments);
          a.unshift(b);
          window.zhuge.push(a);
          return window.zhuge;
        };
      };
      for (var i = 0; i < window.zhuge.methods.length; i++) {
        var key = window.zhuge.methods[i];
        window.zhuge[key] = window.zhuge.factory(key);
      }
      window.zhuge.load = function (b, x) {
        window.zhuge.identify = window.zhuge.track = function (ename, props, callback) {
          if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
            callback();
          } else if (Object.prototype.toString.call(props) === '[object Function]') {
            props();
          }
        };
      };

      // 配置应用的AppKey
      // 根据 WEBPACK_DEV 开启是否debug，不用每次都进行开关
      // 正式环境且是生产模式，不debug
      var useKey = void 0;
      var localPlatform = void 0;
      if (platform && zhugeIO_keys[platform]) {
        useKey = zhugeIO_keys[platform];
        localPlatform = platform;
      } else {
        if (this.platform.isYixinliApp) {
          useKey = zhugeIO_keys.yxlApp;
          localPlatform = 'yxlApp';
        } else if (this.platform.isCeShiApp) {
          useKey = zhugeIO_keys.cpApp;
          localPlatform = 'cpApp';
        } else if (this.platform.isPc) {
          useKey = zhugeIO_keys.yixinliPC;
          localPlatform = 'yixinliPC';
        } else if (this.platform.isZiXunShiApp) {
          useKey = zhugeIO_keys.homeOfConsultants;
          localPlatform = 'homeOfConsultants';
        } else {
          useKey = zhugeIO_keys.msite;
          localPlatform = 'msite';
        }
      }

      // 取出SDK支持的配置参数
      var filtedConfig = Object(objOperation["b" /* pick */])(sdkConfig, ['superProperty', 'adTrack', 'zgsee', 'autoTrack', 'singlePage']);
      console.log('当前环境：', this.runningEnv.env, '是否开启Debug：', this.runningEnv.isDev, '\u4F7F\u7528' + localPlatform + '\u7684KEY', '配置项：', filtedConfig);
      this.curPlatform = localPlatform;
      var finalConfig = Object.assign({}, { debug: this.runningEnv.isDev }, filtedConfig);

      /*如果是全埋点，添加任意元素可点击事件*/
      console.log('是否开启全埋点', sdkConfig && sdkConfig.autoTrack);
      if (sdkConfig && sdkConfig.autoTrack) {
        finalConfig = _extends({}, finalConfig, {
          isClickAble: function isClickAble() {
            //targetElement为点击的dom元素
            return true;
          }
        });
      }

      window.zhuge.load(useKey, finalConfig);

      // if (window.loginUserId) {
      //     window.zhuge.identify(String(window.loginUserId));
      //     console.log(window.loginUserId);
      // }
    }
  }, {
    key: 'send',
    value: function send(data) {
      if (typeof data === 'string') {
        data = {
          name: data
        };
      }
      this.statSend(data);
    }
    /**
     * 标记用户的方法，在后台可以看到具体的属性
     * @param {*} id 唯一标识
     * @param {*} properties 补充说明属性
     */

  }, {
    key: 'identify',
    value: function identify(id) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      try {
        window.zhuge.identify(String(id), properties);
      } catch (error) {
        console.error(error);
      }
    }
  }, {
    key: 'statSend',
    value: function statSend(data) {
      var _this = this;

      var sendFlow = Promise.resolve();
      if (this.interceptor && typeof this.interceptor === 'function') {
        sendFlow.then(function () {
          return _this.interceptor();
        });
      }
      sendFlow.then(function () {
        // 由于诸葛IO SDK升级，能够设置全局属性，但是为了兼容客户端和维持web的灵活性，还是使用自己维护的globalParams
        var resultParams = {};
        if (Stat__typeof(_this.globalParams) === 'object' && Object.keys(_this.globalParams).length > 0) {
          // TODO: 校验globalParams，key的类型，如果是多层Object，将Object抽出来
          // for (let key in  this.globalParams) {
          //     resultParams[key] = typeof(this.globalParams[key] !== ) ? this.globalParams[key] : undefined;
          // }
          data.properties = Object.assign({}, _this.globalParams, data.properties);
        }
        data.properties = Object.assign({}, resultParams, data.properties);

        if (_this.curPlatform === 'yxlApp' && (_this.platform.isYixinliApp || _this.platform.isCeShiApp)) {
          // 是壹心理App但是指定使用的key不是yxlApp的时候，不要给客户端代理埋点
          // app代理埋点
          _this.bridge.call('stat', data);
        } else if (_this.curPlatform === 'homeOfConsultants' && _this.platform.isZiXunShiApp) {
          // app代理埋点
          _this.zxsBridge.call('statForBridge', {
            eventName: data.name,
            param: JSON.stringify(data.properties)
          });
        } else {
          // web埋点
          window.zhuge.track(data.name, data.properties);
        }
      }).catch(function (e) {
        console.log(e);
      });
    }

    /**
     * 页面访问-埋点公共方法
     * @param {Object} params
     * @param {String} params.businessType 事件所属业务
     * @param {String} [params.category] 产品
     * @param {String} params.eventValue 属性值
     * @param {Object} params.extraAttr 额外属性
     */

  }, {
    key: 'visit',
    value: function visit(params) {
      params.eventType = 1;
      params.eventAttribute = '页面';
      this.handleStat(params);
    }

    /**
     * 交互行为-埋点公共方法
     * @param {Object} params
     * @param {String} params.businessType 事件所属业务
     * @param {String} [params.category] 产品
     * @param {String} params.eventValue 属性值
     * @param {String} params.pageTitle 页面title
     * @param {Object} params.extraAttr 额外属性
     */

  }, {
    key: 'interact',
    value: function interact(params) {
      params.eventType = 2;
      params.eventAttribute = '对象';
      this.handleStat(params);
    }

    /**
     * 社交行为-埋点公共方法
     * @param {Object} params
     * @param {String} params.businessType 事件所属业务
     * @param {String} [params.category] 产品
     * @param {String} params.eventAttribute 主要事件属性：页面，对象
     * @param {String} params.eventValue 属性值
     * @param {String} [params.pageTitle] 页面title
     * @param {Object} params.extraAttr 额外属性
     */

  }, {
    key: 'social',
    value: function social(params) {
      params.eventType = 3;
      this.handleStat(params);
    }

    // 不同类型埋点统一处理

  }, {
    key: 'handleStat',
    value: function handleStat(params) {
      var _this2 = this;

      var businessType = params.businessType,
          category = params.category,
          eventType = params.eventType,
          eventAttribute = params.eventAttribute,
          eventValue = params.eventValue,
          pageTitle = params.pageTitle,
          _params$extraAttr = params.extraAttr,
          extraAttr = _params$extraAttr === undefined ? {} : _params$extraAttr;

      this.checkStatParams(params).then(function () {
        var name = businessType + '-' + (category ? category + '-' : '') + eventTypeMap[eventType];
        var properties = _extends(_defineProperty({}, eventAttribute, eventValue), extraAttr);
        if (eventAttribute === '对象' && pageTitle) {
          properties['页面'] = pageTitle;
        }
        _this2.statSend({
          name: name,
          properties: properties
        });
      }).catch(function (e) {
        console.error('请检查传入参数是否有误，详情查看http://112.124.122.87:8090/pages/viewpage.action?pageId=6554041');
      });
    }

    // 校验埋点参数与数据回传

  }, {
    key: 'checkStatParams',
    value: function checkStatParams(params) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var businessType = params.businessType,
            category = params.category,
            eventType = params.eventType,
            eventAttribute = params.eventAttribute,
            pageTitle = params.pageTitle,
            eventValue = params.eventValue;


        if (!businessType) {
          console.error('请传入事件所属业务', businessList);
          reject();
        }

        // if (window && window.monitor && !businessList.includes(businessType)) {
        //   console.error('事件所属业务错误，请传入对应业务名称')
        //   window.monitor.stat({
        //     logType: 'info',
        //     title: '埋点所属业务没有配置businessList',
        //     message: JSON.stringify({
        //       businessType,
        //       category,
        //       pageTitle,
        //       eventValue
        //     }),
        //     remark: businessType
        //   })
        // }

        if (!eventAttributeList.includes(eventAttribute)) {
          console.error('主要事件属性错误，请传入对应事件属性名称');
          reject();
        }
        if (!eventValue) {
          console.error('请传入属性值');
          reject();
        }
        if (eventAttribute === '对象' && !pageTitle) {
          console.error('主要事件属性为对象时，需传入pageTitle');
          reject();
        }

        // debug环境下，进行埋点数据回传
        if (_this3.runningEnv.isDev || window && location.hostname === 'localhost') {
          var param = {
            businessType: businessMap[businessType],
            eventType: eventType,
            eventAttribute: eventAttributeMap[eventAttribute],
            eventValue: eventValue
          };
          if (category) {
            param['category'] = category;
          }
          // this.returnStat(
          //   (window ? window.location.protocol : '') +
          //     '//lx.xinli001.com/user/event/sureSuccess',
          //   param
          // ).then(res => {
          //   if (+res.code !== 0) {
          //     console.error(res.msg)
          //   }
          // })
        }
        resolve();
      });
    }

    // 埋点事件回传

  }, {
    key: 'returnStat',
    value: function returnStat(url, params) {
      return new Promise(function (resolve) {
        // FormData 对象
        var form = new FormData();
        Object.keys(params).forEach(function (key) {
          form.append(key, params[key]);
        });
        var xhr = new XMLHttpRequest();
        xhr.open('post', url, true);
        xhr.onload = function () {
          var result = JSON.parse(xhr.responseText);
          resolve(result);
        };
        xhr.send(form);
      });
    }
  }]);

  return stat;
}();

// window.yxl = window.yxl || {};
// window.yxl.stat = stat;
// return stat;

/* harmony default export */ var Stat = __webpack_exports__["a"] = (Stat_stat);


/**
 * ext:
 * stat.init({bridge: new Bridge()});
 * stat.send({name:"事件名称",properties{key:value}});
 */

/***/ }),

/***/ "EuXz":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("lDLk").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__("bUqO") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "EvFb":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");
var $parseFloat = __webpack_require__("8t38");
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),

/***/ "F1ui":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("Ds5P");
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),

/***/ "F3sI":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");
var toIObject = __webpack_require__("PHqh");
var toLength = __webpack_require__("BbyF");

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),

/***/ "FEuY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pop_btn_back.3f73931.png";

/***/ }),

/***/ "FKfb":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("Ds5P");
var $entries = __webpack_require__("lKE8")(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),

/***/ "FZ+f":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "FaZr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("pd+2");
var anObject = __webpack_require__("DIVP");
var $flags = __webpack_require__("0pGU");
var DESCRIPTORS = __webpack_require__("bUqO");
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__("R3AP")(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__("zgIt")(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),

/***/ "Fe62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_yxlCopyright_vue_vue_type_style_index_0_id_1476679d_lang_scss_scoped_true___ = __webpack_require__("lSFJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_yxlCopyright_vue_vue_type_style_index_0_id_1476679d_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_yxlCopyright_vue_vue_type_style_index_0_id_1476679d_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_yxlCopyright_vue_vue_type_style_index_0_id_1476679d_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "FeBl":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "FeMY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/customer.6135722.png";

/***/ }),

/***/ "FkIZ":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("XSOZ");
var toObject = __webpack_require__("FryR");
var IObject = __webpack_require__("Q6Nf");
var toLength = __webpack_require__("BbyF");

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),

/***/ "Fnm7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),

/***/ "FryR":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("/whu");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "FtD3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("t8qj");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "G3K7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("wI4N");
var transformData = __webpack_require__("uRCW");
var isCancel = __webpack_require__("6SyV");
var defaults = __webpack_require__("8cTw");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "G5/o":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__("uqUo")('getOwnPropertyNames', function () {
  return __webpack_require__("Rrel").f;
});


/***/ }),

/***/ "GDq+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRequestSign;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_md5__ = __webpack_require__("rdRf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objOperation__ = __webpack_require__("ZS9F");


/*
 * 此方法用于平台请求一些方法需要进行签名+验签，
 * params : {
 *  timestamp,
 *  appCode,
 *  _platform, require
 *  _version, require
 *  name,
 *  key
 * }
 */

// todo 这方法名好像不够通用
function getRequestSign() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var apiSecret = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  // IOS跟Android的apiSecret不一样，如果_platform 跟 IOS跟Android的apiSecret不一样对不上会出现签名错误
  var apiSecretMap = {
    android: '910676770dfc5c34d32e250ea3e91049',
    ios: '6767790dfc5c34d32e250ea3e9104910',
    m: '49da2fb42b5655d69f9449ca2fe30e40',
    pc: '9a9e2bc951b8b9ece1581cc2e78e240d'
  };
  var apiSecret2 = apiSecret ? apiSecret : apiSecretMap[params._platform || 'ios'];
  // 默认值做在里面，让外部只关心name，广告位名称就好了
  var timestamp = new Date().getTime();
  var defaultParams = {
    timestamp: timestamp
  };
  params = Object.assign(defaultParams, params);
  // let arr = []
  // let timestamp = params["timestamp"];
  if (params['timestamp']) {
    params = Object(__WEBPACK_IMPORTED_MODULE_1__objOperation__["a" /* omit */])(params, 'timestamp');
  }

  //字典按key的字母顺序
  var keys = Object.keys(params).sort();
  var paramsStr = '';

  //所有参数名和参数值按顺序拼接一起
  keys.map(function (key) {
    paramsStr = '' + paramsStr + key + '=' + params[key] + ',';
  });

  //拼接apiSecret
  paramsStr = '' + paramsStr + timestamp + apiSecret2;
  //md5加密
  var sign = __WEBPACK_IMPORTED_MODULE_0_md5___default()(paramsStr); // 小写
  params.timestamp = timestamp;
  return { sign: sign, params: params };
}

/***/ }),

/***/ "GHBc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "GQaK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * better-normal-scroll v1.15.2
 * (c) 2016-2019 ustbhuangyi
 * Released under the MIT License.
 */
// As of V8 6.6, depending on the size of the array, this is anywhere
// between 1.5-10x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (; index + 1 < list.length; index++) {
    list[index] = list[index + 1];
  }

  list.pop();
}

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();













var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

function eventMixin(BScroll) {
  BScroll.prototype.on = function (type, fn) {
    var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;

    if (!this._events[type]) {
      this._events[type] = [];
    }

    this._events[type].push([fn, context]);
  };

  BScroll.prototype.once = function (type, fn) {
    var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;

    function magic() {
      this.off(type, magic);

      fn.apply(context, arguments);
    }
    // To expose the corresponding function method in order to execute the off method
    magic.fn = fn;

    this.on(type, magic);
  };

  BScroll.prototype.off = function (type, fn) {
    var _events = this._events[type];
    if (!_events) {
      return;
    }

    var count = _events.length;
    while (count--) {
      if (_events[count][0] === fn || _events[count][0] && _events[count][0].fn === fn) {
        spliceOne(_events, count);
      }
    }
  };

  BScroll.prototype.trigger = function (type) {
    var events = this._events[type];
    if (!events) {
      return;
    }

    var len = events.length;
    var eventsCopy = [].concat(toConsumableArray(events));
    for (var i = 0; i < len; i++) {
      var event = eventsCopy[i];

      var _event = slicedToArray(event, 2),
          fn = _event[0],
          context = _event[1];

      if (fn) {
        fn.apply(context, [].slice.call(arguments, 1));
      }
    }
  };
}

// ssr support
var inBrowser = typeof window !== 'undefined';
var ua = inBrowser && navigator.userAgent.toLowerCase();
var isWeChatDevTools = ua && /wechatdevtools/.test(ua);
var isAndroid = ua && ua.indexOf('android') > 0;

function getNow() {
  return window.performance && window.performance.now ? window.performance.now() + window.performance.timing.navigationStart : +new Date();
}

function extend(target) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  for (var i = 0; i < rest.length; i++) {
    var source = rest[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}

function isUndef(v) {
  return v === undefined || v === null;
}

function getDistance(x, y) {
  return Math.sqrt(x * x + y * y);
}

var elementStyle = inBrowser && document.createElement('div').style;

var vendor = function () {
  if (!inBrowser) {
    return false;
  }
  // first pick up standard to fix #743
  var transformNames = {
    standard: 'transform',
    webkit: 'webkitTransform',
    Moz: 'MozTransform',
    O: 'OTransform',
    ms: 'msTransform'
  };

  for (var key in transformNames) {
    if (elementStyle[transformNames[key]] !== undefined) {
      return key;
    }
  }

  return false;
}();

function prefixStyle(style) {
  if (vendor === false) {
    return false;
  }

  if (vendor === 'standard') {
    if (style === 'transitionEnd') {
      return 'transitionend';
    }
    return style;
  }

  return vendor + style.charAt(0).toUpperCase() + style.substr(1);
}

function addEvent(el, type, fn, capture) {
  el.addEventListener(type, fn, { passive: false, capture: !!capture });
}

function removeEvent(el, type, fn, capture) {
  el.removeEventListener(type, fn, { passive: false, capture: !!capture });
}

function offset(el) {
  var left = 0;
  var top = 0;

  while (el) {
    left -= el.offsetLeft;
    top -= el.offsetTop;
    el = el.offsetParent;
  }

  return {
    left: left,
    top: top
  };
}

function offsetToBody(el) {
  var rect = el.getBoundingClientRect();

  return {
    left: -(rect.left + window.pageXOffset),
    top: -(rect.top + window.pageYOffset)
  };
}

var cssVendor = vendor && vendor !== 'standard' ? '-' + vendor.toLowerCase() + '-' : '';

var transform = prefixStyle('transform');
var transition = prefixStyle('transition');

var hasPerspective = inBrowser && prefixStyle('perspective') in elementStyle;
// fix issue #361
var hasTouch = inBrowser && ('ontouchstart' in window || isWeChatDevTools);
var hasTransform = transform !== false;
var hasTransition = inBrowser && transition in elementStyle;

var style = {
  transform: transform,
  transition: transition,
  transitionTimingFunction: prefixStyle('transitionTimingFunction'),
  transitionDuration: prefixStyle('transitionDuration'),
  transitionDelay: prefixStyle('transitionDelay'),
  transformOrigin: prefixStyle('transformOrigin'),
  transitionEnd: prefixStyle('transitionEnd')
};

var TOUCH_EVENT = 1;
var MOUSE_EVENT = 2;

var eventType = {
  touchstart: TOUCH_EVENT,
  touchmove: TOUCH_EVENT,
  touchend: TOUCH_EVENT,

  mousedown: MOUSE_EVENT,
  mousemove: MOUSE_EVENT,
  mouseup: MOUSE_EVENT
};

function getRect(el) {
  if (el instanceof window.SVGElement) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  } else {
    return {
      top: el.offsetTop,
      left: el.offsetLeft,
      width: el.offsetWidth,
      height: el.offsetHeight
    };
  }
}

function preventDefaultException(el, exceptions) {
  for (var i in exceptions) {
    if (exceptions[i].test(el[i])) {
      return true;
    }
  }
  return false;
}

function tap(e, eventName) {
  var ev = document.createEvent('Event');
  ev.initEvent(eventName, true, true);
  ev.pageX = e.pageX;
  ev.pageY = e.pageY;
  e.target.dispatchEvent(ev);
}

function click(e) {
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'click';

  var eventSource = void 0;
  if (e.type === 'mouseup' || e.type === 'mousecancel') {
    eventSource = e;
  } else if (e.type === 'touchend' || e.type === 'touchcancel') {
    eventSource = e.changedTouches[0];
  }
  var posSrc = {};
  if (eventSource) {
    posSrc.screenX = eventSource.screenX || 0;
    posSrc.screenY = eventSource.screenY || 0;
    posSrc.clientX = eventSource.clientX || 0;
    posSrc.clientY = eventSource.clientY || 0;
  }
  var ev = void 0;
  var bubbles = true;
  var cancelable = true;
  if (typeof MouseEvent !== 'undefined') {
    try {
      ev = new MouseEvent(event, extend({
        bubbles: bubbles,
        cancelable: cancelable
      }, posSrc));
    } catch (e) {
      createEvent();
    }
  } else {
    createEvent();
  }

  function createEvent() {
    ev = document.createEvent('Event');
    ev.initEvent(event, bubbles, cancelable);
    extend(ev, posSrc);
  }

  // forwardedTouchEvent set to true in case of the conflict with fastclick
  ev.forwardedTouchEvent = true;
  ev._constructed = true;
  e.target.dispatchEvent(ev);
}

function dblclick(e) {
  click(e, 'dblclick');
}

function prepend(el, target) {
  if (target.firstChild) {
    before(el, target.firstChild);
  } else {
    target.appendChild(el);
  }
}

function before(el, target) {
  target.parentNode.insertBefore(el, target);
}

function removeChild(el, child) {
  el.removeChild(child);
}

var DEFAULT_OPTIONS = {
  startX: 0,
  startY: 0,
  scrollX: false,
  scrollY: true,
  freeScroll: false,
  directionLockThreshold: 5,
  eventPassthrough: '',
  click: false,
  tap: false,
  /**
   * support any side
   * bounce: {
   *   top: true,
   *   bottom: true,
   *   left: true,
   *   right: true
   * }
   */
  bounce: true,
  bounceTime: 800,
  momentum: true,
  momentumLimitTime: 300,
  momentumLimitDistance: 15,
  swipeTime: 2500,
  swipeBounceTime: 500,
  deceleration: 0.0015,
  flickLimitTime: 200,
  flickLimitDistance: 100,
  resizePolling: 60,
  probeType: 0,
  preventDefault: true,
  preventDefaultException: {
    tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|AUDIO)$/
  },
  HWCompositing: true,
  useTransition: true,
  useTransform: true,
  bindToWrapper: false,
  disableMouse: hasTouch,
  disableTouch: !hasTouch,
  observeDOM: true,
  autoBlur: true,
  /**
   * for picker
   * wheel: {
   *   selectedIndex: 0,
   *   rotate: 25,
   *   adjustTime: 400
   *   wheelWrapperClass: 'wheel-scroll',
   *   wheelItemClass: 'wheel-item'
   * }
   */
  wheel: false,
  /**
   * for slide
   * snap: {
   *   loop: false,
   *   el: domEl,
   *   threshold: 0.1,
   *   stepX: 100,
   *   stepY: 100,
   *   speed: 400,
   *   easing: {
   *     style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
   *     fn: function (t) {
   *       return t * (2 - t)
   *     }
   *   }
   *   listenFlick: true
   * }
   */
  snap: false,
  /**
   * for scrollbar
   * scrollbar: {
   *   fade: true,
   *   interactive: false
   * }
   */
  scrollbar: false,
  /**
   * for pull down and refresh
   * pullDownRefresh: {
   *   threshold: 50,
   *   stop: 20
   * }
   */
  pullDownRefresh: false,
  /**
   * for pull up and load
   * pullUpLoad: {
   *   threshold: 50
   * }
   */
  pullUpLoad: false,
  /**
   * for mouse wheel
   * mouseWheel: {
   *   speed: 20,
   *   invert: false,
   *   easeTime: 300
   * }
   */
  mouseWheel: false,
  stopPropagation: false,
  /**
   * for zoom
   * zoom: {
   *   start: 1,
   *   min: 1,
   *   max: 4
   * }
   */
  zoom: false,
  /**
   * for infinity
   * infinity: {
   *   render(item, div) {
   *   },
   *   createTombstone() {
   *   },
   *   fetch(count) {
   *   }
   * }
   */
  infinity: false,
  /**
   * for double click
   * dblclick: {
   *   delay: 300
   * }
   */
  dblclick: false
};

function initMixin(BScroll) {
  BScroll.prototype._init = function (options) {
    this._handleOptions(options);

    // init private custom events
    this._events = {};

    this.x = 0;
    this.y = 0;
    this.directionX = 0;
    this.directionY = 0;

    this.setScale(1);

    this._addDOMEvents();

    this._initExtFeatures();

    this._watchTransition();

    if (this.options.observeDOM) {
      this._initDOMObserver();
    }

    if (this.options.autoBlur) {
      this._handleAutoBlur();
    }

    this.refresh();

    if (!this.options.snap) {
      this.scrollTo(this.options.startX, this.options.startY);
    }

    this.enable();
  };

  BScroll.prototype.setScale = function (scale) {
    this.lastScale = isUndef(this.scale) ? scale : this.scale;
    this.scale = scale;
  };

  BScroll.prototype._handleOptions = function (options) {
    this.options = extend({}, DEFAULT_OPTIONS, options);

    this.translateZ = this.options.HWCompositing && hasPerspective ? ' translateZ(0)' : '';

    this.options.useTransition = this.options.useTransition && hasTransition;
    this.options.useTransform = this.options.useTransform && hasTransform;

    this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

    // If you want eventPassthrough I have to lock one of the axes
    this.options.scrollX = this.options.eventPassthrough === 'horizontal' ? false : this.options.scrollX;
    this.options.scrollY = this.options.eventPassthrough === 'vertical' ? false : this.options.scrollY;

    // With eventPassthrough we also need lockDirection mechanism
    this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
    this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

    if (this.options.tap === true) {
      this.options.tap = 'tap';
    }
  };

  BScroll.prototype._addDOMEvents = function () {
    var eventOperation = addEvent;
    this._handleDOMEvents(eventOperation);
  };

  BScroll.prototype._removeDOMEvents = function () {
    var eventOperation = removeEvent;
    this._handleDOMEvents(eventOperation);
  };

  BScroll.prototype._handleDOMEvents = function (eventOperation) {
    var target = this.options.bindToWrapper ? this.wrapper : window;
    eventOperation(window, 'orientationchange', this);
    eventOperation(window, 'resize', this);

    if (this.options.click) {
      eventOperation(this.wrapper, 'click', this, true);
    }

    if (!this.options.disableMouse) {
      eventOperation(this.wrapper, 'mousedown', this);
      eventOperation(target, 'mousemove', this);
      eventOperation(target, 'mousecancel', this);
      eventOperation(target, 'mouseup', this);
    }

    if (hasTouch && !this.options.disableTouch) {
      eventOperation(this.wrapper, 'touchstart', this);
      eventOperation(target, 'touchmove', this);
      eventOperation(target, 'touchcancel', this);
      eventOperation(target, 'touchend', this);
    }

    eventOperation(this.scroller, style.transitionEnd, this);
  };

  BScroll.prototype._initExtFeatures = function () {
    if (this.options.snap) {
      this._initSnap();
    }
    if (this.options.scrollbar) {
      this._initScrollbar();
    }
    if (this.options.pullUpLoad) {
      this._initPullUp();
    }
    if (this.options.pullDownRefresh) {
      this._initPullDown();
    }
    if (this.options.wheel) {
      this._initWheel();
    }
    if (this.options.mouseWheel) {
      this._initMouseWheel();
    }
    if (this.options.zoom) {
      this._initZoom();
    }
    if (this.options.infinity) {
      this._initInfinite();
    }
  };

  BScroll.prototype._watchTransition = function () {
    if (typeof Object.defineProperty !== 'function') {
      return;
    }
    var me = this;
    var isInTransition = false;
    var key = this.options.useTransition ? 'isInTransition' : 'isAnimating';
    Object.defineProperty(this, key, {
      get: function get() {
        return isInTransition;
      },
      set: function set(newVal) {
        isInTransition = newVal;
        // fix issue #359
        var el = me.scroller.children.length ? me.scroller.children : [me.scroller];
        var pointerEvents = isInTransition && !me.pulling ? 'none' : 'auto';
        for (var i = 0; i < el.length; i++) {
          el[i].style.pointerEvents = pointerEvents;
        }
      }
    });
  };

  BScroll.prototype._handleAutoBlur = function () {
    this.on('scrollStart', function () {
      var activeElement = document.activeElement;
      if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
        activeElement.blur();
      }
    });
  };

  BScroll.prototype._initDOMObserver = function () {
    var _this = this;

    if (typeof MutationObserver !== 'undefined') {
      var timer = void 0;
      var observer = new MutationObserver(function (mutations) {
        // don't do any refresh during the transition, or outside of the boundaries
        if (_this._shouldNotRefresh()) {
          return;
        }
        var immediateRefresh = false;
        var deferredRefresh = false;
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          if (mutation.type !== 'attributes') {
            immediateRefresh = true;
            break;
          } else {
            if (mutation.target !== _this.scroller) {
              deferredRefresh = true;
              break;
            }
          }
        }
        if (immediateRefresh) {
          _this.refresh();
        } else if (deferredRefresh) {
          // attributes changes too often
          clearTimeout(timer);
          timer = setTimeout(function () {
            if (!_this._shouldNotRefresh()) {
              _this.refresh();
            }
          }, 60);
        }
      });
      var config = {
        attributes: true,
        childList: true,
        subtree: true
      };
      observer.observe(this.scroller, config);

      this.on('destroy', function () {
        observer.disconnect();
      });
    } else {
      this._checkDOMUpdate();
    }
  };

  BScroll.prototype._shouldNotRefresh = function () {
    var outsideBoundaries = this.x > this.minScrollX || this.x < this.maxScrollX || this.y > this.minScrollY || this.y < this.maxScrollY;

    return this.isInTransition || this.stopFromTransition || outsideBoundaries;
  };

  BScroll.prototype._checkDOMUpdate = function () {
    var scrollerRect = getRect(this.scroller);
    var oldWidth = scrollerRect.width;
    var oldHeight = scrollerRect.height;

    function check() {
      if (this.destroyed) {
        return;
      }
      scrollerRect = getRect(this.scroller);
      var newWidth = scrollerRect.width;
      var newHeight = scrollerRect.height;

      if (oldWidth !== newWidth || oldHeight !== newHeight) {
        this.refresh();
      }
      oldWidth = newWidth;
      oldHeight = newHeight;

      next.call(this);
    }

    function next() {
      var _this2 = this;

      setTimeout(function () {
        check.call(_this2);
      }, 1000);
    }

    next.call(this);
  };

  BScroll.prototype.handleEvent = function (e) {
    switch (e.type) {
      case 'touchstart':
      case 'mousedown':
        this._start(e);
        if (this.options.zoom && e.touches && e.touches.length > 1) {
          this._zoomStart(e);
        }
        break;
      case 'touchmove':
      case 'mousemove':
        if (this.options.zoom && e.touches && e.touches.length > 1) {
          this._zoom(e);
        } else {
          this._move(e);
        }
        break;
      case 'touchend':
      case 'mouseup':
      case 'touchcancel':
      case 'mousecancel':
        if (this.scaled) {
          this._zoomEnd(e);
        } else {
          this._end(e);
        }
        break;
      case 'orientationchange':
      case 'resize':
        this._resize();
        break;
      case 'transitionend':
      case 'webkitTransitionEnd':
      case 'oTransitionEnd':
      case 'MSTransitionEnd':
        this._transitionEnd(e);
        break;
      case 'click':
        if (this.enabled && !e._constructed) {
          if (!preventDefaultException(e.target, this.options.preventDefaultException)) {
            e.preventDefault();
            e.stopPropagation();
          }
        }
        break;
      case 'wheel':
      case 'DOMMouseScroll':
      case 'mousewheel':
        this._onMouseWheel(e);
        break;
    }
  };

  BScroll.prototype.refresh = function () {
    var isWrapperStatic = window.getComputedStyle(this.wrapper, null).position === 'static';
    var wrapperRect = getRect(this.wrapper);
    this.wrapperWidth = wrapperRect.width;
    this.wrapperHeight = wrapperRect.height;

    var scrollerRect = getRect(this.scroller);
    this.scrollerWidth = Math.round(scrollerRect.width * this.scale);
    this.scrollerHeight = Math.round(scrollerRect.height * this.scale);

    this.relativeX = scrollerRect.left;
    this.relativeY = scrollerRect.top;

    if (isWrapperStatic) {
      this.relativeX -= wrapperRect.left;
      this.relativeY -= wrapperRect.top;
    }

    this.minScrollX = 0;
    this.minScrollY = 0;

    var wheel = this.options.wheel;
    if (wheel) {
      this.items = this.scroller.children;
      // check whether there are all disable items or not when refresh
      this._checkWheelAllDisabled();
      this.options.itemHeight = this.itemHeight = this.items.length ? this.scrollerHeight / this.items.length : 0;
      if (this.selectedIndex === undefined) {
        this.selectedIndex = wheel.selectedIndex || 0;
      }
      this.options.startY = -this.selectedIndex * this.itemHeight;

      this.maxScrollX = 0;
      this.maxScrollY = -this.itemHeight * (this.items.length - 1);
    } else {
      this.maxScrollX = this.wrapperWidth - this.scrollerWidth;
      if (!this.options.infinity) {
        this.maxScrollY = this.wrapperHeight - this.scrollerHeight;
      }
      if (this.maxScrollX < 0) {
        this.maxScrollX -= this.relativeX;
        this.minScrollX = -this.relativeX;
      } else if (this.scale > 1) {
        this.maxScrollX = this.maxScrollX / 2 - this.relativeX;
        this.minScrollX = this.maxScrollX;
      }
      if (this.maxScrollY < 0) {
        this.maxScrollY -= this.relativeY;
        this.minScrollY = -this.relativeY;
      } else if (this.scale > 1) {
        this.maxScrollY = this.maxScrollY / 2 - this.relativeY;
        this.minScrollY = this.maxScrollY;
      }
    }

    this.hasHorizontalScroll = this.options.scrollX && this.maxScrollX < this.minScrollX;
    this.hasVerticalScroll = this.options.scrollY && this.maxScrollY < this.minScrollY;

    if (!this.hasHorizontalScroll) {
      this.maxScrollX = this.minScrollX;
      this.scrollerWidth = this.wrapperWidth;
    }

    if (!this.hasVerticalScroll) {
      this.maxScrollY = this.minScrollY;
      this.scrollerHeight = this.wrapperHeight;
    }

    this.endTime = 0;
    this.directionX = 0;
    this.directionY = 0;
    this.wrapperOffset = offset(this.wrapper);

    this.trigger('refresh');

    !this.scaled && this.resetPosition();
  };

  BScroll.prototype.enable = function () {
    this.enabled = true;
  };

  BScroll.prototype.disable = function () {
    this.enabled = false;
  };
}

var ease = {
  // easeOutQuint
  swipe: {
    style: 'cubic-bezier(0.23, 1, 0.32, 1)',
    fn: function fn(t) {
      return 1 + --t * t * t * t * t;
    }
  },
  // easeOutQuard
  swipeBounce: {
    style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    fn: function fn(t) {
      return t * (2 - t);
    }
  },
  // easeOutQuart
  bounce: {
    style: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
    fn: function fn(t) {
      return 1 - --t * t * t * t;
    }
  }
};

function momentum(current, start, time, lowerMargin, upperMargin, wrapperSize, options, scroll) {
  var distance = current - start;
  var speed = Math.abs(distance) / time;

  var deceleration = options.deceleration,
      itemHeight = options.itemHeight,
      swipeBounceTime = options.swipeBounceTime,
      wheel = options.wheel,
      swipeTime = options.swipeTime;

  var duration = swipeTime;
  var rate = wheel ? 4 : 15;

  var destination = current + speed / deceleration * (distance < 0 ? -1 : 1);

  if (wheel && itemHeight) {
    destination = scroll._findNearestValidWheel(destination).y;
  }

  if (destination < lowerMargin) {
    destination = wrapperSize ? Math.max(lowerMargin - wrapperSize / 4, lowerMargin - wrapperSize / rate * speed) : lowerMargin;
    duration = swipeBounceTime;
  } else if (destination > upperMargin) {
    destination = wrapperSize ? Math.min(upperMargin + wrapperSize / 4, upperMargin + wrapperSize / rate * speed) : upperMargin;
    duration = swipeBounceTime;
  }

  return {
    destination: Math.round(destination),
    duration: duration
  };
}

var DEFAULT_INTERVAL = 100 / 60;

function noop() {}

var requestAnimationFrame = function () {
  if (!inBrowser) {
    /* istanbul ignore if */
    return noop;
  }
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame ||
  // if all else fails, use setTimeout
  function (callback) {
    return window.setTimeout(callback, (callback.interval || DEFAULT_INTERVAL) / 2); // make interval as precise as possible.
  };
}();

var cancelAnimationFrame = function () {
  if (!inBrowser) {
    /* istanbul ignore if */
    return noop;
  }
  return window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.oCancelAnimationFrame || function (id) {
    window.clearTimeout(id);
  };
}();

var DIRECTION_UP = 1;
var DIRECTION_DOWN = -1;
var DIRECTION_LEFT = 1;
var DIRECTION_RIGHT = -1;

var PROBE_DEBOUNCE = 1;

var PROBE_REALTIME = 3;

function warn(msg) {
  console.error('[BScroll warn]: ' + msg);
}

function assert(condition, msg) {
  if (!condition) {
    throw new Error('[BScroll] ' + msg);
  }
}

function coreMixin(BScroll) {
  BScroll.prototype._start = function (e) {
    var _eventType = eventType[e.type];
    if (_eventType !== TOUCH_EVENT) {
      if (e.button !== 0) {
        return;
      }
    }
    if (!this.enabled || this.destroyed || this.initiated && this.initiated !== _eventType) {
      return;
    }
    this.initiated = _eventType;

    if (this.options.preventDefault && !preventDefaultException(e.target, this.options.preventDefaultException)) {
      e.preventDefault();
    }
    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    this.moved = false;
    this.distX = 0;
    this.distY = 0;
    this.directionX = 0;
    this.directionY = 0;
    this.movingDirectionX = 0;
    this.movingDirectionY = 0;
    this.directionLocked = 0;

    this._transitionTime();
    this.startTime = getNow();

    if (this.options.wheel) {
      this.target = e.target;
    }

    this.stop();

    var point = e.touches ? e.touches[0] : e;

    this.startX = this.x;
    this.startY = this.y;
    this.absStartX = this.x;
    this.absStartY = this.y;
    this.pointX = point.pageX;
    this.pointY = point.pageY;

    this.trigger('beforeScrollStart');
  };

  BScroll.prototype._move = function (e) {
    if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
      return;
    }

    if (this.options.preventDefault) {
      e.preventDefault();
    }
    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    var point = e.touches ? e.touches[0] : e;
    var deltaX = point.pageX - this.pointX;
    var deltaY = point.pageY - this.pointY;

    this.pointX = point.pageX;
    this.pointY = point.pageY;

    this.distX += deltaX;
    this.distY += deltaY;

    var absDistX = Math.abs(this.distX);
    var absDistY = Math.abs(this.distY);

    var timestamp = getNow();

    // We need to move at least momentumLimitDistance pixels for the scrolling to initiate
    if (timestamp - this.endTime > this.options.momentumLimitTime && !this.moved && absDistY < this.options.momentumLimitDistance && absDistX < this.options.momentumLimitDistance) {
      return;
    }

    // If you are scrolling in one direction lock the other
    if (!this.directionLocked && !this.options.freeScroll) {
      if (absDistX > absDistY + this.options.directionLockThreshold) {
        this.directionLocked = 'h'; // lock horizontally
      } else if (absDistY >= absDistX + this.options.directionLockThreshold) {
        this.directionLocked = 'v'; // lock vertically
      } else {
        this.directionLocked = 'n'; // no lock
      }
    }

    if (this.directionLocked === 'h') {
      if (this.options.eventPassthrough === 'vertical') {
        e.preventDefault();
      } else if (this.options.eventPassthrough === 'horizontal') {
        this.initiated = false;
        return;
      }
      deltaY = 0;
    } else if (this.directionLocked === 'v') {
      if (this.options.eventPassthrough === 'horizontal') {
        e.preventDefault();
      } else if (this.options.eventPassthrough === 'vertical') {
        this.initiated = false;
        return;
      }
      deltaX = 0;
    }

    deltaX = this.hasHorizontalScroll ? deltaX : 0;
    deltaY = this.hasVerticalScroll ? deltaY : 0;
    this.movingDirectionX = deltaX > 0 ? DIRECTION_RIGHT : deltaX < 0 ? DIRECTION_LEFT : 0;
    this.movingDirectionY = deltaY > 0 ? DIRECTION_DOWN : deltaY < 0 ? DIRECTION_UP : 0;

    var newX = this.x + deltaX;
    var newY = this.y + deltaY;

    var top = false;
    var bottom = false;
    var left = false;
    var right = false;
    // Slow down or stop if outside of the boundaries
    var bounce = this.options.bounce;
    if (bounce !== false) {
      top = bounce.top === undefined ? true : bounce.top;
      bottom = bounce.bottom === undefined ? true : bounce.bottom;
      left = bounce.left === undefined ? true : bounce.left;
      right = bounce.right === undefined ? true : bounce.right;
    }
    if (newX > this.minScrollX || newX < this.maxScrollX) {
      if (newX > this.minScrollX && left || newX < this.maxScrollX && right) {
        newX = this.x + deltaX / 3;
      } else {
        newX = newX > this.minScrollX ? this.minScrollX : this.maxScrollX;
      }
    }
    if (newY > this.minScrollY || newY < this.maxScrollY) {
      if (newY > this.minScrollY && top || newY < this.maxScrollY && bottom) {
        newY = this.y + deltaY / 3;
      } else {
        newY = newY > this.minScrollY ? this.minScrollY : this.maxScrollY;
      }
    }

    if (!this.moved) {
      this.moved = true;
      this.trigger('scrollStart');
    }

    this._translate(newX, newY);

    if (timestamp - this.startTime > this.options.momentumLimitTime) {
      this.startTime = timestamp;
      this.startX = this.x;
      this.startY = this.y;

      if (this.options.probeType === PROBE_DEBOUNCE) {
        this.trigger('scroll', {
          x: this.x,
          y: this.y
        });
      }
    }

    if (this.options.probeType > PROBE_DEBOUNCE) {
      this.trigger('scroll', {
        x: this.x,
        y: this.y
      });
    }

    var scrollLeft = document.documentElement.scrollLeft || window.pageXOffset || document.body.scrollLeft;
    var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

    var pX = this.pointX - scrollLeft;
    var pY = this.pointY - scrollTop;

    if (pX > document.documentElement.clientWidth - this.options.momentumLimitDistance || pX < this.options.momentumLimitDistance || pY < this.options.momentumLimitDistance || pY > document.documentElement.clientHeight - this.options.momentumLimitDistance) {
      this._end(e);
    }
  };

  BScroll.prototype._end = function (e) {
    if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
      return;
    }
    this.initiated = false;

    if (this.options.preventDefault && !preventDefaultException(e.target, this.options.preventDefaultException)) {
      e.preventDefault();
    }
    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    this.trigger('touchEnd', {
      x: this.x,
      y: this.y
    });

    this.isInTransition = false;

    // ensures that the last position is rounded
    var newX = Math.round(this.x);
    var newY = Math.round(this.y);

    var deltaX = newX - this.absStartX;
    var deltaY = newY - this.absStartY;
    this.directionX = deltaX > 0 ? DIRECTION_RIGHT : deltaX < 0 ? DIRECTION_LEFT : 0;
    this.directionY = deltaY > 0 ? DIRECTION_DOWN : deltaY < 0 ? DIRECTION_UP : 0;

    // if configure pull down refresh, check it first
    if (this.options.pullDownRefresh && this._checkPullDown()) {
      return;
    }

    // check if it is a click operation
    if (this._checkClick(e)) {
      this.trigger('scrollCancel');
      return;
    }

    // reset if we are outside of the boundaries
    if (this.resetPosition(this.options.bounceTime, ease.bounce)) {
      return;
    }

    this._translate(newX, newY);

    this.endTime = getNow();
    var duration = this.endTime - this.startTime;
    var absDistX = Math.abs(newX - this.startX);
    var absDistY = Math.abs(newY - this.startY);

    // flick
    if (this._events.flick && duration < this.options.flickLimitTime && absDistX < this.options.flickLimitDistance && absDistY < this.options.flickLimitDistance) {
      this.trigger('flick');
      return;
    }

    var time = 0;
    // start momentum animation if needed
    if (this.options.momentum && duration < this.options.momentumLimitTime && (absDistY > this.options.momentumLimitDistance || absDistX > this.options.momentumLimitDistance)) {
      var top = false;
      var bottom = false;
      var left = false;
      var right = false;
      var bounce = this.options.bounce;
      if (bounce !== false) {
        top = bounce.top === undefined ? true : bounce.top;
        bottom = bounce.bottom === undefined ? true : bounce.bottom;
        left = bounce.left === undefined ? true : bounce.left;
        right = bounce.right === undefined ? true : bounce.right;
      }
      var wrapperWidth = this.directionX === DIRECTION_RIGHT && left || this.directionX === DIRECTION_LEFT && right ? this.wrapperWidth : 0;
      var wrapperHeight = this.directionY === DIRECTION_DOWN && top || this.directionY === DIRECTION_UP && bottom ? this.wrapperHeight : 0;
      var momentumX = this.hasHorizontalScroll ? momentum(this.x, this.startX, duration, this.maxScrollX, this.minScrollX, wrapperWidth, this.options, this) : { destination: newX, duration: 0 };
      var momentumY = this.hasVerticalScroll ? momentum(this.y, this.startY, duration, this.maxScrollY, this.minScrollY, wrapperHeight, this.options, this) : { destination: newY, duration: 0 };
      newX = momentumX.destination;
      newY = momentumY.destination;
      time = Math.max(momentumX.duration, momentumY.duration);
      this.isInTransition = true;
    } else {
      if (this.options.wheel) {
        newY = this._findNearestValidWheel(newY).y;
        time = this.options.wheel.adjustTime || 400;
      }
    }

    var easing = ease.swipe;
    if (this.options.snap) {
      var snap = this._nearestSnap(newX, newY);
      this.currentPage = snap;
      time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(newX - snap.x), 1000), Math.min(Math.abs(newY - snap.y), 1000)), 300);
      newX = snap.x;
      newY = snap.y;

      this.directionX = 0;
      this.directionY = 0;
      easing = this.options.snap.easing || ease.bounce;
    }

    if (newX !== this.x || newY !== this.y) {
      // change easing function when scroller goes out of the boundaries
      if (newX > this.minScrollX || newX < this.maxScrollX || newY > this.minScrollY || newY < this.maxScrollY) {
        easing = ease.swipeBounce;
      }
      this.scrollTo(newX, newY, time, easing);
      return;
    }

    if (this.options.wheel) {
      this.selectedIndex = this._findNearestValidWheel(this.y).index;
    }

    this.trigger('scrollEnd', {
      x: this.x,
      y: this.y
    });
  };

  BScroll.prototype._checkClick = function (e) {
    // when in the process of pulling down, it should not prevent click
    var preventClick = this.stopFromTransition && !this.pulling;
    this.stopFromTransition = false;

    // we scrolled less than 15 pixels
    if (!this.moved) {
      if (this.options.wheel) {
        if (this.target && this.target.className === this.options.wheel.wheelWrapperClass) {
          var index = this._findNearestValidWheel(this.y).index;
          var _offset = Math.round((this.pointY + offsetToBody(this.wrapper).top - this.wrapperHeight / 2) / this.itemHeight);
          this.target = this.items[index + _offset];
        }
        var top = offset(this.target).top;
        var left = offset(this.target).left;
        top -= this.wrapperOffset.top;
        top -= Math.round(this.target.offsetHeight / 2 - this.wrapper.offsetHeight / 2) || 0;
        left -= this.wrapperOffset.left;
        left -= Math.round(this.target.offsetWidth / 2 - this.wrapper.offsetWidth / 2) || 0;

        top = this._findNearestValidWheel(top).y;
        this.scrollTo(left, top, this.options.wheel.adjustTime || 400, ease.swipe);
        return true;
      } else {
        if (!preventClick) {
          var _dblclick = this.options.dblclick;
          var dblclickTrigged = false;
          if (_dblclick && this.lastClickTime) {
            var _dblclick$delay = _dblclick.delay,
                delay = _dblclick$delay === undefined ? 300 : _dblclick$delay;

            if (getNow() - this.lastClickTime < delay) {
              dblclickTrigged = true;
              dblclick(e);
            }
          }
          if (this.options.tap) {
            tap(e, this.options.tap);
          }

          if (this.options.click && !preventDefaultException(e.target, this.options.preventDefaultException)) {
            click(e);
          }
          this.lastClickTime = dblclickTrigged ? null : getNow();
          return true;
        }
        return false;
      }
    }
    return false;
  };

  BScroll.prototype._resize = function () {
    var _this = this;

    if (!this.enabled) {
      return;
    }
    // fix a scroll problem under Android condition
    if (isAndroid) {
      this.wrapper.scrollTop = 0;
    }
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(function () {
      _this.refresh();
    }, this.options.resizePolling);
  };

  BScroll.prototype._startProbe = function () {
    cancelAnimationFrame(this.probeTimer);
    this.probeTimer = requestAnimationFrame(probe);

    var me = this;

    function probe() {
      var pos = me.getComputedPosition();
      me.trigger('scroll', pos);
      if (!me.isInTransition) {
        me.trigger('scrollEnd', pos);
        return;
      }
      me.probeTimer = requestAnimationFrame(probe);
    }
  };

  BScroll.prototype._transitionTime = function () {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    this.scrollerStyle[style.transitionDuration] = time + 'ms';

    if (this.options.wheel) {
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].style[style.transitionDuration] = time + 'ms';
      }
    }

    if (this.indicators) {
      for (var _i = 0; _i < this.indicators.length; _i++) {
        this.indicators[_i].transitionTime(time);
      }
    }
  };

  BScroll.prototype._transitionTimingFunction = function (easing) {
    this.scrollerStyle[style.transitionTimingFunction] = easing;

    if (this.options.wheel) {
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].style[style.transitionTimingFunction] = easing;
      }
    }

    if (this.indicators) {
      for (var _i2 = 0; _i2 < this.indicators.length; _i2++) {
        this.indicators[_i2].transitionTimingFunction(easing);
      }
    }
  };

  BScroll.prototype._transitionEnd = function (e) {
    if (e.target !== this.scroller || !this.isInTransition) {
      return;
    }

    this._transitionTime();
    var needReset = !this.pulling || this.movingDirectionY === DIRECTION_UP;
    if (needReset && !this.resetPosition(this.options.bounceTime, ease.bounce)) {
      this.isInTransition = false;
      if (this.options.probeType !== PROBE_REALTIME) {
        this.trigger('scrollEnd', {
          x: this.x,
          y: this.y
        });
      }
    }
  };

  BScroll.prototype._translate = function (x, y, scale) {
    assert(!isUndef(x) && !isUndef(y), 'Translate x or y is null or undefined.');
    if (isUndef(scale)) {
      scale = this.scale;
    }
    if (this.options.useTransform) {
      this.scrollerStyle[style.transform] = 'translate(' + x + 'px,' + y + 'px) scale(' + scale + ')' + this.translateZ;
    } else {
      x = Math.round(x);
      y = Math.round(y);
      this.scrollerStyle.left = x + 'px';
      this.scrollerStyle.top = y + 'px';
    }

    if (this.options.wheel) {
      var _options$wheel$rotate = this.options.wheel.rotate,
          rotate = _options$wheel$rotate === undefined ? 25 : _options$wheel$rotate;

      for (var i = 0; i < this.items.length; i++) {
        var deg = rotate * (y / this.itemHeight + i);
        this.items[i].style[style.transform] = 'rotateX(' + deg + 'deg)';
      }
    }

    this.x = x;
    this.y = y;
    this.setScale(scale);

    if (this.indicators) {
      for (var _i3 = 0; _i3 < this.indicators.length; _i3++) {
        this.indicators[_i3].updatePosition();
      }
    }
  };

  BScroll.prototype._animate = function (destX, destY, duration, easingFn) {
    var me = this;
    var startX = this.x;
    var startY = this.y;
    var startScale = this.lastScale;
    var destScale = this.scale;
    var startTime = getNow();
    var destTime = startTime + duration;

    function step() {
      var now = getNow();

      if (now >= destTime) {
        me.isAnimating = false;
        me._translate(destX, destY, destScale);

        me.trigger('scroll', {
          x: me.x,
          y: me.y
        });

        if (!me.pulling && !me.resetPosition(me.options.bounceTime)) {
          me.trigger('scrollEnd', {
            x: me.x,
            y: me.y
          });
        }
        return;
      }
      now = (now - startTime) / duration;
      var easing = easingFn(now);
      var newX = (destX - startX) * easing + startX;
      var newY = (destY - startY) * easing + startY;
      var newScale = (destScale - startScale) * easing + startScale;

      me._translate(newX, newY, newScale);

      if (me.isAnimating) {
        me.animateTimer = requestAnimationFrame(step);
      }

      if (me.options.probeType === PROBE_REALTIME) {
        me.trigger('scroll', {
          x: me.x,
          y: me.y
        });
      }
    }

    this.isAnimating = true;
    cancelAnimationFrame(this.animateTimer);
    step();
  };

  BScroll.prototype.scrollBy = function (x, y) {
    var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ease.bounce;

    x = this.x + x;
    y = this.y + y;

    this.scrollTo(x, y, time, easing);
  };

  BScroll.prototype.scrollTo = function (x, y) {
    var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ease.bounce;
    var isSilent = arguments[4];

    if (this.options.wheel) {
      y = this._findNearestValidWheel(y).y;
    }
    if (x === this.x && y === this.y) {
      return;
    }
    this.isInTransition = this.options.useTransition && time > 0 && (this.x !== x || this.y !== y);

    if (!time || this.options.useTransition) {
      this._transitionTimingFunction(easing.style);
      this._transitionTime(time);
      this._translate(x, y);

      if (time && this.options.probeType === PROBE_REALTIME) {
        this._startProbe();
      }
      if (!time && !isSilent) {
        // don't trigger resetPosition when zoom feature is open, fix #748
        if (this.options.zoom) return;
        this.trigger('scroll', {
          x: x,
          y: y
        });
        // force reflow to put everything in position
        this._reflow = document.body.offsetHeight;
        if (!this.resetPosition(this.options.bounceTime, ease.bounce)) {
          this.trigger('scrollEnd', {
            x: x,
            y: y
          });
        }
      }

      if (this.options.wheel) {
        this.selectedIndex = this._findNearestValidWheel(y).index;
      }
    } else {
      this._animate(x, y, time, easing.fn);
    }
  };

  BScroll.prototype.scrollToElement = function (el, time, offsetX, offsetY, easing) {
    if (!el) {
      return;
    }
    el = el.nodeType ? el : this.scroller.querySelector(el);

    if (this.options.wheel && !el.classList.contains(this.options.wheel.wheelItemClass)) {
      return;
    }

    var pos = offset(el);
    pos.left -= this.wrapperOffset.left;
    pos.top -= this.wrapperOffset.top;

    // if offsetX/Y are true we center the element to the screen
    if (offsetX === true) {
      offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
    }
    if (offsetY === true) {
      offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
    }

    pos.left -= offsetX || 0;
    pos.top -= offsetY || 0;
    pos.left = pos.left > this.minScrollX ? this.minScrollX : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
    pos.top = pos.top > this.minScrollY ? this.minScrollY : pos.top < this.maxScrollY ? this.maxScrollY : pos.top;

    if (this.options.wheel) {
      pos.top = this._findNearestValidWheel(pos.top).y;
    }

    this.scrollTo(pos.left, pos.top, time, easing);
  };

  BScroll.prototype.resetPosition = function () {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var easeing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ease.bounce;

    var x = this.x;
    var roundX = Math.round(x);
    if (!this.hasHorizontalScroll || roundX > this.minScrollX) {
      x = this.minScrollX;
    } else if (roundX < this.maxScrollX) {
      x = this.maxScrollX;
    }

    var y = this.y;
    var roundY = Math.round(y);
    if (!this.hasVerticalScroll || roundY > this.minScrollY) {
      y = this.minScrollY;
    } else if (roundY < this.maxScrollY) {
      y = this.maxScrollY;
    }

    if (x === this.x && y === this.y) {
      return false;
    }

    this.scrollTo(x, y, time, easeing);

    return true;
  };

  BScroll.prototype.getComputedPosition = function () {
    var matrix = window.getComputedStyle(this.scroller, null);
    var x = void 0;
    var y = void 0;

    if (this.options.useTransform) {
      matrix = matrix[style.transform].split(')')[0].split(', ');
      x = +(matrix[12] || matrix[4]);
      y = +(matrix[13] || matrix[5]);
    } else {
      x = +matrix.left.replace(/[^-\d.]/g, '');
      y = +matrix.top.replace(/[^-\d.]/g, '');
    }

    return {
      x: x,
      y: y
    };
  };

  BScroll.prototype.stop = function () {
    if (this.options.useTransition && this.isInTransition) {
      this.isInTransition = false;
      cancelAnimationFrame(this.probeTimer);
      var pos = this.getComputedPosition();
      this._translate(pos.x, pos.y);
      if (this.options.wheel) {
        this.target = this.items[this._findNearestValidWheel(pos.y).index];
      } else {
        this.trigger('scrollEnd', {
          x: this.x,
          y: this.y
        });
      }
      this.stopFromTransition = true;
    } else if (!this.options.useTransition && this.isAnimating) {
      this.isAnimating = false;
      cancelAnimationFrame(this.animateTimer);
      this.trigger('scrollEnd', {
        x: this.x,
        y: this.y
      });
      this.stopFromTransition = true;
    }
  };

  BScroll.prototype.destroy = function () {
    this.destroyed = true;
    this.trigger('destroy');
    if (this.options.useTransition) {
      cancelAnimationFrame(this.probeTimer);
    } else {
      cancelAnimationFrame(this.animateTimer);
    }
    this._removeDOMEvents();
    // remove custom events
    this._events = {};
  };
}

function snapMixin(BScroll) {
  BScroll.prototype._initSnap = function () {
    var _this = this;

    this.currentPage = {};
    var snap = this.options.snap;

    if (snap.loop) {
      var children = this.scroller.children;
      if (children.length > 1) {
        prepend(children[children.length - 1].cloneNode(true), this.scroller);
        this.scroller.appendChild(children[1].cloneNode(true));
      } else {
        // Loop does not make any sense if there is only one child.
        snap.loop = false;
      }
    }

    var el = snap.el;
    if (typeof el === 'string') {
      el = this.scroller.querySelectorAll(el);
    }

    this.on('refresh', function () {
      _this.pages = [];

      if (!_this.wrapperWidth || !_this.wrapperHeight || !_this.scrollerWidth || !_this.scrollerHeight) {
        return;
      }

      var stepX = snap.stepX || _this.wrapperWidth;
      var stepY = snap.stepY || _this.wrapperHeight;

      var x = 0;
      var y = void 0;
      var cx = void 0;
      var cy = void 0;
      var i = 0;
      var l = void 0;
      var m = 0;
      var n = void 0;
      var rect = void 0;
      if (!el) {
        cx = Math.round(stepX / 2);
        cy = Math.round(stepY / 2);

        while (x > -_this.scrollerWidth) {
          _this.pages[i] = [];
          l = 0;
          y = 0;

          while (y > -_this.scrollerHeight) {
            _this.pages[i][l] = {
              x: Math.max(x, _this.maxScrollX),
              y: Math.max(y, _this.maxScrollY),
              width: stepX,
              height: stepY,
              cx: x - cx,
              cy: y - cy
            };

            y -= stepY;
            l++;
          }

          x -= stepX;
          i++;
        }
      } else {
        l = el.length;
        n = -1;

        for (; i < l; i++) {
          rect = getRect(el[i]);
          if (i === 0 || rect.left <= getRect(el[i - 1]).left) {
            m = 0;
            n++;
          }

          if (!_this.pages[m]) {
            _this.pages[m] = [];
          }

          x = Math.max(-rect.left, _this.maxScrollX);
          y = Math.max(-rect.top, _this.maxScrollY);
          cx = x - Math.round(rect.width / 2);
          cy = y - Math.round(rect.height / 2);

          _this.pages[m][n] = {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height,
            cx: cx,
            cy: cy
          };

          if (x > _this.maxScrollX) {
            m++;
          }
        }
      }

      _this._checkSnapLoop();

      var initPageX = snap._loopX ? 1 : 0;
      var initPageY = snap._loopY ? 1 : 0;
      _this._goToPage(_this.currentPage.pageX || initPageX, _this.currentPage.pageY || initPageY, 0, undefined, true);

      // Update snap threshold if needed.
      var snapThreshold = snap.threshold;
      if (snapThreshold % 1 === 0) {
        _this.snapThresholdX = snapThreshold;
        _this.snapThresholdY = snapThreshold;
      } else {
        _this.snapThresholdX = Math.round(_this.pages[_this.currentPage.pageX][_this.currentPage.pageY].width * snapThreshold);
        _this.snapThresholdY = Math.round(_this.pages[_this.currentPage.pageX][_this.currentPage.pageY].height * snapThreshold);
      }
    });

    this.on('scrollEnd', function () {
      if (snap.loop) {
        if (snap._loopX) {
          if (_this.currentPage.pageX === 0) {
            _this._goToPage(_this.pages.length - 2, _this.currentPage.pageY, 0, undefined, true);
          }
          if (_this.currentPage.pageX === _this.pages.length - 1) {
            _this._goToPage(1, _this.currentPage.pageY, 0, undefined, true);
          }
        } else {
          if (_this.currentPage.pageY === 0) {
            _this._goToPage(_this.currentPage.pageX, _this.pages[0].length - 2, 0, undefined, true);
          }
          if (_this.currentPage.pageY === _this.pages[0].length - 1) {
            _this._goToPage(_this.currentPage.pageX, 1, 0, undefined, true);
          }
        }
      }
    });

    if (snap.listenFlick !== false) {
      this.on('flick', function () {
        var time = snap.speed || Math.max(Math.max(Math.min(Math.abs(_this.x - _this.startX), 1000), Math.min(Math.abs(_this.y - _this.startY), 1000)), 300);

        _this._goToPage(_this.currentPage.pageX + _this.directionX, _this.currentPage.pageY + _this.directionY, time);
      });
    }

    this.on('destroy', function () {
      if (snap.loop) {
        var _children = _this.scroller.children;
        if (_children.length > 2) {
          removeChild(_this.scroller, _children[_children.length - 1]);
          removeChild(_this.scroller, _children[0]);
        }
      }
    });
  };

  BScroll.prototype._checkSnapLoop = function () {
    var snap = this.options.snap;

    if (!snap.loop || !this.pages || !this.pages.length) {
      return;
    }

    if (this.pages.length > 1) {
      snap._loopX = true;
    }
    if (this.pages[0] && this.pages[0].length > 1) {
      snap._loopY = true;
    }
    if (snap._loopX && snap._loopY) {
      warn('Loop does not support two direction at the same time.');
    }
  };

  BScroll.prototype._nearestSnap = function (x, y) {
    if (!this.pages.length) {
      return { x: 0, y: 0, pageX: 0, pageY: 0 };
    }

    var i = 0;
    // Check if we exceeded the snap threshold
    if (Math.abs(x - this.absStartX) <= this.snapThresholdX && Math.abs(y - this.absStartY) <= this.snapThresholdY) {
      return this.currentPage;
    }

    if (x > this.minScrollX) {
      x = this.minScrollX;
    } else if (x < this.maxScrollX) {
      x = this.maxScrollX;
    }

    if (y > this.minScrollY) {
      y = this.minScrollY;
    } else if (y < this.maxScrollY) {
      y = this.maxScrollY;
    }

    var l = this.pages.length;
    for (; i < l; i++) {
      if (x >= this.pages[i][0].cx) {
        x = this.pages[i][0].x;
        break;
      }
    }

    l = this.pages[i].length;

    var m = 0;
    for (; m < l; m++) {
      if (y >= this.pages[0][m].cy) {
        y = this.pages[0][m].y;
        break;
      }
    }

    if (i === this.currentPage.pageX) {
      i += this.directionX;

      if (i < 0) {
        i = 0;
      } else if (i >= this.pages.length) {
        i = this.pages.length - 1;
      }

      x = this.pages[i][0].x;
    }

    if (m === this.currentPage.pageY) {
      m += this.directionY;

      if (m < 0) {
        m = 0;
      } else if (m >= this.pages[0].length) {
        m = this.pages[0].length - 1;
      }

      y = this.pages[0][m].y;
    }

    return {
      x: x,
      y: y,
      pageX: i,
      pageY: m
    };
  };

  BScroll.prototype._goToPage = function (x) {
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var time = arguments[2];
    var easing = arguments[3];
    var isSilent = arguments[4];

    var snap = this.options.snap;

    if (!snap || !this.pages || !this.pages.length) {
      return;
    }

    easing = easing || snap.easing || ease.bounce;

    if (x >= this.pages.length) {
      x = this.pages.length - 1;
    } else if (x < 0) {
      x = 0;
    }

    if (!this.pages[x]) {
      return;
    }

    if (y >= this.pages[x].length) {
      y = this.pages[x].length - 1;
    } else if (y < 0) {
      y = 0;
    }

    var posX = this.pages[x][y].x;
    var posY = this.pages[x][y].y;

    time = time === undefined ? snap.speed || Math.max(Math.max(Math.min(Math.abs(posX - this.x), 1000), Math.min(Math.abs(posY - this.y), 1000)), 300) : time;

    this.currentPage = {
      x: posX,
      y: posY,
      pageX: x,
      pageY: y
    };
    this.scrollTo(posX, posY, time, easing, isSilent);
  };

  BScroll.prototype.goToPage = function (x, y, time, easing) {
    var snap = this.options.snap;
    if (!snap || !this.pages || !this.pages.length) {
      return;
    }

    if (snap.loop) {
      var len = void 0;
      if (snap._loopX) {
        len = this.pages.length - 2;
        if (x >= len) {
          x = len - 1;
        } else if (x < 0) {
          x = 0;
        }
        x += 1;
      } else {
        len = this.pages[0].length - 2;
        if (y >= len) {
          y = len - 1;
        } else if (y < 0) {
          y = 0;
        }
        y += 1;
      }
    }
    this._goToPage(x, y, time, easing);
  };

  BScroll.prototype.next = function (time, easing) {
    var snap = this.options.snap;
    if (!snap) {
      return;
    }

    var x = this.currentPage.pageX;
    var y = this.currentPage.pageY;

    x++;
    if (x >= this.pages.length && this.hasVerticalScroll) {
      x = 0;
      y++;
    }

    this._goToPage(x, y, time, easing);
  };

  BScroll.prototype.prev = function (time, easing) {
    var snap = this.options.snap;
    if (!snap) {
      return;
    }

    var x = this.currentPage.pageX;
    var y = this.currentPage.pageY;

    x--;
    if (x < 0 && this.hasVerticalScroll) {
      x = 0;
      y--;
    }

    this._goToPage(x, y, time, easing);
  };

  BScroll.prototype.getCurrentPage = function () {
    var snap = this.options.snap;
    if (!snap) {
      return null;
    }

    if (snap.loop) {
      var currentPage = void 0;
      if (snap._loopX) {
        currentPage = extend({}, this.currentPage, {
          pageX: this.currentPage.pageX - 1
        });
      } else {
        currentPage = extend({}, this.currentPage, {
          pageY: this.currentPage.pageY - 1
        });
      }
      return currentPage;
    }
    return this.currentPage;
  };
}

function wheelMixin(BScroll) {
  BScroll.prototype.wheelTo = function () {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (this.options.wheel) {
      var y = -index * this.itemHeight;
      this.scrollTo(0, y);
    }
  };

  BScroll.prototype.getSelectedIndex = function () {
    return this.options.wheel && this.selectedIndex;
  };

  BScroll.prototype._initWheel = function () {
    var wheel = this.options.wheel;
    if (!wheel.wheelWrapperClass) {
      wheel.wheelWrapperClass = 'wheel-scroll';
    }
    if (!wheel.wheelItemClass) {
      wheel.wheelItemClass = 'wheel-item';
    }
    if (!wheel.wheelDisabledItemClass) {
      wheel.wheelDisabledItemClass = 'wheel-disabled-item';
    }
    if (wheel.selectedIndex === undefined) {
      wheel.selectedIndex = 0;
    }
  };

  BScroll.prototype._findNearestValidWheel = function (y) {
    y = y > 0 ? 0 : y < this.maxScrollY ? this.maxScrollY : y;
    var wheel = this.options.wheel;
    var currentIndex = Math.abs(Math.round(-y / this.itemHeight));
    var cacheIndex = currentIndex;
    var items = this.items;
    // Impersonation web native select
    // first, check whether there is a enable item whose index is smaller than currentIndex
    // then, check whether there is a enable item whose index is bigger than currentIndex
    // otherwise, there are all disabled items, just keep currentIndex unchange
    while (currentIndex >= 0) {
      if (items[currentIndex].className.indexOf(wheel.wheelDisabledItemClass) === -1) {
        break;
      }
      currentIndex--;
    }

    if (currentIndex < 0) {
      currentIndex = cacheIndex;
      while (currentIndex <= items.length - 1) {
        if (items[currentIndex].className.indexOf(wheel.wheelDisabledItemClass) === -1) {
          break;
        }
        currentIndex++;
      }
    }

    // keep it unchange when all the items are disabled
    if (currentIndex === items.length) {
      currentIndex = cacheIndex;
    }
    // when all the items are disabled, this.selectedIndex should always be -1
    return {
      index: this.wheelItemsAllDisabled ? -1 : currentIndex,
      y: -currentIndex * this.itemHeight
    };
  };

  BScroll.prototype._checkWheelAllDisabled = function () {
    var wheel = this.options.wheel;
    var items = this.items;
    this.wheelItemsAllDisabled = true;
    for (var i = 0; i < items.length; i++) {
      if (items[i].className.indexOf(wheel.wheelDisabledItemClass) === -1) {
        this.wheelItemsAllDisabled = false;
        break;
      }
    }
  };
}

var INDICATOR_MIN_LEN = 8;

function scrollbarMixin(BScroll) {
  BScroll.prototype._initScrollbar = function () {
    var _this = this;

    var _options$scrollbar = this.options.scrollbar,
        _options$scrollbar$fa = _options$scrollbar.fade,
        fade = _options$scrollbar$fa === undefined ? true : _options$scrollbar$fa,
        _options$scrollbar$in = _options$scrollbar.interactive,
        interactive = _options$scrollbar$in === undefined ? false : _options$scrollbar$in;

    this.indicators = [];
    var indicator = void 0;

    if (this.options.scrollX) {
      indicator = {
        el: createScrollbar('horizontal'),
        direction: 'horizontal',
        fade: fade,
        interactive: interactive
      };
      this._insertScrollBar(indicator.el);

      this.indicators.push(new Indicator(this, indicator));
    }

    if (this.options.scrollY) {
      indicator = {
        el: createScrollbar('vertical'),
        direction: 'vertical',
        fade: fade,
        interactive: interactive
      };
      this._insertScrollBar(indicator.el);
      this.indicators.push(new Indicator(this, indicator));
    }

    this.on('refresh', function () {
      for (var i = 0; i < _this.indicators.length; i++) {
        _this.indicators[i].refresh();
      }
    });

    if (fade) {
      this.on('scrollEnd', function () {
        for (var i = 0; i < _this.indicators.length; i++) {
          _this.indicators[i].fade();
        }
      });

      this.on('scrollCancel', function () {
        for (var i = 0; i < _this.indicators.length; i++) {
          _this.indicators[i].fade();
        }
      });

      this.on('scrollStart', function () {
        for (var i = 0; i < _this.indicators.length; i++) {
          _this.indicators[i].fade(true);
        }
      });

      this.on('beforeScrollStart', function () {
        for (var i = 0; i < _this.indicators.length; i++) {
          _this.indicators[i].fade(true, true);
        }
      });
    }

    this.on('destroy', function () {
      _this._removeScrollBars();
    });
  };

  BScroll.prototype._insertScrollBar = function (scrollbar) {
    this.wrapper.appendChild(scrollbar);
  };

  BScroll.prototype._removeScrollBars = function () {
    for (var i = 0; i < this.indicators.length; i++) {
      this.indicators[i].destroy();
    }
  };
}

function createScrollbar(direction) {
  var scrollbar = document.createElement('div');
  var indicator = document.createElement('div');

  scrollbar.style.cssText = 'position:absolute;z-index:9999;pointerEvents:none';
  indicator.style.cssText = 'box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px;';

  indicator.className = 'bscroll-indicator';

  if (direction === 'horizontal') {
    scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
    indicator.style.height = '100%';
    scrollbar.className = 'bscroll-horizontal-scrollbar';
  } else {
    scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
    indicator.style.width = '100%';
    scrollbar.className = 'bscroll-vertical-scrollbar';
  }

  scrollbar.style.cssText += ';overflow:hidden';
  scrollbar.appendChild(indicator);

  return scrollbar;
}

function Indicator(scroller, options) {
  this.wrapper = options.el;
  this.wrapperStyle = this.wrapper.style;
  this.indicator = this.wrapper.children[0];
  this.indicatorStyle = this.indicator.style;
  this.scroller = scroller;
  this.direction = options.direction;
  if (options.fade) {
    this.visible = 0;
    this.wrapperStyle.opacity = '0';
  } else {
    this.visible = 1;
  }

  this.sizeRatioX = 1;
  this.sizeRatioY = 1;
  this.maxPosX = 0;
  this.maxPosY = 0;
  this.x = 0;
  this.y = 0;

  if (options.interactive) {
    this._addDOMEvents();
  }
}

Indicator.prototype.handleEvent = function (e) {
  switch (e.type) {
    case 'touchstart':
    case 'mousedown':
      this._start(e);
      break;
    case 'touchmove':
    case 'mousemove':
      this._move(e);
      break;
    case 'touchend':
    case 'mouseup':
    case 'touchcancel':
    case 'mousecancel':
      this._end(e);
      break;
  }
};

Indicator.prototype.refresh = function () {
  if (this._shouldShow()) {
    this.transitionTime();
    this._calculate();
    this.updatePosition();
  }
};

Indicator.prototype.fade = function (visible, hold) {
  var _this2 = this;

  if (hold && !this.visible) {
    return;
  }

  var time = visible ? 250 : 500;

  visible = visible ? '1' : '0';

  this.wrapperStyle[style.transitionDuration] = time + 'ms';

  clearTimeout(this.fadeTimeout);
  this.fadeTimeout = setTimeout(function () {
    _this2.wrapperStyle.opacity = visible;
    _this2.visible = +visible;
  }, 0);
};

Indicator.prototype.updatePosition = function () {
  if (this.direction === 'vertical') {
    var y = Math.round(this.sizeRatioY * this.scroller.y);

    if (y < 0) {
      this.transitionTime(500);
      var height = Math.max(this.indicatorHeight + y * 3, INDICATOR_MIN_LEN);
      this.indicatorStyle.height = height + 'px';
      y = 0;
    } else if (y > this.maxPosY) {
      this.transitionTime(500);
      var _height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, INDICATOR_MIN_LEN);
      this.indicatorStyle.height = _height + 'px';
      y = this.maxPosY + this.indicatorHeight - _height;
    } else {
      this.indicatorStyle.height = this.indicatorHeight + 'px';
    }
    this.y = y;

    if (this.scroller.options.useTransform) {
      this.indicatorStyle[style.transform] = 'translateY(' + y + 'px)' + this.scroller.translateZ;
    } else {
      this.indicatorStyle.top = y + 'px';
    }
  } else {
    var x = Math.round(this.sizeRatioX * this.scroller.x);

    if (x < 0) {
      this.transitionTime(500);
      var width = Math.max(this.indicatorWidth + x * 3, INDICATOR_MIN_LEN);
      this.indicatorStyle.width = width + 'px';
      x = 0;
    } else if (x > this.maxPosX) {
      this.transitionTime(500);
      var _width = Math.max(this.indicatorWidth - (x - this.maxPosX) * 3, INDICATOR_MIN_LEN);
      this.indicatorStyle.width = _width + 'px';
      x = this.maxPosX + this.indicatorWidth - _width;
    } else {
      this.indicatorStyle.width = this.indicatorWidth + 'px';
    }

    this.x = x;

    if (this.scroller.options.useTransform) {
      this.indicatorStyle[style.transform] = 'translateX(' + x + 'px)' + this.scroller.translateZ;
    } else {
      this.indicatorStyle.left = x + 'px';
    }
  }
};

Indicator.prototype.transitionTime = function () {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  this.indicatorStyle[style.transitionDuration] = time + 'ms';
};

Indicator.prototype.transitionTimingFunction = function (easing) {
  this.indicatorStyle[style.transitionTimingFunction] = easing;
};

Indicator.prototype.destroy = function () {
  this._removeDOMEvents();
  this.wrapper.parentNode.removeChild(this.wrapper);
};

Indicator.prototype._start = function (e) {
  var point = e.touches ? e.touches[0] : e;

  e.preventDefault();
  e.stopPropagation();

  this.transitionTime();

  this.initiated = true;
  this.moved = false;
  this.lastPointX = point.pageX;
  this.lastPointY = point.pageY;

  this.startTime = getNow();

  this._handleMoveEvents(addEvent);
  this.scroller.trigger('beforeScrollStart');
};

Indicator.prototype._move = function (e) {
  var point = e.touches ? e.touches[0] : e;

  e.preventDefault();
  e.stopPropagation();

  if (!this.moved) {
    this.scroller.trigger('scrollStart');
  }

  this.moved = true;

  var deltaX = point.pageX - this.lastPointX;
  this.lastPointX = point.pageX;

  var deltaY = point.pageY - this.lastPointY;
  this.lastPointY = point.pageY;

  var newX = this.x + deltaX;
  var newY = this.y + deltaY;

  this._pos(newX, newY);
};

Indicator.prototype._end = function (e) {
  if (!this.initiated) {
    return;
  }
  this.initiated = false;

  e.preventDefault();
  e.stopPropagation();

  this._handleMoveEvents(removeEvent);

  var snapOption = this.scroller.options.snap;
  if (snapOption) {
    var speed = snapOption.speed,
        _snapOption$easing = snapOption.easing,
        easing = _snapOption$easing === undefined ? ease.bounce : _snapOption$easing;

    var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);

    var time = speed || Math.max(Math.max(Math.min(Math.abs(this.scroller.x - snap.x), 1000), Math.min(Math.abs(this.scroller.y - snap.y), 1000)), 300);

    if (this.scroller.x !== snap.x || this.scroller.y !== snap.y) {
      this.scroller.directionX = 0;
      this.scroller.directionY = 0;
      this.scroller.currentPage = snap;
      this.scroller.scrollTo(snap.x, snap.y, time, easing);
    }
  }

  if (this.moved) {
    this.scroller.trigger('scrollEnd', {
      x: this.scroller.x,
      y: this.scroller.y
    });
  }
};

Indicator.prototype._pos = function (x, y) {
  if (x < 0) {
    x = 0;
  } else if (x > this.maxPosX) {
    x = this.maxPosX;
  }

  if (y < 0) {
    y = 0;
  } else if (y > this.maxPosY) {
    y = this.maxPosY;
  }

  x = Math.round(x / this.sizeRatioX);
  y = Math.round(y / this.sizeRatioY);

  this.scroller.scrollTo(x, y);
  this.scroller.trigger('scroll', {
    x: this.scroller.x,
    y: this.scroller.y
  });
};

Indicator.prototype._shouldShow = function () {
  if (this.direction === 'vertical' && this.scroller.hasVerticalScroll || this.direction === 'horizontal' && this.scroller.hasHorizontalScroll) {
    this.wrapper.style.display = '';
    return true;
  }
  this.wrapper.style.display = 'none';
  return false;
};

Indicator.prototype._calculate = function () {
  if (this.direction === 'vertical') {
    var wrapperHeight = this.wrapper.clientHeight;
    this.indicatorHeight = Math.max(Math.round(wrapperHeight * wrapperHeight / (this.scroller.scrollerHeight || wrapperHeight || 1)), INDICATOR_MIN_LEN);
    this.indicatorStyle.height = this.indicatorHeight + 'px';

    this.maxPosY = wrapperHeight - this.indicatorHeight;

    this.sizeRatioY = this.maxPosY / this.scroller.maxScrollY;
  } else {
    var wrapperWidth = this.wrapper.clientWidth;
    this.indicatorWidth = Math.max(Math.round(wrapperWidth * wrapperWidth / (this.scroller.scrollerWidth || wrapperWidth || 1)), INDICATOR_MIN_LEN);
    this.indicatorStyle.width = this.indicatorWidth + 'px';

    this.maxPosX = wrapperWidth - this.indicatorWidth;

    this.sizeRatioX = this.maxPosX / this.scroller.maxScrollX;
  }
};

Indicator.prototype._addDOMEvents = function () {
  var eventOperation = addEvent;
  this._handleDOMEvents(eventOperation);
};

Indicator.prototype._removeDOMEvents = function () {
  var eventOperation = removeEvent;
  this._handleDOMEvents(eventOperation);
  this._handleMoveEvents(eventOperation);
};

Indicator.prototype._handleMoveEvents = function (eventOperation) {
  if (!this.scroller.options.disableTouch) {
    eventOperation(window, 'touchmove', this);
  }
  if (!this.scroller.options.disableMouse) {
    eventOperation(window, 'mousemove', this);
  }
};

Indicator.prototype._handleDOMEvents = function (eventOperation) {
  if (!this.scroller.options.disableTouch) {
    eventOperation(this.indicator, 'touchstart', this);
    eventOperation(window, 'touchend', this);
  }
  if (!this.scroller.options.disableMouse) {
    eventOperation(this.indicator, 'mousedown', this);
    eventOperation(window, 'mouseup', this);
  }
};

function pullDownMixin(BScroll) {
  BScroll.prototype._initPullDown = function () {
    // must watch scroll in real time
    this.options.probeType = PROBE_REALTIME;
  };

  BScroll.prototype._checkPullDown = function () {
    var _options$pullDownRefr = this.options.pullDownRefresh,
        _options$pullDownRefr2 = _options$pullDownRefr.threshold,
        threshold = _options$pullDownRefr2 === undefined ? 90 : _options$pullDownRefr2,
        _options$pullDownRefr3 = _options$pullDownRefr.stop,
        stop = _options$pullDownRefr3 === undefined ? 40 : _options$pullDownRefr3;

    // check if a real pull down action

    if (this.directionY !== DIRECTION_DOWN || this.y < threshold) {
      return false;
    }

    if (!this.pulling) {
      this.pulling = true;
      this.trigger('pullingDown');
    }
    this.scrollTo(this.x, stop, this.options.bounceTime, ease.bounce);

    return this.pulling;
  };

  BScroll.prototype.finishPullDown = function () {
    this.pulling = false;
    this.resetPosition(this.options.bounceTime, ease.bounce);
  };

  BScroll.prototype.openPullDown = function () {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    this.options.pullDownRefresh = config;
    this._initPullDown();
  };

  BScroll.prototype.closePullDown = function () {
    this.options.pullDownRefresh = false;
  };

  BScroll.prototype.autoPullDownRefresh = function () {
    var _options$pullDownRefr4 = this.options.pullDownRefresh,
        _options$pullDownRefr5 = _options$pullDownRefr4.threshold,
        threshold = _options$pullDownRefr5 === undefined ? 90 : _options$pullDownRefr5,
        _options$pullDownRefr6 = _options$pullDownRefr4.stop,
        stop = _options$pullDownRefr6 === undefined ? 40 : _options$pullDownRefr6;


    if (this.pulling) {
      return;
    }
    this.pulling = true;

    this.scrollTo(this.x, threshold);
    this.trigger('pullingDown');
    this.scrollTo(this.x, stop, this.options.bounceTime, ease.bounce);
  };
}

function pullUpMixin(BScroll) {
  BScroll.prototype._initPullUp = function () {
    // must watch scroll in real time
    this.options.probeType = PROBE_REALTIME;

    this.pullupWatching = false;
    this._watchPullUp();
  };

  BScroll.prototype._watchPullUp = function () {
    if (this.pullupWatching) {
      return;
    }
    this.pullupWatching = true;
    this.on('scroll', this._checkToEnd);
  };

  BScroll.prototype._checkToEnd = function (pos) {
    var _this = this;

    var _options$pullUpLoad$t = this.options.pullUpLoad.threshold,
        threshold = _options$pullUpLoad$t === undefined ? 0 : _options$pullUpLoad$t;

    if (this.movingDirectionY === DIRECTION_UP && pos.y <= this.maxScrollY + threshold) {
      // reset pullupWatching status after scroll end.
      this.once('scrollEnd', function () {
        _this.pullupWatching = false;
      });
      this.trigger('pullingUp');
      this.off('scroll', this._checkToEnd);
    }
  };

  BScroll.prototype.finishPullUp = function () {
    var _this2 = this;

    if (this.pullupWatching) {
      this.once('scrollEnd', function () {
        _this2._watchPullUp();
      });
    } else {
      this._watchPullUp();
    }
  };

  BScroll.prototype.openPullUp = function () {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    this.options.pullUpLoad = config;
    this._initPullUp();
  };

  BScroll.prototype.closePullUp = function () {
    this.options.pullUpLoad = false;
    if (!this.pullupWatching) {
      return;
    }
    this.pullupWatching = false;
    this.off('scroll', this._checkToEnd);
  };
}

function mouseWheelMixin(BScroll) {
  BScroll.prototype._initMouseWheel = function () {
    var _this = this;

    this._handleMouseWheelEvent(addEvent);

    this.on('destroy', function () {
      clearTimeout(_this.mouseWheelTimer);
      clearTimeout(_this.mouseWheelEndTimer);
      _this._handleMouseWheelEvent(removeEvent);
    });

    this.firstWheelOpreation = true;
  };

  BScroll.prototype._handleMouseWheelEvent = function (eventOperation) {
    eventOperation(this.wrapper, 'wheel', this);
    eventOperation(this.wrapper, 'mousewheel', this);
    eventOperation(this.wrapper, 'DOMMouseScroll', this);
  };

  BScroll.prototype._onMouseWheel = function (e) {
    var _this2 = this;

    if (!this.enabled) {
      return;
    }
    e.preventDefault();

    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    if (this.firstWheelOpreation) {
      this.trigger('scrollStart');
    }
    this.firstWheelOpreation = false;

    var _options$mouseWheel = this.options.mouseWheel,
        _options$mouseWheel$s = _options$mouseWheel.speed,
        speed = _options$mouseWheel$s === undefined ? 20 : _options$mouseWheel$s,
        _options$mouseWheel$i = _options$mouseWheel.invert,
        invert = _options$mouseWheel$i === undefined ? false : _options$mouseWheel$i,
        _options$mouseWheel$e = _options$mouseWheel.easeTime,
        easeTime = _options$mouseWheel$e === undefined ? 300 : _options$mouseWheel$e;


    clearTimeout(this.mouseWheelTimer);
    this.mouseWheelTimer = setTimeout(function () {
      if (!_this2.options.snap && !easeTime) {
        _this2.trigger('scrollEnd', {
          x: _this2.x,
          y: _this2.y
        });
      }
      _this2.firstWheelOpreation = true;
    }, 400);

    var wheelDeltaX = void 0;
    var wheelDeltaY = void 0;

    switch (true) {
      case 'deltaX' in e:
        if (e.deltaMode === 1) {
          wheelDeltaX = -e.deltaX * speed;
          wheelDeltaY = -e.deltaY * speed;
        } else {
          wheelDeltaX = -e.deltaX;
          wheelDeltaY = -e.deltaY;
        }
        break;
      case 'wheelDeltaX' in e:
        wheelDeltaX = e.wheelDeltaX / 120 * speed;
        wheelDeltaY = e.wheelDeltaY / 120 * speed;
        break;
      case 'wheelDelta' in e:
        wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * speed;
        break;
      case 'detail' in e:
        wheelDeltaX = wheelDeltaY = -e.detail / 3 * speed;
        break;
      default:
        return;
    }

    var direction = invert ? -1 : 1;
    wheelDeltaX *= direction;
    wheelDeltaY *= direction;

    if (!this.hasVerticalScroll) {
      wheelDeltaX = wheelDeltaY;
      wheelDeltaY = 0;
    }

    var newX = void 0;
    var newY = void 0;
    if (this.options.snap) {
      newX = this.currentPage.pageX;
      newY = this.currentPage.pageY;

      if (wheelDeltaX > 0) {
        newX--;
      } else if (wheelDeltaX < 0) {
        newX++;
      }

      if (wheelDeltaY > 0) {
        newY--;
      } else if (wheelDeltaY < 0) {
        newY++;
      }

      this._goToPage(newX, newY);
      return;
    }

    newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
    newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);

    this.movingDirectionX = this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
    this.movingDirectionY = this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;

    if (newX > this.minScrollX) {
      newX = this.minScrollX;
    } else if (newX < this.maxScrollX) {
      newX = this.maxScrollX;
    }

    if (newY > this.minScrollY) {
      newY = this.minScrollY;
    } else if (newY < this.maxScrollY) {
      newY = this.maxScrollY;
    }

    var needTriggerEnd = this.y === newY;
    this.scrollTo(newX, newY, easeTime, ease.swipe);
    this.trigger('scroll', {
      x: this.x,
      y: this.y
    });
    clearTimeout(this.mouseWheelEndTimer);
    if (needTriggerEnd) {
      this.mouseWheelEndTimer = setTimeout(function () {
        _this2.trigger('scrollEnd', {
          x: _this2.x,
          y: _this2.y
        });
      }, easeTime);
    }
  };
}

function zoomMixin(BScroll) {
  BScroll.prototype._initZoom = function () {
    var _options$zoom = this.options.zoom,
        _options$zoom$start = _options$zoom.start,
        start = _options$zoom$start === undefined ? 1 : _options$zoom$start,
        _options$zoom$min = _options$zoom.min,
        min = _options$zoom$min === undefined ? 1 : _options$zoom$min,
        _options$zoom$max = _options$zoom.max,
        max = _options$zoom$max === undefined ? 4 : _options$zoom$max;

    this.scale = Math.min(Math.max(start, min), max);
    this.setScale(this.scale);
    this.scrollerStyle[style.transformOrigin] = '0 0';
  };

  BScroll.prototype._zoomTo = function (scale, originX, originY, startScale) {
    this.scaled = true;

    var lastScale = scale / (startScale || this.scale);
    this.setScale(scale);

    this.refresh();

    var newX = Math.round(this.startX - (originX - this.relativeX) * (lastScale - 1));
    var newY = Math.round(this.startY - (originY - this.relativeY) * (lastScale - 1));

    if (newX > this.minScrollX) {
      newX = this.minScrollX;
    } else if (newX < this.maxScrollX) {
      newX = this.maxScrollX;
    }

    if (newY > this.minScrollY) {
      newY = this.minScrollY;
    } else if (newY < this.maxScrollY) {
      newY = this.maxScrollY;
    }

    if (this.x !== newX || this.y !== newY) {
      this.scrollTo(newX, newY, this.options.bounceTime);
    }

    this.scaled = false;
  };

  BScroll.prototype.zoomTo = function (scale, x, y) {
    var _offsetToBody = offsetToBody(this.wrapper),
        left = _offsetToBody.left,
        top = _offsetToBody.top;

    var originX = x + left - this.x;
    var originY = y + top - this.y;
    this._zoomTo(scale, originX, originY);
  };

  BScroll.prototype._zoomStart = function (e) {
    var firstFinger = e.touches[0];
    var secondFinger = e.touches[1];
    var deltaX = Math.abs(firstFinger.pageX - secondFinger.pageX);
    var deltaY = Math.abs(firstFinger.pageY - secondFinger.pageY);

    this.startDistance = getDistance(deltaX, deltaY);
    this.startScale = this.scale;

    var _offsetToBody2 = offsetToBody(this.wrapper),
        left = _offsetToBody2.left,
        top = _offsetToBody2.top;

    this.originX = Math.abs(firstFinger.pageX + secondFinger.pageX) / 2 + left - this.x;
    this.originY = Math.abs(firstFinger.pageY + secondFinger.pageY) / 2 + top - this.y;

    this.trigger('zoomStart');
  };

  BScroll.prototype._zoom = function (e) {
    if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
      return;
    }

    if (this.options.preventDefault) {
      e.preventDefault();
    }

    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    var firstFinger = e.touches[0];
    var secondFinger = e.touches[1];
    var deltaX = Math.abs(firstFinger.pageX - secondFinger.pageX);
    var deltaY = Math.abs(firstFinger.pageY - secondFinger.pageY);
    var distance = getDistance(deltaX, deltaY);
    var scale = distance / this.startDistance * this.startScale;

    this.scaled = true;

    var _options$zoom2 = this.options.zoom,
        _options$zoom2$min = _options$zoom2.min,
        min = _options$zoom2$min === undefined ? 1 : _options$zoom2$min,
        _options$zoom2$max = _options$zoom2.max,
        max = _options$zoom2$max === undefined ? 4 : _options$zoom2$max;


    if (scale < min) {
      scale = 0.5 * min * Math.pow(2.0, scale / min);
    } else if (scale > max) {
      scale = 2.0 * max * Math.pow(0.5, max / scale);
    }

    var lastScale = scale / this.startScale;

    var x = this.startX - (this.originX - this.relativeX) * (lastScale - 1);
    var y = this.startY - (this.originY - this.relativeY) * (lastScale - 1);

    this.setScale(scale);

    this.scrollTo(x, y, 0);
  };

  BScroll.prototype._zoomEnd = function (e) {
    if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
      return;
    }

    if (this.options.preventDefault) {
      e.preventDefault();
    }

    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    this.isInTransition = false;
    this.isAnimating = false;
    this.initiated = 0;

    var _options$zoom3 = this.options.zoom,
        _options$zoom3$min = _options$zoom3.min,
        min = _options$zoom3$min === undefined ? 1 : _options$zoom3$min,
        _options$zoom3$max = _options$zoom3.max,
        max = _options$zoom3$max === undefined ? 4 : _options$zoom3$max;


    var scale = this.scale > max ? max : this.scale < min ? min : this.scale;

    this._zoomTo(scale, this.originX, this.originY, this.startScale);

    this.trigger('zoomEnd');
  };
}

// import { ease } from '../util/ease'

// Number of items to instantiate beyond current view in the scroll direction.
var RUNWAY_ITEMS = 30;

// Number of items to instantiate beyond current view in the opposite direction.
var RUNWAY_ITEMS_OPPOSITE = 10;

// The animation interval (in ms) for fading in content from tombstones.
var ANIMATION_DURATION_MS = 200;

// The number of pixels of default additional length to allow scrolling to.
var DEFAULT_SCROLL_RUNWAY = 2000;

function infiniteMixin(BScroll) {
  BScroll.prototype._initInfinite = function () {
    this.options.probeType = 3;
    this.maxScrollY = -DEFAULT_SCROLL_RUNWAY;
    this.infiniteScroller = new InfiniteScroller(this, this.options.infinity);
  };
}

function isTombstoneNode(node) {
  if (node && node.classList) {
    return node.classList.contains('tombstone');
  }
}

function InfiniteScroller(scroller, options) {
  var _this = this;

  this.options = options;
  assert(typeof this.options.createTombstone === 'function', 'Infinite scroll need createTombstone Function to create tombstone');

  assert(typeof this.options.fetch === 'function', 'Infinite scroll need fetch Function to fetch new data.');

  assert(typeof this.options.render === 'function', 'Infinite scroll need render Function to render each item.');

  this.firstAttachedItem = 0;
  this.lastAttachedItem = 0;

  this.anchorScrollTop = 0;
  this.anchorItem = {
    index: 0,
    offset: 0
  };
  this.tombstoneHeight = 0;
  this.tombstoneWidth = 0;
  this.tombstones = [];
  this.tombstonesAnimationHandlers = [];

  this.items = [];
  this.loadedItems = 0;
  this.requestInProgress = false;
  this.hasMore = true;

  this.scroller = scroller;
  this.wrapperEl = this.scroller.wrapper;
  this.scrollerEl = this.scroller.scroller;

  this.scroller.on('resize', function () {
    _this.onResize();
  });
  this.scroller.on('destroy', function () {
    _this.destroy();
  });

  // wait scroll core init
  this._onResizeHandler = setTimeout(function () {
    _this.onResize();

    // must wait tombstoneHeight has size
    _this.scroller.on('scroll', function () {
      _this.onScroll();
    });
  });
}

InfiniteScroller.prototype.destroy = function () {
  var _this2 = this;

  // In extreme scene, destroy is triggered before _onResizeHandler
  clearTimeout(this._onResizeHandler);
  this.tombstonesAnimationHandlers.forEach(function (handler) {
    clearTimeout(handler);
  });
  this.tombstonesAnimationHandlers = null;
  this.items.forEach(function (item) {
    if (item.node) {
      _this2.scrollerEl.removeChild(item.node);
      item.node = null;
    }
  });
  this.scroller.infiniteScroller = null;
  this.scroller = null;
  this.wrapperEl = null;
  this.scrollerEl = null;
  this.items = null;
  this.tombstones = null;
};

InfiniteScroller.prototype.onScroll = function () {
  var scrollTop = -this.scroller.y;
  var delta = scrollTop - this.anchorScrollTop;
  if (scrollTop === 0) {
    this.anchorItem = {
      index: 0,
      offset: 0
    };
  } else {
    this.anchorItem = this._calculateAnchoredItem(this.anchorItem, delta);
  }

  this.anchorScrollTop = scrollTop;
  var lastScreenItem = this._calculateAnchoredItem(this.anchorItem, this.scroller.wrapperHeight);

  var start = this.anchorItem.index;
  var end = lastScreenItem.index;
  if (delta < 0) {
    start -= RUNWAY_ITEMS;
    end += RUNWAY_ITEMS_OPPOSITE;
  } else {
    start -= RUNWAY_ITEMS_OPPOSITE;
    end += RUNWAY_ITEMS;
  }
  this.fill(start, end);
  this.maybeRequestContent();
};

InfiniteScroller.prototype.onResize = function () {
  var tombstone = this.options.createTombstone();
  tombstone.style.position = 'absolute';
  this.scrollerEl.appendChild(tombstone);
  tombstone.style.display = '';
  this.tombstoneHeight = tombstone.offsetHeight;
  this.tombstoneWidth = tombstone.offsetWidth;
  this.scrollerEl.removeChild(tombstone);

  for (var i = 0; i < this.items.length; i++) {
    this.items[i].height = this.items[i].width = 0;
  }

  this.onScroll();
};

InfiniteScroller.prototype.fill = function (start, end) {
  this.firstAttachedItem = Math.max(0, start);
  if (!this.hasMore) {
    end = Math.min(end, this.items.length);
  }
  this.lastAttachedItem = end;
  this.attachContent();
};

InfiniteScroller.prototype.maybeRequestContent = function () {
  var _this3 = this;

  if (this.requestInProgress || !this.hasMore) {
    return;
  }
  var itemsNeeded = this.lastAttachedItem - this.loadedItems;
  if (itemsNeeded <= 0) {
    return;
  }
  this.requestInProgress = true;
  this.options.fetch(itemsNeeded).then(function (items) {
    _this3.requestInProgress = false;
    if (items) {
      _this3.addContent(items);
    } else {
      _this3.hasMore = false;
      var tombstoneLen = _this3._removeTombstones();
      var curPos = 0;
      if (_this3.anchorItem.index <= _this3.items.length) {
        curPos = _this3._fixScrollPosition();
        _this3._setupAnimations({}, curPos);
        _this3.scroller.resetPosition(_this3.scroller.options.bounceTime);
      } else {
        _this3.anchorItem.index -= tombstoneLen;
        curPos = _this3._fixScrollPosition();
        _this3._setupAnimations({}, curPos);
        _this3.scroller.stop();
        _this3.scroller.resetPosition();
        _this3.onScroll();
      }
    }
  });
};

InfiniteScroller.prototype.addContent = function (items) {
  for (var i = 0; i < items.length; i++) {
    if (this.items.length <= this.loadedItems) {
      this._addItem();
    }
    this.items[this.loadedItems++].data = items[i];
  }
  this.attachContent();
  this.maybeRequestContent();
};

InfiniteScroller.prototype.attachContent = function () {
  var unusedNodes = this._collectUnusedNodes();
  var tombstoneAnimations = this._createDOMNodes(unusedNodes);
  this._cleanupUnusedNodes(unusedNodes);
  this._cacheNodeSize();
  var curPos = this._fixScrollPosition();
  this._setupAnimations(tombstoneAnimations, curPos);
};

InfiniteScroller.prototype.resetMore = function () {
  this.hasMore = true;
};

InfiniteScroller.prototype._removeTombstones = function () {
  var markIndex = void 0;
  var tombstoneLen = 0;
  var itemLen = this.items.length;
  for (var i = 0; i < itemLen; i++) {
    var currentNode = this.items[i].node;
    var currentData = this.items[i].data;
    if ((!currentNode || isTombstoneNode(currentNode)) && !currentData) {
      // 0 should be excluded
      if (markIndex === void 0) {
        markIndex = i;
      }
      if (currentNode) {
        this.scrollerEl.removeChild(currentNode);
      }
    }
  }
  tombstoneLen = itemLen - markIndex;
  this.items.splice(markIndex);
  this.lastAttachedItem = Math.min(this.lastAttachedItem, this.items.length);
  return tombstoneLen;
};

InfiniteScroller.prototype._collectUnusedNodes = function () {
  var unusedNodes = [];
  for (var i = 0; i < this.items.length; i++) {
    // Skip the items which should be visible.
    if (i === this.firstAttachedItem) {
      i = this.lastAttachedItem - 1;
      continue;
    }
    var currentNode = this.items[i].node;
    if (currentNode) {
      if (isTombstoneNode(currentNode)) {
        // Cache tombstones for reuse
        this.tombstones.push(currentNode);
        this.tombstones[this.tombstones.length - 1].style.display = 'none';
      } else {
        unusedNodes.push(currentNode);
      }
    }
    this.items[i].node = null;
  }
  return unusedNodes;
};

InfiniteScroller.prototype._createDOMNodes = function (unusedNodes) {
  var tombstoneAnimations = {};
  for (var i = this.firstAttachedItem; i < this.lastAttachedItem; i++) {
    while (this.items.length <= i) {
      this._addItem();
    }
    var currentNode = this.items[i].node;
    var currentData = this.items[i].data;
    if (currentNode) {
      if (isTombstoneNode(currentNode) && currentData) {
        currentNode.style.zIndex = 1;
        tombstoneAnimations[i] = [currentNode, this.items[i].top - this.anchorScrollTop];
        this.items[i].node = null;
      } else {
        continue;
      }
    }
    var node = currentData ? this.options.render(currentData, unusedNodes.pop()) : this._getTombStone();
    node.style.position = 'absolute';
    this.items[i].top = -1;
    this.scrollerEl.appendChild(node);
    this.items[i].node = node;
  }
  return tombstoneAnimations;
};

InfiniteScroller.prototype._cleanupUnusedNodes = function (unusedNodes) {
  while (unusedNodes.length) {
    this.scrollerEl.removeChild(unusedNodes.pop());
  }
};

InfiniteScroller.prototype._cacheNodeSize = function () {
  for (var i = this.firstAttachedItem; i < this.lastAttachedItem; i++) {
    var item = this.items[i];
    // Only cache the height if we have the real contents, not a placeholder.
    if (item.data && !item.height) {
      var isTombstone = isTombstoneNode(item.node);
      item.height = isTombstone ? this.tombstoneHeight : item.node.offsetHeight;
      item.width = isTombstone ? this.tombstoneWidth : item.node.offsetWidth;
    }
  }
};

InfiniteScroller.prototype._fixScrollPosition = function () {
  this.anchorScrollTop = 0;
  for (var _i = 0; _i < this.anchorItem.index; _i++) {
    this.anchorScrollTop += this.items[_i].height || this.tombstoneHeight;
  }
  this.anchorScrollTop += this.anchorItem.offset;

  // Position all nodes.
  var curPos = this.anchorScrollTop - this.anchorItem.offset;
  var i = this.anchorItem.index;
  while (i > this.firstAttachedItem) {
    curPos -= this.items[i - 1].height || this.tombstoneHeight;
    i--;
  }

  return curPos;
};

InfiniteScroller.prototype._setupAnimations = function (tombstoneAnimations, curPos) {
  var _this4 = this;

  for (var i in tombstoneAnimations) {
    var animation = tombstoneAnimations[i];
    this.items[i].node.style[style.transform] = 'translateY(' + (this.anchorScrollTop + animation[1]) + 'px) scale(' + this.tombstoneWidth / this.items[i].width + ', ' + this.tombstoneHeight / this.items[i].height + ')';
    // Call offsetTop on the nodes to be animated to force them to apply current transforms.
    /* eslint-disable no-unused-expressions */
    this.items[i].node.offsetTop;
    animation[0].offsetTop;
    this.items[i].node.style[style.transition] = cssVendor + 'transform ' + ANIMATION_DURATION_MS + 'ms';
  }

  for (var _i2 = this.firstAttachedItem; _i2 < this.lastAttachedItem; _i2++) {
    var _animation = tombstoneAnimations[_i2];
    if (_animation) {
      var tombstoneNode = _animation[0];
      tombstoneNode.style[style.transition] = cssVendor + 'transform ' + ANIMATION_DURATION_MS + 'ms, opacity ' + ANIMATION_DURATION_MS + 'ms';
      tombstoneNode.style[style.transform] = 'translateY(' + curPos + 'px) scale(' + this.items[_i2].width / this.tombstoneWidth + ', ' + this.items[_i2].height / this.tombstoneHeight + ')';
      tombstoneNode.style.opacity = 0;
    }
    if (curPos !== this.items[_i2].top) {
      if (!_animation) {
        this.items[_i2].node.style[style.transition] = '';
      }
      this.items[_i2].node.style[style.transform] = 'translateY(' + curPos + 'px)';
    }
    this.items[_i2].top = curPos;
    curPos += this.items[_i2].height || this.tombstoneHeight;
  }

  this.scroller.maxScrollY = -(curPos - this.scroller.wrapperHeight + (this.hasMore ? DEFAULT_SCROLL_RUNWAY : 0));

  var tombstoneAnimationsHandler = setTimeout(function () {
    for (var _i3 in tombstoneAnimations) {
      var _animation2 = tombstoneAnimations[_i3];
      _animation2[0].style.display = 'none';
      // Tombstone can be recycled now.
      _this4.tombstones.push(_animation2[0]);
    }
  }, ANIMATION_DURATION_MS);

  this.tombstonesAnimationHandlers.push(tombstoneAnimationsHandler);
};

InfiniteScroller.prototype._getTombStone = function () {
  var tombstone = this.tombstones.pop();
  if (tombstone) {
    tombstone.style.display = '';
    tombstone.style.opacity = 1;
    tombstone.style[style.transform] = '';
    tombstone.style[style.transition] = '';
    return tombstone;
  }
  return this.options.createTombstone();
};

InfiniteScroller.prototype._addItem = function () {
  this.items.push({
    data: null,
    node: null,
    height: 0,
    width: 0,
    top: 0
  });
};

InfiniteScroller.prototype._calculateAnchoredItem = function (initialAnchor, delta) {
  if (delta === 0) {
    return initialAnchor;
  }
  var i = initialAnchor.index;
  var tombstones = 0;

  delta += initialAnchor.offset;
  if (delta < 0) {
    while (delta < 0 && i > 0 && this.items[i - 1].height) {
      delta += this.items[i - 1].height;
      i--;
    }
    tombstones = Math.max(-i, Math.ceil(Math.min(delta, 0) / this.tombstoneHeight));
  } else {
    while (delta > 0 && i < this.items.length && this.items[i].height && this.items[i].height < delta) {
      delta -= this.items[i].height;
      i++;
    }
    if (i >= this.items.length || !this.items[i].height) {
      tombstones = Math.floor(Math.max(delta, 0) / this.tombstoneHeight);
    }
  }
  i += tombstones;
  delta -= tombstones * this.tombstoneHeight;

  return {
    index: i,
    offset: delta
  };
};

function BScroll(el, options) {
  this.wrapper = typeof el === 'string' ? document.querySelector(el) : el;
  if (!this.wrapper) {
    warn('Can not resolve the wrapper DOM.');
  }
  this.scroller = this.wrapper.children[0];
  if (!this.scroller) {
    warn('The wrapper need at least one child element to be scroller.');
  }
  // cache style for better performance
  this.scrollerStyle = this.scroller.style;

  this._init(options);
}

initMixin(BScroll);
coreMixin(BScroll);
eventMixin(BScroll);
snapMixin(BScroll);
wheelMixin(BScroll);
scrollbarMixin(BScroll);
pullDownMixin(BScroll);
pullUpMixin(BScroll);
mouseWheelMixin(BScroll);
zoomMixin(BScroll);
infiniteMixin(BScroll);

BScroll.Version = '1.15.2';

/* harmony default export */ __webpack_exports__["a"] = (BScroll);


/***/ }),

/***/ "Gh7F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("Ds5P");
var context = __webpack_require__("kqpo");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("1ETD")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "Gu7T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ "GxLp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/footerNav.vue?vue&type=template&id=2f14c9b4&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.RENMINWANG_TYPE && !_vm.baidu_toufang__footer_shenhe && !_vm.$route.meta.hideFooter)?_c('div',{staticClass:"footerNav",attrs:{"id":"footerNav"}},[_c('ul',{class:_vm.CHANNEL_CHANNELTYPE && _vm.hideBannerAndConsult?'footerNav_for_weizan':''},[_c('v-touch',{class:{'selected':_vm.curPage=='showIndex'},attrs:{"tag":"li"},on:{"tap":function($event){return _vm.toPage('/index', '测评大厅')}}},[_c('i',{staticClass:"index"})]),_vm._v(" "),(!_vm.isHpnk)?_c('v-touch',{class:{'selected':_vm.curPage=='sorts'},attrs:{"tag":"li"},on:{"tap":function($event){return _vm.toPage('/sorts', '全部分类')}}},[_c('i',{staticClass:"sorts"})]):_vm._e(),_vm._v(" "),(!_vm.isHideVipEntrance && !_vm.CHANNEL_NOT_LOGIN)?_c('v-touch',{class:{
            'selected':_vm.curPage=='vip4-user-center' || _vm.curPage=='vip4Detail'
            },attrs:{"tag":"li"},on:{"tap":function($event){return _vm.toPage('HWZX', '会员中心')}}},[_c('i',{staticClass:"vipUserCenter"})]):_vm._e(),_vm._v(" "),(_vm.CHANNEL_CHANNELTYPE && _vm.hideBannerAndConsult)?_c('v-touch',{class:{'selected':_vm.curPage=='consult'},attrs:{"tag":"li"},on:{"tap":function($event){return _vm.toPage('/yxlConsultPage', '心理咨询')}}},[_c('i',{staticClass:"consult"})]):_vm._e(),_vm._v(" "),_c('v-touch',{class:{
                'selected':_vm.curPage=='myTests'||_vm.curPage=='noLoginCenter',
                'is-notlogin': _vm.CHANNEL_NOT_LOGIN
            },attrs:{"tag":"li"},on:{"tap":function($event){return _vm.toPage('/mine/0', '我的测评')}}},[_c('i',{staticClass:"mine"},[(_vm.notCompleteCount.notCompleteConsultCount || _vm.notCompleteCount.notCompleteOrderCount)?_c('i',{staticClass:"icon-dot"}):_vm._e()])])],1)]):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/show/footerNav.vue?vue&type=template&id=2f14c9b4&scoped=true&

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/apis.js
var apis = __webpack_require__("OTud");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/footerNav.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var footerNavvue_type_script_lang_js_ = ({
    name: 'footerNav',
    components: {},
    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['notCompleteCount']), {
        routerPath: function routerPath() {
            return this.$route.path;
        }
    }, Object(vuex_esm["e" /* mapState */])(['channelId'])),
    data: function data() {
        return {
            curPage: 'index',
            showQrcode: false,
            hasUnfinishConsult: false
        };
    },
    mounted: function mounted() {
        this.iconSwitch();
        this.getConsultFormRedDot();
    },

    watch: {
        routerPath: function routerPath() {
            this.iconSwitch();
        },

        userInfo: function userInfo(_userInfo) {
            if (_userInfo.userKey) {
                this.getConsultFormRedDot();
            }
        }
    },
    methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])(['setNotCompleteCount']), {
        getConsultFormRedDot: function getConsultFormRedDot() {
            var _this = this;

            if (!this.userInfo.userKey) return;
            this.$http.get(apis["a" /* default */].notCompleteCount, {
                params: {
                    userKey: this.userInfo.userKey,
                    channelId: this.channelId
                }
            }).then(function (res) {
                if (+res.data.code === 1) {
                    _this.setNotCompleteCount(res.data.data || {});
                }
            });
        },
        iconSwitch: function iconSwitch(routerName) {
            if (!!routerName) {
                this.$data.curPage = routerName;
            } else {
                this.$data.curPage = this.$route.name;
            }
        },
        showQrCode: function showQrCode() {
            event.stopPropagation();
            event.preventDefault();
            this.$data.showQrcode = true;
        },
        hideQrCode: function hideQrCode() {
            this.$data.showQrcode = false;
            event.stopPropagation();
            event.preventDefault();
        },
        toPage: function toPage(routerPath, button_name) {
            this.$wechatTrackEvent('weizhan_cepinghome_menu', {
                button_name: button_name
            });
            // 跳咨询首页
            if (routerPath === '/yxlConsultPage') {
                location.href = 'https://m.xinli001.com/consult/newUserWelfare?channel_flag=ctdl_yxljxwz_zxtab';
                return;
            }
            // 是测评会员：进入测评会员权益页面；
            // 不是测评会员：进入测评会员购买页。
            if (routerPath === 'HWZX') {
                if (this.isCpVip) {
                    routerPath = '/vip4UserCenter';
                } else {
                    routerPath = '/vip4Detail';
                }
            }

            var that = this;
            // 免登陆切换路径
            var newPath = routerPath == '/mine/0' && that.CHANNEL_NOT_LOGIN ? '/noLoginCenter' : routerPath;
            that.iconSwitch(newPath);
            if (that.$route.path == newPath) {
                location.reload();
            } else if (routerPath === '/vip4UserCenter' || routerPath === '/vip4Detail') {
                that.$router.push({
                    path: newPath,
                    query: {
                        channelId: that.channelId,
                        isFooterNav: 1,
                        _source_page_: encodeURIComponent(this.$route.meta && this.$route.meta.title),
                        sourceName: routerPath === '/vip4Detail' ? 'cphomemenuvipcenter' : this.$route.query.sourceName
                    }
                });
            } else {
                that.$router.push({
                    path: newPath,
                    query: {
                        channelId: that.channelId
                    }
                });
            }
        },
        stopScroll: function stopScroll() {
            event.preventDefault();
            event.stopPropagation();
        }
    })
});
// CONCATENATED MODULE: ./src/components/show/footerNav.vue?vue&type=script&lang=js&
 /* harmony default export */ var show_footerNavvue_type_script_lang_js_ = (footerNavvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/show/footerNav.vue?vue&type=style&index=0&id=2f14c9b4&lang=scss&scoped=true&
var footerNavvue_type_style_index_0_id_2f14c9b4_lang_scss_scoped_true_ = __webpack_require__("EGdc");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/show/footerNav.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  show_footerNavvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "2f14c9b4",
  null
  
)

/* harmony default export */ var footerNav = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "H0mh":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),

/***/ "H3q/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "H6qM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_loadingIcon_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("wKKh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_loadingIcon_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_loadingIcon_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_loadingIcon_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "H7zx":
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),

/***/ "H8TF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("8Uqm");
var transformData = __webpack_require__("I5Ms");
var isCancel = __webpack_require__("m4Kp");
var defaults = __webpack_require__("saHn");
var isAbsoluteURL = __webpack_require__("8I3j");
var combineURLs = __webpack_require__("KqU/");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/***/ }),

/***/ "HFx8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var env = location.host.split('.')[0].match(/(qc|box)\d?/g);
var spell = !!env ? env.length > 0 ? '-' + env[0] : '' : '';
var WXDOMAIN = '//wx' + spell + '.xinli001.com/',
    LXDOMAIN = spell ? '//lingxi' + spell + '.xinli001.com/lingxi/service/' : '//m-lingxi' + spell + '.xinli001.com/lingxi/service/',
    YIAPI = '//yiapi' + spell + '.xinli001.com/v5/yi/',
    APIS = {
  // 免登+先测试后付费（for微博） 
  doFirstAfterBuyCreateOrder: LXDOMAIN + 'notLogin/doFirstAfterBuy/createOrder', // 免登+先测试后付费（for微博） 创建订单
  weiboAuth: LXDOMAIN + 'notLogin/weiboAuth?from=wb' // 微博授权接口
};

/* harmony default export */ __webpack_exports__["a"] = (APIS);

/***/ }),

/***/ "HQe3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("rbJr");

/***/ }),

/***/ "HXil":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HhN8":
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ "Hhm4":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__("bUqO"), 'Object', { defineProperties: __webpack_require__("twxM") });


/***/ }),

/***/ "Hl+4":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', { sign: __webpack_require__("cwmK") });


/***/ }),

/***/ "I+pO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("wI4N");
var settle = __webpack_require__("Cmhu");
var cookies = __webpack_require__("Y/LA");
var buildURL = __webpack_require__("PgLq");
var buildFullPath = __webpack_require__("oHjS");
var parseHeaders = __webpack_require__("P8ML");
var isURLSameOrigin = __webpack_require__("6PNh");
var createError = __webpack_require__("33LG");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "I0MY":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__("rxKx")) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),

/***/ "I5Ms":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("8Uqm");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

/***/ }),

/***/ "I6yJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/frontend-lib/tools/getPlatform.js
var getPlatform = __webpack_require__("hTeI");
var getPlatform_default = /*#__PURE__*/__webpack_require__.n(getPlatform);

// EXTERNAL MODULE: ./src/frontend-lib/tools/utils.js + 1 modules
var utils = __webpack_require__("Zt1H");

// EXTERNAL MODULE: ./src/apis.js
var apis = __webpack_require__("OTud");

// EXTERNAL MODULE: ./src/frontend-lib/lib/stat/Stat.js + 3 modules
var Stat = __webpack_require__("Eqnl");

// CONCATENATED MODULE: ./src/lib/fragment.js
function fragment_getNewData(date, type, inShow) {
    if (type == 1) {
        //中文时间显示
        var time = new Date(date);
        var getFullYear = time.getFullYear();
        var getMonth = time.getMonth() < 9 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
        var getDate = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
        var getHours = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
        var getMinutes = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
        var getSeconds = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
        if (inShow == 'getMinutes') {
            return getFullYear + '\u5E74' + getMonth + '\u6708' + getDate + '\u65E5' + getHours + ':' + getMinutes;
        }
        return getFullYear + '\u5E74' + getMonth + '\u6708' + getDate + '\u65E5' + getHours + ':' + getMinutes + ':' + getSeconds;
    }
}

function fragment_timeTransform(time, type) {
    var myTime = new Date(time);
    if (type == 'day') {
        return myTime.getFullYear() + '\u5E74' + (myTime.getMonth() + 1) + '\u6708' + myTime.getDate() + '\u65E5';
    }
    return myTime.getFullYear() + '\u5E74' + (myTime.getMonth() + 1) + '\u6708' + myTime.getDate() + '\u65E5' + myTime.getHours() + ':' + myTime.getMinutes() + ':' + myTime.getSeconds();
}

function fragment_getColorType(type) {
    var colorS = [{
        bg: '#528FCC',
        graph_bg: '#006ED9',
        text_bg: '#528FCC'
    }, {
        bg: '#7852CC',
        graph_bg: '#4900E8',
        text_bg: '#7852CC'
    }, {
        bg: '#C052CC',
        graph_bg: '#B52DC4',
        text_bg: '#C052CC'
    }, {
        bg: '#E65C5C',
        graph_bg: '#B83232',
        text_bg: '#E65C5C'
    }, {
        bg: '#CC8672',
        graph_bg: '#FFA78F',
        text_bg: '#CC8672'
    }, {
        bg: '#E67129',
        graph_bg: '#FFA200',
        text_bg: '#C78800'
    }, {
        bg: '#E6C35C',
        graph_bg: '#FFC500',
        text_bg: '#FFDD2B'
    }];
    return colorS[type];
}



/* harmony default export */ var fragment = ({
    getNewData: fragment_getNewData,
    timeTransform: fragment_timeTransform,
    getColorType: fragment_getColorType
});
// EXTERNAL MODULE: ./src/assets/img-mbti-random1.jpg
var img_mbti_random1 = __webpack_require__("qBN+");
var img_mbti_random1_default = /*#__PURE__*/__webpack_require__.n(img_mbti_random1);

// EXTERNAL MODULE: ./src/assets/img-mbti-random2.jpg
var img_mbti_random2 = __webpack_require__("Wck+");
var img_mbti_random2_default = /*#__PURE__*/__webpack_require__.n(img_mbti_random2);

// CONCATENATED MODULE: ./src/mixins/globalMixin.js







// @cyc   加入了stream取消监听的管理










/* harmony default export */ var globalMixin = __webpack_exports__["a"] = ({
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])(['setChannelId', 'setLOADING', 'setLOADINGTEXT', 'setTOASTTEXT', 'setGLOBALLOCK', 'setVip', 'setYxyid', 'setVipInfo', 'setShowPopWindowStatus', 'setAdvertisingConfig', 'setAdvertisingPlatform', 'setWeappUrlScheme']), Object(vuex_esm["b" /* mapActions */])(['getChannelMsg', 'pullUserInfo', 'getUserKeyFromPlatfrom', 'getWechatData', 'receiveCoupon', 'fetchVipinfo', 'fecthVipPopWindow', 'fecthVipGetUrl', 'fetchAdsense', 'getAdvertisingCepingConfig', 'fetchAdvertisingPlatform', 'getMiniappScheme']), {
    shouquan: function shouquan() {
      // localStorage.setItem('yxlMicroSite', this.$route.path);
      window.location.href = apis["a" /* default */].shouquan + '?callback=' + encodeURIComponent('' + location.origin + location.pathname + '?channelId=' + this.channelId);
    },
    toTop: function toTop() {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = document.body.scrollTop = 0; //进入置顶
    },
    getScrollBottom: function getScrollBottom() {
      return document.body.scrollHeight - window.screen.availHeight - document.body.scrollTop;
    },
    getUserInfo: function getUserInfo(channelId) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var that, userKey, needAuth, userId, params;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                userKey = that.$route.query.userKey && that.$route.query.userKey !== 'null' ? that.$route.query.userKey : undefined;
                needAuth = that.$route.path == '/index' ? 1 : undefined;
                userId = that.$route.query.userId;

                if (!userId) {
                  _context.next = 9;
                  break;
                }

                needAuth = 1;
                _context.next = 8;
                return _this.getUserKeyFromPlatfrom({ userId: userId });

              case 8:
                userKey = _context.sent;

              case 9:
                params = {
                  channelId: channelId,
                  needAuth: needAuth,
                  sessionKey: that.isWxApp ? that.wxMiniAppSessionKey : undefined,
                  appCode: that.isWxApp ? 16 : undefined,
                  userKey: userKey,
                  yxyid: that.yxyid ? that.yxyid : undefined
                };
                return _context.abrupt('return', that.pullUserInfo({
                  params: params
                }).then(function (res) {
                  console.info('--- 获取用户信息成功 res.data ---', res.data);
                  if (_this.isActivity20201111) {
                    window.monitor.stat({
                      level: 'info',
                      error: 'API',
                      msg: '\u67E5\u8BE2\u7528\u6237\u4FE1\u606F',
                      remark: '2020双十一活动用户信息查询',
                      href: location.href,
                      data: stringify_default()(res.data),
                      params: stringify_default()(params),
                      userKey: that.userInfo.userKey,
                      userName: that.userInfo.nickname
                    });
                  }
                  if (that.$route.path == '/index' && res.data.code != 302) {
                    that.showPromotion(); //重定向后添加拦截窗口
                  }
                  that.$emit('updateUserInfo', res.data);
                  return res;
                }));

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getVipInfo: function getVipInfo(channelId, userKey) {
      //头条快手App不需要vip业务
      var isFecthVip = this.RENMINWANG_TYPE || this.TOUTIAOAPP || this.WEIBO_NOTLOGIN || this.isActivity20201111 || this.KUAISHOU_APP;
      if (isFecthVip) {
        return;
      }
      var that = this;
      var params = {
        channelId: channelId,
        userKey: this.userInfo.userKey || this.$route.query.userKey || userKey
      };
      if (that.$route.name === 'testDetail') {
        params.scalePoolId = that.$route.params.testId;
        return;
      }
      return that.fetchVipinfo({
        params: params
      }).then(function (res) {
        return res;
      });
    },
    initAdCoupon: function initAdCoupon(pageName) {
      // 弹窗浮标只在微信浏览器内使用, 并兼容投放渠道（类型 8）
      if (!this.$platform.isWechat || !(this.channelConfig.channelType && [1, 2, 8].includes(+this.channelConfig.channelType))) {
        return;
      }
      var that = this;
      // console.log('--- 请求弹窗浮标的页面名称 ---', pageName)
      // 1-首页，2-测评报告页，3-趣味测试结果页
      var pages = {
        'showIndex': 1,
        'report2': 2,
        'newReport': 2,
        'topReport': 2,
        'fun-result': 3
      };
      var position = pages[pageName];
      // 投放渠道 1-是报告页
      if (this.channelConfig.channelType == 8) {
        position = 1;
      }
      var params = {
        channelId: this.channelId,
        position: position
      };
      this.fetchAdsense({
        params: params
      }).then(function (res) {
        // console.log('--- fetchAdsense 获取的数据 ---', res.data)
        if (res.data && res.data.length) {
          // showPopWindowStatus 是给会员用的，如果报告页有弹窗也强制开启
          if (pageName != 'showIndex') {
            that.setShowPopWindowStatus(true);
          }
        }
      });
    },
    getNewData: function getNewData(date, type, inShow) {
      return fragment_getNewData(date, type, inShow);
    },
    timeTransform: function timeTransform(time, type) {
      return fragment_timeTransform(time, type);
    },
    getColorType: function getColorType(type) {
      return fragment_getColorType(type);
    },
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    getCoupon: function getCoupon(type, getParams) {
      var _this2 = this;

      return new promise_default.a(function (resolve, reject) {
        var params = {
          channelId: _this2.channelId,
          displayPlace: type,
          sourceName: _this2.$route.query.sourceName ? _this2.$route.query.sourceName : ''
        };
        if (getParams) {
          params = assign_default()(params, getParams);
        }
        _this2.receiveCoupon({
          params: params
        }).then(function (res) {
          resolve(res);
        });
      });
    },
    initOtherApp: function initOtherApp() {
      var that = this;
      //在app端接入页面支付完后回调
      var ua = navigator.userAgent;
      var goAppList = [{
        ua: /(?:PregnancyHelper)/.test(ua),
        apphref: '//app.mama.cn/soft_link/pt',
        channelId: 2049
      }, {
        ua: /(?:wkcqyixinli)/.test(ua),
        apphref: 'wkcqAppScheme://',
        channelId: 2076
      }, {
        ua: false,
        apphref: 'IDreamSleep://',
        channelId: 2129
      }];
      var goApp = goAppList.map(function (item, index) {
        if (that.channelId == item.channelId) {
          return item;
        }
      }).filter(function (one) {
        return !!one;
      });

      if (goApp[0]) {
        if (Object(utils["a" /* GetQueryString */])('payDone') && that.channelId == goApp[0].channelId && !goApp[0].ua && !that.platform.isWechat) {
          if (+this.channelId === 2129) {
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) && /^((?!chrome|android).)*safari/i.test(ua) && !sessionStorage.getItem('isIdream')) {
              location.href = goApp[0].apphref;
            }
            return;
          }
          location.href = goApp[0].apphref;
        }
      }
    },
    getVipPopWindow: function getVipPopWindow(type) {
      console.log('关闭双十二活动接口vipPopWindow弹窗接口');
    },
    getVipGetUrl: function getVipGetUrl(getParams) {
      var params = assign_default()({
        channelId: this.channelId
      }, getParams);
      // 参数 source   1活动首页  2领取红包页 3分销页
      // 参数 channelId
      var that = this;
      var host = location.host;
      if (this.JUMHOST) {
        this.fecthVipGetUrl({
          params: params
        }).then(function (res) {
          // console.log(res)
        });
      }
    },
    goIntoActivty: function goIntoActivty(type) {
      if (this.HOSTC) {
        location.href = location.protocol + '//' + apis["a" /* default */].shareHostC + location.pathname + location.search + '#/vipDetail?channelId=' + this.channelId + '&enterFrom=' + type;
      } else {
        location.href = location.protocol + '//' + apis["a" /* default */].host + location.pathname + location.search + '#/vipDetail?channelId=' + this.channelId + '&enterFrom=' + type;
      }
    },

    //跳转新品活动链接
    goIntoDialog: function goIntoDialog(type, config) {
      // 内部渠道
      if (this.CHANNEL_INTERNALCHANNEL) {
        if (type === 'report') {
          this.$router.push({
            name: 'myTests',
            params: { status: 0 },
            query: { channelId: this.channelId }
          });
          return;
        }
      }
      var statText = '微站专业测评报告页弹窗';
      if (type == 'logo') {
        statText = '微站浮标';
      } else if (type == 'showIndex') {
        statText = '微站弹窗';
      }
      this.$stat.send({
        name: '公共-交互行为',
        properties: {
          '对象': statText,
          '被点击的元素文字': config.title
        }
      });
      var href = config.link;
      // 替换后台设置的渠道 id
      if (href.includes('${channelId}')) {
        href = href.replace('${channelId}', this.channelId);
      }
      var id = setTimeout(function () {
        clearTimeout(id);
        // console.log('--- 跳转的 href ---', href)
        location.href = href;
      }, 350);
    },

    // 投放事件日志
    toufangStat: function toufangStat(behavior) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var userId = this.userInfo && this.userInfo.userId || '';
      var channelId = this.channelId;
      window.monitor.stat({
        logType: 'stat',
        title: '测评投放-行为日志',
        message: stringify_default()(extends_default()({
          toufangId: channelId,
          channelName: this.CHANNEL_CHANNELNAME,
          behavior: behavior,
          userId: userId
        }, message)),
        testTitle: '常规',
        url: location.href,
        userId: userId,
        UA: navigator.userAgent
      });
    },

    // 特殊测评类型的投放日志
    toufangStatV1: function toufangStatV1(params) {
      var userId = this.userInfo && this.userInfo.userId || '';
      var channelId = this.channelId;
      window.monitor.stat({
        logType: 'stat',
        title: '测评投放-行为日志',
        message: stringify_default()(extends_default()({
          toufangId: channelId,
          channelName: this.CHANNEL_CHANNELNAME,
          behavior: params.behavior,
          userId: userId
        }, params.message)),
        testTitle: params.testTitle,
        url: location.href,
        userId: userId,
        UA: navigator.userAgent
      });
    },
    isHighPrice360: function isHighPrice360(scalePoolId) {
      return [543, 547, 550, 557].includes(+scalePoolId);
    },


    // 获取先测试后付费测试配置
    getAdvertisingConfig: function getAdvertisingConfig(scalePoolId) {
      var _this3 = this;

      if (!this.CHANNEL_NOT_LOGIN) {
        return new promise_default.a(function (resolve) {
          resolve();
        });
      }
      if (!scalePoolId) {
        scalePoolId = this.$route.params.testId || (this.scaleModulesMsg ? this.scaleModulesMsg.scalePoolId : this.$route.query.scalePoolId);
      }
      var params = {
        channelId: this.channelId,
        scalePoolId: scalePoolId,
        userKey: this.userKey,
        orderNo: this.$route.query.orderNo
      };
      return this.getAdvertisingCepingConfig({
        params: params
      }).then(function (res) {
        if (res.code === '1') {
          _this3.setAdvertisingConfig(res.data);
        } else {
          _this3.setAdvertisingConfig('');
        }
      });
    },


    // 获取投放平台
    getAdvertisingPlatform: function getAdvertisingPlatform() {
      var _this4 = this;

      if (!this.CHANNEL_NOT_LOGIN) return;
      return this.fetchAdvertisingPlatform({
        params: {
          channelId: this.channelId
        }
      }).then(function (res) {
        if (res.code === '1') {
          _this4.setAdvertisingPlatform(res.data);
        }
      });
    },
    unlouckToGoDetial: function unlouckToGoDetial() {
      if (this.isIQTest) {
        this.$router.replace({
          name: 'testDetailIQ',
          query: this.$route.query
        });
        return;
      }
      this.$router.replace({
        name: 'testDetail',
        params: {
          testId: this.$route.query.scalePoolId
        },
        query: this.$route.query
      });
    },
    fetchTfMiniConfig: function fetchTfMiniConfig() {
      return this.$http.get(apis["a" /* default */].getConfigureByCode, {
        params: {
          configureCode: 'ceping-toufang-mini-config'
        }
      }).then(function (res) {
        var content = JSON.parse(res.data.data.content);
        // let isMiniProgramWorking = content.isMiniProgramWorking
        return content;
      });
    },
    toWeapp: function toWeapp() {
      var _this5 = this;

      this.toufangStat('点击去关注公众号', { testId: this.$route.query.scalePoolId });
      return new promise_default.a(function (resolve, reject) {
        // 利用小程序跳转导致小程序被封，改成直接显示二维码图片
        // this.showCodeDialog = true
        // reject()
        // return

        // qrcodePicture 公众号或企微二维码。不存在时停留在h5页面兜底
        if (!_this5.advertisingConfig || !_this5.advertisingConfig.qrcodePicture) {
          _this5.showCodeDialog = true;
          reject();
          return;
        }
        if (_this5.weappUrlScheme) {
          location.href = _this5.weappUrlScheme;
          resolve();
          return;
        }

        _this5.fetchTfMiniConfig().then(function (res) {
          // 配置导流小程序
          if (res.isMiniProgramWorking) {
            var config = _this5.advertisingConfig;
            var url = '' + location.origin + location.pathname + '#/wechat-app-qrcode?channelId=' + _this5.channelId + '&payRedirectType=' + config.payRedirectType + '&tfWechatAppQrocde=' + config.qrcodePicture;
            var query = 'companyWechatUrl=' + encodeURIComponent(url);
            // 导企业微信路径
            if (config.payRedirectType == 3) {
              if (window.monitor) {
                window.monitor.stat({
                  logType: 'stat',
                  title: '测评投放-导流小程序',
                  message: stringify_default()({
                    behavior: '进入企业微信的流程'
                  }),
                  url: location.href,
                  UA: navigator.userAgent
                });
              }
            } else {
              if (window.monitor) {
                window.monitor.stat({
                  logType: 'stat',
                  title: '测评投放-导流小程序',
                  message: stringify_default()({
                    behavior: '进入公众号的流程'
                  }),
                  url: location.href,
                  UA: navigator.userAgent
                });
              }
            }
            _this5.getMiniappScheme({
              params: {
                path: 'pages/attention/attention',
                query: query
              }
            }).then(function (res) {
              if (res.code === '1' && res.data) {
                _this5.setWeappUrlScheme(res.data);
                location.href = res.data;
                resolve();
              } else {
                if (window.monitor) {
                  window.monitor.stat({
                    logType: 'stat',
                    title: '测评投放-导流小程序',
                    message: stringify_default()(extends_default()({
                      behavior: '获取小程序地址接口code异常',
                      '投放路径': config.payRedirectType == 3 ? '企业微信' : '公众号'
                    }, res)),
                    url: location.href,
                    UA: navigator.userAgent
                  });
                }
                _this5.showCodeDialog = true;
                reject();
              }
            }).catch(function (err) {
              if (window.monitor) {
                window.monitor.stat({
                  logType: 'stat',
                  title: '测评投放-导流小程序',
                  message: stringify_default()({
                    behavior: '获取小程序地址接口失败',
                    '投放路径': config.payRedirectType == 3 ? '企业微信' : '公众号'
                  }),
                  url: location.href,
                  UA: navigator.userAgent
                });
              }
            });
          } else {
            _this5.showCodeDialog = true;
            reject();
          }
        }).catch(function (err) {
          _this5.showCodeDialog = true;
          reject();
        });
      });
    },


    // 神策埋点 微站都要 渠道id 和 渠道name
    $wechatTrackPageView: function $wechatTrackPageView(name) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.platform.isWechat) {
        this.$trackPageView(name, extends_default()({
          test_channel_id: this.channelId,
          test_channel_name: this.channelConfig.name ? this.channelConfig.name : '未获取到渠道信息'
        }, properties));
      }
    },
    $wechatTrackEvent: function $wechatTrackEvent(name) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.platform.isWechat) {
        this.$trackEvent(name, extends_default()({
          test_channel_id: this.channelId,
          test_channel_name: this.channelConfig.name ? this.channelConfig.name : '未获取到渠道信息'
        }, properties));
      }
    },

    // 神策埋点 isApp
    $appTrackPageView: function $appTrackPageView(name, properties) {
      if (this.isApp) {
        // this.setTOASTTEXT(`APP 神策页面访问-调试-参数: ${JSON.stringify(properties)}`)
        this.$trackPageView(name, properties);
      }
    },
    $appTrackEvent: function $appTrackEvent(name, properties) {
      if (this.isApp) {
        // this.setTOASTTEXT(`APP 神策点击事件-调试-参数: ${JSON.stringify(properties)}`)
        this.$trackEvent(name, properties);
      }
    },


    // 神策埋点 渠道来源
    getChannelSource: function getChannelSource() {
      var r = '';
      if (this.WEIBO_NOTLOGIN) {
        r = '测投';
      } else if (this.platform.isWechat) {
        r = '微站';
      }
      return r;
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['channelId', 'channelConfig', 'wxConfig', 'yxyid', 'userInfo', 'vipInfo']), Object(vuex_esm["c" /* mapGetters */])(['CHANNEL_CHANNELNAME', 'CHANNEL_INTERNALCHANNEL', 'CHANNEL_CHANNELTYPE', 'CHANNEL_NOT_LOGIN', 'isVip', 'advertisingConfig', 'advertisingPlatform', 'timingData', 'weappUrlScheme']), {
    $stat: function $stat() {
      var fakeStat = {
        send: function send(params) {
          return '';
        }
      };
      if (this.channelConfig && this.channelConfig.channelType && this.channelConfig.channelType == 8) {
        return fakeStat;
      } else {
        return new Stat["a" /* default */]();
      }
    },
    platform: function platform() {
      return Object(getPlatform["getPlatform"])();
    },
    $platform: function $platform() {
      return this.platform;
    },
    $runningEnv: function $runningEnv() {
      return Object(getPlatform["getRunningEnv"])();
    },
    isApp: function isApp() {
      var _$platform = this.$platform,
          isYixinliApp = _$platform.isYixinliApp,
          isCeShiApp = _$platform.isCeShiApp;

      return isYixinliApp || isCeShiApp;
    },
    userKey: function userKey() {
      return this.$route.query.userKey && this.$route.query.userKey !== 'null' ? this.$route.query.userKey : this.userInfo.userKey ? this.userInfo.userKey : '';
    },


    // 是否是测评VIP 0=禁止，1=正常，2=过期
    isCpVip: function isCpVip() {
      return this.vipInfo.status === 1;
    },


    // 是否是新vip
    isNewVip: function isNewVip() {
      return this.isCpVip && !this.isOldVip;
    },


    // 是否是老vip
    isOldVip: function isOldVip() {
      return [0, 1, 2, 3, 4].includes(this.vipInfo.vipIdentity) && this.vipInfo.status === 1;
    },


    // 报告页下载报告为图片按钮显隐
    reportDownloadVisible: function reportDownloadVisible() {
      // return ((this.isNewVip || this.vipInfo.status === 2 || !this.vipInfo.status) && !this.isHideVipEntrance) || this.isHpnk
      // 3.0会员及以上才有下载报告权益
      return this.isCpVip && this.vipInfo.vipIdentity >= 3 && !this.isHideVipEntrance || this.isHpnk;
    },
    CHANNELNAME: function CHANNELNAME() {
      return this.CHANNEL_CHANNELNAME;
    },
    TESTCHANNEL: function TESTCHANNEL() {
      // 小楼老师心理课的vip通道下掉
      if (!this.vipInfo.vipChannelStatus) {
        return false;
      }
      var exChannel = [170, 2437, 3583];
      return !exChannel.includes(this.channelId);
    },
    ACTIVTYSHARE: function ACTIVTYSHARE() {
      return false;
    },
    ACTIVTYSCOUPON: function ACTIVTYSCOUPON() {
      return false;
    },
    JUMHOST: function JUMHOST() {
      var that = this;
      var host = location.host;
      console.log('跳转域名');
      if (this.HOSTC) {
        return false;
      }
      if (host.indexOf('static' + apis["a" /* default */].env + '.xinli001.com') > -1 && apis["a" /* default */].env == '-qc5') {
        return true;
      }
      if (host.indexOf('cp' + apis["a" /* default */].env + '.japgb7.top') > -1) {
        return true;
      } else {
        return false;
      }
    },
    _setshowProps: function _setshowProps() {
      if (this.$route.name == 'showIndex' || this.$route.name == 'myTests' || this.$route.name == 'sorts' || this.$route.name == 'testDetail') {
        var beginData = new Date('2020/06/25 00:00').getTime();
        var newData = new Date().getTime();
        return parseInt(newData) > parseInt(beginData);
      }
      return false;
    },
    ACTIVTYSLASTYPE: function ACTIVTYSLASTYPE() {
      return 0;
    },
    HOSTC: function HOSTC() {
      var host = location.host;
      return host.indexOf('hd' + apis["a" /* default */].env + '.xinli001.site') > -1;
    },
    HIDDEN_DETAILS: function HIDDEN_DETAILS() {
      return this.channelId == 2218 && this.$route.name == 'testDetail';
    },
    baidu_toufang_shenhe: function baidu_toufang_shenhe() {
      return this.channelId == 3064 && this.$route.name == 'toufangDetail';
    },
    baidu_toufang__footer_shenhe: function baidu_toufang__footer_shenhe() {
      return this.channelId == 3064 && this.$route.name == 'noLoginCenter';
    },
    HIDDEN_DETAILS_PRICE: function HIDDEN_DETAILS_PRICE() {
      var arr = [2259, 2225, 2220, 2129, 2115, 1484, 1777];
      return arr.includes(this.channelId);
    },
    RENMINWANG_TYPE: function RENMINWANG_TYPE() {
      return this.channelId == 2278 || this.channelId == 2310;
    },
    CLOSED_RECOMMON: function CLOSED_RECOMMON() {
      if (this.channelId == 2325 || this.RENMINWANG_TYPE) {
        return true;
      } else {
        return false;
      }
    },
    KUAISHOU_APP: function KUAISHOU_APP() {
      return [2939, 3268].includes(Number(this.channelId));
    },

    //头条小程序
    TOUTIAOAPP: function TOUTIAOAPP() {
      return [2345, 2293, 2545].includes(Number(this.channelId));
    },
    TOUTIAOAPP_IOS: function TOUTIAOAPP_IOS() {
      var query = this.$route.query;
      if ([2345, 2545].includes(Number(this.channelId))) {
        return true;
      } else if (this.channelId == 2293) {
        if (query.isNew && query.isNew == 1) {
          return true;
        } else if (query.fromAd && query.fromAd == 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    notLoginToCikeChannelData: function notLoginToCikeChannelData() {
      var judgeMap = {
        3063: [810],
        3064: [810],
        3097: [810]
      };
      return judgeMap;
    },
    isNotLoginToCike: function isNotLoginToCike() {
      var r = false;
      var specifiedScalePoolId = {
        3063: [810],
        3064: [810]
      };
      var notLoginChannelId = [2819, 2352, 2335, 2129, 2611, 2620, 2621, 2378, 2379, 2644, 2553, 2296];
      var isSpecifiedId = this.scalePoolId && specifiedScalePoolId[+this.channelId] && specifiedScalePoolId[+this.channelId].includes(+this.scalePoolId);
      var isNotLoginChannel = notLoginChannelId.includes(+this.channelId);
      // || this.isTfWechat 暂时不导此刻
      // if (isSpecifiedId || isNotLoginChannel) {
      if (isSpecifiedId || isNotLoginChannel || this.isTfGuideCk) {
        r = true;
      }
      return r;
    },
    afterTestPayChannldData: function afterTestPayChannldData() {
      var judgeMap = {
        2493: [608, 609, 613],
        2685: [608, 613, 541, 795, 801, 803, 820],
        3026: [613, 541, 795, 608, 801, 803],
        3027: [353, 795, 801, 803, 820],
        3029: [795, 801, 803],
        3030: [795, 801, 803, 806],
        3031: [795, 801, 803, 806],
        3032: [795, 801, 803, 806],
        3051: [801, 803],
        3052: [801, 803, 806],
        3063: [806, 810, 814],
        3064: [806, 810],
        3072: [806],
        3071: [806],
        3070: [806],
        3078: [806],
        3082: [806],
        3073: [806],
        3074: [806],
        3083: [806],
        3084: [806],
        3085: [806],
        3086: [806],
        3097: [353, 806, 810],
        3100: [806],
        3098: [806],
        3099: [806],
        3132: [806, 820]
      };
      return judgeMap;
    },

    //先测试后付费渠道和测试id集合
    isAfterTestPay: function isAfterTestPay() {
      var judgeMap = this.afterTestPayChannldData;
      var scalePoolId = this.scalePoolId || this.$route.query.scalePoolId;
      return this.scalePoolId && judgeMap[this.channelId] && judgeMap[this.channelId].includes(+scalePoolId) || !!this.advertisingConfig;
    },
    afterTestPayChannld: function afterTestPayChannld() {
      var channelIds = keys_default()(this.afterTestPayChannldData).map(function (item) {
        return Number(item);
      }).filter(function (one) {
        return !!one;
      });
      return channelIds;
    },

    // 微博免登、哔哩哔哩、知乎免登录等等免登陆渠道汇总 并不只是微博免登陆
    WEIBO_NOTLOGIN: function WEIBO_NOTLOGIN() {
      return keys_default()(this.afterTestPayChannldData).includes(String(this.channelId)) || !!this.advertisingConfig;
    },

    // 是否是哔哩哔哩渠道
    isBilibili: function isBilibili() {
      return [2685, 3026, 3029, 3030, 3031, 3032, 3070].includes(+this.channelId);
    },
    isZhihu: function isZhihu() {
      //知乎投放渠道
      return [3027, 3051, 3052, 3082].includes(+this.channelId);
    },
    isBaidu: function isBaidu() {
      // 添加百度投放渠道
      return [3072, 3064, 3078].includes(+this.channelId);
    },

    // 抖音头条
    isDouyinTouTiao: function isDouyinTouTiao() {
      return [3073, 3074, 3085, 3086].includes(+this.channelId);
    },

    // WPS
    isWps: function isWps() {
      return [3097, 3100].includes(+this.channelId);
    },

    // 喜马拉雅
    isXimalaya: function isXimalaya() {
      return [3098, 3099].includes(+this.channelId);
    },
    isKuaishou: function isKuaishou() {
      return [3083, 3084].includes(+this.channelId);
    },
    isKuaikan: function isKuaikan() {
      return [3251].includes(+this.channelId);
    },


    // 唯爱妈妈
    isVimm: function isVimm() {
      return [3295].includes(+this.channelId);
    },


    // 唯品会
    isVph: function isVph() {
      return [3081].includes(+this.channelId);
    },


    // 是否是B端
    isToB: function isToB() {
      return this.channelConfig && [13, 14, 15, 17].includes(+this.channelConfig.channelType);
    },


    // 飞书
    isFeiShu: function isFeiShu() {
      return [3321].includes(+this.channelId);
    },
    isWoniu: function isWoniu() {
      return [2129].includes(+this.channelId);
    },


    // 麦田心灵
    isMtxl: function isMtxl() {
      return [3583].includes(+this.channelId);
    },
    isCkxl: function isCkxl() {
      return [3593].includes(+this.channelId);
    },


    // 腾讯成长守护平台
    isTxcz: function isTxcz() {
      return [3747].includes(+this.channelId);
    },


    // 测评推广渠道
    isCptg: function isCptg() {
      return [3823].includes(+this.channelId);
    },


    // 此刻心理趣味测试
    isCkxlqwcs: function isCkxlqwcs() {
      return [3925].includes(+this.channelId);
    },


    // 华为日历
    isHwrl: function isHwrl() {
      return [3803].includes(+this.channelId);
    },


    // 浙江健康导航
    isZjjk: function isZjjk() {
      return [4280].includes(+this.channelId);
    },


    // 海普诺凯
    isHpnk: function isHpnk() {
      return [4411].includes(+this.channelId);
    },

    // 测评小程序渠道
    isCpWxapp: function isCpWxapp() {
      return this.isMiniapp || [4297].includes(+this.channelId);
    },

    // 是否是视频号
    isSHIPINHAO: function isSHIPINHAO() {
      if (this.advertisingConfig && this.advertisingConfig.advertisingPlatformId === 5) {
        return true;
      }
      return false;
    },

    // 投放且在微信环境，视频号虽在微信环境，但走投放流程
    isTfWechat: function isTfWechat() {
      return this.WEIBO_NOTLOGIN && this.platform.isWechat;
    },


    // 小程序ios环境
    isIosWxapp: function isIosWxapp() {
      return this.isCpWxapp && this.isIos;
    },


    // 在报告页支付
    isPayOnReport: function isPayOnReport() {
      return false;
    },


    // B端新菜单
    isToBNewMenu: function isToBNewMenu() {
      return this.channelConfig.menuVersion === 2;
    },


    // B端高校版答完题跳转提示页，不给看报告
    isGoFinishTips: function isGoFinishTips() {
      if (this.isToBNewMenu) return false;
      return this.channelConfig.isViewReport === 0;
    },

    // 隐藏弹窗与浮标的渠道
    isHideChannel: function isHideChannel() {
      return [1342, 1479, 1564, 2001, 1415, 1384, 1565, 1424, 1958, 2246, 1563, 1944, 1472, 1968, 1707, 1608, 1566, 2447, 2253, 1671, 2346, 2214, 2101, 2027, 2168, 1987, 2993].includes(+this.channelId);
    },


    // 隐藏会员入口
    isHideVipEntrance: function isHideVipEntrance() {
      return [3783, 3784, 3792, 3793, 3823, 3932, 4247, 4411, 2018, 1703].includes(+this.channelId) || this.channelConfig.channelType === 4 || this.channelConfig.showVip === 0;
    },


    //内部渠道分享文案
    INTERNALCHANNEL_SHARE: function INTERNALCHANNEL_SHARE() {
      return {
        title: '专业、有趣、好玩的壹心理测评，用心理学探索未知自己',
        imgUrl: 'https://ossimg.xinli001.com/20200309/9c00bc9481c1ddf25fddcc94f2f451ae.png',
        desc: '壹心理测评，点击开始测试'
      };
    },
    SHWO_VIP_TIS: function SHWO_VIP_TIS() {
      var exChannel = [1342, 1479, 1564, 1384, 2001, 1565, 1415, 1424, 1958, 1563, 1472, 1944, 1608, 1707, 2246, 1566, 1968, 1671, 2101, 2027, 2253, 2214, 2346, 2168, 1987, 2447, 2437];
      return !exChannel.includes(this.channelId);
    },
    XIAOXIYE: function XIAOXIYE() {
      var exChannel = [1342, 1479, 1564, 1384, 2001, 1565, 1415, 1424, 1958, 1563, 1472, 1944, 1608, 1707, 2246, 1566, 1968, 1671, 2101, 2027, 2253, 2214, 2346, 2168, 1987, 2447];
      return exChannel.includes(Number(this.channelId));
    },
    isActivity20201111: function isActivity20201111() {
      var r = false;
      var scalePoolId = this.$route.params.testId;
      if (!scalePoolId) {
        scalePoolId = this.scaleModulesMsg ? this.scaleModulesMsg.scalePoolId : this.$route.query.scalePoolId;
      }
      var activityPage = this.$route.name == '20inPromotion';
      var activityScalePoolIds = [758, 761, 759, 760, 762, 767, 763, 765, 764, 766];
      r = activityScalePoolIds.includes(Number(scalePoolId)) || activityPage;
      // r = true
      // console.log('--- 是否是双十一活动 ---', r)
      return r;
    },
    IS_APP_MEMBER: function IS_APP_MEMBER() {
      //壹心理app与m站渠道 暂时判断
      return [513, 514].includes(+this.channelId);
    },
    IS_WECHAT_CHANNELTYPE: function IS_WECHAT_CHANNELTYPE() {
      return this.channelConfig.channelType == 1 || this.channelConfig.channelType == 2;
    },

    // 内部微站渠道
    isInternalWechat: function isInternalWechat() {
      return this.CHANNEL_INTERNALCHANNEL && this.IS_WECHAT_CHANNELTYPE;
    },
    IS_SHOW_MEMBER_SHARE: function IS_SHOW_MEMBER_SHARE() {
      var host = location.host;
      return !(host.indexOf('hd' + apis["a" /* default */].env + '.xinli001wx.com') > -1);
    },

    // 隐藏评论模块的渠道类型
    hideCommentChannelType: function hideCommentChannelType() {
      return [3, 10, 16].includes(+this.channelConfig.channelType);
    },


    // 2021 525活动时间
    is2021525: function is2021525() {
      return false;
    },


    // 内隐自尊
    isImplicit: function isImplicit() {
      var scalePoolId = this.$route.params.testId ? this.$route.params.testId : this.$route.query.scalePoolId;
      var r = scalePoolId == '847' || this.timingData.isCaculateTime;
      return r;
    },
    isIQTest: function isIQTest() {
      var isIQTestChannel = [3370, 3371, 3073].includes(+this.channelId);
      if (this.$route.name === 'testDetailIQ' && isIQTestChannel) return true;
      if (this.$route.name === 'testDetail') return false;
      var scalePoolId = this.$route.params.testId;
      if (!scalePoolId) {
        scalePoolId = this.scaleModulesMsg ? this.scaleModulesMsg.scalePoolId : this.$route.query.scalePoolId;
      }
      if (scalePoolId) {
        return [806, 795].includes(+scalePoolId) && isIQTestChannel;
      }
      return false;
    },
    isIos: function isIos() {
      return (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
      );
    },
    isMiniapp: function isMiniapp() {
      return (/miniprogram/i.test(navigator.userAgent)
      );
    },


    // 隐藏导咨询引流信息
    isHideConsult: function isHideConsult() {
      return [3712, 3618, 3670, 3067, 3802, 3820, 3821].includes(+this.channelId);
    },
    mbtiRandomQrcode: function mbtiRandomQrcode() {
      if (Math.ceil(Math.random() * 20) % 2) {
        return img_mbti_random1_default.a;
      }
      return img_mbti_random2_default.a;
    },


    // 曼陀罗测试
    isDatura: function isDatura() {
      var scalePoolId = this.scalePoolId || this.$route.query.scalePoolId;
      var r = [1087, 1090].includes(+scalePoolId);
      return r;
    },
    isCareer: function isCareer() {
      var scalePoolId = this.scalePoolId || this.$route.query.scalePoolId;
      var r = [797].includes(+scalePoolId);
      return r;
    },
    isNotLoginToYxlZixun: function isNotLoginToYxlZixun() {
      var r = this.WEIBO_NOTLOGIN && this.isDatura;
      return r;
    },
    isJumpDetailChannels: function isJumpDetailChannels() {
      return [4711, 4710, 4697, 4631, 4634, 4635, 4636, 4570, 4273, 4286];
    },

    // 定制房树人(放置版本)
    isNewHTPScalePoolIds: function isNewHTPScalePoolIds() {
      return [1207];
    },
    isJumpDetailChannelsCommon: function isJumpDetailChannelsCommon() {
      var scalePoolId = this.scalePoolId || this.$route.query.scalePoolId;
      // 投放房树人跳过详情页
      if (this.isNewHTPScalePoolIds.includes(+scalePoolId)) {
        return true;
      }
      return false;
    },

    // 曼陀罗投放-假题版本（考虑后期可能去除假题，其它地方勿用）
    isNotLoginDaturaForFalseQuestions: function isNotLoginDaturaForFalseQuestions() {
      var specifiedChannel = [4676, 4675, 4674, 4673];
      var channelId = this.channelId || this.$route.query.channelId;
      return this.WEIBO_NOTLOGIN && this.isDatura && specifiedChannel.includes(+channelId);
    },
    isYY_2_1: function isYY_2_1() {
      var isYY_2_1_channels = [4619, 4618, 4690, 4691, 4692];
      var isYY_2_1_scalePoolIds = [1147, 1146, 1145];
      var scalePoolId = this.scalePoolId || this.$route.query.scalePoolId;
      return this.scalePoolId && isYY_2_1_channels.includes(this.channelId) && isYY_2_1_scalePoolIds.includes(+scalePoolId);
    },

    // 是否mbti多题版本
    isMBTI_MQ: function isMBTI_MQ() {
      var scalePoolId = this.scalePoolId || this.$route.query.scalePoolId;
      return +scalePoolId === 1217;
    },

    // 是否mbti2选1
    isMBTI_2_1: function isMBTI_2_1() {
      var isMBTI_2_1scalePoolIds = [1236, 1235, 1217];
      var scalePoolId = this.scalePoolId || this.$route.query.scalePoolId;
      return scalePoolId && isMBTI_2_1scalePoolIds.includes(+scalePoolId);
    },
    hideBannerAndConsult: function hideBannerAndConsult() {
      var hideChannels = [4621, 3618, 1343, 3711, 2018, 1703];
      return !hideChannels.includes(this.channelId);
    },
    isSoulInWechat: function isSoulInWechat() {
      return this.$platform.isWechat && (this.scalePoolId == 876 || this.$route.query.scalePoolId == 876);
    },
    guideToZxszjScalePoolIds: function guideToZxszjScalePoolIds() {
      return [1199, 1206];
    },
    isMediaPlatform: function isMediaPlatform() {
      return this.advertisingConfig && this.advertisingConfig.isAdvertisingPlatform == 1;
    },

    // 定制指定渠道指定评测id，在支付解锁页展示特定支付样式
    // 目前用于定制抑郁测试
    isCustomPayUnlockType: function isCustomPayUnlockType() {
      var channels = [3868, 3738, 4403];
      var scalePoolIds = [353];
      var scalePoolId = this.scalePoolId || this.$route.query.scalePoolId;
      return scalePoolId && channels.includes(this.channelId) && scalePoolIds.includes(+scalePoolId);
    }
  }),

  created: function created() {
    this._stream_ = [];
  },
  mounted: function mounted() {
    this.initOtherApp();
  },
  beforeDestroy: function beforeDestroy() {
    this._stream_.forEach(function (res) {
      return res[0].removeListener(res[1]);
    });
  }
});

/***/ }),

/***/ "ICW8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__("IRMm");

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ "IEQv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_gotoTop_vue_vue_type_style_index_0_id_2f41edf1_lang_scss_scoped_true___ = __webpack_require__("uL9n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_gotoTop_vue_vue_type_style_index_0_id_2f41edf1_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_gotoTop_vue_vue_type_style_index_0_id_2f41edf1_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_gotoTop_vue_vue_type_style_index_0_id_2f41edf1_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "IFpc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__("XO1R");
var isObject = __webpack_require__("UKM+");
var toLength = __webpack_require__("BbyF");
var ctx = __webpack_require__("rFzY");
var IS_CONCAT_SPREADABLE = __webpack_require__("kkCw")('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),

/***/ "IMUI":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Array', { isArray: __webpack_require__("XO1R") });


/***/ }),

/***/ "IO1w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("8Uqm");

function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),

/***/ "IRJ3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("7ylX");
var descriptor = __webpack_require__("fU25");
var setToStringTag = __webpack_require__("yYvK");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("2p1q")(IteratorPrototype, __webpack_require__("kkCw")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "IRMm":
/***/ (function(module, exports) {

module.exports = {"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}

/***/ }),

/***/ "ITw6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.e697933.png";

/***/ }),

/***/ "Ibhu":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("D2L2");
var toIObject = __webpack_require__("TcQ7");
var arrayIndexOf = __webpack_require__("vFc/")(false);
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "IiB5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__("nSQQ");

var callBind = __webpack_require__("bfde");

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

/***/ }),

/***/ "IlSO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IpzJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("cM5C");

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

/***/ }),

/***/ "IrU9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J+j9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__("y325")('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),

/***/ "J2ob":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__("y325")('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),

/***/ "JG34":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__("Ds5P");
var anObject = __webpack_require__("DIVP");
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),

/***/ "JJ3w":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__("0j1G")('Map');


/***/ }),

/***/ "JP+z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "Jbuy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__("32VL");
__webpack_require__("Ds5P")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "JguD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/indexTitle_hot.17b3ece.png";

/***/ }),

/***/ "JkEM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__("lnrT");
var parse = __webpack_require__("9hGZ");
var formats = __webpack_require__("uToG");

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

/***/ }),

/***/ "Jssu":
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),

/***/ "K0JP":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("77Ug")('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "K1/g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeComponent;
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "K9Iu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KB1o":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "KCLY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("cGG2");
var normalizeHeaderName = __webpack_require__("5VQ+");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("7GwW");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("7GwW");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "KOrd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("WBcL");
var toObject = __webpack_require__("FryR");
var IE_PROTO = __webpack_require__("mZON")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "KQfO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kh4W":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("dSzd");


/***/ }),

/***/ "KqU/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),

/***/ "L42u":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("+ZMJ");
var invoke = __webpack_require__("knuC");
var html = __webpack_require__("RPLV");
var cel = __webpack_require__("ON07");
var global = __webpack_require__("7KvD");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("R9M2")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "LF/X":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__("SPM9")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),

/***/ "LG56":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),

/***/ "LJ7O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = doWxShareConfig;
/* harmony export (immutable) */ __webpack_exports__["b"] = wxConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__("OTud");



/**
 * 微信分享配置的方法
 * @param shareConfig
 */
function doWxShareConfig(shareConfig) {
    wxSDKLoadTask.then(function () {
        // console.info('配置' + this.$route.meta.title + '微信分享');
        wx.ready(function () {
            // wx.hideMenuItems({
            //     menuList: [
            //         'menuItem:share:qq',
            //         'menuItem:share:weiboApp',
            //         'menuItem:share:QZone',
            //         'menu:share:timeline',
            //         // "menuItem:openWithSafari"
            //     ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
            // });
            wx.onMenuShareTimeline({
                title: shareConfig.title, // 分享标题
                link: shareConfig.link, // 分享链接
                imgUrl: shareConfig.imgUrl, // 分享图标
                success: shareConfig.successTimeline ? shareConfig.successTimeline : shareConfig.success,
                cancel: shareConfig.cancel
            });
            wx.onMenuShareAppMessage({
                title: shareConfig.title, // 分享标题
                desc: shareConfig.desc, // 分享描述
                link: shareConfig.link, // 分享链接
                imgUrl: shareConfig.imgUrl, // 分享图标
                type: 'link', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: shareConfig.successAppMessage ? shareConfig.successAppMessage : shareConfig.success,
                cancel: shareConfig.cancel
            });
        });
    });
};

/**
 * 微信JSSDK 配置
 * @param data
 * @param errorCallback
 */
function wxConfig(data) {
    return wxSDKLoadTask.then(function () {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: data.appId, // 必填，公众号的唯一标识
                timestamp: data.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.nonceStr, // 必填，生成签名的随机串
                signature: data.signature, // 必填，签名，见附录1
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems', 'showMenuItems', 'chooseWXPay', 'chooseImage', 'getLocalImgData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });

            // 这里resolve的话，error的reject就没意义了 --@by cyc
            // resolve();
            wx.ready(resolve);

            wx.error(function (res) {
                // alert(res.errMsg);
                // window.monitor.stat({
                //     level: 'warn',
                //     error: 'API-data',
                //     url: APIS.wechatData,
                //     message: res.errMsg
                // });
                console.log(res);
                reject();
            });
        });
    });
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
    wxConfig: wxConfig,
    doWxShareConfig: doWxShareConfig
});

/***/ }),

/***/ "LKZe":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("NpIQ");
var createDesc = __webpack_require__("X8DO");
var toIObject = __webpack_require__("TcQ7");
var toPrimitive = __webpack_require__("MmMw");
var has = __webpack_require__("D2L2");
var IE8_DOM_DEFINE = __webpack_require__("SfB7");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("+E39") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "LRL/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__("Ymdd")('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),

/***/ "La7N":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__("0j1G")('WeakMap');


/***/ }),

/***/ "LhTa":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("rFzY");
var IObject = __webpack_require__("Q6Nf");
var toObject = __webpack_require__("FryR");
var toLength = __webpack_require__("BbyF");
var asc = __webpack_require__("plSV");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "LlNE":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__("Ds5P");
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),

/***/ "Lmjj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lqg1":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__("Ds5P");
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__("zgIt")(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),

/***/ "LrcN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("OzIq");
var DESCRIPTORS = __webpack_require__("bUqO");
var LIBRARY = __webpack_require__("V3l/");
var $typed = __webpack_require__("07k+");
var hide = __webpack_require__("2p1q");
var redefineAll = __webpack_require__("A16L");
var fails = __webpack_require__("zgIt");
var anInstance = __webpack_require__("9GpA");
var toInteger = __webpack_require__("oeih");
var toLength = __webpack_require__("BbyF");
var toIndex = __webpack_require__("8D8H");
var gOPN = __webpack_require__("WcO1").f;
var dP = __webpack_require__("lDLk").f;
var arrayFill = __webpack_require__("zCYm");
var setToStringTag = __webpack_require__("yYvK");
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),

/***/ "M6a0":
/***/ (function(module, exports) {



/***/ }),

/***/ "M8WE":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("kkCw");


/***/ }),

/***/ "MAYL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_title_search.524617f.svg";

/***/ }),

/***/ "MGW/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_dialog_vue_vue_type_style_index_0_id_72cd10eb_lang_scss_scoped_true___ = __webpack_require__("72Vn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_dialog_vue_vue_type_style_index_0_id_72cd10eb_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_dialog_vue_vue_type_style_index_0_id_72cd10eb_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_dialog_vue_vue_type_style_index_0_id_72cd10eb_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "MU5D":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("R9M2");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "MfeA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("DIVP");
var toLength = __webpack_require__("BbyF");
var advanceStringIndex = __webpack_require__("TwzQ");
var regExpExec = __webpack_require__("9Dx1");

// @@match logic
__webpack_require__("Vg1y")('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "Mhyx":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("/bQp");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "MjHD":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__("Ds5P");
var expm1 = __webpack_require__("x78i");
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__("zgIt")(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),

/***/ "MmMw":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("EqjI");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "MsuQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("Dgii");
var validate = __webpack_require__("zq/X");
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__("0Rih")(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ "MyjO":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("77Ug")('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),

/***/ "N4KQ":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),

/***/ "NHaJ":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("wCso");
var anObject = __webpack_require__("DIVP");
var getPrototypeOf = __webpack_require__("KOrd");
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-own-property-names.js
var get_own_property_names = __webpack_require__("aFK5");
var get_own_property_names_default = /*#__PURE__*/__webpack_require__.n(get_own_property_names);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-touch/dist/vue-touch.js
var vue_touch = __webpack_require__("I0MY");
var vue_touch_default = /*#__PURE__*/__webpack_require__.n(vue_touch);

// EXTERNAL MODULE: ./src/frontend-lib/tools/getPlatform.js
var getPlatform = __webpack_require__("hTeI");
var getPlatform_default = /*#__PURE__*/__webpack_require__.n(getPlatform);

// EXTERNAL MODULE: ./src/apis.js
var apis = __webpack_require__("OTud");

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__("mw3O");
var qs_lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/frontend-lib/component/vue/toast/toast.vue?vue&type=template&id=71635f86&scoped=true&
var toastvue_type_template_id_71635f86_scoped_true__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visable)?_c('div',{staticClass:"toast"},[_c('v-touch',{staticClass:"toast-mask",class:{ zIndexTop: _vm.zIndexTop },on:{"touchmove":function($event){$event.preventDefault();},"tap":_vm.handleMask}}),_vm._v(" "),_c('div',{staticClass:"toast-cont",class:{ zIndexTop: _vm.zIndexTop }},[(_vm.type === 'loading')?_c('i',{staticClass:"icon icon-loading"}):_vm._e(),_vm._v(" "),(_vm.type === 'success')?_c('i',{staticClass:"icon icon-success"}):_vm._e(),_vm._v(" "),(_vm.type === 'fail')?_c('i',{staticClass:"icon icon-fail"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"toast-text",class:{ tc: _vm.textCenter },domProps:{"innerHTML":_vm._s(_vm.text)}})])],1):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/frontend-lib/component/vue/toast/toast.vue?vue&type=template&id=71635f86&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/frontend-lib/component/vue/toast/toast.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var toastvue_type_script_lang_js_ = ({
  name: 'Toast',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    time: {
      type: Number,
      default: function _default() {
        return this.type === 'loading' ? 0 : 3000;
      }
    },
    zIndexTop: {
      //增加层级
      type: Boolean,
      default: false
    },
    textCenter: {
      //文本居中显示
      type: Boolean,
      default: function _default() {
        return this.type === 'default';
      }
    },
    text: {
      type: String,
      default: function _default() {
        switch (this.type) {
          case 'loading':
            return '加载中...';
          case 'success':
            return '操作成功';
          case 'fail':
            return '操作失败';
          default:
            return '';
        }
      }
    }
  },
  data: function data() {
    return {
      visable: true
    };
  },
  mounted: function mounted() {
    this.time !== 0 && this._setTimer();
  },

  methods: {
    handleMask: function handleMask() {
      this.type !== 'loading' && this.close();
    },
    close: function close() {
      this.visable = false;
      clearTimeout(this._timer);
      this.$emit('close');
    },
    _setTimer: function _setTimer() {
      var _this = this;

      this._timer = setTimeout(function () {
        _this.close();
      }, this.time);
    }
  },
  destoryed: function destoryed() {
    clearTimeout(this._timer);
  }
});
// CONCATENATED MODULE: ./src/frontend-lib/component/vue/toast/toast.vue?vue&type=script&lang=js&
 /* harmony default export */ var toast_toastvue_type_script_lang_js_ = (toastvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/frontend-lib/component/vue/toast/toast.vue?vue&type=style&index=0&id=71635f86&lang=scss&scoped=true&
var toastvue_type_style_index_0_id_71635f86_lang_scss_scoped_true_ = __webpack_require__("p+dV");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/frontend-lib/component/vue/toast/toast.vue






/* normalize component */

var toast_component = Object(componentNormalizer["a" /* default */])(
  toast_toastvue_type_script_lang_js_,
  toastvue_type_template_id_71635f86_scoped_true__render,
  staticRenderFns,
  false,
  null,
  "71635f86",
  null
  
)

/* harmony default export */ var toast = (toast_component.exports);
// CONCATENATED MODULE: ./src/frontend-lib/component/vue/toast/toast.js


var Toast = vue_esm["a" /* default */].extend(toast);

/**
 * 信息提示
 * @param {[object, string]} opts
 * @param {type} opts.string 类型 默认defualt 可选['loading', 'success', 'fail']
 * @param {text} opts.text 文字
 * @param {function} opts.callback 回调方法
 * @return {object} {}.hide 隐藏方法
 */
var toast_toast = function toast(opts) {
  if (!opts) return; // 修复传入undefined导致jsError
  opts = typeof opts === 'string' ? { text: opts } : opts;
  var comp = new Toast({
    propsData: opts
  });
  var vm = comp.$mount();
  document.body.appendChild(vm.$el);
  var close = function close() {
    opts.callback && opts.callback.call(vm);
    try {
      document.body.removeChild(vm.$el);
    } catch (error) {
      console.error(error);
    }
    vm.$destroy();
  };
  vm.$on('close', close);
  return {
    close: function close() {
      vm.close();
    }
  };
};

/**
 * 包装方法，对参数进行处理
 * @param {function} fn
 */
var wrap = function wrap(fn) {
  return function (text, callback, time) {
    // 如果只有两个参数，并且第二个参数是数字，就把第二参数当作关闭时间
    if (typeof callback === 'number') {
      ;var _ref = [callback, function () {}];
      time = _ref[0];
      callback = _ref[1];
    }
    return fn(text, callback, time);
  };
};

/**
 * 加载中
 * @param {string} text
 * @param {function} callback
 * @return {object} {}.close 隐藏方法
 */
var loading = wrap(function (text, callback, time) {
  return toast_toast({ type: 'loading', text: text, time: time, callback: callback });
});

/**
 * 成功
 * @param {string} text
 * @param {number} time
 * @param {function} callback
 * @return {object} {}.close 隐藏方法
 */
var success = wrap(function (text, callback, time) {
  return toast_toast({ type: 'success', text: text, time: time, callback: callback });
});

/**
 * 失败
 * @param {string} text
 * @param {number} time
 * @param {function} callback
 * @return {object} {}.close 隐藏方法
 */
var fail = wrap(function (text, callback, time) {
  return toast_toast({ type: 'fail', text: text, time: time, callback: callback });
});

var toast_install = function install(Vue) {
  Vue.component(toast.name, toast);
  Vue.prototype.$toast = toast_toast;
  Vue.prototype.$loading = loading;
  Vue.prototype.$success = success;
  Vue.prototype.$fail = fail;
};

/* harmony default export */ var vue_toast_toast = (toast_install);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/frontend-lib/component/vue/dialog/dialog.vue?vue&type=template&id=72cd10eb&scoped=true&
var dialogvue_type_template_id_72cd10eb_scoped_true__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['common-dialog-box', _vm.className]},[_c('div',{staticClass:"dialog-mask",attrs:{"tag":"div"},on:{"touchmove":function($event){$event.preventDefault();},"click":function($event){return _vm.handleClose({ isMask: 1 })}}}),_vm._v(" "),_c('div',{class:['dialog-cont', { 'dialog-box': _vm.maskBox }]},[(_vm.showClose || _vm.rightClose)?_c('span',{class:['dialog-close', { 'dialog-close-right': _vm.rightClose }],on:{"click":function($event){return _vm.handleClose({ isMask: 0 })}}}):_vm._e(),_vm._v(" "),(_vm.tipTitle)?_c('p',{staticClass:"dialog-tip-title",domProps:{"innerHTML":_vm._s(_vm.tipTitle)}}):_vm._e(),_vm._v(" "),(_vm.title)?_c('p',{staticClass:"txt",domProps:{"innerHTML":_vm._s(_vm.title)}},[_vm._v("title")]):_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"opt-group"},_vm._l((_vm.buttons),function(v,index){return _c('span',{key:index,staticClass:"btn",style:(index === _vm.buttons.length - 1
            ? Object.assign({}, {background: _vm.theme,
                color: '#fff',
                borderColor: _vm.theme},
                v.styleData)
            : Object.assign({}, {color: _vm.theme,
                borderColor: _vm.theme},
                v.styleData)),on:{"click":function($event){return _vm.handleClick({ index: index })}}},[_vm._v("\n        "+_vm._s(v.label)+"\n      ")])}),0)],2)])}
var dialogvue_type_template_id_72cd10eb_scoped_true__staticRenderFns = []


// CONCATENATED MODULE: ./src/frontend-lib/component/vue/dialog/dialog.vue?vue&type=template&id=72cd10eb&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/frontend-lib/component/vue/dialog/dialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// <Dialog
//   title="是否开始接单？"
//   v-if="dialogVisable"
//   :buttons="[{
//     label: '取消'
//   },
//   {
//     label: '确定',
//     onClick: function(){
//       console.log(1)
//     }
//   }]"
//   @close="dialogVisable = false"
// />
var defaultBtns = [{
  label: '取消',
  onClick: function onClick() {}
}, {
  label: '确定',
  onClick: function onClick() {}
}];
/* harmony default export */ var dialogvue_type_script_lang_js_ = ({
  name: 'Dialog',
  props: {
    title: {
      type: String
    },
    buttons: {
      type: Array,
      default: function _default() {
        return defaultBtns;
      }
    },
    theme: {
      type: String,
      default: '#ff745b'
    },
    showClose: {
      type: Boolean,
      default: false
    },
    maskClose: {
      type: Boolean,
      default: false
    },
    rightClose: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    maskBox: {
      // 有时文案过长会溢出盒子外面，加个参数判断
      type: Boolean,
      default: true
    },
    tipTitle: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(obj) {
      var _this = this;

      var index = obj.index;

      var close = function close() {
        return _this.$emit('close', _this.buttons[index], index);
      };
      var result = true;
      //对应button的回调执行
      if (typeof this.buttons[index].onClick === 'function') {
        var _result = this.buttons[index].onClick(close);
        result = _result === false ? false : true;
      }
      console.log('result', result);
      if (result) {
        close();
      }
    },
    handleClose: function handleClose(_ref) {
      var isMask = _ref.isMask;

      console.log(isMask);
      if (isMask) {
        if (this.maskClose) {
          this.$emit('close');
        }
      } else {
        this.$emit('close');
      }
    }
  }
});
// CONCATENATED MODULE: ./src/frontend-lib/component/vue/dialog/dialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var dialog_dialogvue_type_script_lang_js_ = (dialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/frontend-lib/component/vue/dialog/dialog.vue?vue&type=style&index=0&id=72cd10eb&lang=scss&scoped=true&
var dialogvue_type_style_index_0_id_72cd10eb_lang_scss_scoped_true_ = __webpack_require__("MGW/");

// CONCATENATED MODULE: ./src/frontend-lib/component/vue/dialog/dialog.vue






/* normalize component */

var dialog_component = Object(componentNormalizer["a" /* default */])(
  dialog_dialogvue_type_script_lang_js_,
  dialogvue_type_template_id_72cd10eb_scoped_true__render,
  dialogvue_type_template_id_72cd10eb_scoped_true__staticRenderFns,
  false,
  null,
  "72cd10eb",
  null
  
)

/* harmony default export */ var dialog = (dialog_component.exports);
// CONCATENATED MODULE: ./src/frontend-lib/component/vue/dialog/dialog.js
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Dialog = vue_esm["a" /* default */].extend(dialog);

/**
 * 弹窗方法
 * @param {Object} opts
 * @param {String} opts.title
 * @param {Array} opts.buttons
 * @param {Function} opts.onClose
 * @returns {Promise}
 * @example
 *  $dialog({
      title: 'hehe',
      onClose: function(),
      showClose:false,
      buttons:[{
        label: '取消'
      },
      {
        label: '确定',
        onClick: function(){}
      }]
    })
 */
var dialog_dialog = function dialog(opts) {
  // 如果是标题,就是默认按钮项

  if (typeof opts === 'string') {
    opts = {
      title: opts
    };
  }

  var _opts = opts,
      onClose = _opts.onClose,
      propsData = _objectWithoutProperties(_opts, ['onClose']);

  console.log('propsData', propsData);
  var comp = new Dialog({
    propsData: propsData
  });

  var vm = comp.$mount();
  document.body.appendChild(vm.$el);

  return new Promise(function (resolve, reject) {
    vm.$on('close', function () {
      var index = arguments.length <= 1 ? undefined : arguments[1];
      document.body.removeChild(vm.$el);
      vm.$destroy();
      onClose && onClose.apply(undefined, arguments);
      // 正常引导操作都是按钮最后一个, 根据这个判断promise,
      // 如果不是最后一个通过buttons.onClick也可以准确知道点击,这种情况就不要调then就可以了
      index === vm.buttons.length - 1 ? resolve.apply(undefined, arguments) : reject.apply(undefined, arguments);
      // }
    });
  });
};


var dialog_install = function install(Vue) {
  Vue.component('Dialog', Dialog);
  Vue.prototype.$dialog = dialog_dialog;
};

/* harmony default export */ var vue_dialog_dialog = (dialog_install);
// CONCATENATED MODULE: ./src/frontend-lib/component/vue/entry.js



/* harmony default export */ var entry = ({
  install: function install(Vue) {
    Vue.use(vue_dialog_dialog);
    Vue.use(vue_toast_toast);
  }
});
// EXTERNAL MODULE: ./src/frontend-lib/tools/url.js
var tools_url = __webpack_require__("TF8a");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
/*!
  * vue-router v3.1.6
  * (c) 2020 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isExtendedError (constructor, err) {
  return (
    err instanceof constructor ||
    // _name is to support IE9 too
    (err && (err.name === constructor.name || err._name === constructor._name))
  )
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cachce
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("RouterLink with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function vue_router_esm_install (Vue) {
  if (vue_router_esm_install.installed && _Vue === Vue) { return }
  vue_router_esm_install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && 'pushState' in window.history
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

var NavigationDuplicated = /*@__PURE__*/(function (Error) {
  function NavigationDuplicated (normalizedLocation) {
    Error.call(this);
    this.name = this._name = 'NavigationDuplicated';
    // passing the message to super() doesn't seem to work in the transpiled version
    this.message = "Navigating to current location (\"" + (normalizedLocation.fullPath) + "\") is not allowed";
    // add a stack property so services like Sentry can correctly display it
    Object.defineProperty(this, 'stack', {
      value: new Error().stack,
      writable: true,
      configurable: true
    });
    // we could also have used
    // Error.captureStackTrace(this, this.constructor)
    // but it only exists on node and chrome
  }

  if ( Error ) NavigationDuplicated.__proto__ = Error;
  NavigationDuplicated.prototype = Object.create( Error && Error.prototype );
  NavigationDuplicated.prototype.constructor = NavigationDuplicated;

  return NavigationDuplicated;
}(Error));

// support IE9
NavigationDuplicated._name = 'NavigationDuplicated';

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        this$1.ready = true;
        this$1.readyErrorCbs.forEach(function (cb) {
          cb(err);
        });
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    // after merging https://github.com/vuejs/vue-router/pull/2771 we
    // When the user navigates through history through back/forward buttons
    // we do not want to throw the error. We only throw it if directly calling
    // push/replace. That's why it's not included in isError
    if (!isExtendedError(NavigationDuplicated, err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort(new NavigationDuplicated(route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) {
            cb();
          });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key, cbs, isValid)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
      next(cb);
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (
    instances[key] &&
    !instances[key]._isBeingDestroyed // do not reuse being destroyed instance
  ) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    var this$1 = this;

    History.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = decodeURI(window.location.pathname);
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(
      supportsPushState ? 'popstate' : 'hashchange',
      function () {
        var current = this$1.current;
        if (!ensureSlash()) {
          return
        }
        this$1.transitionTo(getHash(), function (route) {
          if (supportsScroll) {
            handleScroll(this$1.router, route, current, true);
          }
          if (!supportsPushState) {
            replaceHash(route.fullPath);
          }
        });
      }
    );
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);
  // decode the hash but not the search or hash
  // as search(query) is already decoded
  // https://github.com/vuejs/vue-router/issues/2708
  var searchIndex = href.indexOf('?');
  if (searchIndex < 0) {
    var hashIndex = href.indexOf('#');
    if (hashIndex > -1) {
      href = decodeURI(href.slice(0, hashIndex)) + href.slice(hashIndex);
    } else { href = decodeURI(href); }
  } else {
    href = decodeURI(href.slice(0, searchIndex)) + href.slice(searchIndex);
  }

  return href
}

function vue_router_esm_getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(vue_router_esm_getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(vue_router_esm_getUrl(path));
  } else {
    window.location.replace(vue_router_esm_getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        this$1.index = targetIndex;
        this$1.updateRoute(route);
      },
      function (err) {
        if (isExtendedError(NavigationDuplicated, err)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */



var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    vue_router_esm_install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(
    to,
    current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = vue_router_esm_install;
VueRouter.version = '3.1.6';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ var vue_router_esm = (VueRouter);

// EXTERNAL MODULE: ./src/lib/units.js + 2 modules
var units = __webpack_require__("DVdL");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/show/index.vue?vue&type=template&id=5bcd1fa2&
var showvue_type_template_id_5bcd1fa2__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show-root"}},[_c('router-view'),_vm._v(" "),(!_vm.HIDDEN_DETAILS)?_c('footer-nav'):_vm._e(),_vm._v(" "),(_vm.COUPONDIALOGDATA && !_vm.isglobalLimitTimeg)?_c('globalLimitTimeg'):_vm._e(),_vm._v(" "),_c('couponLogo',{attrs:{"inDetailGo":true,"showProps":_vm._setshowProps}})],1)}
var showvue_type_template_id_5bcd1fa2__staticRenderFns = []


// CONCATENATED MODULE: ./src/pages/show/index.vue?vue&type=template&id=5bcd1fa2&

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/components/show/footerNav.vue + 4 modules
var footerNav = __webpack_require__("GxLp");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/globalLoading.vue?vue&type=template&id=67ded17d&scoped=true&
var globalLoadingvue_type_template_id_67ded17d_scoped_true__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.finalText != ''),expression:"finalText != ''"}],staticClass:"globalLoading",class:['globalLoading'],attrs:{"id":"globalLoading"}},[_c('div',{staticClass:"bg"}),_vm._v(" "),_c('div',[_c('loadingIcon',{ref:"icon",style:({zIndex: _vm.zIndex})}),_vm._v(" "),_c('p',[_c('span',{staticClass:"text"},[_c('i',[_vm._v(_vm._s(_vm.finalText))]),_c('i',[_vm._v("...")])])])],1)])}
var globalLoadingvue_type_template_id_67ded17d_scoped_true__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/common/globalLoading.vue?vue&type=template&id=67ded17d&scoped=true&

// EXTERNAL MODULE: ./src/components/common/loadingIcon.vue + 4 modules
var loadingIcon = __webpack_require__("C/Ro");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/vip/common/loadingIcon.vue?vue&type=template&id=54ec3463&
var loadingIconvue_type_template_id_54ec3463__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"inpageLoading"}},[_c('div',{staticClass:"loader loader--style1",attrs:{"title":"0"}},[_c('svg',{attrs:{"version":"1.1","id":"loader-1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"60px","height":"60px","viewBox":"0 0 40 40","enable-background":"new 0 0 40 40","xml:space":"preserve"}},[_c('path',{attrs:{"opacity":"0.2","fill":"#0B8BFF","d":"M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946\n        s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634\n        c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0B8BFF","d":"M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0\n        C22.32,8.481,24.301,9.057,26.013,10.047z"}},[_c('animateTransform',{attrs:{"attributeType":"xml","attributeName":"transform","type":"rotate","from":"0 20 20","to":"360 20 20","dur":"0.5s","repeatCount":"indefinite"}})],1)])])])}
var loadingIconvue_type_template_id_54ec3463__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/vip/common/loadingIcon.vue?vue&type=template&id=54ec3463&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/vip/common/loadingIcon.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var loadingIconvue_type_script_lang_js_ = ({
    name: '',
    mounted: function mounted() {},

    methods: {},
    beforeDestroy: function beforeDestroy() {}
});
// CONCATENATED MODULE: ./src/components/vip/common/loadingIcon.vue?vue&type=script&lang=js&
 /* harmony default export */ var common_loadingIconvue_type_script_lang_js_ = (loadingIconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/vip/common/loadingIcon.vue?vue&type=style&index=0&lang=scss&
var loadingIconvue_type_style_index_0_lang_scss_ = __webpack_require__("H6qM");

// CONCATENATED MODULE: ./src/components/vip/common/loadingIcon.vue






/* normalize component */

var loadingIcon_component = Object(componentNormalizer["a" /* default */])(
  common_loadingIconvue_type_script_lang_js_,
  loadingIconvue_type_template_id_54ec3463__render,
  loadingIconvue_type_template_id_54ec3463__staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var common_loadingIcon = (loadingIcon_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/globalLoading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var globalLoadingvue_type_script_lang_js_ = ({
    name: 'globalLoading',
    components: {
        loadingIcon: loadingIcon["a" /* default */],
        viploadingIcon: common_loadingIcon
    },
    props: {
        propLOADINGTEXT: {
            required: true,
            type: String,
            default: ''
        },
        zIndex: {
            default: '5'
        }
    },
    data: function data() {
        return {
            finalText: ''
        };
    },
    mounted: function mounted() {},

    watch: {
        propLOADINGTEXT: function propLOADINGTEXT(newVal, oldVal) {
            var that = this;
            if (newVal == '') {
                setTimeout(function () {
                    that.finalText = newVal;
                    that.stopAnimate();
                }, 1000);
            } else {
                that.finalText = newVal;
                that.playAnimate();
            }
        }
    },

    methods: {
        stopAnimate: function stopAnimate() {
            var icon = this.$refs.icon;
            icon && icon.getAnime && icon.getAnime().pause();
        },
        playAnimate: function playAnimate() {
            var icon = this.$refs.icon;
            icon && icon.getAnime && icon.getAnime().play();
        }
    }
});
// CONCATENATED MODULE: ./src/components/common/globalLoading.vue?vue&type=script&lang=js&
 /* harmony default export */ var common_globalLoadingvue_type_script_lang_js_ = (globalLoadingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/common/globalLoading.vue?vue&type=style&index=0&id=67ded17d&lang=scss&scoped=true&
var globalLoadingvue_type_style_index_0_id_67ded17d_lang_scss_scoped_true_ = __webpack_require__("iyvF");

// CONCATENATED MODULE: ./src/components/common/globalLoading.vue






/* normalize component */

var globalLoading_component = Object(componentNormalizer["a" /* default */])(
  common_globalLoadingvue_type_script_lang_js_,
  globalLoadingvue_type_template_id_67ded17d_scoped_true__render,
  globalLoadingvue_type_template_id_67ded17d_scoped_true__staticRenderFns,
  false,
  null,
  "67ded17d",
  null
  
)

/* harmony default export */ var globalLoading = (globalLoading_component.exports);
// EXTERNAL MODULE: ./src/components/show/globalLimitTimeg.vue + 4 modules
var globalLimitTimeg = __webpack_require__("bLJ6");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/couponLogo.vue?vue&type=template&id=678e1042&scoped=true&
var couponLogovue_type_template_id_678e1042_scoped_true__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.SHOW_LOGO)?_c('div',[_c('v-touch',{staticClass:"test-coupon",attrs:{"tag":"div"},on:{"tap":function($event){return _vm.goActivty()}}},[_c('img',{attrs:{"src":_vm.logoSrc}})])],1):_vm._e()}
var couponLogovue_type_template_id_678e1042_scoped_true__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/show/couponLogo.vue?vue&type=template&id=678e1042&scoped=true&

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/couponLogo.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//





/* harmony default export */ var couponLogovue_type_script_lang_js_ = ({
  name: "",
  props: ["inDetailGo", "showProps", "isInnerChannel"],
  data: function data() {
    return {
      msg: ""
    };
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['adsense']), {
    adFloatConfig: function adFloatConfig() {
      var r = {};
      r = this.adsense.find(function (element) {
        return element['adsenseType'] == 2;
      });
      // console.log('--- 获取到的浮标数据 ---', r)
      return r;
    },
    SHOW_LOGO: function SHOW_LOGO() {
      return this.showProps && (!this.isDepression || this.useAB) && this.logoSrc;
    },


    // 是否是抑郁单品
    isDepression: function isDepression() {
      if (this.$route.name === 'testDetail' && +this.$route.params.testId === 696) {
        return true;
      }
      return false;
    },
    logoSrc: function logoSrc() {
      if (this.isHideChannel) return '';
      var config = this.adFloatConfig;
      if (!config) {
        return;
      }
      // console.log('--- 弹窗背景 内部渠道 ---', this.CHANNEL_INTERNALCHANNEL)
      var isInternal = config.channelScope.includes('1') && this.CHANNEL_INTERNALCHANNEL;
      var isExternal = config.channelScope.includes('2') && !this.CHANNEL_INTERNALCHANNEL;
      if (isInternal || isExternal) {
        var now = new Date();
        if (config && now > new Date(config.startTime.replace(/-/g, "/")) && now < new Date(config.endTime.replace(/-/g, "/"))) {
          // console.log('--- 弹窗在开始和结束时间内 ---',)
          return config.image;
        } else {
          return '';
        }
      } else {
        return '';
      }
    }
  }),
  methods: {
    goActivty: function goActivty() {
      var type = 'logo';
      this.goIntoDialog(type, this.adFloatConfig);
    }
  },
  components: {},
  mounted: function mounted() {},

  watch: {},
  beforeDestroy: function beforeDestroy() {
    //销毁事件
  }
});
// CONCATENATED MODULE: ./src/components/show/couponLogo.vue?vue&type=script&lang=js&
 /* harmony default export */ var show_couponLogovue_type_script_lang_js_ = (couponLogovue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/show/couponLogo.vue?vue&type=style&index=0&id=678e1042&scoped=true&lang=scss&
var couponLogovue_type_style_index_0_id_678e1042_scoped_true_lang_scss_ = __webpack_require__("YCU4");

// CONCATENATED MODULE: ./src/components/show/couponLogo.vue






/* normalize component */

var couponLogo_component = Object(componentNormalizer["a" /* default */])(
  show_couponLogovue_type_script_lang_js_,
  couponLogovue_type_template_id_678e1042_scoped_true__render,
  couponLogovue_type_template_id_678e1042_scoped_true__staticRenderFns,
  false,
  null,
  "678e1042",
  null
  
)

/* harmony default export */ var couponLogo = (couponLogo_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/show/index.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var showvue_type_script_lang_js_ = ({
    name: 'app',
    components: {
        footerNav: footerNav["a" /* default */],
        globalLoading: globalLoading,
        globalLimitTimeg: globalLimitTimeg["a" /* default */],
        couponLogo: couponLogo
    },
    data: function data() {
        return {
            showTis: false
        };
    },

    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['COUPONDIALOGDATA']), {
        // 使用内部弹窗组件，需要关闭回调
        isglobalLimitTimeg: function isglobalLimitTimeg() {
            return this.$route.path == '/vip4Detail';
        }
    }),
    mounted: function mounted() {
        // console.log(this.$route)
        if (this.platform.isCeShiApp) {
            // 是口袋心理的话重定向到测评M站
            location.replace(location.origin + '/cp-m/index.html?channelId=324#/manage?channelId=324');
        }
        if (this.platform.isWechat && [513, 514, 501].includes(this.channelId)) {
            // 测评微站重定向渠道
            location.href = '' + location.origin + location.pathname + '?channelId=1037#' + this.$route.path;
        }
    },

    methods: {
        _detailGo: function _detailGo() {}
    }
});
// CONCATENATED MODULE: ./src/pages/show/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var pages_showvue_type_script_lang_js_ = (showvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/pages/show/index.vue?vue&type=style&index=0&lang=scss&
var showvue_type_style_index_0_lang_scss_ = __webpack_require__("cxOf");

// CONCATENATED MODULE: ./src/pages/show/index.vue






/* normalize component */

var show_component = Object(componentNormalizer["a" /* default */])(
  pages_showvue_type_script_lang_js_,
  showvue_type_template_id_5bcd1fa2__render,
  showvue_type_template_id_5bcd1fa2__staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var show = (show_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/show/showIndex.vue?vue&type=template&id=98168694&
var showIndexvue_type_template_id_98168694__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.channelConfig.siteName?_vm.channelConfig.siteName:''),expression:"channelConfig.siteName?channelConfig.siteName:''"}],staticClass:"page-index"},[(!_vm.loading)?[_c('page-title',{attrs:{"fixed":false,"propTitle":_vm.channelConfig.siteName,"propLogo":_vm.channelConfig.logoUrl}}),_vm._v(" "),(_vm.isShowBuoy525)?_c('count-down',{class:{'count-down-fixed': _vm.countDownFixed},staticStyle:{"position":"relative","z-index":"9"},attrs:{"endTime":_vm.expireTime525}}):_vm._e(),_vm._v(" "),_c('index-banner',{staticClass:"indexBanner",attrs:{"swiperData":_vm.banner},on:{"swiperClick":_vm.bannerClickHandler}}),_vm._v(" "),(_vm.CHANNEL_CHANNELTYPE&&_vm.hideBannerAndConsult)?_c('div',{staticClass:"yxl-consult-banner",on:{"click":_vm.toYXLConsultPage}},[_c('img',{attrs:{"src":__webpack_require__("9ScX"),"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.CHANNEL_INTERNALCHANNEL&&!_vm.CHANNEL_NOT_LOGIN)?_c('showindexNav',{on:{"viewMoreSort":_vm._viewMoreSort}}):_vm._e(),_vm._v(" "),(_vm.matchEntranceData.showStatus)?_c('matchingEntrance',{attrs:{"entranceData":_vm.matchEntranceData}}):(_vm.CHANNEL_INTERNALCHANNEL&&_vm.funTest)?_c('interestSwiper',{attrs:{"funTest":_vm.funTest},on:{"testClick":_vm.interestClickHandler,"moreFunTest":_vm._viewMoreSort}}):_vm._e(),_vm._v(" "),_c('recomend-list',{attrs:{"indexList":_vm.hotList,"type":'hot'},on:{"testClick":_vm.testClickHandler}}),_vm._v(" "),(_vm.proList.length>0&&!_vm.CHANNEL_NOT_LOGIN)?_c('proSwiper',{attrs:{"indexList":_vm.proList,"type":'hot'},on:{"testClick":_vm.testClickHandler,"viewMoreSort":_vm._viewMoreSort}}):_vm._e(),_vm._v(" "),_c('newSwiper',{attrs:{"indexList":_vm.newList,"type":'new'},on:{"testClick":_vm.testClickHandler}}),_vm._v(" "),_c('testOfChoice',{attrs:{"propTestItems":_vm.choiceTest},on:{"testClick":_vm.testClickHandler}}),_vm._v(" "),(!_vm.isHpnk)?_c('toSort',{ref:"toSortLink",on:{"viewMoreSort":_vm._viewMoreSort}}):_vm._e(),_vm._v(" "),_c('yxlCopyright',{attrs:{"showTip":_vm.isHwrl}}),_vm._v(" "),_c('go2top',{attrs:{"propShow":_vm.go2topShow}}),_vm._v(" "),_c('yxyBox',{attrs:{"showProps":_vm.showYxyBox},on:{"closeYxybox":function($event){return _vm._closeYxybox()}}})]:_vm._e(),_vm._v(" "),(_vm.loading)?[_c('skeleton-index')]:_vm._e()],2)}
var showIndexvue_type_template_id_98168694__staticRenderFns = []


// CONCATENATED MODULE: ./src/pages/show/showIndex.vue?vue&type=template&id=98168694&

// EXTERNAL MODULE: ./src/mixins/pageMixin.js + 1 modules
var pageMixin = __webpack_require__("8xno");

// EXTERNAL MODULE: ./src/components/common/pageTitle.vue + 4 modules
var pageTitle = __webpack_require__("rgm5");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/index/bannerSwiper.vue?vue&type=template&id=0bcad3f0&
var bannerSwipervue_type_template_id_0bcad3f0__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.swiperData.length > 0)?_c('div',{staticClass:"bannerSwiper cp-bannerSwiper"},[(_vm.loadReady)?_c(_vm.swiper,{ref:"mySwiperA",tag:"component",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.swiperData),function(item,index){return (_vm.loadReady)?_c(_vm.swiperSlide,{key:index,tag:"component"},[_c('div',{staticClass:"swiperCont"},[(item.isSpike)?_c('span',{staticClass:"promotion-brand"}):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":item.introPicture}})])]):_vm._e()}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.swiperData.length > 1),expression:"swiperData.length > 1"}],staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2):_vm._e()],1):_vm._e()}
var bannerSwipervue_type_template_id_0bcad3f0__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/show/index/bannerSwiper.vue?vue&type=template&id=0bcad3f0&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/index/bannerSwiper.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var bannerSwipervue_type_script_lang_js__vm = null;

// import {swiper, swiperSlide, swiperPlugins} from 'vue-awesome-swiper'


/* harmony default export */ var bannerSwipervue_type_script_lang_js_ = ({
    name: 'indexSwiper',
    /*components: {
        swiper,
        swiperSlide
    },*/
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['channelId'])),
    props: ['swiperData'],
    data: function data() {
        return {
            swiper: null,
            swiperSlide: null,
            loadReady: false,
            swiperOption: {
                autoplay: 3000,
                autoplayDisableOnInteraction: false,
                slidesPerView: 1.12,
                initialSlide: 0,
                // loopAdditionalSlides : 3,
                loop: true,
                onClick: function onClick(e) {
                    bannerSwipervue_type_script_lang_js__vm.swiperClick(e.realIndex);
                },
                centeredSlides: true,
                spaceBetween: 5,
                observer: true,
                observeParents: true,
                pagination: '.swiper-pagination',
                paginationType: 'fraction'
            }
        };
    },

    methods: {
        swiperClick: function swiperClick(index) {
            var item = this.swiperData[index];
            this.$emit('swiperClick', item, index);
        }
    },
    created: function created() {
        bannerSwipervue_type_script_lang_js__vm = this;
    },

    // 如果日后vue-awesome-swiper用的多，可以考虑分离出一个mixins
    mounted: function mounted() {
        var _this = this;

        domReadyPr.then(function () {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "F3EI"));
        }).then(function (_ref) {
            var swiper = _ref.swiper,
                swiperSlide = _ref.swiperSlide;

            _this.loadReady = true;
            _this.swiper = swiper;
            _this.swiperSlide = swiperSlide;
        });
    }
});
// CONCATENATED MODULE: ./src/components/show/index/bannerSwiper.vue?vue&type=script&lang=js&
 /* harmony default export */ var index_bannerSwipervue_type_script_lang_js_ = (bannerSwipervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/show/index/bannerSwiper.vue?vue&type=style&index=0&lang=scss&
var bannerSwipervue_type_style_index_0_lang_scss_ = __webpack_require__("6vJa");

// CONCATENATED MODULE: ./src/components/show/index/bannerSwiper.vue






/* normalize component */

var bannerSwiper_component = Object(componentNormalizer["a" /* default */])(
  index_bannerSwipervue_type_script_lang_js_,
  bannerSwipervue_type_template_id_0bcad3f0__render,
  bannerSwipervue_type_template_id_0bcad3f0__staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var bannerSwiper = (bannerSwiper_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/index/testSwiper.vue?vue&type=template&id=2eac39b5&
var testSwipervue_type_template_id_2eac39b5__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.indexList.length > 0)?_c('div',{class:['indexList', _vm.type, _vm.toutiaoType?'toutiaoList':'']},[_c('div',{staticClass:"container"},[(_vm.type == 'hot' && !_vm.toutiaoType)?_c('div',{staticClass:"mainTitle hot"}):_vm._e(),_vm._v(" "),(_vm.type == 'hot' && _vm.toutiaoType)?_c('div',{staticClass:"mainTitle toutiao"}):_vm._e(),_vm._v(" "),(_vm.type == 'new')?_c('div',{staticClass:"mainTitle new"}):_vm._e(),_vm._v(" "),(_vm.type == 'hot' && !_vm.toutiaoType)?_c('div',{staticClass:"sceTitle"},[_vm._v("不容错过的精彩测评")]):_vm._e(),_vm._v(" "),(_vm.type == 'new')?_c('div',{staticClass:"sceTitle"},[_vm._v("用新的视角遇见更好的自己")]):_vm._e(),_vm._v(" "),(_vm.loadReady)?_c(_vm.swiper,{tag:"component",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.indexList),function(item){return _c(_vm.swiperSlide,{key:item.scalePoolId,tag:"component"},[_c('v-touch',{staticClass:"swiperCont",on:{"tap":function($event){return _vm.testTap(item)}}},[_c('div',{staticClass:"imgCont"},[(!!item.viewPromotionStyle)?_c('span',{staticClass:"promotion-brand"}):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":item.introPicture}}),_vm._v(" "),((!_vm.isOldVip || item.vipBuyType !== 2) && !_vm.toutiaoType && !_vm.isHideVipEntrance)?_c('i',{staticClass:"vip-sign",class:{'is-half': item.vipBuyType === 1}}):_vm._e(),_vm._v(" "),(_vm.type == 'hot' && !_vm.toutiaoType)?_c('div',{staticClass:"testedPeople"},[_vm._v("\n              "+_vm._s(_vm.cutNum(item.count, 4))+"人已测\n            ")]):_vm._e(),_vm._v(" "),(_vm.type == 'new')?_c('div',{staticClass:"testedPeople"},[_vm._v("\n              "+_vm._s(_vm.timeTransform(item.updateTime))+"\n            ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"title"})]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"info"},[(!_vm.hidePrice)?[_c('span',{staticClass:"fs-14",class:[
                  'price',
                  !!item.viewPromotionStyle ? 'promotion' : ''
                ]},[_vm._v("¥"+_vm._s(Number(item.discountPrice).toFixed(2)))])]:_vm._e()],2),_vm._v(" "),(item.recommended)?_c('div',{staticClass:"status"},[_vm._v("\n            "+_vm._s(item.recommended)+"人已推\n          ")]):_vm._e()])],1)}),1):_vm._e()],1)]):_vm._e()}
var testSwipervue_type_template_id_2eac39b5__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/show/index/testSwiper.vue?vue&type=template&id=2eac39b5&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/index/testSwiper.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import {swiper, swiperSlide, swiperPlugins} from 'vue-awesome-swiper'


/* harmony default export */ var testSwipervue_type_script_lang_js_ = ({
  name: 'indexList',
  /*components: {
            swiper,
            swiperSlide
        },*/
  props: ['indexList', 'type', 'anchorTag', 'toutiaoType', 'hidePrice'],
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['channelId']), {
    isItemDescTwoLine: function isItemDescTwoLine() {
      var that = this;
      var result = 0;
      that.indexList.map(function (item) {
        if (item.name.length > 8) {
          result++;
        }
      });
      return !!(result > 0);
    }
  }),
  data: function data() {
    return {
      swiper: null,
      swiperSlide: null,
      loadReady: false,
      swiperOption: {
        autoplay: 0,
        slidesPerView: 'auto',
        paginationClickable: true,
        loop: false
      }
    };
  },
  mounted: function mounted() {
    if (this.anchorTag != '') {
      var anchorEl = document.querySelector('.indexList.' + this.anchorTag);
      if (anchorEl == undefined) {
        return;
      } else {
        document.body.scrollTop = anchorEl.offsetTop;
      }
    }
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])(['setINDEXSCROLLTOP']), {
    cutNum: units["i" /* cutNum */],
    timeTransform: function timeTransform(time) {
      if (time == '' | time == undefined) {
        return '';
      }
      var rs = '';
      var thatDay = new Date(time.replace(/-/g, '/'));
      var today = new Date();
      var c0 = function c0(num) {
        return num * 1 < 10 ? '0' + num : num;
      };
      if (today.getFullYear() == thatDay.getFullYear() & today.getMonth() == thatDay.getMonth() & today.getDate() == thatDay.getDate()) {
        if (today.getHours() == thatDay.getHours()) {
          return c0(today.getMinutes()) - c0(thatDay.getMinutes()) + '分钟前';
        } else {
          return c0(thatDay.getHours()) + ':' + c0(thatDay.getMinutes());
        }
      } else {
        return c0(thatDay.getMonth() + 1) + '-' + c0(thatDay.getDate());
      }
      return rs;
    },
    testTap: function testTap(testObj) {
      this.$emit('testClick', testObj, this.type);
      // 微站-测评大厅-热卖爆款-查看热卖测评 神策埋点
      this.$wechatTrackEvent('weizhan_cepinghome_checkhottest', {
        test_id: testObj.scalePoolId,
        test_name: testObj.name
      });
    }
  }),

  // 如果日后vue-awesome-swiper用的多，可以考虑分离出一个mixins
  // swiper: null,
  // swiperSlide: null,
  // loadReady: false,
  created: function created() {
    var _this = this;

    domReadyPr.then(function () {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "F3EI"));
    }).then(function (_ref) {
      var swiper = _ref.swiper,
          swiperSlide = _ref.swiperSlide;

      _this.loadReady = true;
      _this.swiper = swiper;
      _this.swiperSlide = swiperSlide;
    });
  }
});
// CONCATENATED MODULE: ./src/components/show/index/testSwiper.vue?vue&type=script&lang=js&
 /* harmony default export */ var index_testSwipervue_type_script_lang_js_ = (testSwipervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/show/index/testSwiper.vue?vue&type=style&index=0&lang=scss&
var testSwipervue_type_style_index_0_lang_scss_ = __webpack_require__("cWPk");

// CONCATENATED MODULE: ./src/components/show/index/testSwiper.vue






/* normalize component */

var testSwiper_component = Object(componentNormalizer["a" /* default */])(
  index_testSwipervue_type_script_lang_js_,
  testSwipervue_type_template_id_2eac39b5__render,
  testSwipervue_type_template_id_2eac39b5__staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var testSwiper = (testSwiper_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/index/testsOfChoice.vue?vue&type=template&id=14139bb4&scoped=true&
var testsOfChoicevue_type_template_id_14139bb4_scoped_true__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.propTestItems.length>0),expression:"propTestItems.length>0"}],staticClass:"testOfChoice"},[_c('div',{staticClass:"head"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"mainTitle",class:{'is-hpnk': _vm.isHpnk}},[_vm._v(_vm._s(_vm.isHpnk ? '妈妈焦虑程度测评' : ''))])]),_vm._v(" "),(!_vm.isHpnk)?_c('div',{staticClass:"more fs-14"},[_c('v-touch',{staticClass:"more-text",on:{"tap":_vm.toSorts}},[_vm._v("更多")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"container"},_vm._l((_vm.propTestItems),function(item){return _c('v-touch',{key:item.scalePoolId,attrs:{"tag":"li"},on:{"tap":function($event){return _vm.toTestDetail(item)}}},[_c('testItem',{staticClass:"testItem",attrs:{"item":item}})],1)}),1)])}
var testsOfChoicevue_type_template_id_14139bb4_scoped_true__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/show/index/testsOfChoice.vue?vue&type=template&id=14139bb4&scoped=true&

// EXTERNAL MODULE: ./src/components/common/testItem.vue + 4 modules
var testItem = __webpack_require__("XMHg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/index/testsOfChoice.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var testsOfChoicevue_type_script_lang_js_ = ({
    name: 'showIndexTestOfChoice',
    components: {
        testItem: testItem["a" /* default */]
    },
    props: {
        propTestItems: {
            required: true,
            type: Array,
            default: function _default() {
                [];
            }
        }
    },
    methods: {
        toSorts: function toSorts() {
            var that = this;
            that.$router.push({
                name: 'sorts',
                path: '/sorts',
                query: {
                    channelId: that.channelId
                }
            });
        },
        toTestDetail: function toTestDetail(testObj) {
            this.$emit('testClick', testObj);
            // 微站-测评大厅-查看精选测评 神策埋点
            this.$wechatTrackEvent('weizhan_cepinghome_checkchosentest', {
                test_id: testObj.scalePoolId,
                test_name: testObj.name
            });
        }
    }
});
// CONCATENATED MODULE: ./src/components/show/index/testsOfChoice.vue?vue&type=script&lang=js&
 /* harmony default export */ var index_testsOfChoicevue_type_script_lang_js_ = (testsOfChoicevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/show/index/testsOfChoice.vue?vue&type=style&index=0&id=14139bb4&lang=scss&scoped=true&
var testsOfChoicevue_type_style_index_0_id_14139bb4_lang_scss_scoped_true_ = __webpack_require__("Rnah");

// CONCATENATED MODULE: ./src/components/show/index/testsOfChoice.vue






/* normalize component */

var testsOfChoice_component = Object(componentNormalizer["a" /* default */])(
  index_testsOfChoicevue_type_script_lang_js_,
  testsOfChoicevue_type_template_id_14139bb4_scoped_true__render,
  testsOfChoicevue_type_template_id_14139bb4_scoped_true__staticRenderFns,
  false,
  null,
  "14139bb4",
  null
  
)

/* harmony default export */ var testsOfChoice = (testsOfChoice_component.exports);
// EXTERNAL MODULE: ./src/components/show/toSort.vue + 4 modules
var toSort = __webpack_require__("YdLG");

// EXTERNAL MODULE: ./src/components/common/gotoTop.vue + 4 modules
var gotoTop = __webpack_require__("bwqu");

// EXTERNAL MODULE: ./src/components/common/yxlCopyright.vue + 4 modules
var yxlCopyright = __webpack_require__("Oe96");

// EXTERNAL MODULE: ./src/pages/show/skeleton/showIndex-skeleton.vue + 4 modules
var showIndex_skeleton = __webpack_require__("gTic");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/yxyBox.vue?vue&type=template&id=07f0793d&
var yxyBoxvue_type_template_id_07f0793d__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showProps&&_vm.shwoBox)?_c('v-touch',{staticClass:"yxybox",on:{"tap":function($event){return _vm.goBack()}}},[_c('v-touch',{staticClass:"closeBoxe",on:{"tap":function($event){return _vm.close()}}})],1):_vm._e()}
var yxyBoxvue_type_template_id_07f0793d__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/show/yxyBox.vue?vue&type=template&id=07f0793d&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/yxyBox.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/* harmony default export */ var yxyBoxvue_type_script_lang_js_ = ({
    components: {},
    data: function data() {
        return {
            shwoBox: true
        };
    },

    props: {
        showProps: {
            type: Boolean,
            default: false
        }
    },
    watch: {},
    computed: {},
    mounted: function mounted() {},

    methods: {
        close: function close() {
            this.shwoBox = false;
        },
        goBack: function goBack() {
            this.$emit('closeYxybox');
        }
    }
});
// CONCATENATED MODULE: ./src/components/show/yxyBox.vue?vue&type=script&lang=js&
 /* harmony default export */ var show_yxyBoxvue_type_script_lang_js_ = (yxyBoxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/show/yxyBox.vue?vue&type=style&index=0&lang=scss&
var yxyBoxvue_type_style_index_0_lang_scss_ = __webpack_require__("BfSO");

// CONCATENATED MODULE: ./src/components/show/yxyBox.vue






/* normalize component */

var yxyBox_component = Object(componentNormalizer["a" /* default */])(
  show_yxyBoxvue_type_script_lang_js_,
  yxyBoxvue_type_template_id_07f0793d__render,
  yxyBoxvue_type_template_id_07f0793d__staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var yxyBox = (yxyBox_component.exports);
// EXTERNAL MODULE: ./src/frontend-lib/tools/cookies.js
var cookies = __webpack_require__("SXOU");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/index/interestSwiper.vue?vue&type=template&id=668e35e8&
var interestSwipervue_type_template_id_668e35e8__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interest"},[_c('div',{staticClass:"container"},[_c('v-touch',{staticClass:"interest_more",on:{"tap":function($event){return _vm.toMore()}}}),_vm._v(" "),_c('div',{staticClass:"interest_tips"}),_vm._v(" "),_c('v-touch',{staticClass:"interest_content",style:({background:_vm.initColor.bg}),on:{"tap":function($event){return _vm.recomendList()}}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content_data"},[_vm._v("- "+_vm._s(_vm.initTime)+" -")]),_vm._v(" "),_c('div',{staticClass:"content_week"},[_vm._v(_vm._s(_vm.initWeek))]),_vm._v(" "),_c('div',{staticClass:"content_title"},[_c('p',[_c('span',{staticClass:"content_title_name"},[_vm._v(_vm._s(_vm.funTest.name))]),_vm._v(" "),_c('span',{staticClass:"content_title_bg",style:({background:_vm.initColor.text_bg})})])])]),_vm._v(" "),_c('img',{staticClass:"interest_bg",attrs:{"src":_vm.funTest.introPicture,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"interest_bg2",style:({background:_vm.initColor.graph_bg})}),_vm._v(" "),_c('img',{staticClass:"interest_bg3",attrs:{"src":__webpack_require__("qYA1"),"alt":""}})])],1)])}
var interestSwipervue_type_template_id_668e35e8__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/show/index/interestSwiper.vue?vue&type=template&id=668e35e8&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/index/interestSwiper.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var interestSwipervue_type_script_lang_js_ = ({
	name: 'interest',
	components: {},
	data: function data() {
		return {};
	},

	watch: {},
	props: ['funTest'],
	computed: {
		initTime: function initTime() {
			return this.timeTransform(new Date(), 'day');
		},
		initWeek: function initWeek() {
			var weekS = new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"),
			    str = weekS[new Date().getDay()];
			return str;
		},
		initColor: function initColor() {
			return this.getColorType(parseInt(new Date().getDay()));
		}
	},
	mounted: function mounted() {},

	methods: {
		recomendList: function recomendList() {
			var that = this;
			that.$emit('testClick', this.funTest);
		},
		toMore: function toMore() {
			this.$emit('moreFunTest', '每日一测');
		}
	}
});
// CONCATENATED MODULE: ./src/components/show/index/interestSwiper.vue?vue&type=script&lang=js&
 /* harmony default export */ var index_interestSwipervue_type_script_lang_js_ = (interestSwipervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/show/index/interestSwiper.vue?vue&type=style&index=0&lang=scss&
var interestSwipervue_type_style_index_0_lang_scss_ = __webpack_require__("huM2");

// CONCATENATED MODULE: ./src/components/show/index/interestSwiper.vue






/* normalize component */

var interestSwiper_component = Object(componentNormalizer["a" /* default */])(
  index_interestSwipervue_type_script_lang_js_,
  interestSwipervue_type_template_id_668e35e8__render,
  interestSwipervue_type_template_id_668e35e8__staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var interestSwiper = (interestSwiper_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/index/showindexNav.vue?vue&type=template&id=6a04988d&
var showindexNavvue_type_template_id_6a04988d__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shownav"},[(_vm.CHANNEL_CHANNELTYPE)?[_c('v-touch',{staticClass:"shownav-box",on:{"tap":function($event){return _vm.geSort('全面评估')}}},[_c('div',{staticClass:"shownav-box-icon qmpg-icon"}),_vm._v(" "),_c('div',{staticClass:"shownav-box-text"},[_vm._v("全面评估")])]),_vm._v(" "),_c('v-touch',{staticClass:"shownav-box",on:{"tap":function($event){return _vm.geSort('健康')}}},[_c('div',{staticClass:"shownav-box-icon jkcp-icon"}),_vm._v(" "),_c('div',{staticClass:"shownav-box-text"},[_vm._v("健康测评")])]),_vm._v(" "),_c('v-touch',{staticClass:"shownav-box",on:{"tap":function($event){return _vm.geSort('性格')}}},[_c('div',{staticClass:"shownav-box-icon xgcs-icon"}),_vm._v(" "),_c('div',{staticClass:"shownav-box-text"},[_vm._v("性格测试")])]),_vm._v(" "),_c('v-touch',{staticClass:"shownav-box",on:{"tap":function($event){return _vm.geSort('职场')}}},[_c('div',{staticClass:"shownav-box-icon zccs-icon"}),_vm._v(" "),_c('div',{staticClass:"shownav-box-text"},[_vm._v("职场测试")])])]:[_c('v-touch',{staticClass:"shownav-box",on:{"tap":function($event){return _vm.geSort('趣味测试')}}},[_c('div',{staticClass:"shownav-box-icon icon-fun"}),_vm._v(" "),_c('div',{staticClass:"shownav-box-text"},[_vm._v("趣味测试")])]),_vm._v(" "),_c('v-touch',{staticClass:"shownav-box",on:{"tap":function($event){return _vm.geSort('全部')}}},[_c('div',{staticClass:"shownav-box-icon icon-nor"}),_vm._v(" "),_c('div',{staticClass:"shownav-box-text"},[_vm._v("专业测评")])]),_vm._v(" "),_c('v-touch',{staticClass:"shownav-box",on:{"tap":function($event){return _vm.geSort('全面评估')}}},[_c('div',{staticClass:"shownav-box-icon icon-pro"}),_vm._v(" "),_c('div',{staticClass:"shownav-box-text"},[_vm._v("全面评估")])])]],2)}
var showindexNavvue_type_template_id_6a04988d__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/show/index/showindexNav.vue?vue&type=template&id=6a04988d&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/index/showindexNav.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var showindexNavvue_type_script_lang_js_ = ({
  name: 'test',
  components: {},
  data: function data() {
    return {};
  },

  watch: {},
  props: {},
  computed: {},
  mounted: function mounted() {},

  methods: {
    geSort: function geSort(type) {
      this.$emit('viewMoreSort', type);
      this.$stat.send({ name: '点击首页快捷入口', properties: { 按钮: type } });
      // 微站-测评大厅-查看测评分类 神策埋点
      this.$wechatTrackEvent('weizhan_cepinghome_checktestsort', {
        test_sort: type == '全部' ? '专业测试' : type
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/show/index/showindexNav.vue?vue&type=script&lang=js&
 /* harmony default export */ var index_showindexNavvue_type_script_lang_js_ = (showindexNavvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/show/index/showindexNav.vue?vue&type=style&index=0&lang=scss&
var showindexNavvue_type_style_index_0_lang_scss_ = __webpack_require__("Rk3p");

// CONCATENATED MODULE: ./src/components/show/index/showindexNav.vue






/* normalize component */

var showindexNav_component = Object(componentNormalizer["a" /* default */])(
  index_showindexNavvue_type_script_lang_js_,
  showindexNavvue_type_template_id_6a04988d__render,
  showindexNavvue_type_template_id_6a04988d__staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var showindexNav = (showindexNav_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/index/proSwiper.vue?vue&type=template&id=4a1c8de3&
var proSwipervue_type_template_id_4a1c8de3__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.indexList.length > 0)?_c('div',{staticClass:"proList"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"mainTitle pro"}),_vm._v(" "),_c('div',{staticClass:"sceTitle"},[_vm._v("用新的视角遇见更好的自己")]),_vm._v(" "),_c('v-touch',{staticClass:"proList-more",on:{"tap":function($event){return _vm.toMore()}}},[_c('div',{staticClass:"more-type"},[_vm._v("更多")])]),_vm._v(" "),_c('div',{staticClass:"pro-top"},_vm._l((_vm.indexList),function(item,index){return _c('v-touch',{key:index,staticClass:"pro-box",on:{"tap":function($event){return _vm.testTap(item)}}},[_c('div',{staticClass:"pro-box-bg"},[_c('img',{attrs:{"src":item.introPicture,"alt":""}})])])}),1)],1)]):_vm._e()}
var proSwipervue_type_template_id_4a1c8de3__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/show/index/proSwiper.vue?vue&type=template&id=4a1c8de3&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/index/proSwiper.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import {swiper, swiperSlide, swiperPlugins} from 'vue-awesome-swiper'


/* harmony default export */ var proSwipervue_type_script_lang_js_ = ({
    name: 'indexList',
    /*components: {
        swiper,
        swiperSlide
    },*/
    props: ['indexList', 'type', 'anchorTag'],
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['channelId']), {
        isItemDescTwoLine: function isItemDescTwoLine() {
            var that = this;
            var result = 0;
            that.indexList.map(function (item) {
                if (item.name.length > 8) {
                    result++;
                }
            });
            return !!(result > 0);
        }
    }),
    data: function data() {
        return {
            swiper: null,
            swiperSlide: null,
            loadReady: false,
            swiperOption: {
                autoplay: 0,
                slidesPerView: 'auto',
                paginationClickable: true,
                loop: false,
                pagination: '.swiper-pagination'
            }
        };
    },
    mounted: function mounted() {
        if (this.anchorTag != '') {
            var anchorEl = document.querySelector('.indexList.' + this.anchorTag);
            if (anchorEl == undefined) {
                return;
            } else {
                document.body.scrollTop = anchorEl.offsetTop;
            }
        }
        ;
    },

    methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])(['setINDEXSCROLLTOP']), {
        cutNum: units["i" /* cutNum */],
        timeTransform: function timeTransform(time) {
            if (time == '' | time == undefined) {
                return '';
            }
            var rs = '';
            var thatDay = new Date(time.replace(/-/g, '/'));
            var today = new Date();
            var c0 = function c0(num) {
                return num * 1 < 10 ? '0' + num : num;
            };
            if (today.getFullYear() == thatDay.getFullYear() & today.getMonth() == thatDay.getMonth() & today.getDate() == thatDay.getDate()) {
                if (today.getHours() == thatDay.getHours()) {
                    return c0(today.getMinutes()) - c0(thatDay.getMinutes()) + '分钟前';
                } else {
                    return c0(thatDay.getHours()) + ':' + c0(thatDay.getMinutes());
                }
            } else {
                return c0(thatDay.getMonth() + 1) + '-' + c0(thatDay.getDate());
            }
            return rs;
        },
        testTap: function testTap(testObj) {
            this.$emit('testClick', testObj);
            this.$stat.send({ name: '点击首页全面评估', properties: { '测评': testObj.name } });
        },
        toMore: function toMore() {
            this.$emit('viewMoreSort', '全面评估');
        }
    }),

    // 如果日后vue-awesome-swiper用的多，可以考虑分离出一个mixins
    // swiper: null,
    // swiperSlide: null,
    // loadReady: false,
    created: function created() {
        var _this = this;

        domReadyPr.then(function () {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "F3EI"));
        }).then(function (_ref) {
            var swiper = _ref.swiper,
                swiperSlide = _ref.swiperSlide;

            _this.loadReady = true;
            _this.swiper = swiper;
            _this.swiperSlide = swiperSlide;
        });
    }
});
// CONCATENATED MODULE: ./src/components/show/index/proSwiper.vue?vue&type=script&lang=js&
 /* harmony default export */ var index_proSwipervue_type_script_lang_js_ = (proSwipervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/show/index/proSwiper.vue?vue&type=style&index=0&lang=scss&
var proSwipervue_type_style_index_0_lang_scss_ = __webpack_require__("g5Ks");

// CONCATENATED MODULE: ./src/components/show/index/proSwiper.vue






/* normalize component */

var proSwiper_component = Object(componentNormalizer["a" /* default */])(
  index_proSwipervue_type_script_lang_js_,
  proSwipervue_type_template_id_4a1c8de3__render,
  proSwipervue_type_template_id_4a1c8de3__staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var proSwiper = (proSwiper_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/index/newSwiper.vue?vue&type=template&id=1ea2625b&
var newSwipervue_type_template_id_1ea2625b__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.indexList.length > 0)?_c('div',{staticClass:"newList"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"newList-banner"},[_c('div',{staticClass:"newList-banner-bg"}),_vm._v(" "),(_vm.loadReady)?_c(_vm.swiper,{tag:"component",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.indexList),function(item){return _c(_vm.swiperSlide,{key:item.scalePoolId,tag:"component"},[_c('v-touch',{staticClass:"swiperCont",on:{"tap":function($event){return _vm.testTap(item)}}},[_c('div',{staticClass:"newList-title"},[_vm._v("\n                            "+_vm._s(item.name)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"newList-desc"},[_vm._v(_vm._s(item.shortDescribe))])])],1)}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2):_vm._e()],1)])]):_vm._e()}
var newSwipervue_type_template_id_1ea2625b__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/show/index/newSwiper.vue?vue&type=template&id=1ea2625b&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/index/newSwiper.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var newSwipervue_type_script_lang_js_ = ({
    name: 'indexList',
    props: ['indexList', 'type', 'anchorTag'],
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['channelId']), {
        isItemDescTwoLine: function isItemDescTwoLine() {
            var that = this;
            var result = 0;
            that.indexList.map(function (item) {
                if (item.name.length > 8) {
                    result++;
                }
            });
            return !!(result > 0);
        }
    }),
    data: function data() {
        return {
            swiper: null,
            swiperSlide: null,
            loadReady: false,
            swiperOption: {
                autoplay: 3000,
                slidesPerView: 'auto',
                paginationClickable: true,
                loop: true,
                pagination: '.swiper-pagination'
            }
        };
    },
    mounted: function mounted() {
        if (this.anchorTag != '') {
            var anchorEl = document.querySelector('.indexList.' + this.anchorTag);
            if (anchorEl == undefined) {
                return;
            } else {
                document.body.scrollTop = anchorEl.offsetTop;
            }
        }
        ;
    },

    methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])(['setINDEXSCROLLTOP']), {
        cutNum: units["i" /* cutNum */],
        timeTransform: function timeTransform(time) {
            if (time == '' | time == undefined) {
                return '';
            }
            var rs = '';
            var thatDay = new Date(time.replace(/-/g, '/'));
            var today = new Date();
            var c0 = function c0(num) {
                return num * 1 < 10 ? '0' + num : num;
            };
            if (today.getFullYear() == thatDay.getFullYear() & today.getMonth() == thatDay.getMonth() & today.getDate() == thatDay.getDate()) {
                if (today.getHours() == thatDay.getHours()) {
                    return c0(today.getMinutes()) - c0(thatDay.getMinutes()) + '分钟前';
                } else {
                    return c0(thatDay.getHours()) + ':' + c0(thatDay.getMinutes());
                }
            } else {
                return c0(thatDay.getMonth() + 1) + '-' + c0(thatDay.getDate());
            }
            return rs;
        },
        testTap: function testTap(testObj) {
            this.$emit('testClick', testObj, this.type);
        }
    }),
    created: function created() {
        var _this = this;

        domReadyPr.then(function () {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "F3EI"));
        }).then(function (_ref) {
            var swiper = _ref.swiper,
                swiperSlide = _ref.swiperSlide;

            _this.loadReady = true;
            _this.swiper = swiper;
            _this.swiperSlide = swiperSlide;
        });
    }
});
// CONCATENATED MODULE: ./src/components/show/index/newSwiper.vue?vue&type=script&lang=js&
 /* harmony default export */ var index_newSwipervue_type_script_lang_js_ = (newSwipervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/show/index/newSwiper.vue?vue&type=style&index=0&lang=scss&
var newSwipervue_type_style_index_0_lang_scss_ = __webpack_require__("atqH");

// CONCATENATED MODULE: ./src/components/show/index/newSwiper.vue






/* normalize component */

var newSwiper_component = Object(componentNormalizer["a" /* default */])(
  index_newSwipervue_type_script_lang_js_,
  newSwipervue_type_template_id_1ea2625b__render,
  newSwipervue_type_template_id_1ea2625b__staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var newSwiper = (newSwiper_component.exports);
// EXTERNAL MODULE: ./src/pages/show/activity/2021525/count-down.vue + 4 modules
var count_down = __webpack_require__("dhJ/");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/matching/components/matchingEntrance.vue?vue&type=template&id=6b86ba56&scoped=true&
var matchingEntrancevue_type_template_id_6b86ba56_scoped_true__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matching__entrance",class:{'is-list': _vm.showList.length},on:{"click":_vm.toMatchingDetail}},[(_vm.entranceData.finishStatus === 2)?_c('span',{staticClass:"matching__unfinish"},[_vm._v("未完成")]):_vm._e(),_vm._v(" "),(_vm.showList.length)?[_vm._l((_vm.showList),function(item,index){return _c('img',{key:index,style:({'z-index': _vm.showList.length - index}),attrs:{"src":item,"alt":""}})}),_vm._v(" "),(_vm.entranceData.matchList.length > 7)?_c('img',{attrs:{"src":__webpack_require__("RIAs"),"alt":""}}):_vm._e()]:_vm._e()],2)}
var matchingEntrancevue_type_template_id_6b86ba56_scoped_true__staticRenderFns = []


// CONCATENATED MODULE: ./src/pages/matching/components/matchingEntrance.vue?vue&type=template&id=6b86ba56&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/matching/components/matchingEntrance.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var matchingEntrancevue_type_script_lang_js_ = ({
  props: {
    entranceData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    showList: function showList() {
      if (this.entranceData.matchList && this.entranceData.matchList.length) {
        return this.entranceData.matchList.slice(0, 7);
      }
      return [];
    }
  },

  methods: {
    toMatchingDetail: function toMatchingDetail() {
      // 未购买且未完成答题
      if (!this.entranceData.buyStatus && this.entranceData.finishStatus === 2) {
        this.createOrder();
        return;
      }
      this.$router.push({
        name: 'matchingDetail',
        query: {
          channelId: this.channelId
        }
      });
    },


    // 去测试
    createOrder: function createOrder() {
      this.$http.get(apis["a" /* default */].matchTestToReport, {
        params: {
          channelId: this.channelId
        }
      }).then(function (res) {
        var _res$data = res.data,
            data = _res$data.data,
            code = _res$data.code;

        if (code === '302') {
          location.href = data;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./src/pages/matching/components/matchingEntrance.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_matchingEntrancevue_type_script_lang_js_ = (matchingEntrancevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/pages/matching/components/matchingEntrance.vue?vue&type=style&index=0&id=6b86ba56&lang=scss&scoped=true&
var matchingEntrancevue_type_style_index_0_id_6b86ba56_lang_scss_scoped_true_ = __webpack_require__("WPNh");

// CONCATENATED MODULE: ./src/pages/matching/components/matchingEntrance.vue






/* normalize component */

var matchingEntrance_component = Object(componentNormalizer["a" /* default */])(
  components_matchingEntrancevue_type_script_lang_js_,
  matchingEntrancevue_type_template_id_6b86ba56_scoped_true__render,
  matchingEntrancevue_type_template_id_6b86ba56_scoped_true__staticRenderFns,
  false,
  null,
  "6b86ba56",
  null
  
)

/* harmony default export */ var matchingEntrance = (matchingEntrance_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/show/showIndex.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



























/* harmony default export */ var showIndexvue_type_script_lang_js_ = ({
  name: "pageIndex",
  components: {
    pageTitle: pageTitle["a" /* default */],
    indexBanner: bannerSwiper,
    recomendList: testSwiper,
    testOfChoice: testsOfChoice,
    footerNav: footerNav["a" /* default */],
    toSort: toSort["a" /* default */],
    go2top: gotoTop["a" /* default */],
    yxlCopyright: yxlCopyright["a" /* default */],
    skeletonIndex: showIndex_skeleton["default"],
    couponLogo: couponLogo,
    yxyBox: yxyBox,
    interestSwiper: interestSwiper,
    showindexNav: showindexNav,
    proSwiper: proSwiper,
    newSwiper: newSwiper,
    countDown: count_down["a" /* default */],
    matchingEntrance: matchingEntrance
  },
  mixins: [pageMixin["a" /* default */]],
  data: function data() {
    return {
      OKAPI: 0,
      userStayTime: 0,
      banner: [],
      bannerLocation: 1, // 首页 banner 位置
      hotList: [],
      newList: [],
      choiceTest: [],
      proList: [],
      go2topShow: false,
      loading: false,
      allowGlobalAd: true,
      funTest: "",
      couponDialogCallback: "",
      isShowBuoy525: false,
      expireTime525: 0,
      countDownFixed: false,
      matchEntranceData: {}
    };
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(["show"]), {
    wxShareConfig: function wxShareConfig() {
      var that = this;
      return {
        title: this.CHANNEL_INTERNALCHANNEL ? this.INTERNALCHANNEL_SHARE.title : that.channelConfig.siteName,
        link: location.origin + location.pathname + "?channelId=" + that.channelId + "#" + that.$route.path,
        imgUrl: this.CHANNEL_INTERNALCHANNEL ? this.INTERNALCHANNEL_SHARE.imgUrl : that.channelConfig.logoUrl ? that.channelConfig.logoUrl : "http://static.xinli001.com/static-ceping-wz/static/images/logo-brain.png",
        desc: this.CHANNEL_INTERNALCHANNEL ? this.INTERNALCHANNEL_SHARE.desc : "专业、有趣、好玩的心理测评，用心理学探索未知的自己。",
        success: function success() {
          // 埋点
          window.TRACKER.sharePage("首页");
        },
        cancel: function cancel() {}
      };
    },
    showYxyBox: function showYxyBox() {
      if (this.yxyid) {
        return true;
      }
      return false;
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$data.fromRoute = from;
      vm.$data.debug = !!(to.query.debug * 1);
    });
  },
  created: function created() {
    var _this = this;

    var that = this;
    that.userStayTime = new Date();
    that.pullHomePageBanner({
      params: {
        channelId: that.channelId,
        bannerLocation: that.bannerLocation
      },
      callback: function callback(DATA) {
        that.banner = DATA;
        that.OKAPI++;
      }
    });

    // 最热
    that.pullHotScales({
      params: {
        channelId: that.channelId
      },
      callback: function callback(DATA) {
        that.hotList = DATA.scales;
        that.OKAPI++;
        // if (DATA.popTimeLimitCoupon) {
        //     that.couponDialogCallback = DATA.backUrl;
        // }
        // 免登陆不用请求接口
        if (!that.CHANNEL_NOT_LOGIN) {
          // 展示位置：展示位置: 1 首页弹框 2详情页弹框 3 个人中心弹框 4报告页贴片 5 趣味测试结果页弹框 6其他
          _this.getCoupon(1);
          //双十二活动弹窗
          _this.getVipPopWindow(1);
        }
      }
    });
    // 最新
    that.pullNewScales({
      params: {
        channelId: that.channelId
      },
      callback: function callback(DATA) {
        DATA.scales.map(function (item, index) {
          if (index < 6) {
            that.newList.push(item);
          }
        });
        that.OKAPI++;
      }
    });
    // 精选测评
    that.pullChoiceScales({
      params: {
        channelId: that.channelId
      },
      callback: function callback(DATA) {
        that.choiceTest = DATA.scales;
        that.OKAPI++;
      }
    });
    // 免登陆不用请求数据
    if (!that.CHANNEL_NOT_LOGIN) {
      // 关闭趣味测试
      //每日一测
      that.getDailyFunTest({
        params: {}
      }).then(function (res) {
        if (res.code == 1) {
          that.funTest = res.data;
        }
      });
      //专业测评
      that.getProfessionalScales({
        params: {
          channelId: that.channelId,
          category: "",
          sortType: 2,
          page: 1,
          pageSize: 2,
          isHome: 1
        }
      }).then(function (res) {
        if (res.code == 1) {
          that.proList = res.data.scales;
        }
      });

      // 创新匹配测评
      this.getMatchEntrance();
    }
  },
  mounted: function mounted() {
    var that = this;
    that.loading = true;
    this.$nextTick(function () {
      document.addEventListener("scroll", that.setShowToSort);
    });
    that.showPromotion();
    if (that.$route.query.delPdf) {
      that.setTOASTTEXT({ str: "正在制作中稍后请留意邮箱", status: "success" });
    }
    var dialogStore = "oneDayfristdialogStore" + new Date().getDate();
    if (dialogStore != localStorage.getItem('dialogStore', dialogStore) && this._setshowProps) {
      this.setShowPopWindowStatus(true);
    }

    // 首页加载弹窗浮标数据
    this.initAdCoupon('showIndex');

    if (this.channelConfig.channelType && this.is2021525) {
      this.getActivity525Countdown();
    }

    // 微站-测评大厅访问 神策埋点
    this.$wechatTrackPageView('weizhan_cepinghome_view', {
      tracing_mark: this.$route.query.sourceName
    });
  },
  updated: function updated() {},
  beforeDestroy: function beforeDestroy() {
    var that = this;
    document.removeEventListener("scroll", that.setShowToSort);
    // this.setLOADINGTEXT('');
    that.loading = false;
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    next();
  },

  watch: {
    OKAPI: function OKAPI(newVal, oldVal) {
      var that = this;
      if (newVal == 4) {
        if (that.$route.query.noAnchor != 1) {
          that.$nextTick(function () {
            if (that.show.INDEXSCROLLTOP != "") {
              document.body.scrollTop = that.show.INDEXSCROLLTOP;
            }
          });
        }
        that.loading = false;
      }
    },
    IS_WECHAT_CHANNELTYPE: function IS_WECHAT_CHANNELTYPE() {
      if (this.IS_WECHAT_CHANNELTYPE) {
        this.initAdCoupon('showIndex');
      }
    },
    channelConfig: function channelConfig(nv) {
      if (nv.channelType && this.is2021525) {
        this.getActivity525Countdown();
      }
    },
    userInfo: function userInfo(_userInfo) {
      if (_userInfo.userKey) {
        this.getMatchEntrance();
      }
    }
  },
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])(["setINDEXSCROLLTOP"]), Object(vuex_esm["b" /* mapActions */])(["pullHomePageBanner", "pullHotScales", "pullNewScales", "pullChoiceScales", "getDailyFunTest", "getProfessionalScales", "receiveCoupon"]), Object(vuex_esm["d" /* mapMutations */])(["setGlobalAdConfirm", "setGlobalAdCancel", "setGlobalAdPeriod", "setGlobalAdShow", "setShowPopWindowStatus"]), {

    // 获取2021-525活动倒计时
    getActivity525Countdown: function getActivity525Countdown() {
      var _this2 = this;

      this.$http.get(apis["a" /* default */].activity525Countdown).then(function (res) {
        var _res$data = res.data,
            data = _res$data.data,
            code = _res$data.code;

        if (code === '1') {
          _this2.expireTime525 = data.expireTime;
          _this2.isShowBuoy525 = data.is_show;
        }
      });
    },
    getMatchEntrance: function getMatchEntrance() {
      var _this3 = this;

      if (!this.userInfo.userKey) return;
      this.$http.get(apis["a" /* default */].matchEntrance, {
        params: {
          channelId: this.channelId,
          userKey: this.userInfo.userKey
        }
      }).then(function (res) {
        _this3.matchEntranceData = res.data.data || {};
      });
    },
    _inPromotion: function _inPromotion() {
      this.allowGlobalAd = true;
      this.showPromotion();
    },
    bannerClickHandler: function bannerClickHandler(item, index) {
      var that = this;
      var url = item.redirectUrl + "&enterFrom=banner";
      if (that.woNiuSourceName) {
        url += "&unique=" + that.woNiuSourceName;
      }
      window.location.href = url;
      // 埋点
      window.TRACKER.indexBannerClick(index, item.name);
      // 微站-测评大厅-banner图点击 神策埋点
      this.$wechatTrackEvent('weizhan_cepinghome_bannerclick', {
        item_location: index + 1,
        item_id: item.scalePoolId, // 暂时处理测试id,后续要兼容其他id
        item_name: item.name
      });
    },
    testClickHandler: function testClickHandler(testObj, type) {
      var that = this;
      that.setINDEXSCROLLTOP(document.body.scrollTop);

      window.TRACKER.indexTestSwiper(testObj.name, type);

      if (testObj.h5Url) {
        var url = testObj.h5Url;
        if (that.woNiuSourceName) {
          url += "&unique=" + that.woNiuSourceName;
        }
        location.href = url;
      } else {
        that.$router.push({
          name: "testDetail",
          path: "/detail",
          params: {
            testId: testObj.scalePoolId
          },
          query: {
            channelId: that.channelId,
            yxyid: that.yxyid,
            unique: that.woNiuSourceName,
            sourceName: that.$route.query.sourceName
          }
        });
      }
    },
    interestClickHandler: function interestClickHandler(testObj) {
      console.log("进入趣味测试");
      var colorType = parseInt(new Date().getDay());
      this.$stat.send({
        name: "点击首页每日趣测",
        properties: { 渠道名称: this.CHANNELNAME, 测试名称: testObj.name }
      });
      this.$router.push({
        path: "./ceshi/" + testObj.id,
        query: {
          channelId: this.channelId,
          colorType: colorType,
          sortType: 2
        }
      });
    },
    setShowToSort: function setShowToSort() {
      // 控制是否显示回到顶部
      if (!this.$refs.toSortLink || !this.$refs.toSortLink.$el) {
        return;
      }
      var offset = this.$refs.toSortLink.$el.offsetTop;
      var offsetHeight = document.body.offsetHeight + document.body.scrollTop + this.$refs.toSortLink.$el.offsetHeight / 2;
      if (offsetHeight > offset) {
        this.go2topShow = true;
      } else {
        this.go2topShow = false;
      }

      if (this.is2021525) {
        var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        this.countDownFixed = scrollTop > 200;
      }
    },
    _viewMoreSort: function _viewMoreSort(type) {
      var that = this;
      if (type == "每日一测") {
        this.$stat.send({
          name: "点击首页每日趣测-更多",
          properties: { 渠道名称: this.CHANNELNAME }
        });
      }
      that.$router.push({
        name: "sorts",
        path: "/sorts",
        query: {
          channelId: that.channelId,
          sort: type ? type : ""
        }
      });
    },
    showPromotion: function showPromotion() {
      var that = this;
      if (that.channelId == 1166) {
        return;
      }
      if (!that.userInfo.userKey) {
        return;
      }
    },
    _closeYxybox: function _closeYxybox() {
      window.location.href = "http://168renwu.com/Api/Jump/index?yxyid=" + this.yxyid;
    },
    toYXLConsultPage: function toYXLConsultPage() {
      this.$wechatTrackEvent('weizhan_cepinghome_consultingbanner');
      location.href = 'https://m.xinli001.com/consult/special-price?_source_page_=5ZKo6K-i5Li76aG1VjU&channel_flag=ctdl_yxljxwz_banner';
    }
  })
});
// CONCATENATED MODULE: ./src/pages/show/showIndex.vue?vue&type=script&lang=js&
 /* harmony default export */ var show_showIndexvue_type_script_lang_js_ = (showIndexvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/pages/show/showIndex.vue?vue&type=style&index=0&lang=scss&
var showIndexvue_type_style_index_0_lang_scss_ = __webpack_require__("zPm4");

// CONCATENATED MODULE: ./src/pages/show/showIndex.vue






/* normalize component */

var showIndex_component = Object(componentNormalizer["a" /* default */])(
  show_showIndexvue_type_script_lang_js_,
  showIndexvue_type_template_id_98168694__render,
  showIndexvue_type_template_id_98168694__staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var showIndex = (showIndex_component.exports);
// CONCATENATED MODULE: ./src/router/show.js
/**
 * 包含展示端的页面路由
 * 首页
 * 分类页
 * 测评详情页
 * 套餐详情页
 * 我的测评页
 */





/* harmony default export */ var router_show = ({
    name: 'show',
    path: '/index',
    component: show,
    children: [
    // search
    {
        name: 'search',
        path: '/search',
        meta: {
            title: '搜索页'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wFbk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '搜索页',
                    err: err
                });
            });
        }
    },
    // index
    {
        name: 'showIndex',
        path: '/index',
        meta: {
            title: '首页'
        },
        component: showIndex
    },
    // redirect to index with channelId
    {
        path: '/index/:channelId',
        redirect: function redirect(to) {
            // 方法接收 目标路由 作为参数
            return {
                path: '/index',
                query: {
                    channelId: to.params.channelId
                }
            };
        }
    },
    // /sorts 分类页
    {
        name: 'sorts',
        path: '/sorts',
        meta: {
            title: '分类页'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("e+tJ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '分类页',
                    err: err
                });
            });
        }
    },
    // testdetail 测评详情
    {
        name: 'testDetail',
        path: '/detail/:testId',
        meta: {
            title: '测评详情页',
            fullTitle: function fullTitle() {
                var rs = '测评详情页';
                if (this.query.enterFrom == 'testDetail') {
                    rs += '-大家都在测';
                }
                return rs;
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(2/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vIDa")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '测评详情页',
                    err: err
                });
            });
        }
    }, {
        name: 'testDetailIQ',
        path: '/detail-iq',
        meta: {
            title: '测评详情页',
            fullTitle: function fullTitle() {
                var rs = '测评详情页';
                return rs;
            },
            hideFooter: true // 隐藏首页底部栏
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(93).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3XCI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '测评详情页',
                    err: err
                });
            });
        }
    }, {
        name: 'testDetailYY',
        path: '/detail-yy/:testId',
        meta: {
            title: '抑郁测评二选一',
            fullTitle: function fullTitle() {
                var rs = '抑郁测评二选一';
                return rs;
            },
            hideFooter: true // 隐藏首页底部栏
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4jKl")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '抑郁测评二选一',
                    err: err
                });
            });
        }
    }, {
        name: 'testDetailMBTI',
        path: '/detail-mbti/:testId',
        meta: {
            title: 'MBTI二选一',
            fullTitle: function fullTitle() {
                var rs = 'MBTI二选一';
                return rs;
            },
            hideFooter: true // 隐藏首页底部栏
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("qsiv")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: 'MBTI二选一',
                    err: err
                });
            });
        }
    },
    // 2021525支付成功页
    {
        name: 'paySuccess',
        path: '/paysuccess',
        meta: {
            title: '支付成功'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(86).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("uZ/8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        name: 'toufangDetail',
        path: '/toufang_detail/:testId/:channelId',
        meta: {
            title: '百度投放详情页',
            fullTitle: function fullTitle() {
                var rs = '百度投放详情页';
                if (this.query.enterFrom == 'toufangDetail') {
                    rs += '-大家都在测';
                }
                return rs;
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(2/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vIDa")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '百度投放详情页',
                    err: err
                });
            });
        }
    },
    // redirect to testdetail with channelId
    {
        path: '/detail/:testId/:channelId',
        redirect: function redirect(to) {
            // 方法接收 目标路由 作为参数
            return {
                path: '/detail/:testId',
                query: {
                    channelId: to.params.channelId
                }
            };
        }
    },
    // combodetail 套餐详情
    {
        name: 'comboDetail',
        path: '/combo/:comboId',
        meta: {
            title: '套餐详情页'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0xRo")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '套餐详情页',
                    err: err
                });
            });
        }
    }, {
        path: '/combo/:comboId/:channelId',
        redirect: function redirect(to) {
            // 方法接收 目标路由 作为参数
            return {
                path: '/combo/:comboId',
                query: {
                    channelId: to.params.channelId
                }
            };
        }
    },
    // 我的测评
    {
        name: 'myTests',
        path: '/mine/:status',
        meta: {
            title: '我的测评',
            fullTitle: function fullTitle() {
                var rs = '我的测评';
                if (this.params.status == 0) {
                    rs += '-未完成';
                } else if (this.params.status == 1) {
                    rs += '-已完成';
                } else {
                    rs = '收藏';
                }
                return rs;
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eah0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '我的测评页',
                    err: err
                });
            });
        }
    }, {
        path: '/mine/',
        redirect: '/mine/0'
    }, {
        path: '/mine/:status/:channelId',
        redirect: function redirect(to) {
            // 方法接收 目标路由 作为参数
            return {
                query: {
                    channelId: to.params.channelId
                }
            };
        }
    },
    // 免登陆个人中心
    {
        name: 'noLoginCenter',
        path: '/noLoginCenter',
        meta: {
            title: '个人中心',
            fullTitle: function fullTitle() {
                var rs = '个人中心';
                return rs;
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(81).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8lw1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '个人中心页',
                    err: err
                });
            });
        }
    },
    // index
    {
        name: 'showIndex-skeleton',
        path: '/indexSkeleton',
        meta: {
            title: '首页骨架图'
        },
        component: function component(resolve) {
            return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gTic")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {});
        }
    },
    // index
    {
        name: 'sort-skeleton',
        path: '/sortSkeleton',
        meta: {
            title: '分类页骨架图'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(141).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ypED")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {});
        }
    },
    // index
    {
        name: 'mine-skeleton',
        path: '/mineSkeleton',
        meta: {
            title: '我的测评骨架图'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(142).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("cL6C")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {});
        }
    }, {
        name: 'myCoupon',
        path: '/myCoupon',
        meta: {
            title: '我的优惠券',
            fullTitle: function fullTitle() {
                return '我的优惠券';
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aM9U")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '我的优惠券',
                    err: err
                });
            });
        }
    }, {
        name: 'myReports',
        path: '/myReports',
        meta: {
            title: '我的报告',
            fullTitle: function fullTitle() {
                return '我的报告';
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DmUL")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '我的报告',
                    err: err
                });
            });
        }
    }, {
        name: 'myEvaluate',
        path: '/myEvaluate',
        meta: {
            title: '我的评价',
            fullTitle: function fullTitle() {
                return '我的评价';
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EJ5Z")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '我的评价',
                    err: err
                });
            });
        }
    }, {
        name: 'myCard',
        path: '/myCard',
        meta: {
            title: '卡包',
            fullTitle: function fullTitle() {
                return '卡包';
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(118).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mhEI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '卡包',
                    err: err
                });
            });
        }
    }, {
        name: 'cardDetail',
        path: '/card-detail',
        meta: {
            title: '卡详情',
            fullTitle: function fullTitle() {
                return '卡详情';
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(102).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("LI5v")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '卡详情',
                    err: err
                });
            });
        }
    }, {
        name: 'cardRecord',
        path: '/card-record',
        meta: {
            title: '使用记录',
            fullTitle: function fullTitle() {
                return '使用记录';
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(144).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("bdNn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '使用记录',
                    err: err
                });
            });
        }
    }, {
        name: 'cardDesc',
        path: '/card-desc',
        meta: {
            title: '领取成功',
            fullTitle: function fullTitle() {
                return '领取成功';
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(128).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("YyGj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '领取成功',
                    err: err
                });
            });
        }
    }, {
        name: 'myOrder',
        path: '/myOrder',
        meta: {
            title: '我的订单',
            fullTitle: function fullTitle() {
                return '我的订单';
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lOSH")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '我的订单',
                    err: err
                });
            });
        }
    }, {
        name: 'myLike',
        path: '/myLike',
        meta: {
            title: '个人中心-喜欢列表',
            fullTitle: function fullTitle() {
                return '个人中心-喜欢列表';
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("E9bB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '个人中心-喜欢列表',
                    err: err
                });
            });
        }
    }, {
        name: 'myFavorite',
        path: '/myFavorite',
        meta: {
            title: '个人中心-收藏列表',
            fullTitle: function fullTitle() {
                return '个人中心-收藏列表';
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("d4Y0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '个人中心-收藏列表',
                    err: err
                });
            });
        }
    },
    // 趣味测试
    {
        name: 'ceshi',
        path: '/ceshi/:id',
        meta: {
            title: '趣味测试详情'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(96).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8ysw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '趣味测试详情',
                    err: err
                });
            });
        }
    }, {
        name: 'fun-result',
        path: '/ceshi/:id/result/:resultId',
        meta: {
            title: '测试结果页'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(74).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("zVNq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '测试结果页',
                    err: err
                });
            });
        }
    }, {
        name: 'searchOrder',
        path: '/searchOrder',
        meta: {
            title: '查询订单',
            fullTitle: function fullTitle() {
                return '查询订单';
            }
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eQxf")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '查询订单',
                    err: err
                });
            });
        }
    }, {
        name: 'vip4Detail',
        path: '/vip4Detail',
        meta: {
            title: '会员详情页'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jcym")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '会员详情页',
                    err: err
                });
            });
        }
    }, {
        name: 'vip4-user-center',
        path: '/vip4UserCenter',
        meta: {
            title: '会员中心'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1f+f")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '会员中心',
                    err: err
                });
            });
        }
    }]
});
// CONCATENATED MODULE: ./src/router/answer_report.js
/**
 * 包含答题和报告，报告分享的路由
 */



/* harmony default export */ var answer_report = ([{
  name: 'answerFrame',
  path: '/answer',
  meta: {
    title: '答题初始化页面'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9uT8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '答题初始化页',
        err: err
      });
    });
  },
  children: [{
    name: 'answerGender',
    path: 'gender',
    meta: {
      title: '答题性别选择页'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(136).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("CDQ2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        Object(units["s" /* loadPageFail */])({
          pagename: '性别选择页',
          err: err
        });
      });
    }
  }, {
    name: 'answerState',
    path: 'state',
    meta: {
      title: '答题测试说明页'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UjeW")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        Object(units["s" /* loadPageFail */])({
          pagename: '测试说明页',
          err: err
        });
      });
    }
  }, {
    name: 'answerList',
    path: 'list',
    meta: {
      title: '答题页'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SNLA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        Object(units["s" /* loadPageFail */])({
          pagename: '答题页',
          err: err
        });
      });
    }
  }, {
    name: 'answerList2',
    path: 'list2',
    meta: {
      title: '答题页'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lGw4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        console.log(err.message);
        alert('加载页面失败');
      });
    }
  },
  // 新房树人
  {
    name: 'htpState',
    path: 'htpState',
    meta: {
      title: '答题测试说明页'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(124).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/SF7")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        Object(units["s" /* loadPageFail */])({
          pagename: '测试说明页',
          err: err
        });
      });
    }
  }, {
    name: 'htpPainting',
    path: 'htpPainting',
    meta: {
      title: '绘画页'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(92).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hF0K")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        Object(units["s" /* loadPageFail */])({
          pagename: '绘画页',
          err: err
        });
      });
    }
  }, {
    name: 'answerPainting',
    path: 'painting',
    meta: {
      title: '照片上传页'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3o0q")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        Object(units["s" /* loadPageFail */])({
          pagename: '照片上传页',
          err: err
        });
      });
    }
  }, {
    name: 'answerListHtp',
    path: 'listHtp',
    meta: {
      title: '房树人答题页',
      newZhugeTitle: '房树人'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yem5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        Object(units["s" /* loadPageFail */])({
          pagename: '房树人答题页',
          err: err
        });
      });
    }
  }, {
    name: 'answerListChildDraw',
    path: 'listChildDraw',
    meta: {
      title: '答题页'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("sZiR")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        Object(units["s" /* loadPageFail */])({
          pagename: '答题页',
          err: err
        });
      });
    }
  }, {
    name: 'answerTransfer',
    path: 'transfer',
    meta: {
      title: '答题中转页'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(153).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ONkN")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        alert('加载页面失败');
      });
    }

  }, {
    name: 'topAnswerList',
    path: 'topAnswerList',
    meta: {
      title: '答题页'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("uq7u")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        console.log(err.message);
        alert('加载页面失败');
      });
    }
  }, {
    name: 'testInstructions',
    path: '/testInstructions',
    meta: {
      title: '测试须知'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(139).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("E7mN")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        console.log(err.message);
        alert('加载页面失败');
      });
    }
  }]
}, {
  name: 'login',
  path: '/login',
  meta: {
    title: '登录/注册'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(113).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JlTt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'finishTips',
  path: '/finishTips',
  meta: {
    title: '测评完成'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(135).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("q8yT")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'applyAssign',
  path: '/applyAssign',
  meta: {
    title: '申请分配测评'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(120).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NV+C")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'auditStatus',
  path: '/auditStatus',
  meta: {
    title: ''
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(126).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MBm2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/report',
  meta: {
    title: '报告页'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(149).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Pm5a")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    name: 'testReport',
    path: '/',
    meta: {
      title: '报告页'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9xiw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        Object(units["s" /* loadPageFail */])({
          pagename: '报告页',
          err: err
        });
      });
    }
  }, {
    name: 'reportPreview',
    path: 'preview',
    meta: {
      title: '报告分享预览'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZZh4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        Object(units["s" /* loadPageFail */])({
          pagename: '报告分享预览页',
          err: err
        });
      });
    }
  }, {
    name: 'shareReport',
    path: 'share/:employeeScaleId/:scaleId/:companyScaleId/:username/:isBackRequest/:isDisplayVote/:channelId',
    meta: {
      title: '报告分享页'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Acey")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        Object(units["s" /* loadPageFail */])({
          pagename: '报告分享页',
          err: err
        });
      });
    }
  }]
}, {
  path: '/report2',
  name: 'report2',
  meta: {
    title: '报告页'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("U1YW")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/genenalReport',
  meta: {
    title: '报告聚合页'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2abG")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'readingReport',
  path: '/readingReport',
  meta: {
    title: '报告解读'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(89).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RRgs")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '报告解读页',
        err: err
      });
    });
  }
}, {
  name: 'showWishes',
  path: '/showWishes',
  meta: {
    title: '晒一晒'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(80).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7ifZ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '晒一晒',
        err: err
      });
    });
  }
}, {
  name: 'voiceDetail',
  path: '/voiceDetail',
  meta: {
    title: '分享落地页'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VrVg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '分享落地页',
        err: err
      });
    });
  }
}, {
  name: 'reportPdf',
  path: '/reportPdf/:accountId/:channelId/:uid/:enterFrom/:tabModuleId/:userKey/:userNickName',
  meta: {
    title: '报告页Pdf'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("bnUg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/topReport',
  name: 'topReport',
  meta: {
    title: '报告页'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nSHl")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/newReport',
  name: 'newReport',
  meta: {
    title: '报告页'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lFbI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'newreportPdf',
  path: '/newreportPdf/:accountId/:channelId/:uid/:enterFrom/:tabModuleId/:userKey/:userNickName',
  meta: {
    title: '报告页Pdf'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lFbI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'scl90Report',
  path: '/scl90Report',
  mata: {
    title: '订制报告'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(123).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7Gun")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'generalReport',
  path: '/generalReport',
  meta: {
    title: '报告聚合页'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ku4k")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'inreadingTopreport',
  path: '/inreadingTopreport',
  meta: {
    title: '高价测试报告页-组件调页面'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EXX6")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/zxSalesQrcode',
  name: 'zxSalesQrcode',
  meta: {
    title: '报告页'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(127).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("l3I/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}]);
// CONCATENATED MODULE: ./src/router/gift.js
// 赠送相关，而又不是在show页面展示的路由


/* harmony default export */ var gift = ([{
    name: 'giftReceive',
    path: '/giftReceive/:channelId/:receiveKey',
    meta: {
        title: '赠礼赠送页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(103).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vfOF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '赠礼赠送页',
                err: err
            });
        });
    }
}, {
    name: 'giftSuccess',
    path: '/payGift/success',
    meta: {
        title: '赠礼支付成功'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(145).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wgm/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '赠礼支付成功页',
                err: err
            });
        });
    }
}, {
    name: 'goShareGift',
    path: '/giftShare/:channelId/:receiveKey',
    meta: {
        title: '赠礼分享页'

    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(129).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("kHUI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '赠礼分享页',
                err: err
            });
        });
    }
}]);
// CONCATENATED MODULE: ./src/router/activity.js

// 赠送相关，而又不是在show页面展示的路由
// 主要是微站活动页面


/* harmony default export */ var activity = ([{
    name: '20inPromotion',
    path: '/20inPromotion',
    meta: {
        title: '双11年度狂欢大促',
        keepAlive: true, // 此组件需要被缓存
        fullTitle: function fullTitle() {
            return '双11年度狂欢大促';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("68qQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '双11年度狂欢大促',
                err: err
            });
        });
    }
}, {
    name: '20rankingList',
    path: '/20rankingList',
    meta: {
        title: '人气测评排行榜',
        fullTitle: function fullTitle() {
            return '人气测评排行榜';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("k7V3")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '人气测评排行榜',
                err: err
            });
        });
    }
}, {
    name: 'inPromotion',
    path: '/inPromotion',
    meta: {
        title: '双11年度狂欢大促',
        fullTitle: function fullTitle() {
            return '双11年度狂欢大促';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(72).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("E7pU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '双11年度狂欢大促',
                err: err
            });
        });
    }
}, {
    name: 'depositSucceed',
    path: '/depositSucceed',
    meta: {
        title: '定金预付成功',
        fullTitle: function fullTitle() {
            return '定金预付成功';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(143).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UPF9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '定金预付成功',
                err: err
            });
        });
    }
}, {
    name: 'couponReceive',
    path: '/couponReceive/:channelId/:uuid',
    meta: {
        title: '领取好友优惠券'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(97).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wycv")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '领取好友优惠券',
                err: err
            });
        });
    }
}, {
    name: 'couponShare',
    path: '/couponShare',
    meta: {
        title: '赠送好友优惠券'

    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(95).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ppTO")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '赠送好友优惠券',
                err: err
            });
        });
    }
}, {
    name: 'doubleTwelve',
    path: '/doubleTwelve',
    meta: {
        title: '双十二活动专场',
        fullTitle: function fullTitle() {
            return '双十二活动专场';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(75).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wLp2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '双十二活动专场',
                err: err
            });
        });
    }
}, {
    name: 'doubleDenier',
    path: '/doubleDenier',
    meta: {
        title: '双旦活动专场',
        fullTitle: function fullTitle() {
            return '双旦活动专场';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2iVy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '双旦活动专场',
                err: err
            });
        });
    }
}, {
    name: 'aosikaShow',
    path: '/aosikaShow',
    meta: {
        title: '奥斯卡活动',
        fullTitle: function fullTitle() {
            return '奥斯卡活动';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(107).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("qze4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '奥斯卡活动',
                err: err
            });
        });
    }
}, {
    name: 'vipDetail',
    path: '/vipDetail',
    meta: {
        title: '会员详情页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aBSH")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '会员详情页',
                err: err
            });
        });
    }
}, {
    name: 'invitation',
    path: '/invitation',
    meta: {
        title: '我的邀请'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(90).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Eodx")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '我的邀请',
                err: err
            });
        });
    }
}, {
    name: 'qixiAnswer',
    path: '/qixiAnswer',
    meta: {
        title: '我在七夕躲避秀恩爱的方式'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(79).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("h9vq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '我在七夕躲避秀恩爱的方式',
                err: err
            });
        });
    }
}, {
    name: 'qixiResult',
    path: '/qixiResult',
    meta: {
        title: '我在七夕躲避秀恩爱的方式'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(73).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eBrB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '我在七夕躲避秀恩爱的方式',
                err: err
            });
        });
    }
}, {
    name: 'vipLottery',
    path: '/vipLottery',
    meta: {
        title: '入会抽奖活动'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jhQU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '入会抽奖活动',
                err: err
            });
        });
    },
    redirect: '/vipLotteryV2'
}, {
    name: 'lotteryRecord',
    path: '/lotteryRecord',
    meta: {
        title: '抽奖记录'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(100).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1x9D")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '抽奖记录',
                err: err
            });
        });
    },
    redirect: '/lotteryRecordV2'
}, {
    name: 'vip3-rights',
    path: '/vip3Rights',
    meta: {
        title: '会员权益'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("a4tE")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '会员权益',
                err: err
            });
        });
    }
}, {
    name: 'union-vip3-success',
    path: '/unionVip3Success',
    meta: {
        title: '领取成功'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(119).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ok+m")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '领取成功',
                err: err
            });
        });
    }
}, {
    name: 'vip3-detail',
    path: '/vip3Detail',
    meta: {
        title: '会员详情页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("A2Ab")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '会员详情页',
                err: err
            });
        });
    }
},
//   4.0会员
{
    name: 'welcome-vip',
    path: '/welcomeVip',
    meta: {
        title: '欢迎加入测评会员'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(130).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1Q+n")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '欢迎加入测评会员',
                err: err
            });
        });
    }
}, {
    name: 'vip4-rights',
    path: '/vip4Rights',
    meta: {
        title: '会员权益'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pOi9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '会员权益',
                err: err
            });
        });
    }
},
// 拉新活动
{
    name: 'inviteHelp',
    path: '/inviteHelp',
    meta: {
        title: '邀请好友助力'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RF6z")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '邀请好友助力',
                err: err
            });
        });
    }
}, {
    name: 'inviteHelpShare',
    path: '/inviteHelpShare',
    meta: {
        title: '邀请好友'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("WkyN")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '邀请好友',
                err: err
            });
        });
    }
}, {
    name: 'vipLotteryV2',
    path: '/vipLotteryV2',
    meta: {
        title: '入会抽奖活动'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(77).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("z4g1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '入会抽奖活动',
                err: err
            });
        });
    }
}, {
    name: 'lotteryRecordV2',
    path: '/lotteryRecordV2',
    meta: {
        title: '抽奖记录'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(99).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/zBV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '抽奖记录',
                err: err
            });
        });
    }
}, {
    name: 'portrait',
    path: '/portrait',
    meta: {
        title: '我的心理画像'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("WIs+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '我的心理画像',
                err: err
            });
        });
    }
}]);
// CONCATENATED MODULE: ./src/router/fragment.js
/**
 * 包含一些零碎的业务的路由
 */


/* harmony default export */ var fragment = ([{
    name: 'commentPage',
    path: '/comment/:status',
    meta: {
        title: function title() {
            var rs = '';
            if (this.params.status == 'write') {
                rs = '发表评价页';
            } else {
                rs = '我的评价页';
            }
            return rs;
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(87).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("m3OC")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '发表/查看评价页',
                err: err
            });
        });
    }
}, {
    name: 'commentSuccessPage',
    path: '/commentSuccess/:status',
    meta: {
        title: '评价成功页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(91).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("E+H7")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '评价成功页',
                err: err
            });
        });
    }
}, {
    name: 'commentListPage',
    path: '/commentList/:id',
    meta: {
        title: '全部评价页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(110).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UGNw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '全部评价页',
                err: err
            });
        });
    }
}, {
    name: 'doFirstEnd',
    path: '/doFirstEnd/:status',
    meta: {
        title: '先做题看报告中转页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(83).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("twzf")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '先做题看报告中转页',
                err: err
            });
        });
    }
}, {
    name: 'packIntroduce',
    path: '/buyCombo/:comboId/channelId/:channelId/orderId/:orderId',
    meta: {
        title: '套餐购买成功页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(94).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MCzh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '套餐购买成功页',
                err: err
            });
        });
    }
}, {
    name: 'myGift',
    path: '/mineGift/:status',
    meta: {
        title: '赠礼管理',
        fullTitle: function fullTitle() {
            var rs = '赠礼管理';
            if (this.params.status == 0) {
                rs += '-我送出的';
            } else if (this.params.status == 1) {
                rs += '-我收到的';
            }

            return rs;
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(109).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Wdyd")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '赠礼管理页',
                err: err
            });
        });
    }
}, {
    name: 'consultOrder',
    path: '/consultOrder',
    meta: {
        title: '填写咨询信息页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(101).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("WNEZ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '填写咨询信息页',
                err: err
            });
        });
    }
}, {
    name: 'consultSucceed',
    path: '/consultSucceed',
    meta: {
        title: '信息提交成功页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(116).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("j3m5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '信息提交成功页',
                err: err
            });
        });
    }
}, {
    name: 'testDistribution',
    path: '/testDistribution',
    meta: {
        title: '分享赚钱页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(140).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NZn1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '分享赚钱页',
                err: err
            });
        });
    }
}, {
    name: 'myTrack',
    path: '/myTrack',
    meta: {
        title: '个人中心-足迹列表',
        fullTitle: function fullTitle() {
            return '个人中心-足迹列表';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aKBa")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '个人中心-足迹列表',
                err: err
            });
        });
    }
}, {
    name: 'pangu',
    path: '/pangu',
    meta: {
        title: '盘古登录',
        fullTitle: function fullTitle() {
            return '盘古登录';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(152).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("b+H8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '盘古登录',
                err: err
            });
        });
    }
}, {
    name: 'shareCard',
    path: '/shareCard',
    meta: {
        title: '壹心理|疫区公益心理援助专线',
        fullTitle: function fullTitle() {
            return '壹心理|疫区公益心理援助专线';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(134).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("51hX")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '壹心理|疫区公益心理援助专线',
                err: err
            });
        });
    }
}, {
    name: 'myConsult',
    path: '/myConsult',
    meta: {
        title: '我的咨询订单页',
        fullTitle: function fullTitle() {
            return '我的咨询订单页';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dBTM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '我的咨询订单页',
                err: err
            });
        });
    }
}, {
    name: 'customerService',
    path: '/customerService',
    meta: {
        title: '客服消息页',
        fullTitle: function fullTitle() {
            return '客服消息页';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(82).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RxrT")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '客服消息页',
                err: err
            });
        });
    }
}, {
    name: 'paymentYxlZixunSuccess',
    path: '/paymentYxlZixunSuccess',
    meta: {
        title: '成功购买咨询页',
        fullTitle: function fullTitle() {
            return '成功购买咨询页';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(85).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("oUlD")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '成功购买咨询页',
                err: err
            });
        });
    }
}]);
// CONCATENATED MODULE: ./src/router/ceshi.js
/**
 * 趣味测试页面路由
 */


/* harmony default export */ var ceshi = ([{
    name: 'answer',
    path: '/ceshi/:id/answer',
    meta: {
        title: '趣味测试答题页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(148).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("j4oQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '趣味测试答题页',
                err: err
            });
        });
    }
}]);
// CONCATENATED MODULE: ./src/router/member.js
// vip 路由


/* harmony default export */ var member = ([{
    name: 'member',
    path: '/member',
    meta: {
        title: '会员购买成功页 ',
        newZhugeTitle: '会员年卡活动',
        fullTitle: function fullTitle() {
            return '支付成功 ';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(98).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("CeaU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '会员购买成功页',
                err: err
            });
        });
    }
}, {
    name: 'memberreceive',
    path: '/memberreceive',
    meta: {
        title: '红包领取页',
        newZhugeTitle: '会员年卡活动',
        fullTitle: function fullTitle() {
            return '领红包';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dSWF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '红包领取页',
                err: err
            });
        });
    }
}, {
    name: 'activityDistribution',
    path: '/activityDistribution',
    meta: {
        title: '分销页',
        newZhugeTitle: '分销页',
        fullTitle: function fullTitle() {
            return '分销页';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("268d")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '分销页',
                err: err
            });
        });
    }
}, {
    name: 'myDistribution',
    path: '/myDistribution',
    meta: {
        title: '我的分享',
        newZhugeTitle: '会员年卡活动',
        fullTitle: function fullTitle() {
            return '我的分享';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(70).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("qqIh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '我的分享',
                err: err
            });
        });
    }
}, {
    name: 'memberActivty',
    path: '/memberActivty',
    meta: {
        title: '会员活动专场',
        newZhugeTitle: '会员年卡活动',
        fullTitle: function fullTitle() {
            return '活动主页';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Cdgn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '会员活动专场',
                err: err
            });
        });
    }
}, {
    name: 'vip-rights',
    path: '/vipRights',
    meta: {
        title: '会员权益页',
        newZhugeTitle: '会员年卡活动',
        fullTitle: function fullTitle() {
            return '个人中心-会员中心';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0VOF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '会员权益页',
                err: err
            });
        });
    }
}, {
    name: 'rank',
    path: '/rank',
    meta: {
        title: '排行榜',
        newZhugeTitle: '会员年卡活动',
        fullTitle: function fullTitle() {
            return '分销排行榜';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EJ28")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '排行榜',
                err: err
            });
        });
    }
}, {
    name: 'callingcard',
    path: '/callingcard',
    meta: {
        title: '亲情卡',
        newZhugeTitle: '亲情卡',
        fullTitle: function fullTitle() {
            return '亲情卡';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4Thc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '亲情卡',
                err: err
            });
        });
    }
}]);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/toutiaoApp/index.vue?vue&type=template&id=1431bea5&scoped=true&
var toutiaoAppvue_type_template_id_1431bea5_scoped_true__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show-root-toutiao"}},[_c('router-view'),_vm._v(" "),_c('footer-nav')],1)}
var toutiaoAppvue_type_template_id_1431bea5_scoped_true__staticRenderFns = []


// CONCATENATED MODULE: ./src/pages/toutiaoApp/index.vue?vue&type=template&id=1431bea5&scoped=true&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/toutiao/footerNav.vue?vue&type=template&id=c8aaa7ae&scoped=true&
var footerNavvue_type_template_id_c8aaa7ae_scoped_true__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.RENMINWANG_TYPE)?_c('div',{staticClass:"footerNav",attrs:{"id":"footerNav"}},[_c('ul',[_c('v-touch',{class:{'selected':_vm.curPage=='extendingCenter'},attrs:{"tag":"li"},on:{"tap":function($event){return _vm.toPage('/extendingCenter')}}},[_c('i',{staticClass:"index",class:{'is-kwai': !_vm.isTikTok}}),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("推广首页")])]),_vm._v(" "),(_vm.isTikTok)?_c('v-touch',{class:{'selected':_vm.curPage=='addData'},attrs:{"tag":"li"},on:{"tap":function($event){return _vm.toPage('/addData')}}},[_c('i',{staticClass:"add"}),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("广告数据")])]):_vm._e(),_vm._v(" "),_c('v-touch',{class:{'selected':_vm.curPage=='myEarnings'},attrs:{"tag":"li"},on:{"tap":function($event){return _vm.toPage('/myEarnings')}}},[_c('i',{staticClass:"mine",class:{'is-kwai': !_vm.isTikTok}}),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("个人中心")])])],1)]):_vm._e()}
var footerNavvue_type_template_id_c8aaa7ae_scoped_true__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/toutiao/footerNav.vue?vue&type=template&id=c8aaa7ae&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/toutiao/footerNav.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var footerNavvue_type_script_lang_js_ = ({
  name: "footerNav",
  components: {},
  computed: extends_default()({
    routerPath: function routerPath() {
      return this.$route.path;
    }
  }, Object(vuex_esm["e" /* mapState */])(['channelId']), Object(vuex_esm["c" /* mapGetters */])(['extendPlatform']), {
    isTikTok: function isTikTok() {
      return this.extendPlatform === 'tiktok';
    }
  }),
  data: function data() {
    return {
      curPage: 'index',
      showQrcode: false
    };
  },
  mounted: function mounted() {
    this.iconSwitch();
  },

  watch: {
    routerPath: function routerPath() {
      this.iconSwitch();
    }
  },
  methods: {
    iconSwitch: function iconSwitch(routerName) {
      if (!!routerName) {
        this.$data.curPage = routerName;
      } else {
        this.$data.curPage = this.$route.name;
      }
    },
    showQrCode: function showQrCode() {
      event.stopPropagation();
      event.preventDefault();
      this.$data.showQrcode = true;
    },
    hideQrCode: function hideQrCode() {
      this.$data.showQrcode = false;
      event.stopPropagation();
      event.preventDefault();
    },
    toPage: function toPage(routerPath) {
      var that = this;
      // 免登陆切换路径
      var newPath = routerPath == '/mine/0' && that.CHANNEL_NOT_LOGIN ? '/noLoginCenter' : routerPath;
      var query = {
        channelId: that.channelId
      };
      if (that.$route.query.force) {
        query.force = that.$route.query.force;
      }
      that.iconSwitch(newPath);
      if (that.$route.path == newPath) {
        location.reload();
      } else {
        that.$router.push({
          path: newPath,
          query: query
        });
      }
    },
    stopScroll: function stopScroll() {
      event.preventDefault();
      event.stopPropagation();
    }
  }
});
// CONCATENATED MODULE: ./src/components/toutiao/footerNav.vue?vue&type=script&lang=js&
 /* harmony default export */ var toutiao_footerNavvue_type_script_lang_js_ = (footerNavvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/toutiao/footerNav.vue?vue&type=style&index=0&id=c8aaa7ae&lang=scss&scoped=true&
var footerNavvue_type_style_index_0_id_c8aaa7ae_lang_scss_scoped_true_ = __webpack_require__("W6XS");

// CONCATENATED MODULE: ./src/components/toutiao/footerNav.vue






/* normalize component */

var footerNav_component = Object(componentNormalizer["a" /* default */])(
  toutiao_footerNavvue_type_script_lang_js_,
  footerNavvue_type_template_id_c8aaa7ae_scoped_true__render,
  footerNavvue_type_template_id_c8aaa7ae_scoped_true__staticRenderFns,
  false,
  null,
  "c8aaa7ae",
  null
  
)

/* harmony default export */ var toutiao_footerNav = (footerNav_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/toutiaoApp/index.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//



/* harmony default export */ var toutiaoAppvue_type_script_lang_js_ = ({
  name: "index",
  components: {
    footerNav: toutiao_footerNav
  }
});
// CONCATENATED MODULE: ./src/pages/toutiaoApp/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var pages_toutiaoAppvue_type_script_lang_js_ = (toutiaoAppvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/pages/toutiaoApp/index.vue





/* normalize component */

var toutiaoApp_component = Object(componentNormalizer["a" /* default */])(
  pages_toutiaoAppvue_type_script_lang_js_,
  toutiaoAppvue_type_template_id_1431bea5_scoped_true__render,
  toutiaoAppvue_type_template_id_1431bea5_scoped_true__staticRenderFns,
  false,
  null,
  "1431bea5",
  null
  
)

/* harmony default export */ var toutiaoApp = (toutiaoApp_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/toutiaoApp/extendingCenter.vue?vue&type=template&id=21d8205d&scoped=true&
var extendingCentervue_type_template_id_21d8205d_scoped_true__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toutiao"},[_c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:('推广中心'),expression:"'推广中心'"}],staticClass:"toutiao-extendingCenter theme-base"},[_c('div',{staticClass:"toutiao-extendingCenter-search"},[_c('v-touch',{staticClass:"search-box",on:{"tap":_vm.goTouTiaoSearch}},[_c('div',{staticClass:"box-icon"}),_vm._v(" "),_c('div',{staticClass:"box-text"},[_vm._v("|搜索你感兴趣的测试")])])],1),_vm._v(" "),_c('div',{staticClass:"toutiao-extendingCenter-yixinli"},[_c('div',{staticClass:"yixinli-logo"}),_vm._v(" "),_c('div',{staticClass:"yixinli-text"}),_vm._v(" "),_c('v-touch',{staticClass:"yixinli-tis",on:{"tap":_vm.goYixinliIntroduce}},[_vm._v("查看更多")])],1),_vm._v(" "),_c('div',{staticClass:"toutiao-extendingCenter-box toutiao-extendingCenter-app"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"extendingCenter-app-list"},_vm._l((_vm.shareAppList),function(one,index){return _c('div',{key:index},[_c('productOne',{attrs:{"item":one,"index":index},on:{"_showCode":_vm.inshowCode}})],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"toutiao-extendingCenter-hot"},[_c('recomend-list',{attrs:{"toutiaoType":true,"indexList":_vm.hotList,"type":'hot',"hidePrice":true}})],1),_vm._v(" "),(_vm.isTikTok)?_c('div',{staticClass:"toutiao-extendingCenter-tip"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._l((_vm.shareAppList),function(item,index){return _c('div',{key:index},[_c('div',{ref:'status' + index,refInFor:true,staticClass:"toutiao-extendingCenter-tip_bind",class:item.isMore2Lines ? 'hidden' : ''},[_c('div',{staticClass:"bind-one"},[_vm._v("\n            《"+_vm._s(item.title)+"》绑定状态：\n            "),(item.nickNames.length > 0)?[_c('span',{class:item.isMore2Lines ? 'hidden' : ''},_vm._l((item.nickNames),function(name,indexName){return _c('span',{key:indexName,class:['bind-name', name.wrong ? 'black' : '']},[_vm._v("\n                  "+_vm._s(name)+"\n                  "),_c('span',{staticClass:"bind-icon"},[_vm._v("\n                    "+_vm._s(indexName == item.nickNames.length - 1 ? '' : '/')+"\n                    "),(_vm.checkName(name))?_c('span',{staticClass:"no-nickName",on:{"click":_vm.openNameTips}}):_vm._e()])])}),0)]:[_c('span',[_vm._v("未绑定")])]],2)]),_vm._v(" "),(item.isMore2Lines)?_c('v-touch',{staticClass:"btn-all-status",on:{"tap":function($event){return _vm.openAllStatus(item)}}},[_vm._v("\n          查看全部\n          "),_c('img',{attrs:{"src":__webpack_require__("jIgu"),"alt":"查看全部"}}),_vm._v(" "),_c('span')]):_vm._e()],1)}),_vm._v(" "),_vm._m(6)],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"toutiao-extendingCenter-box no3"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"toutiao-extendingCenter-box_title title-no3"},[(_vm.teamStatus == 1 || !_vm.isTikTok)?_c('span',{staticClass:"earning-btn",on:{"click":_vm.openTips}},[_vm._v("\n          "+_vm._s(_vm.isTikTok ? '抖音小程序推广分佣比例' : '快手小程序推广分佣说明')+"\n          "),_c('img',{attrs:{"src":__webpack_require__("DYhr"),"alt":""}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"content-no3"},[_c('div',{staticClass:"earning-tip"},[_c('div',{staticClass:"tip-title"},[_vm._v(_vm._s(_vm.isTikTok ? _vm.textConfig.selfSplit : '75%'))]),_vm._v(" "),_c('div',{staticClass:"tip-content"},[_vm._v(_vm._s(_vm.isTikTok ? '自己拍抖音赚佣金比例' : '自己拍快手赚佣金比例'))])]),_vm._v(" "),(_vm.teamStatus == 1 && _vm.isTikTok)?[_c('div',{staticClass:"vertical"}),_vm._v(" "),_c('div',{staticClass:"earning-tip"},[_c('div',{staticClass:"tip-title"},[_vm._v(_vm._s(_vm.textConfig.teamSplit))]),_vm._v(" "),_c('div',{staticClass:"tip-content"},[_vm._v("团队拍抖音拥金比例")])])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"toutiao-extendingCenter-box"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"toutiao-extendingCenter-cooperation"},[_c('div',{staticClass:"toutiao-extendingCenter-box_title title"},[_c('P',[_vm._v("疑问解答")]),_vm._v(" "),_c('P',[_vm._v("请添加微信：")])],1),_vm._v(" "),_c('img',{staticClass:"customer-service",attrs:{"src":__webpack_require__("FeMY")}})])]),_vm._v(" "),(_vm.showCodeImg || _vm.codeUrl)?_c('imgDialog',{attrs:{"hideBtn":true},on:{"closeMoadl":_vm._closeMoadl}},[(_vm.showCodeImg)?_c('img',{attrs:{"src":_vm.showCodeImg,"alt":""}}):_vm._e(),_vm._v(" "),(_vm.codeUrl)?_c('qrCode',{ref:"qrcodeTips",staticClass:"qrcodeCont",attrs:{"propContent":_vm.codeUrl,"size":2000}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.showTips)?_c('div',{staticClass:"commission-tips"},[_c('myMask',{nativeOn:{"click":function($event){return _vm.closeTips($event)}}}),_vm._v(" "),_c('div',{staticClass:"tips-title"}),_vm._v(" "),_c('div',{staticClass:"tips-content"},[_c('div',{staticClass:"content-title"},[_vm._v("分佣比例说明")]),_vm._v(" "),_c('div',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.isTikTok ? '佣金按照小程序实际产生报告数计算：' : '佣金按照小程序实际产生订单数计算'))]),_vm._v(" "),_c('div',{staticClass:"content-box"},[_c('div',{staticClass:"box-line"},[_c('span',{staticClass:"text-name"},[_vm._v("达人自推收益 ：")]),_vm._v(" "),_c('div',{staticClass:"text-info"},[_vm._v(_vm._s(_vm.isTikTok ? ("每份报告金额*达人产生报告总数*" + (_vm.textConfig.selfSplit)) : '订单成交金额*75%'))])]),_vm._v(" "),(_vm.isTikTok)?_c('div',{staticClass:"box-line"},[_c('span',{staticClass:"text-name"},[_vm._v("团队推广收益 ：")]),_vm._v(" "),_c('div',{staticClass:"text-info info-box"},[_vm._v("团队每单金额*"+_vm._s(_vm.textConfig.selfSplit)+"*"+_vm._s(_vm.textConfig.teamSplit)+"（得出每位下级贡献收益后，再进行相加，得出总下级贡献收益）")])]):_vm._e()])])],1):_vm._e(),_vm._v(" "),(_vm.showNameTips)?_c('div',{staticClass:"name-tips"},[_c('myMask'),_vm._v(" "),_c('div',{staticClass:"tips-box"},[_c('div',{staticClass:"box-title"},[_vm._v("温馨提示")]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"box-btn",on:{"click":_vm.closeNameTips}},[_vm._v("我知道了")])])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"toutitao-switch",class:_vm.isTikTok ? 'is-tiktok' : 'is-kwai',on:{"click":_vm.handleSwitch}},[_c('span',[_vm._v(_vm._s(_vm.isTikTok ? '抖音平台' : '快手平台'))]),_vm._v(" "),_c('i')]),_vm._v(" "),(_vm.kwaiNoBindTips)?_c('cp-dialog',{attrs:{"title":"温馨提示","buttonText":"复制"},on:{"close":function($event){_vm.kwaiNoBindTips = false},"click":function($event){return _vm.copyText('yixinlidudu')}}},[_c('div',[_vm._v("请先联系客服在后台绑定快手ID后方可操作查看，客服微信号：yixinlidudu")])]):_vm._e(),_vm._v(" "),(_vm.isTikTok)?_c('div',{ref:"copyBtn",staticClass:"toutiao-extengdingCenter-datagram",attrs:{"data-clipboard-text":'yixinlidudu'}}):_vm._e(),_vm._v(" "),(_vm.PACKAGEPOP_STATUS)?_c('packageDialog',{on:{"_closeModal":function($event){_vm.PACKAGEPOP_STATUS = false}}}):_vm._e()],1)}
var extendingCentervue_type_template_id_21d8205d_scoped_true__staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extendingCenter-box-title"},[_c('span',[_vm._v("产品列表")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extendingCenter-box-title"},[_c('span',[_vm._v("新手指南")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toutiao-extendingCenter-tip_text"},[_vm._v("\n        1、打开\n        "),_c('span',[_vm._v("抖音 APP- 搜索 - 扫一扫 - 相册")]),_vm._v("，将推广码放置扫描框，在抖音里打开小程序，并确认授权。\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toutiao-extendingCenter-tip_icon"},[_c('ul',[_c('li',[_c('div',{staticClass:"tip_icon_img"},[_c('img',{attrs:{"src":__webpack_require__("5FsZ"),"alt":"'打开抖⾳APP'"}})]),_vm._v(" "),_c('div',{staticClass:"tip_icon_text"},[_vm._v("打开抖⾳APP")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"tip_icon_img"},[_c('img',{attrs:{"src":__webpack_require__("OCs3"),"alt":"'搜索「扫一扫」'"}})]),_vm._v(" "),_c('div',{staticClass:"tip_icon_text"},[_vm._v("搜索「扫一扫」")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"tip_icon_img"},[_c('img',{attrs:{"src":__webpack_require__("nKzZ"),"alt":"'点击相册'"}})]),_vm._v(" "),_c('div',{staticClass:"tip_icon_text"},[_vm._v("点击相册")])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"tip_icon_img"},[_c('img',{attrs:{"src":__webpack_require__("ITw6"),"alt":"'扫推广码'"}})]),_vm._v(" "),_c('div',{staticClass:"tip_icon_text"},[_vm._v("扫推广码")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toutiao-extendingCenter-tip_text"},[_vm._v("\n        2、【绑定推广码】保存产品列表里的推广码，打开抖音\n        "),_c('span',[_vm._v("APP-搜索-扫一扫-相册")]),_vm._v("，将推广码放置扫描框，在抖音里打开小程序，点击\n        "),_c('span',[_vm._v("「允许」")]),_vm._v("。\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toutiao-extendingCenter-tip_two-tip"},[_c('img',{attrs:{"src":__webpack_require__("PZJg"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toutiao-extendingCenter-box-no2"},[_c('div',{staticClass:"content-no2"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extendingCenter-box-title"},[_c('span',[_vm._v("收益说明")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extendingCenter-box-title"},[_c('span',[_vm._v("商务合作")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-content"},[_vm._v("\n          这是一个默认昵称，请在抖音app打开该小程序，点击\n          "),_c('span',[_vm._v("右上角-设置-打开用户信息")]),_vm._v("，重新允许授权，然后重启小程序，以此更新您的真实昵称\n        ")])}]


// CONCATENATED MODULE: ./src/pages/toutiaoApp/extendingCenter.vue?vue&type=template&id=21d8205d&scoped=true&

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./src/components/imgDialog.vue + 4 modules
var imgDialog = __webpack_require__("3A6m");

// EXTERNAL MODULE: ./src/components/common/mask.vue + 2 modules
var mask = __webpack_require__("m423");

// CONCATENATED MODULE: ./src/pages/toutiaoApp/toutiaojson.js
var toutiaoList = {
  // 抑郁测试、情商测试、性格盲点、专业爱情、职业性格
  hotList: [{
    "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/0c0c389890434d8b9019638541cbecf5.jpg",
    "name": "ABO性别测试",
    "scalePoolId": 591,
    "discountPrice": '19.9',
    "originalPrice": '19.9',
    "recommended": '4万'
  }, {
    "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/ad820d1d3b804bc892479250cdef12ee.png?x-oss-process=Q_80",
    "name": "情商测试",
    "scalePoolId": 153,
    "discountPrice": '19.9',
    "originalPrice": '19.9',
    "recommended": '8.1万'
  }, {
    "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/06d34ca00cb5434a95549c19970a2c3f.jpg?x-oss-process=Q_80",
    "name": "性格盲点测试",
    "scalePoolId": 440,
    "discountPrice": '19.9',
    "originalPrice": '19.9',
    "recommended": '5.1万'
  }, {
    "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/6ce9db35a17b41fe8713cb38e6c66363.png?x-oss-process=Q_80",
    "name": "专业爱情测试",
    "scalePoolId": 501,
    "discountPrice": '19.9',
    "originalPrice": '19.9',
    "recommended": '5.0万'
  }, {
    "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/090b3521e678443bbfaa65f62f8d15ec.png?x-oss-process=Q_80",
    "name": "职业性格测试",
    "scalePoolId": 75,
    "discountPrice": '19.9',
    "originalPrice": '19.9',
    "recommended": '4.8万'
  }],
  kwaiHotList: [{
    "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/c05197dca72b417a91043cba1c76573f.png?x-oss-process=Q_80",
    "name": "抑郁测试",
    "scalePoolId": 353,
    "discountPrice": '19.9',
    "originalPrice": '19.9',
    "recommended": '5.1万'
  }, {
    "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/ad820d1d3b804bc892479250cdef12ee.png?x-oss-process=Q_80",
    "name": "情商测试",
    "scalePoolId": 153,
    "discountPrice": '19.9',
    "originalPrice": '19.9',
    "recommended": '8.1万'
  }, {
    "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/6ce9db35a17b41fe8713cb38e6c66363.png?x-oss-process=Q_80",
    "name": "专业爱情测试",
    "scalePoolId": 501,
    "discountPrice": '19.9',
    "originalPrice": '19.9',
    "recommended": '5.0万'
  }, {
    "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/311b6c011cc24064a04bdbfcb88701f8.jpg?x-oss-process=Q_80",
    "name": "安全感测试",
    "scalePoolId": 640,
    "discountPrice": '19.9',
    "originalPrice": '19.9',
    "recommended": '4.8万'
  }, {
    "introPicture": "https://imgco.xinli001.com/ceping/lingxi/scalePool/0c0c389890434d8b9019638541cbecf5.jpg",
    "name": "ABO性别测试",
    "scalePoolId": 591,
    "discountPrice": '19.9',
    "originalPrice": '19.9',
    "recommended": '4万'
  }],

  shareList: [{
    "title": "壹心理测评首页",
    "img": __webpack_require__("uGue"),
    "scalePoolId": "",
    "name": "首页",
    "recommended": '100万'
  }, {
    "title": "人格原型测试",
    "img": "https://imgco.xinli001.com/ceping/lingxi/scalePool/241a1857748743d386f99970319819bc.png",
    "scalePoolId": 549,
    "name": "人格原型测试",
    // "discountPrice": '19.9',
    "recommended": '5.1万'
  }, {
    "title": "潜意识画像测试",
    "img": "https://imgco.xinli001.com/ceping/lingxi/scalePool/1d60f2b3a1d043899e5d09d53520abaf.png",
    "scalePoolId": 541,
    "name": "潜意识画像测试",
    // "discountPrice": '19.9',
    "recommended": '3.4万'
  }, {
    "title": "原生家庭伤痛评估",
    "img": "https://imgco.xinli001.com/ceping/lingxi/scalePool/8c86225799354e5189dcada11cdc538c.png",
    "scalePoolId": 521,
    "name": "原生家庭伤痛评估",
    // "discountPrice": '19.9',
    "recommended": '3.8万'
  }, {
    "title": "灵魂伴侣契合度评估",
    "img": "https://imgco.xinli001.com/ceping/lingxi/scalePool/caaa095e8c524ce7acd95af14448f6e2.jpg",
    "scalePoolId": 366,
    "name": "灵魂伴侣契合度评估",
    // "discountPrice": '19.9',
    "recommended": '3.4万'
  }]
};
/* harmony default export */ var toutiaojson = (toutiaoList);
// EXTERNAL MODULE: ./src/components/common/qrCodeMaker.vue + 4 modules
var qrCodeMaker = __webpack_require__("xWsF");

// CONCATENATED MODULE: ./src/mixins/toutiaoMixin.js
 //头条小程序页面
/* harmony default export */ var toutiaoMixin = ({
	components: {},
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		var locationHref = location.href;
		var istToutiaoRouter = this.checkRouter();
		var isToutiaoRoute = ['extendingCenter', '', ''];
		if (locationHref.indexOf('xinli001wx.com') != -1 && istToutiaoRouter) {
			console.log('该页面为旧域名的广告页');
			this.$router.push({
				name: "toutiaono"
			});
		}
		// this.checkToutiao()
	},

	methods: {
		checkRouter: function checkRouter() {
			var that = this;
			// console.log(this.$router)
			var routeNames = [];
			toutiao_app.map(function (item, index) {
				routeNames.push(item.name);
				if (item.children) {
					item.children.map(function (one, i) {
						routeNames.push(one.name);
					});
				}
			});

			var istToutiaoRouter = false;
			routeNames.map(function (item, index) {
				// console.log(that.$route)
				if (item == that.$route.name) {
					istToutiaoRouter = true;
				}
			});
			console.log('istToutiaoRouter', istToutiaoRouter);
			return istToutiaoRouter;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/toutiao/productOne.vue?vue&type=template&id=7c3bf073&
var productOnevue_type_template_id_7c3bf073__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['productone',_vm.index != 0?'productone--bortop':'']},[_c('div',{staticClass:"productone-app"},[_c('div',{staticClass:"flex productone-ap-one"},[_c('div',{staticClass:"productone-app_logo"},[_c('img',{attrs:{"src":_vm.item.logo}})]),_vm._v(" "),_c('div',{staticClass:"productone-app_title"},[_vm._v(_vm._s(_vm.item.title))]),_vm._v(" "),(_vm.isTikTok)?_c('v-touch',{staticClass:"productone-app_btn",class:{ 'is-disabled': ![2345].includes(_vm.item.channelId) },on:{"tap":function($event){return _vm.showCode(_vm.item)}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"productone-app_tis"},[_vm._v(_vm._s(_vm.item.description))])]),_vm._v(" "),_c('div',{staticClass:"productone-app-tests_title"},[_vm._v("精选多款子产品")]),_vm._v(" "),_c('div',{staticClass:"productone-app-tests"},_vm._l((_vm.item.promoScaleVoList),function(one,index){return _c('div',{key:index,staticClass:"tests-one"},[_c('div',{staticClass:"tests-one_logo"},[_c('img',{attrs:{"src":one.logoUrl}})]),_vm._v(" "),_c('div',{staticClass:"tests-one_text"},[_c('p',{staticClass:"tests-one_text_title"},[_vm._v(_vm._s(one.name))]),_vm._v(" "),_c('p',{staticClass:"tests-one_text_tis"},[_vm._v(_vm._s(one.shortDesc))])]),_vm._v(" "),(_vm.isTikTok)?_c('v-touch',{staticClass:"tests-one_btn",class:{ 'is-disabled': ![2473,2345].includes(_vm.item.channelId) },on:{"tap":function($event){return _vm.showCode(one)}}},[_vm._v("推广")]):_vm._e()],1)}),0)])}
var productOnevue_type_template_id_7c3bf073__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/toutiao/productOne.vue?vue&type=template&id=7c3bf073&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/toutiao/productOne.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var productOnevue_type_script_lang_js_ = ({
	components: {},
	data: function data() {
		return {};
	},

	watch: {},
	props: {
		item: {
			type: Object,
			default: function _default() {
				return {};
			}
		},
		index: {
			type: Number,
			default: 0
		}
	},
	computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['extendPlatform']), {
		isTikTok: function isTikTok() {
			return this.extendPlatform === 'tiktok';
		}
	}),
	mounted: function mounted() {},

	methods: {
		showCode: function showCode(obj) {
			console.log(obj);
			this.$emit('_showCode', obj);
		}
	}
});
// CONCATENATED MODULE: ./src/components/toutiao/productOne.vue?vue&type=script&lang=js&
 /* harmony default export */ var toutiao_productOnevue_type_script_lang_js_ = (productOnevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/toutiao/productOne.vue?vue&type=style&index=0&lang=scss&
var productOnevue_type_style_index_0_lang_scss_ = __webpack_require__("UtpN");

// CONCATENATED MODULE: ./src/components/toutiao/productOne.vue






/* normalize component */

var productOne_component = Object(componentNormalizer["a" /* default */])(
  toutiao_productOnevue_type_script_lang_js_,
  productOnevue_type_template_id_7c3bf073__render,
  productOnevue_type_template_id_7c3bf073__staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var productOne = (productOne_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/toutiao/packageDialog.vue?vue&type=template&id=c72e7476&
var packageDialogvue_type_template_id_c72e7476__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"packagedialog"},[_c('myMask'),_vm._v(" "),_c('div',{staticClass:"warning__popup"},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.closeModal($event)}}},[_c('i',{staticClass:"icon-close"})]),_vm._v(" "),_c('p',{staticClass:"warnint__title"},[_vm._v("\n      ！重要通知：\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      经抖音审查发现，现有推广者（微信名：赵莉 420497011344961536205）被抖音直接查出发布令人不适的视频，下令整改，现经过讨论决定，冻结该推广者收益，并告知其他平台注意该用户。\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      1. 为维护抖音环境，欢迎大家举报令人不适的视频，举报有奖，莫让一人行为全网买单\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      2. 现正在全面检查中，除了人工排查外，后台系统也会对视频内容进行筛查，请大家自查抖音视频，如有不适内容立即隐藏。若被查到，将直接冻结收益，后果自负。\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      3. 从现在起，不允许轻易解绑账号，请大家对自己的账号负责。\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      4. 壹心理坚决配合抖音整改活动，也多次发提醒大家不要发布此类视频，望周知！\n    ")])])],1)}
var packageDialogvue_type_template_id_c72e7476__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/toutiao/packageDialog.vue?vue&type=template&id=c72e7476&

// EXTERNAL MODULE: ./node_modules/clipboard/lib/clipboard.js
var lib_clipboard = __webpack_require__("V33R");
var clipboard_default = /*#__PURE__*/__webpack_require__.n(lib_clipboard);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/toutiao/packageDialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var packageDialogvue_type_script_lang_js_ = ({
  name: 'packageDialog',
  components: {
    myMask: mask["a" /* default */]
  },
  data: function data() {
    return {};
  },

  watch: {},
  props: {},
  computed: {},
  mounted: function mounted() {
    // this.$nextTick(() => {
    //   this.initTextBtn()
    // })
  },

  methods: {
    closeModal: function closeModal() {
      this.$emit('_closeModal');
    },
    initTextBtn: function initTextBtn(id, title) {
      var _this = this;

      console.log('点击复制');
      var clipboard = new clipboard_default.a(this.$refs.copyText);
      clipboard.on('success', function (e) {
        e.clearSelection();
        _this.setTOASTTEXT({ str: '微信号已复制' });
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/toutiao/packageDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var toutiao_packageDialogvue_type_script_lang_js_ = (packageDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/toutiao/packageDialog.vue?vue&type=style&index=0&lang=scss&
var packageDialogvue_type_style_index_0_lang_scss_ = __webpack_require__("buex");

// CONCATENATED MODULE: ./src/components/toutiao/packageDialog.vue






/* normalize component */

var packageDialog_component = Object(componentNormalizer["a" /* default */])(
  toutiao_packageDialogvue_type_script_lang_js_,
  packageDialogvue_type_template_id_c72e7476__render,
  packageDialogvue_type_template_id_c72e7476__staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var packageDialog = (packageDialog_component.exports);
// EXTERNAL MODULE: ./src/components/cp-dialog.vue + 4 modules
var cp_dialog = __webpack_require__("OZpQ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/toutiaoApp/extendingCenter.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















var TEXT_CONFIG = {
  before: {
    teamSplit: '12%',
    selfSplit: '75%'
  },
  after: {
    teamSplit: '8%',
    selfSplit: '85%'
  }
};

/* harmony default export */ var extendingCentervue_type_script_lang_js_ = ({
  mixins: [pageMixin["a" /* default */], toutiaoMixin],
  components: {
    myMask: mask["a" /* default */],
    recomendList: testSwiper,
    imgDialog: imgDialog["a" /* default */],
    qrCode: qrCodeMaker["a" /* default */],
    productOne: productOne,
    packageDialog: packageDialog,
    cpDialog: cp_dialog["a" /* default */]
  },
  data: function data() {
    return {
      showCodeImg: '',
      shareList: toutiaojson.shareList,
      byteDanceAppName: '壹心理测评',
      hasBind: 0,
      nickNames: '',
      isMore2Lines: false,
      showTips: false,
      teamStatus: 0, // 1是开 0 是关
      tatisticData: {
        videoViewStatNum: 10,
        createOrderStatNum: 0,
        playOrderStatNum: 0
      },
      promoUser: '',
      shareAppList: [],
      showNameTips: false, // 真实姓名提示
      //二维码链接
      codeUrl: '',
      PACKAGEPOP_STATUS: false, //推广中心资料包弹窗控制
      kwaiNoBindTips: false
    };
  },

  watch: {},
  props: {},
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['extendPlatform']), {
    wxShareConfig: function wxShareConfig() {
      return {
        title: '\u5982\u4F55\u5728\u89C6\u9891\u91CC\u6302\u8F7D\u5C0F\u7A0B\u5E8F\uFF1F',
        link: '' + location.origin + location.pathname + '#/extendingCenter?channelId=' + this.channelId,
        imgUrl: 'https://imgco.xinli001.com/ceping/resources/images/trinyMCE/cc17f28cb20040698337e6cea453ea47.jpg',
        desc: '\u58F9\u5FC3\u7406\u6D4B\u8BC4\u6296\u97F3\u5C0F\u7A0B\u5E8F\u4E0A\u7EBF\u5566\uFF01',
        success: function success() {},
        cancel: function cancel() {}
      };
    },
    textConfig: function textConfig() {
      var isAfter = new Date() > new Date('2020/08/01 00:00');
      return TEXT_CONFIG[isAfter ? 'after' : 'before'];
    },
    isTikTok: function isTikTok() {
      return this.extendPlatform === 'tiktok';
    },
    hotList: function hotList() {
      if (this.isTikTok) {
        return toutiaojson.hotList;
      }
      return toutiaojson.kwaiHotList;
    }
  }),
  created: function created() {
    this.toTop();
    this.initMiniAppList();
  },
  mounted: function mounted() {
    var that = this;
    //获取头条用户信息

    var params = {
      channelId: that.channelId
    };
    if (that.$route.query.recommendUserKey) {
      params.recommendUserKey = that.$route.query.recommendUserKey;
    }
    if (that.$route.query.force) {
      params.force = that.$route.query.force;
    }
    that.promoGetUser({
      params: params
    }).then(function (res) {
      if (res.code == 1) {
        sessionStorage.setItem('promoSign', res.data.sign);
        that.teamStatus = res.data.status;
        that.promoUser = res.data.userKey;
        console.log('获取用户信息成功 res', res);
        that.bindToutiaoRecommendUserKey();
        that.fetchStatisticData();
        that.fetchPromoPackagePop();
        that.initCopyBtn();
      }

      // that.getAuthQrCode()
    });
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['pullHotScales', 'promoGetUser', 'promoQrcodeList', 'promoGetQrCode', 'getBindToutiaoUsers', 'getStatisticData', 'promoAuthUrl', 'promoAppList', 'promoPackagePop']), Object(vuex_esm["d" /* mapMutations */])(['switchPlatform']), {
    gettouTiaoUser: function gettouTiaoUser(type) {
      var _this = this;

      var that = this;
      var paramType = type !== undefined ? type : this.isTikTok ? 0 : 1;
      return that.getBindToutiaoUsers({
        params: {
          channelId: that.channelId,
          type: paramType
        }
      }).then(function (res) {
        if (res.data && res.data.length && res.data.length > 0 && paramType === 0) {
          res.data.forEach(function (item, index) {
            for (var i = 0; i < that.shareAppList.length; i++) {
              var app = that.shareAppList[i];
              if (app.appCode == item.appCode) {
                app['hasBind'] = item.hasBind;
                app['nickNames'] = item.nickNames;
              }
            }
          });
          console.log('绑定抖音号信息 shareAppList', that.shareAppList);
        }
        if (_this.isTikTok) {
          that.$nextTick(function () {
            that.checkMore2Lines();
          });
        }
        return res;
      });
    },
    initMiniAppList: function initMiniAppList() {
      var _this2 = this;

      var that = this;
      this.promoAppList({
        params: {}
      }).then(function (res) {
        console.log(res);
        if (res.code == 1) {
          _this2.shareAppList = res.data.map(function (app) {
            var r = {};
            r.appCode = app.appCode;
            r.channelId = app.channelId;
            r.title = app.name;
            r.logo = app.logoUrl;
            r.hasBind = 0;
            r.nickNames = [];
            r.promoScaleVoList = app.promoScaleVoList;
            r.authUrl = app.authUrl;
            r.description = app.description;
            return r;
          }).filter(function (item) {
            return !!item;
          });
          that.gettouTiaoUser();
        }
      });
    },
    getAuthQrCode: function getAuthQrCode() {
      var _this3 = this;

      this.promoAuthUrl({
        params: {}
      }).then(function (res) {
        console.log(res);
        if (res.code == 1) {
          _this3.codeUrl = res.data;
        }
      });
    },
    openNameTips: function openNameTips() {
      this.showNameTips = true;
    },
    closeNameTips: function closeNameTips() {
      this.showNameTips = false;
    },
    openTips: function openTips() {
      this.showTips = true;
    },
    closeTips: function closeTips() {
      this.showTips = false;
    },
    fetchStatisticData: function fetchStatisticData() {
      var _this4 = this;

      this.getStatisticData({
        params: {
          channelId: this.channelId
        }
      }).then(function (res) {
        console.log('--- 推广中心-统计数据 ---', res);
        if (res.code == 1) {
          _this4.tatisticData = res.data;
        }
      });
    },
    bindToutiaoRecommendUserKey: function bindToutiaoRecommendUserKey() {
      var that = this;
      console.log('bindToutiaoRecommendUserKey', this.$route.query.recommendUserKey);
      if (this.$route.query.recommendUserKey) {
        this.promoBind({
          params: {
            recommendUserKey: this.$route.query.recommendUserKey,
            channelId: that.channelId
          }
        }).then(function (res) {
          console.log(res);
          if (res.code != 44004) {
            that.setTOASTTEXT(res.msg);
          }
        });
      }
    },
    goMyEarnings: function goMyEarnings() {
      location.href = location.protocol + '//' + apis["a" /* default */].toutiaoShareHost + '/cp/index.html?init=17#/myEarnings?channelId=' + this.channelId + '&teamStatus=' + this.teamStatus + '&promoUser=' + this.promoUser;
    },
    inshowCode: function inshowCode(item) {
      console.log('-----------inshowCode');
      console.log(item);
      this.codeUrl = item.authUrl;
    },
    checkMore2Lines: function checkMore2Lines() {
      var _this5 = this;

      var that = this;
      if (this.shareAppList && this.shareAppList.length > 1) {
        that.shareAppList.map(function (item, index) {
          if (_this5.$refs['status' + index][0]) {
            var e = _this5.$refs['status' + index][0];
            var hight = e.offsetHeight || e.clientHeight;
            var lineHeight = Number(window.getComputedStyle(e)['lineHeight'].slice(0, 2));
            that.shareAppList[index].isMore2Lines = hight / lineHeight > 2;
          }
        });
      }
    },
    openAllStatus: function openAllStatus(item) {
      item.isMore2Lines = false;
    },
    goTouTiaoSearch: function goTouTiaoSearch() {
      this.$router.push({
        path: './ttSearch',
        query: {
          channelId: this.channelId,
          force: this.$route.query.force
        }
      });
    },
    goYixinliIntroduce: function goYixinliIntroduce() {
      this.$router.push({
        path: './yixinliIntroduce',
        query: {
          channelId: this.channelId,
          force: this.$route.query.force
        }
      });
    },
    _closeMoadl: function _closeMoadl() {
      this.showCodeImg = '';
      this.codeUrl = '';
    },
    _showAuthCode: function _showAuthCode() {
      this.getAuthQrCode();
    },
    checkName: function checkName(name) {
      if (name.indexOf('小鲸鱼') != -1) {
        return true;
      } else {
        return false;
      }
    },
    fetchPromoPackagePop: function fetchPromoPackagePop() {
      var that = this;
      that.promoPackagePop({
        params: {}
      }).then(function (res) {
        if (res.code == 1) {
          that.PACKAGEPOP_STATUS = !!res.data.pop;
        }
      });
    },
    initCopyBtn: function initCopyBtn(id, title) {
      var _this6 = this;

      console.log('点击复制');
      this.$nextTick(function () {
        if (_this6.$refs.copyBtn) {
          var clipboard = new clipboard_default.a(_this6.$refs.copyBtn);
          clipboard.on('success', function (e) {
            e.clearSelection();
            _this6.setTOASTTEXT({ str: '微信号已复制' });
          });
        }
      });
    },
    handleSwitch: function handleSwitch() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this7.gettouTiaoUser(_this7.isTikTok ? 1 : 0);

              case 2:
                _ref = _context.sent;
                data = _ref.data;

                if (!(!data.length && _this7.isTikTok)) {
                  _context.next = 7;
                  break;
                }

                _this7.kwaiNoBindTips = true;
                return _context.abrupt('return');

              case 7:
                _this7.switchPlatform(_this7.isTikTok ? 'kwai' : 'tiktok');
                _this7.toTop();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this7);
      }))();
    },
    copyText: function copyText(content) {
      var _this8 = this;

      this._copyText(content, function () {
        _this8.setTOASTTEXT('复制成功');
      });
    }
  }),
  filters: {
    bindName: function bindName(name) {
      var t = '';
      if (name.hasBind == 1 && name.nickNames) {
        t = name.nickNames;
      }
      return nickNames;
    }
  }
});
// CONCATENATED MODULE: ./src/pages/toutiaoApp/extendingCenter.vue?vue&type=script&lang=js&
 /* harmony default export */ var toutiaoApp_extendingCentervue_type_script_lang_js_ = (extendingCentervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/pages/toutiaoApp/extendingCenter.vue?vue&type=style&index=0&id=21d8205d&lang=scss&scoped=true&
var extendingCentervue_type_style_index_0_id_21d8205d_lang_scss_scoped_true_ = __webpack_require__("pyy+");

// CONCATENATED MODULE: ./src/pages/toutiaoApp/extendingCenter.vue






/* normalize component */

var extendingCenter_component = Object(componentNormalizer["a" /* default */])(
  toutiaoApp_extendingCentervue_type_script_lang_js_,
  extendingCentervue_type_template_id_21d8205d_scoped_true__render,
  extendingCentervue_type_template_id_21d8205d_scoped_true__staticRenderFns,
  false,
  null,
  "21d8205d",
  null
  
)

/* harmony default export */ var extendingCenter = (extendingCenter_component.exports);
// CONCATENATED MODULE: ./src/router/toutiao_app.js
// vip 路由




/* harmony default export */ var toutiao_app = ([{
  name: 'toutiao',
  path: '/extendingCenter',
  component: toutiaoApp,
  children: [{
    name: 'extendingCenter',
    path: '/extendingCenter',
    meta: {
      title: '推广中心 ',
      newZhugeTitle: '推广中心'
    },
    component: extendingCenter
  }, {
    name: 'myEarnings',
    path: '/myEarnings',
    meta: {
      title: '我的收益 ',
      newZhugeTitle: '我的收益'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eg3x")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        Object(units["s" /* loadPageFail */])({
          pagename: '我的收益',
          err: err
        });
      });
    }
  }, {
    name: 'addData',
    path: '/addData',
    meta: {
      title: '广告数据',
      newZhugeTitle: '广告数据'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(108).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SfIu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
        Object(units["s" /* loadPageFail */])({
          pagename: '广告数据',
          err: err
        });
      });
    }
  }]
}, {
  name: 'cashWithdrawal',
  path: '/cashWithdrawal',
  meta: {
    title: '申请提现 ',
    newZhugeTitle: '申请提现'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(69).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xUf4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '申请提现',
        err: err
      });
    });
  }
}, {
  name: 'nameAuthentication',
  path: '/nameAuthentication',
  meta: {
    title: '实名认证',
    newZhugeTitle: '实名认证'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(68).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nsoP")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '实名认证',
        err: err
      });
    });
  }
}, {
  name: 'authenticationSuccess',
  path: '/authenticationSuccess',
  meta: {
    title: '实名认证',
    newZhugeTitle: '实名认证'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(111).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("6F5c")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '实名认证',
        err: err
      });
    });
  }
}, {
  name: 'authenticationInformation',
  path: '/authenticationInformation',
  meta: {
    title: '认证须知',
    newZhugeTitle: '认证须知'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(138).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0pjM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '认证须知',
        err: err
      });
    });
  }
}, {
  name: 'myTeams',
  path: '/myTeams',
  meta: {
    title: '我的团队',
    newZhugeTitle: '我的团队'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(88).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("l96T")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '我的团队',
        err: err
      });
    });
  }
}, {
  name: 'yixinliIntroduce',
  path: '/yixinliIntroduce',
  meta: {
    title: '关于壹心理',
    newZhugeTitle: '关于壹心理'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(114).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+tXu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '关于壹心理',
        err: err
      });
    });
  }
}, {
  name: 'authenticationWorker',
  path: '/authenticationWorker',
  meta: {
    title: '自由职业合作服务协议',
    newZhugeTitle: '自由职业合作服务协议'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(150).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lrwi")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '自由职业合作服务协议',
        err: err
      });
    });
  }
}, {
  name: 'certificationSuccess',
  path: '/certificationSuccess',
  meta: {
    title: '认证',
    newZhugeTitle: '认证'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(112).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+La8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '认证',
        err: err
      });
    });
  }
}, {
  name: 'ttSearch',
  path: '/ttSearch',
  meta: {
    title: '搜索',
    newZhugeTitle: '搜索'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(117).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NfLK")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '搜索',
        err: err
      });
    });
  }
}, {
  name: 'toutiaono',
  path: '/toutiaono',
  meta: {
    title: '抖音屏蔽页',
    fullTitle: function fullTitle() {
      return '抖音屏蔽页';
    }
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(137).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Y+s2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '抖音屏蔽页',
        err: err
      });
    });
  }
}]);
// CONCATENATED MODULE: ./src/router/houseTreePeople.js
/**
 * 房树人测试 答题和报告的路由
 */



/* harmony default export */ var houseTreePeople = ([{
  name: 'answerHTP',
  path: '/answerHTP',
  meta: {
    title: '答题初始化页面'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yRIz")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '答题初始化页',
        err: err
      });
    });
  }
  // children: [{
  //     name: 'answerPainting',
  //     path: 'painting',
  //     meta: {
  //       title: '照片上传页',
  //     },
  //     component: resolve => require(['../pages/houseTreePeople/answerPainting.vue'], resolve, (err) => {
  //       loadPageFail({
  //         pagename: '照片上传页',
  //         err
  //       })
  //     })
  //   }
  // ]
}, {
  name: 'reportHTP',
  path: '/reportHTP',
  meta: {
    title: '报告页'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("LtNJ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}]);
// CONCATENATED MODULE: ./src/router/careerCard.js
/**
 * 生涯卡测试 答题和报告的路由
 */



/* harmony default export */ var careerCard = ([{
  name: 'careerCardAnswer',
  path: '/careercard-answer',
  meta: {
    title: '答题初始化页面'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/zjj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '生涯卡答题页',
        err: err
      });
    });
  }
}, {
  name: 'careerCardReport',
  path: '/careercard-report',
  meta: {
    title: '人生卡牌'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Nezx")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '人生卡牌',
        err: err
      });
    });
  }
}, {
  name: 'careerCardShare',
  path: '/careercard-share',
  meta: {
    title: '人生卡牌'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(84).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KCez")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '人生卡牌',
        err: err
      });
    });
  }
}]);
// CONCATENATED MODULE: ./src/router/datura.js
/**
 * 曼陀罗 答题和报告的路由
 * 禅道链接
 * http://112.124.122.87:8084/index.php?m=story&f=view&storyID=4847
 */



/* harmony default export */ var datura = ([{
  name: 'daturaAnswer',
  path: '/daturaAnswer',
  meta: {
    title: '答题测试说明页'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(115).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("BGxc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '曼陀罗测试说明页',
        err: err
      });
    });
  }
}, {
  name: 'daturaSelect',
  path: '/daturaSelect',
  meta: {
    title: '选择图案'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(106).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("19lw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '曼陀罗选择图案页',
        err: err
      });
    });
  }
},
// 假题路由-假题版本
{
  name: 'daturaSelectList',
  path: '/daturaSelectList',
  meta: {
    title: '选择答案'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5suM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '曼陀罗选择题',
        err: err
      });
    });
  }
}, {
  name: 'daturaList',
  path: '/daturaList',
  meta: {
    title: '答题页'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(104).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("6C0/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '曼陀罗答题页',
        err: err
      });
    });
  }
}, {
  name: 'daturaReport',
  path: '/daturaReport',
  meta: {
    title: '报告页'
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JYZC")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
      Object(units["s" /* loadPageFail */])({
        pagename: '曼陀罗报告页',
        err: err
      });
    });
  }
}]);
// CONCATENATED MODULE: ./src/router/launch.js
/**
 * 包含一些零碎的业务的路由
 */


/* harmony default export */ var launch = ([{
    name: 'paymentUnlock',
    path: '/paymentUnlock',
    meta: {
        title: '支付解锁页',
        fullTitle: function fullTitle() {
            return '支付解锁页';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("OGVR")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '支付解锁页',
                err: err
            });
        });
    }
}, {
    name: 'paymentcardSuccess',
    path: '/paymentcardSuccess',
    meta: {
        title: '成功购买页',
        fullTitle: function fullTitle() {
            return '成功购买页';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2wpw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '成功购买页',
                err: err
            });
        });
    }
}, {
    name: 'paymentTis',
    path: '/paymentTis',
    meta: {
        title: '客服页',
        fullTitle: function fullTitle() {
            return '客服页';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(146).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("huDF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '客服页',
                err: err
            });
        });
    }
}, {
    name: 'paymentCikeSuccess',
    path: '/paymentCikeSuccess',
    meta: {
        title: '成功购买咨询页',
        fullTitle: function fullTitle() {
            return '成功购买咨询页';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(76).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("rV+h")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '成功购买咨询页',
                err: err
            });
        });
    }
}, {
    name: 'quickUnlock',
    path: '/quickUnlock',
    meta: {
        title: '快速解锁页',
        fullTitle: function fullTitle() {
            return '快速解锁页';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Lj3Y")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '快速解锁页',
                err: err
            });
        });
    }
}, {
    name: 'attentionQrcode',
    path: '/attention-qrcode',
    meta: {
        title: '关注公众号',
        fullTitle: function fullTitle() {
            return '关注公众号';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gpgr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '关注公众号',
                err: err
            });
        });
    }
}, {
    name: 'loadingProgress',
    path: '/loading-progress',
    meta: {
        title: '加载进度条',
        fullTitle: function fullTitle() {
            return '加载进度条';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(131).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gkPu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '加载进度条',
                err: err
            });
        });
    }
}, {
    name: 'saveReport',
    path: '/save-report',
    meta: {
        title: '保存个人测评结果',
        fullTitle: function fullTitle() {
            return '保存个人测评结果';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(105).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tVdc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '保存个人测评结果',
                err: err
            });
        });
    }
},
// 放在小程序 webview 中的二维码落地页
{
    name: 'wechatAppQrcode',
    path: '/wechat-app-qrcode',
    meta: {
        title: '永久保存报告',
        fullTitle: function fullTitle() {
            return '永久保存报告';
        }
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(122).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IRxS")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '永久保存报告',
                err: err
            });
        });
    }
}]);
// CONCATENATED MODULE: ./src/router/matching.js
// 匹配测试路由集合


/* harmony default export */ var matching = ([{
    name: 'matchingDetail',
    path: '/matching-detail',
    meta: {
        title: '测试匹配详情页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("n5Y9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    name: 'matchingRecord',
    path: '/matching-record',
    meta: {
        title: '匹配记录'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(132).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FU5h")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    name: 'matchingExplain',
    path: '/matching-explain',
    meta: {
        title: '玩法说明'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(133).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("cDzP")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    name: 'matchInvitation',
    path: '/match-invitation',
    meta: {
        title: '匹配邀请页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(147).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("qIcS")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '匹配邀请页',
                err: err
            });
        });
    }
}, {
    name: 'matchIndividualReport',
    path: '/match-individualreport',
    meta: {
        title: '个人报告页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Z/B3")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '个人报告页',
                err: err
            });
        });
    }
}, {
    name: 'matchReport',
    path: '/match-report',
    meta: {
        title: '匹配报告页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("CnIm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '匹配报告页',
                err: err
            });
        });
    }
}, {
    name: 'matchBeinvited',
    path: '/match-beinvited',
    meta: {
        title: '匹配被邀请页'
    },
    component: function component(resolve) {
        return __webpack_require__.e/* require */(121).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("S4XP")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
            Object(units["s" /* loadPageFail */])({
                pagename: '匹配被邀请页',
                err: err
            });
        });
    }
}]);
// EXTERNAL MODULE: ./src/store/store.js + 23 modules
var store = __webpack_require__("wtEF");

// CONCATENATED MODULE: ./src/router/index.js


/*
 * @Author: hasee
 * @Date:   2016-12-12 18:22:00
 * @Last Modified by:   hasee
 * @Last Modified time: 2016-12-22 10:59:08
 */




vue_esm["a" /* default */].use(vue_router_esm);









 //头条小程序页面
 // 房树人测试路由

 // 曼陀罗



var router = new vue_router_esm({
    routes: [{
        name: 'defalut',
        path: '/',
        redirect: '/index',
        meta: {
            title: '直接访问'
        }
    }, router_show].concat(toConsumableArray_default()(answer_report), toConsumableArray_default()(gift), toConsumableArray_default()(fragment), toConsumableArray_default()(activity), toConsumableArray_default()(ceshi), toConsumableArray_default()(member), toConsumableArray_default()(toutiao_app), toConsumableArray_default()(houseTreePeople), toConsumableArray_default()(careerCard), toConsumableArray_default()(datura), toConsumableArray_default()(launch), toConsumableArray_default()(matching), [{
        name: 'error',
        path: '/error',
        meta: {
            title: '错误-404页'
        },
        component: function component(resolve) {
            return __webpack_require__.e/* require */(125).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1zYH")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(function (err) {
                Object(units["s" /* loadPageFail */])({
                    pagename: '错误-404页',
                    err: err
                });
            });
        }
    }, {
        name: 'handleError',
        path: '*',
        redirect: '/error'
    }])
});

router.addRoutes([{
    path: '/test',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(151).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Y7I0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}]);

if (false) {
    router.addRoutes([{
        path: '/test_demo',
        component: function component(resolve) {
            return require(['../pages/demoPages/index.vue'], resolve);
        }
    }]);
    router.addRoutes([{
        path: '/test',
        component: function component(resolve) {
            return require(['../pages/test.vue'], resolve);
        }
    }]);
}



router.beforeEach(function (to, from, next) {

    var token = to.query.cpToken || Object(units["a" /* GetQueryString */])('cpToken');
    var channelId = to.query.channelId ? to.query.channelId : Object(units["a" /* GetQueryString */])('channelId') ? Object(units["a" /* GetQueryString */])('channelId') : units["n" /* getPlatform */].isWechat ? 1 : 513;
    //本地localStorage 存token 和 channelId
    if (token) {
        if (!localStorage.getItem('cp_token') || localStorage.getItem('cp_token') != token) {
            localStorage.setItem('cp_token', token);
        }
    }
    if (channelId) {
        if (!localStorage.getItem('cp_channelId') || localStorage.getItem('cp_channelId') != channelId) {
            localStorage.setItem('cp_channelId', channelId);
        }
    }

    if (!window.TRACKER.channelId) {
        if (channelId) {
            window.TRACKER.setChannelId(channelId);
            store["a" /* default */].commit('setChannelId', channelId);

            var yxyid = to.query.yxyid ? to.query.yxyid : Object(units["a" /* GetQueryString */])('yxyid') ? Object(units["a" /* GetQueryString */])('yxyid') : '';
            if (channelId && channelId == 1539 && yxyid) {
                store["a" /* default */].commit('setYxyid', yxyid);
            }
        }
    }

    var tuiliyiKey = '';
    if (channelId == 2663) {
        // 推力益 标识符
        tuiliyiKey = to.query.key ? to.query.key : '';
        console.log(' --- 推力益 tuiliyiKey --- ', tuiliyiKey);
        if (tuiliyiKey) {
            store["a" /* default */].commit('setTuiliyiKey', woNiuUnique);
            localStorage.setItem("tuiliyiKey", stringify_default()(tuiliyiKey));
        }
    }

    // 唯爱妈妈小程序渠道
    if (+channelId === 3295) {
        if (to.query.sourceName) {
            localStorage.setItem("vimmSourceName", to.query.sourceName);
        }
    }

    var sourceName = to.query.sourceName ? to.query.sourceName : Object(units["a" /* GetQueryString */])('sourceName') ? Object(units["a" /* GetQueryString */])('sourceName') : "";
    // 蜗牛睡眠标识符
    var woNiuUnique = to.query.unique ? to.query.unique : Object(units["a" /* GetQueryString */])('unique') ? Object(units["a" /* GetQueryString */])('unique') : "";
    if (sourceName || woNiuUnique) {
        //添加异步操作全局跟踪标识，只需要请求不需要回调
        var source = sourceName ? sourceName : woNiuUnique;
        store["a" /* default */].dispatch('storeSource', { params: { 'sourceName': source } });
    }
    if (woNiuUnique) {
        store["a" /* default */].commit('setWoNiuUnique', woNiuUnique);
        localStorage.setItem("woNiuUnique", stringify_default()(woNiuUnique));
    }
    var sourceId = to.query.sourceId ? to.query.sourceId : Object(units["a" /* GetQueryString */])('sourceId') ? Object(units["a" /* GetQueryString */])('sourceId') : "";
    if (sourceId) {
        store["a" /* default */].commit('setSourceId', sourceId);
        sessionStorage.setItem("sourceId", stringify_default()(sourceId));
    }
    if (to.query.auth_code || to.query.authCode) {
        sessionStorage.setItem("authCode", to.query.auth_code || to.query.authCode);
    }
    // 抑郁2选1版本特有逻辑，防止报告页点击后退时回到旧详情页detail
    var isYY_2_1_channels = [4619, 4618, 4690, 4691, 4692];
    if (isYY_2_1_channels.includes(+channelId) && to.path === '/detail/1147') {
        // 拦截抑郁2选1的旧详情页，指向新的详情页
        next({
            path: '/detail-yy/1147',
            query: to.query,
            params: to.params
        });
        return;
    }
    // isMBTI_2_1版本特有逻辑-end
    if (to.path === '/detail/1236') {
        // 拦截isMBTI_2_1的旧详情页，指向新的详情页
        next({
            path: '/detail-mbti/1236',
            query: to.query,
            params: to.params
        });
        return;
    }
    if (to.query.yxyid) {
        next();
        return;
    }
    if (from.query.yxyid) {
        var toQuery = JSON.parse(stringify_default()(to.query));
        console.log(toQuery);
        toQuery.yxyid = from.query.yxyid;
        next({
            path: to.path,
            query: toQuery
        });
    } else {
        next();
    }
});
/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/lib-flexible/flexible.js
var flexible = __webpack_require__("sVYa");
var flexible_default = /*#__PURE__*/__webpack_require__.n(flexible);

// CONCATENATED MODULE: ./node_modules/vue-lazyload/vue-lazyload.esm.js
/*!
 * Vue-Lazyload.js v1.3.3
 * (c) 2019 Awe <hilongjw@gmail.com>
 * Released under the MIT License.
 */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/*!
 * is-primitive <https://github.com/jonschlinkert/is-primitive>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

// see http://jsperf.com/testing-value-is-primitive/7

var isPrimitive = function isPrimitive(value) {
  return value == null || typeof value !== 'function' && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object';
};

/*!
 * assign-symbols <https://github.com/jonschlinkert/assign-symbols>
 *
 * Copyright (c) 2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

var assignSymbols = function assignSymbols(receiver, objects) {
  if (receiver === null || typeof receiver === 'undefined') {
    throw new TypeError('expected first argument to be an object.');
  }

  if (typeof objects === 'undefined' || typeof Symbol === 'undefined') {
    return receiver;
  }

  if (typeof Object.getOwnPropertySymbols !== 'function') {
    return receiver;
  }

  var isEnumerable = Object.prototype.propertyIsEnumerable;
  var target = Object(receiver);
  var len = arguments.length,
      i = 0;

  while (++i < len) {
    var provider = Object(arguments[i]);
    var names = Object.getOwnPropertySymbols(provider);

    for (var j = 0; j < names.length; j++) {
      var key = names[j];

      if (isEnumerable.call(provider, key)) {
        target[key] = provider[key];
      }
    }
  }
  return target;
};

var vue_lazyload_esm_toString = Object.prototype.toString;

/**
 * Get the native `typeof` a value.
 *
 * @param  {*} `val`
 * @return {*} Native javascript type
 */

var kindOf = function kindOf(val) {
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);

  // primitivies
  if (type === 'undefined') {
    return 'undefined';
  }
  if (val === null) {
    return 'null';
  }
  if (val === true || val === false || val instanceof Boolean) {
    return 'boolean';
  }
  if (type === 'string' || val instanceof String) {
    return 'string';
  }
  if (type === 'number' || val instanceof Number) {
    return 'number';
  }

  // functions
  if (type === 'function' || val instanceof Function) {
    if (typeof val.constructor.name !== 'undefined' && val.constructor.name.slice(0, 9) === 'Generator') {
      return 'generatorfunction';
    }
    return 'function';
  }

  // array
  if (typeof Array.isArray !== 'undefined' && Array.isArray(val)) {
    return 'array';
  }

  // check for instances of RegExp and Date before calling `toString`
  if (val instanceof RegExp) {
    return 'regexp';
  }
  if (val instanceof Date) {
    return 'date';
  }

  // other objects
  type = vue_lazyload_esm_toString.call(val);

  if (type === '[object RegExp]') {
    return 'regexp';
  }
  if (type === '[object Date]') {
    return 'date';
  }
  if (type === '[object Arguments]') {
    return 'arguments';
  }
  if (type === '[object Error]') {
    return 'error';
  }
  if (type === '[object Promise]') {
    return 'promise';
  }

  // buffer
  if (isBuffer(val)) {
    return 'buffer';
  }

  // es6: Map, WeakMap, Set, WeakSet
  if (type === '[object Set]') {
    return 'set';
  }
  if (type === '[object WeakSet]') {
    return 'weakset';
  }
  if (type === '[object Map]') {
    return 'map';
  }
  if (type === '[object WeakMap]') {
    return 'weakmap';
  }
  if (type === '[object Symbol]') {
    return 'symbol';
  }

  if (type === '[object Map Iterator]') {
    return 'mapiterator';
  }
  if (type === '[object Set Iterator]') {
    return 'setiterator';
  }
  if (type === '[object String Iterator]') {
    return 'stringiterator';
  }
  if (type === '[object Array Iterator]') {
    return 'arrayiterator';
  }

  // typed arrays
  if (type === '[object Int8Array]') {
    return 'int8array';
  }
  if (type === '[object Uint8Array]') {
    return 'uint8array';
  }
  if (type === '[object Uint8ClampedArray]') {
    return 'uint8clampedarray';
  }
  if (type === '[object Int16Array]') {
    return 'int16array';
  }
  if (type === '[object Uint16Array]') {
    return 'uint16array';
  }
  if (type === '[object Int32Array]') {
    return 'int32array';
  }
  if (type === '[object Uint32Array]') {
    return 'uint32array';
  }
  if (type === '[object Float32Array]') {
    return 'float32array';
  }
  if (type === '[object Float64Array]') {
    return 'float64array';
  }

  // must be a plain object
  return 'object';
};

/**
 * If you need to support Safari 5-7 (8-10 yr-old browser),
 * take a look at https://github.com/feross/is-buffer
 */

function isBuffer(val) {
  return val.constructor && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

function vue_lazyload_esm_assign(target /*, objects*/) {
  target = target || {};
  var len = arguments.length,
      i = 0;
  if (len === 1) {
    return target;
  }
  while (++i < len) {
    var val = arguments[i];
    if (isPrimitive(target)) {
      target = val;
    }
    if (isObject$1(val)) {
      vue_lazyload_esm_extend(target, val);
    }
  }
  return target;
}

/**
 * Shallow extend
 */

function vue_lazyload_esm_extend(target, obj) {
  assignSymbols(target, obj);

  for (var key in obj) {
    if (key !== '__proto__' && hasOwn(obj, key)) {
      var val = obj[key];
      if (isObject$1(val)) {
        if (kindOf(target[key]) === 'undefined' && kindOf(val) === 'function') {
          target[key] = val;
        }
        target[key] = vue_lazyload_esm_assign(target[key] || {}, val);
      } else {
        target[key] = val;
      }
    }
  }
  return target;
}

/**
 * Returns true if the object is a plain object or a function.
 */

function isObject$1(obj) {
  return kindOf(obj) === 'object' || kindOf(obj) === 'function';
}

/**
 * Returns true if the given `key` is an own property of `obj`.
 */

function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

/**
 * Expose `assign`
 */

var assignDeep = vue_lazyload_esm_assign;

var vue_lazyload_esm_inBrowser = typeof window !== 'undefined';
var hasIntersectionObserver = checkIntersectionObserver();

function checkIntersectionObserver() {
  if (vue_lazyload_esm_inBrowser && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get$$1() {
          return this.intersectionRatio > 0;
        }
      });
    }
    return true;
  }
  return false;
}

var modeType = {
  event: 'event',
  observer: 'observer'

  // CustomEvent polyfill
};var CustomEvent = function () {
  if (!vue_lazyload_esm_inBrowser) return;
  if (typeof window.CustomEvent === 'function') return window.CustomEvent;
  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }
  CustomEvent.prototype = window.Event.prototype;
  return CustomEvent;
}();

function remove(arr, item) {
  if (!arr.length) return;
  var index = arr.indexOf(item);
  if (index > -1) return arr.splice(index, 1);
}

function some(arr, fn) {
  var has = false;
  for (var i = 0, len = arr.length; i < len; i++) {
    if (fn(arr[i])) {
      has = true;
      break;
    }
  }
  return has;
}

function getBestSelectionFromSrcset(el, scale) {
  if (el.tagName !== 'IMG' || !el.getAttribute('data-srcset')) return;

  var options = el.getAttribute('data-srcset');
  var result = [];
  var container = el.parentNode;
  var containerWidth = container.offsetWidth * scale;

  var spaceIndex = void 0;
  var tmpSrc = void 0;
  var tmpWidth = void 0;

  options = options.trim().split(',');

  options.map(function (item) {
    item = item.trim();
    spaceIndex = item.lastIndexOf(' ');
    if (spaceIndex === -1) {
      tmpSrc = item;
      tmpWidth = 999998;
    } else {
      tmpSrc = item.substr(0, spaceIndex);
      tmpWidth = parseInt(item.substr(spaceIndex + 1, item.length - spaceIndex - 2), 10);
    }
    result.push([tmpWidth, tmpSrc]);
  });

  result.sort(function (a, b) {
    if (a[0] < b[0]) {
      return 1;
    }
    if (a[0] > b[0]) {
      return -1;
    }
    if (a[0] === b[0]) {
      if (b[1].indexOf('.webp', b[1].length - 5) !== -1) {
        return 1;
      }
      if (a[1].indexOf('.webp', a[1].length - 5) !== -1) {
        return -1;
      }
    }
    return 0;
  });
  var bestSelectedSrc = '';
  var tmpOption = void 0;

  for (var i = 0; i < result.length; i++) {
    tmpOption = result[i];
    bestSelectedSrc = tmpOption[1];
    var next = result[i + 1];
    if (next && next[0] < containerWidth) {
      bestSelectedSrc = tmpOption[1];
      break;
    } else if (!next) {
      bestSelectedSrc = tmpOption[1];
      break;
    }
  }

  return bestSelectedSrc;
}

function find(arr, fn) {
  var item = void 0;
  for (var i = 0, len = arr.length; i < len; i++) {
    if (fn(arr[i])) {
      item = arr[i];
      break;
    }
  }
  return item;
}

var getDPR = function getDPR() {
  var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return vue_lazyload_esm_inBrowser ? window.devicePixelRatio || scale : scale;
};

function supportWebp() {
  if (!vue_lazyload_esm_inBrowser) return false;

  var support = true;
  var d = document;

  try {
    var el = d.createElement('object');
    el.type = 'image/webp';
    el.style.visibility = 'hidden';
    el.innerHTML = '!';
    d.body.appendChild(el);
    support = !el.offsetWidth;
    d.body.removeChild(el);
  } catch (err) {
    support = false;
  }

  return support;
}

function throttle(action, delay) {
  var timeout = null;
  var lastRun = 0;
  return function () {
    if (timeout) {
      return;
    }
    var elapsed = Date.now() - lastRun;
    var context = this;
    var args = arguments;
    var runCallback = function runCallback() {
      lastRun = Date.now();
      timeout = false;
      action.apply(context, args);
    };
    if (elapsed >= delay) {
      runCallback();
    } else {
      timeout = setTimeout(runCallback, delay);
    }
  };
}

function testSupportsPassive() {
  if (!vue_lazyload_esm_inBrowser) return;
  var support = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get$$1() {
        support = true;
      }
    });
    window.addEventListener('test', null, opts);
  } catch (e) {}
  return support;
}

var supportsPassive = testSupportsPassive();

var _ = {
  on: function on(el, type, func) {
    var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (supportsPassive) {
      el.addEventListener(type, func, {
        capture: capture,
        passive: true
      });
    } else {
      el.addEventListener(type, func, capture);
    }
  },
  off: function off(el, type, func) {
    var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    el.removeEventListener(type, func, capture);
  }
};

var loadImageAsync = function loadImageAsync(item, resolve, reject) {
  var image = new Image();
  if (!item || !item.src) {
    var err = new Error('image src is required');
    return reject(err);
  }

  image.src = item.src;

  image.onload = function () {
    resolve({
      naturalHeight: image.naturalHeight,
      naturalWidth: image.naturalWidth,
      src: image.src
    });
  };

  image.onerror = function (e) {
    reject(e);
  };
};

var style = function style(el, prop) {
  return typeof getComputedStyle !== 'undefined' ? getComputedStyle(el, null).getPropertyValue(prop) : el.style[prop];
};

var overflow = function overflow(el) {
  return style(el, 'overflow') + style(el, 'overflow-y') + style(el, 'overflow-x');
};

var scrollParent = function scrollParent(el) {
  if (!vue_lazyload_esm_inBrowser) return;
  if (!(el instanceof HTMLElement)) {
    return window;
  }

  var parent = el;

  while (parent) {
    if (parent === document.body || parent === document.documentElement) {
      break;
    }

    if (!parent.parentNode) {
      break;
    }

    if (/(scroll|auto)/.test(overflow(parent))) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return window;
};

function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}

function ObjectKeys(obj) {
  if (!(obj instanceof Object)) return [];
  if (Object.keys) {
    return Object.keys(obj);
  } else {
    var keys = [];
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        keys.push(key);
      }
    }
    return keys;
  }
}

function ArrayFrom(arrLike) {
  var len = arrLike.length;
  var list = [];
  for (var i = 0; i < len; i++) {
    list.push(arrLike[i]);
  }
  return list;
}

function vue_lazyload_esm_noop() {}

var ImageCache = function () {
  function ImageCache(_ref) {
    var max = _ref.max;
    classCallCheck(this, ImageCache);

    this.options = {
      max: max || 100
    };
    this._caches = [];
  }

  createClass(ImageCache, [{
    key: 'has',
    value: function has(key) {
      return this._caches.indexOf(key) > -1;
    }
  }, {
    key: 'add',
    value: function add(key) {
      if (this.has(key)) return;
      this._caches.push(key);
      if (this._caches.length > this.options.max) {
        this.free();
      }
    }
  }, {
    key: 'free',
    value: function free() {
      this._caches.shift();
    }
  }]);
  return ImageCache;
}();

// el: {
//     state,
//     src,
//     error,
//     loading
// }

var ReactiveListener = function () {
  function ReactiveListener(_ref) {
    var el = _ref.el,
        src = _ref.src,
        error = _ref.error,
        loading = _ref.loading,
        bindType = _ref.bindType,
        $parent = _ref.$parent,
        options = _ref.options,
        elRenderer = _ref.elRenderer,
        imageCache = _ref.imageCache;
    classCallCheck(this, ReactiveListener);

    this.el = el;
    this.src = src;
    this.error = error;
    this.loading = loading;
    this.bindType = bindType;
    this.attempt = 0;

    this.naturalHeight = 0;
    this.naturalWidth = 0;

    this.options = options;

    this.rect = null;

    this.$parent = $parent;
    this.elRenderer = elRenderer;
    this._imageCache = imageCache;
    this.performanceData = {
      init: Date.now(),
      loadStart: 0,
      loadEnd: 0
    };

    this.filter();
    this.initState();
    this.render('loading', false);
  }

  /*
   * init listener state
   * @return
   */


  createClass(ReactiveListener, [{
    key: 'initState',
    value: function initState() {
      if ('dataset' in this.el) {
        this.el.dataset.src = this.src;
      } else {
        this.el.setAttribute('data-src', this.src);
      }

      this.state = {
        loading: false,
        error: false,
        loaded: false,
        rendered: false
      };
    }

    /*
     * record performance
     * @return
     */

  }, {
    key: 'record',
    value: function record(event) {
      this.performanceData[event] = Date.now();
    }

    /*
     * update image listener data
     * @param  {String} image uri
     * @param  {String} loading image uri
     * @param  {String} error image uri
     * @return
     */

  }, {
    key: 'update',
    value: function update(_ref2) {
      var src = _ref2.src,
          loading = _ref2.loading,
          error = _ref2.error;

      var oldSrc = this.src;
      this.src = src;
      this.loading = loading;
      this.error = error;
      this.filter();
      if (oldSrc !== this.src) {
        this.attempt = 0;
        this.initState();
      }
    }

    /*
     * get el node rect
     * @return
     */

  }, {
    key: 'getRect',
    value: function getRect() {
      this.rect = this.el.getBoundingClientRect();
    }

    /*
     *  check el is in view
     * @return {Boolean} el is in view
     */

  }, {
    key: 'checkInView',
    value: function checkInView() {
      this.getRect();
      return this.rect.top < window.innerHeight * this.options.preLoad && this.rect.bottom > this.options.preLoadTop && this.rect.left < window.innerWidth * this.options.preLoad && this.rect.right > 0;
    }

    /*
     * listener filter
     */

  }, {
    key: 'filter',
    value: function filter() {
      var _this = this;

      ObjectKeys(this.options.filter).map(function (key) {
        _this.options.filter[key](_this, _this.options);
      });
    }

    /*
     * render loading first
     * @params cb:Function
     * @return
     */

  }, {
    key: 'renderLoading',
    value: function renderLoading(cb) {
      var _this2 = this;

      this.state.loading = true;
      loadImageAsync({
        src: this.loading
      }, function (data) {
        _this2.render('loading', false);
        _this2.state.loading = false;
        cb();
      }, function () {
        // handler `loading image` load failed
        cb();
        _this2.state.loading = false;
        if (!_this2.options.silent) console.warn('VueLazyload log: load failed with loading image(' + _this2.loading + ')');
      });
    }

    /*
     * try load image and  render it
     * @return
     */

  }, {
    key: 'load',
    value: function load() {
      var _this3 = this;

      var onFinish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : vue_lazyload_esm_noop;

      if (this.attempt > this.options.attempt - 1 && this.state.error) {
        if (!this.options.silent) console.log('VueLazyload log: ' + this.src + ' tried too more than ' + this.options.attempt + ' times');
        onFinish();
        return;
      }
      if (this.state.rendered && this.state.loaded) return;
      if (this._imageCache.has(this.src)) {
        this.state.loaded = true;
        this.render('loaded', true);
        this.state.rendered = true;
        return onFinish();
      }

      this.renderLoading(function () {
        _this3.attempt++;

        _this3.options.adapter['beforeLoad'] && _this3.options.adapter['beforeLoad'](_this3, _this3.options);
        _this3.record('loadStart');

        loadImageAsync({
          src: _this3.src
        }, function (data) {
          _this3.naturalHeight = data.naturalHeight;
          _this3.naturalWidth = data.naturalWidth;
          _this3.state.loaded = true;
          _this3.state.error = false;
          _this3.record('loadEnd');
          _this3.render('loaded', false);
          _this3.state.rendered = true;
          _this3._imageCache.add(_this3.src);
          onFinish();
        }, function (err) {
          !_this3.options.silent && console.error(err);
          _this3.state.error = true;
          _this3.state.loaded = false;
          _this3.render('error', false);
        });
      });
    }

    /*
     * render image
     * @param  {String} state to render // ['loading', 'src', 'error']
     * @param  {String} is form cache
     * @return
     */

  }, {
    key: 'render',
    value: function render(state, cache) {
      this.elRenderer(this, state, cache);
    }

    /*
     * output performance data
     * @return {Object} performance data
     */

  }, {
    key: 'performance',
    value: function performance() {
      var state = 'loading';
      var time = 0;

      if (this.state.loaded) {
        state = 'loaded';
        time = (this.performanceData.loadEnd - this.performanceData.loadStart) / 1000;
      }

      if (this.state.error) state = 'error';

      return {
        src: this.src,
        state: state,
        time: time
      };
    }

    /*
     * $destroy
     * @return
     */

  }, {
    key: '$destroy',
    value: function $destroy() {
      this.el = null;
      this.src = null;
      this.error = null;
      this.loading = null;
      this.bindType = null;
      this.attempt = 0;
    }
  }]);
  return ReactiveListener;
}();

var DEFAULT_URL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
var DEFAULT_EVENTS = ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove'];
var DEFAULT_OBSERVER_OPTIONS = {
  rootMargin: '0px',
  threshold: 0
};

var Lazy = function (Vue) {
  return function () {
    function Lazy(_ref) {
      var preLoad = _ref.preLoad,
          error = _ref.error,
          throttleWait = _ref.throttleWait,
          preLoadTop = _ref.preLoadTop,
          dispatchEvent = _ref.dispatchEvent,
          loading = _ref.loading,
          attempt = _ref.attempt,
          _ref$silent = _ref.silent,
          silent = _ref$silent === undefined ? true : _ref$silent,
          scale = _ref.scale,
          listenEvents = _ref.listenEvents,
          hasbind = _ref.hasbind,
          filter = _ref.filter,
          adapter = _ref.adapter,
          observer = _ref.observer,
          observerOptions = _ref.observerOptions;
      classCallCheck(this, Lazy);

      this.version = '1.3.3';
      this.mode = modeType.event;
      this.ListenerQueue = [];
      this.TargetIndex = 0;
      this.TargetQueue = [];
      this.options = {
        silent: silent,
        dispatchEvent: !!dispatchEvent,
        throttleWait: throttleWait || 200,
        preLoad: preLoad || 1.3,
        preLoadTop: preLoadTop || 0,
        error: error || DEFAULT_URL,
        loading: loading || DEFAULT_URL,
        attempt: attempt || 3,
        scale: scale || getDPR(scale),
        ListenEvents: listenEvents || DEFAULT_EVENTS,
        hasbind: false,
        supportWebp: supportWebp(),
        filter: filter || {},
        adapter: adapter || {},
        observer: !!observer,
        observerOptions: observerOptions || DEFAULT_OBSERVER_OPTIONS
      };
      this._initEvent();
      this._imageCache = new ImageCache({ max: 200 });
      this.lazyLoadHandler = throttle(this._lazyLoadHandler.bind(this), this.options.throttleWait);

      this.setMode(this.options.observer ? modeType.observer : modeType.event);
    }

    /**
     * update config
     * @param  {Object} config params
     * @return
     */


    createClass(Lazy, [{
      key: 'config',
      value: function config() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        assignDeep(this.options, options);
      }

      /**
       * output listener's load performance
       * @return {Array}
       */

    }, {
      key: 'performance',
      value: function performance() {
        var list = [];

        this.ListenerQueue.map(function (item) {
          list.push(item.performance());
        });

        return list;
      }

      /*
       * add lazy component to queue
       * @param  {Vue} vm lazy component instance
       * @return
       */

    }, {
      key: 'addLazyBox',
      value: function addLazyBox(vm) {
        this.ListenerQueue.push(vm);
        if (vue_lazyload_esm_inBrowser) {
          this._addListenerTarget(window);
          this._observer && this._observer.observe(vm.el);
          if (vm.$el && vm.$el.parentNode) {
            this._addListenerTarget(vm.$el.parentNode);
          }
        }
      }

      /*
       * add image listener to queue
       * @param  {DOM} el
       * @param  {object} binding vue directive binding
       * @param  {vnode} vnode vue directive vnode
       * @return
       */

    }, {
      key: 'add',
      value: function add(el, binding, vnode) {
        var _this = this;

        if (some(this.ListenerQueue, function (item) {
          return item.el === el;
        })) {
          this.update(el, binding);
          return Vue.nextTick(this.lazyLoadHandler);
        }

        var _valueFormatter2 = this._valueFormatter(binding.value),
            src = _valueFormatter2.src,
            loading = _valueFormatter2.loading,
            error = _valueFormatter2.error;

        Vue.nextTick(function () {
          src = getBestSelectionFromSrcset(el, _this.options.scale) || src;
          _this._observer && _this._observer.observe(el);

          var container = Object.keys(binding.modifiers)[0];
          var $parent = void 0;

          if (container) {
            $parent = vnode.context.$refs[container];
            // if there is container passed in, try ref first, then fallback to getElementById to support the original usage
            $parent = $parent ? $parent.$el || $parent : document.getElementById(container);
          }

          if (!$parent) {
            $parent = scrollParent(el);
          }

          var newListener = new ReactiveListener({
            bindType: binding.arg,
            $parent: $parent,
            el: el,
            loading: loading,
            error: error,
            src: src,
            elRenderer: _this._elRenderer.bind(_this),
            options: _this.options,
            imageCache: _this._imageCache
          });

          _this.ListenerQueue.push(newListener);

          if (vue_lazyload_esm_inBrowser) {
            _this._addListenerTarget(window);
            _this._addListenerTarget($parent);
          }

          _this.lazyLoadHandler();
          Vue.nextTick(function () {
            return _this.lazyLoadHandler();
          });
        });
      }

      /**
      * update image src
      * @param  {DOM} el
      * @param  {object} vue directive binding
      * @return
      */

    }, {
      key: 'update',
      value: function update(el, binding, vnode) {
        var _this2 = this;

        var _valueFormatter3 = this._valueFormatter(binding.value),
            src = _valueFormatter3.src,
            loading = _valueFormatter3.loading,
            error = _valueFormatter3.error;

        src = getBestSelectionFromSrcset(el, this.options.scale) || src;

        var exist = find(this.ListenerQueue, function (item) {
          return item.el === el;
        });
        if (!exist) {
          this.add(el, binding, vnode);
        } else {
          exist.update({
            src: src,
            loading: loading,
            error: error
          });
        }
        if (this._observer) {
          this._observer.unobserve(el);
          this._observer.observe(el);
        }
        this.lazyLoadHandler();
        Vue.nextTick(function () {
          return _this2.lazyLoadHandler();
        });
      }

      /**
      * remove listener form list
      * @param  {DOM} el
      * @return
      */

    }, {
      key: 'remove',
      value: function remove$$1(el) {
        if (!el) return;
        this._observer && this._observer.unobserve(el);
        var existItem = find(this.ListenerQueue, function (item) {
          return item.el === el;
        });
        if (existItem) {
          this._removeListenerTarget(existItem.$parent);
          this._removeListenerTarget(window);
          remove(this.ListenerQueue, existItem);
          existItem.$destroy();
        }
      }

      /*
       * remove lazy components form list
       * @param  {Vue} vm Vue instance
       * @return
       */

    }, {
      key: 'removeComponent',
      value: function removeComponent(vm) {
        if (!vm) return;
        remove(this.ListenerQueue, vm);
        this._observer && this._observer.unobserve(vm.el);
        if (vm.$parent && vm.$el.parentNode) {
          this._removeListenerTarget(vm.$el.parentNode);
        }
        this._removeListenerTarget(window);
      }
    }, {
      key: 'setMode',
      value: function setMode(mode) {
        var _this3 = this;

        if (!hasIntersectionObserver && mode === modeType.observer) {
          mode = modeType.event;
        }

        this.mode = mode; // event or observer

        if (mode === modeType.event) {
          if (this._observer) {
            this.ListenerQueue.forEach(function (listener) {
              _this3._observer.unobserve(listener.el);
            });
            this._observer = null;
          }

          this.TargetQueue.forEach(function (target) {
            _this3._initListen(target.el, true);
          });
        } else {
          this.TargetQueue.forEach(function (target) {
            _this3._initListen(target.el, false);
          });
          this._initIntersectionObserver();
        }
      }

      /*
      *** Private functions ***
      */

      /*
       * add listener target
       * @param  {DOM} el listener target
       * @return
       */

    }, {
      key: '_addListenerTarget',
      value: function _addListenerTarget(el) {
        if (!el) return;
        var target = find(this.TargetQueue, function (target) {
          return target.el === el;
        });
        if (!target) {
          target = {
            el: el,
            id: ++this.TargetIndex,
            childrenCount: 1,
            listened: true
          };
          this.mode === modeType.event && this._initListen(target.el, true);
          this.TargetQueue.push(target);
        } else {
          target.childrenCount++;
        }
        return this.TargetIndex;
      }

      /*
       * remove listener target or reduce target childrenCount
       * @param  {DOM} el or window
       * @return
       */

    }, {
      key: '_removeListenerTarget',
      value: function _removeListenerTarget(el) {
        var _this4 = this;

        this.TargetQueue.forEach(function (target, index) {
          if (target.el === el) {
            target.childrenCount--;
            if (!target.childrenCount) {
              _this4._initListen(target.el, false);
              _this4.TargetQueue.splice(index, 1);
              target = null;
            }
          }
        });
      }

      /*
       * add or remove eventlistener
       * @param  {DOM} el DOM or Window
       * @param  {boolean} start flag
       * @return
       */

    }, {
      key: '_initListen',
      value: function _initListen(el, start) {
        var _this5 = this;

        this.options.ListenEvents.forEach(function (evt) {
          return _[start ? 'on' : 'off'](el, evt, _this5.lazyLoadHandler);
        });
      }
    }, {
      key: '_initEvent',
      value: function _initEvent() {
        var _this6 = this;

        this.Event = {
          listeners: {
            loading: [],
            loaded: [],
            error: []
          }
        };

        this.$on = function (event, func) {
          if (!_this6.Event.listeners[event]) _this6.Event.listeners[event] = [];
          _this6.Event.listeners[event].push(func);
        };

        this.$once = function (event, func) {
          var vm = _this6;
          function on() {
            vm.$off(event, on);
            func.apply(vm, arguments);
          }
          _this6.$on(event, on);
        };

        this.$off = function (event, func) {
          if (!func) {
            if (!_this6.Event.listeners[event]) return;
            _this6.Event.listeners[event].length = 0;
            return;
          }
          remove(_this6.Event.listeners[event], func);
        };

        this.$emit = function (event, context, inCache) {
          if (!_this6.Event.listeners[event]) return;
          _this6.Event.listeners[event].forEach(function (func) {
            return func(context, inCache);
          });
        };
      }

      /**
       * find nodes which in viewport and trigger load
       * @return
       */

    }, {
      key: '_lazyLoadHandler',
      value: function _lazyLoadHandler() {
        var _this7 = this;

        var freeList = [];
        this.ListenerQueue.forEach(function (listener, index) {
          if (!listener.el || !listener.el.parentNode) {
            freeList.push(listener);
          }
          var catIn = listener.checkInView();
          if (!catIn) return;
          listener.load();
        });
        freeList.forEach(function (item) {
          remove(_this7.ListenerQueue, item);
          item.$destroy();
        });
      }
      /**
      * init IntersectionObserver
      * set mode to observer
      * @return
      */

    }, {
      key: '_initIntersectionObserver',
      value: function _initIntersectionObserver() {
        var _this8 = this;

        if (!hasIntersectionObserver) return;
        this._observer = new IntersectionObserver(this._observerHandler.bind(this), this.options.observerOptions);
        if (this.ListenerQueue.length) {
          this.ListenerQueue.forEach(function (listener) {
            _this8._observer.observe(listener.el);
          });
        }
      }

      /**
      * init IntersectionObserver
      * @return
      */

    }, {
      key: '_observerHandler',
      value: function _observerHandler(entries, observer) {
        var _this9 = this;

        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            _this9.ListenerQueue.forEach(function (listener) {
              if (listener.el === entry.target) {
                if (listener.state.loaded) return _this9._observer.unobserve(listener.el);
                listener.load();
              }
            });
          }
        });
      }

      /**
      * set element attribute with image'url and state
      * @param  {object} lazyload listener object
      * @param  {string} state will be rendered
      * @param  {bool} inCache  is rendered from cache
      * @return
      */

    }, {
      key: '_elRenderer',
      value: function _elRenderer(listener, state, cache) {
        if (!listener.el) return;
        var el = listener.el,
            bindType = listener.bindType;


        var src = void 0;
        switch (state) {
          case 'loading':
            src = listener.loading;
            break;
          case 'error':
            src = listener.error;
            break;
          default:
            src = listener.src;
            break;
        }

        if (bindType) {
          el.style[bindType] = 'url("' + src + '")';
        } else if (el.getAttribute('src') !== src) {
          el.setAttribute('src', src);
        }

        el.setAttribute('lazy', state);

        this.$emit(state, listener, cache);
        this.options.adapter[state] && this.options.adapter[state](listener, this.options);

        if (this.options.dispatchEvent) {
          var event = new CustomEvent(state, {
            detail: listener
          });
          el.dispatchEvent(event);
        }
      }

      /**
      * generate loading loaded error image url
      * @param {string} image's src
      * @return {object} image's loading, loaded, error url
      */

    }, {
      key: '_valueFormatter',
      value: function _valueFormatter(value) {
        var src = value;
        var loading = this.options.loading;
        var error = this.options.error;

        // value is object
        if (isObject(value)) {
          if (!value.src && !this.options.silent) console.error('Vue Lazyload warning: miss src with ' + value);
          src = value.src;
          loading = value.loading || this.options.loading;
          error = value.error || this.options.error;
        }
        return {
          src: src,
          loading: loading,
          error: error
        };
      }
    }]);
    return Lazy;
  }();
};

var LazyComponent = (function (lazy) {
  return {
    props: {
      tag: {
        type: String,
        default: 'div'
      }
    },
    render: function render(h) {
      if (this.show === false) {
        return h(this.tag);
      }
      return h(this.tag, null, this.$slots.default);
    },
    data: function data() {
      return {
        el: null,
        state: {
          loaded: false
        },
        rect: {},
        show: false
      };
    },
    mounted: function mounted() {
      this.el = this.$el;
      lazy.addLazyBox(this);
      lazy.lazyLoadHandler();
    },
    beforeDestroy: function beforeDestroy() {
      lazy.removeComponent(this);
    },

    methods: {
      getRect: function getRect() {
        this.rect = this.$el.getBoundingClientRect();
      },
      checkInView: function checkInView() {
        this.getRect();
        return vue_lazyload_esm_inBrowser && this.rect.top < window.innerHeight * lazy.options.preLoad && this.rect.bottom > 0 && this.rect.left < window.innerWidth * lazy.options.preLoad && this.rect.right > 0;
      },
      load: function load() {
        this.show = true;
        this.state.loaded = true;
        this.$emit('show', this);
      },
      destroy: function destroy() {
        return this.$destroy;
      }
    }
  };
});

var LazyContainerMananger = function () {
  function LazyContainerMananger(_ref) {
    var lazy = _ref.lazy;
    classCallCheck(this, LazyContainerMananger);

    this.lazy = lazy;
    lazy.lazyContainerMananger = this;
    this._queue = [];
  }

  createClass(LazyContainerMananger, [{
    key: 'bind',
    value: function bind(el, binding, vnode) {
      var container = new LazyContainer$1({ el: el, binding: binding, vnode: vnode, lazy: this.lazy });
      this._queue.push(container);
    }
  }, {
    key: 'update',
    value: function update(el, binding, vnode) {
      var container = find(this._queue, function (item) {
        return item.el === el;
      });
      if (!container) return;
      container.update({ el: el, binding: binding, vnode: vnode });
    }
  }, {
    key: 'unbind',
    value: function unbind(el, binding, vnode) {
      var container = find(this._queue, function (item) {
        return item.el === el;
      });
      if (!container) return;
      container.clear();
      remove(this._queue, container);
    }
  }]);
  return LazyContainerMananger;
}();

var defaultOptions = {
  selector: 'img'
};

var LazyContainer$1 = function () {
  function LazyContainer(_ref2) {
    var el = _ref2.el,
        binding = _ref2.binding,
        vnode = _ref2.vnode,
        lazy = _ref2.lazy;
    classCallCheck(this, LazyContainer);

    this.el = null;
    this.vnode = vnode;
    this.binding = binding;
    this.options = {};
    this.lazy = lazy;

    this._queue = [];
    this.update({ el: el, binding: binding });
  }

  createClass(LazyContainer, [{
    key: 'update',
    value: function update(_ref3) {
      var _this = this;

      var el = _ref3.el,
          binding = _ref3.binding;

      this.el = el;
      this.options = assignDeep({}, defaultOptions, binding.value);

      var imgs = this.getImgs();
      imgs.forEach(function (el) {
        _this.lazy.add(el, assignDeep({}, _this.binding, {
          value: {
            src: 'dataset' in el ? el.dataset.src : el.getAttribute('data-src'),
            error: ('dataset' in el ? el.dataset.error : el.getAttribute('data-error')) || _this.options.error,
            loading: ('dataset' in el ? el.dataset.loading : el.getAttribute('data-loading')) || _this.options.loading
          }
        }), _this.vnode);
      });
    }
  }, {
    key: 'getImgs',
    value: function getImgs() {
      return ArrayFrom(this.el.querySelectorAll(this.options.selector));
    }
  }, {
    key: 'clear',
    value: function clear() {
      var _this2 = this;

      var imgs = this.getImgs();
      imgs.forEach(function (el) {
        return _this2.lazy.remove(el);
      });

      this.vnode = null;
      this.binding = null;
      this.lazy = null;
    }
  }]);
  return LazyContainer;
}();

var LazyImage = (function (lazyManager) {
  return {
    props: {
      src: [String, Object],
      tag: {
        type: String,
        default: 'img'
      }
    },
    render: function render(h) {
      return h(this.tag, {
        attrs: {
          src: this.renderSrc
        }
      }, this.$slots.default);
    },
    data: function data() {
      return {
        el: null,
        options: {
          src: '',
          error: '',
          loading: '',
          attempt: lazyManager.options.attempt
        },
        state: {
          loaded: false,
          error: false,
          attempt: 0
        },
        rect: {},
        renderSrc: ''
      };
    },

    watch: {
      src: function src() {
        this.init();
        lazyManager.addLazyBox(this);
        lazyManager.lazyLoadHandler();
      }
    },
    created: function created() {
      this.init();
      this.renderSrc = this.options.loading;
    },
    mounted: function mounted() {
      this.el = this.$el;
      lazyManager.addLazyBox(this);
      lazyManager.lazyLoadHandler();
    },
    beforeDestroy: function beforeDestroy() {
      lazyManager.removeComponent(this);
    },

    methods: {
      init: function init() {
        var _lazyManager$_valueFo = lazyManager._valueFormatter(this.src),
            src = _lazyManager$_valueFo.src,
            loading = _lazyManager$_valueFo.loading,
            error = _lazyManager$_valueFo.error;

        this.state.loaded = false;
        this.options.src = src;
        this.options.error = error;
        this.options.loading = loading;
        this.renderSrc = this.options.loading;
      },
      getRect: function getRect() {
        this.rect = this.$el.getBoundingClientRect();
      },
      checkInView: function checkInView() {
        this.getRect();
        return vue_lazyload_esm_inBrowser && this.rect.top < window.innerHeight * lazyManager.options.preLoad && this.rect.bottom > 0 && this.rect.left < window.innerWidth * lazyManager.options.preLoad && this.rect.right > 0;
      },
      load: function load() {
        var _this = this;

        var onFinish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : vue_lazyload_esm_noop;

        if (this.state.attempt > this.options.attempt - 1 && this.state.error) {
          if (!lazyManager.options.silent) console.log('VueLazyload log: ' + this.options.src + ' tried too more than ' + this.options.attempt + ' times');
          onFinish();
          return;
        }
        var src = this.options.src;
        loadImageAsync({ src: src }, function (_ref) {
          var src = _ref.src;

          _this.renderSrc = src;
          _this.state.loaded = true;
        }, function (e) {
          _this.state.attempt++;
          _this.renderSrc = _this.options.error;
          _this.state.error = true;
        });
      }
    }
  };
});

var index = {
  /*
  * install function
  * @param  {Vue} Vue
  * @param  {object} options  lazyload options
  */
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var LazyClass = Lazy(Vue);
    var lazy = new LazyClass(options);
    var lazyContainer = new LazyContainerMananger({ lazy: lazy });

    var isVue2 = Vue.version.split('.')[0] === '2';

    Vue.prototype.$Lazyload = lazy;

    if (options.lazyComponent) {
      Vue.component('lazy-component', LazyComponent(lazy));
    }

    if (options.lazyImage) {
      Vue.component('lazy-image', LazyImage(lazy));
    }

    if (isVue2) {
      Vue.directive('lazy', {
        bind: lazy.add.bind(lazy),
        update: lazy.update.bind(lazy),
        componentUpdated: lazy.lazyLoadHandler.bind(lazy),
        unbind: lazy.remove.bind(lazy)
      });
      Vue.directive('lazy-container', {
        bind: lazyContainer.bind.bind(lazyContainer),
        componentUpdated: lazyContainer.update.bind(lazyContainer),
        unbind: lazyContainer.unbind.bind(lazyContainer)
      });
    } else {
      Vue.directive('lazy', {
        bind: lazy.lazyLoadHandler.bind(lazy),
        update: function update(newValue, oldValue) {
          assignDeep(this.vm.$refs, this.vm.$els);
          lazy.add(this.el, {
            modifiers: this.modifiers || {},
            arg: this.arg,
            value: newValue,
            oldValue: oldValue
          }, {
            context: this.vm
          });
        },
        unbind: function unbind() {
          lazy.remove(this.el);
        }
      });

      Vue.directive('lazy-container', {
        update: function update(newValue, oldValue) {
          lazyContainer.update(this.el, {
            modifiers: this.modifiers || {},
            arg: this.arg,
            value: newValue,
            oldValue: oldValue
          }, {
            context: this.vm
          });
        },
        unbind: function unbind() {
          lazyContainer.unbind(this.el);
        }
      });
    }
  }
};

/* harmony default export */ var vue_lazyload_esm = (index);

// CONCATENATED MODULE: ./src/lib/v-title.js

(function () {
  function install(Vue) {
    var setWechatTitle = function setWechatTitle(title, img) {
      if (title === undefined || window.document.title === title) {
        return;
      }
      document.title = title;
      var mobile = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(mobile) && navigator.userAgent && navigator.userAgent.indexOf('AliApp') === -1) {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // 替换成站标favicon路径或者任意存在的较小的图片即可
        iframe.setAttribute('src', img || '/favicon.ico');
        var iframeCallback = function iframeCallback() {
          setTimeout(function () {
            iframe.removeEventListener('load', iframeCallback);
            document.body.removeChild(iframe);
          }, 0);
        };
        iframe.addEventListener('load', iframeCallback);
        document.body.appendChild(iframe);
      }
    };
    Vue.directive('wechat-title', function (el, binding) {
      setWechatTitle(binding.value, el.getAttribute('img-set') || null);
    });
  }
  vue_esm["a" /* default */].use(install);
})();
// EXTERNAL MODULE: ./node_modules/vue-photo-preview/dist/vue-photo-preview.js
var vue_photo_preview = __webpack_require__("ibnl");
var vue_photo_preview_default = /*#__PURE__*/__webpack_require__.n(vue_photo_preview);

// EXTERNAL MODULE: ./node_modules/vue-photo-preview/dist/skin.css
var skin = __webpack_require__("tOCg");
var skin_default = /*#__PURE__*/__webpack_require__.n(skin);

// EXTERNAL MODULE: ./src/mixins/globalMixin.js + 1 modules
var globalMixin = __webpack_require__("I6yJ");

// EXTERNAL MODULE: ./node_modules/xstream/index.js
var xstream = __webpack_require__("ryRw");
var xstream_default = /*#__PURE__*/__webpack_require__.n(xstream);

// CONCATENATED MODULE: ./src/async-hack.js



/*xstream扩展*/

window.xstream = xstream;
var win = window,
    slice = Array.prototype.slice;

function loadScript(url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.onload = function () {
        script.onload = null;
        callback();
    };

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
};

var sdkResolve,
    // 暴露一个wx sdk load task的promise接口
domReadyResolve,
    // 暴露一个DOMContentLoaded event的promise接口
async_hack_domReadyPr = new promise_default.a(function (resolve) {
    return domReadyResolve = resolve;
});

win.domReadyPr = async_hack_domReadyPr;
win.wxSDKLoadTask = new promise_default.a(function (resolve) {
    return sdkResolve = resolve;
});

// var monitor = {
//         init() {
//             var i = 0,
//                 Stream = xstream.Stream;

//             Stream.fromArray(this.list)
//                 // 由于monitor.stat是同步函数，并往文档插入<script>，所以需要限频率
//                 .delayWhen(() => ++i % 4 ? Stream.of(0) : Stream.periodic(400).take(1))
//                 .addListener({
//                     next(params) {
//                         // console.log(win.monitor);
//                         win.monitor.stat.apply(win.monitor, params);
//                     }
//                 })
//         },
//         stat() {
//             this.list.push(slice.call(arguments));
//         },
//         list: []
//     };

// win.monitor = monitor;

// 将一些首屏无关的脚本加载延迟到DOMContentLoaded，甚至onload。
document.addEventListener("DOMContentLoaded", function () {
    domReadyResolve();
    if (/(?:MicroMessenger)/.test(navigator.userAgent)) {
        // 异步加载wxSDK
        loadScript('//res.wx.qq.com/open/js/jweixin-1.3.2.js', sdkResolve);
    }
    // 异步加载monitor.js，在此之前，提供一个monitor对象收集对window.monitor的调用。
    // 在monitor.js 就绪之后，重播收集到的信息。
    // setTimeout(function() {
    //     loadScript('//static.xinli001.com/frontend-lib/monitor.js', function() {
    //         // 配置monitor
    //         window.monitor.rootData.from = 'cp';
    //         monitor.init();
    //     });
    // }, 500);
});
// EXTERNAL MODULE: ./src/lib/zhugeTrack.js
var zhugeTrack = __webpack_require__("U3rI");

// EXTERNAL MODULE: ./src/frontend-lib/lib/stat/Stat.js + 3 modules
var Stat = __webpack_require__("Eqnl");

// CONCATENATED MODULE: ./src/lib/track.js
// 使用新的埋点规范，参考http://112.124.122.87:8090/pages/viewpage.action?pageId=6554041




var _getPlatform = Object(getPlatform["getPlatform"])(),
    isYixinliApp = _getPlatform.isYixinliApp;

var track_channelId = Object(units["l" /* getHashParameters */])()['channelId'] || Object(units["a" /* GetQueryString */])('channelId');

var platform = 'cp';
if (+track_channelId === 513) platform = 'msite';
if (isYixinliApp) platform = 'yxlApp';

var cpStat = new Stat["a" /* default */]({ platform: platform });

// 页面访问
function visit(_ref) {
  var category = _ref.category,
      eventValue = _ref.eventValue,
      extraAttr = _ref.extraAttr;

  cpStat.visit({
    businessType: '测评', // 事件所属业务
    category: category, // 产品
    eventValue: eventValue, // 主要属性值
    extraAttr: extraAttr // 额外属性
  });
}

// 交互行为
function interact(_ref2) {
  var category = _ref2.category,
      eventValue = _ref2.eventValue,
      pageTitle = _ref2.pageTitle,
      extraAttr = _ref2.extraAttr;

  cpStat.interact({
    businessType: '测评', // 事件所属业务
    category: category, // 产品
    eventValue: eventValue, // 主要属性值
    pageTitle: pageTitle,
    extraAttr: extraAttr // 额外属性
  });
}

// 社交行为
function social(_ref3) {
  var category = _ref3.category,
      eventValue = _ref3.eventValue,
      _ref3$eventAttribute = _ref3.eventAttribute,
      eventAttribute = _ref3$eventAttribute === undefined ? '对象' : _ref3$eventAttribute,
      pageTitle = _ref3.pageTitle,
      extraAttr = _ref3.extraAttr;

  cpStat.social({
    businessType: '测评', // 事件所属业务
    category: category, // 产品
    eventAttribute: eventAttribute, // 主要事件属性
    eventValue: eventValue, // 主要属性值
    pageTitle: pageTitle, // 页面title
    extraAttr: extraAttr
  });
}

/* harmony default export */ var track = ({
  visit: visit,
  interact: interact,
  social: social
});
// EXTERNAL MODULE: ./node_modules/@yxl/libs/es/index.js
var es = __webpack_require__("TSB3");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/App.vue?vue&type=template&id=725046fd&
var Appvue_type_template_id_725046fd__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive && !_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_vm._v(" "),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('global-loading',{attrs:{"propLOADINGTEXT":_vm.LOADINGTEXT}})],1),_vm._v(" "),_c('globalToast',{attrs:{"propText":_vm.TOASTTEXT,"status":_vm.TOASTSTATUS,"propTime":_vm.TOASTTIME},on:{"toastEnd":function($event){return _vm.setTOASTTEXT('')}}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.GlobalAdShow)?_c('globalAd',{key:_vm.GlobalAdShow,attrs:{"confirmRoute":_vm.GlobalAdConfirmRoute,"cancelRoute":_vm.GlobalAdCancelRoute,"period":_vm.GlobalAdPeriod},on:{"close":function($event){return _vm.setGlobalAdShow(false)}}}):_vm._e()],1),_vm._v(" "),(_vm.TESTCHANNEL || _vm.showPopWindowStatus)?_c('couponDialog'):_vm._e()],1)}
var Appvue_type_template_id_725046fd__staticRenderFns = []


// CONCATENATED MODULE: ./src/App.vue?vue&type=template&id=725046fd&

// EXTERNAL MODULE: ./src/components/common/yxlToast.vue + 4 modules
var yxlToast = __webpack_require__("d1Yp");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/promotion/global_ad.vue?vue&type=template&id=4fb340d3&
var global_advue_type_template_id_4fb340d3__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"globalAd"},[_c('myMaks',{staticStyle:{"background":"rgba(0,0,0,.75)"}}),_vm._v(" "),_c('scrollview',{staticClass:"globalAd-wrapper"},[_c('ul',{class:[_vm.channelId == 105 ?'globalAd-pic-other':'globalAd-pic']},[_c('v-touch',{staticClass:"cancel-icon",on:{"tap":_vm.cancel}},[_c('img',{attrs:{"src":__webpack_require__("C416")}})]),_vm._v(" "),_c('v-touch',{staticClass:" confirm",on:{"tap":_vm.confirm}},[_vm._v("马上购买")])],1)])],1)}
var global_advue_type_template_id_4fb340d3__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/promotion/global_ad.vue?vue&type=template&id=4fb340d3&

// EXTERNAL MODULE: ./src/components/common/scrollview.vue + 4 modules
var scrollview = __webpack_require__("5sM3");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/promotion/global_ad.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var global_advue_type_script_lang_js_ = ({
    name: 'globalAd',
    components: {
        myMaks: mask["a" /* default */],
        scrollview: scrollview["a" /* default */]
    },
    props: {
        confirmRoute: {
            required: true
        },
        cancelRoute: {
            required: true
        },
        period: {
            // 周期
            required: false,
            type: [String, Number]
        }
    },
    mounted: function mounted() {
        if (this.period) {
            Object(cookies["a" /* setCookie */])({
                key: 'cpPromotionGlobalAdShowed',
                value: 1,
                timeMinSec: this.period
            });
            // this.back();
        }
    },

    methods: {
        stopScroll: function stopScroll() {
            event.preventDefault();
            event.stopPropagation();
        },
        confirm: function confirm() {
            var _this = this;

            this.close();
            if (this.confirmRoute) {
                var route = this.$router.matcher.match(this.confirmRoute);
                if (typeof this.confirmRoute === 'function') {
                    this.confirmRoute();
                } else if (route) {
                    setTimeout(function () {
                        if (route.fullPath) {
                            _this.$router.push(route.fullPath);
                        }
                    }, 500);
                }
            }
        },
        cancel: function cancel() {
            var _this2 = this;

            this.close();
            if (this.cancelRoute) {
                // 有可能是undefined, undefined表示不跳转
                var route = this.$router.matcher.match(this.cancelRoute);
                if (typeof this.cancelRoute === 'function') {
                    this.cancelRoute();
                } else if (route) {
                    setTimeout(function () {
                        if (route.fullPath) {
                            _this2.$router.push(route.fullPath);
                        }
                    }, 500);
                }
            }
        },
        close: function close() {
            this.$emit('close');
            if (this.period) {
                Object(cookies["a" /* setCookie */])({
                    key: 'cpPromotionGlobalAdShowed',
                    value: 1,
                    timeMinSec: this.period
                });
            }
        },
        pushHistory: function pushHistory() {
            var state = {
                title: 'title',
                url: "#"
            };
            window.history.pushState(state, state.title, state.url);
        },
        back: function back() {
            var that = this;
            that.pushHistory();
            window.addEventListener("popstate", function (e) {
                that.close();
                location.href = '' + location.origin + location.pathname + '?channelId=' + that.channelId + '#' + that.$route.path;
                //返回键重定向当前页面
            }, false);
        }
    },
    destroyed: function destroyed() {
        this.close();
    }
});
// CONCATENATED MODULE: ./src/components/promotion/global_ad.vue?vue&type=script&lang=js&
 /* harmony default export */ var promotion_global_advue_type_script_lang_js_ = (global_advue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/promotion/global_ad.vue?vue&type=style&index=0&lang=scss&
var global_advue_type_style_index_0_lang_scss_ = __webpack_require__("2JP7");

// CONCATENATED MODULE: ./src/components/promotion/global_ad.vue






/* normalize component */

var global_ad_component = Object(componentNormalizer["a" /* default */])(
  promotion_global_advue_type_script_lang_js_,
  global_advue_type_template_id_4fb340d3__render,
  global_advue_type_template_id_4fb340d3__staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var global_ad = (global_ad_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/member/couponDialog.vue?vue&type=template&id=3b718f86&scoped=true&
var couponDialogvue_type_template_id_3b718f86_scoped_true__render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPopWindowStatus && _vm.couponBg)?_c('div',{staticClass:"couponModal"},[_c('myMask',{on:{"click":function($event){$event.stopPropagation();return _vm.closeModal($event)}}}),_vm._v(" "),_c('div',{staticClass:"couponModal-win",class:[_vm.couponModalWinBg],style:({'background': ("url(" + _vm.couponBg + ")")}),on:{"click":function($event){return _vm.goActivty()}}},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.closeModal($event)}}},[_c('i',{staticClass:"icon-close"})])])],1):_vm._e()}
var couponDialogvue_type_template_id_3b718f86_scoped_true__staticRenderFns = []


// CONCATENATED MODULE: ./src/components/member/couponDialog.vue?vue&type=template&id=3b718f86&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/member/couponDialog.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var couponDialogvue_type_script_lang_js_ = ({
  name: "",
  components: {
    myMask: mask["a" /* default */]
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['showPopWindowStatus', 'vipPopWindow', 'adsense']), {
    couponModalWinBg: function couponModalWinBg() {
      return 'couponModal-win_bg';
    },
    adPopupConfig: function adPopupConfig() {
      var r = {};
      r = this.adsense.find(function (element) {
        return element['adsenseType'] == 1;
      });
      // console.log('--- 获取到的弹窗数据 ---', r)
      return r;
    },
    couponBg: function couponBg() {
      if (this.isHideChannel) return '';
      var config = this.adPopupConfig;
      if (!config) {
        return;
      }
      // console.log('--- 弹窗背景 内部渠道 ---', this.CHANNEL_INTERNALCHANNEL)
      var isInternal = config.channelScope.includes('1') && this.CHANNEL_INTERNALCHANNEL;
      var isExternal = config.channelScope.includes('2') && !this.CHANNEL_INTERNALCHANNEL;
      var isNotLogin = config.advertisingChannelScope && config.advertisingChannelScope.includes('1') && this.CHANNEL_NOT_LOGIN;
      if (isInternal || isExternal || isNotLogin) {
        var now = new Date();
        if (config && now > new Date(config.startTime.replace(/-/g, "/")) && now < new Date(config.endTime.replace(/-/g, "/"))) {
          // console.log('--- 弹窗在开始和结束时间内 ---',)
          return config.image;
        } else {
          return '';
        }
      } else {
        return '';
      }
    }
  }),
  mounted: function mounted() {
    var that = this;
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])(['setShowPopWindowStatus']), {
    closeModal: function closeModal() {
      this.setShowPopWindowStatus(false);
      this.$emit("closeMoadl");
      if (this.$route.name == 'showIndex') {
        localStorage.setItem('dialogStore', 'oneDayfristdialogStore' + new Date().getDate());
      }
    },
    initScroll: function initScroll() {},
    preventMove: function preventMove() {
      event.preventDefault();
    },
    goActivty: function goActivty() {
      this.setShowPopWindowStatus(false);
      // console.log('--- 跳转之前的路由信息 ---', this.$route)
      if (this.$route.name == 'showIndex') {
        localStorage.setItem('dialogStore', 'oneDayfristdialogStore' + new Date().getDate());
      }
      var type = this.$route.name;
      this.goIntoDialog(type, this.adPopupConfig);
    }
  })
});
// CONCATENATED MODULE: ./src/components/member/couponDialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var member_couponDialogvue_type_script_lang_js_ = (couponDialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/member/couponDialog.vue?vue&type=style&index=0&id=3b718f86&lang=scss&scoped=true&
var couponDialogvue_type_style_index_0_id_3b718f86_lang_scss_scoped_true_ = __webpack_require__("dGBc");

// CONCATENATED MODULE: ./src/components/member/couponDialog.vue






/* normalize component */

var couponDialog_component = Object(componentNormalizer["a" /* default */])(
  member_couponDialogvue_type_script_lang_js_,
  couponDialogvue_type_template_id_3b718f86_scoped_true__render,
  couponDialogvue_type_template_id_3b718f86_scoped_true__staticRenderFns,
  false,
  null,
  "3b718f86",
  null
  
)

/* harmony default export */ var couponDialog = (couponDialog_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/App.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Appvue_type_script_lang_js_ = ({
    name: 'app',
    provide: function provide() {
        return {
            reload: this.reload
        };
    },
    data: function data() {
        return {
            isRouterAlive: true,
            showAD: false,
            couponDialogData: {
                propMask: true,
                title: '',
                content: '',
                actions: []
            },
            test: {}
        };
    },

    components: {
        footerNav: footerNav["a" /* default */],
        globalLoading: globalLoading,
        globalToast: yxlToast["a" /* default */],
        globalAd: global_ad,
        couponDialog: couponDialog
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['LOADINGTEXT', 'TOASTTEXT', 'TOASTSTATUS', 'TOASTTIME', 'userInfo', 'showPopWindowStatus']), Object(vuex_esm["c" /* mapGetters */])(['GlobalAdConfirmRoute', 'GlobalAdCancelRoute', 'GlobalAdPeriod', 'GlobalAdShow'])),
    mounted: function mounted() {
        var that = this;
        // 禁用双指缩放：
        document.documentElement.addEventListener('touchstart', function (event) {
            if (event.touches.length > 1) {
                event.preventDefault();
            }
        }, false);
        // 禁用手指双击缩放：
        var lastTouchEnd = 0;
        document.documentElement.addEventListener('touchend', function (event) {
            var now = Date.now();
            if (now - lastTouchEnd <= 300) {
                event.preventDefault();
            }
            lastTouchEnd = now;
        }, false);
    },

    methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])(['setGlobalAdShow']), Object(vuex_esm["b" /* mapActions */])(['GET_DISCOUNT_COUPON_STATUS', 'DISCOUNT_COUPON_RECERIVE', 'storeSource']), {
        reload: function reload() {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            });
        }
    }),
    watch: {}
});
// CONCATENATED MODULE: ./src/App.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_Appvue_type_script_lang_js_ = (Appvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/App.vue?vue&type=style&index=0&lang=scss&
var Appvue_type_style_index_0_lang_scss_ = __webpack_require__("0e3M");

// CONCATENATED MODULE: ./src/App.vue






/* normalize component */

var App_component = Object(componentNormalizer["a" /* default */])(
  src_Appvue_type_script_lang_js_,
  Appvue_type_template_id_725046fd__render,
  Appvue_type_template_id_725046fd__staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var App = (App_component.exports);
// CONCATENATED MODULE: ./src/main.js













vue_esm["a" /* default */].use(entry);

try {
  window.catchVueErrorFromHeadScript(vue_esm["a" /* default */]);
} catch (e) {
  console.log('--- window.catchVueErrorFromHeadScript --- catch e', e);
}


vue_esm["a" /* default */].use(vue_touch_default.a);
// router

// 移动端适配

// store

// lazyload

//Vue.use(VueLazyload)

vue_esm["a" /* default */].use(vue_lazyload_esm, {
  loading: __webpack_require__("RqoC")
});
// set wechat title

// Vue.use(VueWechatTitle)




var options = {
  fullscreenEl: false
};
vue_esm["a" /* default */].use(vue_photo_preview_default.a, options);

// 引用全局mixin

vue_esm["a" /* default */].mixin(globalMixin["a" /* default */]);

/*全局公用组件注册*/
vue_esm["a" /* default */].component('sort-div', {
  render: function render(createElement) {
    var _this = this;

    return createElement('div', keys_default()(this.$slots).sort(function (a, b) {
      return a - b;
    }).map(function (i) {
      return _this.$slots[+i];
    }));
  }
});

// 将一些首屏无关的脚本改造为异步加载


// 埋点统计的Class

// 配置TRACKER，用于触发埋点的对象
var trackerObj = new zhugeTrack["a" /* TRACKER */]();
var isDouyinApp = navigator.userAgent.toLowerCase().includes('toutiaomicroapp');

//抖音端隐藏诸葛io
if (isDouyinApp) {
  Object(units["t" /* loadScript */])('https://s3.pstatp.com/toutiao/tmajssdk/jssdk-1.0.1.js');
  // 抖音端加载抖音sdk
  get_own_property_names_default()(trackerObj.__proto__).map(function (key) {
    if (typeof trackerObj[key] === 'function') {
      trackerObj[key] = function () {};
    }
  });
}
window.TRACKER = trackerObj;

// 新埋点规范

vue_esm["a" /* default */].prototype.$cpStat = track;

// 配置 axios
vue_esm["a" /* default */].prototype.$http = axios_default.a;
// Vue.prototype.$stat = new stat()
vue_esm["a" /* default */].prototype.$env = Object(getPlatform["getRunningEnv"])();

axios_default.a.defaults.withCredentials = true;
/* 为网络错误提供统一中间件处理 */
axios_default.a.defaults.validateStatus = function (status) {
  return true;
};

function getHashParameters() {
  var arr = (location.hash || "").replace(/^\#/, '').split("&");
  var params = {};
  for (var i = 0; i < arr.length; i++) {
    var data = arr[i].split("=");
    if (data.length == 2) {
      params[data[0]] = data[1];
    }
  }
  var channelIdObj;
  keys_default()(params).map(function (item, index) {
    if (item.indexOf('?')) {
      var getChannelId = item.split("?")[1];
      if (getChannelId == 'channelId') {
        channelIdObj = {
          channelId: params[item]
        };
      }
    }
  });
  params = assign_default()(params, channelIdObj);
  return params;
}

axios_default.a.defaults.withCredentials = true;
axios_default.a.defaults.crossDomain = true;
axios_default.a.interceptors.request.use(function (config) {
  //配合后端解决新版微信授权问题，统一加上token
  if (localStorage.getItem('cp_token')) {
    config.headers.cpToken = localStorage.getItem('cp_token');
  }
  var getPostChannelId = function getPostChannelId() {
    if (config.data) {
      var params = qs_lib_default.a.parse(config.data);
      return params.channelId;
    } else {
      return '';
    }
  };
  var channelId = getHashParameters().channelId || config.params.channelId || getPostChannelId();
  config.url = channelId ? changeApiHost(channelId, config.url) : config.url;
  return config;
}, function (error) {
  // 对请求失败做处理
  return promise_default.a.reject(error);
});

axios_default.a.interceptors.response.use(function (res) {
  if (res.status && res.status != 200) {
    window.monitor.stat({
      level: 'error',
      error: 'API',
      url: res.config.url,
      status: res.status,
      msg: res.stack
    });
  }

  return res;
}, function (err) {
  window.monitor.stat({
    level: 'error',
    error: 'API',
    url: err.config.url,
    msg: err.stack
  });

  return err;
});

// 神策埋点


vue_esm["a" /* default */].use(es["e" /* trackPlugin */], {
  trackOptions: {
    customTrackConfig: {
      is_track_single_page: false
    }
  }
});

/*xstream扩展*/


window.xstream = xstream;
importOutdatedLib();

function importOutdatedLib() {
  __webpack_require__("hPmf");
  var Stream = xstream["Stream"];
  Stream.fromEvent = function (el, event) {
    return Stream.create({
      start: function start(prod) {
        var n = 1;

        this.listener = function (e) {
          prod.next({
            event: e,
            index: n++
          });
        };

        el.addEventListener(event, this.listener);
      },
      stop: function stop() {
        el.removeEventListener(event, this.listener);
      }
    });
  };

  Stream.ajax = function (url, params, method) {
    return Stream.create({
      start: function start(prod) {
        axios_default.a[method || 'get'](url, method == 'post' ? params : {
          params: params
        }).then(function (res) {
          if (+res.data.code !== 1) {
            window.monitor.stat({
              level: 'error',
              error: 'API',
              url: url,
              status: res.data.code,
              params: stringify_default()(params ? params : {}),
              msg: stringify_default()(res.data)
            });
            return promise_default.a.reject(res.data);
          }
          return res.data;
        }).then(function (json) {
          prod.next(json);
          prod.complete();
        }, function (err) {
          return prod.error(err);
        });
      },
      stop: function stop() {}
    });
  };

  Stream.domReady = function () {
    return Stream.from(domReadyPr);
  };

  Stream.prototype.$addListener = function (vm, listeners) {
    if (!(vm instanceof vue_esm["a" /* default */])) {
      throw new Error('vm不是Vue实例');
    }
    vm._stream_.push([this, listeners]);
    return this.addListener(listeners);
  };
}

setTimeout(installFunction);

function installFunction() {
  // 连击页面任意位置10次，开启开发模式
  xstream["Stream"].fromEvent(document.documentElement, 'touchstart').warpGroup(300, 20).filter(function (res) {
    return res.length >= 100;
  }).take(1).addListener({
    next: function next() {
      alert(__PUBLISH_HASH__);
    }
  });
}

function getApiHost(getUrl, type) {
  var hostList = getUrl.split('/');
  var host = hostList[2];
  //小程序的接口路径切换成p-
  if (type) {
    if (host.includes('lingxi' + apis["a" /* default */].env + '.xinli001.com') || host.includes('m-lingxi' + apis["a" /* default */].env + '.xinli001.com')) {
      hostList[2] = 'p-lingxi' + apis["a" /* default */].env + '.xinli001.com';
    }
    if (host.includes('cpapi' + apis["a" /* default */].env + '.xinli001.com') || host.includes('m-cpapi' + apis["a" /* default */].env + '.xinli001.com')) {
      hostList[2] = 'p-cpapi' + apis["a" /* default */].env + '.xinli001.com';
    }
  } else {
    if (host.includes('m-lingxi' + apis["a" /* default */].env + '.xinli001.com')) {
      hostList[2] = 'lingxi' + apis["a" /* default */].env + '.xinli001.com';
    }
    if (host.includes('m-cpapi' + apis["a" /* default */].env + '.xinli001.com')) {
      hostList[2] = 'cpapi' + apis["a" /* default */].env + '.xinli001.com';
    }
  }
  var newUrl = '';
  hostList.map(function (items, index) {
    newUrl = newUrl + '/' + items;
  });
  return newUrl.substr(1);
}

function changeApiHost(channelId, url) {
  var getUrl = url;
  var type = '';
  var getChannelId = channelId.toString();
  //研测环境不需要m- p-
  if (apis["a" /* default */].env) {
    return getApiHost(getUrl);
  }
  var isOldHost = ['122', '168', '238', '364', '378', '394', '398', '485', '1396', '1409', '1542', '1785', '1787', '1843', '1908', '2044', '2068', '2147', '2190', '2244', '2290', '2291', '2432'].includes(getChannelId);
  // 头条渠道 或者 快手渠道 用p-路由
  var isTouTiaoHost = ['2345', '2545', '2939', '3268'].includes(getChannelId);
  if (isTouTiaoHost) {
    type = 'OTHER_WEB_APP';
  }
  var apiUrl = isOldHost || isTouTiaoHost ? getApiHost(getUrl, type) : getUrl;
  return apiUrl;
}

//调试工具，链接上加vconsole=1可见
if (location.href.indexOf('vconsole=1') !== -1) {
  // 劫持console.log，存储vconsole加载前的打印数据
  var consoleLog = [];
  var myVconsole = null;
  var logMethod = console.log;
  console.log = function () {
    if (!myVconsole) {
      consoleLog.push(arguments);
    }
    logMethod.apply(console, arguments);
  };
  var vconsoleUrl = 'https://unpkg.com/vconsole/dist/vconsole.min.js';
  Object(units["t" /* loadScript */])(vconsoleUrl, function () {
    myVconsole = new window.VConsole();
    var i = 0,
        len = consoleLog.length;
    for (; i < len; i++) {
      var item = consoleLog[i];
      console.log.apply(console, item);
    }
  });
}


var main_App = new vue_esm["a" /* default */]({
  store: store["a" /* default */],
  router: src_router,
  template: '<index></index>',
  components: {
    index: App
  },
  created: function created() {
    document.getElementById('pageLoading').remove();
  }
}).$mount('#app');

/***/ }),

/***/ "NNrz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("zgIt");

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),

/***/ "NTs4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "NWt+":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("+ZMJ");
var call = __webpack_require__("msXi");
var isArrayIter = __webpack_require__("Mhyx");
var anObject = __webpack_require__("77Pl");
var toLength = __webpack_require__("QRG4");
var getIterFn = __webpack_require__("3fs2");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "NYxO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Store */
/* unused harmony export createNamespacedHelpers */
/* unused harmony export install */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mapState; });
/*!
 * vuex v3.4.0
 * (c) 2020 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.hasChild = function hasChild (key) {
  return key in this._children
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if ((false)) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  return parent.hasChild(key)
};

function update (path, targetModule, newModule) {
  if ((false)) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if ((false)) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if ((false)) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if ((false)) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if ((false)) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if ((false)) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if ((false)) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.after; })
          .forEach(function (sub) { return sub.after(action, this$1.state); });
      } catch (e) {
        if ((false)) {
          console.warn("[vuex] error in after action subscribers: ");
          console.error(e);
        }
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.error; })
          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
      } catch (e) {
        if ((false)) {
          console.warn("[vuex] error in error action subscribers: ");
          console.error(e);
        }
      }
      reject(error);
    });
  })
};

Store.prototype.subscribe = function subscribe (fn, options) {
  return genericSubscribe(fn, this._subscribers, options)
};

Store.prototype.subscribeAction = function subscribeAction (fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if ((false)) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule (path) {
  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  return this._modules.isRegistered(path)
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && ("production" !== 'production')) {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if ((false)) {
        if (moduleName in parentState) {
          console.warn(
            ("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + (path.join('.')) + "\"")
          );
        }
      }
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if ((false)) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if ((false)) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if ((false)) {
    assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if ((false)) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept anthor params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index = {
  Store: Store,
  install: install,
  version: '3.4.0',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};

/* harmony default export */ __webpack_exports__["a"] = (index);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "NdkX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NfZy":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("77Ug")('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "Nkrw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var $every = __webpack_require__("LhTa")(4);

$export($export.P + $export.F * !__webpack_require__("NNrz")([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "No4x":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__("Ds5P");

$export($export.P, 'Array', { fill: __webpack_require__("zCYm") });

__webpack_require__("RhFG")('fill');


/***/ }),

/***/ "NpIQ":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "Nvhv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O4g8":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "OCs3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.076bc05.png";

/***/ }),

/***/ "ON07":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
var document = __webpack_require__("7KvD").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "OTud":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * @Author: hasee
 * @Date:   2016-12-12 18:27:29
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2019-05-27 10:42:58
 */
var env = location.host.split('.')[0].match(/(qc|box)\d?/g);
var spell = !!env ? env.length > 0 ? '-' + env[0] : '' : '';
var WXDOMAIN = '//wx' + spell + '.xinli001.com/',
    CPDOMAIN = '//m-cpapi' + spell + '.xinli001.com/',
    LXDOMAIN = spell ? '//lingxi' + spell + '.xinli001.com/lingxi/service/' : '//m-lingxi' + spell + '.xinli001.com/lingxi/service/',
    CPAPI = spell ? '//cpapi' + spell + '.xinli001.com/cp/service/' : '//m-cpapi' + spell + '.xinli001.com/cp/service/',
    LX = '//lx' + spell + '.xinli001.com/lx/',
    FUN = '//qu' + spell + '.xinli001.com/lingxi/fun/',
    YIAPIDOMAIN = '//yiapi' + spell + '.xinli001.com',
    MDOMAIN = '//m' + spell + '.xinli001.com',
    PGXINLI = '//appoint' + (spell.indexOf('box') != -1 ? '-box1' : spell.indexOf('qc') != -1 ? '-qc4' : spell) + '.pgxinli.com',

// MDOMAIN = `//m.xinli001.com`,
// PGXINLI = `//appoint.pgxinli.com`,
HCP = '//hcp' + spell + '.xinli001.com',
    CPBADMIN = '//cpbadmin' + spell + '.xinli001.com',
    LXKC = '//kc' + spell + '.xinli001.com/lingxikc/',

// LXKC = `//kc-box4.xinli001.com/lingxikc/`,
APIS = {
  env: spell,
  host: 'cp' + spell + '.japgb7.top',
  shareHost: spell ? 'static' + spell + '.xinli001.com' : 'cp' + spell + '.japgb7.top',
  shareHostC: 'hd' + spell + '.xinli001.site',
  shareHostA: 'hd' + spell + '.ebejj12.top',
  shareHostCC: 'hd' + spell + '.xinli001.cc',
  toutiaoShareHost: 'hd' + spell + '.yixinli.xin', //新增头条分享链接
  locationHerfType: false,
  //  灵犀接口
  wechatData: LXDOMAIN + 'wx/jsConfig', //  微信初始化信息
  getUserInfo: LXDOMAIN + 'user/detail', // 用户信息
  getUserInfoFromPlatfrom: '//m-cpapi' + spell + '.xinli001.com/cp/mservice/user/refreshUser', // 从平台的userId换userKey
  getPlatformUserInfo: '//m-cpapi' + spell + '.xinli001.com/cp/mservice/platformUser/detail', // 获取平台用户信息
  geWxAppUserInfo: LXDOMAIN + 'miniApp/user/detail', // 小程序版的用户信息
  channelConfig: LXDOMAIN + 'getChannelMsg', //  获取渠道配置
  homePageBanner: LXDOMAIN + 'getHomePageBannerData', // 首页Banner
  getHotScales: LXDOMAIN + 'getHotScales', // 首页最热测评
  getNewScales: LXDOMAIN + 'getNewScales', // 首页最新测评
  getHandpickScales: LXDOMAIN + 'getHandpickScales', // 获取 精选测评 接口
  getScales: LXDOMAIN + 'getScales', // 获取测试列表
  getScaleDetail: LXDOMAIN + 'getScaleDetailIntro', // 获取测试详情
  getNologinScaleDetail: LXDOMAIN + 'notLogin/getScaleDetailIntro', // 获取免登录测试详情
  getAdvertisingCepingConfig: LXDOMAIN + 'notLogin/getAdvertisingCepingConfig', // 获取先测试后付费测试配置
  fetchAdvertisingPlatform: LXDOMAIN + 'notLogin/getAdvertisingPlatform', // 获取免登陆广告平台
  miniappScheme: LXDOMAIN + 'miniApp/miniappScheme', // 获取小程序url scheme
  getRelevantScales: LXDOMAIN + 'getRelevantScales', // 相关测试
  getRelevantScalesForReport: LXDOMAIN + 'getRelevantScalesForReport',
  buyScale: LXDOMAIN + 'inner/buyScale', // 购买测评
  notLoginBuyScale: LXDOMAIN + 'notLogin/buyScale', // 免登购买测评
  reportPageCouponReceive: LXDOMAIN + 'coupon/reportPageCouponReceive', // 个人报告页优惠券信息
  newUserCouponReceive: LXDOMAIN + 'coupon/newUserCouponReceive', // 详情页新用户信息
  receiveCoupon: LXDOMAIN + 'coupon/receiveCoupon', // 个人中心页新用户信息
  buyFunScale: LXDOMAIN + 'h5/order', // 购买趣味测试
  buyScaleCallback: LXDOMAIN + 'pay/done/', // 购买测评成功后的回调
  NotLoginbuyScaleCallback: LXDOMAIN + 'notLogin/payDone/', // 购买测评成功后的回调
  getCategoryHotScales: LXDOMAIN + 'getCategoryHotScales', // 大家都在测
  getMyData: LXDOMAIN + 'getMyScaleData', // 我的测评
  searchOrder: LXDOMAIN + 'searchOrder', // 查询订单状态接口
  noLoginSearchOrder: LXDOMAIN + 'notLogin/searchOrder', // 查询未登录订单状态接口
  // 黑马合作项目，
  doFirst: LXDOMAIN + 'doFirst/buy', // 在详情页调用，先做题后支付
  stopSignInAndBuy: LXDOMAIN + 'stopRegistration/buy', // 提交完成后，先做题后支付

  // 评价相关
  reportShowComment: LXDOMAIN + 'getWhetherEvaluateInfo', // 报告页显示是否存在评论，决定是看评价还是发评价
  publishComment: LXDOMAIN + 'publishEvaluation', // 提交评价
  deleteComment: LXDOMAIN + 'deleteEvaluation', // 删除评价
  getMyComment: LXDOMAIN + 'getMyEvaluation', // 获取我的评价
  getUnCommentScales: LXDOMAIN + 'getAwaitEvaluateScalePools', // 未评价测评
  getHandpickComments: LXDOMAIN + 'getHandpickEvaluations', // 获取精选评价
  getLatestComments: LXDOMAIN + 'getNewestEvaluations', // 获取最新评价
  getDetailPageComments: LXDOMAIN + 'getDetailPageEvaluationData', // 获取最新评价
  allComment: LXDOMAIN + 'getAllEvaluations', //获取所有评价

  // 赠送功能相关的接口
  gift_buy: LXDOMAIN + 'gift/buyScale', // 购买赠送的测评
  gift_mine_give: LXDOMAIN + 'gift/giftsToScales', //  赠送管理 - 我送出的测评
  gift_mine_receive: LXDOMAIN + 'gift/receiveScales', // 赠送管理 - 我收到的赠送测评
  gift_give: LXDOMAIN + 'gift/giftsTo', // 赠送测评，分享出去后调用
  gift_receive_detail: LXDOMAIN + 'gift/receiveDetail', // 领取页详情
  gift_receive: LXDOMAIN + 'gift/receive', // 领取测评

  // 灵犀的套餐
  /* 套餐组合 */
  getComboDetail: LXDOMAIN + 'getComboDetail', // 获取单条套餐详情
  buyCombo: LXDOMAIN + 'inner/buyCombo', //  测评组合套餐购买接口
  // lxReportCombo: `//lingxi${spell}.xinli001.com/lingxi/service/getComboRemainScales`, // 小小包麻麻专用 - 测评报告页获取套餐其他测评
  getComboList: LXDOMAIN + 'getComboRemainScales', // 获取 套餐包含的测评接口 和 报告页获取套餐的其他测评

  // 趣味测试的接口
  h5Detail: LXDOMAIN + 'h5/detail',

  // 搜索相关接口
  searchRecommend: LXDOMAIN + 'search/recommendAndHot', // GET, no params, 热搜推荐
  searchAssociation: LXDOMAIN + 'search/association', // GET, params: [keyword], 搜索联想
  search: LXDOMAIN + 'search', // GET, params: [channelId, keyword], 获取搜索结果
  funSearch: FUN + 'search', // GET, params: [channelId, keyword], 获取搜索结果

  /* 测评系统 模块Api */
  testChoicegender: CPDOMAIN + 'updateEmployeeGender', // 选择性别
  testIntro: CPDOMAIN + 'getQuestionnaireIntro', // 测试介绍
  answerOption: CPDOMAIN + 'getEmployeeTestQuestions', // 获取题目选项
  commitAnswer: CPDOMAIN + 'commitStepAnswers', // 提交答案
  commmitAllAnswer: CPDOMAIN + 'commitAllAnswers', // 提交全部报告
  viewReport: CPDOMAIN + 'viewTestReport', // 查看报告
  getReportRecomendTest: WXDOMAIN + 'staticApi/external/getMoreTest', // 查看报告页获取推荐测评
  clearAnswer: CPDOMAIN + 'clearStepAnswers', // 清除答案
  shareCpReport: '//cp' + spell + '.xinli001.com/reportShare/isReportShareExist', // 分享报告
  viewTestReport: 'http://lingxi-box3.xinli001.com/lingxi/service/viewTestReport',
  getScl90Report: CPAPI + 'report/getScl90Report', // 获取Scl90定制报告

  viewReport2: CPAPI + 'viewReport',
  viewAlgorithmReport: CPAPI + 'viewAlgorithmReport', //查看多算法报告接口
  scaleModulesMsg: CPAPI + 'report/getScaleModulesMsg',

  toGeneralReport: CPAPI + 'toGeneralReport', //新增报告页聚合页

  // 旧测评系统接口
  cp: {
    intro: CPDOMAIN + 'getQuestionnaireIntro', // 测试介绍
    setGender: CPDOMAIN + 'updateEmployeeGender', // 选择性别
    questions: CPDOMAIN + 'getEmployeeTestQuestions', // 获取题目选项
    commitStep: CPDOMAIN + 'commitStepAnswers', // 提交答案
    commitClear: CPDOMAIN + 'clearStepAnswers', // 清除答案
    commitAll: CPDOMAIN + 'commitAllAnswers' // 提交全部报告
  },
  /* 新版做题接口，接入的是壹心理CP系统的接口 */
  yxlCp: {
    logIn: CPDOMAIN + 'cp/service/login', // 登录新测评系统
    intro: CPDOMAIN + 'cp/service/getScaleIntro', // 获取测评介绍
    curModuleintro: CPDOMAIN + 'cp/service/getCurModuleIntro', // 获取测评介绍
    setGender: CPDOMAIN + 'cp/service/updateUserGender', // 选择性别
    questions: CPDOMAIN + 'cp/service/getUserModuleQuestions', //获取题目
    commitStep: CPDOMAIN + 'cp/service/commitStepAnswers', // 异步提交
    commitClear: CPDOMAIN + 'cp/service/clearStepAnswers', // 重做清空已选
    commitAll: CPDOMAIN + 'cp/service/commitAllAnswers' // 全部提交
  },
  // 内隐自尊测试
  implicit: {
    questions: CPDOMAIN + 'cp/service/nyzz/getUserModuleQuestions', //获取题目
    commitStep: CPDOMAIN + 'cp/service/nyzz/commitStepAnswers', // 异步提交
    commitClear: CPDOMAIN + 'cp/service/nyzz/clearStepAnswers', // 重做清空部分提交记录
    commitAll: CPDOMAIN + 'cp/service/nyzz/commitAllAnswers' // 全部提交
  },

  // 报告页分享 模块的接口
  shareDetail: CPDOMAIN + 'getShareReportData',
  shareRecommend_wx: WXDOMAIN + 'www/Share/getMoreTest',
  shareRecommend_m: '//m' + spell + '.xinli001.com/ceshi/get-more-test.json',
  //   我也要测的地址
  getDetailUrl: LXDOMAIN + 'getDetailUrl',
  vote: CPDOMAIN + 'vote', // 分享页投票项地址
  getWeixinIimgCode: CPDOMAIN + 'cp/service/getImg', // 分享页投票项地址

  getQuestionnaire: LX + 'cp//questionnaire/getQuestionnaire', //获取ui主题风格

  // 收藏接口
  collectScale: LXDOMAIN + 'collect/collectScale', // 详情页收藏接口
  getCollectScaleData: LXDOMAIN + 'collect/getCollectScaleData', // 我的测评--收藏列表接口
  getTrackScaleData: LXDOMAIN + 'track/getTrackScaleData', // 我的测评--收藏列表接口
  delTrackScale: LXDOMAIN + 'track/delTrackScale', // 我的测评--足迹列表(删除足迹)

  getCustomConfig: CPAPI + 'getCustomConfig', // 心声页面 --- 获取自定义分享配置
  getResultVoiceArr: CPAPI + 'getResultVoiceArr', // 心声页面 --- 获取自定义分享配置
  longToShort: LXDOMAIN + 'longToShort', // 心声页面 --- 二维码长连接转短链接
  shortToLong: LXDOMAIN + 'shortToLong', // 心声页面 --- 二维码短连接转长链接
  shareAuth: LXDOMAIN + 'share/auth', // 心声落地页重定向接口

  //双十一促销落地页
  showExtrance: LXDOMAIN + 'package/showExtrance', // 首页入口展示
  showDeposit: LXDOMAIN + 'package/showDeposit', // 定金礼包的展示
  getDepositOrder: LXDOMAIN + 'package/getDepositOrder', // 我的礼包的展示
  packageList: LXDOMAIN + 'package/list', // 获取礼包列表
  packageBuy: LXDOMAIN + 'package/buy', // 购买礼包
  getMyPackageOrderList: LXDOMAIN + 'getMyPackageOrderList', // 获取我的礼包

  //双十一促销我的手收藏券
  userCouponList: LXDOMAIN + 'coupon/userCouponList', // 获取个人中心优惠券列表（未使用、已使用、已失效）、下单购买页面优惠券列表
  getCustomCoupon: LXDOMAIN + 'coupon/getCustomCoupon', // 单击共享券赠送按钮获取优惠券的详情
  couponGiftReceive: LXDOMAIN + 'coupon/couponGiftReceive', // 好友点击领取共享券

  //双十一分销
  countMyCoupon: LXDOMAIN + 'coupon/countMyCoupon', //我的优惠券 数量查询接口
  //兑换单品券
  redeemCodeUse: LXDOMAIN + 'redeemCode/use', //我的优惠券 兑换优惠券
  //双十二活动
  getDoubleTwelveScales: LXDOMAIN + 'getDoubleTwelveScales', //双十二活动测评列表
  couponDoubleTwelveStatus: LXDOMAIN + 'coupon/getDoubleTwelveStatus', //双十二活动优惠券领取资格
  doubleTwelveScalesReceive: LXDOMAIN + 'coupon/receive', //领取自定义优惠券
  scalePoolCouponList: LXDOMAIN + 'coupon/scalePoolCouponList', //下单购买页面优惠券列表
  newUserVerify: LXDOMAIN + 'newUser/verify', //双十二活动入口展示
  newUserPopWindows: LXDOMAIN + 'newUser/popWindows', //双十二活动入口弹窗
  //报告页pdf（https://code.aliyun.com/yixinli/lingxi/blob/cbfb91d2652a010cfab66b786d1ddcc6f2d87eb3/core/document/%E6%8A%A5%E5%91%8A%E8%BF%81%E7%A7%BB%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3.md）
  getPdfStatus: LXDOMAIN + 'getPdfStatus', //获取报告迁移服务订单状态
  buyPdf: LXDOMAIN + 'buyPdf', //购买报告迁移服务
  sendMailWithPdf: CPAPI + 'sendMailWithPdf', //购买报告pdf发送邮箱
  sendMailWithPdfNew: HCP + '/common/sendMailWithPdf', //购买报告pdf发送邮箱(新)
  deleteReport: LXDOMAIN + 'deleteReport', //购买报告迁移服务
  //添加限时优惠券(https://code.aliyun.com/yixinli/lingxi/blob/ab83daec3a85b2cac5b3b8288e383f8dfb449501/core/document/%E6%B5%8B%E8%AF%84%E7%A4%BC%E5%8C%85%E4%BC%98%E6%83%A0%E5%88%B8%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3.md)
  getDiscountCouponStatus: LXDOMAIN + 'timeLimit/getDiscountCouponStatus', //限时折扣优惠券弹窗状态资格
  discountCouponReceive: LXDOMAIN + 'timeLimit/discountCouponReceive', //限时折扣优惠券领取
  getUserOscarActCard: LXDOMAIN + 'getUserOscarActCard', //获取用户奥斯卡卡片记录的接口
  // 报告导咨询接口(https://code.aliyun.com/yixinli/lingxi/blob/9978046012c4cd3f090a5cbc4b02c130c26a0408/core/document/%E6%8A%A5%E5%91%8A%E5%AF%BC%E5%92%A8%E8%AF%A2%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3.md)
  // 判断报告导咨询价格接口
  verifyConsultPrice: LXDOMAIN + 'reportToConsult/verifyConsultPrice', //判断报告导咨询价格接口
  buyConsult: LXDOMAIN + 'reportToConsult/buyConsult', //购买报告导咨询服务接口
  submitConsultForm: LXDOMAIN + 'reportToConsult/submitConsultForm', //确认提交咨询表单接口
  getMyConsultOrderData: LXDOMAIN + 'consult/listOrders', //获取我的咨询订单接口
  getNotLoginConsultOrderData: LXDOMAIN + 'notLogin/listConsultOrders', // 获取免登咨询订单接口
  getReportConsultForm: LXDOMAIN + 'reportToConsult/getReportConsultForm', //获取单个咨询表单详情接口
  verifyConsultFormRedDot: LXDOMAIN + 'reportToConsult/verifyConsultFormRedDot', //咨询订单是否有待确认红点接口
  setTop20PushRelation: LXDOMAIN + 'setTop20PushRelation', //精准top20推送
  checkBindMobile: LXDOMAIN + 'consult/checkBindMobile', //判断用户是否绑定了手机号
  notLoginCheckBindMobile: LXDOMAIN + 'notLogin/checkBindMobile', // 免登检查此刻手机号绑定状态
  getConsultToken: LXDOMAIN + 'consult/getToken', // 获取咨询token
  consultSendValidcode: LXDOMAIN + 'consult/sendValidcode', //平台发送短信验证吗
  consultBindUserMobile: LXDOMAIN + 'consult/bindUserMobile', //平台绑定用户手机号码
  notLoginconsultBindUserMobile: LXDOMAIN + 'notLogin/bindPhone', // 免登检查此刻手机号
  syncByUserKey: LXDOMAIN + 'consult/syncByUserKey', // 测评导此刻订单同步在此刻咨询创建订单
  syncByOrder: LXDOMAIN + 'notLogin/syncByOrder', // 免登录-测评导此刻订单同步在此刻咨询创建订单
  syncByOrderNo: LXDOMAIN + 'consult/syncByOrderNo', // 订单同步
  // 投放导此刻
  notLoginGetCpPhone: LXDOMAIN + 'notLogin/getCepingPhone', // 免登录获取手机号

  // vip 高端产品
  getHighEndIndexScales: LXDOMAIN + 'highEnd/getHighEndIndexScales', //首页获取测评列表接口
  getHighEndScaleDetailIntro: LXDOMAIN + 'highEnd/getHighEndScaleDetailIntro', //获取高端产品单条测评的详情接口
  getHighEndMyScaleData: LXDOMAIN + 'highEnd/getHighEndMyScaleData', //获取 我的测评列表 (已购买的套餐和测评数据) 接口
  getDistributionCard: LXDOMAIN + 'distribution/getDistributionCard', //获取分销卡接口
  getMyReward: LXDOMAIN + 'distribution/getMyReward', //  获取我的分销收益接口
  viewHighEndReport: CPAPI + 'viewHighEndReport', //查看高端测评报告
  getReportDataUrl: LXDOMAIN + 'getReportDataUrl', //查看高端报告复制链接
  //趣味测试接口
  fungetDetail: FUN + 'getDetail', //趣味测试详情接口
  funquestion: FUN + 'getQuestionsOptions', //趣味测试
  funsendAnswer: FUN + 'postFunOptions', //提交测试
  fungetResult: FUN + 'getFunResult', //趣味测试结果
  getWechatFunDetailRecommends: FUN + 'getWechatFunDetailRecommends', // 趣味测试推荐
  getDailyFunTest: FUN + 'getDailyFunTest', // 趣味测试首页每日一测
  getDailyFunTestList: FUN + 'getDailyFunTestList', //趣味测试分类页每日一测列表
  funScales: FUN + 'funScales', // 趣味测试
  getFunScaleDetailList: LXDOMAIN + 'getFunScaleDetailList', //趣味测试简介列表
  setFavoriteFunScale: FUN + 'setFavoriteFunScale', //测试结果页喜欢
  getFavoriteMessage: FUN + 'getFavoriteMessage', //测试结果页获取喜欢信息
  getWechatFunResultRecommends: FUN + 'getWechatFunResultRecommends', //微站测试结果页相关推荐
  getMyFavoriteFunScaleList: FUN + 'getMyFavoriteFunScaleList', // 我喜欢的趣味测试列表
  storeSource: LXDOMAIN + 'storeSource', //全局添加跟踪标识接口
  closeConsultModule: LXDOMAIN + 'reportToConsult/closeConsultModule', //关闭咨询师解读模块展示
  getConsultModuleStatus: LXDOMAIN + 'reportToConsult/getConsultModuleStatus', //获取咨询师解读模块展示状态

  getMyEvaluationList: LXDOMAIN + 'getAwaitEvaluateScalePools', //我的评价列表
  getPersonalStats: LXDOMAIN + 'getPersonalStats', //我的展示页数据

  // 新增高价测试接口
  getProfessionalScales: LXDOMAIN + 'getProfessionalScales', // 获取高价测试列表
  viewProfessionalReport: CPAPI + 'viewProfessionalReport', //查看高价测评报告
  //盘古登录
  bindGenesis: LXDOMAIN + 'bindGenesis', //盘古登录

  //会员接口
  getVipInfo: LXDOMAIN + 'vip/getVipInfo', // 获取会员信息
  getVipHomePageInfo: LXDOMAIN + 'vip/getVipHomePageInfo', // 双12会员活动首页接口
  vipDistributionRankingList: LXDOMAIN + 'vip/vipDistributionRankingList', // 会员分销排行榜
  vipBuy: LXDOMAIN + 'vip/buy', // 购买会员礼包

  receiveVipCoupon: LXDOMAIN + 'vip/receiveVipCoupon', // 领取会员红包
  vipCouponList: LXDOMAIN + 'vip/vipCouponList', // 会员红包领取列表
  vipPopWindow: LXDOMAIN + 'vip/vipPopWindow', //  会员弹窗接口
  vipGetUrl: LXDOMAIN + 'vip/getUrl', //  会员页跳转接口
  authVipDistribution: LXDOMAIN + 'vip/authVipDistribution', //  会员页跳转接口
  authVipRights: LXDOMAIN + 'vip/authVipRights', //  权益页跳转接口
  getVipDistributionCard: LXDOMAIN + 'vip/getVipDistributionCard', //  获取会员分销卡地址
  appCheckIn: YIAPIDOMAIN + '/v6/yi/integral/save-task.json', // 平台app6.6积分接口，在APP内才触发
  getConfigureByCode: 'https://yiapp' + spell + '.xinli001.com/commonConfigure/getConfigureByCode',
  // 修改抖音答题页 接口路由
  touTiaoMiniAppCommitAnswer: CPAPI + 'touTiaoMiniApp/commitStepAnswers', // 提交答案
  touTiaoMiniAppCommmitAllAnswer: CPAPI + 'touTiaoMiniApp/commitAllAnswers', // 提交全部报告
  touTiaoMiniAppViewReport2: CPAPI + 'touTiaoMiniApp/viewReport',
  touTiaoMiniAppViewAlgorithmReport: CPAPI + 'touTiaoMiniApp/viewAlgorithmReport', //查看多算法报告接口

  meditatingPop: LXDOMAIN + 'touTiaoMiniApp/meditatingPop', // 查询是否需要弹窗
  closeMeditatingPop: LXDOMAIN + 'touTiaoMiniApp/colseMeditatingPop', // 关闭弹窗
  // 525 心理健康活动
  get360DistributionCard: LXDOMAIN + 'distribution/get360DistributionCard', //  获取525 360心理健康体检分销卡地址
  distributionRankingList: LXDOMAIN + 'distribution/distributionRankingList', //  个人分销排行榜
  get525Qrcode: LXDOMAIN + 'inner/getQrcode', //  报告页公众号二维码

  getConsultReadingReportTeachers: MDOMAIN + '/consultteacher/ceping_diversion',
  cpWebAppPlayer: MDOMAIN + '/cpWebApp-player', // 抖音小程序webview课程播放页Url
  // 抑郁单品
  getDepressedUserList: LXDOMAIN + 'depressed/getDepressedUserList', // 获取抑郁单品最新购买用户列表
  depressedPackages: LXDOMAIN + 'depressed/depressedPackages', // 抑郁重复测评礼包价格列表
  consultDepressedPackages: LXDOMAIN + 'consult/depressedPackages', // 抑郁重复测评礼包价格列表
  buyDepressedPackage: LXDOMAIN + 'depressed/buyDepressedPackage', // 购买抑郁单品
  depressedPayDone: LXDOMAIN + 'depressed/pay/done/', // 抑郁单品支付完的回调
  cpConsultantCpDiversion: PGXINLI + '/cpConsultant/cpDiversion', // 获取报告关联的咨询师
  uploadBase64Img: LXDOMAIN + 'uploadBase64Img', // 图片上传
  uploadImg: LXDOMAIN + 'uploadImg',
  shareDataToCommunity: LXDOMAIN + 'shareDataToCommunity', // 分享报告到社区
  repeatTest: LXDOMAIN + 'depressed/repeatTest/', // 抑郁重复测评-再测一次

  newUserGiftPopWindow: LXDOMAIN + 'newUserGiftPopWindow', // 查询B站先测试后付费报告页查询弹窗状态
  receiveNewUserGift: LXDOMAIN + 'receiveNewUserGift', // 存储B站先测试后付费报告页查询弹窗状态
  //房树人需求
  fsrGetUserModuleQuestions: CPDOMAIN + 'cp/service/fsr/getUserModuleQuestions', //frs获取全部问题
  fsrGetUserModuleQuestionsV2: CPDOMAIN + 'cp/service/fsr/v2/getUserModuleQuestions', //frs获取全部问题(新房树人-绘图版本)
  fsrCommitImageAnswers: CPDOMAIN + 'cp/service/fsr/v2/commitImageAnswers', //frs图片题答案提交(新房树人-绘图版本)
  fsrCommitAll: CPDOMAIN + 'cp/service/fsr/commitAllAnswers', // 房树人提交全部答案
  fsrFetchImage: HCP + '/fsr/fetchImage', //获取已上传的房树人测评图片
  //雨中人需求
  yzrGetUserModuleQuestions: CPDOMAIN + 'cp/service/yzr/getUserModuleQuestions', // yzr获取全部问题
  yzrFetchImage: HCP + '/common/getImageByAccountId', //获取已上传的雨中人测评图片

  sendValidcode: CPBADMIN + '/cp/bus/businessScaleAllocation/sendValidcode', // 发送登录手机验证码
  getAllocationScaleAddr: CPBADMIN + '/cp/bus/businessScaleAllocation/getAllocationScaleAddr',
  scaleAddrByAccount: CPBADMIN + '/cp/bus/businessScaleAllocation/scaleAddrByAccount', // 账号密码登录获取答题地址
  getScaleInfo: CPBADMIN + '/client/getScaleInfo',
  getBaseInfo: CPBADMIN + '/client/getBaseInfo',
  applyAssign: CPBADMIN + '/client/apply', // 申请分配测评
  getApplyStatus: CPBADMIN + '/client/getApplyStatus', // 申请分配状态查询
  // 报告页分享图片
  getCommonDistributionCard: LXDOMAIN + 'distribution/getCommonDistributionCard', // 获取报告页分享图片

  // 2020 双十一活动
  buyDoubleElevenScales: LXDOMAIN + 'doubleEleven/buyDoubleElevenScales', // 购买活动测评
  doubleElevenPayDone: LXDOMAIN + 'doubleEleven/payDone/', // 活动测评支付完的回调

  // 获取广告&浮标信息
  fetchAdsense: HCP + '/adsense/fetchAdsense', //获取已上传的房树人测评图片

  // 大众课抖音测评小程序
  getLesson: LXDOMAIN + 'touTiaoMiniApp/getLesson', //测评报告页-获取推荐课程
  getAppHeartCoach: LXDOMAIN + 'heartCoach/getPsychicCoachs',

  // 导咨询接口
  fetchGuideData: HCP + '/gmc/fetchGuideData', // 获取报告页测评导咨询文案信息
  fetchAppConsultantInfo: HCP + '/appConsult/fetchConsultantInfos', // 获取 app 详情页测评咨询师信息
  fetchAppGuideData: HCP + '/appConsult/fetchGuideData', // 获取 app 报告页咨询文案信息
  buyCikeConsult: LXDOMAIN + 'consult/buyConsult', //  购买此刻咨询支付
  notLoginBuyCikeConsult: LXDOMAIN + 'notLogin/buyConsult', //  购买此刻咨询支付
  cikePayDone: LXDOMAIN + 'consult/payDone', // 购买此刻咨询回调
  fetchConsultantInfos: HCP + '/gmc/fetchConsultantInfos', // 获取测评咨询师展示信息
  fetchConsultPrices: HCP + '/gmc/fetchConsultPrices', // 获取详情页和报告页咨询价格信息
  buyConsultCombo: LXDOMAIN + 'consult/buyConsultCombo', // 详情页咨询师购买套餐
  getConsultDescription: HCP + '/gmc/getConsultDescription', // 获取此刻咨询描述信息
  getTeacherAndPrice: HCP + '/gmc/getTeacherAndPrice', // 获取此刻咨询老师及价格配置信息
  getCompleteStatus: LXDOMAIN + 'consult/getCompleteStatus', // 获取此刻咨询订单完成情况
  receiveGuideCoupon: HCP + '/appConsult/receiveCoupon', // 领取导流咨询五折券

  sendMail: CPDOMAIN + 'cp/service/sendMail', // 发送报告到邮箱
  // 2021-525活动
  activity525Countdown: LXDOMAIN + 'activity525/countdown', // 倒计时
  activity525OrderMakeUp: LXDOMAIN + 'activity525/orderMakeUp', // 凑单测评列表
  activity525BuyConsultCombo: LXDOMAIN + 'activity525/buyConsultCombo', // 组合测评购买
  activity525FreeConsultStatus: LXDOMAIN + 'activity525/freeConsultStatus', // 525活动免费咨询购买状态、使用状态、倒计时
  activity525BuyJudge: LXDOMAIN + 'activity525/buyJudge', // 判断是否是首单

  // 活动卡相关
  scaleList: LXDOMAIN + 'scaleList', // 查询指定测评列表
  activityCardList: LXDOMAIN + 'activityCard/activityCardList', // 获取活动卡信息列表
  activityCardInfo: LXDOMAIN + 'activityCard/activityCardInfo', // 根据订单号查询活动卡信息
  activityCardRecords: LXDOMAIN + 'activityCard/records', // 活动卡免费权益使用记录列表
  listActivityCardOrder: LXDOMAIN + 'notLogin/listActivityCardOrder', // 获取活动卡订单信息

  // 导此刻优化
  getRecentConsultUser: HCP + '/gmc/getRecentConsultUser', // 获取最近咨询用户

  consultStatus: LXDOMAIN + 'consult/consultStatus', // 获取此刻咨询状态

  notCompleteCount: LXDOMAIN + 'consult/notCompleteCount', // 未完成订单数
  getTeacherById: HCP + '/gmc/getTeacher', // 通过咨询师id获取咨询师信息
  h5activityAuth: LXDOMAIN + 'h5activity/auth', // 授权
  h5activityUseStatus: HCP + '/h5activity/useStatus', // h5裂变活动1元购测评机会使用状态

  // 匹配测评
  matchTestBuy: LXDOMAIN + 'matchTest/buy', // 付费购买匹配测试
  matchTestCreateOrder: LXDOMAIN + 'matchTest/doFirstAfterBuy/createOrder', // 先测试后付费--下单
  matchTestPayOrder: LXDOMAIN + 'matchTest/doFirstAfterBuy/payOrder', // 先测试后付费--付费
  matchTestToReport: LXDOMAIN + 'matchTest/toReport', // 跳转答题页、报告页
  matchEntrance: HCP + '/match/entrance', // 匹配测试入口显示
  matchList: HCP + '/match/list', // 匹配测试匹配榜
  matchPoster: HCP + '/match/poster', // 匹配测试邀请海报
  matchFactor: HCP + '/match/factor', // 性格测试匹配结果维度集合

  getSubscribeYet: LXDOMAIN + 'MentalCognitiveMap/getSubscribeYet', // 用户是否关注了公众号

  // 2022会员
  getNewCePingReport: LXDOMAIN + 'getNewCePingReport', // 获取报告、咨询最新信息
  startLottery: LXDOMAIN + 'vip/v3/startLottery', // 开始抽奖
  getLotteryStatus: LXDOMAIN + 'vip/v3/getLotteryStatus', // 获取是否已抽奖
  getMyRewardRecord: LXDOMAIN + 'vip/v3/getMyRewardRecord', // 获取抽奖记录
  submitInformation: LXDOMAIN + 'vip/v3/submitInformation', // 提交领奖信息
  vip3Buy: LXKC + 'api/buyCpVip', // 购买会员 3.0
  kcVip: LXKC + 'user/api/vip', // 课程分销数据
  getVip3HomePageInfo: LXDOMAIN + 'vip/v3/getVipHomePageInfo', // 会员详情页接口
  receiveUnionVip: LXDOMAIN + 'vip/v3/receiveUnionVip', // 领取联合会员
  getUnionVipStatus: LXDOMAIN + 'vip/v3/getUnionVipStatus', // 联合会员领取状态

  // 2023会员
  getVip4HomePageInfo: LXDOMAIN + 'vip/v4/getVipHomePageInfo', // 会员详情页接口


  // 儿童绘画
  beforeAndAfterViewReport: CPDOMAIN + 'cp/service/lesson/beforeAndAfter/viewReport', // 前后测报告页
  midViewReport: CPDOMAIN + 'cp/service/lesson/mid/viewReport', // 中间测报告页数据
  getReportProposal: CPBADMIN + '/bus/businessUserLesson/getReportProposal', // 获取特色课程老师意见
  updateReportProposal: CPBADMIN + '/bus/businessUserLesson/updateReportProposal', // 修改特色课程老师意见
  getPictureUrl: CPBADMIN + '/bus/businessUserLesson/getPictureUrl', // 获取用户作品图片
  childCommitAll: CPDOMAIN + 'cp/service/lesson/beforeAndAfter/commitAllAnswers', // 前后测提交全部答案
  childMidQuestions: CPDOMAIN + 'cp/service/lesson/mid/getUserModuleQuestions', // 中间测获取所有问题
  childMidCommitAll: CPDOMAIN + 'cp/service/lesson/mid/commitAllAnswers', // 中间测获取所有问题
  childGetPictureUrl: CPBADMIN + '/bus/businessUserLesson/getPictureUrl', // 获取特色课程老师意见

  getDistributionBackground: HCP + '/common/getDistributionBackground', // 根据测评id获取分销海报
  // 此刻邀请有礼2.0
  cpConsultantOpenInvitee: PGXINLI + '/consultUserCpRecord/openInvitee', // 获取相关浮窗信息

  getAnswerRecord: CPBADMIN + '/client/getAnswerRecord', // 获取答题情况

  // 投放导倾诉
  qingsuCreateOrder: LXDOMAIN + 'qingsu/createOrder',
  getLaunchChannelInfo: MDOMAIN + '/applet/get-short-url.json',

  getCpReportResult: CPDOMAIN + 'cp/service/inner/getCpReportResult', // 抑郁测评结果查询

  getSingleSignOnUrl: LXDOMAIN + 'platform/getSingleSignOnUrl', // 我的测评-查看咨询获取免登录地址

  getAuth: LXDOMAIN + 'yixinli/consultQrCode/auth', // 二维码-授权接口

  // 邀请有礼
  invitePageData: LXDOMAIN + 'vip/v4/invitePageData',
  inviteHelp: LXDOMAIN + 'vip/v4/inviteHelp',

  // 我的心理画像
  getUserProfile: CPAPI + 'getUserProfile',

  checkOrderPush: HCP + '/common/checkOrderPush', // 检查订单号上报情况（前端js布玛数据回传中使用，限制一个订单号只能上报一次）
  autoDoQuestions: CPAPI + 'inner/autoDoQuestions' // 随机自动答题（测试环境使用）
};

/* harmony default export */ __webpack_exports__["a"] = (APIS);

/***/ }),

/***/ "OYls":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("crlp")('asyncIterator');


/***/ }),

/***/ "OZpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cp-dialog.vue?vue&type=template&id=77f48e62&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-dialog"},[_c('myMask'),_vm._v(" "),_c('div',{staticClass:"cp-dialog__content"},[(_vm.closeButton)?_c('i',{staticClass:"cp-dialog__close",on:{"click":function($event){$event.stopPropagation();return _vm.closeModal($event)}}}):_vm._e(),_vm._v(" "),(_vm.title)?_c('div',{staticClass:"cp-dialog__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.buttonText)?_c('div',{staticClass:"cp-dialog__footer"},[_c('div',{staticClass:"cp-dialog__button",on:{"click":_vm.clickButton}},[_vm._v(_vm._s(_vm.buttonText))])]):_vm._e()],2)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/cp-dialog.vue?vue&type=template&id=77f48e62&scoped=true&

// EXTERNAL MODULE: ./src/components/common/mask.vue + 2 modules
var mask = __webpack_require__("m423");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/cp-dialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var cp_dialogvue_type_script_lang_js_ = ({
    props: {
        title: {
            type: String,
            default: ''
        },

        buttonText: {
            type: String,
            default: ''
        },

        closeButton: {
            type: Boolean,
            default: true
        }
    },
    components: {
        myMask: mask["a" /* default */]
    },

    methods: {
        closeModal: function closeModal() {
            this.$emit('close');
        },
        clickButton: function clickButton() {
            this.$emit('click');
        }
    }
});
// CONCATENATED MODULE: ./src/components/cp-dialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_cp_dialogvue_type_script_lang_js_ = (cp_dialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/cp-dialog.vue?vue&type=style&index=0&id=77f48e62&lang=scss&scoped=true&
var cp_dialogvue_type_style_index_0_id_77f48e62_lang_scss_scoped_true_ = __webpack_require__("7Sxt");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/cp-dialog.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_cp_dialogvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "77f48e62",
  null
  
)

/* harmony default export */ var cp_dialog = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "Oe96":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/yxlCopyright.vue?vue&type=template&id=1476679d&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.CHANNEL_YXL_STATEMENT || _vm.showTip),expression:"CHANNEL_YXL_STATEMENT || showTip"}],staticClass:"support"},[(_vm.isHwrl)?_c('p',[_vm._v("本服务由中华万年历联合壹心理提供")]):_c('p',[_vm._v("壹心理©提供内容及技术支持")])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/common/yxlCopyright.vue?vue&type=template&id=1476679d&scoped=true&

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/yxlCopyright.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//



/* harmony default export */ var yxlCopyrightvue_type_script_lang_js_ = ({
  name: 'yxlCopyright',
  computed: Object(vuex_esm["c" /* mapGetters */])(['CHANNEL_YXL_STATEMENT']),
  props: {
    showTip: {
      type: Boolean,
      default: false
    }
  }

});
// CONCATENATED MODULE: ./src/components/common/yxlCopyright.vue?vue&type=script&lang=js&
 /* harmony default export */ var common_yxlCopyrightvue_type_script_lang_js_ = (yxlCopyrightvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/common/yxlCopyright.vue?vue&type=style&index=0&id=1476679d&lang=scss&scoped=true&
var yxlCopyrightvue_type_style_index_0_id_1476679d_lang_scss_scoped_true_ = __webpack_require__("Fe62");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/common/yxlCopyright.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  common_yxlCopyrightvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "1476679d",
  null
  
)

/* harmony default export */ var yxlCopyright = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "OgTs":
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__("OzIq").parseInt;
var $trim = __webpack_require__("Ymdd").trim;
var ws = __webpack_require__("Xduv");
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ "OvRC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("oM7Q"), __esModule: true };

/***/ }),

/***/ "OzIq":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "P2ln":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P8ML":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("wI4N");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "PHCx":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "PHqh":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("Q6Nf");
var defined = __webpack_require__("/whu");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "PZJg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/two-tip.35f6904.png";

/***/ }),

/***/ "PbPd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__("UKM+");
var getPrototypeOf = __webpack_require__("KOrd");
var HAS_INSTANCE = __webpack_require__("kkCw")('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__("lDLk").f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),

/***/ "PgLq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("wI4N");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "PrX1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__("ZNTr");

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') {
		return false;
	}
	if (typeof Symbol !== 'function') {
		return false;
	}
	if (_typeof(origSymbol('foo')) !== 'symbol') {
		return false;
	}
	if (_typeof(Symbol('bar')) !== 'symbol') {
		return false;
	}

	return hasSymbolSham();
};

/***/ }),

/***/ "PuTd":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__("Ds5P");
var getProto = __webpack_require__("KOrd");
var anObject = __webpack_require__("DIVP");

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),

/***/ "PzxK":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("D2L2");
var toObject = __webpack_require__("sB3e");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "Q/CP":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("CEne")('Array');


/***/ }),

/***/ "Q6Nf":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("ydD5");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "QBuC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("OzIq");
var has = __webpack_require__("WBcL");
var cof = __webpack_require__("ydD5");
var inheritIfRequired = __webpack_require__("kic5");
var toPrimitive = __webpack_require__("s4j0");
var fails = __webpack_require__("zgIt");
var gOPN = __webpack_require__("WcO1").f;
var gOPD = __webpack_require__("x9zv").f;
var dP = __webpack_require__("lDLk").f;
var $trim = __webpack_require__("Ymdd").trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__("7ylX")(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__("bUqO") ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__("R3AP")(global, NUMBER, $Number);
}


/***/ }),

/***/ "QCYK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/VIP.62e18b9.png";

/***/ }),

/***/ "QG7u":
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__("vmSO");

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ "QKXm":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "QRG4":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("UuGF");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "QRXx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),

/***/ "QWLi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var toInteger = __webpack_require__("oeih");
var aNumberValue = __webpack_require__("fS0v");
var repeat = __webpack_require__("xAdt");
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__("zgIt")(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),

/***/ "QWe/":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("crlp")('observable');


/***/ }),

/***/ "QaEu":
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),

/***/ "QcWB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("Ds5P");
var newPromiseCapability = __webpack_require__("w6Dh");
var perform = __webpack_require__("SDXa");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "Qh14":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ReGu");
var enumBugKeys = __webpack_require__("QKXm");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "QzLV":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("bUqO"), 'Object', { defineProperty: __webpack_require__("lDLk").f });


/***/ }),

/***/ "R3AP":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("OzIq");
var hide = __webpack_require__("2p1q");
var has = __webpack_require__("WBcL");
var SRC = __webpack_require__("ulTY")('src');
var $toString = __webpack_require__("73qY");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("7gX0").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "R3KI":
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),

/***/ "R4pa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__("y325")('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),

/***/ "R4wc":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("kM2E");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("To3L") });


/***/ }),

/***/ "R9M2":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "RIAs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-more.b169cba.png";

/***/ }),

/***/ "RPLV":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7KvD").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "RVKt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-switch-kwai.8eec722.png";

/***/ }),

/***/ "RY/4":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("R9M2");
var TAG = __webpack_require__("dSzd")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "Racj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var $at = __webpack_require__("49qz")(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),

/***/ "Re3r":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "ReGu":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("WBcL");
var toIObject = __webpack_require__("PHqh");
var arrayIndexOf = __webpack_require__("ot5s")(false);
var IE_PROTO = __webpack_require__("mZON")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "RhFG":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("kkCw")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("2p1q")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "Rk3p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_showindexNav_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("Nvhv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_showindexNav_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_showindexNav_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_showindexNav_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "Rk41":
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__("R3AP")(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),

/***/ "Rnah":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_testsOfChoice_vue_vue_type_style_index_0_id_14139bb4_lang_scss_scoped_true___ = __webpack_require__("grp1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_testsOfChoice_vue_vue_type_style_index_0_id_14139bb4_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_testsOfChoice_vue_vue_type_style_index_0_id_14139bb4_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_testsOfChoice_vue_vue_type_style_index_0_id_14139bb4_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "RqoC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg_base.d897468.gif";

/***/ }),

/***/ "Rrel":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("TcQ7");
var gOPN = __webpack_require__("n0T6").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "Rw4K":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Reflect', { ownKeys: __webpack_require__("YUr7") });


/***/ }),

/***/ "Rz2z":
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),

/***/ "S+E/":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");
var $parseInt = __webpack_require__("OgTs");
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),

/***/ "S60i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S82l":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "SCxx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SDXa":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "SHe9":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("wC1N");
var ITERATOR = __webpack_require__("kkCw")('iterator');
var Iterators = __webpack_require__("bN1p");
module.exports = __webpack_require__("7gX0").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "SPM9":
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),

/***/ "SPtU":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__("x9zv");
var getPrototypeOf = __webpack_require__("KOrd");
var has = __webpack_require__("WBcL");
var $export = __webpack_require__("Ds5P");
var isObject = __webpack_require__("UKM+");
var anObject = __webpack_require__("DIVP");

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),

/***/ "SRCy":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__("Ds5P");
var expm1 = __webpack_require__("x78i");
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),

/***/ "SU+a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__("y325")('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),

/***/ "SXOU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setCookie;
/* unused harmony export getCookie */
/* unused harmony export delCookie */
function setCookie(_ref) {
  var key = _ref.key,
      value = _ref.value,
      timeMinSec = _ref.timeMinSec,
      Expired = _ref.Expired,
      _ref$domain = _ref.domain,
      domain = _ref$domain === undefined ? location.host : _ref$domain;

  var exp = new Date();
  exp.setTime(exp.getTime() + timeMinSec);
  if (Expired) {
    document.cookie = key + '=' + escape(value) + ';expires=' + Expired + ';path=/;domain=' + domain + ';';
  } else if (timeMinSec) {
    document.cookie = key + '=' + escape(value) + ';expires=' + exp.toGMTString() + ';path=/;domain=' + domain + ';';
  }
}

function getCookie(key) {
  var name = key + '=';
  var cookieArray = document.cookie.split(';');
  for (var i = 0; i < cookieArray.length; i++) {
    var c = cookieArray[i].trim();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return undefined;
}

function delCookie(key) {
  setCookie({
    key: key,
    value: '',
    Expired: new Date('Thu, 01 Jan 1970 00:00:00 GMT:')
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  setCookie: setCookie,
  getCookie: getCookie,
  delCookie: delCookie
});

/***/ }),

/***/ "Sejc":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("rFzY");
var invoke = __webpack_require__("PHCx");
var html = __webpack_require__("d075");
var cel = __webpack_require__("jhxf");
var global = __webpack_require__("OzIq");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("ydD5")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "SfB7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("+E39") && !__webpack_require__("S82l")(function () {
  return Object.defineProperty(__webpack_require__("ON07")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "SjAY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SldL":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "SmN4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/indexTitle_new.f3b6d8c.png";

/***/ }),

/***/ "Stuz":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),

/***/ "T7xV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("8Uqm");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

/***/ }),

/***/ "TF8a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addUrlParams", function() { return addUrlParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeUrlParams", function() { return removeUrlParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addHashParams", function() { return addHashParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeHashParams", function() { return removeHashParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUrlParams", function() { return getUrlParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__("JkEM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objOperation__ = __webpack_require__("ZS9F");



function typeMatch(_ref) {
  var url = _ref.url,
      type = _ref.type;

  try {
    var allowType = ['search', 'hash'];
    if (allowType.includes(type.toLowerCase())) {
      var urlObj = void 0;
      // 修复阿里云报警 undefined is not an object (evaluating 's.targetObj')问题
      try {
        urlObj = new URL(url || location.href);
      } catch (e) {
        var isServer = typeof window === 'undefined';
        if (!isServer) {
          urlObj = document.createElement('a');
          urlObj.href = url || location.href;
        }
      }
      var targetHead = '';
      if (type === 'search') {
        targetHead = '?';
      } else if (type === 'hash') {
        if (urlObj[type] && urlObj[type].match(/(#\/)?[a-zA-Z0-9-_]+\??/)) {
          urlObj[type].match(/(#\/)?[a-zA-Z0-9-_]+\??/)[0];
        } else {
          targetHead = '#/?';
        }
      }
      var targetString = urlObj[type].replace(targetHead, '');
      var targetObj = void 0;
      try {
        targetObj = __WEBPACK_IMPORTED_MODULE_0_qs___default.a.parse(targetString) || {};
      } catch (error) {
        targetObj = {};
      }
      return { urlObj: urlObj, targetObj: targetObj, targetHead: targetHead };
    } else {
      return false;
    }
  } catch (err) {
    console.error(err);
  }
}

function addUrlParams(_ref2) {
  var url = _ref2.url,
      _ref2$type = _ref2.type,
      type = _ref2$type === undefined ? 'search' : _ref2$type,
      params = _ref2.params;

  // 利用Qs，将字符串整理为更容易处理的对象进行增加，最后再转为字符串给出去；
  var match = typeMatch({ url: url, type: type });
  if (match) {
    var _typeMatch = typeMatch({ url: url, type: type }),
        urlObj = _typeMatch.urlObj,
        targetObj = _typeMatch.targetObj,
        targetHead = _typeMatch.targetHead;
    // 合并参数


    var finalParamsStr = __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(Object.assign(targetObj, params));
    urlObj[type] = '' + targetHead + finalParamsStr;
    return urlObj.href;
  } else {
    return url;
  }
}

function removeUrlParams(_ref3) {
  var url = _ref3.url,
      _ref3$type = _ref3.type,
      type = _ref3$type === undefined ? 'search' : _ref3$type,
      params = _ref3.params;

  var match = typeMatch({ url: url, type: type });
  if (match) {
    var urlObj = match.urlObj,
        targetObj = match.targetObj,
        targetHead = match.targetHead;
    // 移除参数

    var paramsArray = [];
    if (params instanceof Array) {
      paramsArray = params;
    } else if (typeof params === 'string') {
      paramsArray.push(params);
    } else {
      for (var key in params) {
        paramsArray.push(key);
      }
    }

    paramsArray.map(function (key) {
      targetObj[key] = undefined;
    });

    var finalParamsStr = __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(Object.assign(targetObj, params));
    urlObj[type] = '' + targetHead + finalParamsStr;
    return urlObj.href;
  } else {
    return url;
  }
}

function addHashParams(_ref4) {
  var url = _ref4.url,
      params = _ref4.params;

  return addUrlParams({ url: url, type: 'hash', params: params });
}

function removeHashParams(_ref5) {
  var url = _ref5.url,
      params = _ref5.params;

  return removeUrlParams({ url: url, type: 'hash', params: params });
}

/*
 * todo: hash的情不一定截取到第一个key，因为#后面的字符不可控
 */
function getUrlParams(_ref6) {
  var url = _ref6.url,
      _ref6$type = _ref6.type,
      type = _ref6$type === undefined ? 'search' : _ref6$type,
      _ref6$params = _ref6.params,
      params = _ref6$params === undefined ? [] : _ref6$params;

  var _typeMatch2 = typeMatch({ url: url, type: type }),
      targetObj = _typeMatch2.targetObj;

  return Object(__WEBPACK_IMPORTED_MODULE_1__objOperation__["b" /* pick */])(targetObj, params);
}



/* harmony default export */ __webpack_exports__["default"] = ({
  addUrlParams: addUrlParams,
  removeUrlParams: removeUrlParams,
  addHashParams: addHashParams,
  removeHashParams: removeHashParams,
  getUrlParams: getUrlParams
});

/***/ }),

/***/ "TFWu":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("77Ug")('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "THnP":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("77Ug")('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "TN6f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TNV1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "TSB3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export addHashParams */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addUrlParams; });
/* unused harmony export askSubmitVerify */
/* unused harmony export baiduStat */
/* unused harmony export bridge */
/* unused harmony export broswerLoadedToDownloadApp */
/* unused harmony export chunkArray */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHttpServer; });
/* unused harmony export debounce */
/* unused harmony export delCookie */
/* unused harmony export fakeVconsole */
/* unused harmony export getCookie */
/* unused harmony export getEnvHost */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPlatform; });
/* unused harmony export getQueryString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRequestSign; });
/* unused harmony export getRunningEnv */
/* unused harmony export getScrollHeight */
/* unused harmony export getScrollTop */
/* unused harmony export getUrlParams */
/* unused harmony export goApp */
/* unused harmony export handleExpiresStorage */
/* unused harmony export isCanHideNavigationBar */
/* unused harmony export isDangerUrl */
/* unused harmony export isIOS9 */
/* unused harmony export loadScript */
/* unused harmony export omit */
/* unused harmony export pick */
/* unused harmony export secondCounter */
/* unused harmony export secondToTime */
/* unused harmony export setCookie */
/* unused harmony export setScrollTop */
/* unused harmony export stat */
/* unused harmony export throttle */
/* unused harmony export track */
/* unused harmony export trackCreator */
/* unused harmony export trackLoginAxiosInterceptor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return trackPlugin; });
/* unused harmony export updateOrDownLoadApp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return versionfunegt; });
/* unused harmony export wxConfigOrigin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("HQe3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);



function getPlatform(){var ua=arguments.length>0&&arguments[0]!==undefined?arguments[0]:navigator.userAgent;var isServer=typeof window==="undefined";var PickYxlInfoString=function PickYxlInfoString(pickdata,filter){if(!isServer&&window&&window.YXL_INFO&& typeof pickdata=="string"){var data=window.YXL_INFO[pickdata];if(typeof data==="function"){data=window.YXL_INFO[pickdata]();}if(filter&& typeof filter=="function"){return filter(data)}return data}else {return undefined}};var fullTypeJudge=function fullTypeJudge(Rex,targerStringLikeUA){var ref2=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{useWierdWay:true},type1=ref2.type,isTargetApp=ref2.isTargetApp,_useWierdWay=ref2.useWierdWay,useWierdWay=_useWierdWay===void 0?true:_useWierdWay;if(isServer){useWierdWay=false;}var regExp=Rex;var uaMatch=runRex(regExp,targerStringLikeUA);var YxlInfoFilterMap={app:function(app){var appRegExName;switch(app){case"\u58F9\u5FC3\u7406":appRegExName="yixinliApp";break;default:appRegExName="n0th1ng MaTch";break}return appRegExName},system:function(system){var isiOS=/iOS|ios/g.test(system);return isiOS?"iOS":"Android"},model:null,version:function(version){if(isTargetApp){return version}else {return "0.0.0"}},fullscreen:function(tof){return !!tof}};var clientNavagitorTry={app:function(){if(!isServer){var ref=__webpack_require__("6qEs").getUrlParams({url:location.href,params:["_platform"]})||"",searchPlatform=ref._platform;var ref1=__webpack_require__("6qEs").getUrlParams({url:location.href,type:"hash",params:["_platform"]})||"",hashPlatform=ref1._platform;if(searchPlatform||hashPlatform){return true}else {return false}}},version:function(){if(!isServer&&isTargetApp){var ref=__webpack_require__("6qEs").getUrlParams({url:location.href,params:["_version"]})||"",searchVersion=ref._version;var ref3=__webpack_require__("6qEs").getUrlParams({url:location.href,type:"hash",params:["_version"]})||"",hashVersion=ref3._version;if(searchVersion){return searchVersion}else if(hashVersion){return hashVersion}else {return false}}}};var InfoString=PickYxlInfoString(type1,YxlInfoFilterMap[type1]);var wierdWaysToComfirm=function(type){var canTry=clientNavagitorTry[type];if(canTry&&useWierdWay){var wierdTryResult=canTry(Rex,targerStringLikeUA);console.log("wierdTryResult",wierdTryResult);return wierdTryResult}else {return false}};var wierdWays=wierdWaysToComfirm(type1);try{if(InfoString){if(type1=="version"){console.log("------------------InfoString",regExp.toString(),InfoString);return InfoString+""}else {console.log("------------------InfoString",regExp.toString(),runRex(regExp,InfoString));return runRex(regExp,InfoString)}}else if(uaMatch){console.log("------------------",Rex.toString(),uaMatch,wierdWays);if(type1=="version"){if(uaMatch)return targerStringLikeUA.match(regExp)[0].split(";")[1]}else {return uaMatch}}else if(wierdWays){return wierdWays}else {return false}}catch(e){console.error("Error@getPlaftorm:"+e.toString()+"\nParams"+"Rex:".concat(Rex.toString(),", targerStringLikeUA: ").concat(targerStringLikeUA,", type: ").concat(type1,", isTargetApp: ").concat(isTargetApp,", useWierdWay: ").concat(useWierdWay));}};var runRex=function runRex(Rex,targetString){if(Rex.test){return Rex.test(targetString)}else {return false}};var iPadOS13Up=isServer?false:navigator.platform==="MacIntel"&&navigator.maxTouchPoints>1;var isWindowsPhone=fullTypeJudge(/(?:Windows Phone)/,ua),isSymbian=fullTypeJudge(/(?:SymbianOS)/,ua)||isWindowsPhone,isAndroid=fullTypeJudge(/(?:Android)/,ua,{type:"system"}),isiOS1=fullTypeJudge(/(?:iOS)/,ua,{type:"system"}),isFireFox=fullTypeJudge(/(?:FireFox)/,ua),isChrome=fullTypeJudge(/(?:Chrome|CriOS)/,ua),isWechat=fullTypeJudge(/(?:MicroMessenger)/,ua),isiPad=fullTypeJudge(/(?:iPad)/,ua,{type:"model"})||iPadOS13Up,isiPhone=fullTypeJudge(/(?:iPhone)/,ua,{type:"model"}),isTablet=fullTypeJudge(/(?:Tablet|PlayBook)/,ua)||isiPad||isAndroid&&!fullTypeJudge(/(?:Mobile)/,ua)||isFireFox&&fullTypeJudge(/(?:Tablet)/,ua),isPc=!isiPhone&&!isAndroid&&!isSymbian&&!isiPad,isMobile=!isPc,isZiXunApp=fullTypeJudge(/(?:yixinliConsultationApp)/,ua,{type:"app",useWierdWay:false}),isYixinliApp=fullTypeJudge(/(?:yixinliApp)/,ua,{type:"app",useWierdWay:false}),isMuseApp=fullTypeJudge(/(?:muse)/,ua,{type:"app",useWierdWay:false}),isCeShiApp=fullTypeJudge(/(?:XinLiCeShiApp)/,ua,{type:"app",useWierdWay:false}),yixinliAPPVersion=fullTypeJudge(/^([1-9]\d|[1-9])(.([1-9]\d|\d)){2}$/,ua,{type:"version",isTargetApp:isYixinliApp,useWierdWay:false}),museAPPVersion=fullTypeJudge(/muse;*.*.*/i,ua,{type:"version",isTargetApp:isMuseApp,useWierdWay:false}),zixunAppVersion=fullTypeJudge(/yixinliConsultationApp;*.*.*/i,ua,{type:"version",isTargetApp:isZiXunApp,useWierdWay:false}),isBaiduminiapp=fullTypeJudge(/(?:swan-baiduboxapp)/,ua),isZiXunShiApp=fullTypeJudge(/(?:(Android|iOS)-Counselor)/,ua),isWeibo=fullTypeJudge(/(weibo).*weibo__([\d.]+)/i,ua);var result={isAndroid:isAndroid,isiOS:isiOS1,isPc:isPc,isMobile:isMobile,isTablet:isTablet,isiPhone:isiPhone,isiPad:isiPad,isChrome:isChrome,isWechat:isWechat,isYixinliApp:isYixinliApp,isMuseApp:isMuseApp,isCeShiApp:isCeShiApp,isZiXunApp:isZiXunApp,isZiXunShiApp:isZiXunShiApp,isBaiduminiapp:isBaiduminiapp,yixinliAPPVersion:yixinliAPPVersion,museAPPVersion:museAPPVersion,zixunAppVersion:zixunAppVersion,isWeibo:isWeibo};return result}

function _classCallCheck$3(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function")}}var BRIDGERESOLVE="_bridgeResolve";var Bridge=function(){function Bridge(options){_classCallCheck$3(this,Bridge);this.tokenStringify="";this.version="0.1";this.platform=getPlatform();if(options&&!options.disInitAppHook){this.AppHookInit();}this.ready=null;if(options&&options.methods&&options.methods.length){var methods=options.methods;for(var i=0;i<methods.length;i++){this.MethodCall(methods[i]);}}}var _proto=Bridge.prototype;_proto._init=function _init(){};_proto.add=function add(options){var methods;if(options&&options.methods&&options.methods.length){methods=options.methods;}else if(Array.isArray(options)){methods=options;}if(methods){for(var i=0;i<methods.length;i++){this.MethodCall(methods[i]);}}};_proto.MethodCall=function MethodCall(obj){var ERROR_TITLE="[Bridge.js] error : ";var methodName=obj.method;try{var _this=this;if(!methodName)throw "".concat(ERROR_TITLE," method undefined");if(!obj.callback)throw "".concat(ERROR_TITLE," callback undefined");window[methodName]=function(){var param=arguments.length>0&&arguments[0]!==void 0?arguments[0]:"{}";var formatedParams=JSON.parse(param);if(!_this.tokenStringify&&Object.prototype.toString.call(formatedParams)==="[object Object]"){var ObjectKeys=Object.keys(formatedParams);if(ObjectKeys.length===1&&ObjectKeys[0]==="token"){_this.tokenStringify=param;}}obj.callback(formatedParams);var bridgeResolve=window[methodName][BRIDGERESOLVE];if(typeof bridgeResolve==="function"){bridgeResolve(formatedParams);window[methodName][BRIDGERESOLVE]=null;console.log("\u91CA\u653E".concat(methodName,"\u7684resolve"));}if(Object.prototype.toString.call(bridgeResolve)==="[object Array]"){bridgeResolve.forEach(function(resolve){resolve(formatedParams);});window[methodName][BRIDGERESOLVE]=[];console.log("\u91CA\u653EgetTokenArr\u7684resolve");}};}catch(err){console.error("".concat(ERROR_TITLE," MethodCall register failed"),err);}};_proto._callIos=function _callIos(callName){var options=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};console.log("@ _callIos",options);try{options=options?JSON.stringify(options):null;window.webkit.messageHandlers[callName].postMessage(options);}catch(err){console.log(err);}};_proto._callAndroid=function _callAndroid(callName){var options=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};console.log("@ _callAndroid",options);try{options=options?window.JSON.stringify(options):"";var uri="jsbridge://bridege/"+callName+"?"+options;window.prompt(uri,"");}catch(err){console.error(err);}};_proto.call=function call(callName){var options=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};var _this=this;var system=this.platform.isiPhone||this.platform.isiPad?"Ios":"Android";var callbackName=options.callbackName;try{var platform=getPlatform();if(!platform.isYixinliApp&&!platform.isMuseApp&&!platform.isCeShiApp&&!platform.isZiXunApp&&window.navigator.userAgent.indexOf("yixinli")=== -1){typeof window.monitor==="object"&& typeof window.monitor.stat==="function"&&window.monitor.stat({title:"\u5728\u975Eapp\u73AF\u5883\u8C03\u7528bridge\uFF01\uFF01\uFF01\uFF01",level:"error",logType:"JSError",code:599});}}catch(e){console.error("bridge \u5F02\u5E38\u65E5\u5FD7\u4E0A\u62A5\u5931\u8D25",e);}return new Promise(function(resolve){if(callbackName&& typeof window[callbackName]==="function"){if(callName==="getToken"){var resolveArr=window[callbackName][BRIDGERESOLVE];if(resolveArr){resolveArr.push(resolve);}else {resolveArr=[resolve];window[callbackName][BRIDGERESOLVE]=resolveArr;}if(_this.tokenStringify){window[callbackName](_this.tokenStringify);return}}else {window[callbackName][BRIDGERESOLVE]=resolve;}}else {resolve();}_this["_call".concat(system)](callName,options);})};_proto.removeMethods=function removeMethods(){if(this.ots&&this.ots.methods&&this.ots.methods.length>0){for(var i=0;i<this.ots.methods.length;i++){var obj=this.ots.methods[i];window[obj.method]=null;}}};_proto.AppHookInit=function AppHookInit(){console.log("\u521D\u59CB\u5316APP\u4E8B\u4EF6");var codeEventMap={10001:"appShow","10002_0":"appPayDoneFail","10002_1":"appPayDoneSuccess",10003:"appWebviewShow",10004:"appWebviewHide"};var eventFactory=function eventFactory(code){var eventName=codeEventMap[code];return new Event(eventName)};window.yxlAppCustomEvent={};for(var key in codeEventMap){window.yxlAppCustomEvent[key]=eventFactory(key);}window.appBecomeActiveStatus=function(optionString){var res=JSON.parse(optionString);console.log("\u6D3E\u53D1App\u4E8B\u4EF6",res.code,"Useage: window.addEventListener(".concat(codeEventMap[res.code],")"));switch(+res.code){case 10002:if(res.data.status==="paySuccess"){window.dispatchEvent(window.yxlAppCustomEvent["10002_1"]);}else {window.dispatchEvent(window.yxlAppCustomEvent["10002_0"]);}break;default:window.dispatchEvent(window.yxlAppCustomEvent[+res.code]);break}};};return Bridge}();

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': Bridge
});

function pick(obj,keys){return keys.reduce(function(result,key){if(obj[key]){result[key]=obj[key];}return result},{})}

var ZHUGEKEYS = {msite:"be2579193b754fd2900f660a0093fa62",yxlApp:"f6f19cec54894af8990714a597fc09f4",cpApp:"c6ef6a45ade340999081be514623f29e",kc:"38193a7a6e34415daeef0cb2b0002e54",yixinliPC:"18f5038ab49c4ae4918641ae36d67496",promotion:"e989fdd0fb8b4af384ec7c87c2d9cfb4"};

function getRunningEnv$1(){var WEBPACK_DEV=WEBPACK_DEV||false;var result={};var env=location.host.split(".")[0].match(/(qc|box)\d?/g);if(!!env||WEBPACK_DEV){result.isDev=1;result.env=env.length>0?env[0]:"";}else {result.isDev=0;result.env="";}return result}

function _classCallCheck$2(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function")}}function _defineProperty$3(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else {obj[key]=value;}return obj}function _objectSpread$3(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};var ownKeys=Object.keys(source);if(typeof Object.getOwnPropertySymbols==="function"){ownKeys=ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym){return Object.getOwnPropertyDescriptor(source,sym).enumerable}));}ownKeys.forEach(function(key){_defineProperty$3(target,key,source[key]);});}return target}var stat=function(){function stat(){var ref=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{},platform=ref.platform,_globalParams=ref.globalParams,globalParams=_globalParams===void 0?{}:_globalParams,interceptor=ref.interceptor,_customTrackConfig=ref.customTrackConfig,customTrackConfig=_customTrackConfig===void 0?{}:_customTrackConfig;_classCallCheck$2(this,stat);console.log("\u521D\u59CB\u5316 Stat \u5BF9\u8C61\uFF1A",platform,globalParams);this.platform=getPlatform();this.curPlatform=platform||"";this.runningEnv=getRunningEnv$1();this.bridge=new Bridge;this.globalParams=globalParams;this.interceptor=interceptor;this.zhugeSDK(platform,customTrackConfig);}var _proto=stat.prototype;_proto.init=function init(){return this};_proto.setGlobalParams=function setGlobalParams(){var globalParams=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};this.globalParams=Object.assign(this.globalParams,globalParams);};_proto.zhugeSDK=function zhugeSDK(platform,sdkConfig){if(window.zhuge)return;window.zhuge=window.zhuge||[];window.zhuge.methods="_init debug identify track getDid getSid getKey setSuperProperty setUserProperties setWxProperties setPlatform".split(" ");window.zhuge.factory=function(b){return function(){var a=Array.prototype.slice.call(arguments);a.unshift(b);window.zhuge.push(a);return window.zhuge}};for(var i=0;i<window.zhuge.methods.length;i++){var key=window.zhuge.methods[i];window.zhuge[key]=window.zhuge.factory(key);}window.zhuge.load=function(b,x){if(!document.getElementById("zhuge-js")){var a=document.createElement("script");var verDate=new Date;var verStr=verDate.getFullYear().toString()+verDate.getMonth().toString()+verDate.getDate().toString();a.type="text/javascript";a.id="zhuge-js";a.async=!0;a.src=(location.protocol=="http:"?"http://sdk.zhugeio.com/zhuge.min.js?v=":"https://zgsdk.zhugeio.com/zhuge.min.js?v=")+verStr;a.onerror=function(){window.zhuge.identify=window.zhuge.track=function(ename,props,callback){if(callback&&Object.prototype.toString.call(callback)==="[object Function]"){callback();}else if(Object.prototype.toString.call(props)==="[object Function]"){props();}};};var c=document.getElementsByTagName("script")[0];c.parentNode.insertBefore(a,c);window.zhuge._init(b,x);}};var useKey;var localPlatform;if(platform&&ZHUGEKEYS[platform]){useKey=ZHUGEKEYS[platform];localPlatform=platform;}else {if(this.platform.isYixinliApp){useKey=ZHUGEKEYS.yxlApp;localPlatform="yxlApp";}else if(this.platform.isCeShiApp){useKey=ZHUGEKEYS.cpApp;localPlatform="cpApp";}else if(this.platform.isPc){useKey=ZHUGEKEYS.yixinliPC;localPlatform="yixinliPC";}else {useKey=ZHUGEKEYS.msite;localPlatform="msite";}}var filtedConfig=pick(sdkConfig,["superProperty","adTrack","zgsee","autoTrack","singlePage"]);console.log("\u5F53\u524D\u73AF\u5883\uFF1A",this.runningEnv.env,"\u662F\u5426\u5F00\u542FDebug\uFF1A",this.runningEnv.isDev,"\u4F7F\u7528".concat(localPlatform,"\u7684KEY"),"\u914D\u7F6E\u9879\uFF1A",filtedConfig);this.curPlatform=localPlatform;var finalConfig=Object.assign({},{debug:this.runningEnv.isDev},filtedConfig);console.log("\u662F\u5426\u5F00\u542F\u5168\u57CB\u70B9",sdkConfig&&sdkConfig.autoTrack);if(sdkConfig&&sdkConfig.autoTrack){finalConfig=_objectSpread$3({},finalConfig,{isClickAble:function isClickAble(){return true}});}window.zhuge.load(useKey,finalConfig);};_proto.send=function send(data){if(typeof data==="string"){data={name:data};}this.statSend(data);};_proto.identify=function identify(id){var properties=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};try{window.zhuge.identify(String(id),properties);}catch(error){console.error(error);}};_proto.statSend=function statSend(data){var _this=this;var sendFlow=Promise.resolve();if(this.interceptor&& typeof this.interceptor==="function"){var _this1=this;sendFlow.then(function(){return _this1.interceptor()});}sendFlow.then(function(){var resultParams={};if(typeof _this.globalParams==="object"&&Object.keys(_this.globalParams).length>0){data.properties=Object.assign({},_this.globalParams,data.properties);}data.properties=Object.assign({},resultParams,data.properties);if(_this.curPlatform==="yxlApp"&&(_this.platform.isYixinliApp||_this.platform.isCeShiApp)){_this.bridge.call("stat",data);}else {window.zhuge.track(data.name,data.properties);}}).catch(function(e){console.log(e);});};return stat}();

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': stat
});

function askSubmitVerify(){var el=arguments.length>0&&arguments[0]!==void 0?arguments[0]:"#sc";var smartCaptcha=window.smartCaptcha,NVC_Opt=window.NVC_Opt;return new Promise(function(resolve){if(window.NVC_Opt&&smartCaptcha){var ic=new smartCaptcha({renderTo:el,width:"100%",secvrf_layout:true,height:42,default_txt:"\u70B9\u51FB\u6309\u94AE\u5F00\u59CB\u667A\u80FD\u9A8C\u8BC1",success_txt:"\u9A8C\u8BC1\u6210\u529F",fail_txt:"\u9A8C\u8BC1\u5931\u8D25\uFF0C\u8BF7\u5728\u6B64\u70B9\u51FB\u6309\u94AE\u5237\u65B0",scaning_txt:"\u667A\u80FD\u68C0\u6D4B\u4E2D",success:function success(data){console.log(NVC_Opt.token);console.log(data.sessionId);console.log(data.sig);resolve({token:NVC_Opt.token,sessionId:data.sessionId,sig:data.sig});}});ic.init();}else {resolve(null);}})}

function baiduStat(){var id=arguments.length>0&&arguments[0]!==void 0?arguments[0]:"d64469e9d7bdbf03af6f074dffe7f9b5";var platform=getPlatform();var isApp=platform.isYixinliApp||platform.isCeShiApp||platform.isZiXunApp;if(isApp){return}(function(){var hm=document.createElement("script");hm.src="https://hm.baidu.com/hm.js?".concat(id);var s=document.getElementsByTagName("script")[0];s.parentNode.insertBefore(hm,s);})();var bp=document.createElement("script");var curProtocol=window.location.protocol.split(":")[0];if(curProtocol==="https"){bp.src="https://zz.bdstatic.com/linksubmit/push.js";}else {bp.src="http://push.zhanzhang.baidu.com/push.js";}var s1=document.getElementsByTagName("script")[0];s1.parentNode.insertBefore(bp,s1);}

var chunkArray=function(data,length){var newArr=[];for(var i=0;i<data.length;i+=length){newArr.push(data.slice(i,i+length));}return newArr};

function debounce(action,idle){var last=null;return function(){var ctx=this;var args=arguments;clearTimeout(last);last=setTimeout(function(){action.apply(ctx,args);},idle);}}

function _classCallCheck$1(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function")}}var vconsole=function vconsole(){_classCallCheck$1(this,vconsole);console.log("vconsole is replaced");};

var getQueryString=function(name,url){var reg=new RegExp("(^|&?)".concat(name,"=([^&]*)(&|$)"));var r=(url||window.location.search.substr(1)).match(reg);if(r!=null)return unescape(r[2]);return null};

var goApp=function(href){var src="";if(href.indexOf("yixinli://")> -1){src=href.trim();}else {src="yixinli://".concat(href);}var UA=window.navigator.userAgent.toUpperCase();if(/MICROMESSENGER/i.test(UA)){if(window.toast){window.toast("\u5FAE\u4FE1\u7528\u6237\u9700\u8981\u70B9\u51FB\u53F3\u4E0A\u89D2\u83DC\u5355\uFF0C\u4F7F\u7528\u201C\u6D4F\u89C8\u5668\u201D\u6253\u5F00~",3e3);}else {alert("\u5FAE\u4FE1\u7528\u6237\u9700\u8981\u70B9\u51FB\u53F3\u4E0A\u89D2\u83DC\u5355\uFF0C\u4F7F\u7528\u201C\u6D4F\u89C8\u5668\u201D\u6253\u5F00~");}return}window.location.href=src;window.setTimeout(function(){window.location.href="//a.app.qq.com/o/simple.jsp?pkgname=com.xinli.yixinli";},3500);};

function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++)arr2[i]=arr[i];return arr2}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr}function _iterableToArrayLimit(arr,i){var _i=arr==null?null:typeof Symbol!=="undefined"&&arr[Symbol.iterator]||arr["@@iterator"];if(_i==null)return;var _arr=[];var _n=true;var _d=false;var _s,_e;try{for(_i=_i.call(arr);!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e}}return _arr}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_unsupportedIterableToArray(arr,i)||_nonIterableRest()}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(n);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen)}var handleExpiresStorage=function(val,key,day){var writable=arguments.length>3&&arguments[3]!==void 0?arguments[3]:false;var StorageObj=JSON.parse(localStorage.getItem(val));var StorageMap=new Map;var curTime=Date.now();for(var _$key in StorageObj){StorageMap.set(_$key,StorageObj[_$key]);}var keyValue=StorageMap.get(key);if(keyValue){var interval=curTime-keyValue;if(interval<0)return false}if(writable){localStorage.removeItem(val);StorageMap.set(key,curTime+day*1e3*86400);var objFromMap={};var _iteratorNormalCompletion=true,_didIteratorError=false,_iteratorError=undefined;try{for(var _iterator=StorageMap[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _value=_slicedToArray(_step.value,2),k=_value[0],v=_value[1];objFromMap[k]=v;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return!=null){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError}}}localStorage.setItem(val,JSON.stringify(objFromMap));}return true};

var versionfunegt=function(){var appVer=arguments.length>0&&arguments[0]!==void 0?arguments[0]:"",standardVer=arguments.length>1&&arguments[1]!==void 0?arguments[1]:"";if(!appVer||!standardVer)return false;var appVerArr=appVer.split(".").map(function(item){return +item});var standardVerArr=standardVer.split(".").map(function(item){return +item});if(appVerArr[0]!==standardVerArr[0]){return appVerArr[0]>standardVerArr[0]}else {if(appVerArr[1]!==standardVerArr[1]){return appVerArr[1]>standardVerArr[1]}else {return appVerArr[2]>=standardVerArr[2]}}};

var isCanHideNavigationBar=function(platform){var isYixinliApp=platform.isYixinliApp,yixinliAPPVersion=platform.yixinliAPPVersion,isZiXunApp=platform.isZiXunApp,zixunAppVersion=platform.zixunAppVersion,isZiXunShiApp=platform.isZiXunShiApp;var isYixinliAppVersionWork=isYixinliApp&&versionfunegt(yixinliAPPVersion,"5.9.0");var isZiXunAppVersionWork=isZiXunApp&&versionfunegt(zixunAppVersion,"4.0.0");return (isYixinliAppVersionWork||isZiXunAppVersionWork||isZiXunShiApp)&&window.screen.height-document.documentElement.clientHeight<50};

var isDangerUrl=function(){var host=arguments.length>0&&arguments[0]!==void 0?arguments[0]:window.location.hostname;var dangerUrls=["xinli001.com","xinli001.xin","xinli001.cc","xinli001.net","pgxinli.com","zixunshizhijia.com"];var isProd=getRunningEnv$1().env==="";var isWechat=getPlatform().isWechat;if(!isProd||!isWechat)return false;var isDanger=false;for(var i=0;i<dangerUrls.length;i++){var url=dangerUrls[i];if(host.indexOf(url)> -1){isDanger=true;}}return isDanger};

function loadScript(url){window.loadedScript=window.loadedScript||[];return new Promise(function(resolve){if(window.loadedScript.includes(url)){resolve({code:1,msg:"this script was loaded"});}var script=document.createElement("script");script.type="text/javascript";script.src=url;document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){script.onload=null;window.loadedScript.push(url);resolve({code:1,msg:"script load success!"});};})}

function omit(obj,keys){var result={},key;for(key in obj){if(keys.indexOf(key)== -1)result[key]=obj[key];}return result}

function secondCounter(start,end,callback){var countWay=start>end?"down":"up";if(start!==end){setTimeout(function(){if(countWay==="down"){secondCounter(start-1,end,callback);}else {secondCounter(start+1,end,callback);}},1e3);}callback(start);}

function secondToTime(second){var sec="".concat(Math.round(second)%60).padStart(2,"0");var minute="".concat((second/60).toFixed(0)).padStart(2,"0");return "".concat(minute,":").concat(sec)}

function throttle(fn,delay){var mustRunDelay=arguments.length>2&&arguments[2]!==void 0?arguments[2]:0;var timer=null;var tStart;return function(){var context=this;var args=arguments;var tCurr=+new Date;clearTimeout(timer);if(!tStart){tStart=tCurr;}if(mustRunDelay!==0&&tCurr-tStart>=mustRunDelay){fn.apply(context,args);tStart=tCurr;}else {timer=setTimeout(function(){fn.apply(context,args);},delay);}}}

var updateOrDownLoadApp=function(){var platform=getPlatform();var ua=window.navigator.userAgent;var isApp=platform.isYixinliApp||platform.isCeShiApp;var isAndroid=ua.indexOf("Android")> -1||ua.indexOf("Adr")> -1;if(isApp){var bridge=new Bridge;var _version=GetQueryString("_version",window.location.hash);if(versionfunegt(_version,"5.2.1")){bridge.call("doUpgrade");}else {if(isAndroid){var iframe=document.createElement("iframe");var src="http://xinli001-file.oss-cn-hangzhou.aliyuncs.com/android_patch/yixinli.apk";iframe.src=src;iframe.style="width:0;height:0;overflow:hidden;position: absolute;";document.body.appendChild(iframe);setTimeout(function(){return document.body.removeChild(iframe)},2e3);}else {var href="http://a.app.qq.com/o/simple.jsp?open_by_broswer=1&pkgname=com.xinli.yixinli";bridge.call("openWebview",{url:href,isOpenByBrowser:1});}}}else {goApp();}};

var wxConfigOrigin=function(json,origin,str){var wechat=arguments.length>3&&arguments[3]!==void 0?arguments[3]:true,protocol=arguments.length>4&&arguments[4]!==void 0?arguments[4]:window.location.protocol;var originUpper=origin.toUpperCase();if(!/_ORIGIN$/.test(originUpper)){originUpper+="_ORIGIN";}var className="_warn",typeName=str;if(/_(warn|safe|risk)$/.test(str)){var index=str.lastIndexOf("_");typeName=str.substring(index,0);className=str.substr(index);}var platform=getPlatform();if(!platform.isWechat&&wechat){className="_safe";}json=json["domain"][originUpper];if(json&&json[typeName+className]){return protocol+"//"+json[typeName+className]}else {throw new Error("wxConfigOrigin:Can't match any origin with "+origin+str)}};

function setCookie(param){var key=param.key,value=param.value,timeMinSec=param.timeMinSec,Expired=param.Expired,_domain=param.domain,domain=_domain===void 0?location.host:_domain;var exp=new Date;exp.setTime(exp.getTime()+timeMinSec);if(Expired){document.cookie="".concat(key,"=").concat(escape(value),";expires=").concat(Expired,";path=/;domain=").concat(domain,";");}else if(timeMinSec){document.cookie="".concat(key,"=").concat(escape(value),";expires=").concat(exp.toGMTString(),";path=/;domain=").concat(domain,";");}}

function delCookie(key){setCookie({key:key,value:"",Expired:new Date("Thu, 01 Jan 1970 00:00:00 GMT:")});}

function getCookie(key){var name=key+"=";var cookieArray=document.cookie.split(";");for(var i=0;i<cookieArray.length;i++){var c=cookieArray[i].trim();if(c.indexOf(name)==0)return c.substring(name.length,c.length)}return undefined}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var md5$1 = {exports: {}};

var crypt = {exports: {}};

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt$1 = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt$1.rotl(n, 8) & 0x00FF00FF | crypt$1.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt$1.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  crypt.exports = crypt$1;
})();

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

var charenc_1 = charenc;

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
var isBuffer_1 = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
};

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}

(function(){
  var crypt$1 = crypt.exports,
      utf8 = charenc_1.utf8,
      isBuffer = isBuffer_1,
      bin = charenc_1.bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
      message = message.toString();
    // else, assume byte array already

    var m = crypt$1.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt$1.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  md5$1.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt$1.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt$1.bytesToHex(digestbytes);
  };

})();

var md5 = md5$1.exports;

function getRequestSign(){var params=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{},apiSecret=arguments.length>1&&arguments[1]!==void 0?arguments[1]:"";var apiSecretMap={android:"910676770dfc5c34d32e250ea3e91049",ios:"6767790dfc5c34d32e250ea3e9104910",m:"49da2fb42b5655d69f9449ca2fe30e40",pc:"9a9e2bc951b8b9ece1581cc2e78e240d"};var apiSecret2=apiSecret?apiSecret:apiSecretMap[params._platform||"ios"];var timestamp=new Date().getTime();var defaultParams={timestamp:timestamp};params=Object.assign(defaultParams,params);if(params["timestamp"]){params=omit(params,"timestamp");}var keys=Object.keys(params).sort();var paramsStr="";keys.map(function(key){paramsStr="".concat(paramsStr).concat(key,"=").concat(params[key],",");});paramsStr="".concat(paramsStr).concat(timestamp).concat(apiSecret2);var sign=md5(paramsStr);params.timestamp=timestamp;return {sign:sign,params:params}}

function createHttpServer(){var _http=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({withCredentials:true});var ref=getPlatform(),isYixinliApp=ref.isYixinliApp,isZiXunApp=ref.isZiXunApp;if(isYixinliApp||isZiXunApp){var getToken=function(){return new Promise(function(resolve){var callbackName="frontend_lib_axios_getToken"+ +new Date;var bridge=new Bridge({methods:[{method:callbackName,callback:function(obj){if(typeof obj==="object"&&!!obj.token){resolve(obj.token);}else {resolve("");}}}]});bridge.call("getToken",{callbackName:callbackName});})};_http.formatEnvInterceptor=_http.interceptors.request.use(function(res){if(isYixinliApp||isZiXunApp){return getToken().then(function(token){if(res.url.indexOf("?")=== -1){res.url+="?token="+token;}else {res.url+="&token="+token;}return Promise.resolve(res)})}});}return _http}

function getScrollHeight(){return document.documentElement.scrollHeight}

function getScrollTop(){var scrollTop=document.documentElement.scrollTop||window.pageYOffset||document.body.scrollTop;return scrollTop}

function setScrollTop(number){if(number!==undefined&&!Number.isNaN(number)){console.log("setScrollTop",number);document.body.scrollTop=document.documentElement.scrollTop=window.pageYOffset=number;}}

var broswerLoadedToDownloadApp=function(){var platform=getPlatform();if(platform.isYixinliApp)return;if(platform.isiPhone||platform.isiPad){window.location.href="https://apps.apple.com/app/apple-store/id994051627";}else {var iframe=document.createElement("iframe");var src="https://filecdn.xinli001.com/android_patch/yixinli.apk";iframe.src=src;iframe.style="width:0;height:0;overflow:hidden;position: absolute;";document.body.appendChild(iframe);setTimeout(function(){return document.body.removeChild(iframe)},2e3);}};

function getEnvHost(str){var _getRunningEnv=getRunningEnv(),env=_getRunningEnv.env;var result=str;if(env){result=str.replace(/\./,"-"+env+".");}return result}

function isIOS9(){var getOsv=function getOsv(){var reg=/OS ((\d+_?){2,3})\s/;if(navigator.userAgent.match(/iPad/i)||navigator.platform.match(/iPad/i)||navigator.userAgent.match(/iP(hone|od)/i)||navigator.platform.match(/iP(hone|od)/i)){var _osv=reg.exec(navigator.userAgent);if(_osv.length>0){return _osv[0].replace("OS","").replace("os","").replace(/\s+/g,"").replace(/_/g,".")}}return ""};var osv=getOsv();var osvArr=osv.split(".");if(osvArr&&osvArr.length>0){if(parseInt(osvArr[0])<=9){return true}}return false}

function typeMatch(param){var url=param.url,type=param.type;try{var allowType=["search","hash"];if(allowType.includes(type.toLowerCase())){var urlObj=new URL(url||location.href);var targetHead="";if(type==="search"){targetHead="?";}else if(type==="hash"){if(urlObj[type]&&urlObj[type].match(/(#\/)?[a-zA-Z0-9-_]+\??/)){urlObj[type].match(/(#\/)?[a-zA-Z0-9-_]+\??/)[0];}else {targetHead="#/?";}}var targetString=urlObj[type].replace(targetHead,"");var targetObj=Object(__WEBPACK_IMPORTED_MODULE_1_qs__["parse"])(targetString);return {urlObj:urlObj,targetObj:targetObj,targetHead:targetHead}}else {return false}}catch(err){console.error(err);}}

function addUrlParams(param){var url=param.url,_type=param.type,type=_type===void 0?"search":_type,params=param.params;var match=typeMatch({url:url,type:type});if(match){var ref=typeMatch({url:url,type:type}),urlObj=ref.urlObj,targetObj=ref.targetObj,targetHead=ref.targetHead;var finalParamsStr=Object(__WEBPACK_IMPORTED_MODULE_1_qs__["stringify"])(Object.assign(targetObj,params));urlObj[type]="".concat(targetHead).concat(finalParamsStr);return urlObj.href}else {return url}}

function addHashParams(param){var url=param.url,params=param.params;return addUrlParams({url:url,type:"hash",params:params})}

function getUrlParams(param){var url=param.url,_type=param.type,type=_type===void 0?"search":_type,_params=param.params,params=_params===void 0?[]:_params;var targetObj=typeMatch({url:url,type:type}).targetObj;return pick(targetObj,params)}

var base64 = {exports: {}};

/*
 *  base64.js
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 */

(function (module, exports) {
(function (global, factory) {
    module.exports = factory(global)
        ;
}((
    typeof self !== 'undefined' ? self
        : typeof window !== 'undefined' ? window
        : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal
: commonjsGlobal
), function(global) {
    // existing version for noConflict()
    global = global || {};
    var _Base64 = global.Base64;
    var version = "2.5.1";
    // if node.js and NOT React Native, we use Buffer
    var buffer;
    if (module.exports) {
        try {
            buffer = eval("require('buffer').Buffer");
        } catch (err) {
            buffer = undefined;
        }
    }
    // constants
    var b64chars
        = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var b64tab = function(bin) {
        var t = {};
        for (var i = 0, l = bin.length; i < l; i++) t[bin.charAt(i)] = i;
        return t;
    }(b64chars);
    var fromCharCode = String.fromCharCode;
    // encoder stuff
    var cb_utob = function(c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c
                : cc < 0x800 ? (fromCharCode(0xc0 | (cc >>> 6))
                                + fromCharCode(0x80 | (cc & 0x3f)))
                : (fromCharCode(0xe0 | ((cc >>> 12) & 0x0f))
                   + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
                   + fromCharCode(0x80 | ( cc         & 0x3f)));
        } else {
            var cc = 0x10000
                + (c.charCodeAt(0) - 0xD800) * 0x400
                + (c.charCodeAt(1) - 0xDC00);
            return (fromCharCode(0xf0 | ((cc >>> 18) & 0x07))
                    + fromCharCode(0x80 | ((cc >>> 12) & 0x3f))
                    + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
                    + fromCharCode(0x80 | ( cc         & 0x3f)));
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    var utob = function(u) {
        return u.replace(re_utob, cb_utob);
    };
    var cb_encode = function(ccc) {
        var padlen = [0, 2, 1][ccc.length % 3],
        ord = ccc.charCodeAt(0) << 16
            | ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8)
            | ((ccc.length > 2 ? ccc.charCodeAt(2) : 0)),
        chars = [
            b64chars.charAt( ord >>> 18),
            b64chars.charAt((ord >>> 12) & 63),
            padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
            padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
        ];
        return chars.join('');
    };
    var btoa = global.btoa ? function(b) {
        return global.btoa(b);
    } : function(b) {
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    var _encode = buffer ?
        buffer.from && Uint8Array && buffer.from !== Uint8Array.from
        ? function (u) {
            return (u.constructor === buffer.constructor ? u : buffer.from(u))
                .toString('base64')
        }
        :  function (u) {
            return (u.constructor === buffer.constructor ? u : new  buffer(u))
                .toString('base64')
        }
        : function (u) { return btoa(utob(u)) }
    ;
    var encode = function(u, urisafe) {
        return !urisafe
            ? _encode(String(u))
            : _encode(String(u)).replace(/[+\/]/g, function(m0) {
                return m0 == '+' ? '-' : '_';
            }).replace(/=/g, '');
    };
    var encodeURI = function(u) { return encode(u, true) };
    // decoder stuff
    var re_btou = new RegExp([
        '[\xC0-\xDF][\x80-\xBF]',
        '[\xE0-\xEF][\x80-\xBF]{2}',
        '[\xF0-\xF7][\x80-\xBF]{3}'
    ].join('|'), 'g');
    var cb_btou = function(cccc) {
        switch(cccc.length) {
        case 4:
            var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                |    ((0x3f & cccc.charCodeAt(1)) << 12)
                |    ((0x3f & cccc.charCodeAt(2)) <<  6)
                |     (0x3f & cccc.charCodeAt(3)),
            offset = cp - 0x10000;
            return (fromCharCode((offset  >>> 10) + 0xD800)
                    + fromCharCode((offset & 0x3FF) + 0xDC00));
        case 3:
            return fromCharCode(
                ((0x0f & cccc.charCodeAt(0)) << 12)
                    | ((0x3f & cccc.charCodeAt(1)) << 6)
                    |  (0x3f & cccc.charCodeAt(2))
            );
        default:
            return  fromCharCode(
                ((0x1f & cccc.charCodeAt(0)) << 6)
                    |  (0x3f & cccc.charCodeAt(1))
            );
        }
    };
    var btou = function(b) {
        return b.replace(re_btou, cb_btou);
    };
    var cb_decode = function(cccc) {
        var len = cccc.length,
        padlen = len % 4,
        n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0)
            | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0)
            | (len > 2 ? b64tab[cccc.charAt(2)] <<  6 : 0)
            | (len > 3 ? b64tab[cccc.charAt(3)]       : 0),
        chars = [
            fromCharCode( n >>> 16),
            fromCharCode((n >>>  8) & 0xff),
            fromCharCode( n         & 0xff)
        ];
        chars.length -= [0, 0, 2, 1][padlen];
        return chars.join('');
    };
    var _atob = global.atob ? function(a) {
        return global.atob(a);
    } : function(a){
        return a.replace(/\S{1,4}/g, cb_decode);
    };
    var atob = function(a) {
        return _atob(String(a).replace(/[^A-Za-z0-9\+\/]/g, ''));
    };
    var _decode = buffer ?
        buffer.from && Uint8Array && buffer.from !== Uint8Array.from
        ? function(a) {
            return (a.constructor === buffer.constructor
                    ? a : buffer.from(a, 'base64')).toString();
        }
        : function(a) {
            return (a.constructor === buffer.constructor
                    ? a : new buffer(a, 'base64')).toString();
        }
        : function(a) { return btou(_atob(a)) };
    var decode = function(a){
        return _decode(
            String(a).replace(/[-_]/g, function(m0) { return m0 == '-' ? '+' : '/' })
                .replace(/[^A-Za-z0-9\+\/]/g, '')
        );
    };
    var noConflict = function() {
        var Base64 = global.Base64;
        global.Base64 = _Base64;
        return Base64;
    };
    // export Base64
    global.Base64 = {
        VERSION: version,
        atob: atob,
        btoa: btoa,
        fromBase64: decode,
        toBase64: encode,
        utob: utob,
        encode: encode,
        encodeURI: encodeURI,
        btou: btou,
        decode: decode,
        noConflict: noConflict,
        __buffer__: buffer
    };
    // if ES5 is available, make Base64.extendString() available
    if (typeof Object.defineProperty === 'function') {
        var noEnum = function(v){
            return {value:v,enumerable:false,writable:true,configurable:true};
        };
        global.Base64.extendString = function () {
            Object.defineProperty(
                String.prototype, 'fromBase64', noEnum(function () {
                    return decode(this)
                }));
            Object.defineProperty(
                String.prototype, 'toBase64', noEnum(function (urisafe) {
                    return encode(this, urisafe)
                }));
            Object.defineProperty(
                String.prototype, 'toBase64URI', noEnum(function () {
                    return encode(this, true)
                }));
        };
    }
    //
    // export Base64 to the namespace
    //
    if (global['Meteor']) { // Meteor.js
        Base64 = global.Base64;
    }
    // module.exports and AMD are mutually exclusive.
    // module.exports has precedence.
    if (module.exports) {
        module.exports.Base64 = global.Base64;
    }
    // that's it!
    return {Base64: global.Base64}
}));
}(base64));

function isBase64(str){if(str===""||str.trim()===""){return false}try{return base64.exports.Base64.encodeURI(base64.exports.Base64.decode(str))==str}catch(err){return false}}var parseQueryVal=function(val){return isBase64(val)?base64.exports.Base64.decode(val):decodeURIComponent(val)};var handleQueryVal=function(val){return base64.exports.Base64.encodeURI(val)};function isIpUrl(ip){var re=/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;if(re.test(ip)){if(RegExp.$1<256&&RegExp.$2<256&&RegExp.$3<256&&RegExp.$4<256)return true}return false}

function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor}function _defineProperty$2(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else {obj[key]=value;}return obj}function _objectSpread$2(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};var ownKeys=Object.keys(source);if(typeof Object.getOwnPropertySymbols==="function"){ownKeys=ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym){return Object.getOwnPropertyDescriptor(source,sym).enumerable}));}ownKeys.forEach(function(key){_defineProperty$2(target,key,source[key]);});}return target}var Track=function(){function Track(){var ref=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{},_globalParams=ref.globalParams,globalParams=_globalParams===void 0?{}:_globalParams,_customTrackConfig=ref.customTrackConfig,customTrackConfig=_customTrackConfig===void 0?{}:_customTrackConfig,sensorsConfig=ref.sensorsConfig;_classCallCheck(this,Track);this.runningEnv=getRunningEnv$1();this.platform=getPlatform();this.globalParams=globalParams;this._http=createHttpServer();var platform_type;if(this.isApp){platform_type="app\u7AEF";}else {platform_type="\u7F51\u9875\u7AEF";}var isLocal=window.location.href.indexOf("localhost")> -1;var isIp=isIpUrl(window.location.hostname);var isDev=this.runningEnv.isDev||isLocal||isIp;this.isDev=isDev;console.log("\u795E\u7B56\uFF0CisDev: ",this.isDev);this.sensorsConfig=sensorsConfig||(isDev?{project:"",abtestKey:"12EF873F39ADC26C2325F77E33614F73DCA41F1E"}:{project:"production",abtestKey:"FE01E606197BE842D4F240332C2BD4BBE81A803D"});this.initSDK(customTrackConfig);this.setGlobalParams({platform_type:platform_type});}var _proto=Track.prototype;_proto.init=function init(){return this};_proto.setGlobalParams=function setGlobalParams(){var globalParams=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};if(!this.isEnable)return;this.loadJSPromise.then(function(){window.sensors.registerPage(globalParams);});};_proto.initSDK=function initSDK(customTrackConfig){var _this=this;if(!this.isEnable)return;var server_url=window.location.protocol+"//sdata.xinli001.com/sa?project="+this.sensorsConfig.project;this.loadJSPromise=loadScript("//static.xinli001.com/frontend-lib/sensorsdata.min.js").then(function(){window.sensors=window["sensorsDataAnalytic201505"];var config=_objectSpread$2({show_log:!!_this.isDev,server_url:server_url,heatmap:{clickmap:"not_collect",scroll_notice_map:"not_collect"},is_track_single_page:true,use_client_time:true,send_type:"beacon",app_js_bridge:_this.isApp},customTrackConfig);console.log("\u795E\u7B56init:",config);window.sensors.init(config);});};_proto.loadAbTest=function loadAbTest(){var _this=this;if(this.loadABtestJSPromise){return this.loadABtestJSPromise}this.loadABtestJSPromise=Promise.all([this.loadJSPromise,loadScript("//static.xinli001.com/frontend-lib/abtest.min.js"),]).then(function(){var _abtest=window.sensors.use("SensorsABTest",{url:window.location.protocol+"//abtest-tx-beijing-01.saas.sensorsdata.cn/api/v2/abtest/online/results?project-key="+_this.sensorsConfig.abtestKey,multilink:{timeout:500,pass_params:true}});_this._abtest=_abtest;});return this.loadABtestJSPromise};_proto.send=function send(name,properties){if(!this.isEnable)return;this.loadJSPromise.then(function(){window.sensors.track(name,properties||{});});};_proto.identify=function identify(id,properties){if(!this.isEnable)return;this.loadJSPromise.then(function(){try{window.sensors.login(id);if(properties){window.sensors.setProfile(properties);}}catch(error){console.error(error);}});};_proto.login=function login(id){if(!this.isEnable)return;this.loadJSPromise.then(function(){try{window.sensors.login(id);}catch(error){console.error(error);}});};_proto._getUserInfo=function _getUserInfo(){var _this=this;var pre=this.runningEnv.env?"-"+this.runningEnv.env:"";return new Promise(function(resolve){_this._http.get("//m".concat(pre,".xinli001.com/ajax/get-user-header")).then(function(res){var _data=res.data,code=_data.code,data=_data.data;if(code===0){resolve(data);}resolve(null);}).catch(function(){return resolve(null)});})};_proto._fetchSensorsCustomWhiteCache=function _fetchSensorsCustomWhiteCache(token){if(!this._fetchSensorsCustomWhiteFetchPromise){var _this=this;var pre=this.runningEnv.env?"-"+this.runningEnv.env:"";this._fetchSensorsCustomWhiteFetchPromise=new Promise(function(resolve){var _this1=_this;(token?Promise.resolve(token):_this._getUserInfo().then(function(data){return data?data.user.token:""})).then(function(_token){if(!_token){return resolve(undefined)}_this1._http.get("//yiapp".concat(pre,".xinli001.com/sensors/customWhite?token=").concat(_token)).then(function(res){resolve(res);});});});}return this._fetchSensorsCustomWhiteFetchPromise};_proto._fetchSensorsCustomWhite=function _fetchSensorsCustomWhite(obj,token){var _this=this;return new Promise(function(resolve){_this._fetchSensorsCustomWhiteCache(token).then(function(res){var _data=res.data,code=_data.code,data=_data.data;if(code===0){var target=data.find(function(v){return v.testName===obj.param_name});var testValue=target.testValue;if(obj.value_type==="Number"){testValue=+testValue;}else if(obj.value_type==="Boolean"){testValue=Boolean(testValue);}else if(obj.value_type==="Object"){try{testValue=JSON.parse(testValue);}catch(e){console.log(e);testValue=target.testValue;}}return testValue?resolve(testValue):resolve(obj.default_value)}resolve(undefined);}).catch(function(){resolve(undefined);});})};_proto.fetchAbtest=function fetchAbtest(obj){var token=arguments.length>1&&arguments[1]!==void 0?arguments[1]:"",cache=arguments.length>2&&arguments[2]!==void 0?arguments[2]:true;var _this3=this;return new Promise(function(resolve){var callback=function(result){if(typeof obj.callback==="function")obj.callback(result);resolve(result);};console.log("\u795E\u7B56\u73AF\u5883\u662F\u5426\u652F\u6301ab test",_this3.isEnable);if(_this3.isEnable){var _this2=_this3;_this3._fetchSensorsCustomWhite(obj,token).then(function(result){var _this=_this2;console.log("\u58F9\u5FC3\u7406\u8FD4\u56DEabtest\u7ED3\u679C",result);return result!==undefined?callback(result):_this2.loadAbTest().then(function(){_this._abtest[cache?"fastFetchABTest":"asyncFetchABTest"](_objectSpread$2({},obj,{callback:callback}));})});}else {callback(obj.default_value);}})};_createClass(Track,[{key:"isApp",get:function get(){var isYixinliApp=this.platform.isYixinliApp;return isYixinliApp}},{key:"isEnable",get:function get(){var _platform=this.platform,yixinliAPPVersion=_platform.yixinliAPPVersion,isYixinliApp=_platform.isYixinliApp;return isYixinliApp?versionfunegt(yixinliAPPVersion,"8.0.0"):true}}]);return Track}();function singleton(){var instance;return function(config){if(instance){return instance}return instance=new Track(config)}}var _track = singleton();

function _defineProperty$1(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else {obj[key]=value;}return obj}function _objectSpread$1(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};var ownKeys=Object.keys(source);if(typeof Object.getOwnPropertySymbols==="function"){ownKeys=ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym){return Object.getOwnPropertyDescriptor(source,sym).enumerable}));}ownKeys.forEach(function(key){_defineProperty$1(target,key,source[key]);});}return target}function merge(Vue){Vue.prototype.$handleTrackQuery=function(str){return handleQueryVal(str)};Vue.prototype.$parseTrackQuery=function(str){return parseQueryVal(str)};Vue.prototype.$getTrackRunWithRouteQuerys=function(){var params=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};var _$route=this.$route,meta=_$route.meta,query=_$route.query;var result={};if(meta&&meta.pageName){result._source_page_=meta.pageName;if(event){var target=event.target;var site="";try{var runTimes=0;while(target!==document.documentElement&&runTimes<100){var _site=target.getAttribute("data-site");if(_site){site=_site+(site?"-":"")+site;}target=target.parentNode;runTimes++;}}catch(e){console.log(e);site="";}if(site){result._touch_name_=site;}}}if(query.yxl_source){result.yxl_source=query.yxl_source;}if(params._source_page_){result._source_page_=params._source_page_;}if(params._source_page_){result._touch_name_=params._touch_name_;}if(result._source_page_){result._source_page_=handleQueryVal(result._source_page_);}if(result._touch_name_){result._touch_name_=handleQueryVal(result._touch_name_);}return result};Vue.prototype.$trackPageView=function(name){var properties=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};var source_page=properties.source_page||this.$route.query._source_page_||getQueryString("_source_page_")||"";var touch_name=properties.touch_name||this.$route.query._touch_name_||getQueryString("_touch_name_")||"";var yxl_source=this.$route.query.yxl_source||getQueryString("yxl_source")||"";this.$track.send(name,_objectSpread$1({yxl_source:yxl_source},properties,{source_page:source_page?parseQueryVal(source_page):"",touch_name:touch_name?parseQueryVal(touch_name):""}));};Vue.prototype.$trackEvent=function(name){var properties=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};var yxl_source=this.$route.query.yxl_source||getQueryString("yxl_source")||"";this.$track.send(name,_objectSpread$1({yxl_source:yxl_source},properties));};}var trackPlugin = {install:function install(Vue,options){var trackOptions=options&&options.trackOptions?options.trackOptions:undefined;var _track$1=_track(trackOptions);Vue.prototype.$track=_track$1;if(!window.yxl){window.yxl={};}window.yxl.track=_track$1;merge(Vue);if(options&&options.store){options.store.watch(function(){return options.store.state.userinfo},function(val){try{if(val&&val.id){_track$1.login(val.id);}}catch(e){console.log("_track.login",e);}});}}};

function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else {obj[key]=value;}return obj}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};var ownKeys=Object.keys(source);if(typeof Object.getOwnPropertySymbols==="function"){ownKeys=ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym){return Object.getOwnPropertyDescriptor(source,sym).enumerable}));}ownKeys.forEach(function(key){_defineProperty(target,key,source[key]);});}return target}function trackCreator(){var options=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};var track=_track(options);var handleTrackQuery=handleQueryVal;var getTrackRunWithRouteQuerys=function(){var params=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};var result={};if(params.source_page){result._source_page_=handleQueryVal(params.source_page);}if(params.source_page){result._touch_name_=handleQueryVal(params.touch_name);}return result};var parseTrackQuery=parseQueryVal;var trackPageView=function trackPageView(name,properties){var source_page=properties.source_page||getQueryString("_source_page_")||"";var touch_name=properties.touch_name||getQueryString("_touch_name_")||"";track.send(name,_objectSpread({},properties,{source_page:source_page?parseQueryVal(source_page):"",touch_name:touch_name?parseQueryVal(touch_name):""}));};var trackEvent=function trackEvent(name,properties){track.send(name,properties);};return {handleTrackQuery:handleTrackQuery,parseTrackQuery:parseTrackQuery,trackPageView:trackPageView,trackEvent:trackEvent,getTrackRunWithRouteQuerys:getTrackRunWithRouteQuerys}}

var trackLoginAxiosInterceptor=function(track){var logined=false;return function(res){if(logined)return res;var isFetchSuccess=+res.data.code===0;var isFetchUserInfo=res.config.url.indexOf("ajax/get-user-header")> -1;if(isFetchUserInfo&&isFetchSuccess){var user=res.data.data.user;if(user.id){track.login(user.id);logined=true;console.log("isFetchUserInfo",user.id);}}var isFetchConsultUser=res.config.url.indexOf("consult/consult_user");if(isFetchConsultUser&&isFetchSuccess){var user_id=res.data.data.user_id;track.login(user_id);logined=true;console.log("isFetchConsultUser",user_id);}return res}};


//# sourceMappingURL=index.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "TcQ7":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("MU5D");
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "Tiqt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "To3L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("+E39");
var getKeys = __webpack_require__("lktj");
var gOPS = __webpack_require__("1kS7");
var pIE = __webpack_require__("NpIQ");
var toObject = __webpack_require__("sB3e");
var IObject = __webpack_require__("MU5D");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("S82l")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "TuAd":
/***/ (function(module, exports) {

module.exports = {"code":"1","msg":"请求接口成功","data":{"intro":"<p>壹心理测评提醒您，在做题过程中，请注意以下几点：<br /><br />1. 测试一共<strong> 78 </strong>题，请尽量在 <strong>25 </strong>分钟内完成，否则数据可能无法保存（右上方有时间进度条）；<br /><br />2. 答案没有对错之分，如实作答即可，若遇到难以抉择的问题，请根据第一感觉作答，你的作答将得到严格保密；<br /><br />3. 如遇电话、死机等导致测试中断，可到公众号找回，系统将保留你的答题记录。</p>","name":"疫情心理修复评估","scaleId":410}}

/***/ }),

/***/ "TwzQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("49qz")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "U+VG":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__("Ds5P");
var cof = __webpack_require__("ydD5");

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),

/***/ "U3rI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis__ = __webpack_require__("OTud");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_units__ = __webpack_require__("DVdL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__frontend_lib_lib_stat_Stat_js__ = __webpack_require__("Eqnl");









var TRACKER = function () {
    function TRACKER() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$channelId = _ref.channelId,
            channelId = _ref$channelId === undefined ? null : _ref$channelId,
            _ref$channemName = _ref.channemName,
            channemName = _ref$channemName === undefined ? '未获取到渠道信息' : _ref$channemName,
            _ref$internalChannelT = _ref.internalChannelText,
            internalChannelText = _ref$internalChannelT === undefined ? '内部渠道' : _ref$internalChannelT;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TRACKER);

        this.channelId = this.setChannelId(channelId * 1);
        this.channelName = channemName;
        this.platform = Object(__WEBPACK_IMPORTED_MODULE_4__lib_units__["n" /* getPlatform */])();
        this.runtime = 'wechat';
        this.internalChannelText = internalChannelText;
        this.publicZhugeStat = null;
        this.setRuntime();
        console.log('\u57CB\u70B9\u7684\u5E73\u53F0\u662F: ' + this.runtime);
        this.initPublicZhuge();
        this.initZhuge();
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TRACKER, [{
        key: 'initZhuge',
        value: function initZhuge() {
            window.zhuge = window.zhuge || [];
            window.zhuge.methods = "_init debug identify track trackLink trackForm page".split(" ");
            window.zhuge.factory = function (b) {
                return function () {
                    var a = Array.prototype.slice.call(arguments);
                    a.unshift(b);
                    window.zhuge[b.indexOf('init') == -1 ? 'push' : 'unshift'](a); // 由于诸葛io异步加载，命令的调用顺序变为非固定，但是要保证init指令先执行 --@by cyc
                    return window.zhuge;
                };
            };
            for (var i = 0; i < window.zhuge.methods.length; i++) {
                var key = window.zhuge.methods[i];
                window.zhuge[key] = window.zhuge.factory(key);
            }
            window.zhuge.load = function (b, x) {
                if (!document.getElementById("zhuge-js")) {
                    var a = document.createElement("script");
                    var verDate = new Date();
                    var verStr = verDate.getFullYear().toString() + verDate.getMonth().toString() + verDate.getDate().toString();

                    a.type = "text/javascript";
                    a.id = "zhuge-js";
                    a.async = !0;
                    a.src = (location.protocol == 'http:' ? "http://sdk.zhugeio.com/zhuge.min.js?v=" : 'https://zgsdk.zhugeio.com/zhuge.min.js?v=') + verStr;
                    var c = document.getElementsByTagName("script")[0];
                    c.parentNode.insertBefore(a, c);
                    window.zhuge._init(b, x);
                }
            };

            // 异步加载zhugeio
            // 诸葛IO，this app key is use for app
            // 根据 IS_PRODUCTION 开启是否debug，不用每次都进行开关
            // appkey :f6f19cec54894af8990714a597fc09f4
            // m站key：be2579193b754fd2900f660a0093fa62
            // 微站key：954fc7ea2885479cae96792800783191
            var zhugeKey = '954fc7ea2885479cae96792800783191';
            if (this.runtime === 'app') {
                zhugeKey = 'f6f19cec54894af8990714a597fc09f4';
            } else if (this.runtime === 'msite') {
                zhugeKey = 'be2579193b754fd2900f660a0093fa62';
            }

            console.log({ debug: true && __WEBPACK_IMPORTED_MODULE_3__apis__["a" /* default */].env == '' ? false : true }, this.runtime);
            window.zhuge.load(zhugeKey, { debug: true && __WEBPACK_IMPORTED_MODULE_3__apis__["a" /* default */].env == '' ? false : true });
        }
    }, {
        key: 'initPublicZhuge',
        value: function initPublicZhuge() {
            if (this.runtime == "app") {
                this.publicZhugeStat = new __WEBPACK_IMPORTED_MODULE_5__frontend_lib_lib_stat_Stat_js__["a" /* default */]();
            }
        }
    }, {
        key: 'setChannelName',
        value: function setChannelName(name) {
            this.channelName = name;
        }
    }, {
        key: 'setInternalChannel',
        value: function setInternalChannel(state) {
            this.internalChannelText = !!state ? '内部渠道' : '外部部渠道';
        }
    }, {
        key: 'setChannelId',
        value: function setChannelId(id) {
            this.channelId = id;
            if ([513, 514].includes(id)) {
                this.setChannelName(id === 513 ? '壹心理M站' : '壹心理APP');
            }
        }
    }, {
        key: 'setRuntime',
        value: function setRuntime() {
            if (this.platform.isYixinliApp || this.channelId === 514) {
                this.runtime = 'app';
            } else if (!(this.platform.isYixinliApp || this.platform.isWechat) || this.channelId === 513) {
                this.runtime = 'msite';
            }
        }

        // 下面是事件

    }, {
        key: 'indexTestSwiper',
        value: function indexTestSwiper(testName, indexTagType) {
            var eventName = '';
            if (indexTagType == 'new') {
                eventName = '点击最新';
            }
            if (indexTagType == 'hot') {
                eventName = '点击最热';
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '题目名称': testName
            });
        }
    }, {
        key: 'indexBannerClick',
        value: function indexBannerClick(index, testName) {
            zhuge.track('点击焦点图', {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '位置': index + 1,
                '题目名称': testName
            });
        }
    }, {
        key: 'sharePage',
        value: function sharePage(pageName, testName, testId) {
            var eventName = '\u5206\u4EAB';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            var params = {
                '分享内容': pageName,
                '渠道ID': this.channelId,
                '渠道': this.channelName
            };
            if (testName) params['测试名称'] = testName;
            if (testId) params['测试ID'] = testId;
            zhuge.track(eventName, params);
        }
    }, {
        key: 'sortSetType',
        value: function sortSetType(sortType, sortBy) {
            var eventName = '\u8BBF\u95EE\u5206\u7C7B\u9875\u680F\u76EE';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '栏目': sortType,
                '排序方式': sortBy
            });
        }
    }, {
        key: 'sortFilterSwitch',
        value: function sortFilterSwitch(sortType, sortBy) {
            var eventName = '\u5207\u6362\u6392\u5E8F\u65B9\u5F0F';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '栏目': sortType,
                '排序方式': sortBy
            });
        }
    }, {
        key: 'payTest',
        value: function payTest(testName) {
            var eventName = '\u70B9\u51FB\u7ACB\u5373\u652F\u4ED8';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'answerStartTest',
        value: function answerStartTest(testTitle, startFrom) {
            var eventName = '开始测试';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '题目名称': testTitle,
                '开始位置': startFrom
            });
        }
    }, {
        key: 'answerOvertime',
        value: function answerOvertime(testName) {
            var eventName = '超时未完成';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '题目名称': testName
            });
        }
    }, {
        key: 'answerGiveUp',
        value: function answerGiveUp(testName) {
            var eventName = '中途放弃';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '题目名称': testName
            });
        }
    }, {
        key: 'answerProgress',
        value: function answerProgress(testName, progress) {
            var eventName = '新答题情况';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '题目名称': testName,
                '答题进度': progress
            });
        }
    }, {
        key: 'answerSubmit',
        value: function answerSubmit(testName) {
            var eventName = '提交测试';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '题目名称': testName
            });
        }
    }, {
        key: 'reviewReport',
        value: function reviewReport() {
            var eventName = '重复查看报告';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId
            });
        }
    }, {
        key: 'viewSharedReport',
        value: function viewSharedReport(testName) {
            var eventName = '访问报告分享页（无浏览时长）';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '题目名称': testName
            });
        }
    }, {
        key: 'shareReport',
        value: function shareReport(testName) {
            var eventName = '点击报告页分享按钮';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '题目名称': testName
            });
        }
    }, {
        key: 'shareReportinS',
        value: function shareReportinS(testName) {
            var eventName = '点击报告页晒一晒按钮';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '题目名称': testName
            });
        }
    }, {
        key: 'shareReportSuccess',
        value: function shareReportSuccess(testName) {
            var eventName = '报告页分享成功';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '题目名称': testName
            });
        }
    }, {
        key: 'reportSend2Email',
        value: function reportSend2Email(testName) {
            var eventName = '发送报告到邮箱';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '题目名称': testName
            });
        }
    }, {
        key: 'pageView',
        value: function pageView(pageName, fromPage, Options) {
            console.log('\u8BBF\u95EE' + pageName);
            var eventName = '\u8BBF\u95EE' + pageName;
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '页面来源': fromPage
            }, Options));
        }
    }, {
        key: 'pageLeave',
        value: function pageLeave(pageName, toPage, Options) {
            console.log('\u79BB\u5F00' + pageName);
            var eventName = '\u79BB\u5F00' + pageName;
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '前往页面': toPage
            }, Options));
        }
    }, {
        key: 'searchClickSuggest',
        value: function searchClickSuggest(Options) {
            // 点击搜索建议，可能是 关键词 或者 热门搜索
            var eventName = '\u70B9\u51FB\u641C\u7D22\u5EFA\u8BAE';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
                '渠道': this.channelName,
                '渠道ID': this.channelId
            }, Options));
        }
    }, {
        key: 'searchUserWord',
        value: function searchUserWord(word) {
            // 用户搜索【自己输入】的词
            var eventName = '搜索内容';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '关键词': word
            });
        }
    }, {
        key: 'eventViewReport',
        value: function eventViewReport(_ref2) {
            var from = _ref2.from,
                testName = _ref2.testName;

            var eventName = '\u67E5\u770B\u62A5\u544A';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 用户点击查看报告的一刹那
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '题目名称': testName,
                '来源': from
            });
        }
    }, {
        key: 'clickDetailRecomend',
        value: function clickDetailRecomend(_ref3) {
            var toTestName = _ref3.toTestName,
                fromTestName = _ref3.fromTestName;

            // 点击测评详情页的大家都在测
            var eventName = '点击测评详情页-推荐';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '来源题目': fromTestName,
                '访问题目': toTestName
            });
        }
    }, {
        key: 'clickShareRecomend',
        value: function clickShareRecomend(_ref4) {
            var toTestName = _ref4.toTestName,
                fromTestName = _ref4.fromTestName;

            var eventName = '\u70B9\u51FB\u62A5\u544A\u5206\u4EAB\u9875-\u63A8\u8350';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 报告分享页的大家都要测被点击的时候
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '来源题目': fromTestName,
                '访问题目': toTestName
            });
        }
    }, {
        key: 'clickShareMeToo',
        value: function clickShareMeToo(testName) {
            var eventName = '\u70B9\u51FB\u62A5\u544A\u5206\u4EAB\u9875-\u6211\u4E5F\u8981\u6D4B';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 报告分享页的我也要测被点击的时候
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '题目名称': testName
            });
        }
    }, {
        key: 'clickReportRecomend',
        value: function clickReportRecomend(_ref5) {
            var toTestName = _ref5.toTestName,
                fromTestName = _ref5.fromTestName;

            var eventName = '\u70B9\u51FB\u62A5\u544A\u9875-\u63A8\u8350';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 报告页的推荐被点击的时候
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '来源题目': fromTestName,
                '访问题目': toTestName
            });
        }
    }, {
        key: 'mineDotest',
        value: function mineDotest(testName) {
            // 点击我的测评-去测试
            var eventName = '\u70B9\u51FB\u6211\u7684\u6D4B\u8BC4-\u53BB\u6D4B\u8BD5';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '题目名称': testName
            });
        }
    }, {
        key: 'minePublishComment',
        value: function minePublishComment(testName) {
            var eventName = '\u70B9\u51FB\u6211\u7684\u6D4B\u8BC4-\u53D1\u8868\u8BC4\u4EF7';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 点击 我的测评-发表评价
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'commentAnonymous',
        value: function commentAnonymous(_ref6) {
            var testName = _ref6.testName,
                anonymous = _ref6.anonymous;

            var eventName = '\u9009\u62E9\u533F\u540D\u8BC4\u4EF7';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 点击 评价成功-接着评价
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName,
                '是否匿名': !!anonymous ? '是' : '否'
            });
        }
    }, {
        key: 'commentSuccessPublishComment',
        value: function commentSuccessPublishComment(testName) {
            var eventName = '\u70B9\u51FB\u8BC4\u4EF7\u6210\u529F-\u53BB\u8BC4\u4EF7';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 点击 评价成功-接着评价
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'reportPublishComment',
        value: function reportPublishComment(testName) {
            var eventName = '\u70B9\u51FB\u53D1\u8868\u8BC4\u4EF7\u6309\u94AE';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 点击 报告页 发表评价按钮
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'reportViewComment',
        value: function reportViewComment(testName) {
            var eventName = '\u70B9\u51FB\u67E5\u770B\u8BC4\u4EF7\u6309\u94AE';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 点击 报告页 查看评价按钮
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'deleteComment',
        value: function deleteComment(testName) {
            var eventName = '\u5220\u9664\u8BC4\u4EF7';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 点击 查看我的评价页 确认删除评价按钮
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'commentShareScale',
        value: function commentShareScale(testName) {
            var eventName = '\u63A8\u8350\u6D4B\u8BC4\u7ED9\u597D\u53CB';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 评价成功页 推荐测评给好友，分享成功时触发
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'commentSubmitFail',
        value: function commentSubmitFail(testName) {
            var eventName = '\u8BC4\u4EF7\u5931\u8D25';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 评价失败，分享成功时触发
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'detail_viewAllComment',
        value: function detail_viewAllComment(testName) {
            // 详情页-查看全部评论
            var eventName = '\u8BE6\u60C5\u9875-\u67E5\u770B\u5168\u90E8\u8BC4\u8BBA';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'commentSuccess_viewAllComment',
        value: function commentSuccess_viewAllComment(testName) {
            var eventName = '\u8BC4\u4EF7\u6210\u529F-\u67E5\u770B\u5168\u90E8\u8BC4\u8BBA';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 评价成功-查看全部评论
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'commentSuccess_recommendClicked',
        value: function commentSuccess_recommendClicked(testName) {
            var eventName = '\u70B9\u51FB\u53D1\u8868\u6210\u529F\u9875-\u731C\u4F60\u60F3\u6D4B';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 评价成功-查看全部评论
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'detail_clickGift',
        value: function detail_clickGift(testName) {
            // 详情页-点击赠送他人按钮
            var eventName = '\u70B9\u51FB"\u8D60\u9001\u4ED6\u4EBA"\u6309\u94AE';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'gift_paySuccess',
        value: function gift_paySuccess(_ref7) {
            var testName = _ref7.testName,
                buyNUmber = _ref7.buyNUmber;

            // 购买赠礼成功
            var eventName = '\u8D2D\u4E70\u8D60\u793C\u6210\u529F';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            zhuge.track(eventName, {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName,
                '份数': buyNUmber
            });
        }
    }, {
        key: 'gift_shareSuccess',
        value: function gift_shareSuccess(testName) {
            // 赠送好友成功
            zhuge.track('赠送好友成功', {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'gift_click_receiveGift',
        value: function gift_click_receiveGift(testName) {
            // 点击“立即领取”按钮
            zhuge.track('点击“立即领取”按钮', {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'gift_click_startGiftTest',
        value: function gift_click_startGiftTest(testName) {
            // 点击“已领取！开始测试”
            zhuge.track('点击“已领取！开始测试”', {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'gift_click_goShare',
        value: function gift_click_goShare(testName) {
            // 点击“待赠”按钮
            zhuge.track('点击“待赠”按钮”', {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'gift_mine_goTest',
        value: function gift_mine_goTest(testName) {
            // 点击“赠礼管理”-“去测试”
            zhuge.track('点击“赠礼管理”-“去测试”', {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'gift_mine_goReport',
        value: function gift_mine_goReport(testName) {
            // 点击“赠礼管理”-“查看报告”
            zhuge.track('点击“赠礼管理”-“查看报告”', {
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '测评名称': testName
            });
        }
    }, {
        key: 'gift_mine_empty_viewMore',
        value: function gift_mine_empty_viewMore() {
            // 点击“赠礼管理”-“去看看”
            zhuge.track('点击“赠礼管理”-“去看看”', {
                '渠道': this.channelName,
                '渠道ID': this.channelId
            });
        }
    }, {
        key: 'shareReport_Img',
        value: function shareReport_Img(testName) {
            console.log(testName);
            // 点击保存图片事件
            zhuge.track('点击保存图片事件', {
                '渠道ID': this.channelId,
                '渠道': this.channelName,
                '测评名称': testName
            });
        }
    }, {
        key: 'reportADclick',
        value: function reportADclick(testName) {
            var eventName = '\u70B9\u51FB\u62A5\u544A\u9875\u5E7F\u544A';
            if (this.runtime !== 'wechat') {
                eventName = 'v5100_\u6D4B\u8BC4-' + eventName;
            }
            // 点击报告页广告
            zhuge.track(eventName, {
                '渠道ID': this.channelId,
                '渠道': this.channelName,
                '测评名称': testName
            });
        }
    }, {
        key: 'save_Collect',
        value: function save_Collect(name) {
            console.log(name);
            // 点击收藏按钮
            zhuge.track('点击“收藏按”钮', {
                '渠道ID': this.channelId,
                '渠道': this.channelName,
                '测评名称': name
            });
        }
    }, {
        key: 'up_Collect',
        value: function up_Collect(name) {
            console.log(name);
            // 点击取消收藏按钮
            zhuge.track('点击取消收藏按钮', {
                '渠道ID': this.channelId,
                '渠道': this.channelName,
                '测评名称': name
            });
        }
    }, {
        key: 'on_myCollect',
        value: function on_myCollect(name) {
            console.log(name);
            // 我的测评-点击-“收藏”列表
            zhuge.track('我的测评-点击“收藏”列表', {});
        }
    }, {
        key: 'on_mytrack',
        value: function on_mytrack(name) {
            console.log(name);
            // 访问“我的足迹”页
            zhuge.track('访问“我的足迹”页', {
                '渠道ID': this.channelId,
                '渠道': this.channelName
            });
        }
    }, {
        key: 'edit_mytrack',
        value: function edit_mytrack(name) {
            console.log(name);
            // 足迹页-点击“编辑”按钮
            zhuge.track('足迹页-点击“编辑”按钮', {
                '渠道ID': this.channelId,
                '渠道': this.channelName
            });
        }
    }, {
        key: 'del_mytrack',
        value: function del_mytrack(name) {
            console.log(name);
            // 足迹页-点击“删除”按钮
            zhuge.track('足迹页-点击“删除”按钮', {
                '渠道ID': this.channelId,
                '渠道': this.channelName
            });
        }
    }, {
        key: 'all_Sel_mytrack',
        value: function all_Sel_mytrack(name) {
            console.log(name);
            // 足迹页-点击“全选”按钮
            zhuge.track('足迹页-点击“全选”按钮', {
                '渠道ID': this.channelId,
                '渠道': this.channelName
            });
        }
    }, {
        key: 'reportADclick_qingshu',
        value: function reportADclick_qingshu(testName) {
            // 点击报告倾诉业务广告
            zhuge.track("推荐倾诉业务", {
                '渠道ID': this.channelId,
                '渠道': this.channelName,
                '测评名称': testName
            });
        }
        // 测试添加pdf数据

    }, {
        key: 'report_onremoval',
        value: function report_onremoval(name) {
            // 点击报告迁移服务
            zhuge.track('点击报告迁移服务', {
                '测评名称': name
            });
        }
    }, {
        key: 'report_onremoval_pdf',
        value: function report_onremoval_pdf(name) {
            // 点击迁移弹窗-PDF报告
            zhuge.track('点击迁移弹窗-PDF报告', {
                '测评名称': name
            });
        }
    }, {
        key: 'report_commit_pdf',
        value: function report_commit_pdf(name) {
            // 选中迁移弹窗-PDF报告 点击“确认迁移”后统计
            zhuge.track('选中迁移弹窗-PDF报告', {
                '测评名称': name
            });
        }
    }, {
        key: 'report_onremoval_book',
        value: function report_onremoval_book(name) {
            // 点击迁移弹窗-纸质报告
            zhuge.track('点击迁移弹窗-纸质报告', {
                '测评名称': name
            });
        }
    }, {
        key: 'report_commit_book',
        value: function report_commit_book(name) {
            // 选中迁移弹窗-纸质报告 点击“确认迁移”后统计
            zhuge.track('选中迁移弹窗-纸质报告', {
                '测评名称': name
            });
        }
    }, {
        key: 'report_close_email',
        value: function report_close_email(name) {
            // 点击迁移弹窗-关闭弹窗
            zhuge.track('点击迁移弹窗-关闭弹窗', {
                '测评名称': name
            });
        }
    }, {
        key: 'report_on_del',
        value: function report_on_del(name) {
            // 点击迁移弹窗-测后即焚
            zhuge.track('点击迁移弹窗-测后即焚', {
                '测评名称': name
            });
        }
    }, {
        key: 'report_commit_opendel',
        value: function report_commit_opendel(name) {
            // 开启迁移弹窗-测后即焚 点击“确认迁移”后统计
            zhuge.track('开启迁移弹窗-测后即焚', {
                '测评名称': name
            });
        }
    }, {
        key: 'report_commit_del',
        value: function report_commit_del(name) {
            // 关闭迁移弹窗-测后即焚 点击“确认迁移”后统计
            zhuge.track('关闭迁移弹窗-测后即焚', {
                '测评名称': name
            });
        }
    }, {
        key: 'report_commit_email',
        value: function report_commit_email(name) {
            // 点击迁移弹窗-确认迁移
            zhuge.track('点击迁移弹窗-确认迁移', {
                '测评名称': name
            });
        }
    }, {
        key: 'report_send_email',
        value: function report_send_email(name) {
            // 确认发送报告到邮箱
            zhuge.track('确认发送报告到邮箱', {
                '测评名称': name
            });
        }
    }, {
        key: 'onclick_readingReport',
        value: function onclick_readingReport(name) {
            // 点击报告解读按钮
            zhuge.track('点击报告解读按钮', {
                '测评名称': name
            });
        }
    }, {
        key: 'readingReport_callOn',
        value: function readingReport_callOn(name) {
            // 点击接通报告解读师按钮
            zhuge.track('点击接通报告解读师按钮', {
                '测评名称': name
            });
        }
    }, {
        key: 'readingReport_inOk',
        value: function readingReport_inOk(name) {
            // 点击解读繁忙弹窗-好的
            zhuge.track('点击解读繁忙弹窗-好的', {
                '测评名称': name
            });
        }
    }, {
        key: 'goInto_readingReport',
        value: function goInto_readingReport(name) {
            // 访问解读报告页
            zhuge.track('访问解读报告页', {
                '测评名称': name
            });
        }
    }, {
        key: 'leave_readingReport',
        value: function leave_readingReport(initTime, leaveTime, onTime, go, name) {
            // 离开解读报告页  （访问时间，离开时间，浏览时间， 前往页面， 测评名称）
            zhuge.track('点击接通报告解读师按钮', {
                '测评名称': name
            });
        }
        // 双十一定金页面

    }, {
        key: 'go_dingjin_btn',
        value: function go_dingjin_btn() {
            // 点击“预售定金GO”按钮
            zhuge.track('点击“预售定金GO”按钮', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_dingjin_cancel',
        value: function go_dingjin_cancel() {
            // 点击“定金-我再想想”按钮
            zhuge.track('点击“定金-我再想想”按钮', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_dingjin_confrim',
        value: function go_dingjin_confrim() {
            // 点击“定金-确认下单”按钮
            zhuge.track('点击“定金-确认下单”按钮', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_dingjin_getback',
        value: function go_dingjin_getback() {
            // 点击“回到主会场”按钮
            zhuge.track('点击“回到主会场”按钮', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_dingjin_getTest',
        value: function go_dingjin_getTest() {
            // 点击“查看全部测试”按钮
            zhuge.track('点击“查看全部测试”按钮', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_dingjin_suss',
        value: function go_dingjin_suss() {
            // 访问“定金预付成功”页
            zhuge.track('访问“定金预付成功”页', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_into_active11',
        value: function go_into_active11() {
            // 点击双11活动入口
            zhuge.track('点击双11活动入口', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_promotion490_btn',
        value: function go_promotion490_btn() {
            // 点击“4.9季卡-去抢”按钮
            zhuge.track('点击“4.9季卡-去抢”按钮', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_promotion3800_btn',
        value: function go_promotion3800_btn() {
            // 点击“38年卡-去抢”按钮
            zhuge.track('点击“38年卡-去抢”按钮', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_promotion1990_btn',
        value: function go_promotion1990_btn() {
            // 点击“19.9季卡-去抢”按钮
            zhuge.track('点击“19.9季卡-去抢”按钮', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_promotion1_emotion_btn',
        value: function go_promotion1_emotion_btn() {
            // 点击“情感套餐包”按钮
            zhuge.track('点击“情感套餐包”按钮', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_promotion_work_btn',
        value: function go_promotion_work_btn() {
            // 点击“职场套餐包”按钮
            zhuge.track('点击“职场套餐包”按钮', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_promotion_health_btn',
        value: function go_promotion_health_btn() {
            // 点击“健康套餐包”按钮
            zhuge.track('点击“健康套餐包”按钮', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_promotion_all_btn',
        value: function go_promotion_all_btn() {
            // 点击“全部测评”按钮
            zhuge.track('点击“全部测评”按钮', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_promotion_today_pay',
        value: function go_promotion_today_pay(typeName) {
            // 访问“今日必抢-确认付款”弹窗
            zhuge.track('访问“今日必抢-确认付款”弹窗', {
                '渠道名称': this.channelName,
                '券包类型': typeName
            });
        }
    }, {
        key: 'go_promotion_category_pay',
        value: function go_promotion_category_pay() {
            // 访问“品类包-确认付款”弹窗
            zhuge.track('访问“品类包-确认付款”弹窗', {
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'go_promotion_category_payin',
        value: function go_promotion_category_payin(typeName) {
            // 点击“品类包-立即支付”按钮
            zhuge.track('点击“品类包-立即支付”按钮', {
                '渠道名称': this.channelName,
                '券包类型': typeName
            });
        }
    }, {
        key: 'go_promotion_category_phonenum',
        value: function go_promotion_category_phonenum(typeName) {
            // 点击“填写手机号码”
            zhuge.track('点击“填写手机号码”', {
                '渠道名称': this.channelName,
                '券包类型': typeName
            });
        }
    }, {
        key: 'go_promotion_taday_canvalpay',
        value: function go_promotion_taday_canvalpay(typeName) {
            // 点击“今日必抢-确认付款-关闭”按钮
            zhuge.track('点击“今日必抢-确认付款-关闭”按钮', {
                '渠道名称': this.channelName,
                '券包类型': typeName
            });
        }
    }, {
        key: 'go_promotion_category_canvalpay',
        value: function go_promotion_category_canvalpay(typeName) {
            // 套餐包-确认付款-关闭
            zhuge.track('套餐包-确认付款-关闭', {
                '渠道名称': this.channelName,
                '券包类型': typeName
            });
        }

        // 晒一晒需求

    }, {
        key: 'click_show_share',
        value: function click_show_share(name) {
            console.log(name);
            // 晒一晒页面-点击晒一晒心声按钮
            zhuge.track('点击晒一晒-心声按钮', {
                '测评名称': name,
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'click_bg_share',
        value: function click_bg_share(name) {
            console.log(name);
            // 晒一晒页面-点击晒一晒背景按钮
            zhuge.track('点击晒一晒-背景按钮', {
                '测评名称': name,
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'click_challenge_share',
        value: function click_challenge_share(name) {
            console.log(name);
            // 晒一晒页面-点击晒一晒挑战语按钮
            zhuge.track('点击晒一晒-挑战语按钮', {
                '测评名称': name,
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'click_go_share',
        value: function click_go_share(name) {
            console.log(name);
            // 晒一晒页面-点击晒一晒-去晒按钮
            zhuge.track('点击晒一晒-去晒按钮', {
                '测评名称': name,
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'click_vocie_go',
        value: function click_vocie_go(name) {
            // 晒一晒页面-点击落地页-立刻购买按钮
            zhuge.track('点击落地页-立刻购买按钮', {
                '测评名称': name,
                '渠道名称': this.channelName
            });
        }
    }, {
        key: 'vipPageView',
        value: function vipPageView(pageName, fromPage, Options) {
            console.log('\u9AD8\u7AEF\u4EA7\u54C1-\u8BBF\u95EE' + pageName);
            var eventName = '\u8BBF\u95EE' + pageName;
            zhuge.track(eventName, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '页面来源': fromPage
            }, Options));
        }
    }, {
        key: 'newPageView',
        value: function newPageView(activtyName, pageName, Options) {
            console.log(this.channelConfig);
            zhuge.track(activtyName + '-\u9875\u9762\u8BBF\u95EE', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
                '渠道': this.channelName,
                '渠道ID': this.channelId,
                '页面名称': pageName,
                '渠道来源': this.internalChannelText
            }, Options));
        }

        // 抑郁单品点击事件

    }, {
        key: 'depressionClick',
        value: function depressionClick(element) {
            zhuge.track('抑郁单品-点击事件', {
                '点击元素': element,
                '渠道名称': this.channelName,
                '渠道ID': this.channelId
            });
        }

        // 抑郁单品支付事件

    }, {
        key: 'depressionPay',
        value: function depressionPay(type) {
            zhuge.track('抑郁单品-支付事件', {
                '支付类型': type,
                '渠道名称': this.channelName,
                '渠道ID': this.channelId
            });
        }

        // 分享测评社区

    }, {
        key: 'shareCommunity',
        value: function shareCommunity(testId) {
            zhuge.track('测评社区-交互行为', {
                '对象': '一键分享按钮',
                '测评ID': testId,
                '渠道名称': this.channelName,
                '渠道ID': this.channelId
            });
        }

        // 会员升级2020

    }, {
        key: 'vipPageEvent2020',
        value: function vipPageEvent2020(pageName) {
            zhuge.track('会员升级2020--页面访问', {
                '页面名称': pageName,
                '渠道ID': this.channelId,
                '来源域名': location.hostname
            });
        }
    }, {
        key: 'vipInteraction2020',
        value: function vipInteraction2020(target) {
            var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '点击';

            zhuge.track('会员升级2020--交互行为', {
                '行为': behavior,
                '对象': target,
                '被点击的元素文字': text,
                '渠道ID': this.channelId,
                '来源域名': location.hostname
            });
        }
    }, {
        key: 'importCommonConsult',
        value: function importCommonConsult(target) {
            var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '点击';

            if (this.platform.isYixinliApp || this.channelId === 514) {
                // 2021.04.15 配合咨询统一形式导咨询埋点
                this.publicZhugeStat.send({
                    name: '常规导咨询--交互行为',
                    properties: {
                        '行为': behavior,
                        '对象': target,
                        '被点击的元素文字': text,
                        '渠道ID': this.channelId,
                        '来源域名': location.hostname
                    }
                });
            } else {
                zhuge.track('常规导咨询--交互行为', {
                    '行为': behavior,
                    '对象': target,
                    '被点击的元素文字': text,
                    '渠道ID': this.channelId,
                    '来源域名': location.hostname
                });
            }
        }
    }, {
        key: 'vipPageEventSyk',
        value: function vipPageEventSyk(pageName) {
            zhuge.track('生涯卡-页面访问', {
                '页面名称': pageName,
                '渠道ID': this.channelId,
                '来源域名': location.hostname
            });
        }
    }, {
        key: 'importCommonSyk',
        value: function importCommonSyk(target) {
            var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '点击';

            zhuge.track('生涯卡-交互行为', {
                '行为': behavior,
                '对象': target,
                '被点击的元素文字': text,
                '渠道ID': this.channelId,
                '来源域名': location.hostname
            });
        }
    }, {
        key: 'toutiaoClick',
        value: function toutiaoClick(target) {
            var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '点击';

            zhuge.track('抖音小程序--交互行为', {
                '行为': behavior,
                '对象': target,
                '被点击的元素文字': text,
                '渠道ID': this.channelId,
                '来源域名': location.hostname
            });
        }
    }]);

    return TRACKER;
}();



/***/ }),

/***/ "U5ju":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("M6a0");
__webpack_require__("zQR9");
__webpack_require__("+tPU");
__webpack_require__("CXw9");
__webpack_require__("EqBC");
__webpack_require__("jKW+");
module.exports = __webpack_require__("FeBl").Promise;


/***/ }),

/***/ "U6qc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__("Ds5P");
var $find = __webpack_require__("LhTa")(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("RhFG")(KEY);


/***/ }),

/***/ "UJiG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__("y325")('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),

/***/ "UKM+":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "UbU9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("8Uqm");

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),

/***/ "UbXY":
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__("Ds5P");
var toISOString = __webpack_require__("Y7Tz");

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),

/***/ "UtpN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_productOne_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("2lwE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_productOne_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_productOne_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_productOne_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "UuGF":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "V/H1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__("fJSx");
var validate = __webpack_require__("zq/X");
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__("0Rih")(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),

/***/ "V0Yy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/testDefault.021de12.png";

/***/ }),

/***/ "V33R":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__("LF/X"), __webpack_require__("WreF"), __webpack_require__("Bj/7")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),

/***/ "V3l/":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "V3tA":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("R4wc");
module.exports = __webpack_require__("FeBl").Object.assign;


/***/ }),

/***/ "VR0t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/dialog.vue?vue&type=template&id=07cefbd0&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog",on:{"touchmove":function($event){$event.preventDefault();}}},[(_vm.dialog.mask & _vm.show)?_c('myMask'):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"dialogWin"},[(_vm.showClose)?_c('i',{staticClass:"close fs-18",on:{"click":function($event){return _vm.close('close')}}},[_vm._v("×")]):_vm._e(),_vm._v(" "),_vm._t("topIcon"),_vm._v(" "),(_vm.dialog.title.text != '')?_c('div',{staticClass:"title fs-18",style:(_vm.dialog.title.style)},[_vm._v("\n      "+_vm._s(_vm.dialog.title.text)+"\n    ")]):_vm._e(),_vm._v(" "),_vm._t("top"),_vm._v(" "),(_vm.dialog.content.text)?_c('div',{staticClass:"fs-16",class:['content', _vm.dialog.title.text != '' ? '' : 'noTitle'],style:(_vm.dialog.content.style)},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.dialog.content.text)}})]):_vm._e(),_vm._v(" "),_vm._t("content"),_vm._v(" "),_vm._t("bottom"),_vm._v(" "),_c('div',{class:[_vm.tomoreBtn ? 'other-action' : 'action']},_vm._l((_vm.dialog.actions),function(item,index){return _c('div',{key:index,staticClass:"btnCont"},[_c('div',{class:[
            'btn',
            'fs-16',
            item.disabled ? 'disabled' : '',
            item.active ? 'btn--yellow' : '',
            _vm.freeStyleBtn ? '':_vm.QUESTIONS_TYPE != 5  ? 'btn--yellow' : 'btnvip--vip'
          ],on:{"click":function($event){$event.stopPropagation();return item.callBack($event)}}},[_vm._v(_vm._s(item.text))])])}),0)],2)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/common/dialog.vue?vue&type=template&id=07cefbd0&scoped=true&

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/components/common/mask.vue + 2 modules
var mask = __webpack_require__("m423");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/dialog.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var dialogvue_type_script_lang_js_ = ({
  components: {
    myMask: mask["a" /* default */]
  },
  props: {
    propMask: {
      type: Boolean
    },
    propTitle: [String, Object],
    propContent: {
      type: [String, Object]
    },
    propActions: {
      type: Array
    },
    propTime: Number,
    showClose: {
      type: Boolean,
      default: true
    },
    propSlot: {
      type: Boolean,
      default: false
    },
    freeStyleBtn: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      mask: true,
      title: '',
      content: '',
      actions: [],
      show: false
    };
  },
  mounted: function mounted() {
    //            console.log(this.propActions[0].callBack);
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['QUESTIONS_TYPE']), {
    dialog: function dialog() {
      var that = this;
      var rs = {
        title: {},
        content: {},
        actions: []
      };
      rs.mask = that.propMask != undefined ? that.propMask : that.$data.mask;
      if (that.propTitle != undefined) {
        if (typeof that.propTitle == 'string') {
          rs.title.text = that.propTitle != '' ? that.propTitle : '';
        } else {
          rs.title.text = that.propTitle.text != undefined ? that.propTitle.text : '';
          rs.title.style = that.propTitle.style;
        }
      }

      if (!!that.propContent) {
        if (typeof that.propContent == 'string') {
          rs.content.text = that.propContent;
          that.$data.show = true;
        } else {
          rs.content.text = that.propContent.text;
          rs.content.style = that.propContent.style;
          that.$data.show = true;
        }
      } else if (that.propSlot) {
        that.$data.show = true;
      }

      if (that.propActions != undefined) {
        if (that.propActions.length > 0) {
          var _loop = function _loop(i) {
            var temp = {};
            temp.text = that.propActions[i].text != undefined ? that.propActions[i].text + '' : '按钮' + i;
            temp.active = that.propActions[i].active != undefined ? that.propActions[i].active : false;
            temp.disabled = that.propActions[i].disabled != undefined ? that.propActions[i].disabled : false;
            if (that.propActions[i].callBack != undefined) {
              temp.callBack = function () {
                if (temp.disabled) {
                  return false;
                }
                that.propActions[i].callBack();
                that.close();
              };
            } else {
              temp.callBack = function () {
                that.close();
              };
            }
            rs.actions.push(temp);
          };

          for (var i = 0; i < that.propActions.length; i++) {
            _loop(i);
          }
        } else {
          var _temp = {};
          _temp.text = '关闭';
          _temp.callBack = that.close;
          rs.actions.push(_temp);
        }
      } else {
        var _temp2 = {};
        _temp2.text = '关闭';
        _temp2.callBack = that.close;
        rs.actions.push(_temp2);
      }
      return rs;
    },
    tomoreBtn: function tomoreBtn() {
      if (this.dialog.actions.length > 2) {
        return true;
      } else {
        return false;
      }
    }
  }),
  methods: {
    close: function close(type) {
      this.show = false;
      this.actions = [];
      this.title = '';
      this.content = '';
      if (type) {
        this.$emit('myDialogClose', true);
      } else {
        this.$emit('myDialogClose');
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/common/dialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var common_dialogvue_type_script_lang_js_ = (dialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/common/dialog.vue?vue&type=style&index=0&id=07cefbd0&lang=scss&scoped=true&
var dialogvue_type_style_index_0_id_07cefbd0_lang_scss_scoped_true_ = __webpack_require__("nd4N");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/common/dialog.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  common_dialogvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "07cefbd0",
  null
  
)

/* harmony default export */ var dialog = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "VTn2":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__("UKM+");
var meta = __webpack_require__("1aA0").onFreeze;

__webpack_require__("3i66")('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),

/***/ "VWgF":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("7gX0");
var global = __webpack_require__("OzIq");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("V3l/") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "Vg1y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("Jbuy");
var redefine = __webpack_require__("R3AP");
var hide = __webpack_require__("2p1q");
var fails = __webpack_require__("zgIt");
var defined = __webpack_require__("/whu");
var wks = __webpack_require__("kkCw");
var regexpExec = __webpack_require__("32VL");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "VjuZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("DIVP");
var toObject = __webpack_require__("FryR");
var toLength = __webpack_require__("BbyF");
var toInteger = __webpack_require__("oeih");
var advanceStringIndex = __webpack_require__("TwzQ");
var regExpExec = __webpack_require__("9Dx1");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("Vg1y")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "W/IU":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__("UKM+");
var meta = __webpack_require__("1aA0").onFreeze;

__webpack_require__("3i66")('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),

/***/ "W0pi":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),

/***/ "W2nU":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "W4Z6":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("FryR");
var $getPrototypeOf = __webpack_require__("KOrd");

__webpack_require__("3i66")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "W6XS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_footerNav_vue_vue_type_style_index_0_id_c8aaa7ae_lang_scss_scoped_true___ = __webpack_require__("HXil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_footerNav_vue_vue_type_style_index_0_id_c8aaa7ae_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_footerNav_vue_vue_type_style_index_0_id_c8aaa7ae_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_footerNav_vue_vue_type_style_index_0_id_c8aaa7ae_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "WBcL":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "WPNh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_matchingEntrance_vue_vue_type_style_index_0_id_6b86ba56_lang_scss_scoped_true___ = __webpack_require__("Lmjj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_matchingEntrance_vue_vue_type_style_index_0_id_6b86ba56_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_matchingEntrance_vue_vue_type_style_index_0_id_6b86ba56_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_matchingEntrance_vue_vue_type_style_index_0_id_6b86ba56_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "WY8G":
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),

/***/ "WcO1":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("ReGu");
var hiddenKeys = __webpack_require__("QKXm").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "Wck+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-mbti-random2.5fcdd25.jpg";

/***/ }),

/***/ "WgSQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("RhFG");
var step = __webpack_require__("KB1o");
var Iterators = __webpack_require__("bN1p");
var toIObject = __webpack_require__("PHqh");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("uc2A")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "WhbY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function getScrollTop() {
	// 试过了IOS和红米都有document.body.scrollTop，所以其他都不要了
	var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
	return scrollTop;
}
/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			limit: 0, // 防抖参数
			touchStart: {
				timeStamp: ''
			},
			touchEnd: {
				timeStamp: ''
			}
		};
	},
	mounted: function mounted() {
		this.scrollControllerInit();
	},
	beforeDestroy: function beforeDestroy() {
		this.scrollControllerDestory();
		this.showFixedbBox(false);
	},
	deactivated: function deactivated() {
		this.scrollControllerDestory();
		this.showFixedbBox(false);
	},

	methods: {
		scrollControllerInit: function scrollControllerInit() {
			window.addEventListener('scroll', this.scrollHandler);
			// window.addEventListener('touchstart', this.touchSHandler);
			// window.addEventListener('touchend', this.touchEHandler);
		},
		scrollHandler: function scrollHandler() {
			var st = getScrollTop();
			var nowTime = new Date().getTime();
			if (!this.scrollHandlerStartTime) {
				this.scrollHandlerStartTime = nowTime;
			}
			if (nowTime - this.scrollHandlerStartTime < 200) {
				return;
			}
			if (!this.scrollHandlerStart) {
				this.scrollHandlerStart = st;
				return;
			}
			// 小于80直接显示，或者对比前后滚动位置
			var hide = st < 80 ? false : st > this.scrollHandlerStart;
			if (hide) {
				this.showFixedbBox(false);
			} else {
				this.showFixedbBox(true);
			}
			this.scrollHandlerStart = st;
			this.scrollHandlerStartTime = nowTime;
		},
		touchSHandler: function touchSHandler(e) {
			this.touchStart.point = e.changedTouches[0];
			this.touchStart.timeStamp = new Date();
		},
		touchEHandler: function touchEHandler(e) {
			this.touchEnd.point = e.changedTouches[0];
			this.touchEnd.timeStamp = new Date();
			if (this.touchEnd.timeStamp - this.touchStart.timeStamp > 200) {
				// 时间要求大于300ms，避免是tap
				var x = Math.abs(this.touchEnd.point.clientX - this.touchStart.point.clientX);
				var y = Math.abs(this.touchEnd.point.clientY - this.touchStart.point.clientY);

				var distance = Math.sqrt(x * x + y * y);
				if (distance < 80) {
					this.showFixedbBox(true);
				}
			}
		},
		scrollControllerDestory: function scrollControllerDestory() {
			window.removeEventListener('scroll', this.scrollHandler);
			// window.removeEventListener('touchstart', this.touchSHandler);
			// window.removeEventListener('touchend', this.touchEHandler);
		}
	}
});

/***/ }),

/***/ "WiIn":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),

/***/ "WpPb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__("UKM+");

__webpack_require__("3i66")('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),

/***/ "WpTh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__("Ds5P");
var $find = __webpack_require__("LhTa")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("RhFG")(KEY);


/***/ }),

/***/ "WreF":
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;


/***/ }),

/***/ "Wwne":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("r2E/");
module.exports = __webpack_require__("7gX0").RegExp.escape;


/***/ }),

/***/ "X/Hz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__("y325")('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),

/***/ "X6NR":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),

/***/ "X7aK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__("Ds5P");
var anObject = __webpack_require__("DIVP");
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__("IRJ3")(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),

/***/ "X8DO":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "XDDC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XMHg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/testItem.vue?vue&type=template&id=11b3e96f&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.item.spike,_vm.iscollect?'testListItem_collect testListItem':'testListItem',_vm.isNoBorder?'testitem-noborder':''],attrs:{"id":_vm.item.scalePoolId}},[_c('div',{staticClass:"cpInfo"},[_c('div',{staticClass:"cpInfo-text"},[_c('h1',{staticClass:"title fs-16"},[_vm._v(_vm._s(_vm.switchTitle?_vm.myDesc:_vm.myTitle))]),_vm._v(" "),(_vm.showCategory)?_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.switchTitle?_vm.myTitle: _vm.myDesc))]):_vm._e(),_vm._v(" "),_c('div',{class:{'pieces':_vm.showCategory,'pieces-mine':!_vm.showCategory}},[(!_vm.TOUTIAOAPP && _vm.priceVisible)?_c('span',{class:['discount', 'fs-14', !!_vm.item.viewPromotionStyle? 'promotion': '']},[_vm._v("¥"+_vm._s(_vm.item.discountPrice))]):_vm._e(),_vm._v(" "),(_vm.showBtn)?_c('object',[(_vm.item.state == undefined)?_c('a',{staticClass:"buyBtn",attrs:{"href":"javascript:;"},on:{"tap":function($event){return _vm.goBuy(_vm.item.pay_href)}}},[_vm._v(_vm._s(_vm.btnText))]):_vm._e(),_vm._v(" "),(_vm.item.state*1==1)?_c('a',{staticClass:"buyBtn red"},[_vm._v("查看报告")]):_vm._e(),_vm._v(" "),(_vm.item.state*1==0)?_c('a',{staticClass:"buyBtn green"},[_vm._v("去测试")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.showBuyPeople && _vm.item.count)?_c('span',{staticClass:"tested"},[_vm._v(_vm._s(_vm.cutNum(_vm.item.count, 4))+"人已测")]):_vm._e()]),_vm._v(" "),(!_vm.showCategory)?_c('div',{staticClass:"cpSummary"},[(_vm.item.state*1==1)?_c('span',{staticClass:"date"},[_vm._v("完成时间："+_vm._s(_vm.timeTransform(_vm.item.completeTime)))]):_vm._e(),_vm._v(" "),(_vm.item.state*1==0)?_c('span',{staticClass:"date"},[_vm._v("购买时间："+_vm._s(_vm.timeTransform(_vm.item.buyTime)))]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.showCategory)?_c('mineTestOrderNum',{attrs:{"propOrderNum":_vm.item.orderNo}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"cpInfo-img"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.item.introPicture),expression:"item.introPicture"}],key:_vm.item.img_url,attrs:{"src":__webpack_require__("V0Yy")}}),_vm._v(" "),(!!_vm.item.viewPromotionStyle)?_c('div',{staticClass:"promotion-brand"}):_vm._e(),_vm._v(" "),((!_vm.isOldVip || _vm.item.vipBuyType !== 2) && !_vm.isHideVipEntrance)?_c('i',{staticClass:"vip-sign",class:{'is-half': _vm.item.vipBuyType === 1}}):_vm._e()])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/common/testItem.vue?vue&type=template&id=11b3e96f&scoped=true&

// EXTERNAL MODULE: ./src/components/show/mine/mineTestOrderNum.vue + 4 modules
var mineTestOrderNum = __webpack_require__("Yq/6");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/testItem.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var testItemvue_type_script_lang_js_ = ({
    name: 'indexListItem',
    props: {
        showBtn: {
            required: false,
            default: false,
            type: Boolean
        },
        showBuyPeople: {
            required: false,
            default: true,
            type: Boolean
        },
        item: {
            required: true,
            type: Object
        },
        btnText: {
            required: false,
            type: String,
            default: '立即购买'
        },
        showCategory: {
            required: false,
            type: Boolean,
            default: true
        },
        switchTitle: {
            required: false,
            type: Boolean,
            default: false
        },
        iscollect: {
            required: false,
            type: Boolean,
            default: false
        },
        isNoBorder: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    components: {
        mineTestOrderNum: mineTestOrderNum["a" /* default */]
    },
    computed: {
        myTitle: function myTitle() {
            // 不是我的测评调用
            if (this.item.state == undefined) {
                return this.item.shortDescribe;
            } else {
                return this.item.name;
            }
        },
        myDesc: function myDesc() {
            // 不是我的测评调用
            if (this.item.state == undefined) {
                return this.item.name;
            } else {
                return this.item.shortDescribe;
            }
        },
        priceVisible: function priceVisible() {
            return !(this.isHpnk && +this.item.discountPrice === 0);
        }
    },
    methods: {
        cutNum: function cutNum(num) {
            var leval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

            // 因为返回裁剪后的都是以万为单位，所以规定最少是10的4次幂;
            var standard = Math.pow(10, leval > 4 ? leval : 4);
            if (num > standard) {
                // 虽然level不同，但是最后返回的都要多少多少W人为单位
                return (num / 10000).toFixed(1) + 'W';
            } else {
                return num;
            }
        },
        timeTransform: function timeTransform(time) {
            var myTime = new Date(time);
            return myTime.getFullYear() + '\u5E74' + (myTime.getMonth() + 1) + '\u6708' + myTime.getDate() + '\u65E5' + myTime.getHours() + ':' + myTime.getMinutes() + ':' + myTime.getSeconds();
        }
    }
});
// CONCATENATED MODULE: ./src/components/common/testItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var common_testItemvue_type_script_lang_js_ = (testItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/common/testItem.vue?vue&type=style&index=0&id=11b3e96f&lang=scss&scoped=true&
var testItemvue_type_style_index_0_id_11b3e96f_lang_scss_scoped_true_ = __webpack_require__("Z8KK");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/common/testItem.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  common_testItemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "11b3e96f",
  null
  
)

/* harmony default export */ var testItem = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "XO1R":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("ydD5");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "XSOZ":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "XXBo":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__("wC1N");
var from = __webpack_require__("QG7u");
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ "XXhe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_imgDialog_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("1g80");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_imgDialog_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_imgDialog_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_imgDialog_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "Xc4G":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("lktj");
var gOPS = __webpack_require__("1kS7");
var pIE = __webpack_require__("NpIQ");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "Xduv":
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "XgCd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),

/***/ "XmWM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("KCLY");
var utils = __webpack_require__("cGG2");
var InterceptorManager = __webpack_require__("fuGk");
var dispatchRequest = __webpack_require__("xLtR");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "XtiL":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Number', { isInteger: __webpack_require__("n982") });


/***/ }),

/***/ "XvUs":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("DIVP");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "Xxa5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("1H6C");


/***/ }),

/***/ "Y/LA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("wI4N");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ "Y1N3":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "Y1S0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__("Ds5P");
var toLength = __webpack_require__("BbyF");
var context = __webpack_require__("kqpo");
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__("1ETD")(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ "Y1aA":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "Y5ex":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__("UKM+");
var meta = __webpack_require__("1aA0").onFreeze;

__webpack_require__("3i66")('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),

/***/ "Y7Tz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__("zgIt");
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),

/***/ "YCU4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_couponLogo_vue_vue_type_style_index_0_id_678e1042_scoped_true_lang_scss___ = __webpack_require__("KQfO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_couponLogo_vue_vue_type_style_index_0_id_678e1042_scoped_true_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_couponLogo_vue_vue_type_style_index_0_id_678e1042_scoped_true_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_couponLogo_vue_vue_type_style_index_0_id_678e1042_scoped_true_lang_scss____default.a); 

/***/ }),

/***/ "YRLd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YTdK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("wI4N");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "YUr7":
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__("WcO1");
var gOPS = __webpack_require__("Y1N3");
var anObject = __webpack_require__("DIVP");
var Reflect = __webpack_require__("OzIq").Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),

/***/ "YVn/":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("Ds5P");
var $values = __webpack_require__("lKE8")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ "YdLG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/toSort.vue?vue&type=template&id=6b340526&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toSort"},[_c('v-touch',{staticClass:"fs-14",attrs:{"tag":"a"},on:{"tap":_vm._tap}},[_vm._v(_vm._s(_vm.propText))])],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/show/toSort.vue?vue&type=template&id=6b340526&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/toSort.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/* harmony default export */ var toSortvue_type_script_lang_js_ = ({
    name: 'indexToSort',
    props: {
        propText: {
            type: String,
            default: '查看全部测评'
        }
    },
    methods: {
        _tap: function _tap() {
            this.$emit('viewMoreSort');
        }
    }
});
// CONCATENATED MODULE: ./src/components/show/toSort.vue?vue&type=script&lang=js&
 /* harmony default export */ var show_toSortvue_type_script_lang_js_ = (toSortvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/show/toSort.vue?vue&type=style&index=0&id=6b340526&lang=scss&scoped=true&
var toSortvue_type_style_index_0_id_6b340526_lang_scss_scoped_true_ = __webpack_require__("uMWd");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/show/toSort.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  show_toSortvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "6b340526",
  null
  
)

/* harmony default export */ var toSort = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "Ygg6":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__("iKpr")('Set');


/***/ }),

/***/ "YhzP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/couponTips-boxshare.3d437f9.png";

/***/ }),

/***/ "Ymdd":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");
var defined = __webpack_require__("/whu");
var fails = __webpack_require__("zgIt");
var spaces = __webpack_require__("Xduv");
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),

/***/ "Yobk":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("77Pl");
var dPs = __webpack_require__("qio6");
var enumBugKeys = __webpack_require__("xnc9");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("ON07")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("RPLV").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "Yq/6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/mine/mineTestOrderNum.vue?vue&type=template&id=add56cf4&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.propOrderNum != ''),expression:"propOrderNum != ''"}],staticClass:"mineTest-foot__orderNum flex flex--middle"},[_c('span',{staticClass:"orderId flex__item"},[_c('div',{staticClass:"wrapper"},[_c('span',{staticClass:"text"},[_vm._v("订单编号：")]),_vm._v(_vm._s(_vm.propOrderNum))])]),_vm._v(" "),_c('button',{ref:"copyBtn",staticClass:"copyTip",attrs:{"id":"copyTip","data-clipboard-text":_vm.propOrderNum+''}},[_vm._v("复制\n    ")])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/show/mine/mineTestOrderNum.vue?vue&type=template&id=add56cf4&

// EXTERNAL MODULE: ./node_modules/clipboard/lib/clipboard.js
var lib_clipboard = __webpack_require__("V33R");
var clipboard_default = /*#__PURE__*/__webpack_require__.n(lib_clipboard);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/mine/mineTestOrderNum.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var mineTestOrderNumvue_type_script_lang_js_ = ({
    name: 'mineTestFooter',
    props: {
        propOrderNum: {
            required: true,
            type: [String, Number],
            default: ''
        }
    },
    mounted: function mounted() {
        var that = this;
        that.initCopy();
    },

    methods: {
        initCopy: function initCopy() {
            var that = this;
            that.$nextTick(function () {
                var clipboard = new clipboard_default.a(that.$refs.copyBtn);
                clipboard.on('success', function (e) {
                    e.trigger.innerText = '已复制';
                    e.clearSelection();
                    setTimeout(function () {
                        e.trigger.innerText = '复制';
                    }, 1000);
                });
            });
        }
    }
});
// CONCATENATED MODULE: ./src/components/show/mine/mineTestOrderNum.vue?vue&type=script&lang=js&
 /* harmony default export */ var mine_mineTestOrderNumvue_type_script_lang_js_ = (mineTestOrderNumvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/show/mine/mineTestOrderNum.vue?vue&type=style&index=0&lang=scss&
var mineTestOrderNumvue_type_style_index_0_lang_scss_ = __webpack_require__("arfw");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/show/mine/mineTestOrderNum.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mine_mineTestOrderNumvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mineTestOrderNum = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "Z8KK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_testItem_vue_vue_type_style_index_0_id_11b3e96f_lang_scss_scoped_true___ = __webpack_require__("IrU9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_testItem_vue_vue_type_style_index_0_id_11b3e96f_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_testItem_vue_vue_type_style_index_0_id_11b3e96f_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_testItem_vue_vue_type_style_index_0_id_11b3e96f_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "ZDXm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("OzIq");
var each = __webpack_require__("LhTa")(0);
var redefine = __webpack_require__("R3AP");
var meta = __webpack_require__("1aA0");
var assign = __webpack_require__("oYd7");
var weak = __webpack_require__("fJSx");
var isObject = __webpack_require__("UKM+");
var validate = __webpack_require__("zq/X");
var NATIVE_WEAK_MAP = __webpack_require__("zq/X");
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__("0Rih")(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),

/***/ "ZE5A":
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__("Jssu");

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),

/***/ "ZNTr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
		return false;
	}
	if (_typeof(Symbol.iterator) === 'symbol') {
		return true;
	}

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') {
		return false;
	}

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
		return false;
	}
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
		return false;
	}

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) {
		return false;
	} // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
		return false;
	}

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
		return false;
	}

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) {
		return false;
	}

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
		return false;
	}

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) {
			return false;
		}
	}

	return true;
};

/***/ }),

/***/ "ZQsr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var env = location.host.split('.')[0].match(/(qc|box)\d?/g);
var spell = !!env ? env.length > 0 ? '-' + env[0] : '' : '';
var WXDOMAIN = '//wx' + spell + '.xinli001.com/',
    LXDOMAIN = spell ? '//lingxi' + spell + '.xinli001.com/lingxi/service/' : '//m-lingxi' + spell + '.xinli001.com/lingxi/service/',
    YIAPI = '//yiapi' + spell + '.xinli001.com/v5/yi/',
    APIS = {
  // 导入此刻接口 
  lifeCardCardList: LXDOMAIN + 'consult/getOrgId', //获取生涯卡列表
  fecthNotCompleteCount: LXDOMAIN + 'consult/notCompleteCount' //获取生涯卡列表
};

/* harmony default export */ __webpack_exports__["a"] = (APIS);

/***/ }),

/***/ "ZRJK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var $fails = __webpack_require__("zgIt");
var aNumberValue = __webpack_require__("fS0v");
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),

/***/ "ZS9F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = pick;
/* harmony export (immutable) */ __webpack_exports__["a"] = omit;
/* unused harmony export uniq */
/* unused harmony export sortByRule */
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// 提取obj里面的
// lodash.pick的代替品
function pick(obj, keys) {
  // eslint-disable-line
  return keys.reduce(function (result, key) {
    if (obj[key]) {
      result[key] = obj[key];
    }
    return result;
  }, {});
}

// lodash.omit的代替品
function omit(obj, keys) {
  var result = {},
      key;

  for (key in obj) {
    if (keys.indexOf(key) == -1) result[key] = obj[key];
  }

  return result;
}

function uniq(list, key) {
  var _map = {};
  var list_temp = [].concat(_toConsumableArray(list));

  for (var i = 0; i < list_temp.length; i++) {
    var match = list_temp[i][key];

    if (_map[match]) {
      list_temp.splice(i, 1, '');
    }

    _map[match] = true;
  }

  return list_temp.filter(function (v) {
    return !!v;
  });
}

var sortByRule = function sortByRule(list, key, rule) {
  if (!Array.isArray(list) || !Array.isArray(rule)) return;
  var result = [];
  rule.map(function (ret) {
    result.push.apply(result, _toConsumableArray(list.filter(function (v) {
      return v[key] === ret;
    })));
  });
  result.push.apply(result, _toConsumableArray(list.filter(function (v) {
    return !v[key] || rule.indexOf(v[key]) === -1;
  })));
  return result;
};

/***/ }),

/***/ "ZUuQ":
/***/ (function(module, exports) {

(function () {
  var base64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
      crypt = {
    // Bit-wise rotation left
    rotl: function rotl(n, b) {
      return n << b | n >>> 32 - b;
    },

    // Bit-wise rotation right
    rotr: function rotr(n, b) {
      return n << 32 - b | n >>> b;
    },

    // Swap big-endian to little-endian and vice versa
    endian: function endian(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++) {
        n[i] = crypt.endian(n[i]);
      }return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function randomBytes(n) {
      for (var bytes = []; n > 0; n--) {
        bytes.push(Math.floor(Math.random() * 256));
      }return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function bytesToWords(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8) {
        words[b >>> 5] |= bytes[i] << 24 - b % 32;
      }return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function wordsToBytes(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8) {
        bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
      }return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function bytesToHex(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function hexToBytes(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2) {
        bytes.push(parseInt(hex.substr(c, 2), 16));
      }return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function bytesToBase64(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
        for (var j = 0; j < 4; j++) {
          if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));else base64.push('=');
        }
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function base64ToBytes(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();

/***/ }),

/***/ "Zrlr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "Zt1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/frontend-lib/tools/getPlatform.js
var getPlatform = __webpack_require__("hTeI");
var getPlatform_default = /*#__PURE__*/__webpack_require__.n(getPlatform);

// EXTERNAL MODULE: ./src/frontend-lib/lib/Bridge.js
var Bridge = __webpack_require__("wlTy");

// EXTERNAL MODULE: ./src/frontend-lib/tools/platformSign.js
var platformSign = __webpack_require__("GDq+");

// EXTERNAL MODULE: ./src/frontend-lib/node_modules/axios/index.js
var axios = __webpack_require__("k/xo");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/frontend-lib/component/wxToAPP/appCommand.js




var $http = axios_default.a.create();
function getRunTime(str) {
  return str;

  // let result
  // let _href = location.href.split('.')[0]
  // _href.replace(/-((box|qc)[0-9]*)/, (s, v) => {
  //   result = str.replace(/\./, `-${v}.`)
  // })
  //
  // if (!result) {
  //   result = str
  // }
  // return result
}

function linkToAppStore(params) {
  var UA = navigator.userAgent;
  var IS_IOS = /(iPhone|iPad|iPod|iOS)/i.test(UA);

  if (IS_IOS) {
    window.location.href = params.errIosUrl || 'https://itunes.apple.com/app/apple-store/id994051627?pt=1667142&ct=m5&mt=8';
  } else {
    window.location.href = params.errAndroidUrl || 'https://m.xinli001.com/download?utm_source=' + utmSource;
  }
}
function copyStr(str) {
  return new Promise(function (resolve) {
    var selection = window.getSelection();
    var range = document.createRange();
    var $code = document.createElement('div');
    $code.display = 'none';
    $code.innerHTML = str;
    document.body.appendChild($code);

    range.selectNodeContents($code);
    selection.removeAllRanges();
    selection.addRange(range);

    document.execCommand('copy');
    selection = null;
    range = null;
    document.body.removeChild($code);
    resolve(true);
  });
}

function handleCopyAndToApp(params, toAPP) {
  /* params = {
              object_id: '' ,//业务id,比如文章id
              title: '', //标题
              desc: '', //	描述
              url: ``, // 访问链接或协议
              type: '' // 业务类型 允许值: "article", "qa", "ceping", "lesson", "meditation", "fm", "act", "summit", "identity"
          }*/
  getCommandRequest(params).then(function (res) {
    if (res) {
      copyStr(res).then(function () {
        if (toAPP) {
          linkToAppStore(params);
        }
      });
    } else {
      if (toAPP) {
        linkToAppStore(params);
      }
    }
  });
}
var utmSource = '';
function getCommandRequest() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$_version = _ref._version,
      _version = _ref$_version === undefined ? '6.7.7' : _ref$_version,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? '' : _ref$type,
      _ref$object_id = _ref.object_id,
      object_id = _ref$object_id === undefined ? '' : _ref$object_id,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      _ref$desc = _ref.desc,
      desc = _ref$desc === undefined ? '' : _ref$desc,
      _ref$url = _ref.url,
      url = _ref$url === undefined ? '' : _ref$url,
      _ref$utm_source = _ref.utm_source,
      utm_source = _ref$utm_source === undefined ? '' : _ref$utm_source,
      _ref$errIosUrl = _ref.errIosUrl,
      errIosUrl = _ref$errIosUrl === undefined ? '' : _ref$errIosUrl,
      _ref$errAndroidUrl = _ref.errAndroidUrl,
      errAndroidUrl = _ref$errAndroidUrl === undefined ? '' : _ref$errAndroidUrl;

  var platform = Object(getPlatform["getPlatform"])();
  var $platform = 'm';
  if (platform.isAndroid) {
    $platform = 'android';
  } else if (platform.isiPhone || platform.isiPad) {
    $platform = 'ios';
  } else if (platform.isPc) {
    $platform = 'pc';
  }
  if (platform.isYixinliApp) return;
  return new Promise(function (resolve, reject) {
    var baseParams = {
      _platform: $platform,
      _version: _version,
      type: type,
      object_id: object_id,
      title: title,
      desc: desc,
      url: url
    };
    var platFormSign = Object(platformSign["a" /* getRequestSign */])(baseParams);
    var newParams = Object.assign(platFormSign.params, {
      sign: platFormSign.sign
    });
    var yiapiHost = getRunTime('//yiapi.xinli001.com');
    $http.get(yiapiHost + '/v6/yi/common/create-encode-command.json', {
      params: newParams
    }).then(function (res) {
      utmSource = utm_source;
      console.log('res', res);
      if (+res.data.code === 0) {
        resolve(res.data.data);
      } else {
        linkToAppStore({ errIosUrl: errIosUrl, errAndroidUrl: errAndroidUrl });
        reject();
      }
    });
  });
}

function getShortUrl() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$_version = _ref2._version,
      _version = _ref2$_version === undefined ? '6.7.7' : _ref2$_version,
      _ref2$remark = _ref2.remark,
      remark = _ref2$remark === undefined ? '' : _ref2$remark,
      _ref2$long_url = _ref2.long_url,
      long_url = _ref2$long_url === undefined ? '' : _ref2$long_url;

  var platform = Object(getPlatform["getPlatform"])();
  var $platform = 'm';
  if (platform.isAndroid) {
    $platform = 'android';
  } else if (platform.isiPhone || platform.isiPad) {
    $platform = 'ios';
  } else if (platform.isPc) {
    $platform = 'pc';
  }
  return new Promise(function (resolve, reject) {
    var baseParams = {
      _platform: $platform,
      _version: _version,
      remark: remark,
      long_url: long_url,
      token: ''
    };
    var platFormSign = Object(platformSign["a" /* getRequestSign */])(baseParams);
    var newParams = Object.assign(platFormSign.params, {
      sign: platFormSign.sign
    });
    var yiapiHost = getRunTime('//yiapi.xinli001.com');
    $http.post(yiapiHost + '/v7/yi/short-url-generate.json', newParams).then(function (res) {
      console.log('res', res);
      if (+res.data.code === 0 || +res.data.code === 20002) {
        resolve(res.data.data);
      } else {
        reject();
      }
    });
  });
}
// EXTERNAL MODULE: ./src/frontend-lib/lib/base64.js
var base64 = __webpack_require__("9uvj");
var base64_default = /*#__PURE__*/__webpack_require__.n(base64);

// CONCATENATED MODULE: ./src/frontend-lib/tools/utils.js
/* unused harmony export wxConfigOrigin */
/* unused harmony export updateOrDownLoadApp */
/* unused harmony export goApp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetQueryString; });
/* unused harmony export throttle */
/* unused harmony export loadScript */
/* unused harmony export getScrollTop */
/* unused harmony export setScrollTop */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return debounce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return versionfunegt; });
/* unused harmony export handleExpiresStorage */
/* unused harmony export secondCounter */
/* unused harmony export secondToTime */
/* unused harmony export isCanHideNavigationBar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return utils_getStatusBarHeight; });
/* unused harmony export isDangerUrl */
/* unused harmony export chunkArray */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utils_getRunTime; });
/* unused harmony export updateQueryStringParameter */
/* unused harmony export addQueryToUrl */
/* unused harmony export dateFormater */
/* unused harmony export isBase64 */
/* unused harmony export decodeUrlQuery */
var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






/**
 * 微信下获取危险域名，非微信环境获取正常域名
 * @param {JSON} json 配置文件内容
 * @param {String} origin  获取哪个业务的域名，支持'MEDI'|'medi_origin'
 * @param {String} str 获取warn|safe|risk的类型，支持'm'|'m_warn' 默认使用_warn类型，
 * @param {String} wechat 默认只有微信下才用危险域名，设置为false即不管是不是微信都使用危险域名
 * @param {String} protocol 重新设定协议
 * @returns {String} 获取的域名,若匹配不到，return location.origin
 */

var utils_wxConfigOrigin = function wxConfigOrigin(json, origin, str) {
  var wechat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var protocol = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window.location.protocol;

  var originUpper = origin.toUpperCase();
  if (!/_ORIGIN$/.test(originUpper)) {
    originUpper += '_ORIGIN';
  }

  var className = '_warn',
      typeName = str;
  if (/_(warn|safe|risk)$/.test(str)) {
    var index = str.lastIndexOf('_');
    typeName = str.substring(index, 0);
    className = str.substr(index);
  }
  var platform = Object(getPlatform["getPlatform"])();
  if (!platform.isWechat && wechat) {
    className = '_safe';
  }
  json = json['domain'][originUpper];
  if (json && json[typeName + className]) {
    return protocol + '//' + json[typeName + className];
  } else {
    throw new Error("wxConfigOrigin:Can't match any origin with " + origin + str);
  }
};
/*
 * 比较版本号
 */
var versionfunegt = function versionfunegt() {
  var appVer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var standardVer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!appVer || !standardVer) return false;
  var appVerArr = appVer.split('.').map(function (item) {
    return +item;
  });
  var standardVerArr = standardVer.split('.').map(function (item) {
    return +item;
  });

  if (appVerArr[0] !== standardVerArr[0]) {
    return appVerArr[0] > standardVerArr[0];
  } else {
    if (appVerArr[1] !== standardVerArr[1]) {
      return appVerArr[1] > standardVerArr[1];
    } else {
      return appVerArr[2] >= standardVerArr[2];
    }
  }
};

/* 获取链接钟的query */
var GetQueryString = function GetQueryString(name, url) {
  var reg = new RegExp('(^|&?)' + name + '=([^&]*)(&|$)');
  var r = (url || window.location.search.substr(1)).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

// 可以唤端，但是重新下载后没办法直接打开web访问页面
// 需要下载app后打开指定页面请不要使用这个方法
var utils_goApp = function goApp(href) {
  var src = '';
  if (href.indexOf('yixinli://') > -1) {
    src = href.trim();
  } else {
    src = 'yixinli://' + href;
  }
  var UA = window.navigator.userAgent.toUpperCase();

  // 判断微信环境
  if (/MICROMESSENGER/i.test(UA)) {
    if (window.toast) {
      window.toast('微信用户需要点击右上角菜单，使用“浏览器”打开~', 3000);
    } else {
      alert('微信用户需要点击右上角菜单，使用“浏览器”打开~');
    }
    return;
  }
  var downloadLink = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.xinli.yixinli';
  var toDownload = function toDownload() {
    window.location.href = downloadLink;
  };

  var platform = Object(getPlatform["getPlatform"])();
  if (platform.isiPhone || platform.isiPad) {
    getShortUrl({
      remark: '引流唤端请求 - ' + document.title,
      long_url: downloadLink + '&app_link=' + encodeURIComponent(src)
    }).then(function (res) {
      if (res && res.www_short_url) {
        window.location.href = res.www_short_url;
      } else {
        toDownload();
      }
    }).catch(function () {
      toDownload();
    });
  } else {
    window.location.href = src;
    window.setTimeout(function () {
      toDownload();
    }, 2000);
  }
};

/**
 * 移动端跳转到下载，app内调协议更新
 */
var utils_updateOrDownLoadApp = function updateOrDownLoadApp() {
  var platform = Object(getPlatform["getPlatform"])();
  var ua = window.navigator.userAgent;
  var isApp = platform.isYixinliApp || platform.isCeShiApp;
  var isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
  if (isApp) {
    var bridge = new Bridge["a" /* default */]();
    var _version = GetQueryString('_version', window.location.hash);
    // APP 5.2.1 才有执行更新方法（doUpgrade）
    if (versionfunegt(_version, '5.2.1')) {
      bridge.call('doUpgrade');
    } else {
      if (isAndroid) {
        // bridge.call('openWebView', {
        //   url: 'http://app-global.pgyer.com/3032d1cee33cd139f310f9f1da85caa9.apk?attname=yixinli-debug-20180816-175409.apk&sign=730cd838ae4b4c83f6af335e669bd51c&t=5b7671c5', // sdk原型上链接
        //   isCurrentPageOpen: 0
        // })
        var iframe = document.createElement('iframe');
        var src = 'http://xinli001-file.oss-cn-hangzhou.aliyuncs.com/android_patch/yixinli.apk';
        iframe.src = src;
        iframe.style = 'width:0;height:0;overflow:hidden;position: absolute;';
        document.body.appendChild(iframe);
        setTimeout(function () {
          return document.body.removeChild(iframe);
        }, 2000);
      } else {
        // ios从浏览器打开应用宝
        // const a = document.createElement('a')
        var href = 'http://a.app.qq.com/o/simple.jsp?open_by_broswer=1&pkgname=com.xinli.yixinli';
        bridge.call('openWebview', {
          url: href,
          isOpenByBrowser: 1
        });
        // a.href = href
        // document.body.appendChild(a)
        // a.click()
        // document.body.removeChild(a)
      }
    }
  } else {
    utils_goApp();
  }
};

function throttle(fn, delay) {
  var mustRunDelay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var timer = null;
  var tStart = void 0;
  return function () {
    var context = this;
    var args = arguments;
    var tCurr = +new Date();
    clearTimeout(timer);
    if (!tStart) {
      tStart = tCurr;
    }
    if (mustRunDelay !== 0 && tCurr - tStart >= mustRunDelay) {
      fn.apply(context, args);
      tStart = tCurr;
    } else {
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    }
  };
}

function loadScript(url, callback) {
  return new Promise(function (resolve) {
    var script = document.createElement('script');
    // 遍历当前的script有没有已有的，已有的就不触发
    var scripts = Array.from(document.querySelectorAll('script'));
    var hasUrlScript = scripts.filter(function (i) {
      return i.getAttribute('src') === url;
    });

    if (hasUrlScript.length > 0) {
      console.log('script: ' + url + ' has already been loaded, mission end');
      return;
    }
    script.type = 'text/javascript';
    if (typeof callback !== 'undefined') {
      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState == 'loaded' || script.readyState == 'complete') {
            script.onreadystatechange = null;
            callback();
            resolve();
          }
        };
      } else {
        script.onload = resolve;
      }
    }
    script.src = url;
    document.body.appendChild(script);
  });
}

// 输入秒数，转换成 mm:ss的格式
function secondToTime(second) {
  var sec = ('' + Math.round(second) % 60).padStart(2, '0');
  var minute = ('' + (second / 60).toFixed(0)).padStart(2, '0');
  return minute + ':' + sec;
}

/*
  秒数倒计时
  当start大于end的时候，认为是倒计时，否则是正计时，每次时间变化都调用callback
 */
function secondCounter(start, end, callback) {
  var countWay = start > end ? 'down' : 'up';
  if (start !== end) {
    setTimeout(function () {
      if (countWay === 'down') {
        secondCounter(start - 1, end, callback);
      } else {
        secondCounter(start + 1, end, callback);
      }
    }, 1000);
  }
  callback(start);
}

function getScrollTop() {
  // 试过了IOS和红米都有document.body.scrollTop，所以其他都不要了
  var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
  return scrollTop;
}

function setScrollTop(number) {
  if (number !== undefined && !Number.isNaN(number)) {
    console.log('setScrollTop', number);
    document.body.scrollTop = document.documentElement.scrollTop = window.pageYOffset = number;
  }
}

function debounce(action, idle) {
  var last = null;
  return function () {
    var ctx = this;
    var args = arguments;
    clearTimeout(last);
    last = setTimeout(function () {
      action.apply(ctx, args);
    }, idle);
  };
}

/**
 *
 * @param val Storage名
 * @param key 键名
 * @param day 过期时间  单位：天
 * @param writable  是否可以set
 * @returns {boolean} false:未过期   true:已过期
 * @constructor
 */
var handleExpiresStorage = function handleExpiresStorage(val, key, day) {
  var writable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var StorageObj = JSON.parse(localStorage.getItem(val));
  var StorageMap = new Map();
  var curTime = Date.now();
  for (var _key in StorageObj) {
    StorageMap.set(_key, StorageObj[_key]);
  }
  var keyValue = StorageMap.get(key);
  if (keyValue) {
    var interval = curTime - keyValue;
    if (interval < 0) return false; //未过期
  }
  if (writable) {
    localStorage.removeItem(val);
    StorageMap.set(key, curTime + day * 1000 * 86400);
    var objFromMap = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = StorageMap[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = _slicedToArray(_ref, 2);

        var k = _ref2[0];
        var v = _ref2[1];

        objFromMap[k] = v;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    localStorage.setItem(val, JSON.stringify(objFromMap));
  }
  return true;
};

// 判断是不是隐藏了头部，全屏显示
var isCanHideNavigationBar = function isCanHideNavigationBar(platform) {
  var isYixinliApp = platform.isYixinliApp,
      yixinliAPPVersion = platform.yixinliAPPVersion,
      isZiXunApp = platform.isZiXunApp,
      zixunAppVersion = platform.zixunAppVersion,
      isZiXunShiApp = platform.isZiXunShiApp;


  var isYixinliAppVersionWork = isYixinliApp && versionfunegt(yixinliAPPVersion, '5.9.0');
  var isZiXunAppVersionWork = isZiXunApp && versionfunegt(zixunAppVersion, '4.0.0');

  return (isYixinliAppVersionWork || isZiXunAppVersionWork || isZiXunShiApp) && window.screen.height - document.documentElement.clientHeight < 50 // 高度差小于50就认为是全面屏，考虑ipx底部，安卓操作条
  ;
};

var utils_getStatusBarHeight = function getStatusBarHeight() {
  return new Promise(function (resolve, reject) {
    try {
      var bridge = new Bridge["a" /* default */]({
        methods: [{
          method: 'areaListHasNotch',
          callback: function callback(obj) {
            var hasNotch = obj.hasNotch,
                notchHeight = obj.notchHeight;

            var statusBarHeight = notchHeight && window.devicePixelRatio ? notchHeight / window.devicePixelRatio | 0 : hasNotch === 1 || hasNotch === true ? _this.$platform.isAndroid ? 35 : 40 : 20;
            resolve(statusBarHeight);
          }
        }]
      });

      bridge.call('hasNotch', {
        callbackName: 'areaListHasNotch'
      });
    } catch (e) {
      reject(e);
    }
  });
};

var utils_isDangerUrl = function isDangerUrl() {
  var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;

  var dangerUrls = ['xinli001.com', 'xinli001.xin', 'xinli001.cc', 'xinli001.net', 'pgxinli.com', 'zixunshizhijia.com'];

  var isProd = Object(getPlatform["getRunningEnv"])().env === '';
  var isWechat = Object(getPlatform["getPlatform"])().isWechat;

  if (!isProd || !isWechat) return false;
  var isDanger = false;

  for (var i = 0; i < dangerUrls.length; i++) {
    var url = dangerUrls[i];
    if (host.indexOf(url) > -1) {
      isDanger = true;
    }
  }

  return isDanger;
};

var chunkArray = function chunkArray(data, length) {
  var newArr = [];

  for (var i = 0; i < data.length; i += length) {
    newArr.push(data.slice(i, i + length));
  }

  return newArr;
};

var utils_getRunTime = function getRunTime(str) {
  var result = void 0;
  var _href = window.location.href.split('.')[0];
  _href.replace(/-([A-Za-z0-9]*)/, function (s, v) {
    result = str.replace(/\./, '-' + v + '.');
  });

  if (!result) {
    result = str;
  }

  return result;
};

var updateQueryStringParameter = function updateQueryStringParameter(url, key, value) {
  if (!value) {
    return url;
  }
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  var separator = url.indexOf('?') !== -1 ? '&' : '?';
  if (url.match(re)) {
    return url.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    return url + separator + key + '=' + value;
  }
};

/**
 * 批量添加链接参数
 */
var addQueryToUrl = function addQueryToUrl(url, querys) {
  if (!url || !querys) return url;

  for (var key in querys) {
    url = updateQueryStringParameter(url, key, querys[key]);
  }

  return url;
};

/**
 *
 * @param dateObj 日期对象 Date Object
 * @param fmt 格式，字符串类型，YY代表年，MM代表月，DD代表日，hh时，mm分，ss秒，SS毫秒
 * @returns {*}
 */
var dateFormater = function dateFormater(dateObj, fmt) {
  if (dateObj instanceof Date) {
    console.log('dateObj is good');
  } else if (typeof dateObj == 'string') {
    dateObj = new Date(dateObj.replace(/-/g, '/'));
  } else {
    console.error('日期数据格式错误');
    return;
  }
  var o = {
    'M+': dateObj.getMonth() + 1, //月份
    'D+': dateObj.getDate(), //日
    'h+': dateObj.getHours(), //小时
    'm+': dateObj.getMinutes(), //分
    's+': dateObj.getSeconds(), //秒
    'q+': Math.floor((dateObj.getMonth() + 3) / 3), //季度
    S: dateObj.getMilliseconds() //毫秒
  };
  if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (dateObj.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  }return fmt;
};

// 判断是否base64字符串
var utils_isBase64 = function isBase64(str) {
  if (str === '' || typeof str === 'string' && str.trim() === '') {
    return false;
  }
  try {
    return base64["Base64"].encodeURI(base64["Base64"].decode(str)) == str;
  } catch (err) {
    return false;
  }
};

// 解码url参数
var utils_decodeUrlQuery = function decodeUrlQuery(str) {
  return utils_isBase64(str) ? base64["Base64"].decode(str) : decodeURIComponent(str);
};

/* harmony default export */ var utils = ({
  updateOrDownLoadApp: utils_updateOrDownLoadApp,
  goApp: utils_goApp,
  GetQueryString: GetQueryString,
  throttle: throttle,
  loadScript: loadScript,
  getScrollTop: getScrollTop,
  setScrollTop: setScrollTop,
  debounce: debounce,
  versionfunegt: versionfunegt,
  handleExpiresStorage: handleExpiresStorage,
  secondCounter: secondCounter,
  secondToTime: secondToTime,
  isCanHideNavigationBar: isCanHideNavigationBar,
  getStatusBarHeight: utils_getStatusBarHeight,
  isDangerUrl: utils_isDangerUrl,
  chunkArray: chunkArray,
  getRunTime: utils_getRunTime,
  updateQueryStringParameter: updateQueryStringParameter,
  addQueryToUrl: addQueryToUrl,
  dateFormater: dateFormater,
  isBase64: utils_isBase64,
  decodeUrlQuery: utils_decodeUrlQuery
});



/***/ }),

/***/ "ZtwE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("XSOZ");
var isObject = __webpack_require__("UKM+");
var invoke = __webpack_require__("PHCx");
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),

/***/ "Zzip":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("/n6Q"), __esModule: true };

/***/ }),

/***/ "a7gV":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer(obj) {
  return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

/***/ }),

/***/ "aFK5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("gAsd"), __esModule: true };

/***/ }),

/***/ "aJ2J":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),

/***/ "aM0T":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__("Ds5P");
var microtask = __webpack_require__("g36u")();
var process = __webpack_require__("OzIq").process;
var isNode = __webpack_require__("ydD5")(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),

/***/ "altv":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");
var $parseFloat = __webpack_require__("8t38");
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),

/***/ "arGp":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("Ds5P");

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__("XXBo")('Set') });


/***/ }),

/***/ "arfw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_mineTestOrderNum_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("IlSO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_mineTestOrderNum_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_mineTestOrderNum_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_mineTestOrderNum_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "atqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_newSwiper_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("TN6f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_newSwiper_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_newSwiper_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_newSwiper_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "avV3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ax3d":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("e8AB")('keys');
var uid = __webpack_require__("3Eo+");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "b2xw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("H3q/");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "bG/2":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("PHqh");
var gOPN = __webpack_require__("WcO1").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "bLJ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/globalLimitTimeg.vue?vue&type=template&id=1d8cbce2&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog"},[(_vm.COUPONDIALOGDATA)?_c('myMask'):_vm._e(),_vm._v(" "),(_vm.COUPONDIALOGDATA)?_c('div',{staticClass:"firework-grp"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.COUPONDIALOGDATA),expression:"COUPONDIALOGDATA"}],staticClass:"timeg-dialogWin",class:{'is-comb': _vm.COUPONDIALOGDATA.isCombination}},[_c('div',{staticClass:"title fs-18"}),_vm._v(" "),_vm._t("top"),_vm._v(" "),_c('div',{staticClass:"fs-16 content"},[_c('div',{staticClass:"subtitle",domProps:{"innerHTML":_vm._s(_vm.COUPONDIALOGDATA.subtitle || '你被优惠券砸中啦')}}),_vm._v(" "),(_vm.COUPONDIALOGDATA.isCombination)?_c('div',{staticClass:"comb-content"},_vm._l((_vm.COUPONDIALOGDATA.combination),function(item,index){return _c('div',{key:index,staticClass:"comb-content-item",on:{"click":function($event){return _vm.hanldeUse(item)}}},[_c('i',{class:("is-" + (item.type))}),_vm._v(" "),_c('span',{staticClass:"comb-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('span',{staticClass:"comb-button"},[_vm._v(_vm._s(item.button || '立即使用'))])])}),0):[_c('div',{staticClass:"coupon"},[_c('div',{staticClass:"coupon-title"},[_c('div',{staticClass:"intitle"},[_vm._v(_vm._s(_vm.COUPONDIALOGDATA.popTitle))]),_vm._v(" "),(_vm.COUPONDIALOGDATA.popDescription)?_c('div',{staticClass:"intis"},[_vm._v(_vm._s(_vm.COUPONDIALOGDATA.popDescription))]):_vm._e()]),_vm._v(" "),_c('div',{class:[_vm.COUPONDIALOGDATA.popCouponTypeDes.length > 4?'coupon-price-min':'coupon-price']},[_vm._v(_vm._s(_vm.COUPONDIALOGDATA.popCouponTypeDes))])]),_vm._v(" "),_c('div',{staticClass:"dialog-timer"},[_c('div',{staticClass:"timer-title"},[_vm._v(_vm._s(_vm.COUPONDIALOGDATA.expireTimeTitle || '优惠券有效时间'))]),_vm._v(" "),(_vm.COUPONDIALOGDATA.expireTime)?_c('div',{staticClass:"timer-tis"},[(_vm.endTime.day)?_c('span',[_vm._v(_vm._s(_vm.endTime.day)+"天")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.endTime.hr))]),_vm._v(":\n            "),_c('span',[_vm._v(_vm._s(_vm.endTime.min))]),_vm._v(":\n            "),_c('span',[_vm._v(_vm._s(_vm.endTime.sec))])]):_vm._e()])]],2),_vm._v(" "),(!_vm.COUPONDIALOGDATA.isCombination)?_c('div',{staticClass:"action"},[_c('div',{staticClass:"btnCont"},[_c('v-touch',{staticClass:"inbtn fs-16",on:{"tap":function($event){return _vm.callBack()}}},[_vm._v("立即使用")])],1)]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"coupondialog-close",on:{"click":function($event){$event.stopPropagation();return _vm.close('isDialogClose')}}},[_c('img',{attrs:{"src":__webpack_require__("obJF")}})])],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"firework pos1"},[_c('div',{staticClass:"drops-grp"},[_c('span',{staticClass:"drop drop-1"}),_vm._v(" "),_c('span',{staticClass:"drop drop-2"}),_vm._v(" "),_c('span',{staticClass:"drop drop-3"}),_vm._v(" "),_c('span',{staticClass:"drop drop-4"})]),_vm._v(" "),_c('div',{staticClass:"drops-grp drops-grp2"},[_c('span',{staticClass:"drop drop-1"}),_vm._v(" "),_c('span',{staticClass:"drop drop-2"}),_vm._v(" "),_c('span',{staticClass:"drop drop-3"}),_vm._v(" "),_c('span',{staticClass:"drop drop-4"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"firework pos2 delay1"},[_c('div',{staticClass:"drops-grp"},[_c('span',{staticClass:"drop drop-1"}),_vm._v(" "),_c('span',{staticClass:"drop drop-2"}),_vm._v(" "),_c('span',{staticClass:"drop drop-3"}),_vm._v(" "),_c('span',{staticClass:"drop drop-4"})]),_vm._v(" "),_c('div',{staticClass:"drops-grp drops-grp2"},[_c('span',{staticClass:"drop drop-1"}),_vm._v(" "),_c('span',{staticClass:"drop drop-2"}),_vm._v(" "),_c('span',{staticClass:"drop drop-3"}),_vm._v(" "),_c('span',{staticClass:"drop drop-4"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"firework pos4 delay2"},[_c('div',{staticClass:"drops-grp"},[_c('span',{staticClass:"drop drop-1"}),_vm._v(" "),_c('span',{staticClass:"drop drop-2"}),_vm._v(" "),_c('span',{staticClass:"drop drop-3"}),_vm._v(" "),_c('span',{staticClass:"drop drop-4"})]),_vm._v(" "),_c('div',{staticClass:"drops-grp drops-grp2"},[_c('span',{staticClass:"drop drop-1"}),_vm._v(" "),_c('span',{staticClass:"drop drop-2"}),_vm._v(" "),_c('span',{staticClass:"drop drop-3"}),_vm._v(" "),_c('span',{staticClass:"drop drop-4"})])])}]


// CONCATENATED MODULE: ./src/components/show/globalLimitTimeg.vue?vue&type=template&id=1d8cbce2&scoped=true&

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/components/common/mask.vue + 2 modules
var mask = __webpack_require__("m423");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/globalLimitTimeg.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var globalLimitTimegvue_type_script_lang_js_ = ({
  components: {
    myMask: mask["a" /* default */]
  },
  data: function data() {
    return {
      mask: true,
      title: "",
      content: "",
      actions: [],
      show: false,
      endTime: {
        day: 0,
        hr: 0,
        min: 0,
        sec: 0
      },
      initPropTime: ""
    };
  },
  mounted: function mounted() {
    this.initPropTime = this.COUPONDIALOGDATA.expireTime;
    this.inEndTime();
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["COUPONDIALOGDATA"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])(["setCouponDialogData"]), {
    inEndTime: function inEndTime() {
      //倒计时结束
      var that = this;
      if (this.initPropTime < 2) {
        return;
      }
      this.initPropTime = this.initPropTime - 1000;
      var day = parseInt(this.initPropTime / 1000 / 60 / 60 / 24);
      var hr = parseInt(this.initPropTime / 1000 / 60 / 60 % 24);
      var min = parseInt(this.initPropTime / 1000 / 60 % 60);
      var sec = parseInt(this.initPropTime / 1000 % 60);
      this.endTime.day = day;
      this.endTime.hr = hr > 9 ? hr : "0" + hr;
      this.endTime.min = min > 9 ? min : "0" + min;
      this.endTime.sec = sec > 9 ? sec : "0" + sec;
      var timer = setTimeout(function () {
        that.inEndTime();
        clearTimeout(timer);
      }, 1000);
    },
    callBack: function callBack() {
      console.log("关闭优惠券");
      var scope = this.COUPONDIALOGDATA.scope;
      if (!scope) {
        this.$emit('use');
      }
      if (!scope || scope === 1 && this.$route.name === 'testDetail') {
        this.close();
        return;
      }
      if (scope == 3) {
        this.$router.push({
          name: "testDetail",
          path: "/detail",
          params: {
            testId: this.COUPONDIALOGDATA.scalePoolIds[0]
          },
          query: {
            channelId: this.channelId
          }
        });
      } else {
        this.$router.push({
          name: "sorts",
          path: "/sorts",
          query: {
            channelId: this.channelId,
            sort: "全部"
          }
        });
      }
      this.close();
    },
    close: function close() {
      this.$emit('close');
      this.setCouponDialogData("");
    },
    hanldeUse: function hanldeUse(item) {
      this.$emit('use', item);
      this.close();
    }
  })
});
// CONCATENATED MODULE: ./src/components/show/globalLimitTimeg.vue?vue&type=script&lang=js&
 /* harmony default export */ var show_globalLimitTimegvue_type_script_lang_js_ = (globalLimitTimegvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/show/globalLimitTimeg.vue?vue&type=style&index=0&id=1d8cbce2&lang=scss&scoped=true&
var globalLimitTimegvue_type_style_index_0_id_1d8cbce2_lang_scss_scoped_true_ = __webpack_require__("527X");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/show/globalLimitTimeg.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  show_globalLimitTimegvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "1d8cbce2",
  null
  
)

/* harmony default export */ var globalLimitTimeg = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "bN1p":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "bOdI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "bRrM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var dP = __webpack_require__("evD5");
var DESCRIPTORS = __webpack_require__("+E39");
var SPECIES = __webpack_require__("dSzd")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "bSML":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("lDLk");
var createDesc = __webpack_require__("fU25");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "bUY0":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__("lDLk");
var gOPD = __webpack_require__("x9zv");
var getPrototypeOf = __webpack_require__("KOrd");
var has = __webpack_require__("WBcL");
var $export = __webpack_require__("Ds5P");
var createDesc = __webpack_require__("fU25");
var anObject = __webpack_require__("DIVP");
var isObject = __webpack_require__("UKM+");

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),

/***/ "bUqO":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("zgIt")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "bWSI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("saHn");
var utils = __webpack_require__("8Uqm");
var InterceptorManager = __webpack_require__("DX9u");
var dispatchRequest = __webpack_require__("H8TF");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, { method: 'get' }, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),

/***/ "beEN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("rFzY");
var $export = __webpack_require__("Ds5P");
var toObject = __webpack_require__("FryR");
var call = __webpack_require__("XvUs");
var isArrayIter = __webpack_require__("9vb1");
var toLength = __webpack_require__("BbyF");
var createProperty = __webpack_require__("bSML");
var getIterFn = __webpack_require__("SHe9");

$export($export.S + $export.F * !__webpack_require__("qkyc")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "bfde":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("cM5C");
var GetIntrinsic = __webpack_require__("nSQQ");

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(func, 'length', { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) });
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}

/***/ }),

/***/ "bn6T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var env = location.host.split('.')[0].match(/(qc|box)\d?/g);
var spell = !!env ? env.length > 0 ? '-' + env[0] : '' : '';
var WXDOMAIN = '//wx' + spell + '.xinli001.com/',
    CPDOMAIN = '//m-cpapi' + spell + '.xinli001.com/',
    LXDOMAIN = spell ? '//lingxi' + spell + '.xinli001.com/lingxi/service/' : '//m-lingxi' + spell + '.xinli001.com/lingxi/service/',
    CPAPI = spell ? '//cpapi' + spell + '.xinli001.com/cp/service/' : '//m-cpapi' + spell + '.xinli001.com/cp/service/',
    LX = '//lx' + spell + '.xinli001.com/lx/',
    FUN = '//qu' + spell + '.xinli001.com/lingxi/fun/',
    YIAPIDOMAIN = '//yiapi' + spell + '.xinli001.com',
    MDOMAIN = '//m' + spell + '.xinli001.com',

// PGXINLI = `//appoint${spell}.pgxinli.com`,
// MDOMAIN = `//m.xinli001.com`,
PGXINLI = '//appoint.pgxinli.com',
    HCP = '//hcp' + spell + '.xinli001.com',
    CPBADMIN = '//cpbadmin' + spell + '.xinli001.com';

/* harmony default export */ __webpack_exports__["a"] = ({
  env: env, spell: spell, WXDOMAIN: WXDOMAIN, CPAPI: CPAPI, LX: LX, FUN: FUN, YIAPIDOMAIN: YIAPIDOMAIN, MDOMAIN: MDOMAIN, PGXINLI: PGXINLI, HCP: HCP, CPBADMIN: CPBADMIN, LXDOMAIN: LXDOMAIN
});

/***/ }),

/***/ "boo2":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("UKM+");
var isArray = __webpack_require__("XO1R");
var SPECIES = __webpack_require__("kkCw")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "bqLP":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var match = String.prototype.match;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'object';
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
? function (O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);

var inspectCustom = __webpack_require__(0).custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;
var toStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag !== 'undefined' ? Symbol.toStringTag : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double') {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean') {
        throw new TypeError('option "customInspect", if provided, must be `true` or `false`');
    }

    if (has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
        throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
    }

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        return String(obj);
    }
    if (typeof obj === 'bigint') {
        return String(obj) + 'n';
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') {
        depth = 0;
    }
    if (depth >= maxDepth && maxDepth > 0 && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = seen.slice();
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + keys.join(', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? String(obj).replace(/^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + String(obj.nodeName).toLowerCase();
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) {
            s += '...';
        }
        s += '</' + String(obj.nodeName).toLowerCase() + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) {
            return '[]';
        }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + xs.join(', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (parts.length === 0) {
            return '[' + String(obj) + ']';
        }
        return '{ [' + String(obj) + '] ' + parts.join(', ') + ' }';
    }
    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? toStr(obj).slice(8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + [].concat(stringTag || [], protoTag || []).join(': ') + '] ' : '');
        if (ys.length === 0) {
            return tag + '{}';
        }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + ys.join(', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return String(s).replace(/"/g, '&quot;');
}

function isArray(obj) {
    return toStr(obj) === '[object Array]' && (!toStringTag || !((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && toStringTag in obj));
}
function isDate(obj) {
    return toStr(obj) === '[object Date]' && (!toStringTag || !((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && toStringTag in obj));
}
function isRegExp(obj) {
    return toStr(obj) === '[object RegExp]' && (!toStringTag || !((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && toStringTag in obj));
}
function isError(obj) {
    return toStr(obj) === '[object Error]' && (!toStringTag || !((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && toStringTag in obj));
}
function isString(obj) {
    return toStr(obj) === '[object String]' && (!toStringTag || !((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && toStringTag in obj));
}
function isNumber(obj) {
    return toStr(obj) === '[object Number]' && (!toStringTag || !((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && toStringTag in obj));
}
function isBoolean(obj) {
    return toStr(obj) === '[object Boolean]' && (!toStringTag || !((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && toStringTag in obj));
}

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj instanceof Symbol;
    }
    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'symbol') {
        return true;
    }
    if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) {
    return key in this;
};
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) {
        return f.name;
    }
    var m = match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) {
        return m[1];
    }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) {
        return xs.indexOf(x);
    }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) {
            return i;
        }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || (typeof x === 'undefined' ? 'undefined' : _typeof(x)) !== 'object') {
        return false;
    }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = str.replace(/(['\\])/g, '\\$1').replace(/[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) {
        return '\\' + x;
    }
    return '\\x' + (n < 0x10 ? '0' : '') + n.toString(16).toUpperCase();
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : entries.join(', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = Array(opts.indent + 1).join(' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: Array(depth + 1).join(baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) {
        return '';
    }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + xs.join(',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) {
        // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) {
            continue;
        } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) {
            continue;
        } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if (/[^\w$]/.test(key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

/***/ }),

/***/ "bqOW":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");
var toAbsoluteIndex = __webpack_require__("zo/l");
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),

/***/ "buex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_packageDialog_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("S60i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_packageDialog_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_packageDialog_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_packageDialog_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "bwqu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/gotoTop.vue?vue&type=template&id=2f41edf1&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-go2Top"},[_c('transition',{attrs:{"name":"fadeIn"}},[_c('v-touch',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGoTop),expression:"showGoTop"}],staticClass:"goTopButton",on:{"tap":_vm.go2Top}})],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/common/gotoTop.vue?vue&type=template&id=2f41edf1&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/gotoTop.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//

/* harmony default export */ var gotoTopvue_type_script_lang_js_ = ({
    name: 'vue-go2Top',
    props: {
        propShow: {
            required: false,
            type: Boolean,
            default: null
        },
        propOffset: {
            required: false,
            type: [Number, String],
            default: function _default() {
                return document.body.offsetHeight;
            }
        }
    },
    data: function data() {
        return {
            showGoTop: false
        };
    },
    mounted: function mounted() {
        if (this.propShow == null) {
            this.init();
        }
    },

    watch: {
        'propShow': function propShow(newVal) {
            this.showGoTop = !!newVal;
        }
    },
    methods: {
        init: function init() {
            var that = this;
            //                使用prop的默认值取代这个值
            //                const screenHeight = document.body.offsetHeight;
            var buffer = 0;
            document.addEventListener('scroll', function () {
                var scrollTop = document.body.scrollTop;
                if (buffer < 10) {
                    buffer++;
                }
                if (scrollTop > that.propOffset) {
                    that.$data.showGoTop = true;
                } else {
                    that.$data.showGoTop = false;
                }
            });
        },
        go2Top: function go2Top() {
            document.body.scrollTop = 0;
        }
    }
});
// CONCATENATED MODULE: ./src/components/common/gotoTop.vue?vue&type=script&lang=js&
 /* harmony default export */ var common_gotoTopvue_type_script_lang_js_ = (gotoTopvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/common/gotoTop.vue?vue&type=style&index=0&id=2f41edf1&lang=scss&scoped=true&
var gotoTopvue_type_style_index_0_id_2f41edf1_lang_scss_scoped_true_ = __webpack_require__("IEQv");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/common/gotoTop.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  common_gotoTopvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "2f41edf1",
  null
  
)

/* harmony default export */ var gotoTop = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "c/Tr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("5zde"), __esModule: true };

/***/ }),

/***/ "cGG2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("JP+z");
var isBuffer = __webpack_require__("Re3r");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "cM5C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("ekJV");

module.exports = Function.prototype.bind || implementation;

/***/ }),

/***/ "cWPk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_testSwiper_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("DPOj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_testSwiper_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_testSwiper_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_testSwiper_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "cWxy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("dVOP");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "cbIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "crlp":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var LIBRARY = __webpack_require__("O4g8");
var wksExt = __webpack_require__("Kh4W");
var defineProperty = __webpack_require__("evD5").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "cwmK":
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),

/***/ "cxOf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("pkjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_index_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "d075":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("OzIq").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "d1Yp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/yxlToast.vue?vue&type=template&id=335d6f37&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showText)?_c('div',{staticClass:"toast-container"},[_c('div',{class:['toast fs-14', _vm.localStatus]},[_c('div',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.showText)}})])])]):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/common/yxlToast.vue?vue&type=template&id=335d6f37&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/yxlToast.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var yxlToastvue_type_script_lang_js_ = ({
    name: 'yxl-toast',
    props: {
        propText: {
            required: true,
            type: String,
            default: ''
        },
        status: {
            type: String,
            default: ''
        },
        propTime: {
            type: [Number, String],
            default: 1300
        },
        istTisImg: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            showText: '',
            localStatus: '',
            showToast: false
        };
    },
    mounted: function mounted() {
        this.showText = this.propText;
    },

    watch: {
        'propText': function propText(newVal, oldVal) {
            var that = this;
            if (newVal != '') {
                that.showText = newVal;
                that.localStatus = that.status;
                that.timeOutFn();
            }
        }
    },
    methods: {
        timeOutFn: function timeOutFn() {
            var that = this;
            setTimeout(function () {
                that.showText = '';
                that.localStatus = '';
                that.$emit('toastEnd');
            }, that.propTime);
        }
    }
});
// CONCATENATED MODULE: ./src/components/common/yxlToast.vue?vue&type=script&lang=js&
 /* harmony default export */ var common_yxlToastvue_type_script_lang_js_ = (yxlToastvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/common/yxlToast.vue?vue&type=style&index=0&lang=scss&
var yxlToastvue_type_style_index_0_lang_scss_ = __webpack_require__("l3EO");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/common/yxlToast.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  common_yxlToastvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var yxlToast = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "dGBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_couponDialog_vue_vue_type_style_index_0_id_3b718f86_lang_scss_scoped_true___ = __webpack_require__("K9Iu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_couponDialog_vue_vue_type_style_index_0_id_3b718f86_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_couponDialog_vue_vue_type_style_index_0_id_3b718f86_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_couponDialog_vue_vue_type_style_index_0_id_3b718f86_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "dIwP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "dMBf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/service-qrcode.f5b0e42.png";

/***/ }),

/***/ "dNDb":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "dSUw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("Dgii");
var validate = __webpack_require__("zq/X");
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__("0Rih")(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ "dSzd":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("e8AB")('wks');
var uid = __webpack_require__("3Eo+");
var Symbol = __webpack_require__("7KvD").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "dTzs":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("77Ug")('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "dULJ":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");
var $parseInt = __webpack_require__("OgTs");
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),

/***/ "dVOP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "dY0y":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("dSzd")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "dhJ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/show/activity/2021525/count-down.vue?vue&type=template&id=3a5b6e03&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count__wrap"},[_c('div',{staticClass:"count__date"},[_vm._v("距结束"+_vm._s(_vm.countdown.days)+"天")]),_vm._v(" "),_c('div',{staticClass:"count__time"},[_c('span',[_vm._v(_vm._s(_vm.countdown.hours))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.countdown.minutes))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.countdown.seconds))])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/pages/show/activity/2021525/count-down.vue?vue&type=template&id=3a5b6e03&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/show/activity/2021525/count-down.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var count_downvue_type_script_lang_js_ = ({
  props: {
    endTime: {
      type: String | Number,
      default: ''
    }
  },

  data: function data() {
    return {
      countdown: {},
      countdownTask: null
    };
  },
  created: function created() {
    this.leftTime = this.endTime;
    this.calculateCountDown();
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.countdownTask);
  },


  methods: {
    calculateCountDown: function calculateCountDown() {
      var _this = this;

      if (this.leftTime > 0) {
        var leftTime = this.leftTime; //计算剩余的毫秒数
        var days = parseInt(leftTime / 1000 / 60 / 60 / 24, 10); //计算剩余的天数
        var hours = parseInt(leftTime / 1000 / 60 / 60 % 24, 10); //计算剩余的小时
        var minutes = parseInt(leftTime / 1000 / 60 % 60, 10); //计算剩余的分钟
        var seconds = parseInt(leftTime / 1000 % 60, 10); //计算剩余的秒数
        this.countdown = {
          days: days,
          hours: hours > 9 ? hours : '0' + hours,
          minutes: minutes > 9 ? minutes : '0' + minutes,
          seconds: seconds > 9 ? seconds : '0' + seconds
        };
        this.countdownTask = setTimeout(function () {
          _this.leftTime -= 1000;
          _this.calculateCountDown();
        }, 1000);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/pages/show/activity/2021525/count-down.vue?vue&type=script&lang=js&
 /* harmony default export */ var _021525_count_downvue_type_script_lang_js_ = (count_downvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/pages/show/activity/2021525/count-down.vue?vue&type=style&index=0&id=3a5b6e03&lang=scss&scoped=true&
var count_downvue_type_style_index_0_id_3a5b6e03_lang_scss_scoped_true_ = __webpack_require__("1/KO");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/pages/show/activity/2021525/count-down.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  _021525_count_downvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "3a5b6e03",
  null
  
)

/* harmony default export */ var count_down = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "dich":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");
var $task = __webpack_require__("Sejc");
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),

/***/ "dm+7":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),

/***/ "dm6P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__("V3l/") || !__webpack_require__("zgIt")(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__("OzIq")[K];
});


/***/ }),

/***/ "dvtS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dxQb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var toObject = __webpack_require__("FryR");
var aFunction = __webpack_require__("XSOZ");
var $defineProperty = __webpack_require__("lDLk");

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__("bUqO") && $export($export.P + __webpack_require__("dm6P"), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),

/***/ "dxwT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ "e6n0":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("evD5").f;
var has = __webpack_require__("D2L2");
var TAG = __webpack_require__("dSzd")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "e8AB":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("FeBl");
var global = __webpack_require__("7KvD");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("O4g8") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "eC2H":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__("3i66")('getOwnPropertyNames', function () {
  return __webpack_require__("bG/2").f;
});


/***/ }),

/***/ "eUeS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "eVIH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__("y325")('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),

/***/ "ekJV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat(slice.call(arguments)));
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(that, args.concat(slice.call(arguments)));
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

/***/ }),

/***/ "evD5":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var IE8_DOM_DEFINE = __webpack_require__("SfB7");
var toPrimitive = __webpack_require__("MmMw");
var dP = Object.defineProperty;

exports.f = __webpack_require__("+E39") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "evt/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_arrow_r.ba8a2d6.svg";

/***/ }),

/***/ "ew32":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_up.cbb7971.svg";

/***/ }),

/***/ "exGp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ "f+7r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f1Eh":
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "fBQ2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("evD5");
var createDesc = __webpack_require__("X8DO");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "fJSx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__("A16L");
var getWeak = __webpack_require__("1aA0").getWeak;
var anObject = __webpack_require__("DIVP");
var isObject = __webpack_require__("UKM+");
var anInstance = __webpack_require__("9GpA");
var forOf = __webpack_require__("vmSO");
var createArrayMethod = __webpack_require__("LhTa");
var $has = __webpack_require__("WBcL");
var validate = __webpack_require__("zq/X");
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),

/***/ "fJUb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var isObject = __webpack_require__("EqjI");
var newPromiseCapability = __webpack_require__("qARP");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "fOdq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var $filter = __webpack_require__("LhTa")(2);

$export($export.P + $export.F * !__webpack_require__("NNrz")([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "fOgK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-search.2079e5e.png";

/***/ }),

/***/ "fS0v":
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__("ydD5");
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),

/***/ "fU25":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "fWfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("7KvD");
var has = __webpack_require__("D2L2");
var DESCRIPTORS = __webpack_require__("+E39");
var $export = __webpack_require__("kM2E");
var redefine = __webpack_require__("880/");
var META = __webpack_require__("06OY").KEY;
var $fails = __webpack_require__("S82l");
var shared = __webpack_require__("e8AB");
var setToStringTag = __webpack_require__("e6n0");
var uid = __webpack_require__("3Eo+");
var wks = __webpack_require__("dSzd");
var wksExt = __webpack_require__("Kh4W");
var wksDefine = __webpack_require__("crlp");
var enumKeys = __webpack_require__("Xc4G");
var isArray = __webpack_require__("7UMu");
var anObject = __webpack_require__("77Pl");
var isObject = __webpack_require__("EqjI");
var toObject = __webpack_require__("sB3e");
var toIObject = __webpack_require__("TcQ7");
var toPrimitive = __webpack_require__("MmMw");
var createDesc = __webpack_require__("X8DO");
var _create = __webpack_require__("Yobk");
var gOPNExt = __webpack_require__("Rrel");
var $GOPD = __webpack_require__("LKZe");
var $GOPS = __webpack_require__("1kS7");
var $DP = __webpack_require__("evD5");
var $keys = __webpack_require__("lktj");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("n0T6").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("NpIQ").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("O4g8")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("hJx8")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "fZjL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("jFbC"), __esModule: true };

/***/ }),

/***/ "fkB2":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "fuGk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "fx22":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("WgSQ");
var getKeys = __webpack_require__("Qh14");
var redefine = __webpack_require__("R3AP");
var global = __webpack_require__("OzIq");
var hide = __webpack_require__("2p1q");
var Iterators = __webpack_require__("bN1p");
var wks = __webpack_require__("kkCw");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "g/m8":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__("cwmK");
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),

/***/ "g36u":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("OzIq");
var macrotask = __webpack_require__("Sejc").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("ydD5")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "g5Ks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_proSwiper_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("YRLd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_proSwiper_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_proSwiper_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_proSwiper_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "gAsd":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("G5/o");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};


/***/ }),

/***/ "gMg8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gPva":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__("UKM+");

__webpack_require__("3i66")('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),

/***/ "gTic":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/show/skeleton/showIndex-skeleton.vue?vue&type=template&id=752d07ea&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-index"},[_c('img',{attrs:{"src":"data:image/png;base64,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"}})])}]


// CONCATENATED MODULE: ./src/pages/show/skeleton/showIndex-skeleton.vue?vue&type=template&id=752d07ea&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/show/skeleton/showIndex-skeleton.vue?vue&type=script&lang=js&
//
//
//
//
//
//


/* harmony default export */ var showIndex_skeletonvue_type_script_lang_js_ = ({
  name: '',
  data: function data() {
    return {
      msg: ''
    };
  },

  components: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});
// CONCATENATED MODULE: ./src/pages/show/skeleton/showIndex-skeleton.vue?vue&type=script&lang=js&
 /* harmony default export */ var skeleton_showIndex_skeletonvue_type_script_lang_js_ = (showIndex_skeletonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/pages/show/skeleton/showIndex-skeleton.vue?vue&type=style&index=0&id=752d07ea&scoped=true&lang=scss&
var showIndex_skeletonvue_type_style_index_0_id_752d07ea_scoped_true_lang_scss_ = __webpack_require__("wBbU");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/pages/show/skeleton/showIndex-skeleton.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  skeleton_showIndex_skeletonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "752d07ea",
  null
  
)

/* harmony default export */ var showIndex_skeleton = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "gYYG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__("wC1N");
var test = {};
test[__webpack_require__("kkCw")('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__("R3AP")(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),

/***/ "gbyG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("Ds5P");
var $includes = __webpack_require__("ot5s")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("RhFG")('includes');


/***/ }),

/***/ "grp1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gvDt":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("UKM+");
var anObject = __webpack_require__("DIVP");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("rFzY")(Function.call, __webpack_require__("x9zv").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "h65t":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var defined = __webpack_require__("52gC");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "h7Xi":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("Ds5P");

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__("XXBo")('Map') });


/***/ }),

/***/ "hJx8":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var createDesc = __webpack_require__("X8DO");
module.exports = __webpack_require__("+E39") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "hPmf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);




(function (root, factory) {
    if (typeof define === 'function' && __webpack_require__("nErl")) {
        define(['xstream'], factory);
    } else if (true) {
        new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ryRw")]; ((factory).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
        module.exports = factory(require('xstream'));
    } else {
        /*root.returnExports = */factory(root.xstream);
    }
})(this, function (xstream) {
    var NO = xstream.NO,
        Stream = xstream.Stream;

    var extend = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a;
    var slice = Array.prototype.slice;

    function noop() {}
    xstream.noop = noop;

    function isFunction(fn) {
        return typeof fn === 'function';
    }

    var _inherit = function () {
        var create = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default.a ? function (proto, c) {
            var o = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(proto);
            o.constructor = c;
            return o;
        } : function (proto, c) {
            function F() {}
            F.prototype = proto;

            var o = new F();
            o.constructor = c;

            return o;
        };

        function extendStatics(a, b) {
            for (var k in b) {
                if (b.hasOwnProperty(k)) a[k] = b[k];
            }
        }

        return function (a, _super) {
            extendStatics(a, _super);
            a._super = _super;
            a.prototype = create(_super.prototype, a);
        };
    }();

    function _try(c, t, u) {
        try {
            return c.f(t);
        } catch (e) {
            u._e(e);
            return NO;
        }
    }

    function packPromise(pr) {
        if (isFunction(pr.then)) {
            return Stream.fromPromise(pr);
        }

        return pr;
    }

    var Operator = function () {
        function hookFactory(m) {
            return function (t) {
                var u = this.out,
                    k = m + 'Fn';
                if (u === NO) return;
                if (this[k] && this[k](t, u) === NO) return;
                u[m](t);
            };
        }

        function Operator(param, ins) {
            this.ins = ins;
            this.out = NO;
            this.param = param;
        }

        extend(Operator.prototype, {
            _start: function _start(out) {
                if (this.startFn && this.startFn(out) === NO) return;
                this.out = out;
                this.ins._add(this);
            },
            _stop: function _stop() {
                if (this.stopFn && this.stopFn() === NO) return;
                this.ins._remove(this);
                this.out = NO;
            },

            _n: hookFactory('_n'),
            _e: hookFactory('_e'),
            _c: hookFactory('_c')
        });

        return Operator;
    }();

    /* Throttle */
    _inherit(Throttle, Operator);
    function Throttle(fn, ins) {
        Throttle._super.call(this, fn, ins);
        this.f = fn;
    }

    extend(Throttle.prototype, {
        type: 'throttle',
        stopFn: function stopFn() {
            this.throttle$ && this.throttle$._remove(this._throttleProd);
            this.throttle$ = this._throttleProd = null;
        },
        _unlock: function _unlock() {
            this.stopFn();
            this._lock = false;
        },
        _nFn: function _nFn(val, out$) {
            var self = this,
                throttle$;

            if (!self.throttle$) {
                throttle$ = _try(this, val, out$);

                if (throttle$ == NO) {
                    return NO;
                } else {
                    self.throttle$ = throttle$;
                    self.throttle$._add(self._throttleProd = {
                        _n: function _n() {
                            self._unlock();
                        },
                        _e: function _e(err) {
                            self.throttle$ = false, out$._e(err);
                        },
                        _c: function _c() {
                            self._unlock();
                        }
                    });
                }
            }

            if (!self._lock) {
                out$._n(val);
                self._lock = true;
            }

            return NO;
        }
    });

    /* Debounce */
    _inherit(Debounce, Operator);
    function Debounce(fn, ins) {
        Debounce._super.call(this, fn, ins);
        this._nid = 1;
        this._cid = 1;
        this._eid = 1;
        this._prevVal = NO;
        this.f = fn;
    }

    Debounce.fnFactory = function (key) {
        return function (val, out$) {
            var self = this,
                tid = ++this[key + 'id'],
                debounce$;

            function checkTid() {
                return tid === self[key + 'id'];
            }

            function _action() {
                self.stopFn();
                out$[key](val);
                self._prevVal = NO;
            }

            if (key == '_n') {
                self._prevVal = val;
                self.stopFn();
                debounce$ = _try(this, val, out$);

                if (debounce$ == NO) {
                    return NO;
                } else {
                    self.debounce$ = debounce$;
                    self.debounce$._add(self._debounceProd = {
                        _n: function _n() {
                            checkTid() && _action();
                        },
                        _e: function _e(err) {
                            checkTid() && (self.debounce$ = null, out$._e(err));
                        },
                        _c: function _c() {
                            checkTid() && (_action(), self.debounce$ = false);
                        }
                    });
                }
            } else {
                if (key === '_c' && self._prevVal !== NO) {
                    out$._n(self._prevVal);
                }
                _action();
            }

            return NO;
        };
    };

    extend(Debounce.prototype, {
        type: 'debounce',
        stopFn: function stopFn() {
            this.debounce$ && this.debounce$._remove(this._debounceProd);
            this.debounce$ = this._debounceProd = null;
        },
        _nFn: Debounce.fnFactory('_n'),
        _cFn: Debounce.fnFactory('_c')
    });

    /* Do */
    _inherit(Do, Operator);
    function Do(fn, ins) {
        Do._super.call(this, fn, ins);
        this.f = fn;
    }

    extend(Do.prototype, {
        type: 'do',
        _nFn: function _nFn(t, u) {
            return _try(this, t, u);
        }
    });

    /* DelayWhen */
    _inherit(DelayWhen, Operator);
    function DelayWhen(factory, ins) {
        this.delayCount = 0;
        this.open = true;
        this.f = factory;
        DelayWhen._super.call(this, factory, ins);
    }

    extend(DelayWhen.prototype, {
        type: 'delayWhen',
        startFn: function startFn() {
            this.open = true;
        },

        _nFn: function _nFn(val, out$) {
            var self = this,
                delay$ = _try(this, val, out$),
                _delayProd;

            if (delay$ == NO) {
                return NO;
            }

            self.delayCount++;

            function _destory() {
                delay$ && delay$._remove(_delayProd);
                delay$ = _delayProd = null;
            }

            function _action() {
                if (delay$) {
                    out$._n(val);
                    self.delayCount--;

                    if (!self.open) {
                        self._c();
                    }
                }

                _destory();
            }

            delay$._add(_delayProd = {
                _n: _action,
                _c: _action,
                _e: function _e(err) {
                    _destory();out$._e(err);
                }
            });

            return NO;
        },
        _cFn: function _cFn() {
            this.open = false;
            if (this.delayCount !== 0) return NO;
        }
        // _eFn: DelayWhen.fnFactory('_e')

    });

    /* Exhaust */
    var ExhaustListener = function () {
        function ExhaustListener(out, prod) {
            this.prod = prod;
            this.out = out;
        }

        extend(ExhaustListener.prototype, {
            _n: function _n(val) {
                this.out._n(val);
            },
            _e: function _e(err) {
                this.out._e(err);
            },
            _c: function _c() {
                this.prod.inner = NO;
                this.prod.less();
            }
        });

        return ExhaustListener;
    }();

    _inherit(Exhaust, Operator);
    function Exhaust(fn, ins) {
        this.open = true;
        this.inner = NO;
        Exhaust._super.call(this, fn, ins);
    }
    extend(Exhaust.prototype, {
        type: 'exhaust',
        startFn: function startFn() {
            this.open = true;
            this.inner = NO;
        },
        stopFn: function stopFn() {},
        _nFn: function _nFn(s, out) {
            if (this.inner !== NO) return NO;
            // this.param && this.param();
            (this.inner = packPromise(s))._add(new ExhaustListener(out, this));
            return NO;
        },
        less: function less() {
            if (!this.open && this.inner === NO) {
                this.out._c();
            }
        },
        _cFn: function _cFn() {
            this.open = false;
            this.less();
            return NO;
        }
    });

    /* Concat */
    _inherit(ConcatAll, Operator);
    function ConcatAll(param, ins) {
        var self = this;

        ConcatAll._super.call(this, param, ins);
        this.open = true;
        this.streams = [];
        this._proxy = {
            _n: function _n(val) {
                var u = self.out;
                if (u === NO) return;
                u._n(val);
            },
            _c: function _c() {
                self.streams.shift();
                self.startNext();
            },
            _e: function _e(err) {
                self._e(err);
            }
        };
    }
    extend(ConcatAll.prototype, {
        type: 'concatAll',
        startNext: function startNext() {
            var u = this.out,
                streams = this.streams;

            if (u === NO) return;

            if (streams.length) {
                streams[0]._add(this._proxy);
            } else if (!this.open) {
                u._c();
            }
        },
        stopFn: function stopFn() {
            var streams = this.streams;

            this.open = false;
            if (streams.length) {
                streams[0]._remove(this._proxy);
                streams.splice(0);
            }
        },
        startFn: function startFn() {
            this.open = true;
        },
        _n: function _n(val) {
            var streams = this.streams;

            if (this.out === NO) return;
            streams.push(packPromise(val));

            if (streams.length === 1) {
                this.startNext();
            }
        },
        _c: function _c() {
            this.open = false;

            if (!this.streams.length) {
                this.startNext();
            }
        }
    });

    _inherit(Concat, ConcatAll);
    function Concat(param, ins) {
        Concat._super.call(this, param, ins);
    }
    extend(Concat.prototype, {
        type: 'concat',
        startNext: function startNext() {
            var u = this.out,
                streams = this.streams;

            if (u === NO) return;

            if (streams.length) {
                streams[0]._add(this._proxy);
            } else {
                u._c();
            }
        },
        _c: function _c() {
            var streams = this.streams;

            this.open = true;
            streams.push.apply(streams, this.param);

            if (streams.length) {
                this.startNext();
            }
        },
        _n: function _n(t) {
            var u = this.out;
            if (u === NO) return;
            u._n(t);
        }
    });

    /* WithLatestFrom */
    _inherit(WithLatestFrom, Operator);
    function WithLatestFrom(stream, ins) {
        this.latestVal = NO;
        WithLatestFrom._super.call(this, stream, ins);
    }
    extend(WithLatestFrom.prototype, {
        type: 'withLatestFrom',
        startFn: function startFn(out) {
            var self = this;

            this.param._add(this.prod = {
                _n: function _n(n) {
                    self.latestVal = n;
                },
                _e: function _e(err) {
                    out._e(err);
                },

                _c: noop
            });
        },
        _nFn: function _nFn(val, out) {
            var latestVal = this.latestVal;

            if (latestVal === NO) return NO;
            out._n([val, latestVal]);
            return NO;
        },
        _cFn: function _cFn() {
            this.param._remove(this.prod);
        },
        _eFn: function _eFn() {
            this.param._remove(this.prod);
        }
    });

    /* Distinct Until Changed */
    _inherit(DistinctUntilChanged, Operator);
    function DistinctUntilChanged(compare, ins) {
        DistinctUntilChanged._super.call(this, compare, ins);
        this._prevVal = NO;
    }
    extend(DistinctUntilChanged.prototype, {
        type: 'distinctUntilChanged',
        _nFn: function _nFn(val) {
            if ((this.param || this._compare)(val, this._prevVal)) return NO;
            this._prevVal = val;
        },
        _compare: function _compare(val, _prevVal) {
            return val === _prevVal;
        }
    });

    /* Cache */
    _inherit(Cache, Operator);
    function Cache(when, ins) {
        this._cache = NO;
        Cache._super.call(this, when, ins);
    }
    extend(Cache.prototype, {
        type: 'cache',
        startFn: function startFn(out) {
            if (this._expirationTime && this._expirationTime < Date.now()) {
                this._cache = NO;
            }

            if (this._cache !== NO) {
                out._n(this._cache);
                out._c();
                return NO;
            }
        },
        _nFn: function _nFn(val, out) {
            var when = this.param;

            if (this._cache === NO) {
                if (typeof when === 'number') {
                    this._expirationTime = Date.now() + when;
                }

                out._n(this._cache = val);
                out._c();
            }

            return NO;
        }
        // ,_cFn: function() {return NO}
    });

    /* Retry */
    _inherit(Retry, Operator);
    function Retry(count, ins) {
        Retry._super.call(this, count, ins);
        this.param = count || 1;
    }
    extend(Retry.prototype, {
        type: 'retry',
        startFn: function startFn() {
            this.count = this.param;
        },
        _eFn: function _eFn() {
            var _this = this;

            if (this.count) {
                this.count--;
                setTimeout(function () {
                    return _this.ins._add(_this);
                });

                return NO;
            }
        }
    });

    /* BufferCount */
    _inherit(BufferCount, Operator);
    function BufferCount(param, ins) {
        BufferCount._super.call(this, param, ins);
        this.count = param[0] || 1;
        this.start = param[1] || param[0];
    }
    extend(BufferCount.prototype, {
        type: 'bufferCount',
        startFn: function startFn() {
            this.buffer = [];
        },
        _nFn: function _nFn(n, out$) {
            var buffer = this.buffer,
                count = this.count,
                start = this.start;


            buffer.push(n);

            if (buffer.length === count) {
                out$._n(buffer.slice(0));
                buffer.splice(0, start);
            }

            return NO;
        },
        _cFn: function _cFn(_, out$) {
            if (this.buffer.length) {
                out$._n(this.buffer.slice(0));
            }
        }
    });

    /*SkipUntil*/
    _inherit(SkipUntil, Operator);
    function SkipUntil(stream, ins) {
        SkipUntil._super.call(this, stream, ins);
        this._lock = true;
    }
    extend(SkipUntil.prototype, {
        type: 'skipUntil',
        startFn: function startFn() {
            var self = this;
            self._lock = true;

            self.param.take(1)._add({
                _n: function _n() {
                    self._lock = false;
                },
                _c: function _c() {
                    self._lock = false;
                },
                _e: function _e(err) {
                    self._eFn(err);
                }
            });
        },
        _nFn: function _nFn() {
            if (this._lock) return NO;
        }
    });

    /*TakeWhile*/
    _inherit(TakeWhile, Operator);
    function TakeWhile(fn, ins) {
        TakeWhile._super.call(this, fn, ins);
        this.f = fn;
    }
    extend(TakeWhile.prototype, {
        type: 'takeWhile',
        _nFn: function _nFn(t, u) {
            var r = _try(this, t, u);

            if (!r) {
                u._c();
                return NO;
            } else if (r == NO) {
                return NO;
            }
        }
    });

    /*Reduce*/
    _inherit(Reduce, Operator);
    function Reduce(fn, ins) {
        var self = this;

        Reduce._super.call(this, fn, ins);
        this.acc = this.param[1];
        this.f = function (t) {
            return self.param[0](self.acc, t);
        };
    }
    extend(Reduce.prototype, {
        type: 'reduce',
        startFn: function startFn() {
            this.acc = this.param[1];
        },
        _nFn: function _nFn(t, u) {
            var r = _try(this, t, u);

            if (r != NO) {
                this.acc = r;
            }

            return NO;
        },
        _cFn: function _cFn() {
            if (this.acc != NO) {
                this.out._n(this.acc);
            }
        }
    });

    /* warpGroup */
    _inherit(_warpGroup, Operator);
    function _warpGroup(config, ins) {
        _warpGroup._super.call(this, config, ins);
        this._wrap = [];
        this._nid = 1;
        this._cid = 1;
        this._eid = 1;
    }
    _warpGroup.fnFactory = function (key) {
        return function (val, out$) {
            var self = this,
                _wrap = this._wrap,
                delay = this.param[0],
                max = this.param[1] || -1,
                tid = ++this[key + 'id'];

            function checkTid() {
                return tid === self[key + 'id'];
            }

            function _action() {
                _wrap.length && out$[key](_wrap.splice(0));
            }

            _wrap.push(val);
            if (key == '_n') {
                self.debounce$ && self.debounce$._remove(self._debounceProd);

                if (max > 0 && _wrap.length >= max) {
                    _action();
                } else {
                    self.debounce$ = delay(val);
                    self.debounce$._add(self._debounceProd = {
                        _n: function _n() {
                            checkTid() && _action();
                        },
                        _e: function _e(err) {
                            checkTid() && (self.debounce$ = null, out$._e(err));
                        },
                        _c: function _c() {
                            checkTid() && (_action(), self.debounce$ = false);
                        }
                    });
                }
            } else {
                if (key === '_c') {
                    _wrap.length && out$._n(_wrap.splice(0));
                }
                _action();
            }

            return NO;
        };
    };

    extend(_warpGroup.prototype, {
        type: 'warpGroup',
        stopFn: function stopFn() {
            this.debounce$ && this.debounce$._remove(this._debounceProd);
            this.debounce$ = this._debounceProd = null;
        },
        _nFn: _warpGroup.fnFactory('_n'),
        _cFn: _warpGroup.fnFactory('_c')
        // ,_eFn: warpGroup.fnFactory('_e')
    });

    /* Concurrence */
    _inherit(Concurrence, Operator);
    function Concurrence(param, ins) {
        Concurrence._super.call(this, param, ins);
        this.taskCount = 0;
        this.queue = [];
        this.open = true;
        this.f = param[0];
        this.max = param[1] || Infinity;
    }

    extend(Concurrence.prototype, {
        type: 'concurrence',
        releaseOne: function releaseOne() {
            var u = this.out;

            if (u === NO) return;

            this.taskCount--;

            if (this.taskCount < 0) {
                throw 'Concurrence taskCount have a bug!!!!';
            }

            if (this.taskCount <= 0 && !this.open) {
                u._c();
            }

            if (this.queue.length) {
                this._nFn(this.queue.shift(), u);
            }
        },
        startFn: function startFn() {
            this.open = true;
        },
        stopFn: function stopFn() {
            this.queue.splice(0);
            this.taskCount = 0;
            this.open = false;
        },

        _cFn: function _cFn() {
            if (this.taskCount > 0) {
                this.open = false;
                return NO;
            }
        },
        _nFn: function _nFn(val, out$) {
            var self = this,
                task$;

            function _action(value) {
                out$._n(value);
            }

            if (self.taskCount < self.max) {
                self.taskCount++;
                task$ = _try(this, val, out$);

                if (task$ == NO) {
                    return NO;
                }

                packPromise(task$)._add({
                    _n: _action,
                    _c: function _c() {
                        /*self.lastCompleteVal = val;*/self.releaseOne();
                    },
                    _e: function _e(err) {
                        out$._e(err), self.releaseOne();
                    }
                });
            } else {
                self.queue.push(val);
            }

            return NO;
        }
    });

    function fillArr(arr, val, len) {
        for (var i = 0; i < len; i++) {
            arr[len] = val;
        }return arr;
    }

    /*
     * extend。如无特殊说明，操作符都是返回Stream。
     */
    extend(Stream, {
        fromEvent: function fromEvent(el, event) {
            return Stream.create({
                start: function start(prod) {
                    var n = 1;

                    this.listener = function (e) {
                        prod.next({ event: e, index: n++ });
                    };
                    if (el) {
                        el.addEventListener(event, this.listener);
                    }
                },
                stop: function stop() {
                    if (el) {
                        el.removeEventListener(event, this.listener);
                    }
                }
            });
        },
        Subject: function Subject() {
            return Stream.create({
                start: function start() {},
                stop: function stop() {}
            });
        },
        loopAnimationFrame: function loopAnimationFrame() {
            return Stream.create({
                start: function start(prod) {
                    var i = 0,
                        start = false,
                        self = this;

                    function loop() {
                        if (self._open) {
                            start && prod.next(i++);
                            requestAnimationFrame(loop);
                        }

                        if (!start) {
                            start = true;
                        }
                    }

                    self._open = true;
                    loop();
                },
                stop: function stop() {
                    this._open = false;
                }
            });
        },
        timeout: function timeout(n) {
            return Stream.create({
                start: function start(listener) {
                    this.timer = setTimeout(function () {
                        listener.next();
                        listener.complete();
                    }, n);
                },
                stop: function stop() {
                    clearTimeout(this.timer);
                }
            });
        }
    });

    extend(Stream.prototype, {
        flattenMap: function flattenMap(fn) {
            return this.map(isFunction(fn) ? fn : function () {
                return fn;
            }).flatten();
        },

        /**
         * ----1-2-3--|-->
         *     cache()
         * ----1|-->
         *
         * 在接收到上游的值以后next和complete（不管什么值，只要上游next了），并缓存下该值。
         * 跟first()相似，差异在于再次订阅时，cache会立即获得缓存值（如果没有过期）。
         *
         * @param {Number} when 过期时间，获得上流数据后n毫秒后过期；
         * @improtant 警告：切勿在scroll事件使用过期时间。
         *            由于某些版本chrome(webkit)在连续触发scroll事件时，主动“优化”了定时器代码，某些情况（或设备）下scroll事件里的定时器
         *            有几率被延后若干秒，由于cache过期时会取消订阅stream，而stream.js在取消订阅的实现使用了setTimeout(fn, 0)
         * @info Blink deferred a task in order to make scrolling smoother. Your timer and network tasks should take less than 50ms to run to avoid this. Please see https://developers.google.com/web/tools/chrome-devtools/profile/evaluate-performance/rail and https://crbug.com/574343#c40 for more information.
         */
        cache: function cache(when) {
            return new Stream(new Cache(when, this));
        },
        toPromise: function toPromise() {
            var stream = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var listener = {
                    next: function next(res) {
                        stream.removeListener(listener);
                        resolve(res);
                    },

                    error: reject
                };

                stream.addListener(listener);
            });
        },


        // 以下是Rx的同名操作符
        throttle: function throttle(fn) {
            return new Stream(new Throttle(fn, this));
        },
        throttleTime: function throttleTime(time) {
            return new Stream(new Throttle(function () {
                return Stream.timeout(time);
            }, this));
        },
        debounce: function debounce(fn) {
            return new Stream(new Debounce(fn, this));
        },
        debounceTime: function debounceTime(time) {
            return new Stream(new Debounce(function () {
                return Stream.timeout(time);
            }, this));
        },

        // 仅仅执行fn后立即发射值，该操作符不会改变值
        do: function _do(fn) {
            return new Stream(new Do(fn, this));
        },


        // 延迟n毫秒发射
        delay: function delay(n) {
            return new Stream(new DelayWhen(function () {
                return Stream.timeout(n);
            }, this));
        },

        // 延迟的时间取决于factory(val)返回的流什么时候发射值
        delayWhen: function delayWhen(factory) {
            return new Stream(new DelayWhen(factory, this));
        },
        partition: function partition(fn) {
            return [this.filter(function (val) {
                return fn(val);
            }), this.filter(function (val) {
                return fn(val) === false;
            })];
        },
        reduce: function reduce(fn, initVal) {
            return new Stream(new Reduce(arguments, this));
        },
        exhaust: function exhaust() {
            return new Stream(new Exhaust(null, this));
        },
        exhaustMap: function exhaustMap(fn) {
            return this.map(isFunction(fn) ? fn : function () {
                return fn;
            }).exhaust();
        },
        concat: function concat() {
            if (!arguments.length) throw new Error('concat: no next stream');

            return new Stream(new Concat(arguments, this));
        },
        concatAll: function concatAll() {
            return new Stream(new ConcatAll(null, this));
        },
        concatMap: function concatMap(fn) {
            return this.map(isFunction(fn) ? fn : function () {
                return fn;
            }).concatAll();
        },
        withLatestFrom: function withLatestFrom(stream) {
            return new Stream(new WithLatestFrom(stream, this));
        },
        distinctUntilChanged: function distinctUntilChanged(compare) {
            return new Stream(new DistinctUntilChanged(compare, this));
        },


        /**
         * ----1-2-3--X-->
         *     retry(2)
         * ----1-2-3------1-2-3------1-2-3--X-->
         */
        retry: function retry(count) {
            return new Stream(new Retry(count, this));
        },
        bufferCount: function bufferCount(n, start) {
            return new Stream(new BufferCount(slice.call(arguments, 0), this));
        },
        skip: function skip(n) {
            return this.skipUntil(this.take(n));
        },
        skipUntil: function skipUntil(stream) {
            return new Stream(new SkipUntil(stream, this));
        },
        takeWhile: function takeWhile(fn) {
            return new Stream(new TakeWhile(fn, this));
        },


        filterEmpty: function filterEmpty() {
            var empty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            return this.filter(function (val) {
                return val !== empty;
            });
        },

        /*
         * @example
         * stream$.pardonError(fn, filterEmpty)
         * stream$.pardonError(filterEmpty)
         */
        pardonError: function pardonError(fn) {
            var filterEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            return this.replaceError(function (err) {
                if (typeof fn === 'boolean') {
                    filterEmpty = fn;
                    fn = null;
                }

                fn && fn(err);

                return filterEmpty ? Stream.of(null).filterEmpty() : Stream.of(null);
            });
        },

        /**
         * 以下操作符由业务需求衍生出来，属于实验性的功能。
         * 因为后来业务上用不上，所以特性在日后很可能会发生变化。
         */

        /**
         * 缓存一定频率的数据值，延迟发射。
         * @param  {Function|Number} time   维度一：控制时间，每次有新值的时候，都重置计时
         * @param  {Number}          [max]  维度二：控制缓存的最大数量，达到时无视延迟，立即发射
         * @return {Stream}
         */
        warpGroup: function warpGroup(time, max) {
            var t = time;

            if (typeof time === 'number') {
                time = function time() {
                    return Stream.timeout(t);
                };
            }

            return new Stream(new _warpGroup([time, max], this));
        },


        /**
         * 并发限制，要求factory返回一个（子）流。
         * @param  {Function}  factory  子流的工厂函数
         * @param  {Number}    max      最大并发量，每个子流占一个计数，直到它complete。
         *                              为1时可达到类concat效果，为Infinity时可达到类merge效果
         * @return {Stream} 当上一个流complete时，如果子流的计数器为0时，立即complete，否则等到全部子流complete
         */
        concurrence: function concurrence(factory, max) {
            return new Stream(new Concurrence(arguments, this));
        }
    });
});

/***/ }),

/***/ "hTeI":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (global, factory) {
  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.stat = {});
})(this, function (exports) {
  'use strict';

  function getPlatform_old() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.userAgent;

    var isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isWechat = /(?:MicroMessenger)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || isAndroid && !/(?:Mobile)/.test(ua) || isFireFox && /(?:Tablet)/.test(ua),
        isiPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isiPad = /(?:iPad)/.test(ua) && isTablet,
        isPc = !isiPhone && !isAndroid && !isSymbian && !isiPad,
        isMobile = !isPc,
        isYixinliApp = /(?:yixinliApp)/.test(ua),
        isMuseApp = /(?:muse)/.test(ua),
        isCeShiApp = /(?:XinLiCeShiApp)/.test(ua),
        isZiXunApp = /(?:yixinliConsultationApp)/.test(ua),
        yixinliAPPVersion = isYixinliApp ? ua.match(/YIXINLIAPP;*.*.*/i)[0].split(';')[1] : null,
        museAPPVersion = isMuseApp ? ua.match(/muse;*.*.*/i)[0].split(';')[1] : null,
        isBaiduminiapp = /(?:swan-baiduboxapp)/.test(ua),
        isWxmp = /miniProgram/i.test(ua);
    return {
      isWechat: isWechat,
      isTablet: isTablet,
      isiPhone: isiPhone,
      isiPad: isiPad,
      isAndroid: isAndroid,
      isPc: isPc,
      isMobile: isMobile,
      isYixinliApp: isYixinliApp,
      isMuseApp: isMuseApp,
      isCeShiApp: isCeShiApp,
      isZiXunApp: isZiXunApp,
      yixinliAPPVersion: yixinliAPPVersion,
      museAPPVersion: museAPPVersion,
      isChrome: isChrome,
      isBaiduminiapp: isBaiduminiapp,
      isWxmp: isWxmp
    };
  }

  function getPlatform() {
    /*
     * 壹心理App 6.7.7 开始，在webview 内置名为 YXL_INFO的对象，包含以下字段
     * app	string	 	App 名称；比如：壹心理
     * version	string	 	App 版本；比如：6.7.7
     * fullscreen	int	 0｜1	是否全面屏；比如：0
     * system	string	 	系统信息；比如：iOS 13.4.1
     * model	string	 	型号；比如：iPhone
     * */
    // EASY_ENV_IS_NODE 是Node项目的全局变量，用于判断是否在Node server上面运行
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.userAgent;
    var isServer = typeof window === 'undefined';
    var PickYxlInfoString = function PickYxlInfoString(pickdata, filter) {
      // 从YXL_INFO获取字段，并且利用filter的方式，将字符串去转换成想要的格式，方便下一步调用
      if (!isServer && window && window.YXL_INFO && typeof pickdata == 'string') {
        // alert(window.YXL_INFO[pickdata])
        var data = window.YXL_INFO[pickdata];
        // iOS拿到的是字符串，安卓返回的是function，所以需要再执行一下
        if (typeof data === 'function') {
          data = window.YXL_INFO[pickdata](); // 只能直接调用，不能引用data()，安卓方面有安全方面的限制
        }
        if (filter && typeof filter == 'function') {
          return filter(data);
        }
        return data;
      } else {
        return undefined;
      }
    };
    var fullTypeJudge = function fullTypeJudge(Rex, targerStringLikeUA) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { useWierdWay: true },
          type = _ref.type,
          isTargetApp = _ref.isTargetApp,
          _ref$useWierdWay = _ref.useWierdWay,
          useWierdWay = _ref$useWierdWay === undefined ? true : _ref$useWierdWay;

      if (isServer) {
        useWierdWay = false;
      }
      var regExp = Rex;
      var uaMatch = runRex(regExp, targerStringLikeUA);
      // 有window.YXL_INFO，优先级最高，取出app的name，模仿UA判断
      var YxlInfoFilterMap = {
        app: function app(_app) {
          var appRegExName = void 0;
          switch (_app) {
            case '壹心理':
              appRegExName = 'yixinliApp';
              break;
            default:
              appRegExName = 'n0th1ng MaTch';
              break;
          }
          return appRegExName;
        },
        system: function system(_system) {
          /* 会出现几种情况
           * 1. iOS **。*
           * 2. 纯数字版本 安卓返回
           * 3. Android **.* 安卓返回
           * 所以用正则的情况排除iOS去判断是否正则
           */
          var isiOS = /iOS|ios/g.test(_system);
          return isiOS ? 'iOS' : 'Android';
        },
        model: null,
        version: function version(_version) {
          // 由于会存在多个App，所以需要确定是不是targetApp才返回version
          if (isTargetApp) {
            return _version;
          } else {
            return '0.0.0';
          }
        },
        fullscreen: function fullscreen(tof) {
          return !!tof;
        }

        // 其他判断方法
      };var clientNavagitorTry = {
        app: function app() {
          if (!isServer) {
            var _ref2 = __webpack_require__("TF8a").getUrlParams({
              url: location.href,
              params: ['_platform']
            }) || '',
                searchPlatform = _ref2._platform;

            var _ref3 = __webpack_require__("TF8a").getUrlParams({
              url: location.href,
              type: 'hash',
              params: ['_platform']
            }) || '',
                hashPlatform = _ref3._platform;

            if (searchPlatform || hashPlatform) {
              return true;
            } else {
              return false;
            }
          }
        },
        version: function version() {
          if (!isServer && isTargetApp) {
            var _ref4 = __webpack_require__("TF8a").getUrlParams({
              url: location.href,
              params: ['_version']
            }) || '',
                searchVersion = _ref4._version;

            var _ref5 = __webpack_require__("TF8a").getUrlParams({
              url: location.href,
              type: 'hash',
              params: ['_version']
            }) || '',
                hashVersion = _ref5._version;

            if (searchVersion) {
              return searchVersion;
            } else if (hashVersion) {
              return hashVersion;
            } else {
              return false;
            }
          }
        }
      };
      var InfoString = PickYxlInfoString(type, YxlInfoFilterMap[type]);

      var wierdWaysToComfirm = function wierdWaysToComfirm(type) {
        var canTry = clientNavagitorTry[type];
        if (canTry && useWierdWay) {
          var wierdTryResult = canTry(Rex, targerStringLikeUA);
          console.log('wierdTryResult', wierdTryResult);
          return wierdTryResult;
        } else {
          return false;
        }
      };

      var wierdWays = wierdWaysToComfirm(type);

      try {
        if (InfoString) {
          // console.log('result1',  InfoString, regExp.toString(), runRex(regExp, InfoString))

          if (type == 'version') {
            console.log('------------------InfoString', regExp.toString(), InfoString);

            return InfoString + '';
          } else {
            console.log('------------------InfoString', regExp.toString(), runRex(regExp, InfoString));

            return runRex(regExp, InfoString);
          }
        } else if (uaMatch) {
          console.log('------------------', Rex.toString(), uaMatch, wierdWays);
          // console.log('result2',  Rex.toString(), uaMatch, wierdWays)
          // version 需要输出 x.y.z 的数字字符串
          if (type == 'version') {
            if (uaMatch) return targerStringLikeUA.match(regExp)[0].split(';')[1];
          } else {
            return uaMatch;
          }
        } else if (wierdWays) {
          // 实在没办法，只能相信这个判断
          return wierdWays;
        } else {
          return false;
        }
      } catch (e) {
        console.error('Error@getPlaftorm:' + e.toString() + '\nParams' + ('Rex:' + Rex.toString() + ', targerStringLikeUA: ' + targerStringLikeUA + ', type: ' + type + ', isTargetApp: ' + isTargetApp + ', useWierdWay: ' + useWierdWay));
      }
    };

    var runRex = function runRex(Rex, targetString) {
      if (Rex.test) {
        return Rex.test(targetString);
      } else {
        return false;
      }
    };

    var iPadOS13Up = isServer ? false : navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1; //
    // system / 浏览器（微信/Chrome/Firefox） / 设备 / 自家App
    var isWindowsPhone = fullTypeJudge(/(?:Windows Phone)/, ua),
        isSymbian = fullTypeJudge(/(?:SymbianOS)/, ua) || isWindowsPhone,
        isAndroid = fullTypeJudge(/(?:Android)/, ua, { type: 'system' }),
        isiOS = fullTypeJudge(/(?:iOS)/, ua, { type: 'system' }),
        isFireFox = fullTypeJudge(/(?:FireFox)/, ua),
        isChrome = fullTypeJudge(/(?:Chrome|CriOS)/, ua),
        isWechat = fullTypeJudge(/(?:MicroMessenger)/, ua),
        isiPad = fullTypeJudge(/(?:iPad)/, ua, { type: 'model' }) || iPadOS13Up,
        isiPhone = fullTypeJudge(/(?:iPhone)/, ua, { type: 'model' }),
        // /(?:iPhone)/.test(ua) && !isTablet,
    isTablet = fullTypeJudge(/(?:Tablet|PlayBook)/, ua) || isiPad || isAndroid && !fullTypeJudge(/(?:Mobile)/, ua) || isFireFox && fullTypeJudge(/(?:Tablet)/, ua),
        isPc = !isiPhone && !isAndroid && !isSymbian && !isiPad,
        isMobile = !isPc,
        isZiXunApp = fullTypeJudge(/(?:yixinliConsultationApp)/, ua, {
      type: 'app',
      useWierdWay: false
    }),
        //  /(?:yixinliConsultationApp)/.test(ua),
    isYixinliApp = fullTypeJudge(/(?:yixinliApp)/, ua, {
      type: 'app',
      useWierdWay: false
    }),
        isMuseApp = fullTypeJudge(/(?:muse)/, ua, {
      type: 'app',
      useWierdWay: false
    }),
        //  /(?:muse)/.test(ua),
    isCeShiApp = fullTypeJudge(/(?:XinLiCeShiApp)/, ua, {
      type: 'app',
      useWierdWay: false
    }),
        //  /(?:XinLiCeShiApp)/.test(ua),
    yixinliAPPVersion = fullTypeJudge(/^([1-9]\d|[1-9])(.([1-9]\d|\d)){2}$/, ua, {
      type: 'version',
      isTargetApp: isYixinliApp,
      useWierdWay: false // 在非iPad环境都是安全的,不需要用URL判断
    }),
        museAPPVersion = fullTypeJudge(/muse;*.*.*/i, ua, {
      type: 'version',
      isTargetApp: isMuseApp,
      useWierdWay: false
    }),
        //  isMuseApp
    zixunAppVersion = fullTypeJudge(/yixinliConsultationApp;*.*.*/i, ua, {
      type: 'version',
      isTargetApp: isZiXunApp,
      useWierdWay: false
    }),
        isBaiduminiapp = fullTypeJudge(/(?:swan-baiduboxapp)/, ua),
        //  /(?:swan-baiduboxapp)/.test(ua)
    isZiXunShiApp = fullTypeJudge(/(?:(Android|iOS)-Counselor)/, ua),
        isWxmp = fullTypeJudge(/miniProgram/, ua);
    // console.log('YXL', isYixinliApp, 'YXLZX', isZiXunApp)
    var result = {
      // *system 系统类
      isAndroid: isAndroid,
      isiOS: isiOS,
      // 设备类
      isPc: isPc,
      isMobile: isMobile,
      isTablet: isTablet,

      // *model
      isiPhone: isiPhone,
      isiPad: isiPad,

      // 浏览器类
      isChrome: isChrome,
      isWechat: isWechat,

      // *app 类
      isYixinliApp: isYixinliApp,
      isMuseApp: isMuseApp,
      isCeShiApp: isCeShiApp,
      isZiXunApp: isZiXunApp,
      isZiXunShiApp: isZiXunShiApp,
      isWxmp: isWxmp,
      isBaiduminiapp: isBaiduminiapp,

      // *version 类
      yixinliAPPVersion: yixinliAPPVersion,
      museAPPVersion: museAPPVersion,
      zixunAppVersion: zixunAppVersion
      // console.log(result)
    };return result;
  }

  /*
   * 获取当前环境和是否开发状态/环境
   * box/qc环境/本地运行 都被认为是dev状态
   * env 表示当前环境的 boxX/qcX/'' 字符串
   * */
  function getRunningEnv() {
    var WEBPACK_DEV = WEBPACK_DEV || false;
    var result = {};
    var env = location.host.split('.')[0].match(/(qc|box)[0-9]+/g);
    if (!!env || WEBPACK_DEV) {
      result.isDev = 1;
      result.env = env.length > 0 ? env[0] : '';
    } else {
      result.isDev = 0;
      result.env = '';
    }
    return result;
  }

  /*
   * 将 str 转换为适配当前环境的域名
   * */
  function getEnvHost(str) {
    var _getRunningEnv = getRunningEnv(),
        env = _getRunningEnv.env;

    var result = str;
    if (env) {
      result = str.replace(/\./, '-' + env + '.');
    }
    // console.log(result)
    return result;
  }

  function isIOS9() {
    //获取固件版本
    var getOsv = function getOsv() {
      var reg = /OS ((\d+_?){2,3})\s/;
      if (navigator.userAgent.match(/iPad/i) || navigator.platform.match(/iPad/i) || navigator.userAgent.match(/iP(hone|od)/i) || navigator.platform.match(/iP(hone|od)/i)) {
        var _osv = reg.exec(navigator.userAgent);
        if (_osv.length > 0) {
          return _osv[0].replace('OS', '').replace('os', '').replace(/\s+/g, '').replace(/_/g, '.');
        }
      }
      return '';
    };
    var osv = getOsv();
    var osvArr = osv.split('.');
    // console.log('osv', osv, 'osvArr', osvArr)
    if (osvArr && osvArr.length > 0) {
      if (parseInt(osvArr[0]) <= 9) {
        return true;
      }
    }
    return false;
  }

  var urlRule = /(node\-website|yiapi|cpapi|m|static|ce|hd|www|medi|meditation){1}(\-(qc\d{1}|box\d{1}))?.(xinli001|onexinli).(com|cc)/; // eslint-disable-line

  var sigleTonPlatform = function sigleTonPlatform(getP) {
    var result = void 0;
    return function () {
      if (!result) {
        console.log('没有单例');
        result = getP();
      }
      return result;
    };
  };

  var getPlatform$1 = {
    urlRule: urlRule,
    getPlatform_old: getPlatform_old,
    getPlatform: getPlatform,
    getRunningEnv: getRunningEnv,
    getEnvHost: getEnvHost,
    isIOS9: isIOS9
  };

  exports.urlRule = urlRule;
  exports.getPlatform_old = getPlatform_old;
  exports.getPlatform = getPlatform;
  exports.getRunningEnv = getRunningEnv;
  exports.getEnvHost = getEnvHost;
  exports.isIOS9 = isIOS9;
  exports.default = getPlatform$1;

  Object.defineProperty(exports, '__esModule', { value: true });
});

/***/ }),

/***/ "huM2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_interestSwiper_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("f+7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_interestSwiper_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_interestSwiper_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_interestSwiper_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "i039":
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),

/***/ "i3FV":
/***/ (function(module, exports) {

module.exports = {"code":"1","msg":"请求接口成功","data":{"showOrNot":1,"scalePoolId":566,"understanndAvgScore":4.7,"accuracyAvgScore":4.5,"practicalAvgScore":4.7,"commentAvgScore":4.63,"commentTotal":142,"vos":[{"avatar":"https://imgco.xinli001.com/ceping/resources/images/trinyMCE/65926816cbee40c98153678d8348750d.png","nickname":"小鲸鱼368319","createTime":"Feb 11, 2020 9:24:31 AM","commentContent":"还行 90分 疫情当前 从我做起 不给国家添乱 感谢奋战在一线的勇士们！","formatCreateTime":"7小时前"},{"avatar":"https://imgco.xinli001.com/ceping/resources/images/trinyMCE/65926816cbee40c98153678d8348750d.png","nickname":"小鲸鱼368314","createTime":"Feb 11, 2020 8:39:44 AM","commentContent":"根据结果合理安排，正确对待自己的情绪，把控好自己","formatCreateTime":"7小时前"},{"avatar":"https://imgco.xinli001.com/ceping/resources/images/trinyMCE/65926816cbee40c98153678d8348750d.png","nickname":"小鲸鱼368295","createTime":"Feb 11, 2020 7:39:33 AM","commentContent":"分析点很准确，跟着做完，身体很放松，感觉有愉悦感！","formatCreateTime":"8小时前"}]}}

/***/ }),

/***/ "i68Q":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("7ylX") });


/***/ }),

/***/ "iDEd":
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),

/***/ "iKpr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("Ds5P");
var aFunction = __webpack_require__("XSOZ");
var ctx = __webpack_require__("rFzY");
var forOf = __webpack_require__("vmSO");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ "iM2X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__("y325")('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),

/***/ "iUbK":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "ibnl":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("vue-photo-preview",[],t):"object"==typeof exports?exports["vue-photo-preview"]=t():e["vue-photo-preview"]=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var i=n[o]={i:o,l:!1,exports:{}};return e[o].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:o})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/dist/",t(t.s=1)}([function(e,t,n){"use strict";var o=n(7),i=(n.n(o),n(8));n.n(i);t.a={}},function(e,t,n){"use strict";function o(e){return function(){var t=e.apply(this,arguments);return new Promise(function(e,n){function o(i,r){try{var a=t[i](r),l=a.value}catch(e){return void n(e)}if(!a.done)return Promise.resolve(l).then(function(e){o("next",e)},function(e){o("throw",e)});e(l)}return o("next")})}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(2),r=n.n(i),a=n(5),l=n(10),s=n.n(l),u=n(11),c=n.n(u),d=void 0,p={install:function(e,t){var n=e.extend(a.a),t=t||{};d||(d=new n({el:document.createElement("div")}),document.body.appendChild(d.$el));var i=void 0,l=void 0;e.prototype.$preview={self:null,on:function(e,t){i=e,l=t}},e.mixin({data:function(){return{galleryElements:null,galleryPicLoading:!1}},methods:{$previewRefresh:function(){var e=this;setTimeout(function(){e.galleryElements=document.querySelectorAll("img[preview]");for(var t=0,n=e.galleryElements.length;t<n;t++)e.galleryElements[t].setAttribute("data-pswp-uid",t+1),e.galleryElements[t].onclick=e.onThumbnailsClick},200)},onThumbnailsClick:function(e){if(this.galleryPicLoading)return!1;this.galleryPicLoading=!0,e=e||window.event,e.preventDefault?e.preventDefault():e.returnValue=!1;var t,n=e.target||e.srcElement,o=n.getAttribute("preview");t=o?document.querySelectorAll('img[preview="'+o+'"]'):document.querySelectorAll("img[preview]");for(var i,r=t,a=0;a<r.length;a++)if(r[a]===n){i=a;break}return i>=0&&(this.openPhotoSwipe(i,r),this.$emit("preview-open",e,n.src)),!1},openPhotoSwipe:function(n,a,u,p){var f=this;return o(r.a.mark(function o(){var m,h,v,g,w,y,x,b,_;return r.a.wrap(function(o){for(;;)switch(o.prev=o.next){case 0:return m=document.querySelectorAll(".pswp")[0],o.next=3,f.parseThumbnailElements(a);case 3:if(g=o.sent,v={getThumbBoundsFn:function(e){var t=g[e].el,n=window.pageYOffset||document.documentElement.scrollTop,o=t.getBoundingClientRect();return{x:o.left,y:o.top+n,w:o.width}},addCaptionHTMLFn:function(e,t,n){return e.title?(t.children[0].innerHTML=e.title,!0):(t.children[0].innerText="",!1)},showHideOpacity:!0,history:!1,shareEl:!1,maxSpreadZoom:3,getDoubleTapZoom:function(e,t){return e?1.5:t.initialZoomLevel<.7?1:1.5}},!p){o.next=20;break}if(!v.galleryPIDs){o.next=17;break}w=0;case 8:if(!(w<g.length)){o.next=15;break}if(g[w].pid!=n){o.next=12;break}return v.index=w,o.abrupt("break",15);case 12:w++,o.next=8;break;case 15:o.next=18;break;case 17:v.index=parseInt(n,10)-1;case 18:o.next=21;break;case 20:v.index=parseInt(n,10);case 21:if(!isNaN(v.index)){o.next=23;break}return o.abrupt("return");case 23:v=f.extend(v,t),u&&(v.showAnimationDuration=0),h=new s.a(m,c.a,g,v),e.prototype.$preview.self=h,x=!1,b=!0,h.listen("beforeResize",function(){var e=window.devicePixelRatio?window.devicePixelRatio:1;e=Math.min(e,2.5),y=h.viewportSize.x*e,y>=1200||!h.likelyTouchDevice&&y>800||screen.width>1200?x||(x=!0,_=!0):x&&(x=!1,_=!0),_&&!b&&h.invalidateCurrItems(),b&&(b=!1),_=!1}),h.listen("gettingData",function(e,t){t.el.getAttribute("large")?(t.src=t.o.src,t.w=t.o.w,t.h=t.o.h):(t.src=t.m.src,t.w=t.m.w,t.h=t.m.h)}),h.listen("imageLoadComplete",function(e,t){f.galleryPicLoading=!1}),h.listen(i,l),h.init(),d.$el.classList=d.$el.classList+" pswp--zoom-allowed";case 34:case"end":return o.stop()}},o,f)}))()},parseThumbnailElements:function(e){return new Promise(function(t){var n,o,i=[];o={};for(var r=0;r<e.length;r++){if(n=e[r],1===n.nodeType){if(void 0===n.naturalWidth){var r=new Image;r.src=n.src;var a=r.width,l=r.height}else var a=n.naturalWidth,l=n.naturalHeight;!function(r){var u=new Image;u.src=n.getAttribute("large")?n.getAttribute("large"):n.getAttribute("src"),u.text=n.getAttribute("preview-text"),u.author=n.getAttribute("data-author"),u.onload=function(){o={title:u.text,el:e[r],src:u.src,w:a,h:l,author:u.author,o:{src:u.src,w:this.width,h:this.height},m:{src:u.src,w:this.width,h:this.height}},i[r]=o,++s==e.length&&t(i)}}(r);var s=0}}})},extend:function(e,t){for(var n in t)e[n]=t[n];return e},initPreview:function(e){this.galleryElements=document.querySelectorAll(e);for(var t=0,n=this.galleryElements.length;t<n;t++)this.galleryElements[t].setAttribute("data-pswp-uid",t+1),this.galleryElements[t].onclick=this.onThumbnailsClick}},mounted:function(){this.initPreview("img[preview]")}})}};t.default=p,"undefined"==typeof window||window.vuePhotoPreview||(window.vuePhotoPreview=p)},function(e,t,n){e.exports=n(3)},function(e,t,n){var o=function(){return this}()||Function("return this")(),i=o.regeneratorRuntime&&Object.getOwnPropertyNames(o).indexOf("regeneratorRuntime")>=0,r=i&&o.regeneratorRuntime;if(o.regeneratorRuntime=void 0,e.exports=n(4),i)o.regeneratorRuntime=r;else try{delete o.regeneratorRuntime}catch(e){o.regeneratorRuntime=void 0}},function(e,t){!function(t){"use strict";function n(e,t,n,o){var r=t&&t.prototype instanceof i?t:i,a=Object.create(r.prototype),l=new f(o||[]);return a._invoke=u(e,n,l),a}function o(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}function i(){}function r(){}function a(){}function l(e){["next","throw","return"].forEach(function(t){e[t]=function(e){return this._invoke(t,e)}})}function s(e){function t(n,i,r,a){var l=o(e[n],e,i);if("throw"!==l.type){var s=l.arg,u=s.value;return u&&"object"==typeof u&&w.call(u,"__await")?Promise.resolve(u.__await).then(function(e){t("next",e,r,a)},function(e){t("throw",e,r,a)}):Promise.resolve(u).then(function(e){s.value=e,r(s)},a)}a(l.arg)}function n(e,n){function o(){return new Promise(function(o,i){t(e,n,o,i)})}return i=i?i.then(o,o):o()}var i;this._invoke=n}function u(e,t,n){var i=E;return function(r,a){if(i===S)throw new Error("Generator is already running");if(i===k){if("throw"===r)throw a;return h()}for(n.method=r,n.arg=a;;){var l=n.delegate;if(l){var s=c(l,n);if(s){if(s===D)continue;return s}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(i===E)throw i=k,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);i=S;var u=o(e,t,n);if("normal"===u.type){if(i=n.done?k:I,u.arg===D)continue;return{value:u.arg,done:n.done}}"throw"===u.type&&(i=k,n.method="throw",n.arg=u.arg)}}}function c(e,t){var n=e.iterator[t.method];if(n===v){if(t.delegate=null,"throw"===t.method){if(e.iterator.return&&(t.method="return",t.arg=v,c(e,t),"throw"===t.method))return D;t.method="throw",t.arg=new TypeError("The iterator does not provide a 'throw' method")}return D}var i=o(n,e.iterator,t.arg);if("throw"===i.type)return t.method="throw",t.arg=i.arg,t.delegate=null,D;var r=i.arg;return r?r.done?(t[e.resultName]=r.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=v),t.delegate=null,D):r:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,D)}function d(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function p(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function f(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(d,this),this.reset(!0)}function m(e){if(e){var t=e[x];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var n=-1,o=function t(){for(;++n<e.length;)if(w.call(e,n))return t.value=e[n],t.done=!1,t;return t.value=v,t.done=!0,t};return o.next=o}}return{next:h}}function h(){return{value:v,done:!0}}var v,g=Object.prototype,w=g.hasOwnProperty,y="function"==typeof Symbol?Symbol:{},x=y.iterator||"@@iterator",b=y.asyncIterator||"@@asyncIterator",_=y.toStringTag||"@@toStringTag",C="object"==typeof e,T=t.regeneratorRuntime;if(T)return void(C&&(e.exports=T));T=t.regeneratorRuntime=C?e.exports:{},T.wrap=n;var E="suspendedStart",I="suspendedYield",S="executing",k="completed",D={},O={};O[x]=function(){return this};var L=Object.getPrototypeOf,F=L&&L(L(m([])));F&&F!==g&&w.call(F,x)&&(O=F);var A=a.prototype=i.prototype=Object.create(O);r.prototype=A.constructor=a,a.constructor=r,a[_]=r.displayName="GeneratorFunction",T.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===r||"GeneratorFunction"===(t.displayName||t.name))},T.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,a):(e.__proto__=a,_ in e||(e[_]="GeneratorFunction")),e.prototype=Object.create(A),e},T.awrap=function(e){return{__await:e}},l(s.prototype),s.prototype[b]=function(){return this},T.AsyncIterator=s,T.async=function(e,t,o,i){var r=new s(n(e,t,o,i));return T.isGeneratorFunction(t)?r:r.next().then(function(e){return e.done?e.value:r.next()})},l(A),A[_]="Generator",A[x]=function(){return this},A.toString=function(){return"[object Generator]"},T.keys=function(e){var t=[];for(var n in e)t.push(n);return t.reverse(),function n(){for(;t.length;){var o=t.pop();if(o in e)return n.value=o,n.done=!1,n}return n.done=!0,n}},T.values=m,f.prototype={constructor:f,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=v,this.done=!1,this.delegate=null,this.method="next",this.arg=v,this.tryEntries.forEach(p),!e)for(var t in this)"t"===t.charAt(0)&&w.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=v)},stop:function(){this.done=!0;var e=this.tryEntries[0],t=e.completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(e){function t(t,o){return r.type="throw",r.arg=e,n.next=t,o&&(n.method="next",n.arg=v),!!o}if(this.done)throw e;for(var n=this,o=this.tryEntries.length-1;o>=0;--o){var i=this.tryEntries[o],r=i.completion;if("root"===i.tryLoc)return t("end");if(i.tryLoc<=this.prev){var a=w.call(i,"catchLoc"),l=w.call(i,"finallyLoc");if(a&&l){if(this.prev<i.catchLoc)return t(i.catchLoc,!0);if(this.prev<i.finallyLoc)return t(i.finallyLoc)}else if(a){if(this.prev<i.catchLoc)return t(i.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return t(i.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var o=this.tryEntries[n];if(o.tryLoc<=this.prev&&w.call(o,"finallyLoc")&&this.prev<o.finallyLoc){var i=o;break}}i&&("break"===e||"continue"===e)&&i.tryLoc<=t&&t<=i.finallyLoc&&(i=null);var r=i?i.completion:{};return r.type=e,r.arg=t,i?(this.method="next",this.next=i.finallyLoc,D):this.complete(r)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),D},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),p(n),D}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var o=n.completion;if("throw"===o.type){var i=o.arg;p(n)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,n){return this.delegate={iterator:m(e),resultName:t,nextLoc:n},"next"===this.method&&(this.arg=v),D}}}(function(){return this}()||Function("return this")())},function(e,t,n){"use strict";var o=n(0),i=n(9),r=n(6),a=r(o.a,i.a,!1,null,null,null);t.a=a.exports},function(e,t){e.exports=function(e,t,n,o,i,r){var a,l=e=e||{},s=typeof e.default;"object"!==s&&"function"!==s||(a=e,l=e.default);var u="function"==typeof l?l.options:l;t&&(u.render=t.render,u.staticRenderFns=t.staticRenderFns,u._compiled=!0),n&&(u.functional=!0),i&&(u._scopeId=i);var c;if(r?(c=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),o&&o.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(r)},u._ssrRegister=c):o&&(c=o),c){var d=u.functional,p=d?u.render:u.beforeCreate;d?(u._injectStyles=c,u.render=function(e,t){return c.call(t),p(e,t)}):u.beforeCreate=p?[].concat(p,c):[c]}return{esModule:a,exports:l,options:u}}},function(e,t){},function(e,t){},function(e,t,n){"use strict";var o=function(){var e=this,t=e.$createElement;e._self._c;return e._m(0)},i=[function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"pswp",attrs:{tabindex:"-1",role:"dialog","aria-hidden":"true"}},[n("div",{staticClass:"pswp__bg"}),e._v(" "),n("div",{staticClass:"pswp__scroll-wrap"},[n("div",{staticClass:"pswp__container"},[n("div",{staticClass:"pswp__item"}),e._v(" "),n("div",{staticClass:"pswp__item"}),e._v(" "),n("div",{staticClass:"pswp__item"})]),e._v(" "),n("div",{staticClass:"pswp__ui pswp__ui--hidden"},[n("div",{staticClass:"pswp__top-bar"},[n("div",{staticClass:"pswp__counter"}),e._v(" "),n("button",{staticClass:"pswp__button pswp__button--close",attrs:{title:"Close (Esc)"}}),e._v(" "),n("button",{staticClass:"pswp__button pswp__button--share",attrs:{title:"Share"}}),e._v(" "),n("button",{staticClass:"pswp__button pswp__button--fs",attrs:{title:"Toggle fullscreen"}}),e._v(" "),n("button",{staticClass:"pswp__button pswp__button--zoom",attrs:{title:"Zoom in/out"}}),e._v(" "),n("div",{staticClass:"pswp__preloader"},[n("div",{staticClass:"pswp__preloader__icn"},[n("div",{staticClass:"pswp__preloader__cut"},[n("div",{staticClass:"pswp__preloader__donut"})])])])]),e._v(" "),n("div",{staticClass:"pswp__share-modal pswp__share-modal--hidden pswp__single-tap"},[n("div",{staticClass:"pswp__share-tooltip"})]),e._v(" "),n("button",{staticClass:"pswp__button pswp__button--arrow--left",attrs:{title:"Previous (arrow left)"}}),e._v(" "),n("button",{staticClass:"pswp__button pswp__button--arrow--right",attrs:{title:"Next (arrow right)"}}),e._v(" "),n("div",{staticClass:"pswp__caption"},[n("div",{staticClass:"pswp__caption__center"})])])])])}],r={render:o,staticRenderFns:i};t.a=r},function(e,t,n){var o,i;/*! PhotoSwipe - v4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */
!function(r,a){o=a,void 0!==(i="function"==typeof o?o.call(t,n,t,e):o)&&(e.exports=i)}(0,function(){"use strict";return function(e,t,n,o){var i={features:null,bind:function(e,t,n,o){var i=(o?"remove":"add")+"EventListener";t=t.split(" ");for(var r=0;r<t.length;r++)t[r]&&e[i](t[r],n,!1)},isArray:function(e){return e instanceof Array},createEl:function(e,t){var n=document.createElement(t||"div");return e&&(n.className=e),n},getScrollY:function(){var e=window.pageYOffset;return void 0!==e?e:document.documentElement.scrollTop},unbind:function(e,t,n){i.bind(e,t,n,!0)},removeClass:function(e,t){var n=new RegExp("(\\s|^)"+t+"(\\s|$)");e.className=e.className.replace(n," ").replace(/^\s\s*/,"").replace(/\s\s*$/,"")},addClass:function(e,t){i.hasClass(e,t)||(e.className+=(e.className?" ":"")+t)},hasClass:function(e,t){return e.className&&new RegExp("(^|\\s)"+t+"(\\s|$)").test(e.className)},getChildByClass:function(e,t){for(var n=e.firstChild;n;){if(i.hasClass(n,t))return n;n=n.nextSibling}},arraySearch:function(e,t,n){for(var o=e.length;o--;)if(e[o][n]===t)return o;return-1},extend:function(e,t,n){for(var o in t)if(t.hasOwnProperty(o)){if(n&&e.hasOwnProperty(o))continue;e[o]=t[o]}},easing:{sine:{out:function(e){return Math.sin(e*(Math.PI/2))},inOut:function(e){return-(Math.cos(Math.PI*e)-1)/2}},cubic:{out:function(e){return--e*e*e+1}}},detectFeatures:function(){if(i.features)return i.features;var e=i.createEl(),t=e.style,n="",o={};if(o.oldIE=document.all&&!document.addEventListener,o.touch="ontouchstart"in window,window.requestAnimationFrame&&(o.raf=window.requestAnimationFrame,o.caf=window.cancelAnimationFrame),o.pointerEvent=!!window.PointerEvent||navigator.msPointerEnabled,!o.pointerEvent){var r=navigator.userAgent;if(/iP(hone|od)/.test(navigator.platform)){var a=navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);a&&a.length>0&&(a=parseInt(a[1],10))>=1&&a<8&&(o.isOldIOSPhone=!0)}var l=r.match(/Android\s([0-9\.]*)/),s=l?l[1]:0;s=parseFloat(s),s>=1&&(s<4.4&&(o.isOldAndroid=!0),o.androidVersion=s),o.isMobileOpera=/opera mini|opera mobi/i.test(r)}for(var u,c,d=["transform","perspective","animationName"],p=["","webkit","Moz","ms","O"],f=0;f<4;f++){n=p[f];for(var m=0;m<3;m++)u=d[m],c=n+(n?u.charAt(0).toUpperCase()+u.slice(1):u),!o[u]&&c in t&&(o[u]=c);n&&!o.raf&&(n=n.toLowerCase(),o.raf=window[n+"RequestAnimationFrame"],o.raf&&(o.caf=window[n+"CancelAnimationFrame"]||window[n+"CancelRequestAnimationFrame"]))}if(!o.raf){var h=0;o.raf=function(e){var t=(new Date).getTime(),n=Math.max(0,16-(t-h)),o=window.setTimeout(function(){e(t+n)},n);return h=t+n,o},o.caf=function(e){clearTimeout(e)}}return o.svg=!!document.createElementNS&&!!document.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,i.features=o,o}};i.detectFeatures(),i.features.oldIE&&(i.bind=function(e,t,n,o){t=t.split(" ");for(var i,r=(o?"detach":"attach")+"Event",a=function(){n.handleEvent.call(n)},l=0;l<t.length;l++)if(i=t[l])if("object"==typeof n&&n.handleEvent){if(o){if(!n["oldIE"+i])return!1}else n["oldIE"+i]=a;e[r]("on"+i,n["oldIE"+i])}else e[r]("on"+i,n)});var r=this,a={allowPanToNext:!0,spacing:.12,bgOpacity:1,mouseUsed:!1,loop:!0,pinchToClose:!0,closeOnScroll:!0,closeOnVerticalDrag:!0,verticalDragRange:.75,hideAnimationDuration:333,showAnimationDuration:333,showHideOpacity:!1,focus:!0,escKey:!0,arrowKeys:!0,mainScrollEndFriction:.35,panEndFriction:.35,isClickableElement:function(e){return"A"===e.tagName},getDoubleTapZoom:function(e,t){return e?1:t.initialZoomLevel<.7?1:1.33},maxSpreadZoom:1.33,modal:!0,scaleMode:"fit"};i.extend(a,o);var l,s,u,c,d,p,f,m,h,v,g,w,y,x,b,_,C,T,E,I,S,k,D,O,L,F,A,M,R,P,Z,z,N,U,K,H,W,B,G,Y,j,q,$,V,X,J,Q,ee,te,ne,oe,ie,re,ae,le,se,ue,ce=function(){return{x:0,y:0}},de=ce(),pe=ce(),fe=ce(),me={},he=0,ve={},ge=ce(),we=0,ye=!0,xe=[],be={},_e=!1,Ce=function(e,t){i.extend(r,t.publicMethods),xe.push(e)},Te=function(e){var t=Vt();return e>t-1?e-t:e<0?t+e:e},Ee={},Ie=function(e,t){return Ee[e]||(Ee[e]=[]),Ee[e].push(t)},Se=function(e){var t=Ee[e];if(t){var n=Array.prototype.slice.call(arguments);n.shift();for(var o=0;o<t.length;o++)t[o].apply(r,n)}},ke=function(){return(new Date).getTime()},De=function(e){le=e,r.bg.style.opacity=e*a.bgOpacity},Oe=function(e,t,n,o,i){(!_e||i&&i!==r.currItem)&&(o/=i?i.fitRatio:r.currItem.fitRatio),e[k]=w+t+"px, "+n+"px"+y+" scale("+o+")"},Le=function(e){ne&&(e&&(v>r.currItem.fitRatio?_e||(un(r.currItem,!1,!0),_e=!0):_e&&(un(r.currItem),_e=!1)),Oe(ne,fe.x,fe.y,v))},Fe=function(e){e.container&&Oe(e.container.style,e.initialPosition.x,e.initialPosition.y,e.initialZoomLevel,e)},Ae=function(e,t){t[k]=w+e+"px, 0px"+y},Me=function(e,t){if(!a.loop&&t){var n=c+(ge.x*he-e)/ge.x,o=Math.round(e-ht.x);(n<0&&o>0||n>=Vt()-1&&o<0)&&(e=ht.x+o*a.mainScrollEndFriction)}ht.x=e,Ae(e,d)},Re=function(e,t){var n=vt[e]-ve[e];return pe[e]+de[e]+n-n*(t/g)},Pe=function(e,t){e.x=t.x,e.y=t.y,t.id&&(e.id=t.id)},Ze=function(e){e.x=Math.round(e.x),e.y=Math.round(e.y)},ze=null,Ne=function(){ze&&(i.unbind(document,"mousemove",Ne),i.addClass(e,"pswp--has_mouse"),a.mouseUsed=!0,Se("mouseUsed")),ze=setTimeout(function(){ze=null},100)},Ue=function(){i.bind(document,"keydown",r),Z.transform&&i.bind(r.scrollWrap,"click",r),a.mouseUsed||i.bind(document,"mousemove",Ne),i.bind(window,"resize scroll orientationchange",r),Se("bindEvents")},Ke=function(){i.unbind(window,"resize scroll orientationchange",r),i.unbind(window,"scroll",h.scroll),i.unbind(document,"keydown",r),i.unbind(document,"mousemove",Ne),Z.transform&&i.unbind(r.scrollWrap,"click",r),G&&i.unbind(window,f,r),clearTimeout(z),Se("unbindEvents")},He=function(e,t){var n=rn(r.currItem,me,e);return t&&(te=n),n},We=function(e){return e||(e=r.currItem),e.initialZoomLevel},Be=function(e){return e||(e=r.currItem),e.w>0?a.maxSpreadZoom:1},Ge=function(e,t,n,o){return o===r.currItem.initialZoomLevel?(n[e]=r.currItem.initialPosition[e],!0):(n[e]=Re(e,o),n[e]>t.min[e]?(n[e]=t.min[e],!0):n[e]<t.max[e]&&(n[e]=t.max[e],!0))},Ye=function(){if(k){var t=Z.perspective&&!O;return w="translate"+(t?"3d(":"("),void(y=Z.perspective?", 0px)":")")}k="left",i.addClass(e,"pswp--ie"),Ae=function(e,t){t.left=e+"px"},Fe=function(e){var t=e.fitRatio>1?1:e.fitRatio,n=e.container.style,o=t*e.w,i=t*e.h;n.width=o+"px",n.height=i+"px",n.left=e.initialPosition.x+"px",n.top=e.initialPosition.y+"px"},Le=function(){if(ne){var e=ne,t=r.currItem,n=t.fitRatio>1?1:t.fitRatio,o=n*t.w,i=n*t.h;e.width=o+"px",e.height=i+"px",e.left=fe.x+"px",e.top=fe.y+"px"}}},je=function(e){var t="";a.escKey&&27===e.keyCode?t="close":a.arrowKeys&&(37===e.keyCode?t="prev":39===e.keyCode&&(t="next")),t&&(e.ctrlKey||e.altKey||e.shiftKey||e.metaKey||(e.preventDefault?e.preventDefault():e.returnValue=!1,r[t]()))},qe=function(e){e&&(q||j||oe||W)&&(e.preventDefault(),e.stopPropagation())},$e=function(){r.setScrollOffset(0,i.getScrollY())},Ve={},Xe=0,Je=function(e){Ve[e]&&(Ve[e].raf&&F(Ve[e].raf),Xe--,delete Ve[e])},Qe=function(e){Ve[e]&&Je(e),Ve[e]||(Xe++,Ve[e]={})},et=function(){for(var e in Ve)Ve.hasOwnProperty(e)&&Je(e)},tt=function(e,t,n,o,i,r,a){var l,s=ke();Qe(e);var u=function(){if(Ve[e]){if((l=ke()-s)>=o)return Je(e),r(n),void(a&&a());r((n-t)*i(l/o)+t),Ve[e].raf=L(u)}};u()},nt={shout:Se,listen:Ie,viewportSize:me,options:a,isMainScrollAnimating:function(){return oe},getZoomLevel:function(){return v},getCurrentIndex:function(){return c},isDragging:function(){return G},isZooming:function(){return J},setScrollOffset:function(e,t){ve.x=e,P=ve.y=t,Se("updateScrollOffset",ve)},applyZoomPan:function(e,t,n,o){fe.x=t,fe.y=n,v=e,Le(o)},init:function(){if(!l&&!s){var n;r.framework=i,r.template=e,r.bg=i.getChildByClass(e,"pswp__bg"),A=e.className,l=!0,Z=i.detectFeatures(),L=Z.raf,F=Z.caf,k=Z.transform,R=Z.oldIE,r.scrollWrap=i.getChildByClass(e,"pswp__scroll-wrap"),r.container=i.getChildByClass(r.scrollWrap,"pswp__container"),d=r.container.style,r.itemHolders=_=[{el:r.container.children[0],wrap:0,index:-1},{el:r.container.children[1],wrap:0,index:-1},{el:r.container.children[2],wrap:0,index:-1}],_[0].el.style.display=_[2].el.style.display="none",Ye(),h={resize:r.updateSize,orientationchange:function(){clearTimeout(z),z=setTimeout(function(){me.x!==r.scrollWrap.clientWidth&&r.updateSize()},500)},scroll:$e,keydown:je,click:qe};var o=Z.isOldIOSPhone||Z.isOldAndroid||Z.isMobileOpera;for(Z.animationName&&Z.transform&&!o||(a.showAnimationDuration=a.hideAnimationDuration=0),n=0;n<xe.length;n++)r["init"+xe[n]]();if(t){(r.ui=new t(r,i)).init()}Se("firstUpdate"),c=c||a.index||0,(isNaN(c)||c<0||c>=Vt())&&(c=0),r.currItem=$t(c),(Z.isOldIOSPhone||Z.isOldAndroid)&&(ye=!1),e.setAttribute("aria-hidden","false"),a.modal&&(ye?e.style.position="fixed":(e.style.position="absolute",e.style.top=i.getScrollY()+"px")),void 0===P&&(Se("initialLayout"),P=M=i.getScrollY());var u="pswp--open ";for(a.mainClass&&(u+=a.mainClass+" "),a.showHideOpacity&&(u+="pswp--animate_opacity "),u+=O?"pswp--touch":"pswp--notouch",u+=Z.animationName?" pswp--css_animation":"",u+=Z.svg?" pswp--svg":"",i.addClass(e,u),r.updateSize(),p=-1,we=null,n=0;n<3;n++)Ae((n+p)*ge.x,_[n].el.style);R||i.bind(r.scrollWrap,m,r),Ie("initialZoomInEnd",function(){r.setContent(_[0],c-1),r.setContent(_[2],c+1),_[0].el.style.display=_[2].el.style.display="block",a.focus&&e.focus(),Ue()}),r.setContent(_[1],c),r.updateCurrItem(),Se("afterInit"),ye||(x=setInterval(function(){Xe||G||J||v!==r.currItem.initialZoomLevel||r.updateSize()},1e3)),i.addClass(e,"pswp--visible")}},close:function(){l&&(l=!1,s=!0,Se("close"),Ke(),Jt(r.currItem,null,!0,r.destroy))},destroy:function(){Se("destroy"),Gt&&clearTimeout(Gt),e.setAttribute("aria-hidden","true"),e.className=A,x&&clearInterval(x),i.unbind(r.scrollWrap,m,r),i.unbind(window,"scroll",r),bt(),et(),Ee=null},panTo:function(e,t,n){n||(e>te.min.x?e=te.min.x:e<te.max.x&&(e=te.max.x),t>te.min.y?t=te.min.y:t<te.max.y&&(t=te.max.y)),fe.x=e,fe.y=t,Le()},handleEvent:function(e){e=e||window.event,h[e.type]&&h[e.type](e)},goTo:function(e){e=Te(e);var t=e-c;we=t,c=e,r.currItem=$t(c),he-=t,Me(ge.x*he),et(),oe=!1,r.updateCurrItem()},next:function(){r.goTo(c+1)},prev:function(){r.goTo(c-1)},updateCurrZoomItem:function(e){if(e&&Se("beforeChange",0),_[1].el.children.length){var t=_[1].el.children[0];ne=i.hasClass(t,"pswp__zoom-wrap")?t.style:null}else ne=null;te=r.currItem.bounds,g=v=r.currItem.initialZoomLevel,fe.x=te.center.x,fe.y=te.center.y,e&&Se("afterChange")},invalidateCurrItems:function(){b=!0;for(var e=0;e<3;e++)_[e].item&&(_[e].item.needsUpdate=!0)},updateCurrItem:function(e){if(0!==we){var t,n=Math.abs(we);if(!(e&&n<2)){r.currItem=$t(c),_e=!1,Se("beforeChange",we),n>=3&&(p+=we+(we>0?-3:3),n=3);for(var o=0;o<n;o++)we>0?(t=_.shift(),_[2]=t,p++,Ae((p+2)*ge.x,t.el.style),r.setContent(t,c-n+o+1+1)):(t=_.pop(),_.unshift(t),p--,Ae(p*ge.x,t.el.style),r.setContent(t,c+n-o-1-1));if(ne&&1===Math.abs(we)){var i=$t(C);i.initialZoomLevel!==v&&(rn(i,me),un(i),Fe(i))}we=0,r.updateCurrZoomItem(),C=c,Se("afterChange")}}},updateSize:function(t){if(!ye&&a.modal){var n=i.getScrollY();if(P!==n&&(e.style.top=n+"px",P=n),!t&&be.x===window.innerWidth&&be.y===window.innerHeight)return;be.x=window.innerWidth,be.y=window.innerHeight,e.style.height=be.y+"px"}if(me.x=r.scrollWrap.clientWidth,me.y=r.scrollWrap.clientHeight,$e(),ge.x=me.x+Math.round(me.x*a.spacing),ge.y=me.y,Me(ge.x*he),Se("beforeResize"),void 0!==p){for(var o,l,s,u=0;u<3;u++)o=_[u],Ae((u+p)*ge.x,o.el.style),s=c+u-1,a.loop&&Vt()>2&&(s=Te(s)),l=$t(s),l&&(b||l.needsUpdate||!l.bounds)?(r.cleanSlide(l),r.setContent(o,s),1===u&&(r.currItem=l,r.updateCurrZoomItem(!0)),l.needsUpdate=!1):-1===o.index&&s>=0&&r.setContent(o,s),l&&l.container&&(rn(l,me),un(l),Fe(l));b=!1}g=v=r.currItem.initialZoomLevel,te=r.currItem.bounds,te&&(fe.x=te.center.x,fe.y=te.center.y,Le(!0)),Se("resize")},zoomTo:function(e,t,n,o,r){t&&(g=v,vt.x=Math.abs(t.x)-fe.x,vt.y=Math.abs(t.y)-fe.y,Pe(pe,fe));var a=He(e,!1),l={};Ge("x",a,l,e),Ge("y",a,l,e);var s=v,u={x:fe.x,y:fe.y};Ze(l);var c=function(t){1===t?(v=e,fe.x=l.x,fe.y=l.y):(v=(e-s)*t+s,fe.x=(l.x-u.x)*t+u.x,fe.y=(l.y-u.y)*t+u.y),r&&r(t),Le(1===t)};n?tt("customZoomTo",0,1,n,o||i.easing.sine.inOut,c):c(1)}},ot={},it={},rt={},at={},lt={},st=[],ut={},ct=[],dt={},pt=0,ft=ce(),mt=0,ht=ce(),vt=ce(),gt=ce(),wt=function(e,t){return e.x===t.x&&e.y===t.y},yt=function(e,t){return Math.abs(e.x-t.x)<25&&Math.abs(e.y-t.y)<25},xt=function(e,t){return dt.x=Math.abs(e.x-t.x),dt.y=Math.abs(e.y-t.y),Math.sqrt(dt.x*dt.x+dt.y*dt.y)},bt=function(){$&&(F($),$=null)},_t=function(){G&&($=L(_t),zt())},Ct=function(){return!("fit"===a.scaleMode&&v===r.currItem.initialZoomLevel)},Tt=function(e,t){return!(!e||e===document)&&(!(e.getAttribute("class")&&e.getAttribute("class").indexOf("pswp__scroll-wrap")>-1)&&(t(e)?e:Tt(e.parentNode,t)))},Et={},It=function(e,t){return Et.prevent=!Tt(e.target,a.isClickableElement),Se("preventDragEvent",e,t,Et),Et.prevent},St=function(e,t){return t.x=e.pageX,t.y=e.pageY,t.id=e.identifier,t},kt=function(e,t,n){n.x=.5*(e.x+t.x),n.y=.5*(e.y+t.y)},Dt=function(e,t,n){if(e-U>50){var o=ct.length>2?ct.shift():{};o.x=t,o.y=n,ct.push(o),U=e}},Ot=function(){var e=fe.y-r.currItem.initialPosition.y;return 1-Math.abs(e/(me.y/2))},Lt={},Ft={},At=[],Mt=function(e){for(;At.length>0;)At.pop();return D?(ue=0,st.forEach(function(e){0===ue?At[0]=e:1===ue&&(At[1]=e),ue++})):e.type.indexOf("touch")>-1?e.touches&&e.touches.length>0&&(At[0]=St(e.touches[0],Lt),e.touches.length>1&&(At[1]=St(e.touches[1],Ft))):(Lt.x=e.pageX,Lt.y=e.pageY,Lt.id="",At[0]=Lt),At},Rt=function(e,t){var n,o,i,l,s=fe[e]+t[e],u=t[e]>0,c=ht.x+t.x,d=ht.x-ut.x;if(n=s>te.min[e]||s<te.max[e]?a.panEndFriction:1,s=fe[e]+t[e]*n,(a.allowPanToNext||v===r.currItem.initialZoomLevel)&&(ne?"h"!==ie||"x"!==e||j||(u?(s>te.min[e]&&(n=a.panEndFriction,te.min[e]-s,o=te.min[e]-pe[e]),(o<=0||d<0)&&Vt()>1?(l=c,d<0&&c>ut.x&&(l=ut.x)):te.min.x!==te.max.x&&(i=s)):(s<te.max[e]&&(n=a.panEndFriction,s-te.max[e],o=pe[e]-te.max[e]),(o<=0||d>0)&&Vt()>1?(l=c,d>0&&c<ut.x&&(l=ut.x)):te.min.x!==te.max.x&&(i=s))):l=c,"x"===e))return void 0!==l&&(Me(l,!0),V=l!==ut.x),te.min.x!==te.max.x&&(void 0!==i?fe.x=i:V||(fe.x+=t.x*n)),void 0!==l;oe||V||v>r.currItem.fitRatio&&(fe[e]+=t[e]*n)},Pt=function(e){if(!("mousedown"===e.type&&e.button>0)){if(qt)return void e.preventDefault();if(!B||"mousedown"!==e.type){if(It(e,!0)&&e.preventDefault(),Se("pointerDown"),D){var t=i.arraySearch(st,e.pointerId,"id");t<0&&(t=st.length),st[t]={x:e.pageX,y:e.pageY,id:e.pointerId}}var n=Mt(e),o=n.length;X=null,et(),G&&1!==o||(G=re=!0,i.bind(window,f,r),H=se=ae=W=V=q=Y=j=!1,ie=null,Se("firstTouchStart",n),Pe(pe,fe),de.x=de.y=0,Pe(at,n[0]),Pe(lt,at),ut.x=ge.x*he,ct=[{x:at.x,y:at.y}],U=N=ke(),He(v,!0),bt(),_t()),!J&&o>1&&!oe&&!V&&(g=v,j=!1,J=Y=!0,de.y=de.x=0,Pe(pe,fe),Pe(ot,n[0]),Pe(it,n[1]),kt(ot,it,gt),vt.x=Math.abs(gt.x)-fe.x,vt.y=Math.abs(gt.y)-fe.y,Q=ee=xt(ot,it))}}},Zt=function(e){if(e.preventDefault(),D){var t=i.arraySearch(st,e.pointerId,"id");if(t>-1){var n=st[t];n.x=e.pageX,n.y=e.pageY}}if(G){var o=Mt(e);if(ie||q||J)X=o;else if(ht.x!==ge.x*he)ie="h";else{var r=Math.abs(o[0].x-at.x)-Math.abs(o[0].y-at.y);Math.abs(r)>=10&&(ie=r>0?"h":"v",X=o)}}},zt=function(){if(X){var e=X.length;if(0!==e)if(Pe(ot,X[0]),rt.x=ot.x-at.x,rt.y=ot.y-at.y,J&&e>1){if(at.x=ot.x,at.y=ot.y,!rt.x&&!rt.y&&wt(X[1],it))return;Pe(it,X[1]),j||(j=!0,Se("zoomGestureStarted"));var t=xt(ot,it),n=Wt(t);n>r.currItem.initialZoomLevel+r.currItem.initialZoomLevel/15&&(se=!0);var o=1,i=We(),l=Be();if(n<i)if(a.pinchToClose&&!se&&g<=r.currItem.initialZoomLevel){var s=i-n,u=1-s/(i/1.2);De(u),Se("onPinchClose",u),ae=!0}else o=(i-n)/i,o>1&&(o=1),n=i-o*(i/3);else n>l&&(o=(n-l)/(6*i),o>1&&(o=1),n=l+o*i);o<0&&(o=0),Q=t,kt(ot,it,ft),de.x+=ft.x-gt.x,de.y+=ft.y-gt.y,Pe(gt,ft),fe.x=Re("x",n),fe.y=Re("y",n),H=n>v,v=n,Le()}else{if(!ie)return;if(re&&(re=!1,Math.abs(rt.x)>=10&&(rt.x-=X[0].x-lt.x),Math.abs(rt.y)>=10&&(rt.y-=X[0].y-lt.y)),at.x=ot.x,at.y=ot.y,0===rt.x&&0===rt.y)return;if("v"===ie&&a.closeOnVerticalDrag&&!Ct()){de.y+=rt.y,fe.y+=rt.y;var c=Ot();return W=!0,Se("onVerticalDrag",c),De(c),void Le()}Dt(ke(),ot.x,ot.y),q=!0,te=r.currItem.bounds;var d=Rt("x",rt);d||(Rt("y",rt),Ze(fe),Le())}}},Nt=function(e){if(Z.isOldAndroid){if(B&&"mouseup"===e.type)return;e.type.indexOf("touch")>-1&&(clearTimeout(B),B=setTimeout(function(){B=0},600))}Se("pointerUp"),It(e,!1)&&e.preventDefault();var t;if(D){var n=i.arraySearch(st,e.pointerId,"id");if(n>-1)if(t=st.splice(n,1)[0],navigator.msPointerEnabled){var o={4:"mouse",2:"touch",3:"pen"};t.type=o[e.pointerType],t.type||(t.type=e.pointerType||"mouse")}else t.type=e.pointerType||"mouse"}var l,s=Mt(e),u=s.length;if("mouseup"===e.type&&(u=0),2===u)return X=null,!0;1===u&&Pe(lt,s[0]),0!==u||ie||oe||(t||("mouseup"===e.type?t={x:e.pageX,y:e.pageY,type:"mouse"}:e.changedTouches&&e.changedTouches[0]&&(t={x:e.changedTouches[0].pageX,y:e.changedTouches[0].pageY,type:"touch"})),Se("touchRelease",e,t));var c=-1;if(0===u&&(G=!1,i.unbind(window,f,r),bt(),J?c=0:-1!==mt&&(c=ke()-mt)),mt=1===u?ke():-1,l=-1!==c&&c<150?"zoom":"swipe",J&&u<2&&(J=!1,1===u&&(l="zoomPointerUp"),Se("zoomGestureEnded")),X=null,q||j||oe||W)if(et(),K||(K=Ut()),K.calculateSwipeSpeed("x"),W){var d=Ot();if(d<a.verticalDragRange)r.close();else{var p=fe.y,m=le;tt("verticalDrag",0,1,300,i.easing.cubic.out,function(e){fe.y=(r.currItem.initialPosition.y-p)*e+p,De((1-m)*e+m),Le()}),Se("onVerticalDrag",1)}}else{if((V||oe)&&0===u){var h=Ht(l,K);if(h)return;l="zoomPointerUp"}if(!oe)return"swipe"!==l?void Bt():void(!V&&v>r.currItem.fitRatio&&Kt(K))}},Ut=function(){var e,t,n={lastFlickOffset:{},lastFlickDist:{},lastFlickSpeed:{},slowDownRatio:{},slowDownRatioReverse:{},speedDecelerationRatio:{},speedDecelerationRatioAbs:{},distanceOffset:{},backAnimDestination:{},backAnimStarted:{},calculateSwipeSpeed:function(o){ct.length>1?(e=ke()-U+50,t=ct[ct.length-2][o]):(e=ke()-N,t=lt[o]),n.lastFlickOffset[o]=at[o]-t,n.lastFlickDist[o]=Math.abs(n.lastFlickOffset[o]),n.lastFlickDist[o]>20?n.lastFlickSpeed[o]=n.lastFlickOffset[o]/e:n.lastFlickSpeed[o]=0,Math.abs(n.lastFlickSpeed[o])<.1&&(n.lastFlickSpeed[o]=0),n.slowDownRatio[o]=.95,n.slowDownRatioReverse[o]=1-n.slowDownRatio[o],n.speedDecelerationRatio[o]=1},calculateOverBoundsAnimOffset:function(e,t){n.backAnimStarted[e]||(fe[e]>te.min[e]?n.backAnimDestination[e]=te.min[e]:fe[e]<te.max[e]&&(n.backAnimDestination[e]=te.max[e]),void 0!==n.backAnimDestination[e]&&(n.slowDownRatio[e]=.7,n.slowDownRatioReverse[e]=1-n.slowDownRatio[e],n.speedDecelerationRatioAbs[e]<.05&&(n.lastFlickSpeed[e]=0,n.backAnimStarted[e]=!0,tt("bounceZoomPan"+e,fe[e],n.backAnimDestination[e],t||300,i.easing.sine.out,function(t){fe[e]=t,Le()}))))},calculateAnimOffset:function(e){n.backAnimStarted[e]||(n.speedDecelerationRatio[e]=n.speedDecelerationRatio[e]*(n.slowDownRatio[e]+n.slowDownRatioReverse[e]-n.slowDownRatioReverse[e]*n.timeDiff/10),n.speedDecelerationRatioAbs[e]=Math.abs(n.lastFlickSpeed[e]*n.speedDecelerationRatio[e]),n.distanceOffset[e]=n.lastFlickSpeed[e]*n.speedDecelerationRatio[e]*n.timeDiff,fe[e]+=n.distanceOffset[e])},panAnimLoop:function(){if(Ve.zoomPan&&(Ve.zoomPan.raf=L(n.panAnimLoop),n.now=ke(),n.timeDiff=n.now-n.lastNow,n.lastNow=n.now,n.calculateAnimOffset("x"),n.calculateAnimOffset("y"),Le(),n.calculateOverBoundsAnimOffset("x"),n.calculateOverBoundsAnimOffset("y"),n.speedDecelerationRatioAbs.x<.05&&n.speedDecelerationRatioAbs.y<.05))return fe.x=Math.round(fe.x),fe.y=Math.round(fe.y),Le(),void Je("zoomPan")}};return n},Kt=function(e){if(e.calculateSwipeSpeed("y"),te=r.currItem.bounds,e.backAnimDestination={},e.backAnimStarted={},Math.abs(e.lastFlickSpeed.x)<=.05&&Math.abs(e.lastFlickSpeed.y)<=.05)return e.speedDecelerationRatioAbs.x=e.speedDecelerationRatioAbs.y=0,e.calculateOverBoundsAnimOffset("x"),e.calculateOverBoundsAnimOffset("y"),!0;Qe("zoomPan"),e.lastNow=ke(),e.panAnimLoop()},Ht=function(e,t){var n;oe||(pt=c);var o;if("swipe"===e){var l=at.x-lt.x,s=t.lastFlickDist.x<10;l>30&&(s||t.lastFlickOffset.x>20)?o=-1:l<-30&&(s||t.lastFlickOffset.x<-20)&&(o=1)}var u;o&&(c+=o,c<0?(c=a.loop?Vt()-1:0,u=!0):c>=Vt()&&(c=a.loop?0:Vt()-1,u=!0),u&&!a.loop||(we+=o,he-=o,n=!0));var d,p=ge.x*he,f=Math.abs(p-ht.x);return n||p>ht.x==t.lastFlickSpeed.x>0?(d=Math.abs(t.lastFlickSpeed.x)>0?f/Math.abs(t.lastFlickSpeed.x):333,d=Math.min(d,400),d=Math.max(d,250)):d=333,pt===c&&(n=!1),oe=!0,Se("mainScrollAnimStart"),tt("mainScroll",ht.x,p,d,i.easing.cubic.out,Me,function(){et(),oe=!1,pt=-1,(n||pt!==c)&&r.updateCurrItem(),Se("mainScrollAnimComplete")}),n&&r.updateCurrItem(!0),n},Wt=function(e){return 1/ee*e*g},Bt=function(){var e=v,t=We(),n=Be();v<t?e=t:v>n&&(e=n);var o,a=le;return ae&&!H&&!se&&v<t?(r.close(),!0):(ae&&(o=function(e){De((1-a)*e+a)}),r.zoomTo(e,0,200,i.easing.cubic.out,o),!0)};Ce("Gestures",{publicMethods:{initGestures:function(){var e=function(e,t,n,o,i){T=e+t,E=e+n,I=e+o,S=i?e+i:""};D=Z.pointerEvent,D&&Z.touch&&(Z.touch=!1),D?navigator.msPointerEnabled?e("MSPointer","Down","Move","Up","Cancel"):e("pointer","down","move","up","cancel"):Z.touch?(e("touch","start","move","end","cancel"),O=!0):e("mouse","down","move","up"),f=E+" "+I+" "+S,m=T,D&&!O&&(O=navigator.maxTouchPoints>1||navigator.msMaxTouchPoints>1),r.likelyTouchDevice=O,h[T]=Pt,h[E]=Zt,h[I]=Nt,S&&(h[S]=h[I]),Z.touch&&(m+=" mousedown",f+=" mousemove mouseup",h.mousedown=h[T],h.mousemove=h[E],h.mouseup=h[I]),O||(a.allowPanToNext=!1)}}});var Gt,Yt,jt,qt,$t,Vt,Xt,Jt=function(t,n,o,l){Gt&&clearTimeout(Gt),qt=!0,jt=!0;var s;t.initialLayout?(s=t.initialLayout,t.initialLayout=null):s=a.getThumbBoundsFn&&a.getThumbBoundsFn(c);var d=o?a.hideAnimationDuration:a.showAnimationDuration,p=function(){Je("initialZoom"),o?(r.template.removeAttribute("style"),r.bg.removeAttribute("style")):(De(1),n&&(n.style.display="block"),i.addClass(e,"pswp--animated-in"),Se("initialZoom"+(o?"OutEnd":"InEnd"))),l&&l(),qt=!1};if(!d||!s||void 0===s.x)return Se("initialZoom"+(o?"Out":"In")),v=t.initialZoomLevel,Pe(fe,t.initialPosition),Le(),e.style.opacity=o?0:1,De(1),void(d?setTimeout(function(){p()},d):p());!function(){var n=u,l=!r.currItem.src||r.currItem.loadError||a.showHideOpacity;t.miniImg&&(t.miniImg.style.webkitBackfaceVisibility="hidden"),o||(v=s.w/t.w,fe.x=s.x,fe.y=s.y-M,r[l?"template":"bg"].style.opacity=.001,Le()),Qe("initialZoom"),o&&!n&&i.removeClass(e,"pswp--animated-in"),l&&(o?i[(n?"remove":"add")+"Class"](e,"pswp--animate_opacity"):setTimeout(function(){i.addClass(e,"pswp--animate_opacity")},30)),Gt=setTimeout(function(){if(Se("initialZoom"+(o?"Out":"In")),o){var r=s.w/t.w,a={x:fe.x,y:fe.y},u=v,c=le,f=function(t){1===t?(v=r,fe.x=s.x,fe.y=s.y-P):(v=(r-u)*t+u,fe.x=(s.x-a.x)*t+a.x,fe.y=(s.y-P-a.y)*t+a.y),Le(),l?e.style.opacity=1-t:De(c-t*c)};n?tt("initialZoom",0,1,d,i.easing.cubic.out,f,p):(f(1),Gt=setTimeout(p,d+20))}else v=t.initialZoomLevel,Pe(fe,t.initialPosition),Le(),De(1),l?e.style.opacity=1:De(1),Gt=setTimeout(p,d+20)},o?25:90)}()},Qt={},en=[],tn={index:0,errorMsg:'<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',forceProgressiveLoading:!1,preload:[1,1],getNumItemsFn:function(){return Yt.length}},nn=function(){return{center:{x:0,y:0},max:{x:0,y:0},min:{x:0,y:0}}},on=function(e,t,n){var o=e.bounds;o.center.x=Math.round((Qt.x-t)/2),o.center.y=Math.round((Qt.y-n)/2)+e.vGap.top,o.max.x=t>Qt.x?Math.round(Qt.x-t):o.center.x,o.max.y=n>Qt.y?Math.round(Qt.y-n)+e.vGap.top:o.center.y,o.min.x=t>Qt.x?0:o.center.x,o.min.y=n>Qt.y?e.vGap.top:o.center.y},rn=function(e,t,n){if(e.src&&!e.loadError){var o=!n;if(o&&(e.vGap||(e.vGap={top:0,bottom:0}),Se("parseVerticalMargin",e)),Qt.x=t.x,Qt.y=t.y-e.vGap.top-e.vGap.bottom,o){var i=Qt.x/e.w,r=Qt.y/e.h;e.fitRatio=i<r?i:r;var l=a.scaleMode;"orig"===l?n=1:"fit"===l&&(n=e.fitRatio),n>1&&(n=1),e.initialZoomLevel=n,e.bounds||(e.bounds=nn())}if(!n)return;return on(e,e.w*n,e.h*n),o&&n===e.initialZoomLevel&&(e.initialPosition=e.bounds.center),e.bounds}return e.w=e.h=0,e.initialZoomLevel=e.fitRatio=1,e.bounds=nn(),e.initialPosition=e.bounds.center,e.bounds},an=function(e,t,n,o,i,a){t.loadError||o&&(t.imageAppended=!0,un(t,o,t===r.currItem&&_e),n.appendChild(o),a&&setTimeout(function(){t&&t.loaded&&t.placeholder&&(t.placeholder.style.display="none",t.placeholder=null)},500))},ln=function(e){e.loading=!0,e.loaded=!1;var t=e.img=i.createEl("pswp__img","img"),n=function(){e.loading=!1,e.loaded=!0,e.loadComplete?e.loadComplete(e):e.img=null,t.onload=t.onerror=null,t=null};return t.onload=n,t.onerror=function(){e.loadError=!0,n()},t.src=e.src,t},sn=function(e,t){if(e.src&&e.loadError&&e.container)return t&&(e.container.innerHTML=""),e.container.innerHTML=a.errorMsg.replace("%url%",e.src),!0},un=function(e,t,n){if(e.src){t||(t=e.container.lastChild);var o=n?e.w:Math.round(e.w*e.fitRatio),i=n?e.h:Math.round(e.h*e.fitRatio);e.placeholder&&!e.loaded&&(e.placeholder.style.width=o+"px",e.placeholder.style.height=i+"px"),t.style.width=o+"px",t.style.height=i+"px"}},cn=function(){if(en.length){for(var e,t=0;t<en.length;t++)e=en[t],e.holder.index===e.index&&an(e.index,e.item,e.baseDiv,e.img,0,e.clearPlaceholder);en=[]}};Ce("Controller",{publicMethods:{lazyLoadItem:function(e){e=Te(e);var t=$t(e);t&&(!t.loaded&&!t.loading||b)&&(Se("gettingData",e,t),t.src&&ln(t))},initController:function(){i.extend(a,tn,!0),r.items=Yt=n,$t=r.getItemAt,Vt=a.getNumItemsFn,Xt=a.loop,Vt()<3&&(a.loop=!1),Ie("beforeChange",function(e){var t,n=a.preload,o=null===e||e>=0,i=Math.min(n[0],Vt()),l=Math.min(n[1],Vt());for(t=1;t<=(o?l:i);t++)r.lazyLoadItem(c+t);for(t=1;t<=(o?i:l);t++)r.lazyLoadItem(c-t)}),Ie("initialLayout",function(){r.currItem.initialLayout=a.getThumbBoundsFn&&a.getThumbBoundsFn(c)}),Ie("mainScrollAnimComplete",cn),Ie("initialZoomInEnd",cn),Ie("destroy",function(){for(var e,t=0;t<Yt.length;t++)e=Yt[t],e.container&&(e.container=null),e.placeholder&&(e.placeholder=null),e.img&&(e.img=null),e.preloader&&(e.preloader=null),e.loadError&&(e.loaded=e.loadError=!1);en=null})},getItemAt:function(e){return e>=0&&(void 0!==Yt[e]&&Yt[e])},allowProgressiveImg:function(){return a.forceProgressiveLoading||!O||a.mouseUsed||screen.width>1200},setContent:function(e,t){a.loop&&(t=Te(t));var n=r.getItemAt(e.index);n&&(n.container=null);var o,s=r.getItemAt(t);if(!s)return void(e.el.innerHTML="");Se("gettingData",t,s),e.index=t,e.item=s;var u=s.container=i.createEl("pswp__zoom-wrap");if(!s.src&&s.html&&(s.html.tagName?u.appendChild(s.html):u.innerHTML=s.html),sn(s),rn(s,me),!s.src||s.loadError||s.loaded)s.src&&!s.loadError&&(o=i.createEl("pswp__img","img"),o.style.opacity=1,o.src=s.src,un(s,o),an(0,s,u,o));else{if(s.loadComplete=function(n){if(l){if(e&&e.index===t){if(sn(n,!0))return n.loadComplete=n.img=null,rn(n,me),Fe(n),void(e.index===c&&r.updateCurrZoomItem());n.imageAppended?!qt&&n.placeholder&&(n.placeholder.style.display="none",n.placeholder=null):Z.transform&&(oe||qt)?en.push({item:n,baseDiv:u,img:n.img,index:t,holder:e,clearPlaceholder:!0}):an(0,n,u,n.img,0,!0)}n.loadComplete=null,n.img=null,Se("imageLoadComplete",t,n)}},i.features.transform){var d="pswp__img pswp__img--placeholder";d+=s.msrc?"":" pswp__img--placeholder--blank";var p=i.createEl(d,s.msrc?"img":"");s.msrc&&(p.src=s.msrc),un(s,p),u.appendChild(p),s.placeholder=p}s.loading||ln(s),r.allowProgressiveImg()&&(!jt&&Z.transform?en.push({item:s,baseDiv:u,img:s.img,index:t,holder:e}):an(0,s,u,s.img,0,!0))}jt||t!==c?Fe(s):(ne=u.style,Jt(s,o||s.img)),e.el.innerHTML="",e.el.appendChild(u)},cleanSlide:function(e){e.img&&(e.img.onload=e.img.onerror=null),e.loaded=e.loading=e.img=e.imageAppended=!1}}});var dn,pn={},fn=function(e,t,n){var o=document.createEvent("CustomEvent"),i={origEvent:e,target:e.target,releasePoint:t,pointerType:n||"touch"};o.initCustomEvent("pswpTap",!0,!0,i),e.target.dispatchEvent(o)};Ce("Tap",{publicMethods:{initTap:function(){Ie("firstTouchStart",r.onTapStart),Ie("touchRelease",r.onTapRelease),Ie("destroy",function(){pn={},dn=null})},onTapStart:function(e){e.length>1&&(clearTimeout(dn),dn=null)},onTapRelease:function(e,t){if(t&&!q&&!Y&&!Xe){var n=t;if(dn&&(clearTimeout(dn),dn=null,yt(n,pn)))return void Se("doubleTap",n);if("mouse"===t.type)return void fn(e,t,"mouse");if("BUTTON"===e.target.tagName.toUpperCase()||i.hasClass(e.target,"pswp__single-tap"))return void fn(e,t);Pe(pn,n),dn=setTimeout(function(){fn(e,t),dn=null},300)}}}});var mn;Ce("DesktopZoom",{publicMethods:{initDesktopZoom:function(){R||(O?Ie("mouseUsed",function(){r.setupDesktopZoom()}):r.setupDesktopZoom(!0))},setupDesktopZoom:function(t){mn={};var n="wheel mousewheel DOMMouseScroll";Ie("bindEvents",function(){i.bind(e,n,r.handleMouseWheel)}),Ie("unbindEvents",function(){mn&&i.unbind(e,n,r.handleMouseWheel)}),r.mouseZoomedIn=!1;var o,a=function(){r.mouseZoomedIn&&(i.removeClass(e,"pswp--zoomed-in"),r.mouseZoomedIn=!1),v<1?i.addClass(e,"pswp--zoom-allowed"):i.removeClass(e,"pswp--zoom-allowed"),l()},l=function(){o&&(i.removeClass(e,"pswp--dragging"),o=!1)};Ie("resize",a),Ie("afterChange",a),Ie("pointerDown",function(){r.mouseZoomedIn&&(o=!0,i.addClass(e,"pswp--dragging"))}),Ie("pointerUp",l),t||a()},handleMouseWheel:function(e){if(v<=r.currItem.fitRatio)return a.modal&&(!a.closeOnScroll||Xe||G?e.preventDefault():k&&Math.abs(e.deltaY)>2&&(u=!0,r.close())),!0;if(e.stopPropagation(),mn.x=0,"deltaX"in e)1===e.deltaMode?(mn.x=18*e.deltaX,mn.y=18*e.deltaY):(mn.x=e.deltaX,mn.y=e.deltaY);else if("wheelDelta"in e)e.wheelDeltaX&&(mn.x=-.16*e.wheelDeltaX),e.wheelDeltaY?mn.y=-.16*e.wheelDeltaY:mn.y=-.16*e.wheelDelta;else{if(!("detail"in e))return;mn.y=e.detail}He(v,!0);var t=fe.x-mn.x,n=fe.y-mn.y;(a.modal||t<=te.min.x&&t>=te.max.x&&n<=te.min.y&&n>=te.max.y)&&e.preventDefault(),r.panTo(t,n)},toggleDesktopZoom:function(t){t=t||{x:me.x/2+ve.x,y:me.y/2+ve.y};var n=a.getDoubleTapZoom(!0,r.currItem),o=v===n;r.mouseZoomedIn=!o,r.zoomTo(o?r.currItem.initialZoomLevel:n,t,333),i[(o?"remove":"add")+"Class"](e,"pswp--zoomed-in")}}});var hn,vn,gn,wn,yn,xn,bn,_n,Cn,Tn,En,In,Sn={history:!0,galleryUID:1},kn=function(){return En.hash.substring(1)},Dn=function(){hn&&clearTimeout(hn),gn&&clearTimeout(gn)},On=function(){var e=kn(),t={};if(e.length<5)return t;var n,o=e.split("&");for(n=0;n<o.length;n++)if(o[n]){var i=o[n].split("=");i.length<2||(t[i[0]]=i[1])}if(a.galleryPIDs){var r=t.pid;for(t.pid=0,n=0;n<Yt.length;n++)if(Yt[n].pid===r){t.pid=n;break}}else t.pid=parseInt(t.pid,10)-1;return t.pid<0&&(t.pid=0),t},Ln=function(){if(gn&&clearTimeout(gn),Xe||G)return void(gn=setTimeout(Ln,500));wn?clearTimeout(vn):wn=!0;var e=c+1,t=$t(c);t.hasOwnProperty("pid")&&(e=t.pid);var n=bn+"&gid="+a.galleryUID+"&pid="+e;_n||-1===En.hash.indexOf(n)&&(Tn=!0);var o=En.href.split("#")[0]+"#"+n;In?"#"+n!==window.location.hash&&history[_n?"replaceState":"pushState"]("",document.title,o):_n?En.replace(o):En.hash=n,_n=!0,vn=setTimeout(function(){wn=!1},60)};Ce("History",{publicMethods:{initHistory:function(){if(i.extend(a,Sn,!0),a.history){En=window.location,Tn=!1,Cn=!1,_n=!1,bn=kn(),In="pushState"in history,bn.indexOf("gid=")>-1&&(bn=bn.split("&gid=")[0],bn=bn.split("?gid=")[0]),Ie("afterChange",r.updateURL),Ie("unbindEvents",function(){i.unbind(window,"hashchange",r.onHashChange)});var e=function(){xn=!0,Cn||(Tn?history.back():bn?En.hash=bn:In?history.pushState("",document.title,En.pathname+En.search):En.hash=""),Dn()};Ie("unbindEvents",function(){u&&e()}),Ie("destroy",function(){xn||e()}),Ie("firstUpdate",function(){c=On().pid});var t=bn.indexOf("pid=");t>-1&&(bn=bn.substring(0,t),"&"===bn.slice(-1)&&(bn=bn.slice(0,-1))),setTimeout(function(){l&&i.bind(window,"hashchange",r.onHashChange)},40)}},onHashChange:function(){if(kn()===bn)return Cn=!0,void r.close();wn||(yn=!0,r.goTo(On().pid),yn=!1)},updateURL:function(){Dn(),yn||(_n?hn=setTimeout(Ln,800):Ln())}}}),i.extend(r,nt)}})},function(e,t,n){var o,i;/*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */
!function(r,a){o=a,void 0!==(i="function"==typeof o?o.call(t,n,t,e):o)&&(e.exports=i)}(0,function(){"use strict";return function(e,t){var n,o,i,r,a,l,s,u,c,d,p,f,m,h,v,g,w,y,x,b=this,_=!1,C=!0,T=!0,E={barsSize:{top:44,bottom:"auto"},closeElClasses:["item","caption","zoom-wrap","ui","top-bar"],timeToIdle:4e3,timeToIdleOutside:1e3,loadingIndicatorDelay:1e3,addCaptionHTMLFn:function(e,t){return e.title?(t.children[0].innerHTML=e.title,!0):(t.children[0].innerHTML="",!1)},closeEl:!0,captionEl:!0,fullscreenEl:!0,zoomEl:!0,shareEl:!0,counterEl:!0,arrowEl:!0,preloaderEl:!0,tapToClose:!1,tapToToggleControls:!0,clickToCloseNonZoomable:!0,shareButtons:[{id:"facebook",label:"Share on Facebook",url:"https://www.facebook.com/sharer/sharer.php?u={{url}}"},{id:"twitter",label:"Tweet",url:"https://twitter.com/intent/tweet?text={{text}}&url={{url}}"},{id:"pinterest",label:"Pin it",url:"http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"},{id:"download",label:"Download image",url:"{{raw_image_url}}",download:!0}],getImageURLForShare:function(){return e.currItem.src||""},getPageURLForShare:function(){return window.location.href},getTextForShare:function(){return e.currItem.title||""},indexIndicatorSep:" / ",fitControlsWidth:1200},I=function(e){if(g)return!0;e=e||window.event,v.timeToIdle&&v.mouseUsed&&!c&&P();for(var n,o,i=e.target||e.srcElement,r=i.getAttribute("class")||"",a=0;a<B.length;a++)n=B[a],n.onTap&&r.indexOf("pswp__"+n.name)>-1&&(n.onTap(),o=!0);if(o){e.stopPropagation&&e.stopPropagation(),g=!0;var l=t.features.isOldAndroid?600:30;w=setTimeout(function(){g=!1},l)}},S=function(){return!e.likelyTouchDevice||v.mouseUsed||screen.width>v.fitControlsWidth},k=function(e,n,o){t[(o?"add":"remove")+"Class"](e,"pswp__"+n)},D=function(){var e=1===v.getNumItemsFn();e!==h&&(k(o,"ui--one-slide",e),h=e)},O=function(){k(s,"share-modal--hidden",T)},L=function(){return T=!T,T?(t.removeClass(s,"pswp__share-modal--fade-in"),setTimeout(function(){T&&O()},300)):(O(),setTimeout(function(){T||t.addClass(s,"pswp__share-modal--fade-in")},30)),T||A(),!1},F=function(t){t=t||window.event;var n=t.target||t.srcElement;return e.shout("shareLinkClick",t,n),!!n.href&&(!!n.hasAttribute("download")||(window.open(n.href,"pswp_share","scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left="+(window.screen?Math.round(screen.width/2-275):100)),T||L(),!1))},A=function(){for(var e,t,n,o,i,r="",a=0;a<v.shareButtons.length;a++)e=v.shareButtons[a],n=v.getImageURLForShare(e),o=v.getPageURLForShare(e),i=v.getTextForShare(e),t=e.url.replace("{{url}}",encodeURIComponent(o)).replace("{{image_url}}",encodeURIComponent(n)).replace("{{raw_image_url}}",n).replace("{{text}}",encodeURIComponent(i)),r+='<a href="'+t+'" target="_blank" class="pswp__share--'+e.id+'"'+(e.download?"download":"")+">"+e.label+"</a>",v.parseShareButtonOut&&(r=v.parseShareButtonOut(e,r));s.children[0].innerHTML=r,s.children[0].onclick=F},M=function(e){for(var n=0;n<v.closeElClasses.length;n++)if(t.hasClass(e,"pswp__"+v.closeElClasses[n]))return!0},R=0,P=function(){clearTimeout(x),R=0,c&&b.setIdle(!1)},Z=function(e){e=e||window.event;var t=e.relatedTarget||e.toElement;t&&"HTML"!==t.nodeName||(clearTimeout(x),x=setTimeout(function(){b.setIdle(!0)},v.timeToIdleOutside))},z=function(){v.fullscreenEl&&!t.features.isOldAndroid&&(n||(n=b.getFullscreenAPI()),n?(t.bind(document,n.eventK,b.updateFullscreen),b.updateFullscreen(),t.addClass(e.template,"pswp--supports-fs")):t.removeClass(e.template,"pswp--supports-fs"))},N=function(){v.preloaderEl&&(U(!0),d("beforeChange",function(){clearTimeout(m),m=setTimeout(function(){e.currItem&&e.currItem.loading?(!e.allowProgressiveImg()||e.currItem.img&&!e.currItem.img.naturalWidth)&&U(!1):U(!0)},v.loadingIndicatorDelay)}),d("imageLoadComplete",function(t,n){e.currItem===n&&U(!0)}))},U=function(e){f!==e&&(k(p,"preloader--active",!e),f=e)},K=function(e){var n=e.vGap;if(S()){var a=v.barsSize;if(v.captionEl&&"auto"===a.bottom)if(r||(r=t.createEl("pswp__caption pswp__caption--fake"),r.appendChild(t.createEl("pswp__caption__center")),o.insertBefore(r,i),t.addClass(o,"pswp__ui--fit")),v.addCaptionHTMLFn(e,r,!0)){var l=r.clientHeight;n.bottom=parseInt(l,10)||44}else n.bottom=a.top;else n.bottom="auto"===a.bottom?0:a.bottom;n.top=a.top}else n.top=n.bottom=0},H=function(){v.timeToIdle&&d("mouseUsed",function(){t.bind(document,"mousemove",P),t.bind(document,"mouseout",Z),y=setInterval(function(){2===++R&&b.setIdle(!0)},v.timeToIdle/2)})},W=function(){d("onVerticalDrag",function(e){C&&e<.95?b.hideControls():!C&&e>=.95&&b.showControls()});var e;d("onPinchClose",function(t){C&&t<.9?(b.hideControls(),e=!0):e&&!C&&t>.9&&b.showControls()}),d("zoomGestureEnded",function(){(e=!1)&&!C&&b.showControls()})},B=[{name:"caption",option:"captionEl",onInit:function(e){i=e}},{name:"share-modal",option:"shareEl",onInit:function(e){s=e},onTap:function(){L()}},{name:"button--share",option:"shareEl",onInit:function(e){l=e},onTap:function(){L()}},{name:"button--zoom",option:"zoomEl",onTap:e.toggleDesktopZoom},{name:"counter",option:"counterEl",onInit:function(e){a=e}},{name:"button--close",option:"closeEl",onTap:e.close},{name:"button--arrow--left",option:"arrowEl",onTap:e.prev},{name:"button--arrow--right",option:"arrowEl",onTap:e.next},{name:"button--fs",option:"fullscreenEl",onTap:function(){n.isFullscreen()?n.exit():n.enter()}},{name:"preloader",option:"preloaderEl",onInit:function(e){p=e}}],G=function(){var e,n,i,r=function(o){if(o)for(var r=o.length,a=0;a<r;a++){e=o[a],n=e.className;for(var l=0;l<B.length;l++)i=B[l],n.indexOf("pswp__"+i.name)>-1&&(v[i.option]?(t.removeClass(e,"pswp__element--disabled"),i.onInit&&i.onInit(e)):t.addClass(e,"pswp__element--disabled"))}};r(o.children);var a=t.getChildByClass(o,"pswp__top-bar");a&&r(a.children)};b.init=function(){t.extend(e.options,E,!0),v=e.options,o=t.getChildByClass(e.scrollWrap,"pswp__ui"),d=e.listen,W(),d("beforeChange",b.update),d("doubleTap",function(t){var n=e.currItem.initialZoomLevel;e.getZoomLevel()!==n?e.zoomTo(n,t,333):e.zoomTo(v.getDoubleTapZoom(!1,e.currItem),t,333)}),d("preventDragEvent",function(e,t,n){var o=e.target||e.srcElement;o&&o.getAttribute("class")&&e.type.indexOf("mouse")>-1&&(o.getAttribute("class").indexOf("__caption")>0||/(SMALL|STRONG|EM)/i.test(o.tagName))&&(n.prevent=!1)}),d("bindEvents",function(){t.bind(o,"pswpTap click",I),t.bind(e.scrollWrap,"pswpTap",b.onGlobalTap),e.likelyTouchDevice||t.bind(e.scrollWrap,"mouseover",b.onMouseOver)}),d("unbindEvents",function(){T||L(),y&&clearInterval(y),t.unbind(document,"mouseout",Z),t.unbind(document,"mousemove",P),t.unbind(o,"pswpTap click",I),t.unbind(e.scrollWrap,"pswpTap",b.onGlobalTap),t.unbind(e.scrollWrap,"mouseover",b.onMouseOver),n&&(t.unbind(document,n.eventK,b.updateFullscreen),n.isFullscreen()&&(v.hideAnimationDuration=0,n.exit()),n=null)}),d("destroy",function(){v.captionEl&&(r&&o.removeChild(r),t.removeClass(i,"pswp__caption--empty")),s&&(s.children[0].onclick=null),t.removeClass(o,"pswp__ui--over-close"),t.addClass(o,"pswp__ui--hidden"),b.setIdle(!1)}),v.showAnimationDuration||t.removeClass(o,"pswp__ui--hidden"),d("initialZoomIn",function(){v.showAnimationDuration&&t.removeClass(o,"pswp__ui--hidden")}),d("initialZoomOut",function(){t.addClass(o,"pswp__ui--hidden")}),d("parseVerticalMargin",K),G(),v.shareEl&&l&&s&&(T=!0),D(),H(),z(),N()},b.setIdle=function(e){c=e,k(o,"ui--idle",e)},b.update=function(){C&&e.currItem?(b.updateIndexIndicator(),v.captionEl&&(v.addCaptionHTMLFn(e.currItem,i),k(i,"caption--empty",!e.currItem.title)),_=!0):_=!1,T||L(),D()},b.updateFullscreen=function(o){o&&setTimeout(function(){e.setScrollOffset(0,t.getScrollY())},50),t[(n.isFullscreen()?"add":"remove")+"Class"](e.template,"pswp--fs")},b.updateIndexIndicator=function(){v.counterEl&&(a.innerHTML=e.getCurrentIndex()+1+v.indexIndicatorSep+v.getNumItemsFn())},b.onGlobalTap=function(n){n=n||window.event;var o=n.target||n.srcElement;if(!g)if(n.detail&&"mouse"===n.detail.pointerType){if(M(o))return void e.close();t.hasClass(o,"pswp__img")&&(1===e.getZoomLevel()&&e.getZoomLevel()<=e.currItem.fitRatio?v.clickToCloseNonZoomable&&e.close():e.toggleDesktopZoom(n.detail.releasePoint))}else if(v.tapToToggleControls&&(C?b.hideControls():b.showControls()),v.tapToClose&&(t.hasClass(o,"pswp__img")||M(o)))return void e.close()},b.onMouseOver=function(e){e=e||window.event;var t=e.target||e.srcElement;k(o,"ui--over-close",M(t))},b.hideControls=function(){t.addClass(o,"pswp__ui--hidden"),C=!1},b.showControls=function(){C=!0,_||b.update(),t.removeClass(o,"pswp__ui--hidden")},b.supportsFullscreen=function(){var e=document;return!!(e.exitFullscreen||e.mozCancelFullScreen||e.webkitExitFullscreen||e.msExitFullscreen)},b.getFullscreenAPI=function(){var t,n=document.documentElement,o="fullscreenchange";return n.requestFullscreen?t={enterK:"requestFullscreen",exitK:"exitFullscreen",elementK:"fullscreenElement",eventK:o}:n.mozRequestFullScreen?t={enterK:"mozRequestFullScreen",exitK:"mozCancelFullScreen",elementK:"mozFullScreenElement",eventK:"moz"+o}:n.webkitRequestFullscreen?t={enterK:"webkitRequestFullscreen",exitK:"webkitExitFullscreen",elementK:"webkitFullscreenElement",eventK:"webkit"+o}:n.msRequestFullscreen&&(t={enterK:"msRequestFullscreen",exitK:"msExitFullscreen",elementK:"msFullscreenElement",eventK:"MSFullscreenChange"}),t&&(t.enter=function(){if(u=v.closeOnScroll,v.closeOnScroll=!1,"webkitRequestFullscreen"!==this.enterK)return e.template[this.enterK]();e.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)},t.exit=function(){return v.closeOnScroll=u,document[this.exitK]()},t.isFullscreen=function(){return document[this.elementK]}),t}}})}])});
//# sourceMappingURL=vue-photo-preview.js.map

/***/ }),

/***/ "iyvF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_globalLoading_vue_vue_type_style_index_0_id_67ded17d_lang_scss_scoped_true___ = __webpack_require__("dvtS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_globalLoading_vue_vue_type_style_index_0_id_67ded17d_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_globalLoading_vue_vue_type_style_index_0_id_67ded17d_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_globalLoading_vue_vue_type_style_index_0_id_67ded17d_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "j/Lv":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__("Ds5P");

$export($export.S, 'System', { global: __webpack_require__("OzIq") });


/***/ }),

/***/ "j1ja":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__("4M2W");

__webpack_require__("SldL");

__webpack_require__("Wwne");

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "j42X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__("Ds5P");
var toIObject = __webpack_require__("PHqh");
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__("Q6Nf") != Object || !__webpack_require__("NNrz")(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "jB26":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("DIVP");
var toPrimitive = __webpack_require__("s4j0");
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),

/***/ "jFbC":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Cdx3");
module.exports = __webpack_require__("FeBl").Object.keys;


/***/ }),

/***/ "jIgu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/btn-bottom.0d60224.png";

/***/ }),

/***/ "jKW+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("kM2E");
var newPromiseCapability = __webpack_require__("qARP");
var perform = __webpack_require__("dNDb");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "jgOX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-brand.85c4118.svg";

/***/ }),

/***/ "jhxf":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("UKM+");
var document = __webpack_require__("OzIq").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "jrHM":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("Ds5P");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("gvDt").set });


/***/ }),

/***/ "k/xo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("1qR5");

/***/ }),

/***/ "kBOG":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__("Ds5P");
var sign = __webpack_require__("cwmK");

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),

/***/ "kJ6Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kM2E":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var ctx = __webpack_require__("+ZMJ");
var hide = __webpack_require__("hJx8");
var has = __webpack_require__("D2L2");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "kTdg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("wI4N");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "kic5":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("UKM+");
var setPrototypeOf = __webpack_require__("gvDt").set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),

/***/ "kkCw":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("VWgF")('wks');
var uid = __webpack_require__("ulTY");
var Symbol = __webpack_require__("OzIq").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "knuC":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "kqpo":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("u0PK");
var defined = __webpack_require__("/whu");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "kxFB":
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),

/***/ "l3EO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_yxlToast_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("tih0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_yxlToast_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_yxlToast_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_yxlToast_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "l4ZY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),

/***/ "lDLk":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("DIVP");
var IE8_DOM_DEFINE = __webpack_require__("xZa+");
var toPrimitive = __webpack_require__("s4j0");
var dP = Object.defineProperty;

exports.f = __webpack_require__("bUqO") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "lKE8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("bUqO");
var getKeys = __webpack_require__("Qh14");
var toIObject = __webpack_require__("PHqh");
var isEnum = __webpack_require__("Y1aA").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ "lOnJ":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "lSFJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "laHn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lkT3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var $reduce = __webpack_require__("FkIZ");

$export($export.P + $export.F * !__webpack_require__("NNrz")([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),

/***/ "lktj":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("Ibhu");
var enumBugKeys = __webpack_require__("xnc9");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "lmiR":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @fileoverview
 * - Using the 'QRCode for Javascript library'
 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
 * - this library has no dependencies.
 * 
 * @author davidshimjs
 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
 */
/**
 * 2017/7/26 added by Lin WeiLong
 */
(function () {
	//---------------------------------------------------------------------
	// QRCode for JavaScript
	//
	// Copyright (c) 2009 Kazuhiko Arase
	//
	// URL: http://www.d-project.com/
	//
	// Licensed under the MIT license:
	//   http://www.opensource.org/licenses/mit-license.php
	//
	// The word "QR Code" is registered trademark of 
	// DENSO WAVE INCORPORATED
	//   http://www.denso-wave.com/qrcode/faqpatent-e.html
	//
	//---------------------------------------------------------------------

	var QRCode;

	function QR8bitByte(data) {
		this.mode = QRMode.MODE_8BIT_BYTE;
		this.data = data;
		this.parsedData = [];

		// Added to support UTF-8 Characters
		for (var i = 0, l = this.data.length; i < l; i++) {
			var byteArray = [];
			var code = this.data.charCodeAt(i);

			if (code > 0x10000) {
				byteArray[0] = 0xF0 | (code & 0x1C0000) >>> 18;
				byteArray[1] = 0x80 | (code & 0x3F000) >>> 12;
				byteArray[2] = 0x80 | (code & 0xFC0) >>> 6;
				byteArray[3] = 0x80 | code & 0x3F;
			} else if (code > 0x800) {
				byteArray[0] = 0xE0 | (code & 0xF000) >>> 12;
				byteArray[1] = 0x80 | (code & 0xFC0) >>> 6;
				byteArray[2] = 0x80 | code & 0x3F;
			} else if (code > 0x80) {
				byteArray[0] = 0xC0 | (code & 0x7C0) >>> 6;
				byteArray[1] = 0x80 | code & 0x3F;
			} else {
				byteArray[0] = code;
			}

			this.parsedData.push(byteArray);
		}

		this.parsedData = Array.prototype.concat.apply([], this.parsedData);

		if (this.parsedData.length != this.data.length) {
			this.parsedData.unshift(191);
			this.parsedData.unshift(187);
			this.parsedData.unshift(239);
		}
	}

	QR8bitByte.prototype = {
		getLength: function getLength(buffer) {
			return this.parsedData.length;
		},
		write: function write(buffer) {
			for (var i = 0, l = this.parsedData.length; i < l; i++) {
				buffer.put(this.parsedData[i], 8);
			}
		}
	};

	function QRCodeModel(typeNumber, errorCorrectLevel) {
		this.typeNumber = typeNumber;
		this.errorCorrectLevel = errorCorrectLevel;
		this.modules = null;
		this.moduleCount = 0;
		this.dataCache = null;
		this.dataList = [];
	}

	QRCodeModel.prototype = { addData: function addData(data) {
			var newData = new QR8bitByte(data);this.dataList.push(newData);this.dataCache = null;
		}, isDark: function isDark(row, col) {
			if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
				throw new Error(row + "," + col);
			}
			return this.modules[row][col];
		}, getModuleCount: function getModuleCount() {
			return this.moduleCount;
		}, make: function make() {
			this.makeImpl(false, this.getBestMaskPattern());
		}, makeImpl: function makeImpl(test, maskPattern) {
			this.moduleCount = this.typeNumber * 4 + 17;this.modules = new Array(this.moduleCount);for (var row = 0; row < this.moduleCount; row++) {
				this.modules[row] = new Array(this.moduleCount);for (var col = 0; col < this.moduleCount; col++) {
					this.modules[row][col] = null;
				}
			}
			this.setupPositionProbePattern(0, 0);this.setupPositionProbePattern(this.moduleCount - 7, 0);this.setupPositionProbePattern(0, this.moduleCount - 7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(test, maskPattern);if (this.typeNumber >= 7) {
				this.setupTypeNumber(test);
			}
			if (this.dataCache == null) {
				this.dataCache = QRCodeModel.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
			}
			this.mapData(this.dataCache, maskPattern);
		}, setupPositionProbePattern: function setupPositionProbePattern(row, col) {
			for (var r = -1; r <= 7; r++) {
				if (row + r <= -1 || this.moduleCount <= row + r) continue;for (var c = -1; c <= 7; c++) {
					if (col + c <= -1 || this.moduleCount <= col + c) continue;if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}, getBestMaskPattern: function getBestMaskPattern() {
			var minLostPoint = 0;var pattern = 0;for (var i = 0; i < 8; i++) {
				this.makeImpl(true, i);var lostPoint = QRUtil.getLostPoint(this);if (i == 0 || minLostPoint > lostPoint) {
					minLostPoint = lostPoint;pattern = i;
				}
			}
			return pattern;
		}, createMovieClip: function createMovieClip(target_mc, instance_name, depth) {
			var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);var cs = 1;this.make();for (var row = 0; row < this.modules.length; row++) {
				var y = row * cs;for (var col = 0; col < this.modules[row].length; col++) {
					var x = col * cs;var dark = this.modules[row][col];if (dark) {
						qr_mc.beginFill(0, 100);qr_mc.moveTo(x, y);qr_mc.lineTo(x + cs, y);qr_mc.lineTo(x + cs, y + cs);qr_mc.lineTo(x, y + cs);qr_mc.endFill();
					}
				}
			}
			return qr_mc;
		}, setupTimingPattern: function setupTimingPattern() {
			for (var r = 8; r < this.moduleCount - 8; r++) {
				if (this.modules[r][6] != null) {
					continue;
				}
				this.modules[r][6] = r % 2 == 0;
			}
			for (var c = 8; c < this.moduleCount - 8; c++) {
				if (this.modules[6][c] != null) {
					continue;
				}
				this.modules[6][c] = c % 2 == 0;
			}
		}, setupPositionAdjustPattern: function setupPositionAdjustPattern() {
			var pos = QRUtil.getPatternPosition(this.typeNumber);for (var i = 0; i < pos.length; i++) {
				for (var j = 0; j < pos.length; j++) {
					var row = pos[i];var col = pos[j];if (this.modules[row][col] != null) {
						continue;
					}
					for (var r = -2; r <= 2; r++) {
						for (var c = -2; c <= 2; c++) {
							if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) {
								this.modules[row + r][col + c] = true;
							} else {
								this.modules[row + r][col + c] = false;
							}
						}
					}
				}
			}
		}, setupTypeNumber: function setupTypeNumber(test) {
			var bits = QRUtil.getBCHTypeNumber(this.typeNumber);for (var i = 0; i < 18; i++) {
				var mod = !test && (bits >> i & 1) == 1;this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
			}
			for (var i = 0; i < 18; i++) {
				var mod = !test && (bits >> i & 1) == 1;this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
			}
		}, setupTypeInfo: function setupTypeInfo(test, maskPattern) {
			var data = this.errorCorrectLevel << 3 | maskPattern;var bits = QRUtil.getBCHTypeInfo(data);for (var i = 0; i < 15; i++) {
				var mod = !test && (bits >> i & 1) == 1;if (i < 6) {
					this.modules[i][8] = mod;
				} else if (i < 8) {
					this.modules[i + 1][8] = mod;
				} else {
					this.modules[this.moduleCount - 15 + i][8] = mod;
				}
			}
			for (var i = 0; i < 15; i++) {
				var mod = !test && (bits >> i & 1) == 1;if (i < 8) {
					this.modules[8][this.moduleCount - i - 1] = mod;
				} else if (i < 9) {
					this.modules[8][15 - i - 1 + 1] = mod;
				} else {
					this.modules[8][15 - i - 1] = mod;
				}
			}
			this.modules[this.moduleCount - 8][8] = !test;
		}, mapData: function mapData(data, maskPattern) {
			var inc = -1;var row = this.moduleCount - 1;var bitIndex = 7;var byteIndex = 0;for (var col = this.moduleCount - 1; col > 0; col -= 2) {
				if (col == 6) col--;while (true) {
					for (var c = 0; c < 2; c++) {
						if (this.modules[row][col - c] == null) {
							var dark = false;if (byteIndex < data.length) {
								dark = (data[byteIndex] >>> bitIndex & 1) == 1;
							}
							var mask = QRUtil.getMask(maskPattern, row, col - c);if (mask) {
								dark = !dark;
							}
							this.modules[row][col - c] = dark;bitIndex--;if (bitIndex == -1) {
								byteIndex++;bitIndex = 7;
							}
						}
					}
					row += inc;if (row < 0 || this.moduleCount <= row) {
						row -= inc;inc = -inc;break;
					}
				}
			}
		} };QRCodeModel.PAD0 = 0xEC;QRCodeModel.PAD1 = 0x11;QRCodeModel.createData = function (typeNumber, errorCorrectLevel, dataList) {
		var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectLevel);var buffer = new QRBitBuffer();for (var i = 0; i < dataList.length; i++) {
			var data = dataList[i];buffer.put(data.mode, 4);buffer.put(data.getLength(), QRUtil.getLengthInBits(data.mode, typeNumber));data.write(buffer);
		}
		var totalDataCount = 0;for (var i = 0; i < rsBlocks.length; i++) {
			totalDataCount += rsBlocks[i].dataCount;
		}
		if (buffer.getLengthInBits() > totalDataCount * 8) {
			throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
		}
		if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
			buffer.put(0, 4);
		}
		while (buffer.getLengthInBits() % 8 != 0) {
			buffer.putBit(false);
		}
		while (true) {
			if (buffer.getLengthInBits() >= totalDataCount * 8) {
				break;
			}
			buffer.put(QRCodeModel.PAD0, 8);if (buffer.getLengthInBits() >= totalDataCount * 8) {
				break;
			}
			buffer.put(QRCodeModel.PAD1, 8);
		}
		return QRCodeModel.createBytes(buffer, rsBlocks);
	};QRCodeModel.createBytes = function (buffer, rsBlocks) {
		var offset = 0;var maxDcCount = 0;var maxEcCount = 0;var dcdata = new Array(rsBlocks.length);var ecdata = new Array(rsBlocks.length);for (var r = 0; r < rsBlocks.length; r++) {
			var dcCount = rsBlocks[r].dataCount;var ecCount = rsBlocks[r].totalCount - dcCount;maxDcCount = Math.max(maxDcCount, dcCount);maxEcCount = Math.max(maxEcCount, ecCount);dcdata[r] = new Array(dcCount);for (var i = 0; i < dcdata[r].length; i++) {
				dcdata[r][i] = 0xff & buffer.buffer[i + offset];
			}
			offset += dcCount;var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);var rawPoly = new QRPolynomial(dcdata[r], rsPoly.getLength() - 1);var modPoly = rawPoly.mod(rsPoly);ecdata[r] = new Array(rsPoly.getLength() - 1);for (var i = 0; i < ecdata[r].length; i++) {
				var modIndex = i + modPoly.getLength() - ecdata[r].length;ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
			}
		}
		var totalCodeCount = 0;for (var i = 0; i < rsBlocks.length; i++) {
			totalCodeCount += rsBlocks[i].totalCount;
		}
		var data = new Array(totalCodeCount);var index = 0;for (var i = 0; i < maxDcCount; i++) {
			for (var r = 0; r < rsBlocks.length; r++) {
				if (i < dcdata[r].length) {
					data[index++] = dcdata[r][i];
				}
			}
		}
		for (var i = 0; i < maxEcCount; i++) {
			for (var r = 0; r < rsBlocks.length; r++) {
				if (i < ecdata[r].length) {
					data[index++] = ecdata[r][i];
				}
			}
		}
		return data;
	};var QRMode = { MODE_NUMBER: 1 << 0, MODE_ALPHA_NUM: 1 << 1, MODE_8BIT_BYTE: 1 << 2, MODE_KANJI: 1 << 3 };var QRErrorCorrectLevel = { L: 1, M: 0, Q: 3, H: 2 };var QRMaskPattern = { PATTERN000: 0, PATTERN001: 1, PATTERN010: 2, PATTERN011: 3, PATTERN100: 4, PATTERN101: 5, PATTERN110: 6, PATTERN111: 7 };var QRUtil = { PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]], G15: 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0, G18: 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0, G15_MASK: 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1, getBCHTypeInfo: function getBCHTypeInfo(data) {
			var d = data << 10;while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
				d ^= QRUtil.G15 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15);
			}
			return (data << 10 | d) ^ QRUtil.G15_MASK;
		}, getBCHTypeNumber: function getBCHTypeNumber(data) {
			var d = data << 12;while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
				d ^= QRUtil.G18 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18);
			}
			return data << 12 | d;
		}, getBCHDigit: function getBCHDigit(data) {
			var digit = 0;while (data != 0) {
				digit++;data >>>= 1;
			}
			return digit;
		}, getPatternPosition: function getPatternPosition(typeNumber) {
			return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
		}, getMask: function getMask(maskPattern, i, j) {
			switch (maskPattern) {case QRMaskPattern.PATTERN000:
					return (i + j) % 2 == 0;case QRMaskPattern.PATTERN001:
					return i % 2 == 0;case QRMaskPattern.PATTERN010:
					return j % 3 == 0;case QRMaskPattern.PATTERN011:
					return (i + j) % 3 == 0;case QRMaskPattern.PATTERN100:
					return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;case QRMaskPattern.PATTERN101:
					return i * j % 2 + i * j % 3 == 0;case QRMaskPattern.PATTERN110:
					return (i * j % 2 + i * j % 3) % 2 == 0;case QRMaskPattern.PATTERN111:
					return (i * j % 3 + (i + j) % 2) % 2 == 0;default:
					throw new Error("bad maskPattern:" + maskPattern);}
		}, getErrorCorrectPolynomial: function getErrorCorrectPolynomial(errorCorrectLength) {
			var a = new QRPolynomial([1], 0);for (var i = 0; i < errorCorrectLength; i++) {
				a = a.multiply(new QRPolynomial([1, QRMath.gexp(i)], 0));
			}
			return a;
		}, getLengthInBits: function getLengthInBits(mode, type) {
			if (1 <= type && type < 10) {
				switch (mode) {case QRMode.MODE_NUMBER:
						return 10;case QRMode.MODE_ALPHA_NUM:
						return 9;case QRMode.MODE_8BIT_BYTE:
						return 8;case QRMode.MODE_KANJI:
						return 8;default:
						throw new Error("mode:" + mode);}
			} else if (type < 27) {
				switch (mode) {case QRMode.MODE_NUMBER:
						return 12;case QRMode.MODE_ALPHA_NUM:
						return 11;case QRMode.MODE_8BIT_BYTE:
						return 16;case QRMode.MODE_KANJI:
						return 10;default:
						throw new Error("mode:" + mode);}
			} else if (type < 41) {
				switch (mode) {case QRMode.MODE_NUMBER:
						return 14;case QRMode.MODE_ALPHA_NUM:
						return 13;case QRMode.MODE_8BIT_BYTE:
						return 16;case QRMode.MODE_KANJI:
						return 12;default:
						throw new Error("mode:" + mode);}
			} else {
				throw new Error("type:" + type);
			}
		}, getLostPoint: function getLostPoint(qrCode) {
			var moduleCount = qrCode.getModuleCount();var lostPoint = 0;for (var row = 0; row < moduleCount; row++) {
				for (var col = 0; col < moduleCount; col++) {
					var sameCount = 0;var dark = qrCode.isDark(row, col);for (var r = -1; r <= 1; r++) {
						if (row + r < 0 || moduleCount <= row + r) {
							continue;
						}
						for (var c = -1; c <= 1; c++) {
							if (col + c < 0 || moduleCount <= col + c) {
								continue;
							}
							if (r == 0 && c == 0) {
								continue;
							}
							if (dark == qrCode.isDark(row + r, col + c)) {
								sameCount++;
							}
						}
					}
					if (sameCount > 5) {
						lostPoint += 3 + sameCount - 5;
					}
				}
			}
			for (var row = 0; row < moduleCount - 1; row++) {
				for (var col = 0; col < moduleCount - 1; col++) {
					var count = 0;if (qrCode.isDark(row, col)) count++;if (qrCode.isDark(row + 1, col)) count++;if (qrCode.isDark(row, col + 1)) count++;if (qrCode.isDark(row + 1, col + 1)) count++;if (count == 0 || count == 4) {
						lostPoint += 3;
					}
				}
			}
			for (var row = 0; row < moduleCount; row++) {
				for (var col = 0; col < moduleCount - 6; col++) {
					if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) {
						lostPoint += 40;
					}
				}
			}
			for (var col = 0; col < moduleCount; col++) {
				for (var row = 0; row < moduleCount - 6; row++) {
					if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) {
						lostPoint += 40;
					}
				}
			}
			var darkCount = 0;for (var col = 0; col < moduleCount; col++) {
				for (var row = 0; row < moduleCount; row++) {
					if (qrCode.isDark(row, col)) {
						darkCount++;
					}
				}
			}
			var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;lostPoint += ratio * 10;return lostPoint;
		} };var QRMath = { glog: function glog(n) {
			if (n < 1) {
				throw new Error("glog(" + n + ")");
			}
			return QRMath.LOG_TABLE[n];
		}, gexp: function gexp(n) {
			while (n < 0) {
				n += 255;
			}
			while (n >= 256) {
				n -= 255;
			}
			return QRMath.EXP_TABLE[n];
		}, EXP_TABLE: new Array(256), LOG_TABLE: new Array(256) };for (var i = 0; i < 8; i++) {
		QRMath.EXP_TABLE[i] = 1 << i;
	}
	for (var i = 8; i < 256; i++) {
		QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8];
	}
	for (var i = 0; i < 255; i++) {
		QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
	}
	function QRPolynomial(num, shift) {
		if (num.length == undefined) {
			throw new Error(num.length + "/" + shift);
		}
		var offset = 0;while (offset < num.length && num[offset] == 0) {
			offset++;
		}
		this.num = new Array(num.length - offset + shift);for (var i = 0; i < num.length - offset; i++) {
			this.num[i] = num[i + offset];
		}
	}
	QRPolynomial.prototype = { get: function get(index) {
			return this.num[index];
		}, getLength: function getLength() {
			return this.num.length;
		}, multiply: function multiply(e) {
			var num = new Array(this.getLength() + e.getLength() - 1);for (var i = 0; i < this.getLength(); i++) {
				for (var j = 0; j < e.getLength(); j++) {
					num[i + j] ^= QRMath.gexp(QRMath.glog(this.get(i)) + QRMath.glog(e.get(j)));
				}
			}
			return new QRPolynomial(num, 0);
		}, mod: function mod(e) {
			if (this.getLength() - e.getLength() < 0) {
				return this;
			}
			var ratio = QRMath.glog(this.get(0)) - QRMath.glog(e.get(0));var num = new Array(this.getLength());for (var i = 0; i < this.getLength(); i++) {
				num[i] = this.get(i);
			}
			for (var i = 0; i < e.getLength(); i++) {
				num[i] ^= QRMath.gexp(QRMath.glog(e.get(i)) + ratio);
			}
			return new QRPolynomial(num, 0).mod(e);
		} };function QRRSBlock(totalCount, dataCount) {
		this.totalCount = totalCount;this.dataCount = dataCount;
	}
	QRRSBlock.RS_BLOCK_TABLE = [[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], [1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], [1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], [1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], [1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], [2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], [2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], [2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], [2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], [2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], [4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], [2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], [4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], [3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], [5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], [5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], [1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], [5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], [3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], [3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], [4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], [2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], [4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], [6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], [8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], [10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], [8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], [3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], [7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], [5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], [13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], [17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], [17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], [13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], [12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], [6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], [17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], [4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], [20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], [19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]];QRRSBlock.getRSBlocks = function (typeNumber, errorCorrectLevel) {
		var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);if (rsBlock == undefined) {
			throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
		}
		var length = rsBlock.length / 3;var list = [];for (var i = 0; i < length; i++) {
			var count = rsBlock[i * 3 + 0];var totalCount = rsBlock[i * 3 + 1];var dataCount = rsBlock[i * 3 + 2];for (var j = 0; j < count; j++) {
				list.push(new QRRSBlock(totalCount, dataCount));
			}
		}
		return list;
	};QRRSBlock.getRsBlockTable = function (typeNumber, errorCorrectLevel) {
		switch (errorCorrectLevel) {case QRErrorCorrectLevel.L:
				return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];case QRErrorCorrectLevel.M:
				return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];case QRErrorCorrectLevel.Q:
				return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];case QRErrorCorrectLevel.H:
				return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];default:
				return undefined;}
	};function QRBitBuffer() {
		this.buffer = [];this.length = 0;
	}
	QRBitBuffer.prototype = { get: function get(index) {
			var bufIndex = Math.floor(index / 8);return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
		}, put: function put(num, length) {
			for (var i = 0; i < length; i++) {
				this.putBit((num >>> length - i - 1 & 1) == 1);
			}
		}, getLengthInBits: function getLengthInBits() {
			return this.length;
		}, putBit: function putBit(bit) {
			var bufIndex = Math.floor(this.length / 8);if (this.buffer.length <= bufIndex) {
				this.buffer.push(0);
			}
			if (bit) {
				this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
			}
			this.length++;
		} };var QRCodeLimitLength = [[17, 14, 11, 7], [32, 26, 20, 14], [53, 42, 32, 24], [78, 62, 46, 34], [106, 84, 60, 44], [134, 106, 74, 58], [154, 122, 86, 64], [192, 152, 108, 84], [230, 180, 130, 98], [271, 213, 151, 119], [321, 251, 177, 137], [367, 287, 203, 155], [425, 331, 241, 177], [458, 362, 258, 194], [520, 412, 292, 220], [586, 450, 322, 250], [644, 504, 364, 280], [718, 560, 394, 310], [792, 624, 442, 338], [858, 666, 482, 382], [929, 711, 509, 403], [1003, 779, 565, 439], [1091, 857, 611, 461], [1171, 911, 661, 511], [1273, 997, 715, 535], [1367, 1059, 751, 593], [1465, 1125, 805, 625], [1528, 1190, 868, 658], [1628, 1264, 908, 698], [1732, 1370, 982, 742], [1840, 1452, 1030, 790], [1952, 1538, 1112, 842], [2068, 1628, 1168, 898], [2188, 1722, 1228, 958], [2303, 1809, 1283, 983], [2431, 1911, 1351, 1051], [2563, 1989, 1423, 1093], [2699, 2099, 1499, 1139], [2809, 2213, 1579, 1219], [2953, 2331, 1663, 1273]];

	function _isSupportCanvas() {
		return typeof CanvasRenderingContext2D != "undefined";
	}

	// android 2.x doesn't support Data-URI spec
	function _getAndroid() {
		var android = false;
		var sAgent = navigator.userAgent;

		if (/android/i.test(sAgent)) {
			// android
			android = true;
			var aMat = sAgent.toString().match(/android ([0-9]\.[0-9])/i);

			if (aMat && aMat[1]) {
				android = parseFloat(aMat[1]);
			}
		}

		return android;
	}

	var svgDrawer = function () {

		var Drawing = function Drawing(el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};

		Drawing.prototype.draw = function (oQRCode) {
			var _htOption = this._htOption;
			var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);

			this.clear();

			function makeSVG(tag, attrs) {
				var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
				for (var k in attrs) {
					if (attrs.hasOwnProperty(k)) el.setAttribute(k, attrs[k]);
				}return el;
			}

			var svg = makeSVG("svg", { 'viewBox': '0 0 ' + String(nCount) + " " + String(nCount), 'width': '100%', 'height': '100%', 'fill': _htOption.colorLight });
			svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
			_el.appendChild(svg);

			svg.appendChild(makeSVG("rect", { "fill": _htOption.colorLight, "width": "100%", "height": "100%" }));
			svg.appendChild(makeSVG("rect", { "fill": _htOption.colorDark, "width": "1", "height": "1", "id": "template" }));

			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					if (oQRCode.isDark(row, col)) {
						var child = makeSVG("use", { "x": String(col), "y": String(row) });
						child.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#template");
						svg.appendChild(child);
					}
				}
			}
		};
		Drawing.prototype.clear = function () {
			while (this._el.hasChildNodes()) {
				this._el.removeChild(this._el.lastChild);
			}
		};
		return Drawing;
	}();

	var useSVG = document.documentElement.tagName.toLowerCase() === "svg";

	// Drawing in DOM by using Table tag
	var Drawing = useSVG ? svgDrawer : !_isSupportCanvas() ? function () {
		var Drawing = function Drawing(el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};

		/**
   * Draw the QRCode
   * 
   * @param {QRCode} oQRCode
   */
		Drawing.prototype.draw = function (oQRCode) {
			var _htOption = this._htOption;
			var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);
			var aHTML = ['<table style="border:0;border-collapse:collapse;">'];

			for (var row = 0; row < nCount; row++) {
				aHTML.push('<tr>');

				for (var col = 0; col < nCount; col++) {
					aHTML.push('<td style="border:0;border-collapse:collapse;padding:0;margin:5px;width:' + nWidth + 'px;height:' + nHeight + 'px;background-color:' + (oQRCode.isDark(row, col) ? _htOption.colorDark : _htOption.colorLight) + ';"></td>');
				}

				aHTML.push('</tr>');
			}

			aHTML.push('</table>');
			_el.innerHTML = aHTML.join('');

			// Fix the margin values as real size.
			var elTable = _el.childNodes[0];
			var nLeftMarginTable = (_htOption.width - elTable.offsetWidth) / 2;
			var nTopMarginTable = (_htOption.height - elTable.offsetHeight) / 2;

			if (nLeftMarginTable > 0 && nTopMarginTable > 0) {
				elTable.style.margin = nTopMarginTable + "px " + nLeftMarginTable + "px";
			}
		};

		/**
   * Clear the QRCode
   */
		Drawing.prototype.clear = function () {
			this._el.innerHTML = '';
		};

		return Drawing;
	}() : function () {
		// Drawing in Canvas
		function _onMakeImage() {
			this._elImage.src = this._elCanvas.toDataURL("image/png");
			this._elImage.style.display = "block";
			this._elCanvas.style.display = "none";
		}

		// Android 2.1 bug workaround
		// http://code.google.com/p/android/issues/detail?id=5141
		if (this._android && this._android <= 2.1) {
			var factor = 1 / window.devicePixelRatio;
			var drawImage = CanvasRenderingContext2D.prototype.drawImage;
			CanvasRenderingContext2D.prototype.drawImage = function (image, sx, sy, sw, sh, dx, dy, dw, dh) {
				if ("nodeName" in image && /img/i.test(image.nodeName)) {
					for (var i = arguments.length - 1; i >= 1; i--) {
						arguments[i] = arguments[i] * factor;
					}
				} else if (typeof dw == "undefined") {
					arguments[1] *= factor;
					arguments[2] *= factor;
					arguments[3] *= factor;
					arguments[4] *= factor;
				}

				drawImage.apply(this, arguments);
			};
		}

		/**
   * Check whether the user's browser supports Data URI or not
   * 
   * @private
   * @param {Function} fSuccess Occurs if it supports Data URI
   * @param {Function} fFail Occurs if it doesn't support Data URI
   */
		function _safeSetDataURI(fSuccess, fFail) {
			var self = this;
			self._fFail = fFail;
			self._fSuccess = fSuccess;

			// Check it just once
			if (self._bSupportDataURI === null) {
				var el = document.createElement("img");
				var fOnError = function fOnError() {
					self._bSupportDataURI = false;

					if (self._fFail) {
						self._fFail.call(self);
					}
				};
				var fOnSuccess = function fOnSuccess() {
					self._bSupportDataURI = true;

					if (self._fSuccess) {
						self._fSuccess.call(self);
					}
				};

				el.onabort = fOnError;
				el.onerror = fOnError;
				el.onload = fOnSuccess;
				el.src = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="; // the Image contains 1px data.
				return;
			} else if (self._bSupportDataURI === true && self._fSuccess) {
				self._fSuccess.call(self);
			} else if (self._bSupportDataURI === false && self._fFail) {
				self._fFail.call(self);
			}
		};

		/**
   * Drawing QRCode by using canvas
   * 
   * @constructor
   * @param {HTMLElement} el
   * @param {Object} htOption QRCode Options 
   */
		var Drawing = function Drawing(el, htOption) {
			this._bIsPainted = false;
			this._android = _getAndroid();

			this._htOption = htOption;
			this._elCanvas = document.createElement("canvas");
			this._elCanvas.width = htOption.width;
			this._elCanvas.height = htOption.height;
			el.appendChild(this._elCanvas);
			this._el = el;
			this._oContext = this._elCanvas.getContext("2d");
			this._bIsPainted = false;
			this._elImage = document.createElement("img");
			this._elImage.alt = "Scan me!";
			this._elImage.style.display = "none";
			this._el.appendChild(this._elImage);
			this._bSupportDataURI = null;
		};

		/**
   * Draw the QRCode
   * 
   * @param {QRCode} oQRCode 
   */
		Drawing.prototype.draw = function (oQRCode) {
			var _elImage = this._elImage;
			var _oContext = this._oContext;
			var _htOption = this._htOption;

			var nCount = oQRCode.getModuleCount();
			var nWidth = _htOption.width / nCount;
			var nHeight = _htOption.height / nCount;
			var nRoundedWidth = Math.round(nWidth);
			var nRoundedHeight = Math.round(nHeight);

			_elImage.style.display = "none";
			this.clear();

			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					var bIsDark = oQRCode.isDark(row, col);
					var nLeft = col * nWidth;
					var nTop = row * nHeight;
					_oContext.strokeStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
					_oContext.lineWidth = 1;
					_oContext.fillStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
					_oContext.fillRect(nLeft, nTop, nWidth, nHeight);

					// 안티 앨리어싱 방지 처리
					_oContext.strokeRect(Math.floor(nLeft) + 0.5, Math.floor(nTop) + 0.5, nRoundedWidth, nRoundedHeight);

					_oContext.strokeRect(Math.ceil(nLeft) - 0.5, Math.ceil(nTop) - 0.5, nRoundedWidth, nRoundedHeight);
				}
			}

			this._bIsPainted = true;
		};

		/**
   * Make the image from Canvas if the browser supports Data URI.
   */
		Drawing.prototype.makeImage = function () {
			if (this._bIsPainted) {
				_safeSetDataURI.call(this, _onMakeImage);
			}
		};

		/**
   * Return whether the QRCode is painted or not
   * 
   * @return {Boolean}
   */
		Drawing.prototype.isPainted = function () {
			return this._bIsPainted;
		};

		/**
   * Clear the QRCode
   */
		Drawing.prototype.clear = function () {
			this._oContext.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
			this._bIsPainted = false;
		};

		/**
   * @private
   * @param {Number} nNumber
   */
		Drawing.prototype.round = function (nNumber) {
			if (!nNumber) {
				return nNumber;
			}

			return Math.floor(nNumber * 1000) / 1000;
		};

		return Drawing;
	}();

	/**
  * Get the type by string length
  * 
  * @private
  * @param {String} sText
  * @param {Number} nCorrectLevel
  * @return {Number} type
  */
	function _getTypeNumber(sText, nCorrectLevel) {
		var nType = 1;
		var length = _getUTF8Length(sText);

		for (var i = 0, len = QRCodeLimitLength.length; i <= len; i++) {
			var nLimit = 0;

			switch (nCorrectLevel) {
				case QRErrorCorrectLevel.L:
					nLimit = QRCodeLimitLength[i][0];
					break;
				case QRErrorCorrectLevel.M:
					nLimit = QRCodeLimitLength[i][1];
					break;
				case QRErrorCorrectLevel.Q:
					nLimit = QRCodeLimitLength[i][2];
					break;
				case QRErrorCorrectLevel.H:
					nLimit = QRCodeLimitLength[i][3];
					break;
			}

			if (length <= nLimit) {
				break;
			} else {
				nType++;
			}
		}

		if (nType > QRCodeLimitLength.length) {
			throw new Error("Too long data");
		}

		return nType;
	}

	function _getUTF8Length(sText) {
		var replacedText = encodeURI(sText).toString().replace(/\%[0-9a-fA-F]{2}/g, 'a');
		return replacedText.length + (replacedText.length != sText ? 3 : 0);
	}

	/**
  * @class QRCode
  * @constructor
  * @example 
  * new QRCode(document.getElementById("test"), "http://jindo.dev.naver.com/collie");
  *
  * @example
  * var oQRCode = new QRCode("test", {
  *    text : "http://naver.com",
  *    width : 128,
  *    height : 128
  * });
  * 
  * oQRCode.clear(); // Clear the QRCode.
  * oQRCode.makeCode("http://map.naver.com"); // Re-create the QRCode.
  *
  * @param {HTMLElement|String} el target element or 'id' attribute of element.
  * @param {Object|String} vOption
  * @param {String} vOption.text QRCode link data
  * @param {Number} [vOption.width=256]
  * @param {Number} [vOption.height=256]
  * @param {String} [vOption.colorDark="#000000"]
  * @param {String} [vOption.colorLight="#ffffff"]
  * @param {QRCode.CorrectLevel} [vOption.correctLevel=QRCode.CorrectLevel.H] [L|M|Q|H] 
  */
	QRCode = function QRCode(el, vOption, CorrectLevelCode) {
		if (CorrectLevelCode == 'L') {
			var correctLevel = QRErrorCorrectLevel.L;
		} else {
			var correctLevel = QRErrorCorrectLevel.H;
		}
		this._htOption = {
			width: 500,
			height: 500,
			typeNumber: 4,
			colorDark: "#000000",
			colorLight: "#ffffff",
			correctLevel: correctLevel
		};

		if (typeof vOption === 'string') {
			vOption = {
				text: vOption
			};
		}

		// Overwrites options
		if (vOption) {
			for (var i in vOption) {
				this._htOption[i] = vOption[i];
			}
		}

		if (typeof el == "string") {
			el = document.getElementById(el);
		}

		if (this._htOption.useSVG) {
			Drawing = svgDrawer;
		}

		this._android = _getAndroid();
		this._el = el;
		this._oQRCode = null;
		this._oDrawing = new Drawing(this._el, this._htOption);

		if (this._htOption.text) {
			this.makeCode(this._htOption.text);
		}
	};

	/**
  * Make the QRCode
  * 
  * @param {String} sText link data
  */
	QRCode.prototype.makeCode = function (sText) {
		this._oQRCode = new QRCodeModel(_getTypeNumber(sText, this._htOption.correctLevel), this._htOption.correctLevel);
		this._oQRCode.addData(sText);
		this._oQRCode.make();
		this._el.title = sText;
		this._oDrawing.draw(this._oQRCode);
		this.makeImage();
	};

	/**
  * Make the Image from Canvas element
  * - It occurs automatically
  * - Android below 3 doesn't support Data-URI spec.
  * 
  * @private
  */
	QRCode.prototype.makeImage = function () {
		if (typeof this._oDrawing.makeImage == "function" && (!this._android || this._android >= 3)) {
			this._oDrawing.makeImage();
		}
	};

	/**
  * Clear the QRCode
  */
	QRCode.prototype.clear = function () {
		this._oDrawing.clear();
	};

	/**
  * @name QRCode.CorrectLevel
  */
	QRCode.CorrectLevel = QRErrorCorrectLevel;

	/**
  * 2017/7/26 added by Lin WeiLong
  */
	if (typeof module != 'undefined' && module.exports) {
		module.exports = QRCode;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return QRCode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.QRCode = QRCode;
	}
})(window);

/***/ }),

/***/ "lnZN":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("OzIq");
var inheritIfRequired = __webpack_require__("kic5");
var dP = __webpack_require__("lDLk").f;
var gOPN = __webpack_require__("WcO1").f;
var isRegExp = __webpack_require__("u0PK");
var $flags = __webpack_require__("0pGU");
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__("bUqO") && (!CORRECT_NEW || __webpack_require__("zgIt")(function () {
  re2[__webpack_require__("kkCw")('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__("R3AP")(global, 'RegExp', $RegExp);
}

__webpack_require__("CEne")('RegExp');


/***/ }),

/***/ "lnrT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var getSideChannel = __webpack_require__("D6sz");
var utils = __webpack_require__("5dnF");
var formats = __webpack_require__("uToG");
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function pushToArray(arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'symbol' || typeof v === 'bigint';
};

var stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;

    if (sideChannel.has(object)) {
        throw new RangeError('Cyclic object value');
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = (typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object' && key.value !== undefined ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, true);
        var valueSideChannel = getSideChannel();
        pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

/***/ }),

/***/ "lyhN":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__("Ds5P");
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),

/***/ "m423":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/mask.vue?vue&type=template&id=327be300&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fadeIn"}},[_c('div',{staticClass:"mask"})])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/common/mask.vue?vue&type=template&id=327be300&scoped=true&

// EXTERNAL MODULE: ./src/components/common/mask.vue?vue&type=style&index=0&id=327be300&lang=scss&scoped=true&
var maskvue_type_style_index_0_id_327be300_lang_scss_scoped_true_ = __webpack_require__("5Ya/");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/common/mask.vue

var script = {}



/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327be300",
  null
  
)

/* harmony default export */ var mask = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "m4Kp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),

/***/ "m6Yj":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', { fround: __webpack_require__("g/m8") });


/***/ }),

/***/ "m8F4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__("Ds5P");
var $pad = __webpack_require__("2VSL");
var userAgent = __webpack_require__("41xE");

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),

/***/ "mClu":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("kM2E");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("+E39"), 'Object', { defineProperty: __webpack_require__("evD5").f });


/***/ }),

/***/ "mJx5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__("u0PK");
var anObject = __webpack_require__("DIVP");
var speciesConstructor = __webpack_require__("7O1s");
var advanceStringIndex = __webpack_require__("TwzQ");
var toLength = __webpack_require__("BbyF");
var callRegExpExec = __webpack_require__("9Dx1");
var regexpExec = __webpack_require__("32VL");
var fails = __webpack_require__("zgIt");
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__("Vg1y")('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),

/***/ "mNVr":
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function stringToBytes(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function bytesToString(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function stringToBytes(str) {
      for (var bytes = [], i = 0; i < str.length; i++) {
        bytes.push(str.charCodeAt(i) & 0xFF);
      }return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function bytesToString(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++) {
        str.push(String.fromCharCode(bytes[i]));
      }return str.join('');
    }
  }
};

module.exports = charenc;

/***/ }),

/***/ "mTp7":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__("Ds5P");
var setProto = __webpack_require__("gvDt");

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "mZON":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("VWgF")('keys');
var uid = __webpack_require__("ulTY");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "mhn7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__("Ymdd")('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),

/***/ "mhrf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};

/***/ }),

/***/ "msXi":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("77Pl");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "mtWM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("tIFN");

/***/ }),

/***/ "mvHQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("qkKv"), __esModule: true };

/***/ }),

/***/ "mw3O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__("CwSZ");
var parse = __webpack_require__("DDCP");
var formats = __webpack_require__("XgCd");

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ "mypn":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "n0T6":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("Ibhu");
var hiddenKeys = __webpack_require__("xnc9").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "n12u":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("Ds5P");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("oYd7") });


/***/ }),

/***/ "n4cT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-switch-tiktok.328a5ed.png";

/***/ }),

/***/ "n982":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__("UKM+");
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "nDJU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-home_on.715129a.png";

/***/ }),

/***/ "nErl":
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ "nKzZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.275e2fe.png";

/***/ }),

/***/ "nRs1":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__("Ds5P");
$export($export.S, 'Object', { is: __webpack_require__("4IZP") });


/***/ }),

/***/ "nSQQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function throwTypeError() {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function () {
	try {
		// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
		arguments.callee; // IE 8 does not throw here
		return throwTypeError;
	} catch (calleeThrows) {
		try {
			// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
			return $gOPD(arguments, 'callee').get;
		} catch (gOPDthrows) {
			return throwTypeError;
		}
	}
}() : throwTypeError;

var hasSymbols = __webpack_require__("PrX1")();

var getProto = Object.getPrototypeOf || function (x) {
	return x.__proto__;
}; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': (typeof JSON === 'undefined' ? 'undefined' : _typeof(JSON)) === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__("cM5C");
var hasOwn = __webpack_require__("IpzJ");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && i + 1 >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

/***/ }),

/***/ "nd4N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_dialog_vue_vue_type_style_index_0_id_07cefbd0_lang_scss_scoped_true___ = __webpack_require__("wLTK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_dialog_vue_vue_type_style_index_0_id_07cefbd0_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_dialog_vue_vue_type_style_index_0_id_07cefbd0_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_dialog_vue_vue_type_style_index_0_id_07cefbd0_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "nh2o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__("Ds5P");
var global = __webpack_require__("OzIq");
var core = __webpack_require__("7gX0");
var microtask = __webpack_require__("g36u")();
var OBSERVABLE = __webpack_require__("kkCw")('observable');
var aFunction = __webpack_require__("XSOZ");
var anObject = __webpack_require__("DIVP");
var anInstance = __webpack_require__("9GpA");
var redefineAll = __webpack_require__("A16L");
var hide = __webpack_require__("2p1q");
var forOf = __webpack_require__("vmSO");
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__("CEne")('Observable');


/***/ }),

/***/ "nphH":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("DIVP");
var isObject = __webpack_require__("UKM+");
var newPromiseCapability = __webpack_require__("w6Dh");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "nqOf":
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),

/***/ "oF0V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__("Ds5P");
var flattenIntoArray = __webpack_require__("IFpc");
var toObject = __webpack_require__("FryR");
var toLength = __webpack_require__("BbyF");
var aFunction = __webpack_require__("XSOZ");
var arraySpeciesCreate = __webpack_require__("plSV");

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__("RhFG")('flatMap');


/***/ }),

/***/ "oHKp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var toIObject = __webpack_require__("PHqh");
var toInteger = __webpack_require__("oeih");
var toLength = __webpack_require__("BbyF");
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__("NNrz")($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),

/***/ "oHjS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__("EQyZ");
var combineURLs = __webpack_require__("7B7M");

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ "oJlt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "oM7Q":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("sF+V");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ "oYd7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("bUqO");
var getKeys = __webpack_require__("Qh14");
var gOPS = __webpack_require__("Y1N3");
var pIE = __webpack_require__("Y1aA");
var toObject = __webpack_require__("FryR");
var IObject = __webpack_require__("Q6Nf");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("zgIt")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "oYp4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var toObject = __webpack_require__("FryR");
var aFunction = __webpack_require__("XSOZ");
var $defineProperty = __webpack_require__("lDLk");

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__("bUqO") && $export($export.P + __webpack_require__("dm6P"), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),

/***/ "obJF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/btn_close.f5b0139.png";

/***/ }),

/***/ "oeih":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "ohSy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

/***/ }),

/***/ "ot5s":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("PHqh");
var toLength = __webpack_require__("BbyF");
var toAbsoluteIndex = __webpack_require__("zo/l");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "p+dV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_toast_vue_vue_type_style_index_0_id_71635f86_lang_scss_scoped_true___ = __webpack_require__("2lCz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_toast_vue_vue_type_style_index_0_id_71635f86_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_toast_vue_vue_type_style_index_0_id_71635f86_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_toast_vue_vue_type_style_index_0_id_71635f86_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "p1b6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "p8xL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    merge: merge
};


/***/ }),

/***/ "pBtG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "pFYg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("Zzip");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("5QVw");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "pFvp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determine if a DOM element matches a CSS selector
 *
 * @param {Element} elem
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function matches(elem, selector) {
  // Vendor-specific implementations of `Element.prototype.matches()`.
  var proto = window.Element.prototype;
  var nativeMatches = proto.matches ||
      proto.mozMatchesSelector ||
      proto.msMatchesSelector ||
      proto.oMatchesSelector ||
      proto.webkitMatchesSelector;

  if (!elem || elem.nodeType !== 1) {
    return false;
  }

  var parentElem = elem.parentNode;

  // use native 'matches'
  if (nativeMatches) {
    return nativeMatches.call(elem, selector);
  }

  // native support for `matches` is missing and a fallback is required
  var nodes = parentElem.querySelectorAll(selector);
  var len = nodes.length;

  for (var i = 0; i < len; i++) {
    if (nodes[i] === elem) {
      return true;
    }
  }

  return false;
}

/**
 * Expose `matches`
 */

module.exports = matches;


/***/ }),

/***/ "pWGb":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', { log1p: __webpack_require__("Rz2z") });


/***/ }),

/***/ "pd+2":
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__("bUqO") && /./g.flags != 'g') __webpack_require__("lDLk").f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__("0pGU")
});


/***/ }),

/***/ "pkjZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "plSV":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("boo2");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "pxG4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "pyy+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_extendingCenter_vue_vue_type_style_index_0_id_21d8205d_lang_scss_scoped_true___ = __webpack_require__("9cWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_extendingCenter_vue_vue_type_style_index_0_id_21d8205d_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_extendingCenter_vue_vue_type_style_index_0_id_21d8205d_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_extendingCenter_vue_vue_type_style_index_0_id_21d8205d_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "qARP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("lOnJ");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "qBN+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-mbti-random1.30a5285.jpg";

/***/ }),

/***/ "qP/X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var env = location.host.split('.')[0].match(/(qc|box)\d?/g);
var spell = !!env ? env.length > 0 ? '-' + env[0] : '' : '';
var HCP = '//hcp' + spell + '.xinli001.com/',
    APIS = {
  daturaUploadOpus: HCP + 'daturaCeping/uploadOpus', //  上传图片并与accountId绑定关系
  daturaCommitAnswers: HCP + 'daturaCeping/commitAnswers', //  提交测评
  daturaReport: HCP + 'daturaCeping/viewReport' //  查询报告页
};

/* harmony default export */ __webpack_exports__["a"] = (APIS);

/***/ }),

/***/ "qRfI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "qYA1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/index-bg.a45caa3.png";

/***/ }),

/***/ "qZb+":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__("0j1G")('Set');


/***/ }),

/***/ "qdHU":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__("iKpr")('WeakSet');


/***/ }),

/***/ "qio6":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var anObject = __webpack_require__("77Pl");
var getKeys = __webpack_require__("lktj");

module.exports = __webpack_require__("+E39") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "qkKv":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("FeBl");
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ "qkyc":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("kkCw")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "qtRy":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("77Ug")('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "qubT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qwQ3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("DIVP");
var sameValue = __webpack_require__("4IZP");
var regExpExec = __webpack_require__("9Dx1");

// @@search logic
__webpack_require__("Vg1y")('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ "qyJz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("+ZMJ");
var $export = __webpack_require__("kM2E");
var toObject = __webpack_require__("sB3e");
var call = __webpack_require__("msXi");
var isArrayIter = __webpack_require__("Mhyx");
var toLength = __webpack_require__("QRG4");
var createProperty = __webpack_require__("fBQ2");
var getIterFn = __webpack_require__("3fs2");

$export($export.S + $export.F * !__webpack_require__("dY0y")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "r2E/":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__("Ds5P");
var $re = __webpack_require__("nqOf")(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),

/***/ "rFzY":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("XSOZ");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "rbJr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("wI4N");
var bind = __webpack_require__("NTs4");
var Axios = __webpack_require__("0lbK");
var mergeConfig = __webpack_require__("voum");
var defaults = __webpack_require__("8cTw");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("H3q/");
axios.CancelToken = __webpack_require__("b2xw");
axios.isCancel = __webpack_require__("6SyV");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("eUeS");

// Expose isAxiosError
axios.isAxiosError = __webpack_require__("dxwT");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "rdRf":
/***/ (function(module, exports, __webpack_require__) {

(function () {
  var crypt = __webpack_require__("ZUuQ"),
      utf8 = __webpack_require__("mNVr").utf8,
      isBuffer = __webpack_require__("uCbX"),
      bin = __webpack_require__("mNVr").bin,


  // The core
  md5 = function md5(message, options) {
    // Convert to byte array
    if (message.constructor == String) {
      if (options && options.encoding === 'binary') message = bin.stringToBytes(message);else message = utf8.stringToBytes(message);
    } else if (isBuffer(message)) message = Array.prototype.slice.call(message, 0);else if (!Array.isArray(message) && message.constructor !== Uint8Array) message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a = 1732584193,
        b = -271733879,
        c = -1732584194,
        d = 271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = (m[i] << 8 | m[i] >>> 24) & 0x00FF00FF | (m[i] << 24 | m[i] >>> 8) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << l % 32;
    m[(l + 64 >>> 9 << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i + 0], 7, -680876936);
      d = FF(d, a, b, c, m[i + 1], 12, -389564586);
      c = FF(c, d, a, b, m[i + 2], 17, 606105819);
      b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i + 4], 7, -176418897);
      d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
      c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i + 7], 22, -45705983);
      a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
      d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i + 10], 17, -42063);
      b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
      a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
      d = FF(d, a, b, c, m[i + 13], 12, -40341101);
      c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
      b = FF(b, c, d, a, m[i + 15], 22, 1236535329);

      a = GG(a, b, c, d, m[i + 1], 5, -165796510);
      d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
      c = GG(c, d, a, b, m[i + 11], 14, 643717713);
      b = GG(b, c, d, a, m[i + 0], 20, -373897302);
      a = GG(a, b, c, d, m[i + 5], 5, -701558691);
      d = GG(d, a, b, c, m[i + 10], 9, 38016083);
      c = GG(c, d, a, b, m[i + 15], 14, -660478335);
      b = GG(b, c, d, a, m[i + 4], 20, -405537848);
      a = GG(a, b, c, d, m[i + 9], 5, 568446438);
      d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
      c = GG(c, d, a, b, m[i + 3], 14, -187363961);
      b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
      a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
      d = GG(d, a, b, c, m[i + 2], 9, -51403784);
      c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
      b = GG(b, c, d, a, m[i + 12], 20, -1926607734);

      a = HH(a, b, c, d, m[i + 5], 4, -378558);
      d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
      b = HH(b, c, d, a, m[i + 14], 23, -35309556);
      a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
      d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
      c = HH(c, d, a, b, m[i + 7], 16, -155497632);
      b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
      a = HH(a, b, c, d, m[i + 13], 4, 681279174);
      d = HH(d, a, b, c, m[i + 0], 11, -358537222);
      c = HH(c, d, a, b, m[i + 3], 16, -722521979);
      b = HH(b, c, d, a, m[i + 6], 23, 76029189);
      a = HH(a, b, c, d, m[i + 9], 4, -640364487);
      d = HH(d, a, b, c, m[i + 12], 11, -421815835);
      c = HH(c, d, a, b, m[i + 15], 16, 530742520);
      b = HH(b, c, d, a, m[i + 2], 23, -995338651);

      a = II(a, b, c, d, m[i + 0], 6, -198630844);
      d = II(d, a, b, c, m[i + 7], 10, 1126891415);
      c = II(c, d, a, b, m[i + 14], 15, -1416354905);
      b = II(b, c, d, a, m[i + 5], 21, -57434055);
      a = II(a, b, c, d, m[i + 12], 6, 1700485571);
      d = II(d, a, b, c, m[i + 3], 10, -1894986606);
      c = II(c, d, a, b, m[i + 10], 15, -1051523);
      b = II(b, c, d, a, m[i + 1], 21, -2054922799);
      a = II(a, b, c, d, m[i + 8], 6, 1873313359);
      d = II(d, a, b, c, m[i + 15], 10, -30611744);
      c = II(c, d, a, b, m[i + 6], 15, -1560198380);
      b = II(b, c, d, a, m[i + 13], 21, 1309151649);
      a = II(a, b, c, d, m[i + 4], 6, -145523070);
      d = II(d, a, b, c, m[i + 11], 10, -1120210379);
      c = II(c, d, a, b, m[i + 2], 15, 718787259);
      b = II(b, c, d, a, m[i + 9], 21, -343485551);

      a = a + aa >>> 0;
      b = b + bb >>> 0;
      c = c + cc >>> 0;
      d = d + dd >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };
  md5._gg = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };
  md5._hh = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };
  md5._ii = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null) throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
  };
})();

/***/ }),

/***/ "rgm5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/pageTitle.vue?vue&type=template&id=765fb3af&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['pagetitle', 'pagetitle-hold']},[_c('div',{class:[
      'title',
      'fs-14',
      { fixed: _vm.localFixed || _vm.propFixed },
      { noMargin: _vm.propNoMargin }
    ]},[_c('div',{staticClass:"container container-nodwapp"},[[(!_vm.isHwrl)?_c('div',{class:['title-text', 'fs-14']},[(!_vm.baidu_toufang_shenhe)?_c('router-link',{attrs:{"to":{ path: '/index', query: { channelId: _vm.channelId } }}},[_c('span',{staticClass:"logoContainer"},[_c('img',{attrs:{"src":_vm.propLogo}})]),_vm._v(_vm._s(_vm.finalTitle)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.baidu_toufang_shenhe)?_c('div',[_c('span',{staticClass:"logoContainer"},[_c('img',{attrs:{"src":_vm.propLogo}})]),_vm._v(_vm._s(_vm.finalTitle)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.WEIBO_NOTLOGIN)?_c('div',{on:{"click":_vm.getKefu}},[_vm._v("   |   联系客服")]):_vm._e(),_vm._v(" "),(_vm.SHOW_FOCUS)?_c('v-touch',{staticClass:"pagetitle-focus",attrs:{"tag":"span"},on:{"tap":function($event){return _vm.onFocus(true)}}},[_vm._v("关注领福利~")]):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.HIDDEN_DETAILS && !_vm.RENMINWANG_TYPE && !_vm.baidu_toufang_shenhe && !_vm.isHpnk)?_c('div',{staticClass:"search",class:{'is-center': _vm.isHwrl}},[_c('v-touch',{staticClass:"searchBox fs-14",on:{"tap":_vm.goSearch}},[_c('input',{staticClass:"fakeInput",attrs:{"type":"text"}}),_vm._v("搜索")])],1):_vm._e()]],2)]),_vm._v(" "),(_vm.focusDialog)?_c('myMask'):_vm._e(),_vm._v(" "),(_vm.focusDialog)?_c('div',{staticClass:"box"},[_c('div',{staticClass:"popupimgbox"},[_c('div',{staticClass:"popupimg"},[_c('img',{attrs:{"src":__webpack_require__("zX4R"),"alt":"扫描关注二维码"},on:{"touchstart":_vm.intouchStart,"touchmove":_vm.intouchMove,"touchend":_vm.intouchEnd}})]),_vm._v(" "),_c('v-touch',{staticClass:"closeicon",on:{"tap":function($event){return _vm.onFocus(false)}}})],1)]):_vm._e(),_vm._v(" "),(_vm.dialogData)?_c('myDialog',{attrs:{"propMask":_vm.dialogData.propMask,"propTitle":_vm.dialogData.title,"propContent":_vm.dialogData.content,"propActions":_vm.dialogData.actions},on:{"myDialogClose":function($event){_vm.dialogData = ''}}},[_c('div',{staticClass:"service-qrcode",attrs:{"slot":"content"},slot:"content"},[_c('img',{staticClass:"qrcode",attrs:{"src":__webpack_require__("dMBf"),"alt":""}})])]):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/common/pageTitle.vue?vue&type=template&id=765fb3af&scoped=true&

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/mixins/scrollController.js
var scrollController = __webpack_require__("WhbY");

// EXTERNAL MODULE: ./src/components/common/mask.vue + 2 modules
var mask = __webpack_require__("m423");

// EXTERNAL MODULE: ./src/components/common/dialog.vue + 4 modules
var dialog = __webpack_require__("VR0t");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/pageTitle.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var pageTitlevue_type_script_lang_js_ = ({
  name: 'pageTitle',
  data: function data() {
    return {
      localFixed: false,
      focusDialog: false,
      timeOutEvent: 0,
      dialogData: null
    };
  },

  components: {
    myMask: mask["a" /* default */],
    myDialog: dialog["a" /* default */]
  },
  mixins: [scrollController["a" /* default */]],
  props: {
    propTitle: {
      required: true,
      default: '',
      type: String
    },
    propLogo: {
      required: true,
      type: String,
      default: ''
    },
    propFixed: {
      required: false,
      default: false,
      type: Boolean
    },
    propNoMargin: {
      required: false,
      default: false,
      type: Boolean
    },
    propFocus: {
      required: false,
      default: true,
      type: Boolean
    }
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['channelId', 'channelConfig']), Object(vuex_esm["c" /* mapGetters */])(['CHANNEL_NOT_LOGIN']), {
    finalTitle: function finalTitle() {
      return this.propTitle == '' | this.propTitle == undefined ? '' : this.propTitle;
    },
    isWechat: function isWechat() {
      return this.platform.isWechat;
    },
    noLoginText: function noLoginText() {
      var t = this.CHANNEL_NOT_LOGIN ? '复制二维码到微信，' : '';
      return t;
    },
    SHOW_FOCUS: function SHOW_FOCUS() {
      //添加渠道2325详情页关闭关注按钮
      //人民网渠道关闭关注按钮
      if (!this.SHWO_VIP_TIS) {
        return false;
      }
      if (this.channelId == 2530 || this.channelId == 2535 || this.channelId == 2444) {
        return false;
      }
      if (this.isWechat && this.CHANNEL_INTERNALCHANNEL) {
        return this.channelConfig.channelType == 1 || this.channelConfig.channelType == 2;
      } else {
        return false;
      }
    },
    SHOW_DOWN_YXL: function SHOW_DOWN_YXL() {
      //2021-1-14 不展示下载app
      return false;
      //return (this.$route.name == 'testDetail' || this.$route.name == 'showIndex') && this.CHANNEL_INTERNALCHANNEL
    }
  }),
  mounted: function mounted() {
    // console.log(this.$route)
  },

  methods: {
    goSearch: function goSearch() {
      this.$router.push({
        path: '/search',
        query: {
          channelId: this.channelId
        }
      });
    },
    showFixedbBox: function showFixedbBox(val) {
      this.localFixed = val;
    },
    onFocus: function onFocus(type) {
      if (type) {
        this.$stat.send({
          name: '关注弹窗-点击打开弹窗按钮',
          properties: { 渠道名称: this.CHANNELNAME }
        });
        // 微站-测评大厅-关注领福利 神策埋点
        this.$wechatTrackEvent('weizhan_cepinghome_followgetpresent');
      } else {
        this.$stat.send({
          name: '关注弹窗-关闭打开弹窗按钮',
          properties: { 渠道名称: this.CHANNELNAME }
        });
      }
      this.focusDialog = type;
    },

    //下面为监听长按事件
    intouchStart: function intouchStart(e) {
      var this_ = this;
      this_.timeOutEvent++;
      this_.setTime = setTimeout(function () {
        this_.intouchStart(); //长按触发事件
      }, 10);
    },
    intouchMove: function intouchMove(e) {},
    intouchEnd: function intouchEnd(e) {
      var this_ = this;
      console.log(this_.timeOutEvent);
      if (this_.timeOutEvent > 75) {
        this.$stat.send({
          name: '关注弹窗-长按关注二维码',
          properties: { 渠道名称: this.CHANNELNAME }
        });
      }
      clearInterval(this_.setTime);
      this_.timeOutEvent = 0;
    },
    getKefu: function getKefu() {
      var _this = this;

      this.dialogData = {
        content: '答题或查看报告过程有疑问，请添加客服微信，解决您的问题。',
        actions: [{
          text: '好的',
          callBack: function callBack() {
            _this.dialogData = '';
          }
        }]
      };
    }
  }
});
// CONCATENATED MODULE: ./src/components/common/pageTitle.vue?vue&type=script&lang=js&
 /* harmony default export */ var common_pageTitlevue_type_script_lang_js_ = (pageTitlevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/common/pageTitle.vue?vue&type=style&index=0&id=765fb3af&lang=scss&scoped=true&
var pageTitlevue_type_style_index_0_id_765fb3af_lang_scss_scoped_true_ = __webpack_require__("CpFK");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/common/pageTitle.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  common_pageTitlevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "765fb3af",
  null
  
)

/* harmony default export */ var pageTitle = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "rjj0":
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__("tTVk")

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "rxKx":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),

/***/ "ryRw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var symbol_observable_1 = __webpack_require__("3yIl");
var NO = {};
exports.NO = NO;
function noop() { }
function cp(a) {
    var l = a.length;
    var b = Array(l);
    for (var i = 0; i < l; ++i)
        b[i] = a[i];
    return b;
}
function and(f1, f2) {
    return function andFn(t) {
        return f1(t) && f2(t);
    };
}
function _try(c, t, u) {
    try {
        return c.f(t);
    }
    catch (e) {
        u._e(e);
        return NO;
    }
}
var NO_IL = {
    _n: noop,
    _e: noop,
    _c: noop,
};
exports.NO_IL = NO_IL;
// mutates the input
function internalizeProducer(producer) {
    producer._start = function _start(il) {
        il.next = il._n;
        il.error = il._e;
        il.complete = il._c;
        this.start(il);
    };
    producer._stop = producer.stop;
}
var StreamSub = /** @class */ (function () {
    function StreamSub(_stream, _listener) {
        this._stream = _stream;
        this._listener = _listener;
    }
    StreamSub.prototype.unsubscribe = function () {
        this._stream._remove(this._listener);
    };
    return StreamSub;
}());
var Observer = /** @class */ (function () {
    function Observer(_listener) {
        this._listener = _listener;
    }
    Observer.prototype.next = function (value) {
        this._listener._n(value);
    };
    Observer.prototype.error = function (err) {
        this._listener._e(err);
    };
    Observer.prototype.complete = function () {
        this._listener._c();
    };
    return Observer;
}());
var FromObservable = /** @class */ (function () {
    function FromObservable(observable) {
        this.type = 'fromObservable';
        this.ins = observable;
        this.active = false;
    }
    FromObservable.prototype._start = function (out) {
        this.out = out;
        this.active = true;
        this._sub = this.ins.subscribe(new Observer(out));
        if (!this.active)
            this._sub.unsubscribe();
    };
    FromObservable.prototype._stop = function () {
        if (this._sub)
            this._sub.unsubscribe();
        this.active = false;
    };
    return FromObservable;
}());
var Merge = /** @class */ (function () {
    function Merge(insArr) {
        this.type = 'merge';
        this.insArr = insArr;
        this.out = NO;
        this.ac = 0;
    }
    Merge.prototype._start = function (out) {
        this.out = out;
        var s = this.insArr;
        var L = s.length;
        this.ac = L;
        for (var i = 0; i < L; i++)
            s[i]._add(this);
    };
    Merge.prototype._stop = function () {
        var s = this.insArr;
        var L = s.length;
        for (var i = 0; i < L; i++)
            s[i]._remove(this);
        this.out = NO;
    };
    Merge.prototype._n = function (t) {
        var u = this.out;
        if (u === NO)
            return;
        u._n(t);
    };
    Merge.prototype._e = function (err) {
        var u = this.out;
        if (u === NO)
            return;
        u._e(err);
    };
    Merge.prototype._c = function () {
        if (--this.ac <= 0) {
            var u = this.out;
            if (u === NO)
                return;
            u._c();
        }
    };
    return Merge;
}());
var CombineListener = /** @class */ (function () {
    function CombineListener(i, out, p) {
        this.i = i;
        this.out = out;
        this.p = p;
        p.ils.push(this);
    }
    CombineListener.prototype._n = function (t) {
        var p = this.p, out = this.out;
        if (out === NO)
            return;
        if (p.up(t, this.i)) {
            var a = p.vals;
            var l = a.length;
            var b = Array(l);
            for (var i = 0; i < l; ++i)
                b[i] = a[i];
            out._n(b);
        }
    };
    CombineListener.prototype._e = function (err) {
        var out = this.out;
        if (out === NO)
            return;
        out._e(err);
    };
    CombineListener.prototype._c = function () {
        var p = this.p;
        if (p.out === NO)
            return;
        if (--p.Nc === 0)
            p.out._c();
    };
    return CombineListener;
}());
var Combine = /** @class */ (function () {
    function Combine(insArr) {
        this.type = 'combine';
        this.insArr = insArr;
        this.out = NO;
        this.ils = [];
        this.Nc = this.Nn = 0;
        this.vals = [];
    }
    Combine.prototype.up = function (t, i) {
        var v = this.vals[i];
        var Nn = !this.Nn ? 0 : v === NO ? --this.Nn : this.Nn;
        this.vals[i] = t;
        return Nn === 0;
    };
    Combine.prototype._start = function (out) {
        this.out = out;
        var s = this.insArr;
        var n = this.Nc = this.Nn = s.length;
        var vals = this.vals = new Array(n);
        if (n === 0) {
            out._n([]);
            out._c();
        }
        else {
            for (var i = 0; i < n; i++) {
                vals[i] = NO;
                s[i]._add(new CombineListener(i, out, this));
            }
        }
    };
    Combine.prototype._stop = function () {
        var s = this.insArr;
        var n = s.length;
        var ils = this.ils;
        for (var i = 0; i < n; i++)
            s[i]._remove(ils[i]);
        this.out = NO;
        this.ils = [];
        this.vals = [];
    };
    return Combine;
}());
var FromArray = /** @class */ (function () {
    function FromArray(a) {
        this.type = 'fromArray';
        this.a = a;
    }
    FromArray.prototype._start = function (out) {
        var a = this.a;
        for (var i = 0, n = a.length; i < n; i++)
            out._n(a[i]);
        out._c();
    };
    FromArray.prototype._stop = function () {
    };
    return FromArray;
}());
var FromPromise = /** @class */ (function () {
    function FromPromise(p) {
        this.type = 'fromPromise';
        this.on = false;
        this.p = p;
    }
    FromPromise.prototype._start = function (out) {
        var prod = this;
        this.on = true;
        this.p.then(function (v) {
            if (prod.on) {
                out._n(v);
                out._c();
            }
        }, function (e) {
            out._e(e);
        }).then(noop, function (err) {
            setTimeout(function () { throw err; });
        });
    };
    FromPromise.prototype._stop = function () {
        this.on = false;
    };
    return FromPromise;
}());
var Periodic = /** @class */ (function () {
    function Periodic(period) {
        this.type = 'periodic';
        this.period = period;
        this.intervalID = -1;
        this.i = 0;
    }
    Periodic.prototype._start = function (out) {
        var self = this;
        function intervalHandler() { out._n(self.i++); }
        this.intervalID = setInterval(intervalHandler, this.period);
    };
    Periodic.prototype._stop = function () {
        if (this.intervalID !== -1)
            clearInterval(this.intervalID);
        this.intervalID = -1;
        this.i = 0;
    };
    return Periodic;
}());
var Debug = /** @class */ (function () {
    function Debug(ins, arg) {
        this.type = 'debug';
        this.ins = ins;
        this.out = NO;
        this.s = noop;
        this.l = '';
        if (typeof arg === 'string')
            this.l = arg;
        else if (typeof arg === 'function')
            this.s = arg;
    }
    Debug.prototype._start = function (out) {
        this.out = out;
        this.ins._add(this);
    };
    Debug.prototype._stop = function () {
        this.ins._remove(this);
        this.out = NO;
    };
    Debug.prototype._n = function (t) {
        var u = this.out;
        if (u === NO)
            return;
        var s = this.s, l = this.l;
        if (s !== noop) {
            try {
                s(t);
            }
            catch (e) {
                u._e(e);
            }
        }
        else if (l)
            console.log(l + ':', t);
        else
            console.log(t);
        u._n(t);
    };
    Debug.prototype._e = function (err) {
        var u = this.out;
        if (u === NO)
            return;
        u._e(err);
    };
    Debug.prototype._c = function () {
        var u = this.out;
        if (u === NO)
            return;
        u._c();
    };
    return Debug;
}());
var Drop = /** @class */ (function () {
    function Drop(max, ins) {
        this.type = 'drop';
        this.ins = ins;
        this.out = NO;
        this.max = max;
        this.dropped = 0;
    }
    Drop.prototype._start = function (out) {
        this.out = out;
        this.dropped = 0;
        this.ins._add(this);
    };
    Drop.prototype._stop = function () {
        this.ins._remove(this);
        this.out = NO;
    };
    Drop.prototype._n = function (t) {
        var u = this.out;
        if (u === NO)
            return;
        if (this.dropped++ >= this.max)
            u._n(t);
    };
    Drop.prototype._e = function (err) {
        var u = this.out;
        if (u === NO)
            return;
        u._e(err);
    };
    Drop.prototype._c = function () {
        var u = this.out;
        if (u === NO)
            return;
        u._c();
    };
    return Drop;
}());
var EndWhenListener = /** @class */ (function () {
    function EndWhenListener(out, op) {
        this.out = out;
        this.op = op;
    }
    EndWhenListener.prototype._n = function () {
        this.op.end();
    };
    EndWhenListener.prototype._e = function (err) {
        this.out._e(err);
    };
    EndWhenListener.prototype._c = function () {
        this.op.end();
    };
    return EndWhenListener;
}());
var EndWhen = /** @class */ (function () {
    function EndWhen(o, ins) {
        this.type = 'endWhen';
        this.ins = ins;
        this.out = NO;
        this.o = o;
        this.oil = NO_IL;
    }
    EndWhen.prototype._start = function (out) {
        this.out = out;
        this.o._add(this.oil = new EndWhenListener(out, this));
        this.ins._add(this);
    };
    EndWhen.prototype._stop = function () {
        this.ins._remove(this);
        this.o._remove(this.oil);
        this.out = NO;
        this.oil = NO_IL;
    };
    EndWhen.prototype.end = function () {
        var u = this.out;
        if (u === NO)
            return;
        u._c();
    };
    EndWhen.prototype._n = function (t) {
        var u = this.out;
        if (u === NO)
            return;
        u._n(t);
    };
    EndWhen.prototype._e = function (err) {
        var u = this.out;
        if (u === NO)
            return;
        u._e(err);
    };
    EndWhen.prototype._c = function () {
        this.end();
    };
    return EndWhen;
}());
var Filter = /** @class */ (function () {
    function Filter(passes, ins) {
        this.type = 'filter';
        this.ins = ins;
        this.out = NO;
        this.f = passes;
    }
    Filter.prototype._start = function (out) {
        this.out = out;
        this.ins._add(this);
    };
    Filter.prototype._stop = function () {
        this.ins._remove(this);
        this.out = NO;
    };
    Filter.prototype._n = function (t) {
        var u = this.out;
        if (u === NO)
            return;
        var r = _try(this, t, u);
        if (r === NO || !r)
            return;
        u._n(t);
    };
    Filter.prototype._e = function (err) {
        var u = this.out;
        if (u === NO)
            return;
        u._e(err);
    };
    Filter.prototype._c = function () {
        var u = this.out;
        if (u === NO)
            return;
        u._c();
    };
    return Filter;
}());
var FlattenListener = /** @class */ (function () {
    function FlattenListener(out, op) {
        this.out = out;
        this.op = op;
    }
    FlattenListener.prototype._n = function (t) {
        this.out._n(t);
    };
    FlattenListener.prototype._e = function (err) {
        this.out._e(err);
    };
    FlattenListener.prototype._c = function () {
        this.op.inner = NO;
        this.op.less();
    };
    return FlattenListener;
}());
var Flatten = /** @class */ (function () {
    function Flatten(ins) {
        this.type = 'flatten';
        this.ins = ins;
        this.out = NO;
        this.open = true;
        this.inner = NO;
        this.il = NO_IL;
    }
    Flatten.prototype._start = function (out) {
        this.out = out;
        this.open = true;
        this.inner = NO;
        this.il = NO_IL;
        this.ins._add(this);
    };
    Flatten.prototype._stop = function () {
        this.ins._remove(this);
        if (this.inner !== NO)
            this.inner._remove(this.il);
        this.out = NO;
        this.open = true;
        this.inner = NO;
        this.il = NO_IL;
    };
    Flatten.prototype.less = function () {
        var u = this.out;
        if (u === NO)
            return;
        if (!this.open && this.inner === NO)
            u._c();
    };
    Flatten.prototype._n = function (s) {
        var u = this.out;
        if (u === NO)
            return;
        var _a = this, inner = _a.inner, il = _a.il;
        if (inner !== NO && il !== NO_IL)
            inner._remove(il);
        (this.inner = s)._add(this.il = new FlattenListener(u, this));
    };
    Flatten.prototype._e = function (err) {
        var u = this.out;
        if (u === NO)
            return;
        u._e(err);
    };
    Flatten.prototype._c = function () {
        this.open = false;
        this.less();
    };
    return Flatten;
}());
var Fold = /** @class */ (function () {
    function Fold(f, seed, ins) {
        var _this = this;
        this.type = 'fold';
        this.ins = ins;
        this.out = NO;
        this.f = function (t) { return f(_this.acc, t); };
        this.acc = this.seed = seed;
    }
    Fold.prototype._start = function (out) {
        this.out = out;
        this.acc = this.seed;
        out._n(this.acc);
        this.ins._add(this);
    };
    Fold.prototype._stop = function () {
        this.ins._remove(this);
        this.out = NO;
        this.acc = this.seed;
    };
    Fold.prototype._n = function (t) {
        var u = this.out;
        if (u === NO)
            return;
        var r = _try(this, t, u);
        if (r === NO)
            return;
        u._n(this.acc = r);
    };
    Fold.prototype._e = function (err) {
        var u = this.out;
        if (u === NO)
            return;
        u._e(err);
    };
    Fold.prototype._c = function () {
        var u = this.out;
        if (u === NO)
            return;
        u._c();
    };
    return Fold;
}());
var Last = /** @class */ (function () {
    function Last(ins) {
        this.type = 'last';
        this.ins = ins;
        this.out = NO;
        this.has = false;
        this.val = NO;
    }
    Last.prototype._start = function (out) {
        this.out = out;
        this.has = false;
        this.ins._add(this);
    };
    Last.prototype._stop = function () {
        this.ins._remove(this);
        this.out = NO;
        this.val = NO;
    };
    Last.prototype._n = function (t) {
        this.has = true;
        this.val = t;
    };
    Last.prototype._e = function (err) {
        var u = this.out;
        if (u === NO)
            return;
        u._e(err);
    };
    Last.prototype._c = function () {
        var u = this.out;
        if (u === NO)
            return;
        if (this.has) {
            u._n(this.val);
            u._c();
        }
        else
            u._e(new Error('last() failed because input stream completed'));
    };
    return Last;
}());
var MapOp = /** @class */ (function () {
    function MapOp(project, ins) {
        this.type = 'map';
        this.ins = ins;
        this.out = NO;
        this.f = project;
    }
    MapOp.prototype._start = function (out) {
        this.out = out;
        this.ins._add(this);
    };
    MapOp.prototype._stop = function () {
        this.ins._remove(this);
        this.out = NO;
    };
    MapOp.prototype._n = function (t) {
        var u = this.out;
        if (u === NO)
            return;
        var r = _try(this, t, u);
        if (r === NO)
            return;
        u._n(r);
    };
    MapOp.prototype._e = function (err) {
        var u = this.out;
        if (u === NO)
            return;
        u._e(err);
    };
    MapOp.prototype._c = function () {
        var u = this.out;
        if (u === NO)
            return;
        u._c();
    };
    return MapOp;
}());
var Remember = /** @class */ (function () {
    function Remember(ins) {
        this.type = 'remember';
        this.ins = ins;
        this.out = NO;
    }
    Remember.prototype._start = function (out) {
        this.out = out;
        this.ins._add(out);
    };
    Remember.prototype._stop = function () {
        this.ins._remove(this.out);
        this.out = NO;
    };
    return Remember;
}());
var ReplaceError = /** @class */ (function () {
    function ReplaceError(replacer, ins) {
        this.type = 'replaceError';
        this.ins = ins;
        this.out = NO;
        this.f = replacer;
    }
    ReplaceError.prototype._start = function (out) {
        this.out = out;
        this.ins._add(this);
    };
    ReplaceError.prototype._stop = function () {
        this.ins._remove(this);
        this.out = NO;
    };
    ReplaceError.prototype._n = function (t) {
        var u = this.out;
        if (u === NO)
            return;
        u._n(t);
    };
    ReplaceError.prototype._e = function (err) {
        var u = this.out;
        if (u === NO)
            return;
        try {
            this.ins._remove(this);
            (this.ins = this.f(err))._add(this);
        }
        catch (e) {
            u._e(e);
        }
    };
    ReplaceError.prototype._c = function () {
        var u = this.out;
        if (u === NO)
            return;
        u._c();
    };
    return ReplaceError;
}());
var StartWith = /** @class */ (function () {
    function StartWith(ins, val) {
        this.type = 'startWith';
        this.ins = ins;
        this.out = NO;
        this.val = val;
    }
    StartWith.prototype._start = function (out) {
        this.out = out;
        this.out._n(this.val);
        this.ins._add(out);
    };
    StartWith.prototype._stop = function () {
        this.ins._remove(this.out);
        this.out = NO;
    };
    return StartWith;
}());
var Take = /** @class */ (function () {
    function Take(max, ins) {
        this.type = 'take';
        this.ins = ins;
        this.out = NO;
        this.max = max;
        this.taken = 0;
    }
    Take.prototype._start = function (out) {
        this.out = out;
        this.taken = 0;
        if (this.max <= 0)
            out._c();
        else
            this.ins._add(this);
    };
    Take.prototype._stop = function () {
        this.ins._remove(this);
        this.out = NO;
    };
    Take.prototype._n = function (t) {
        var u = this.out;
        if (u === NO)
            return;
        var m = ++this.taken;
        if (m < this.max)
            u._n(t);
        else if (m === this.max) {
            u._n(t);
            u._c();
        }
    };
    Take.prototype._e = function (err) {
        var u = this.out;
        if (u === NO)
            return;
        u._e(err);
    };
    Take.prototype._c = function () {
        var u = this.out;
        if (u === NO)
            return;
        u._c();
    };
    return Take;
}());
var Stream = /** @class */ (function () {
    function Stream(producer) {
        this._prod = producer || NO;
        this._ils = [];
        this._stopID = NO;
        this._dl = NO;
        this._d = false;
        this._target = NO;
        this._err = NO;
    }
    Stream.prototype._n = function (t) {
        var a = this._ils;
        var L = a.length;
        if (this._d)
            this._dl._n(t);
        if (L == 1)
            a[0]._n(t);
        else if (L == 0)
            return;
        else {
            var b = cp(a);
            for (var i = 0; i < L; i++)
                b[i]._n(t);
        }
    };
    Stream.prototype._e = function (err) {
        if (this._err !== NO)
            return;
        this._err = err;
        var a = this._ils;
        var L = a.length;
        this._x();
        if (this._d)
            this._dl._e(err);
        if (L == 1)
            a[0]._e(err);
        else if (L == 0)
            return;
        else {
            var b = cp(a);
            for (var i = 0; i < L; i++)
                b[i]._e(err);
        }
        if (!this._d && L == 0)
            throw this._err;
    };
    Stream.prototype._c = function () {
        var a = this._ils;
        var L = a.length;
        this._x();
        if (this._d)
            this._dl._c();
        if (L == 1)
            a[0]._c();
        else if (L == 0)
            return;
        else {
            var b = cp(a);
            for (var i = 0; i < L; i++)
                b[i]._c();
        }
    };
    Stream.prototype._x = function () {
        if (this._ils.length === 0)
            return;
        if (this._prod !== NO)
            this._prod._stop();
        this._err = NO;
        this._ils = [];
    };
    Stream.prototype._stopNow = function () {
        // WARNING: code that calls this method should
        // first check if this._prod is valid (not `NO`)
        this._prod._stop();
        this._err = NO;
        this._stopID = NO;
    };
    Stream.prototype._add = function (il) {
        var ta = this._target;
        if (ta !== NO)
            return ta._add(il);
        var a = this._ils;
        a.push(il);
        if (a.length > 1)
            return;
        if (this._stopID !== NO) {
            clearTimeout(this._stopID);
            this._stopID = NO;
        }
        else {
            var p = this._prod;
            if (p !== NO)
                p._start(this);
        }
    };
    Stream.prototype._remove = function (il) {
        var _this = this;
        var ta = this._target;
        if (ta !== NO)
            return ta._remove(il);
        var a = this._ils;
        var i = a.indexOf(il);
        if (i > -1) {
            a.splice(i, 1);
            if (this._prod !== NO && a.length <= 0) {
                this._err = NO;
                this._stopID = setTimeout(function () { return _this._stopNow(); });
            }
            else if (a.length === 1) {
                this._pruneCycles();
            }
        }
    };
    // If all paths stemming from `this` stream eventually end at `this`
    // stream, then we remove the single listener of `this` stream, to
    // force it to end its execution and dispose resources. This method
    // assumes as a precondition that this._ils has just one listener.
    Stream.prototype._pruneCycles = function () {
        if (this._hasNoSinks(this, []))
            this._remove(this._ils[0]);
    };
    // Checks whether *there is no* path starting from `x` that leads to an end
    // listener (sink) in the stream graph, following edges A->B where B is a
    // listener of A. This means these paths constitute a cycle somehow. Is given
    // a trace of all visited nodes so far.
    Stream.prototype._hasNoSinks = function (x, trace) {
        if (trace.indexOf(x) !== -1)
            return true;
        else if (x.out === this)
            return true;
        else if (x.out && x.out !== NO)
            return this._hasNoSinks(x.out, trace.concat(x));
        else if (x._ils) {
            for (var i = 0, N = x._ils.length; i < N; i++)
                if (!this._hasNoSinks(x._ils[i], trace.concat(x)))
                    return false;
            return true;
        }
        else
            return false;
    };
    Stream.prototype.ctor = function () {
        return this instanceof MemoryStream ? MemoryStream : Stream;
    };
    /**
     * Adds a Listener to the Stream.
     *
     * @param {Listener} listener
     */
    Stream.prototype.addListener = function (listener) {
        listener._n = listener.next || noop;
        listener._e = listener.error || noop;
        listener._c = listener.complete || noop;
        this._add(listener);
    };
    /**
     * Removes a Listener from the Stream, assuming the Listener was added to it.
     *
     * @param {Listener<T>} listener
     */
    Stream.prototype.removeListener = function (listener) {
        this._remove(listener);
    };
    /**
     * Adds a Listener to the Stream returning a Subscription to remove that
     * listener.
     *
     * @param {Listener} listener
     * @returns {Subscription}
     */
    Stream.prototype.subscribe = function (listener) {
        this.addListener(listener);
        return new StreamSub(this, listener);
    };
    /**
     * Add interop between most.js and RxJS 5
     *
     * @returns {Stream}
     */
    Stream.prototype[symbol_observable_1.default] = function () {
        return this;
    };
    /**
     * Creates a new Stream given a Producer.
     *
     * @factory true
     * @param {Producer} producer An optional Producer that dictates how to
     * start, generate events, and stop the Stream.
     * @return {Stream}
     */
    Stream.create = function (producer) {
        if (producer) {
            if (typeof producer.start !== 'function'
                || typeof producer.stop !== 'function')
                throw new Error('producer requires both start and stop functions');
            internalizeProducer(producer); // mutates the input
        }
        return new Stream(producer);
    };
    /**
     * Creates a new MemoryStream given a Producer.
     *
     * @factory true
     * @param {Producer} producer An optional Producer that dictates how to
     * start, generate events, and stop the Stream.
     * @return {MemoryStream}
     */
    Stream.createWithMemory = function (producer) {
        if (producer)
            internalizeProducer(producer); // mutates the input
        return new MemoryStream(producer);
    };
    /**
     * Creates a Stream that does nothing when started. It never emits any event.
     *
     * Marble diagram:
     *
     * ```text
     *          never
     * -----------------------
     * ```
     *
     * @factory true
     * @return {Stream}
     */
    Stream.never = function () {
        return new Stream({ _start: noop, _stop: noop });
    };
    /**
     * Creates a Stream that immediately emits the "complete" notification when
     * started, and that's it.
     *
     * Marble diagram:
     *
     * ```text
     * empty
     * -|
     * ```
     *
     * @factory true
     * @return {Stream}
     */
    Stream.empty = function () {
        return new Stream({
            _start: function (il) { il._c(); },
            _stop: noop,
        });
    };
    /**
     * Creates a Stream that immediately emits an "error" notification with the
     * value you passed as the `error` argument when the stream starts, and that's
     * it.
     *
     * Marble diagram:
     *
     * ```text
     * throw(X)
     * -X
     * ```
     *
     * @factory true
     * @param error The error event to emit on the created stream.
     * @return {Stream}
     */
    Stream.throw = function (error) {
        return new Stream({
            _start: function (il) { il._e(error); },
            _stop: noop,
        });
    };
    /**
     * Creates a stream from an Array, Promise, or an Observable.
     *
     * @factory true
     * @param {Array|PromiseLike|Observable} input The input to make a stream from.
     * @return {Stream}
     */
    Stream.from = function (input) {
        if (typeof input[symbol_observable_1.default] === 'function')
            return Stream.fromObservable(input);
        else if (typeof input.then === 'function')
            return Stream.fromPromise(input);
        else if (Array.isArray(input))
            return Stream.fromArray(input);
        throw new TypeError("Type of input to from() must be an Array, Promise, or Observable");
    };
    /**
     * Creates a Stream that immediately emits the arguments that you give to
     * *of*, then completes.
     *
     * Marble diagram:
     *
     * ```text
     * of(1,2,3)
     * 123|
     * ```
     *
     * @factory true
     * @param a The first value you want to emit as an event on the stream.
     * @param b The second value you want to emit as an event on the stream. One
     * or more of these values may be given as arguments.
     * @return {Stream}
     */
    Stream.of = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        return Stream.fromArray(items);
    };
    /**
     * Converts an array to a stream. The returned stream will emit synchronously
     * all the items in the array, and then complete.
     *
     * Marble diagram:
     *
     * ```text
     * fromArray([1,2,3])
     * 123|
     * ```
     *
     * @factory true
     * @param {Array} array The array to be converted as a stream.
     * @return {Stream}
     */
    Stream.fromArray = function (array) {
        return new Stream(new FromArray(array));
    };
    /**
     * Converts a promise to a stream. The returned stream will emit the resolved
     * value of the promise, and then complete. However, if the promise is
     * rejected, the stream will emit the corresponding error.
     *
     * Marble diagram:
     *
     * ```text
     * fromPromise( ----42 )
     * -----------------42|
     * ```
     *
     * @factory true
     * @param {PromiseLike} promise The promise to be converted as a stream.
     * @return {Stream}
     */
    Stream.fromPromise = function (promise) {
        return new Stream(new FromPromise(promise));
    };
    /**
     * Converts an Observable into a Stream.
     *
     * @factory true
     * @param {any} observable The observable to be converted as a stream.
     * @return {Stream}
     */
    Stream.fromObservable = function (obs) {
        if (obs.endWhen)
            return obs;
        var o = typeof obs[symbol_observable_1.default] === 'function' ? obs[symbol_observable_1.default]() : obs;
        return new Stream(new FromObservable(o));
    };
    /**
     * Creates a stream that periodically emits incremental numbers, every
     * `period` milliseconds.
     *
     * Marble diagram:
     *
     * ```text
     *     periodic(1000)
     * ---0---1---2---3---4---...
     * ```
     *
     * @factory true
     * @param {number} period The interval in milliseconds to use as a rate of
     * emission.
     * @return {Stream}
     */
    Stream.periodic = function (period) {
        return new Stream(new Periodic(period));
    };
    Stream.prototype._map = function (project) {
        return new (this.ctor())(new MapOp(project, this));
    };
    /**
     * Transforms each event from the input Stream through a `project` function,
     * to get a Stream that emits those transformed events.
     *
     * Marble diagram:
     *
     * ```text
     * --1---3--5-----7------
     *    map(i => i * 10)
     * --10--30-50----70-----
     * ```
     *
     * @param {Function} project A function of type `(t: T) => U` that takes event
     * `t` of type `T` from the input Stream and produces an event of type `U`, to
     * be emitted on the output Stream.
     * @return {Stream}
     */
    Stream.prototype.map = function (project) {
        return this._map(project);
    };
    /**
     * It's like `map`, but transforms each input event to always the same
     * constant value on the output Stream.
     *
     * Marble diagram:
     *
     * ```text
     * --1---3--5-----7-----
     *       mapTo(10)
     * --10--10-10----10----
     * ```
     *
     * @param projectedValue A value to emit on the output Stream whenever the
     * input Stream emits any value.
     * @return {Stream}
     */
    Stream.prototype.mapTo = function (projectedValue) {
        var s = this.map(function () { return projectedValue; });
        var op = s._prod;
        op.type = 'mapTo';
        return s;
    };
    /**
     * Only allows events that pass the test given by the `passes` argument.
     *
     * Each event from the input stream is given to the `passes` function. If the
     * function returns `true`, the event is forwarded to the output stream,
     * otherwise it is ignored and not forwarded.
     *
     * Marble diagram:
     *
     * ```text
     * --1---2--3-----4-----5---6--7-8--
     *     filter(i => i % 2 === 0)
     * ------2--------4---------6----8--
     * ```
     *
     * @param {Function} passes A function of type `(t: T) => boolean` that takes
     * an event from the input stream and checks if it passes, by returning a
     * boolean.
     * @return {Stream}
     */
    Stream.prototype.filter = function (passes) {
        var p = this._prod;
        if (p instanceof Filter)
            return new Stream(new Filter(and(p.f, passes), p.ins));
        return new Stream(new Filter(passes, this));
    };
    /**
     * Lets the first `amount` many events from the input stream pass to the
     * output stream, then makes the output stream complete.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c----d---e--
     *    take(3)
     * --a---b--c|
     * ```
     *
     * @param {number} amount How many events to allow from the input stream
     * before completing the output stream.
     * @return {Stream}
     */
    Stream.prototype.take = function (amount) {
        return new (this.ctor())(new Take(amount, this));
    };
    /**
     * Ignores the first `amount` many events from the input stream, and then
     * after that starts forwarding events from the input stream to the output
     * stream.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c----d---e--
     *       drop(3)
     * --------------d---e--
     * ```
     *
     * @param {number} amount How many events to ignore from the input stream
     * before forwarding all events from the input stream to the output stream.
     * @return {Stream}
     */
    Stream.prototype.drop = function (amount) {
        return new Stream(new Drop(amount, this));
    };
    /**
     * When the input stream completes, the output stream will emit the last event
     * emitted by the input stream, and then will also complete.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c--d----|
     *       last()
     * -----------------d|
     * ```
     *
     * @return {Stream}
     */
    Stream.prototype.last = function () {
        return new Stream(new Last(this));
    };
    /**
     * Prepends the given `initial` value to the sequence of events emitted by the
     * input stream. The returned stream is a MemoryStream, which means it is
     * already `remember()`'d.
     *
     * Marble diagram:
     *
     * ```text
     * ---1---2-----3---
     *   startWith(0)
     * 0--1---2-----3---
     * ```
     *
     * @param initial The value or event to prepend.
     * @return {MemoryStream}
     */
    Stream.prototype.startWith = function (initial) {
        return new MemoryStream(new StartWith(this, initial));
    };
    /**
     * Uses another stream to determine when to complete the current stream.
     *
     * When the given `other` stream emits an event or completes, the output
     * stream will complete. Before that happens, the output stream will behaves
     * like the input stream.
     *
     * Marble diagram:
     *
     * ```text
     * ---1---2-----3--4----5----6---
     *   endWhen( --------a--b--| )
     * ---1---2-----3--4--|
     * ```
     *
     * @param other Some other stream that is used to know when should the output
     * stream of this operator complete.
     * @return {Stream}
     */
    Stream.prototype.endWhen = function (other) {
        return new (this.ctor())(new EndWhen(other, this));
    };
    /**
     * "Folds" the stream onto itself.
     *
     * Combines events from the past throughout
     * the entire execution of the input stream, allowing you to accumulate them
     * together. It's essentially like `Array.prototype.reduce`. The returned
     * stream is a MemoryStream, which means it is already `remember()`'d.
     *
     * The output stream starts by emitting the `seed` which you give as argument.
     * Then, when an event happens on the input stream, it is combined with that
     * seed value through the `accumulate` function, and the output value is
     * emitted on the output stream. `fold` remembers that output value as `acc`
     * ("accumulator"), and then when a new input event `t` happens, `acc` will be
     * combined with that to produce the new `acc` and so forth.
     *
     * Marble diagram:
     *
     * ```text
     * ------1-----1--2----1----1------
     *   fold((acc, x) => acc + x, 3)
     * 3-----4-----5--7----8----9------
     * ```
     *
     * @param {Function} accumulate A function of type `(acc: R, t: T) => R` that
     * takes the previous accumulated value `acc` and the incoming event from the
     * input stream and produces the new accumulated value.
     * @param seed The initial accumulated value, of type `R`.
     * @return {MemoryStream}
     */
    Stream.prototype.fold = function (accumulate, seed) {
        return new MemoryStream(new Fold(accumulate, seed, this));
    };
    /**
     * Replaces an error with another stream.
     *
     * When (and if) an error happens on the input stream, instead of forwarding
     * that error to the output stream, *replaceError* will call the `replace`
     * function which returns the stream that the output stream will replicate.
     * And, in case that new stream also emits an error, `replace` will be called
     * again to get another stream to start replicating.
     *
     * Marble diagram:
     *
     * ```text
     * --1---2-----3--4-----X
     *   replaceError( () => --10--| )
     * --1---2-----3--4--------10--|
     * ```
     *
     * @param {Function} replace A function of type `(err) => Stream` that takes
     * the error that occurred on the input stream or on the previous replacement
     * stream and returns a new stream. The output stream will behave like the
     * stream that this function returns.
     * @return {Stream}
     */
    Stream.prototype.replaceError = function (replace) {
        return new (this.ctor())(new ReplaceError(replace, this));
    };
    /**
     * Flattens a "stream of streams", handling only one nested stream at a time
     * (no concurrency).
     *
     * If the input stream is a stream that emits streams, then this operator will
     * return an output stream which is a flat stream: emits regular events. The
     * flattening happens without concurrency. It works like this: when the input
     * stream emits a nested stream, *flatten* will start imitating that nested
     * one. However, as soon as the next nested stream is emitted on the input
     * stream, *flatten* will forget the previous nested one it was imitating, and
     * will start imitating the new nested one.
     *
     * Marble diagram:
     *
     * ```text
     * --+--------+---------------
     *   \        \
     *    \       ----1----2---3--
     *    --a--b----c----d--------
     *           flatten
     * -----a--b------1----2---3--
     * ```
     *
     * @return {Stream}
     */
    Stream.prototype.flatten = function () {
        return new Stream(new Flatten(this));
    };
    /**
     * Passes the input stream to a custom operator, to produce an output stream.
     *
     * *compose* is a handy way of using an existing function in a chained style.
     * Instead of writing `outStream = f(inStream)` you can write
     * `outStream = inStream.compose(f)`.
     *
     * @param {function} operator A function that takes a stream as input and
     * returns a stream as well.
     * @return {Stream}
     */
    Stream.prototype.compose = function (operator) {
        return operator(this);
    };
    /**
     * Returns an output stream that behaves like the input stream, but also
     * remembers the most recent event that happens on the input stream, so that a
     * newly added listener will immediately receive that memorised event.
     *
     * @return {MemoryStream}
     */
    Stream.prototype.remember = function () {
        return new MemoryStream(new Remember(this));
    };
    /**
     * Returns an output stream that identically behaves like the input stream,
     * but also runs a `spy` function for each event, to help you debug your app.
     *
     * *debug* takes a `spy` function as argument, and runs that for each event
     * happening on the input stream. If you don't provide the `spy` argument,
     * then *debug* will just `console.log` each event. This helps you to
     * understand the flow of events through some operator chain.
     *
     * Please note that if the output stream has no listeners, then it will not
     * start, which means `spy` will never run because no actual event happens in
     * that case.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3-----4--
     *         debug
     * --1----2-----3-----4--
     * ```
     *
     * @param {function} labelOrSpy A string to use as the label when printing
     * debug information on the console, or a 'spy' function that takes an event
     * as argument, and does not need to return anything.
     * @return {Stream}
     */
    Stream.prototype.debug = function (labelOrSpy) {
        return new (this.ctor())(new Debug(this, labelOrSpy));
    };
    /**
     * *imitate* changes this current Stream to emit the same events that the
     * `other` given Stream does. This method returns nothing.
     *
     * This method exists to allow one thing: **circular dependency of streams**.
     * For instance, let's imagine that for some reason you need to create a
     * circular dependency where stream `first$` depends on stream `second$`
     * which in turn depends on `first$`:
     *
     * <!-- skip-example -->
     * ```js
     * import delay from 'xstream/extra/delay'
     *
     * var first$ = second$.map(x => x * 10).take(3);
     * var second$ = first$.map(x => x + 1).startWith(1).compose(delay(100));
     * ```
     *
     * However, that is invalid JavaScript, because `second$` is undefined
     * on the first line. This is how *imitate* can help solve it:
     *
     * ```js
     * import delay from 'xstream/extra/delay'
     *
     * var secondProxy$ = xs.create();
     * var first$ = secondProxy$.map(x => x * 10).take(3);
     * var second$ = first$.map(x => x + 1).startWith(1).compose(delay(100));
     * secondProxy$.imitate(second$);
     * ```
     *
     * We create `secondProxy$` before the others, so it can be used in the
     * declaration of `first$`. Then, after both `first$` and `second$` are
     * defined, we hook `secondProxy$` with `second$` with `imitate()` to tell
     * that they are "the same". `imitate` will not trigger the start of any
     * stream, it just binds `secondProxy$` and `second$` together.
     *
     * The following is an example where `imitate()` is important in Cycle.js
     * applications. A parent component contains some child components. A child
     * has an action stream which is given to the parent to define its state:
     *
     * <!-- skip-example -->
     * ```js
     * const childActionProxy$ = xs.create();
     * const parent = Parent({...sources, childAction$: childActionProxy$});
     * const childAction$ = parent.state$.map(s => s.child.action$).flatten();
     * childActionProxy$.imitate(childAction$);
     * ```
     *
     * Note, though, that **`imitate()` does not support MemoryStreams**. If we
     * would attempt to imitate a MemoryStream in a circular dependency, we would
     * either get a race condition (where the symptom would be "nothing happens")
     * or an infinite cyclic emission of values. It's useful to think about
     * MemoryStreams as cells in a spreadsheet. It doesn't make any sense to
     * define a spreadsheet cell `A1` with a formula that depends on `B1` and
     * cell `B1` defined with a formula that depends on `A1`.
     *
     * If you find yourself wanting to use `imitate()` with a
     * MemoryStream, you should rework your code around `imitate()` to use a
     * Stream instead. Look for the stream in the circular dependency that
     * represents an event stream, and that would be a candidate for creating a
     * proxy Stream which then imitates the target Stream.
     *
     * @param {Stream} target The other stream to imitate on the current one. Must
     * not be a MemoryStream.
     */
    Stream.prototype.imitate = function (target) {
        if (target instanceof MemoryStream)
            throw new Error('A MemoryStream was given to imitate(), but it only ' +
                'supports a Stream. Read more about this restriction here: ' +
                'https://github.com/staltz/xstream#faq');
        this._target = target;
        for (var ils = this._ils, N = ils.length, i = 0; i < N; i++)
            target._add(ils[i]);
        this._ils = [];
    };
    /**
     * Forces the Stream to emit the given value to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     *
     * @param value The "next" value you want to broadcast to all listeners of
     * this Stream.
     */
    Stream.prototype.shamefullySendNext = function (value) {
        this._n(value);
    };
    /**
     * Forces the Stream to emit the given error to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     *
     * @param {any} error The error you want to broadcast to all the listeners of
     * this Stream.
     */
    Stream.prototype.shamefullySendError = function (error) {
        this._e(error);
    };
    /**
     * Forces the Stream to emit the "completed" event to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     */
    Stream.prototype.shamefullySendComplete = function () {
        this._c();
    };
    /**
     * Adds a "debug" listener to the stream. There can only be one debug
     * listener, that's why this is 'setDebugListener'. To remove the debug
     * listener, just call setDebugListener(null).
     *
     * A debug listener is like any other listener. The only difference is that a
     * debug listener is "stealthy": its presence/absence does not trigger the
     * start/stop of the stream (or the producer inside the stream). This is
     * useful so you can inspect what is going on without changing the behavior
     * of the program. If you have an idle stream and you add a normal listener to
     * it, the stream will start executing. But if you set a debug listener on an
     * idle stream, it won't start executing (not until the first normal listener
     * is added).
     *
     * As the name indicates, we don't recommend using this method to build app
     * logic. In fact, in most cases the debug operator works just fine. Only use
     * this one if you know what you're doing.
     *
     * @param {Listener<T>} listener
     */
    Stream.prototype.setDebugListener = function (listener) {
        if (!listener) {
            this._d = false;
            this._dl = NO;
        }
        else {
            this._d = true;
            listener._n = listener.next || noop;
            listener._e = listener.error || noop;
            listener._c = listener.complete || noop;
            this._dl = listener;
        }
    };
    /**
     * Blends multiple streams together, emitting events from all of them
     * concurrently.
     *
     * *merge* takes multiple streams as arguments, and creates a stream that
     * behaves like each of the argument streams, in parallel.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3--------4---
     * ----a-----b----c---d------
     *            merge
     * --1-a--2--b--3-c---d--4---
     * ```
     *
     * @factory true
     * @param {Stream} stream1 A stream to merge together with other streams.
     * @param {Stream} stream2 A stream to merge together with other streams. Two
     * or more streams may be given as arguments.
     * @return {Stream}
     */
    Stream.merge = function merge() {
        var streams = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            streams[_i] = arguments[_i];
        }
        return new Stream(new Merge(streams));
    };
    /**
     * Combines multiple input streams together to return a stream whose events
     * are arrays that collect the latest events from each input stream.
     *
     * *combine* internally remembers the most recent event from each of the input
     * streams. When any of the input streams emits an event, that event together
     * with all the other saved events are combined into an array. That array will
     * be emitted on the output stream. It's essentially a way of joining together
     * the events from multiple streams.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3--------4---
     * ----a-----b-----c--d------
     *          combine
     * ----1a-2a-2b-3b-3c-3d-4d--
     * ```
     *
     * @factory true
     * @param {Stream} stream1 A stream to combine together with other streams.
     * @param {Stream} stream2 A stream to combine together with other streams.
     * Multiple streams, not just two, may be given as arguments.
     * @return {Stream}
     */
    Stream.combine = function combine() {
        var streams = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            streams[_i] = arguments[_i];
        }
        return new Stream(new Combine(streams));
    };
    return Stream;
}());
exports.Stream = Stream;
var MemoryStream = /** @class */ (function (_super) {
    __extends(MemoryStream, _super);
    function MemoryStream(producer) {
        var _this = _super.call(this, producer) || this;
        _this._has = false;
        return _this;
    }
    MemoryStream.prototype._n = function (x) {
        this._v = x;
        this._has = true;
        _super.prototype._n.call(this, x);
    };
    MemoryStream.prototype._add = function (il) {
        var ta = this._target;
        if (ta !== NO)
            return ta._add(il);
        var a = this._ils;
        a.push(il);
        if (a.length > 1) {
            if (this._has)
                il._n(this._v);
            return;
        }
        if (this._stopID !== NO) {
            if (this._has)
                il._n(this._v);
            clearTimeout(this._stopID);
            this._stopID = NO;
        }
        else if (this._has)
            il._n(this._v);
        else {
            var p = this._prod;
            if (p !== NO)
                p._start(this);
        }
    };
    MemoryStream.prototype._stopNow = function () {
        this._has = false;
        _super.prototype._stopNow.call(this);
    };
    MemoryStream.prototype._x = function () {
        this._has = false;
        _super.prototype._x.call(this);
    };
    MemoryStream.prototype.map = function (project) {
        return this._map(project);
    };
    MemoryStream.prototype.mapTo = function (projectedValue) {
        return _super.prototype.mapTo.call(this, projectedValue);
    };
    MemoryStream.prototype.take = function (amount) {
        return _super.prototype.take.call(this, amount);
    };
    MemoryStream.prototype.endWhen = function (other) {
        return _super.prototype.endWhen.call(this, other);
    };
    MemoryStream.prototype.replaceError = function (replace) {
        return _super.prototype.replaceError.call(this, replace);
    };
    MemoryStream.prototype.remember = function () {
        return this;
    };
    MemoryStream.prototype.debug = function (labelOrSpy) {
        return _super.prototype.debug.call(this, labelOrSpy);
    };
    return MemoryStream;
}(Stream));
exports.MemoryStream = MemoryStream;
var xs = Stream;
exports.default = xs;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ "s4j0":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("UKM+");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "sB3e":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "sF+V":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("kM2E");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("Yobk") });


/***/ }),

/***/ "sOR5":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "sVYa":
/***/ (function(module, exports) {


;(function(win, lib) {
    var doc = win.document;
    var docEl = doc.documentElement;
    var metaEl = doc.querySelector('meta[name="viewport"]');
    var flexibleEl = doc.querySelector('meta[name="flexible"]');
    var dpr = 0;
    var scale = 0;
    var tid;
    var flexible = lib.flexible || (lib.flexible = {});

    if (metaEl) {
        console.warn('将根据已有的meta标签来设置缩放比例');
        var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
        if (match) {
            scale = parseFloat(match[1]);
            dpr = parseInt(1 / scale);
        }
    } else if (flexibleEl) {
        var content = flexibleEl.getAttribute('content');
        if (content) {
            var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
            var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
            if (initialDpr) {
                dpr = parseFloat(initialDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
            if (maximumDpr) {
                dpr = parseFloat(maximumDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
        }
    }

    if (!dpr && !scale) {
        var isAndroid = win.navigator.appVersion.match(/android/gi);
        var isIPhone = win.navigator.appVersion.match(/iphone/gi);
        var devicePixelRatio = win.devicePixelRatio;
        if (isIPhone) {
            // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
            if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
                dpr = 3;
            } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)){
                dpr = 2;
            } else {
                dpr = 1;
            }
        } else {
            // 其他设备下，仍旧使用1倍的方案
            dpr = 1;
        }
        scale = 1 / dpr;
    }

    docEl.setAttribute('data-dpr', dpr);
    if (!metaEl) {
        metaEl = doc.createElement('meta');
        metaEl.setAttribute('name', 'viewport');
        metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no');
        if (docEl.firstElementChild) {
            docEl.firstElementChild.appendChild(metaEl);
        } else {
            var wrap = doc.createElement('div');
            wrap.appendChild(metaEl);
            doc.write(wrap.innerHTML);
        }
    }

    function refreshRem(){
        var width = docEl.getBoundingClientRect().width;
        if (width / dpr > 540) {
            width = 540 * dpr;
        }
        var rem = width / 10;
        docEl.style.fontSize = rem + 'px';
        flexible.rem = win.rem = rem;
    }

    win.addEventListener('resize', function() {
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
    }, false);
    win.addEventListener('pageshow', function(e) {
        if (e.persisted) {
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
        }
    }, false);

    if (doc.readyState === 'complete') {
        doc.body.style.fontSize = 12 * dpr + 'px';
    } else {
        doc.addEventListener('DOMContentLoaded', function(e) {
            doc.body.style.fontSize = 12 * dpr + 'px';
        }, false);
    }


    refreshRem();

    flexible.dpr = win.dpr = dpr;
    flexible.refreshRem = refreshRem;
    flexible.rem2px = function(d) {
        var val = parseFloat(d) * this.rem;
        if (typeof d === 'string' && d.match(/rem$/)) {
            val += 'px';
        }
        return val;
    }
    flexible.px2rem = function(d) {
        var val = parseFloat(d) / this.rem;
        if (typeof d === 'string' && d.match(/px$/)) {
            val += 'rem';
        }
        return val;
    }

})(window, window['lib'] || (window['lib'] = {}));


/***/ }),

/***/ "saHn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("8Uqm");
var normalizeHeaderName = __webpack_require__("+ayu");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("ucSM");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("ucSM");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "sc7i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__("Ds5P");
var defined = __webpack_require__("/whu");
var toLength = __webpack_require__("BbyF");
var isRegExp = __webpack_require__("u0PK");
var getFlags = __webpack_require__("0pGU");
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__("IRJ3")($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),

/***/ "smQ+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__("Ds5P");
var $pad = __webpack_require__("2VSL");
var userAgent = __webpack_require__("41xE");

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),

/***/ "t8qj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "t8x9":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("77Pl");
var aFunction = __webpack_require__("lOnJ");
var SPECIES = __webpack_require__("dSzd")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "tIFN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var bind = __webpack_require__("JP+z");
var Axios = __webpack_require__("XmWM");
var defaults = __webpack_require__("KCLY");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("dVOP");
axios.CancelToken = __webpack_require__("cWxy");
axios.isCancel = __webpack_require__("pBtG");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("pxG4");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "tJwI":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("FryR");
var $keys = __webpack_require__("Qh14");

__webpack_require__("3i66")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "tOCg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tTVk":
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),

/***/ "taNN":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("Ds5P");
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),

/***/ "thJu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "tih0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tjtg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("CF4R");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),

/***/ "tqSY":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__("xAdt")
});


/***/ }),

/***/ "twxM":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("lDLk");
var anObject = __webpack_require__("DIVP");
var getKeys = __webpack_require__("Qh14");

module.exports = __webpack_require__("bUqO") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "u0PK":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("UKM+");
var cof = __webpack_require__("ydD5");
var MATCH = __webpack_require__("kkCw")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "uCbX":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};

function isBuffer(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
}

/***/ }),

/***/ "uDYd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var aFunction = __webpack_require__("XSOZ");
var toObject = __webpack_require__("FryR");
var fails = __webpack_require__("zgIt");
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__("NNrz")($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),

/***/ "uEEG":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', { scale: __webpack_require__("WY8G") });


/***/ }),

/***/ "uGue":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home.2e8d64e.png";

/***/ }),

/***/ "uL9n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uMWd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_toSort_vue_vue_type_style_index_0_id_6b340526_lang_scss_scoped_true___ = __webpack_require__("Tiqt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_toSort_vue_vue_type_style_index_0_id_6b340526_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_toSort_vue_vue_type_style_index_0_id_6b340526_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_toSort_vue_vue_type_style_index_0_id_6b340526_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ "uRCW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("wI4N");
var defaults = __webpack_require__("8cTw");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ "uToG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function RFC1738(value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function RFC3986(value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

/***/ }),

/***/ "uc2A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("V3l/");
var $export = __webpack_require__("Ds5P");
var redefine = __webpack_require__("R3AP");
var hide = __webpack_require__("2p1q");
var Iterators = __webpack_require__("bN1p");
var $iterCreate = __webpack_require__("IRJ3");
var setToStringTag = __webpack_require__("yYvK");
var getPrototypeOf = __webpack_require__("KOrd");
var ITERATOR = __webpack_require__("kkCw")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "ucSM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("8Uqm");
var settle = __webpack_require__("tjtg");
var buildURL = __webpack_require__("IO1w");
var parseHeaders = __webpack_require__("T7xV");
var isURLSameOrigin = __webpack_require__("UbU9");
var createError = __webpack_require__("CF4R");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("6obF");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),

/***/ "ujcs":
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "ulTY":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "uqUo":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("kM2E");
var core = __webpack_require__("FeBl");
var fails = __webpack_require__("S82l");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "v2lb":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__("Ds5P");
var log1p = __webpack_require__("Rz2z");
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),

/***/ "v3hU":
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__("dSUw");
var from = __webpack_require__("QG7u");
var metadata = __webpack_require__("wCso");
var anObject = __webpack_require__("DIVP");
var getPrototypeOf = __webpack_require__("KOrd");
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),

/***/ "v8VU":
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__("OzIq");
var $export = __webpack_require__("Ds5P");
var userAgent = __webpack_require__("41xE");
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),

/***/ "v90c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__("Ds5P");
var flattenIntoArray = __webpack_require__("IFpc");
var toObject = __webpack_require__("FryR");
var toLength = __webpack_require__("BbyF");
var toInteger = __webpack_require__("oeih");
var arraySpeciesCreate = __webpack_require__("plSV");

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__("RhFG")('flatten');


/***/ }),

/***/ "vFc/":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("TcQ7");
var toLength = __webpack_require__("QRG4");
var toAbsoluteIndex = __webpack_require__("fkB2");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "vIB/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("O4g8");
var $export = __webpack_require__("kM2E");
var redefine = __webpack_require__("880/");
var hide = __webpack_require__("hJx8");
var Iterators = __webpack_require__("/bQp");
var $iterCreate = __webpack_require__("94VQ");
var setToStringTag = __webpack_require__("e6n0");
var getPrototypeOf = __webpack_require__("PzxK");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "vmSO":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("rFzY");
var call = __webpack_require__("XvUs");
var isArrayIter = __webpack_require__("9vb1");
var anObject = __webpack_require__("DIVP");
var toLength = __webpack_require__("BbyF");
var getIterFn = __webpack_require__("SHe9");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "vmSu":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__("Ds5P");
var create = __webpack_require__("7ylX");
var aFunction = __webpack_require__("XSOZ");
var anObject = __webpack_require__("DIVP");
var isObject = __webpack_require__("UKM+");
var fails = __webpack_require__("zgIt");
var bind = __webpack_require__("ZtwE");
var rConstruct = (__webpack_require__("OzIq").Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "vnWP":
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__("Ds5P");
var scale = __webpack_require__("WY8G");
var fround = __webpack_require__("g/m8");

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),

/***/ "voum":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("wI4N");

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),

/***/ "vsh6":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("wCso");
var anObject = __webpack_require__("DIVP");
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),

/***/ "vu/c":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("3g/S")('observable');


/***/ }),

/***/ "w6Dh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("XSOZ");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "w6W7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var $map = __webpack_require__("LhTa")(1);

$export($export.P + $export.F * !__webpack_require__("NNrz")([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "wBbU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_showIndex_skeleton_vue_vue_type_style_index_0_id_752d07ea_scoped_true_lang_scss___ = __webpack_require__("0qX9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_showIndex_skeleton_vue_vue_type_style_index_0_id_752d07ea_scoped_true_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_showIndex_skeleton_vue_vue_type_style_index_0_id_752d07ea_scoped_true_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_showIndex_skeleton_vue_vue_type_style_index_0_id_752d07ea_scoped_true_lang_scss____default.a); 

/***/ }),

/***/ "wC1N":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("ydD5");
var TAG = __webpack_require__("kkCw")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "wCso":
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__("MsuQ");
var $export = __webpack_require__("Ds5P");
var shared = __webpack_require__("VWgF")('metadata');
var store = shared.store || (shared.store = new (__webpack_require__("ZDXm"))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),

/***/ "wI4N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("NTs4");

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ "wKKh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wLTK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wSGD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wVdn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var $some = __webpack_require__("LhTa")(3);

$export($export.P + $export.F * !__webpack_require__("NNrz")([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "wlTy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_getPlatform__ = __webpack_require__("hTeI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_getPlatform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tools_getPlatform__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Bridge.js
 * 适应于壹心理js调用native方法
 *
 * ex:
 * var bridge = new Bridge({
 * 	methods:[
 * 		{
 * 			method: "goBack",
 * 			callback: function(param){}
 * 		}
 * 	]
 * });
 *
 * bridge.call("setTitle",{title:"我是标题"});
 * options.disInitAppHook true为不执行AppHookInit
 */


var getPlatform = __WEBPACK_IMPORTED_MODULE_0__tools_getPlatform___default.a.getPlatform;

// import vconsole from 'vconsole'
// new vconsole()

// const IS_APP =
//   window.navigator.userAgent.indexOf('yixinliApp') !== -1 ||
//   window.navigator.userAgent.toUpperCase().indexOf('YIXINLICONSULTATIONAPP') !==
//     -1

var BRIDGERESOLVE = '_bridgeResolve';

var Bridge = function () {
  function Bridge(options) {
    _classCallCheck(this, Bridge);

    this.tokenStringify = '';
    this.version = '0.1';
    this.platform = getPlatform();
    if (options && !options.disInitAppHook) {
      this.AppHookInit();
    }
    this.ready = null;
    if (options && options.methods && options.methods.length) {
      var methods = options.methods;
      for (var i = 0; i < methods.length; i++) {
        this.MethodCall(methods[i]);
      }
    }
  }

  _createClass(Bridge, [{
    key: '_init',
    value: function _init() {}
  }, {
    key: 'add',
    value: function add(options) {
      var methods = void 0;
      if (options && options.methods && options.methods.length) {
        methods = options.methods;
      } else if (Array.isArray(options)) {
        methods = options;
      } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
        methods = [options];
      }
      if (methods) {
        for (var i = 0; i < methods.length; i++) {
          this.MethodCall(methods[i]);
        }
      }
    }
  }, {
    key: 'MethodCall',
    value: function MethodCall(obj) {
      var ERROR_TITLE = '[Bridge.js] error : ';

      var methodName = obj.method;

      try {
        if (!methodName) throw ERROR_TITLE + ' method undefined';
        if (!obj.callback) throw ERROR_TITLE + ' callback undefined';
        window[methodName] = function () {
          var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '{}';

          var formatedParams = JSON.parse(param);
          // if (
          //   !this.tokenStringify &&
          //   Object.prototype.toString.call(formatedParams) === '[object Object]'
          // ) {
          //   let ObjectKeys = Object.keys(formatedParams)
          //   if (ObjectKeys.length === 1 && ObjectKeys[0] === 'token') {
          //     // 缓存getToken返回的json字符串
          //     this.tokenStringify = param
          //   }
          // }

          // 真实的callback接收的是格式化好的参数
          obj.callback(formatedParams);

          // 存在异步resolve方法，释放出来
          var bridgeResolve = window[methodName][BRIDGERESOLVE];
          if (typeof bridgeResolve === 'function') {
            bridgeResolve(formatedParams);
            window[methodName][BRIDGERESOLVE] = null;
            console.log('\u91CA\u653E' + methodName + '\u7684resolve');
          }
          // getToken的resolveArr
          if (Object.prototype.toString.call(bridgeResolve) === '[object Array]') {
            bridgeResolve.forEach(function (resolve) {
              resolve(formatedParams);
            });
            window[methodName][BRIDGERESOLVE] = [];
            console.log('\u91CA\u653EgetTokenArr\u7684resolve');
          }
        };
      } catch (err) {
        console.error(ERROR_TITLE + ' MethodCall register failed', err);
      }
    }

    /**
     * call ios function
     * @param  {[string]} callName [协议接口名]
     * @param  {[object]} options  [参数]
     */

  }, {
    key: '_callIos',
    value: function _callIos(callName) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      console.log('@ _callIos', options);
      try {
        options = options ? JSON.stringify(options) : null;
        window.webkit.messageHandlers[callName].postMessage(options);
      } catch (err) {
        console.log(err);
      }
    }
  }, {
    key: '_callAndroid',
    value: function _callAndroid(callName) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      console.log('@ _callAndroid', options);
      try {
        // 这里对options进行统一encode，安卓客户端对options进行统一decode
        // update: 2018/12/18 和安卓确认埋点的时候没有decode，所以前端也不用encode，当时为什么encode已经找不到原因，现在重新注释掉
        // if (properties) {
        //   for (let i in properties) {
        //     properties[i] = encodeURIComponent(properties[i])
        //   }
        //   options.properties = properties
        // }

        options = options ? window.JSON.stringify(options) : '';
        var uri = 'jsbridge://bridege/' + callName + '?' + options;
        window.prompt(uri, '');
      } catch (err) {
        console.error(err);
      }
    }

    /**
     * public 调用原生方法 js2native
     * @param  {[string]} callName [方法名称]
     * @param  {[object]} options  [参数]
     */

  }, {
    key: 'call',
    value: function call(callName) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var system = this.platform.isiPhone || this.platform.isiPad ? 'Ios' : 'Android';
      var callbackName = options.callbackName;

      try {
        var platform = getPlatform();
        if (!platform.isYixinliApp && !platform.isMuseApp && !platform.isCeShiApp && !platform.isZiXunApp && window.navigator.userAgent.indexOf('yixinli') === -1) {
          _typeof(window.monitor) === 'object' && typeof window.monitor.stat === 'function' && window.monitor.stat({
            title: '在非app环境调用bridge！！！！',
            level: 'error',
            logType: 'JSError',
            code: 599
          });
        }
      } catch (e) {
        console.error('bridge 异常日志上报失败', e);
      }

      return new Promise(function (resolve) {
        if (callbackName && typeof window[callbackName] === 'function') {
          if (callName === 'getToken') {
            var resolveArr = window[callbackName][BRIDGERESOLVE];
            if (resolveArr) {
              resolveArr.push(resolve);
            } else {
              resolveArr = [resolve];
              window[callbackName][BRIDGERESOLVE] = resolveArr;
            }
            // 使用缓存的getToken字符串, 模拟App回调
            // if (this.tokenStringify) {
            //   window[callbackName](this.tokenStringify)
            //   return
            // }
          } else {
            // 需要避免多个callName调同一个callback的情况
            window[callbackName][BRIDGERESOLVE] = resolve;
          }
        } else {
          // 没有回调的resolve
          resolve();
        }
        _this['_call' + system](callName, options);
      });
    }

    /**
     * public 移除native调用js的注册接口
     */

  }, {
    key: 'removeMethods',
    value: function removeMethods() {
      if (this.ots && this.ots.methods && this.ots.methods.length > 0) {
        for (var i = 0; i < this.ots.methods.length; i++) {
          var obj = this.ots.methods[i];
          window[obj.method] = null;
        }
      }
    }
  }, {
    key: 'AppHookInit',
    value: function AppHookInit() {
      console.log('初始化APP事件');
      var codeEventMap = {
        10001: 'appShow',
        '10002_0': 'appPayDoneFail',
        '10002_1': 'appPayDoneSuccess',
        10003: 'appWebviewShow',
        10004: 'appWebviewHide'
      };
      var eventFactory = function eventFactory(code) {
        var eventName = codeEventMap[code];
        return new Event(eventName);
      };

      window.yxlAppCustomEvent = {};
      for (var key in codeEventMap) {
        window.yxlAppCustomEvent[key] = eventFactory(key);
      }

      window.appBecomeActiveStatus = function (optionString) {
        // 使用 window.addEventListener('appPayDoneFail') 之类的触发
        var res = JSON.parse(optionString);
        console.log('派发App事件', res.code, 'Useage: window.addEventListener(' + codeEventMap[res.code] + ')');
        switch (+res.code) {
          case 10002:
            if (res.data.status === 'paySuccess') {
              window.dispatchEvent(window.yxlAppCustomEvent['10002_1']);
            } else {
              window.dispatchEvent(window.yxlAppCustomEvent['10002_0']);
            }
            break;
          default:
            window.dispatchEvent(window.yxlAppCustomEvent[+res.code]);
            break;
        }
      };
    }
  }]);

  return Bridge;
}();

// 供umd引用


try {
  // 非服务端
  if (typeof window !== 'undefined') {
    window.Bridge = Bridge;
  }
} catch (e) {
  console.log(e);
}

/* harmony default export */ __webpack_exports__["a"] = (Bridge);

/*
var myBridge = new Bridge({
    methods: [{
        method: "test",
        callback: function(param) {
        	alert("hello world");
        }
    }]
});

myBridge.call("setTitle",{title:"我是标题"});
*/

/***/ }),

/***/ "wnRD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var $reduce = __webpack_require__("FkIZ");

$export($export.P + $export.F * !__webpack_require__("NNrz")([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),

/***/ "woOf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("V3tA"), __esModule: true };

/***/ }),

/***/ "wrs0":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__("Ds5P");
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/apis.js
var apis = __webpack_require__("OTud");

// CONCATENATED MODULE: ./src/store/callbackHandler.js


function callbackHandler(API, res, callback, noDate) {
    var RES = res.data;
    var DATA = RES && RES.data ? RES.data : {};
    if (RES.code * 1 == 1) {
        if (typeof callback == 'function') {
            if (noDate) {
                callback(RES);
            } else {
                callback(DATA);
            }
        }
    } else if (RES.code * 1 == 302) {
        console.log(RES.code);
        location.href = RES.data;
    } else {
        // 全都是异常情况，先把loading藏起来
        store_store.commit('setLOADINGTEXT', '');

        if (RES.code * 1 == 0) {
            window.monitor.stat({
                level: 'error',
                error: 'API-data',
                msg: '请求接口失败',
                url: API
            });
            setTimeout(function () {
                store_store.commit('setTOASTTEXT', '接口请求失败');
            }, 1000);
        } else if (RES.code * 1 == 2001) {
            if (typeof callback == 'function') {
                // 购买测评，有已完成订单，进行弹框提示
                callback(DATA, 2001);
            }
        } else if (RES.code * 1 == 5000) {
            window.monitor.stat({
                level: 'error',
                error: 'API-data',
                msg: '服务器内部错误',
                url: API
            });
            setTimeout(function () {
                store_store.commit('setTOASTTEXT', '接口请求失败');
            }, 1000);
        } else if (RES.code * 1 == 5001) {
            window.monitor.stat({
                level: 'error',
                error: 'API-data',
                msg: '用户未登录',
                url: API
            });
        } else if (RES.code * 1 == 5003) {
            window.monitor.stat({
                level: 'error',
                error: 'API-data',
                msg: '服务超时',
                url: API
            });
        } else if (RES.code * 1 == 40001) {
            window.monitor.stat({
                level: 'error',
                msg: '请求参数中没有签名',
                error: 'API-data',
                url: API
            });
        } else if (RES.code * 1 == 40002) {
            window.monitor.stat({
                level: 'error',
                msg: '签名错误',
                error: 'API-data',
                url: API
            });
        } else if (RES.code * 1 == 40003) {
            window.monitor.stat({
                level: 'error',
                msg: '接口传参 错误(没有传对应的接口参数)',
                error: 'API-data',
                url: API
            });
        } else if (RES.code * 1 == 40004) {
            window.monitor.stat({
                level: 'error',
                msg: '企业没有密钥错误',
                error: 'API-data',
                url: API
            });
        } else if (RES.code * 1 == 40005) {
            window.monitor.stat({
                msg: '企业不存在',
                error: 'API-data',
                url: API
            });
        } else if (RES.code * 1 == 40006) {
            window.monitor.stat({
                level: 'error',
                msg: '请求数据size太长',
                error: 'API-data',
                url: API
            });
        } else if (RES.code * 1 == 40007) {
            window.monitor.stat({
                level: 'error',
                msg: '请求参数不合法',
                error: 'API-data',
                url: API
            });
        } else {
            window.monitor.stat({
                level: 'info',
                msg: '\u63A5\u53E3\u8BF7\u6C42\u6210\u529F\uFF0C\u72B6\u6001code=' + RES.code,
                error: 'API-data',
                url: API
            });

            if (typeof callback == 'function') {
                callback(DATA ? DATA : RES.msg, RES.code);
            }
        }
    }
    return RES;
}

function YIAPIcallbackHandler(API, res, callback, noDate) {
    var RES = res.data,
        DATA = RES.data ? RES.data : {};
    if (RES.code * 1 == 0) {
        if (typeof callback == 'function') {
            if (noDate) {
                callback(RES);
            } else {
                callback(DATA);
            }
        }
    } else {
        // 全都是异常情况，先把loading藏起来
        store_store.commit('setLOADINGTEXT', '');

        if (RES.code * 1 == 1) {
            window.monitor.stat({
                level: 'error',
                error: 'API-data',
                msg: '请求接口失败',
                url: API
            });
            setTimeout(function () {
                store_store.commit('setTOASTTEXT', '' + RES.message);
            }, 1000);
        } else {
            window.monitor.stat({
                level: 'info',
                msg: '\u63A5\u53E3\u8BF7\u6C42\u6210\u529F\uFF0C\u72B6\u6001code=' + RES.code,
                error: 'API-data',
                url: API
            });

            if (typeof callback == 'function') {
                callback(DATA ? DATA : RES.msg, RES.code);
            }
        }
    }
    return RES;
}

/* harmony default export */ var store_callbackHandler = ({
    callbackHandler: callbackHandler
});
// EXTERNAL MODULE: ./src/lib/wxActions.js
var wxActions = __webpack_require__("LJ7O");

// EXTERNAL MODULE: ./src/frontend-lib/tools/getPlatform.js
var getPlatform = __webpack_require__("hTeI");
var getPlatform_default = /*#__PURE__*/__webpack_require__.n(getPlatform);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("mw3O");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/store/modules/answer.js





var _mutations, _getters, _actions;

/**
 * Created by laixinyu on 2017/3/21.
 */





/* harmony default export */ var answer = ({
    state: {
        ANSWER_TITLE: '',
        ANSWER_SOURCE: null,
        ANSWER_TESTID: null,
        ANSWER_INTRO: '',
        ANSWER_SCALEID: '',
        ANSWER_MODULE_INTRO: '',
        ANSWER_MODULE_TITLE: '',
        MODULE_CONNECT_MODE: '',
        MULTI_MODULE: false,
        LAST_MODULE: false,
        SHOW_TIPS: false,
        QUESTIONS_TYPE: 0,
        ANSWER_CONFIGVO: '',
        ALGORITHMTYPE: false,
        REPORTVERSION: 1,
        timingData: {} // 计时数据
    },
    mutations: (_mutations = {}, defineProperty_default()(_mutations, 'SET_LAST_MODULE', function undefined(state, tof) {
        state.LAST_MODULE = !!tof;
    }), defineProperty_default()(_mutations, 'SET_SHOW_TIPS', function undefined(state, tof) {
        state.SHOW_TIPS = !!tof;
    }), defineProperty_default()(_mutations, 'SET_MODULE_CONNECT_MODE', function SET_MODULE_CONNECT_MODE(state, mode) {
        state.MODULE_CONNECT_MODE = mode * 1;
    }), defineProperty_default()(_mutations, 'SET_MULTI_MODULE', function SET_MULTI_MODULE(state, tof) {
        state.MULTI_MODULE = !!tof;
    }), defineProperty_default()(_mutations, 'SET_ANSWER_TITLE', function SET_ANSWER_TITLE(state, title) {
        state.ANSWER_TITLE = title == undefined ? '' : title;
    }), defineProperty_default()(_mutations, 'SET_ANSWER_SOURCE', function SET_ANSWER_SOURCE(state, source) {
        state.ANSWER_SOURCE = source;
    }), defineProperty_default()(_mutations, 'SET_ANSWER_TESTID', function SET_ANSWER_TESTID(state, testid) {
        state.ANSWER_TESTID = testid;
    }), defineProperty_default()(_mutations, 'SET_ANSWER_INTRO', function SET_ANSWER_INTRO(state, intro) {
        state.ANSWER_INTRO = intro == undefined ? '' : intro;
    }), defineProperty_default()(_mutations, 'SET_ANSWER_SCALEID', function SET_ANSWER_SCALEID(state, scaleId) {
        state.ANSWER_SCALEID = +scaleId || '';
    }), defineProperty_default()(_mutations, 'SET_ANSWER_MODULE_INTRO', function SET_ANSWER_MODULE_INTRO(state, intro) {
        state.ANSWER_MODULE_INTRO = intro == undefined ? '' : intro;
    }), defineProperty_default()(_mutations, 'SET_ANSWER_MODULE_TITLE', function SET_ANSWER_MODULE_TITLE(state, intro) {
        state.ANSWER_MODULE_TITLE = intro == undefined ? '' : intro;
    }), defineProperty_default()(_mutations, 'SET_QUESTIONS_TYPE', function SET_QUESTIONS_TYPE(state, source) {
        console.log('设置颜色配案', source);
        state.QUESTIONS_TYPE = source;
    }), defineProperty_default()(_mutations, 'SET_ANSWER_CONFIGVO', function SET_ANSWER_CONFIGVO(state, source) {
        state.ANSWER_CONFIGVO = source;
    }), defineProperty_default()(_mutations, 'SET_ALGORITHM_TYPE', function SET_ALGORITHM_TYPE(state, source) {
        state.ALGORITHMTYPE = source;
    }), defineProperty_default()(_mutations, 'SET_REPORT_VERSION', function SET_REPORT_VERSION(state, source) {
        state.REPORTVERSION = source;
    }), defineProperty_default()(_mutations, 'setTimingData', function setTimingData(state, val) {
        state.timingData = val;
    }), _mutations),
    getters: (_getters = {}, defineProperty_default()(_getters, 'LAST_MODULE', function undefined(state) {
        return state.LAST_MODULE;
    }), defineProperty_default()(_getters, 'MODULE_CONNECT_MODE', function undefined(state) {
        return state.MODULE_CONNECT_MODE;
    }), defineProperty_default()(_getters, 'MULTI_MODULE', function undefined(state) {
        return state.MULTI_MODULE;
    }), defineProperty_default()(_getters, 'ANSWER_GETCALCTITLE', function ANSWER_GETCALCTITLE(state) {
        var result = '';
        if (state.ANSWER_TITLE.length > 10) {

            [].concat(toConsumableArray_default()(state.ANSWER_TITLE)).forEach(function (str, index) {
                if (index === 8) {
                    result += '</br>';
                }

                result += str;
            });
        } else {
            result = state.ANSWER_TITLE;
        }

        return result;
    }), defineProperty_default()(_getters, 'ANSWER_TITLE', function ANSWER_TITLE(state) {
        return state.ANSWER_TITLE;
    }), defineProperty_default()(_getters, 'ANSWER_INTRO', function ANSWER_INTRO(state) {
        return state.ANSWER_INTRO;
    }), defineProperty_default()(_getters, 'ANSWER_SCALEID', function ANSWER_SCALEID(state) {
        return state.ANSWER_SCALEID;
    }), defineProperty_default()(_getters, 'ANSWER_MODULE_INTRO', function ANSWER_MODULE_INTRO(state) {
        return state.ANSWER_MODULE_INTRO;
    }), defineProperty_default()(_getters, 'ANSWER_MODULE_TITLE', function ANSWER_MODULE_TITLE(state) {
        return state.ANSWER_MODULE_TITLE;
    }), defineProperty_default()(_getters, 'QUESTIONS_TYPE', function undefined(state) {
        return state.QUESTIONS_TYPE;
    }), defineProperty_default()(_getters, 'ANSWER_CONFIGVO', function ANSWER_CONFIGVO(state) {
        return state.ANSWER_CONFIGVO;
    }), defineProperty_default()(_getters, 'SHOW_TIPS', function SHOW_TIPS(state) {
        return state.SHOW_TIPS;
    }), defineProperty_default()(_getters, 'ALGORITHM_TYPE', function ALGORITHM_TYPE(state) {
        return state.ALGORITHMTYPE;
    }), defineProperty_default()(_getters, 'REPORT_VERSION', function REPORT_VERSION(state) {
        return state.REPORTVERSION;
    }), defineProperty_default()(_getters, 'timingData', function timingData(state) {
        return state.timingData;
    }), _getters),
    actions: (_actions = {}, defineProperty_default()(_actions, 'YXLCP_LOGIN', function undefined(context, _ref) {
        var params = _ref.params;

        return axios_default.a.get(apis["a" /* default */].yxlCp.logIn, { params: params }).then(function (res) {
            return callbackHandler(apis["a" /* default */].yxlCp.logIn, res);
        });
    }), defineProperty_default()(_actions, 'GET_MODULE_INTRO', function (_undefined) {
        function undefined(_x2) {
            return _undefined.apply(this, arguments);
        }

        undefined.toString = function () {
            return _undefined.toString();
        };

        return undefined;
    }(function (context) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            params = _ref2.params;

        if ((params.channelId == 2278 || params.channelId == 2310) && (params.questionnaireId == 424 || params.questionnaireId == 442)) {
            console.log('2278 2310渠道且566ID的getScaleIntro接口数据，后续需要处理');
            return promise_default.a.resolve(__webpack_require__("/vy1"));
        } else {
            return axios_default.a.get(apis["a" /* default */].yxlCp.curModuleintro, { params: params }).then(function (res) {
                if (+res.data.code === 1) {
                    var data = res.data.data;
                    context.commit('setTimingData', data);
                    return res.data;
                }
                return {
                    code: res.data.code,
                    data: {}
                };
            });
        }
    })), defineProperty_default()(_actions, 'GET_SCALE_INTRO', function (_undefined2) {
        function undefined(_x4) {
            return _undefined2.apply(this, arguments);
        }

        undefined.toString = function () {
            return _undefined2.toString();
        };

        return undefined;
    }(function (context) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref3.env,
            params = _ref3.params;

        if ((params.channelId == 2278 || params.channelId == 2310) && (params.questionnaireId == 424 || params.questionnaireId == 442)) {
            console.log('2278 2310渠道且566ID的getScaleIntro接口数据，后续需要处理');
            return promise_default.a.resolve(__webpack_require__("TuAd"));
        } else {
            var api = apis["a" /* default */][env].intro;
            return axios_default.a.get(api, { params: params }).then(function (res) {
                if (res.data.code == 1) {
                    localStorage.setItem('localScaleModules', stringify_default()({
                        scaleId: res.data.data.scaleId
                    }));
                    context.commit('SET_ANSWER_SCALEID', res.data.data.scaleId);
                }
                return callbackHandler(api, res);
            });
        }
    })), defineProperty_default()(_actions, 'SET_SCALE_GENDER', function (_undefined3) {
        function undefined(_x6) {
            return _undefined3.apply(this, arguments);
        }

        undefined.toString = function () {
            return _undefined3.toString();
        };

        return undefined;
    }(function (context) {
        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref4.env,
            params = _ref4.params;

        var api = apis["a" /* default */][env].setGender;
        return axios_default.a.get(api, { params: params }).then(function (res) {
            return callbackHandler(api, res);
        });
    })), defineProperty_default()(_actions, 'GET_QUESTIONS', function GET_QUESTIONS(context) {
        var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref5.env,
            params = _ref5.params;

        var api = apis["a" /* default */][env].questions;
        return axios_default.a.get(api, { params: params }).then(function (res) {
            return callbackHandler(api, res);
        });
    }), defineProperty_default()(_actions, 'SET_SCALE_COMMIT_STEP', function (_undefined4) {
        function undefined(_x9) {
            return _undefined4.apply(this, arguments);
        }

        undefined.toString = function () {
            return _undefined4.toString();
        };

        return undefined;
    }(function (context) {
        var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref6.env,
            params = _ref6.params;

        //更换接口路由
        var touTiaoMiniApp = [2345, 2293, 2545].includes(Number(params.channelId));
        var api = !touTiaoMiniApp ? apis["a" /* default */][env].commitStep : apis["a" /* default */].touTiaoMiniAppCommitAnswer;

        return axios_default.a.post(api, lib_default.a.stringify(params)).then(function (res) {
            return callbackHandler(api, res);
        });
    })), defineProperty_default()(_actions, 'SET_SCALE_COMMIT_CLEAR', function (_undefined5) {
        function undefined(_x11) {
            return _undefined5.apply(this, arguments);
        }

        undefined.toString = function () {
            return _undefined5.toString();
        };

        return undefined;
    }(function (context) {
        var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref7.env,
            params = _ref7.params;

        var api = apis["a" /* default */][env].commitClear;
        return axios_default.a.get(api, { params: params }).then(function (res) {
            callbackHandler(api, res);
            return res.data;
        });
    })), defineProperty_default()(_actions, 'SET_SCALE_COMMIT_ALL', function (_undefined6) {
        function undefined(_x13) {
            return _undefined6.apply(this, arguments);
        }

        undefined.toString = function () {
            return _undefined6.toString();
        };

        return undefined;
    }(function (context) {
        var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref8.env,
            params = _ref8.params;

        //更换接口路由
        var touTiaoMiniApp = [2345, 2293, 2545].includes(Number(params.channelId));
        var api = !touTiaoMiniApp ? apis["a" /* default */][env].commitAll : apis["a" /* default */].touTiaoMiniAppCommmitAllAnswer;

        return axios_default.a.get(api, { params: params }).then(function (res) {
            return callbackHandler(api, res);
        });
    })), defineProperty_default()(_actions, 'FSR_GET_QUESTIONS', function FSR_GET_QUESTIONS(context) {
        var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref9.env,
            params = _ref9.params;

        var api = apis["a" /* default */].fsrGetUserModuleQuestions;
        return axios_default.a.get(api, { params: params }).then(function (res) {
            callbackHandler(api, res);
            return res.data;
        });
    }), defineProperty_default()(_actions, 'FSR_GET_QUESTIONS_V2', function FSR_GET_QUESTIONS_V2(context) {
        var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref10.env,
            params = _ref10.params;

        var api = apis["a" /* default */].fsrGetUserModuleQuestionsV2;
        return axios_default.a.get(api, { params: params }).then(function (res) {
            callbackHandler(api, res);
            return res.data;
        });
    }), defineProperty_default()(_actions, 'FSR_COMMIT_IMAGE_ANSWERS_V2', function FSR_COMMIT_IMAGE_ANSWERS_V2(context) {
        var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref11.env,
            params = _ref11.params;

        var api = apis["a" /* default */].fsrCommitImageAnswers;
        return axios_default.a.post(api, lib_default.a.stringify(params)).then(function (res) {
            return callbackHandler(api, res);
        });
    }), defineProperty_default()(_actions, 'FSR_SET_SCALE_COMMIT_ALL', function (_undefined7) {
        function undefined(_x18) {
            return _undefined7.apply(this, arguments);
        }

        undefined.toString = function () {
            return _undefined7.toString();
        };

        return undefined;
    }(function (context) {
        var _ref12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref12.env,
            params = _ref12.params;

        var api = apis["a" /* default */].fsrCommitAll;
        return axios_default.a.get(api, { params: params }).then(function (res) {
            callbackHandler(api, res);
            return res.data;
        });
    })), defineProperty_default()(_actions, 'FSR_FETCH_IMG', function (_undefined8) {
        function undefined(_x20) {
            return _undefined8.apply(this, arguments);
        }

        undefined.toString = function () {
            return _undefined8.toString();
        };

        return undefined;
    }(function (context) {
        var _ref13 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref13.env,
            params = _ref13.params;

        var api = apis["a" /* default */].fsrFetchImage;
        return axios_default.a.get(api, { params: params }).then(function (res) {
            callbackHandler(api, res);
            return res.data;
        });
    })), defineProperty_default()(_actions, 'YZR_GET_QUESTIONS', function YZR_GET_QUESTIONS(context) {
        var _ref14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref14.env,
            params = _ref14.params;

        var api = apis["a" /* default */].yzrGetUserModuleQuestions;
        return axios_default.a.get(api, { params: params }).then(function (res) {
            callbackHandler(api, res);
            return res.data;
        });
    }), defineProperty_default()(_actions, 'YZR_FETCH_IMG', function (_undefined9) {
        function undefined(_x23) {
            return _undefined9.apply(this, arguments);
        }

        undefined.toString = function () {
            return _undefined9.toString();
        };

        return undefined;
    }(function (context) {
        var _ref15 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref15.env,
            params = _ref15.params;

        var api = apis["a" /* default */].yzrFetchImage;
        return axios_default.a.get(api, { params: params }).then(function (res) {
            callbackHandler(api, res);
            return res.data;
        });
    })), defineProperty_default()(_actions, 'CHILD_SET_SCALE_COMMIT_ALL', function (_undefined10) {
        function undefined(_x25) {
            return _undefined10.apply(this, arguments);
        }

        undefined.toString = function () {
            return _undefined10.toString();
        };

        return undefined;
    }(function (context) {
        var _ref16 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref16.env,
            params = _ref16.params;

        var api = apis["a" /* default */].childCommitAll;
        return axios_default.a.get(api, { params: params }).then(function (res) {
            callbackHandler(api, res);
            return res.data;
        });
    })), defineProperty_default()(_actions, 'GET_CHILD_MID_QUESTIONS', function GET_CHILD_MID_QUESTIONS(context) {
        var _ref17 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref17.env,
            params = _ref17.params;

        var api = apis["a" /* default */].childMidQuestions;
        console.log('--- GET_CHILD_MID_QUESTIONS --- api', api);
        return axios_default.a.get(api, { params: params }).then(function (res) {
            return callbackHandler(api, res);
        });
    }), defineProperty_default()(_actions, 'CHILD_MID_SET_SCALE_COMMIT_ALL', function (_undefined11) {
        function undefined(_x28) {
            return _undefined11.apply(this, arguments);
        }

        undefined.toString = function () {
            return _undefined11.toString();
        };

        return undefined;
    }(function (context) {
        var _ref18 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref18.env,
            params = _ref18.params;

        var api = apis["a" /* default */].childMidCommitAll;
        return axios_default.a.get(api, { params: params }).then(function (res) {
            callbackHandler(api, res);
            return res.data;
        });
    })), defineProperty_default()(_actions, 'CHILD_FETCH_IMG', function (_undefined12) {
        function undefined(_x30) {
            return _undefined12.apply(this, arguments);
        }

        undefined.toString = function () {
            return _undefined12.toString();
        };

        return undefined;
    }(function (context) {
        var _ref19 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref19.env,
            params = _ref19.params;

        var api = apis["a" /* default */].childGetPictureUrl;
        return axios_default.a.get(api, { params: params }).then(function (res) {
            callbackHandler(api, res);
            return res.data;
        });
    })), _actions)
});
// CONCATENATED MODULE: ./src/store/modules/ad.js
/* harmony default export */ var ad = ({
  state: {
    globalAdConfirmRoute: {},
    globalAdCancelRoute: {},
    globalAdPeriod: {},
    globalAdShow: false
  },
  mutations: {
    setGlobalAdConfirm: function setGlobalAdConfirm(state, route) {
      state.globalAdConfirmRoute = route;
    },
    setGlobalAdCancel: function setGlobalAdCancel(state, route) {
      state.globalAdCancelRoute = route;
    },
    setGlobalAdPeriod: function setGlobalAdPeriod(state, globalAdPeriod) {
      state.globalAdPeriod = globalAdPeriod;
    },
    setGlobalAdShow: function setGlobalAdShow(state, tof) {
      state.globalAdShow = !!tof;
      console.log(state.globalAdShow);
    }
  },
  getters: {
    GlobalAdConfirmRoute: function GlobalAdConfirmRoute(state) {
      return state.globalAdConfirmRoute;
    },
    GlobalAdCancelRoute: function GlobalAdCancelRoute(state) {
      return state.globalAdCancelRoute;
    },
    GlobalAdPeriod: function GlobalAdPeriod(state) {
      return state.globalAdPeriod;
    },
    GlobalAdShow: function GlobalAdShow(state) {
      return state.globalAdShow;
    }
  },
  actions: {}
});
// CONCATENATED MODULE: ./src/store/modules/show.js


var show__actions;

// created by LinWeiLong @ 2017/06/21






/* harmony default export */ var show = ({
    state: {
        INDEXSCROLLTOP: 0,
        advertisingConfig: null,
        advertisingPlatform: {},
        isConsult525: false, // 是否是2021-525咨询
        endTime525: 0, // 2021-525结束时间
        notCompleteCount: {}, // 未完成的测评和咨询数量
        weappUrlScheme: '' // 投放跳转的小程序url scheme
    },
    mutations: {
        setINDEXSCROLLTOP: function setINDEXSCROLLTOP(state, number) {
            state.INDEXSCROLLTOP = number;
        },
        setAdvertisingConfig: function setAdvertisingConfig(state, val) {
            state.advertisingConfig = val;
        },
        setAdvertisingPlatform: function setAdvertisingPlatform(state, val) {
            state.advertisingPlatform = val;
        },
        setIsConsult525: function setIsConsult525(state, val) {
            state.isConsult525 = val;
        },
        setEndTime525: function setEndTime525(state, val) {
            state.endTime525 = val;
        },
        setNotCompleteCount: function setNotCompleteCount(state, val) {
            state.notCompleteCount = val;
        },
        setWeappUrlScheme: function setWeappUrlScheme(state, val) {
            state.weappUrlScheme = val;
        }
    },
    getters: {
        advertisingConfig: function advertisingConfig(state) {
            return state.advertisingConfig;
        },
        advertisingPlatform: function advertisingPlatform(state) {
            return state.advertisingPlatform;
        },
        isConsult525: function isConsult525(state) {
            return state.isConsult525;
        },
        endTime525: function endTime525(state) {
            return state.endTime525;
        },
        notCompleteCount: function notCompleteCount(state) {
            return state.notCompleteCount;
        },
        weappUrlScheme: function weappUrlScheme(state) {
            return state.weappUrlScheme;
        }
    },
    actions: (show__actions = {
        // 测评Banner
        pullHomePageBanner: function pullHomePageBanner(context, params) {
            axios_default.a.get(apis["a" /* default */].homePageBanner, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].homePageBanner, res, params.callback);
            });
        },

        // 测评Hot列表
        pullHotScales: function pullHotScales(context, params) {
            axios_default.a.get(apis["a" /* default */].getHotScales, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].getHotScales, res, params.callback);
            });
        },

        // 测评New列表
        pullNewScales: function pullNewScales(context, params) {
            axios_default.a.get(apis["a" /* default */].getNewScales, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].getNewScales, res, params.callback);
            });
        },

        // 精选测评
        pullChoiceScales: function pullChoiceScales(context, params) {
            axios_default.a.get(apis["a" /* default */].getHandpickScales, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].getHandpickScales, res, params.callback);
            });
        },

        // 测评列表
        pullScales: function pullScales(context, params) {
            axios_default.a.get(apis["a" /* default */].getScales, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].getScales, res, params.callback);
            });
        },

        // 测评详情
        GET_SCALE_DETAIL: function GET_SCALE_DETAIL(context, params) {
            return axios_default.a.get(apis["a" /* default */].getScaleDetail, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].getScaleDetail, res);
                return res.data;
            });
        },
        getNologinScaleDetail: function getNologinScaleDetail(context, params) {
            return axios_default.a.get(apis["a" /* default */].getNologinScaleDetail, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].getNologinScaleDetail, res);
                return res.data;
            });
        },
        getAdvertisingCepingConfig: function getAdvertisingCepingConfig(context, params) {
            return axios_default.a.get(apis["a" /* default */].getAdvertisingCepingConfig, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].getAdvertisingCepingConfig, res);
                return res.data;
            });
        },
        fetchAdvertisingPlatform: function fetchAdvertisingPlatform(context, params) {
            return axios_default.a.get(apis["a" /* default */].fetchAdvertisingPlatform, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].fetchAdvertisingPlatform, res);
                return res.data;
            });
        },
        getMiniappScheme: function getMiniappScheme(context, params) {
            return axios_default.a.get(apis["a" /* default */].miniappScheme, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].miniappScheme, res);
                return res.data;
            });
        },

        // H5测评详情
        pullH5Detail: function pullH5Detail(context, params) {
            console.log(params);
            axios_default.a.get(apis["a" /* default */].h5Detail, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].getScaleDetail, res, params.callback);
            });
        },


        // 详情页 - 相关测试
        pullDetailRecomend: function pullDetailRecomend(context, params) {
            axios_default.a.get(apis["a" /* default */].getRelevantScales, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].getRelevantScales, res, params.callback);
            });
        },

        // 购买测评, 套餐
        BUY_SCALE: function BUY_SCALE(context, _ref) {
            var API = _ref.API,
                params = _ref.params;

            /*
             params 需要4各参数
             1、channelId
             2、scalePoolId
             3、tradeType
             4、goonBuy  存在已购买未完成的测评时 1表示继续购买
             */
            return axios_default.a.get(API, {
                params: params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].buyScale, res);
                return res.data;
            });
        }
    }, defineProperty_default()(show__actions, 'BUY_DOFIRST_TEST', function undefined(context, _ref2) {
        var params = _ref2.params,
            callback = _ref2.callback;

        return axios_default.a.get(apis["a" /* default */].doFirst, {
            params: params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].doFirst, res, callback);
        });
    }), defineProperty_default()(show__actions, 'pullComboDetail', function pullComboDetail(context, params) {
        /**
         * params 需要2个参数
         * 1、channelId
         * 2、comboId
         */
        axios_default.a.get(apis["a" /* default */].getComboDetail, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].buyScale, res, params.callback);
        });
    }), defineProperty_default()(show__actions, 'pullMineScales', function pullMineScales(context, params) {
        axios_default.a.get(apis["a" /* default */].getMyData, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getMyData, res, params.callback);
        });
    }), defineProperty_default()(show__actions, 'buyFunScale', function buyFunScale(context, params) {
        /**
         * params 有3各参数
         * channelId 渠道Id
         * orderId
         * scalePoolId 测评ID
         */
        axios_default.a.get(apis["a" /* default */].buyFunScale, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].buyFunScale, res, params.callback);
        });
    }), defineProperty_default()(show__actions, 'checkOrderStatus', function checkOrderStatus(context, params) {
        /**
         * params
         * orderId Number
         */
        return axios_default.a.get(apis["a" /* default */].searchOrder, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].searchOrder, res, params.callback);
        });
    }), defineProperty_default()(show__actions, 'GET_COMBO_LIST', function undefined(context, params) {
        axios_default.a.get(apis["a" /* default */].getComboList, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].homePageBanner, res, params.callback);
        });
    }), defineProperty_default()(show__actions, 'DOFIRST_BUYREPORT', function undefined(context, params) {
        return axios_default.a.get(apis["a" /* default */].stopSignInAndBuy, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].homePageBanner, res, params.callback);
        });
    }), defineProperty_default()(show__actions, 'SetCollectScale', function SetCollectScale(context, params) {
        return axios_default.a.get(apis["a" /* default */].collectScale, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].collectScale, res, params.callback);
            return res;
        });
    }), defineProperty_default()(show__actions, 'getCollectScaleData', function getCollectScaleData(context, params) {
        axios_default.a.get(apis["a" /* default */].getCollectScaleData, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getCollectScaleData, res, params.callback);
        });
    }), defineProperty_default()(show__actions, 'getTrackScaleData', function getTrackScaleData(context, params) {
        axios_default.a.get(apis["a" /* default */].getTrackScaleData, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getTrackScaleData, res, params.callback);
        });
    }), defineProperty_default()(show__actions, 'delTrackScale', function delTrackScale(context) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref3.env,
            params = _ref3.params,
            callback = _ref3.callback;

        axios_default.a.post(apis["a" /* default */].delTrackScale, lib_default.a.stringify(params)).then(function (res) {
            console.log(res);
            callbackHandler(apis["a" /* default */].delTrackScale, res, callback, true);
            return res;
        });
    }), defineProperty_default()(show__actions, 'getCustomConfig', function getCustomConfig(context, params) {
        axios_default.a.get(apis["a" /* default */].getCustomConfig, {
            params: params.params
        }).then(function (res) {
            console.log(res);
            callbackHandler(apis["a" /* default */].getCustomConfig, res, params.callback);
            return res;
        });
    }), defineProperty_default()(show__actions, 'getResultVoiceArr', function getResultVoiceArr(context, params) {
        axios_default.a.get(apis["a" /* default */].getResultVoiceArr, {
            params: params.params
        }).then(function (res) {
            console.log(res);
            callbackHandler(apis["a" /* default */].getResultVoiceArr, res, params.callback);
            return res;
        });
    }), defineProperty_default()(show__actions, 'longToShort', function longToShort(context) {
        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref4.env,
            params = _ref4.params,
            callback = _ref4.callback;

        axios_default.a.post(apis["a" /* default */].longToShort, lib_default.a.stringify(params)).then(function (res) {
            console.log(res);
            callbackHandler(apis["a" /* default */].longToShort, res, callback, true);
            return res;
        });
    }), defineProperty_default()(show__actions, 'shortToLong', function shortToLong(context, params) {
        axios_default.a.get(apis["a" /* default */].shortToLong, {
            params: params.params
        }).then(function (res) {
            console.log(res);
            callbackHandler(apis["a" /* default */].shortToLong, res, params.callback);
            return res;
        });
    }), defineProperty_default()(show__actions, 'shareAuth', function shareAuth(context, params) {
        return axios_default.a.get(apis["a" /* default */].shareAuth, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].shareAuth, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'packageList', function packageList(context, params) {
        axios_default.a.get(apis["a" /* default */].packageList, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].packageList, res, params.callback);
        });
    }), defineProperty_default()(show__actions, 'getMyPackageOrderList', function getMyPackageOrderList(context, params) {
        axios_default.a.get(apis["a" /* default */].getMyPackageOrderList, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getMyPackageOrderList, res, params.callback);
        });
    }), defineProperty_default()(show__actions, 'BUY_COUPONS', function BUY_COUPONS(context, _ref5) {
        var API = _ref5.API,
            params = _ref5.params;

        return axios_default.a.get(API, {
            params: params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].packageBuy, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'packageBuy', function packageBuy(context, params) {
        axios_default.a.get(apis["a" /* default */].packageBuy, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].packageBuy, res, params.callback);
            return res;
        });
    }), defineProperty_default()(show__actions, 'showExtrance', function showExtrance(context, params) {
        axios_default.a.get(apis["a" /* default */].showExtrance, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].showExtrance, res, params.callback);
        });
    }), defineProperty_default()(show__actions, 'showDeposit', function showDeposit(context, params) {
        axios_default.a.get(apis["a" /* default */].showDeposit, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].showDeposit, res, params.callback);
        });
    }), defineProperty_default()(show__actions, 'getDepositOrder', function getDepositOrder(context, params) {
        return axios_default.a.get(apis["a" /* default */].getDepositOrder, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getDepositOrder, res);
            console.log(res.data);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'userCouponList', function userCouponList(context, params) {
        return axios_default.a.get(apis["a" /* default */].userCouponList, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].userCouponList, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'getCustomCoupon', function getCustomCoupon(context, params) {
        axios_default.a.get(apis["a" /* default */].getCustomCoupon, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getCustomCoupon, res, params.callback);
        });
    }), defineProperty_default()(show__actions, 'couponGiftReceive', function couponGiftReceive(context, params) {
        return axios_default.a.get(apis["a" /* default */].couponGiftReceive, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].couponGiftReceive, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'getDistributionCard', function getDistributionCard(context, params) {
        return axios_default.a.get(apis["a" /* default */].getDistributionCard, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getDistributionCard, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'getMyReward', function getMyReward(context, params) {
        console.log(params);
        return axios_default.a.get(apis["a" /* default */].getMyReward, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getMyReward, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'countMyCoupon', function countMyCoupon(context, params) {
        console.log(params);
        return axios_default.a.get(apis["a" /* default */].countMyCoupon, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].countMyCoupon, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'REDEEMCODEUSE', function REDEEMCODEUSE(context, params) {
        console.log(params);
        return axios_default.a.get(apis["a" /* default */].redeemCodeUse, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].redeemCodeUse, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'getDoubleTwelveScales', function getDoubleTwelveScales(context, params) {
        return axios_default.a.get(apis["a" /* default */].getDoubleTwelveScales, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getDoubleTwelveScales, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'couponDoubleTwelveStatus', function couponDoubleTwelveStatus(context, params) {
        return axios_default.a.get(apis["a" /* default */].couponDoubleTwelveStatus, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].couponDoubleTwelveStatus, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'doubleTwelveScalesReceive', function doubleTwelveScalesReceive(context, params) {
        return axios_default.a.get(apis["a" /* default */].doubleTwelveScalesReceive, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].doubleTwelveScalesReceive, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'scalePoolCouponList', function scalePoolCouponList(context, params) {
        console.log(params);
        return axios_default.a.get(apis["a" /* default */].scalePoolCouponList, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].scalePoolCouponList, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'newUserVerify', function newUserVerify(context, params) {
        console.log(params);
        return axios_default.a.get(apis["a" /* default */].newUserVerify, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].newUserVerify, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'GET_DISCOUNT_COUPON_STATUS', function GET_DISCOUNT_COUPON_STATUS(context, params) {
        return axios_default.a.get(apis["a" /* default */].getDiscountCouponStatus, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getDiscountCouponStatus, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'DISCOUNT_COUPON_RECERIVE', function DISCOUNT_COUPON_RECERIVE(context, params) {
        return axios_default.a.get(apis["a" /* default */].discountCouponReceive, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].discountCouponReceive, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'GETUSEROSCARACTCARD', function GETUSEROSCARACTCARD(context, params) {
        console.log(params);
        return axios_default.a.get(apis["a" /* default */].getUserOscarActCard, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getUserOscarActCard, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'setTop20PushRelation', function setTop20PushRelation(context, params) {
        console.log(params);
        return axios_default.a.get(apis["a" /* default */].setTop20PushRelation, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].setTop20PushRelation, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'storeSource', function storeSource(context, params) {
        console.log('进入接口---');
        console.log(params);
        return axios_default.a.get(apis["a" /* default */].storeSource, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].storeSource, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'bindGenesis', function bindGenesis(context, params) {
        console.log('盘古登录---');
        console.log(params);
        return axios_default.a.get(apis["a" /* default */].bindGenesis, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].bindGenesis, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'newUserCouponReceive', function newUserCouponReceive(context, _ref6) {
        var API = _ref6.API,
            params = _ref6.params;

        return axios_default.a.get(API, {
            params: params
        }).then(function (res) {
            callbackHandler(API, res);
            return res.data;
        });
    }), defineProperty_default()(show__actions, 'noLoginSearchOrder', function noLoginSearchOrder(context, params) {
        return axios_default.a.get(apis["a" /* default */].noLoginSearchOrder, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].noLoginSearchOrder, res);
            return res;
        });
    }), show__actions)
});
// EXTERNAL MODULE: ./src/lib/units.js + 2 modules
var units = __webpack_require__("DVdL");

// CONCATENATED MODULE: ./src/store/modules/report.js


var report__getters, report__actions;







// 用一个唯一或特殊的字段，在json里提取出一个blockData
function getBlockDataFromListByField(list, field) {
  if (!list || !list.length) return;

  for (var i = list.length - 1; i >= 0; i--) {
    if (typeof list[i][field] !== 'undefined') {
      return list[i];
    }
  }
}

/* harmony default export */ var report = ({
  state: {
    reportData: {}
  },
  mutations: {
    setReportData: function setReportData(state, payload) {
      state.reportData = payload;
    }
  },
  getters: (report__getters = {}, defineProperty_default()(report__getters, 'REPORT_QUESTIONNAIRE', function (_undefined) {
    function undefined(_x) {
      return _undefined.apply(this, arguments);
    }

    undefined.toString = function () {
      return _undefined.toString();
    };

    return undefined;
  }(function (state) {
    var that = this;
    var blockData = state.reportData.questionnaire;
    if (state.reportData.questionnaire == undefined) {
      return {};
    }
    var queInfo = {
      id: blockData.id,
      title: blockData.alias,
      content: blockData.intro
    };
    return queInfo;
  })), defineProperty_default()(report__getters, 'REPORT_SCALE', function (_undefined2) {
    function undefined(_x2) {
      return _undefined2.apply(this, arguments);
    }

    undefined.toString = function () {
      return _undefined2.toString();
    };

    return undefined;
  }(function (state) {
    var that = this;
    var scale = {};
    if (state.reportData.scale == undefined) {
      return {
        desc: ''
      };
    }
    scale.desc = state.reportData.scale.reportDescription;
    scale.showQRCode = !!(state.reportData.scale.isShowQrcode * 1);
    return scale;
  })), defineProperty_default()(report__getters, 'REPORT_BASEINFO', function (_undefined3) {
    function undefined(_x3) {
      return _undefined3.apply(this, arguments);
    }

    undefined.toString = function () {
      return _undefined3.toString();
    };

    return undefined;
  }(function (state) {
    var that = this;
    var baseInfo = {};
    if (state.reportData.employeeTest == undefined) {
      return {
        title: '',
        userName: '',
        testDate: ''
      };
    }
    var date = new Date(state.reportData.employeeTest.lastCompletedDatetime);
    var fillZero = function fillZero(str) {
      var result = '';
      if (str * 1 < 10) {
        result = '0' + str;
      } else {
        result = '' + str;
      }
      return result;
    };
    baseInfo.title = state.reportData.scale.name;
    baseInfo.userName = state.reportData.employee.name;
    baseInfo.testDate = date.getFullYear() + '.' + fillZero(date.getMonth() + 1) + '.' + fillZero(date.getDate()) + ' ' + fillZero(date.getHours()) + ':' + fillZero(date.getMinutes());

    return baseInfo;
  })), defineProperty_default()(report__getters, 'REPORT_SUMMARY', function (_undefined4) {
    function undefined(_x4) {
      return _undefined4.apply(this, arguments);
    }

    undefined.toString = function () {
      return _undefined4.toString();
    };

    return undefined;
  }(function (state) {
    var that = this;
    var viewData = {
      chart: {
        factorId: '',
        data: [],
        label: [],
        resultName: [],
        level: [],
        moduleIndexNumber: 0
      }
    };

    var blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'exponentFactorData');
    if (blockData == undefined) {
      // if (state.reportData.moduleDataList == undefined) {
      return viewData;
    }

    // const blockData = state.reportData.moduleDataList[0];
    var summary = viewData;
    // 指数型结果和组合型结果拼接
    summary.moduleIndexNumber = blockData.moduleIndexNumber;
    summary.title = blockData.moduleName;
    summary.chart.chartType = 'pointer';
    console.log(blockData);
    summary.chart.factorId = blockData.exponentFactorData.factorId;
    summary.chart.data.push(Math.round(blockData.exponentFactorData.scoringRatio));
    summary.chart.label.push(blockData.exponentFactorData.factorName);
    summary.chart.resultName.push(blockData.exponentFactorData.resultName);
    summary.chart.level.push(blockData.exponentFactorData.level);
    summary.result = blockData.exponentFactorData.resultDescription;
    // console.log(summary)
    return summary;
  })), defineProperty_default()(report__getters, 'REPORT_SUMMARY_ANSWER', function (_undefined5) {
    function undefined(_x5) {
      return _undefined5.apply(this, arguments);
    }

    undefined.toString = function () {
      return _undefined5.toString();
    };

    return undefined;
  }(function (state) {
    var that = this;
    var blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'synthesisAnalysisResult');
    if (blockData == undefined) {
      // if (state.reportData.moduleDataList == undefined) {
      return {};
    }

    // const blockData = state.reportData.moduleDataList[0].synthesisAnalysisResult;
    return {
      title: blockData.synthesisAnalysisResult.moduleName,
      content: blockData.synthesisAnalysisResult.description,
      moduleIndexNumber: blockData.moduleIndexNumber
    };
  })), defineProperty_default()(report__getters, 'REPORT_RADAR', function undefined(state) {
    var radarData,
        list,
        group = [];

    var blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'factorList');

    if (blockData) {
      radarData = blockData;
      list = radarData.factorList;

      if (list.length) {
        group.push(list.map(function (item) {
          return item.value;
        }));

        // 数据项有referenceAvgScore这个字段就认为有维度对比
        if (list[0].hasOwnProperty('referenceAvgScore') && list.filter(function (item) {
          return +item.referenceAvgScore;
        }).length) {
          group.push(list.map(function (item) {
            return item.referenceAvgScore;
          }));
        }

        return {
          group: group,
          title: radarData.moduleName,
          types: list.map(function (item) {
            return item.name;
          }),
          moduleIndexNumber: blockData.moduleIndexNumber
        };
      }
    } else {
      return {
        title: '',
        group: [],
        types: []
      };
    }
  }), defineProperty_default()(report__getters, 'REPORT_DIMENSION_COMPARISON', function undefined(state) {
    var barData,
        list,
        comparison,
        transpose,
        types,
        shortTypes,
        maxLabelLength,
        resultItemKeys = ['level1FactorDatas', 'factorName', 'resultName', 'resultdescription', 'fillColor'],
        group = [];

    var blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'level2FactorVos');

    if (blockData) {
      barData = blockData;
      list = barData.level2FactorVos;

      types = list.map(function (item) {
        return item.factorName;
      });
      comparison = barData.factorComparison;
      transpose = !barData.factorComparisonStyle;
      maxLabelLength = Math.max.apply(Math, types.map(function (str) {
        return str.length;
      }));

      if (list.length) {
        group.push([], []);
        list.forEach(function (dimension) {
          group[0].push(dimension.level1FactorDatas[0].scoringRatio);
          group[1].push(dimension.level1FactorDatas[1].scoringRatio);
        });

        // 竖向排列时，如果label超过8个字，用字母代替
        if (comparison && (transpose ? 7 : 0) < maxLabelLength) {
          shortTypes = types.map(function (_, i) {
            return String.fromCharCode(65 + i);
          });
        }

        return {
          group: group,
          types: types,
          shortTypes: shortTypes,
          title: barData.moduleName,
          results: list.map(function (item) {
            return Object(units["v" /* pick */])(item, resultItemKeys);
          }),
          legend: [barData.factorComparatorLegend1, barData.factorComparatorLegend2],
          comparison: comparison,
          transpose: transpose,
          moduleIndexNumber: blockData.moduleIndexNumber
        };
      }
    } else {
      return {};
    }
  }), defineProperty_default()(report__getters, 'REPORT_SUMMARY_FACTORS', function (_undefined6) {
    function undefined(_x6) {
      return _undefined6.apply(this, arguments);
    }

    undefined.toString = function () {
      return _undefined6.toString();
    };

    return undefined;
  }(function (state) {
    var that = this;
    var blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'level2FactorDataList');
    if (blockData == undefined) {
      // if (state.reportData.moduleDataList == undefined) {
      return {
        tabData: {},
        chart: {}
      };
    }

    // const blockData = state.reportData.moduleDataList[2];
    var summaryFactors = {
      chart: {},
      tabData: {},
      moduleIndexNumber: blockData.moduleIndexNumber
    };
    summaryFactors.title = blockData.moduleName;
    summaryFactors.chart = Object(units["k" /* factorArrayToChart */])(blockData.level2FactorDataList);
    summaryFactors.chart.chartType = 'bar';
    summaryFactors.tabData.tabNames = blockData.level2FactorDataList.map(function (item) {
      return item.factorName;
    });
    summaryFactors.tabData.tabConts = blockData.level2FactorDataList.map(function (item) {
      return {
        factorName: item.factorName,
        result: item.resultdescription,
        resultName: item.resultName,
        resultNameColor: item.fillColor
      };
    });
    //        console.log(summaryFactors);
    return summaryFactors;
  })), defineProperty_default()(report__getters, 'REPORT_DETAIL_ANALYSIS', function (_undefined7) {
    function undefined(_x7) {
      return _undefined7.apply(this, arguments);
    }

    undefined.toString = function () {
      return _undefined7.toString();
    };

    return undefined;
  }(function (state) {
    var that = this;
    var blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'factorGroups');
    if (blockData == undefined) {
      // if (state.reportData.moduleDataList == undefined) {
      return {
        tabData: {}
      };
    }

    // const blockData = state.reportData.moduleDataList[3];
    var detailAnalysis = {
      moduleIndexNumber: blockData.moduleIndexNumber,
      tabData: {
        tabNames: [],
        tabConts: []
      }
    };
    detailAnalysis.title = blockData.moduleName;
    for (var i = 0; i < blockData.factorGroups.length; i++) {
      var item = blockData.factorGroups[i];
      if (item.level1FactorDatas.length > 0) {
        var tabCont = {};
        detailAnalysis.tabData.tabNames.push(item.name);
        tabCont.chart = Object(units["k" /* factorArrayToChart */])(item.level1FactorDatas);
        tabCont.chart.chartType = 'line';
        tabCont.factors = [];
        for (var j = 0; j < item.level1FactorDatas.length; j++) {
          var curFactor = item.level1FactorDatas[j];
          tabCont.factors.push({
            factorName: curFactor.factorName,
            result: curFactor.resultDescription,
            resultName: curFactor.resultName,
            resultNameColor: curFactor.fillColor
          });
        }
        detailAnalysis.tabData.tabConts.push(tabCont);
      }
    }
    return detailAnalysis;
  })), defineProperty_default()(report__getters, 'REPORT_RESULTS', function (_undefined8) {
    function undefined(_x8) {
      return _undefined8.apply(this, arguments);
    }

    undefined.toString = function () {
      return _undefined8.toString();
    };

    return undefined;
  }(function (state) {
    var that = this;
    var blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'conclusions');
    if (blockData == undefined) {
      // if (state.reportData.moduleDataList == undefined) {
      return {};
    }

    // const blockData = state.reportData.moduleDataList[5];
    var result = {
      moduleIndexNumber: blockData.moduleIndexNumber
    };
    // result
    result.title = blockData.moduleName;
    result.result = [];
    for (var i = 0; i < blockData.conclusions.length; i++) {
      var item = blockData.conclusions[i];
      if (item.resultConclusion != '') {
        result.result.push(item.resultConclusion);
      }
    }

    return result;
  })), defineProperty_default()(report__getters, 'REPORT_SUGGEST', function (_undefined9) {
    function undefined(_x9) {
      return _undefined9.apply(this, arguments);
    }

    undefined.toString = function () {
      return _undefined9.toString();
    };

    return undefined;
  }(function (state) {
    var that = this;
    var blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'resultProposals');
    if (blockData == undefined) {
      // if (state.reportData.moduleDataList == undefined) {
      return {};
    }

    // const blockData = state.reportData.moduleDataList[6];
    var suggest = {
      moduleIndexNumber: blockData.moduleIndexNumber
    };
    suggest.title = blockData.moduleName;
    suggest.suggest = [];
    for (var i = 0; i < blockData.resultProposals.length; i++) {
      var item = blockData.resultProposals[i];
      if (item.resultProposal != '') {
        suggest.suggest.push(item.resultProposal);
      }
    }
    return suggest;
  })), defineProperty_default()(report__getters, 'REPORT_OTHERS', function (_undefined10) {
    function undefined(_x10) {
      return _undefined10.apply(this, arguments);
    }

    undefined.toString = function () {
      return _undefined10.toString();
    };

    return undefined;
  }(function (state) {
    var that = this;
    if (state.reportData.employee == undefined) {
      return {
        companyScaleId: '',
        accountId: '',
        scaleId: '',
        questionnaireId: '',
        employeeScaleId: '',
        orderId: '',
        shareTemplateMsg: {
          username: ''
        }
      };
    }
    var others = {
      companyScaleId: '' + state.reportData.employee.companyScaleId,
      accountId: '' + state.reportData.employee.accountId,
      scaleId: '' + state.reportData.scale.id,
      questionnaireId: '' + state.reportData.questionnaire.id,
      employeeScaleId: '' + state.reportData.shareTemplateMsg.employeeScaleId,
      orderId: '' + state.reportData.employeeTest.orderId,
      shareTemplateMsg: state.reportData.shareTemplateMsg
    };
    return others;
  })), report__getters),
  actions: (report__actions = {}, defineProperty_default()(report__actions, 'GET_REPORTDATA', function undefined(context) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        params = _ref.params,
        callback = _ref.callback;

    return axios_default.a.get(apis["a" /* default */].viewReport, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].homePageBanner, res, callback);
      return res;
    });
  }), defineProperty_default()(report__actions, 'GET_REPORT_RECOMMEND', function undefined(context) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        params = _ref2.params,
        callback = _ref2.callback;

    axios_default.a.get(apis["a" /* default */].getRelevantScalesForReport, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].homePageBanner, res, callback);
    });
  }), defineProperty_default()(report__actions, 'GET_REPORT_COUPON', function undefined(context) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        params = _ref3.params,
        callback = _ref3.callback;

    axios_default.a.get(apis["a" /* default */].reportPageCouponReceive, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].homePageBanner, res, callback);
    });
  }), defineProperty_default()(report__actions, 'GET_REPORT_SHARE_DATA', function undefined(context) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        params = _ref4.params,
        callback = _ref4.callback;

    axios_default.a.get(apis["a" /* default */].shareDetail, {
      params: params
    }).then(function (res) {
      callback(res.data);
      // callbackHandler(APIS.shareDetail, res, callback);
    });
  }), defineProperty_default()(report__actions, 'GET_REPORT_SHARE_SCALE_URL', function undefined(context) {
    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        params = _ref5.params,
        callback = _ref5.callback;

    axios_default.a.get(apis["a" /* default */].getDetailUrl, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].getDetailUrl, res, callback);
    });
  }), defineProperty_default()(report__actions, 'GET_REPORT_SHARE_RECOMMEND', function undefined(context) {
    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        isWechat = _ref6.isWechat,
        params = _ref6.params,
        callback = _ref6.callback;

    axios_default.a.get(isWechat ? apis["a" /* default */].shareRecommend_wx : apis["a" /* default */].shareRecommend_m, {
      params: params
    }).then(function (res) {
      callback(res.data);
    });
  }), defineProperty_default()(report__actions, 'PUSH_REPORT_SHARE_VOTE', function undefined(context) {
    var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        params = _ref7.params,
        callback = _ref7.callback;

    axios_default.a.get(apis["a" /* default */].vote, {
      params: params
    }).then(function (res) {
      callback(res.data);
    });
  }), defineProperty_default()(report__actions, 'GET_PDF_STATUS', function undefined(context) {
    var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        params = _ref8.params,
        callback = _ref8.callback;

    return axios_default.a.get(apis["a" /* default */].getPdfStatus, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].getPdfStatus, res, callback);
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'BUY_PDF', function undefined(context) {
    var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        params = _ref9.params,
        callback = _ref9.callback;

    return axios_default.a.get(apis["a" /* default */].buyPdf, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].buyPdf, res, callback);
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'GET_BUY_PDF', function GET_BUY_PDF(context, _ref10) {
    var API = _ref10.API,
        params = _ref10.params;

    return axios_default.a.get(API, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].buyPdf, res);
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'SEND_MAIL_WITH_PDF', function SEND_MAIL_WITH_PDF(context, _ref11) {
    var API = _ref11.API,
        params = _ref11.params;

    return axios_default.a.get(apis["a" /* default */].sendMailWithPdfNew, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].sendMailWithPdfNew, res);
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'DELETE_REPORT', function DELETE_REPORT(context, _ref12) {
    var API = _ref12.API,
        params = _ref12.params;

    return axios_default.a.get(apis["a" /* default */].deleteReport, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].deleteReport, res);
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'verifyConsultPrice', function verifyConsultPrice(context, _ref13) {
    var API = _ref13.API,
        params = _ref13.params;

    return axios_default.a.get(apis["a" /* default */].verifyConsultPrice, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].verifyConsultPrice, res);
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'buyConsult', function buyConsult(context, _ref14) {
    var API = _ref14.API,
        params = _ref14.params;

    return axios_default.a.get(apis["a" /* default */].buyConsult, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].buyConsult, res);
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'submitConsultForm', function submitConsultForm(context, _ref15) {
    var API = _ref15.API,
        params = _ref15.params;

    return axios_default.a.post(apis["a" /* default */].submitConsultForm, lib_default.a.stringify(params)).then(function (res) {
      callbackHandler(apis["a" /* default */].submitConsultForm, res);
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'getMyConsultOrderData', function getMyConsultOrderData(context, _ref16) {
    var API = _ref16.API,
        params = _ref16.params;

    return axios_default.a.get(API, {
      params: params
    }).then(function (res) {
      callbackHandler(API, res);
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'getReportConsultForm', function getReportConsultForm(context, _ref17) {
    var API = _ref17.API,
        params = _ref17.params;

    return axios_default.a.get(apis["a" /* default */].getReportConsultForm, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].getReportConsultForm, res);
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'verifyConsultFormRedDot', function verifyConsultFormRedDot(context, _ref18) {
    var API = _ref18.API,
        params = _ref18.params;

    return axios_default.a.get(apis["a" /* default */].verifyConsultFormRedDot, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].verifyConsultFormRedDot, res);
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'closeConsultModule', function closeConsultModule(context, _ref19) {
    var API = _ref19.API,
        params = _ref19.params;

    return axios_default.a.get(apis["a" /* default */].closeConsultModule, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].closeConsultModule, res);
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'getConsultModuleStatus', function getConsultModuleStatus(context, _ref20) {
    var API = _ref20.API,
        params = _ref20.params;

    return axios_default.a.get(apis["a" /* default */].getConsultModuleStatus, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].getConsultModuleStatus, res);
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'getReportDataUrl', function getReportDataUrl(context, _ref21) {
    var API = _ref21.API,
        params = _ref21.params;

    return axios_default.a.get(apis["a" /* default */].getReportDataUrl, {
      params: params
    }).then(function (res) {
      callbackHandler(apis["a" /* default */].getReportDataUrl, res);
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'getConsultReadingReportTeachers', function getConsultReadingReportTeachers(context, _ref22) {
    var params = _ref22.params;

    return axios_default.a.get(apis["a" /* default */].getConsultReadingReportTeachers, {
      params: params
    }).then(function (res) {
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'getCpConsultantCpDiversion', function getCpConsultantCpDiversion(context, _ref23) {
    var params = _ref23.params;

    return axios_default.a.get(apis["a" /* default */].cpConsultantCpDiversion, {
      params: params
    }).then(function (res) {
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'fetchCommonDistributionCard', function fetchCommonDistributionCard(context, _ref24) {
    var params = _ref24.params;

    return axios_default.a.get(apis["a" /* default */].getCommonDistributionCard, {
      params: params
    }).then(function (res) {
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'fetchAppHeartCoach', function fetchAppHeartCoach(context, _ref25) {
    var params = _ref25.params;

    return axios_default.a.get(apis["a" /* default */].getAppHeartCoach, {
      params: params
    }).then(function (res) {
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'fetchGuideData', function fetchGuideData(context, _ref26) {
    var params = _ref26.params;

    return axios_default.a.get(apis["a" /* default */].fetchGuideData, {
      params: params
    }).then(function (res) {
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'getConsultDescription', function getConsultDescription(context, _ref27) {
    var params = _ref27.params;

    return axios_default.a.get(apis["a" /* default */].getConsultDescription, {
      params: params
    }).then(function (res) {
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'getTeacherAndPrice', function getTeacherAndPrice(context, _ref28) {
    var params = _ref28.params;

    return axios_default.a.get(apis["a" /* default */].getTeacherAndPrice, {
      params: params
    }).then(function (res) {
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'fetchAppConsultantInfo', function fetchAppConsultantInfo(context, _ref29) {
    var params = _ref29.params;

    return axios_default.a.get(apis["a" /* default */].fetchAppConsultantInfo, {
      params: params
    }).then(function (res) {
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'fetchAppGuideData', function fetchAppGuideData(context, _ref30) {
    var params = _ref30.params;

    return axios_default.a.get(apis["a" /* default */].fetchAppGuideData, {
      params: params
    }).then(function (res) {
      return res.data;
    });
  }), defineProperty_default()(report__actions, 'getCpConsultantOpenInvitee', function getCpConsultantOpenInvitee(context, _ref31) {
    var params = _ref31.params;

    return axios_default.a.get(apis["a" /* default */].cpConsultantOpenInvitee, {
      params: params
    }).then(function (res) {
      return res.data;
    });
  }), report__actions)

});
// CONCATENATED MODULE: ./src/store/modules/search.js


var _state, search__mutations, search__getters, search__actions;

// created by LinWeiLong @ 2017/09/12





;

/* harmony default export */ var search = ({
    state: (_state = {}, defineProperty_default()(_state, 'SEARCH_KEYWORD', ''), defineProperty_default()(_state, 'SEARCHED_WORD', ''), defineProperty_default()(_state, 'SEARCH_RELATED_WORDS', []), defineProperty_default()(_state, 'SEARCH_RECOMMEND_WORDS', []), defineProperty_default()(_state, 'SEARCH_RECOMMEND_SCALES', {}), defineProperty_default()(_state, 'SEARCH_RESULT', []), _state),
    mutations: (search__mutations = {}, defineProperty_default()(search__mutations, 'SET_SEARCH_KEYWORD', function undefined(state) {
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        state.SEARCH_KEYWORD = payload;
    }), defineProperty_default()(search__mutations, 'SET_SEARCHED_WORD', function undefined(state) {
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        state.SEARCHED_WORD = payload;
    }), defineProperty_default()(search__mutations, 'SET_SEARCH_RELATED_WORDS', function undefined(state) {
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        payload = Object(units["q" /* isEmpObj */])(payload) ? [] : payload;
        state.SEARCH_RELATED_WORDS = payload;
    }), defineProperty_default()(search__mutations, 'SET_SEARCH_RECOMEND_WORDS', function undefined(state, payload) {
        state.SEARCH_RECOMMEND_WORDS = payload;
    }), defineProperty_default()(search__mutations, 'SET_SEARCH_RECOMEND_SCALES', function undefined(state, payload) {
        state.SEARCH_RECOMMEND_SCALES = payload;
    }), defineProperty_default()(search__mutations, 'SET_SEARCH_RESULT', function undefined(state, payload) {
        state.SEARCH_RESULT = payload;
    }), search__mutations),
    getters: (search__getters = {}, defineProperty_default()(search__getters, 'SEARCH_KEYWORD', function undefined(state) {
        return state.SEARCH_KEYWORD;
    }), defineProperty_default()(search__getters, 'SEARCHED_WORD', function undefined(state) {
        return state.SEARCHED_WORD;
    }), defineProperty_default()(search__getters, 'SEARCH_RELATED_WORDS', function undefined(state) {
        return state.SEARCH_RELATED_WORDS;
    }), defineProperty_default()(search__getters, 'SEARCH_RECOMMEND_WORDS', function SEARCH_RECOMMEND_WORDS(state) {
        return state.SEARCH_RECOMMEND_WORDS;
    }), defineProperty_default()(search__getters, 'SEARCH_RECOMMEND_SCALES', function SEARCH_RECOMMEND_SCALES(state) {
        return state.SEARCH_RECOMMEND_SCALES;
    }), defineProperty_default()(search__getters, 'SEARCH_RESULT', function undefined(state) {
        return state.SEARCH_RESULT;
    }), search__getters),
    actions: (search__actions = {}, defineProperty_default()(search__actions, 'GET_SEARCH_RESULT', function undefined(context, _ref) {
        var _ref$params = _ref.params,
            params = _ref$params === undefined ? {} : _ref$params,
            callback = _ref.callback;

        axios_default.a.get(apis["a" /* default */].funSearch, {
            params: params
        }).then(function (res) {
            //2019/6/28 改成趣味测试和专业测试
            callbackHandler(apis["a" /* default */].funSearch, res, function (DATA) {
                console.log(DATA);
                context.commit('SET_SEARCH_RELATED_WORDS', []);
                context.commit('SET_SEARCH_RESULT', DATA.list);
                if (typeof callback == 'function') {
                    callback();
                }
            });
        });
    }), defineProperty_default()(search__actions, 'GET_SEARCH_RECOMMEND', function GET_SEARCH_RECOMMEND(context) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$params = _ref2.params,
            params = _ref2$params === undefined ? {} : _ref2$params,
            _ref2$callback = _ref2.callback,
            callback = _ref2$callback === undefined ? function () {} : _ref2$callback;

        axios_default.a.get(apis["a" /* default */].searchRecommend, {
            params: params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].funSearch, res, function (DATA) {
                context.commit('SET_SEARCH_RECOMEND_WORDS', DATA.recommends);
                context.commit('SET_SEARCH_RECOMEND_SCALES', DATA.scales);
                callback(DATA);
            });
        });
    }), defineProperty_default()(search__actions, 'GET_SEARCH_RELATED_WORDS', function undefined(context) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref3$params = _ref3.params,
            params = _ref3$params === undefined ? {} : _ref3$params,
            _ref3$callback = _ref3.callback,
            callback = _ref3$callback === undefined ? function () {} : _ref3$callback;

        if (params.keyword == '') {
            context.commit('SET_SEARCH_RELATED_WORDS', []);
        } else {
            axios_default.a.get(apis["a" /* default */].funSearch, {
                params: params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].funSearch, res, function (DATA) {
                    var list = DATA.list.map(function (item) {
                        return item.name;
                    });
                    console.log(list);
                    context.commit('SET_SEARCH_RELATED_WORDS', list);
                    if (typeof callback == 'function') {
                        callback(DATA);
                    }
                });
            });
        }
    }), search__actions)
});
// CONCATENATED MODULE: ./src/store/modules/comment.js



var comment__actions;





/* harmony default export */ var comment = ({
    getters: {},
    actions: (comment__actions = {}, defineProperty_default()(comment__actions, 'GET_REPORT_HASCOMMENT', function undefined(context) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            params = _ref.params,
            callback = _ref.callback;

        return axios_default.a.get(apis["a" /* default */].reportShowComment, {
            params: params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].reportShowComment, res, callback);
            return res.data;
        });
    }), defineProperty_default()(comment__actions, 'PUBLISH_COMMENT', function undefined(context) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            params = _ref2.params,
            callback = _ref2.callback;

        // console.info(qs.stringify(evaluationItem));
        return axios_default.a.post(apis["a" /* default */].publishComment, lib_default.a.stringify({ evaluationItem: params })).then(function (res) {
            callbackHandler(apis["a" /* default */].publishComment, res, callback);
            return res.data;
        });
    }), defineProperty_default()(comment__actions, 'DELETE_COMMENT', function undefined(context, _ref3) {
        var params = _ref3.params,
            callback = _ref3.callback;

        axios_default.a.get(apis["a" /* default */].deleteComment, {
            params: params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].deleteComment, res, callback);
        });
    }), defineProperty_default()(comment__actions, 'GET_UNCOMMENT_SCALES', function undefined(context, _ref4) {
        var params = _ref4.params,
            callback = _ref4.callback;

        return axios_default.a.get(apis["a" /* default */].getUnCommentScales, {
            params: params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getUnCommentScales, res, callback);
            return res.data;
        });
    }), defineProperty_default()(comment__actions, 'GET_MY_COMMENT', function undefined(context, _ref5) {
        var params = _ref5.params,
            callback = _ref5.callback;

        axios_default.a.get(apis["a" /* default */].getMyComment, {
            params: params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getMyComment, res, callback);
        });
    }), defineProperty_default()(comment__actions, 'GET_ALL_COMMENT', function undefined(context, _ref6) {
        var params = _ref6.params;

        return axios_default.a.get(apis["a" /* default */].allComment, {
            params: params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getMyComment, res);
            return res.data;
        });
    }), defineProperty_default()(comment__actions, 'GET_HANDPICK_COMMENT', function undefined(context, _ref7) {
        var params = _ref7.params,
            callback = _ref7.callback;

        axios_default.a.get(apis["a" /* default */].getHandpickComments, {
            params: params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getHandpickComments, res, callback);
        });
    }), defineProperty_default()(comment__actions, 'GET_LATEST_COMMENT', function undefined(context, _ref8) {
        var params = _ref8.params,
            callback = _ref8.callback;

        axios_default.a.get(apis["a" /* default */].getLatestComments, {
            params: params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getLatestComments, res, callback);
        });
    }), defineProperty_default()(comment__actions, 'GET_DETAIL_COMMENT', function undefined(context, params) {
        console.log(params);
        console.log('GET_DETAIL_COMMENT');
        if ((params.channelId == 2278 || params.channelId == 2310) && (params.scalePoolId == 566 || params.scalePoolId == 587)) {
            console.log('2278 2310渠道且566ID的评论数据，后续需要处理');
            return promise_default.a.resolve(__webpack_require__("i3FV"));
        } else {
            return axios_default.a.get(apis["a" /* default */].getDetailPageComments, {
                params: params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].getDetailPageComments, res);
                return res.data;
            });
        }
    }), defineProperty_default()(comment__actions, 'getCpReportResult', function getCpReportResult(context, params) {
        return axios_default.a.get(apis["a" /* default */].getCpReportResult, {
            params: params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getCpReportResult, res);
            return res.data;
        });
    }), defineProperty_default()(comment__actions, 'getConfigureByCode', function getConfigureByCode(context, params) {
        return axios_default.a.get(apis["a" /* default */].getConfigureByCode, {
            params: params
        }).then(function (res) {
            return res.data;
        });
    }), comment__actions)
});
// CONCATENATED MODULE: ./src/store/modules/gift.js





/* harmony default export */ var gift = ({
    state: {},
    mutations: {},
    getters: {},
    actions: {
        GIFT_BUY: function GIFT_BUY(context, _ref) {
            var params = _ref.params;

            return axios_default.a.get(apis["a" /* default */].gift_buy, {
                params: params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].gift_buy, res);
                return res.data;
            });
        },
        GIFT_MINE_GIVE: function GIFT_MINE_GIVE(context, _ref2) {
            var params = _ref2.params;

            return axios_default.a.get(apis["a" /* default */].gift_mine_give, {
                params: params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].gift_mine_give, res);
                return res.data;
            });
        },
        GIFT_MINE_RECEIVE: function GIFT_MINE_RECEIVE(context, _ref3) {
            var params = _ref3.params;

            return axios_default.a.get(apis["a" /* default */].gift_mine_receive, {
                params: params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].gift_mine_receive, res);
                return res.data;
            });
        },
        GIFT_RECEIVE_DETAIL: function GIFT_RECEIVE_DETAIL(context, _ref4) {
            var params = _ref4.params;

            return axios_default.a.get(apis["a" /* default */].gift_receive_detail, {
                params: params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].gift_receive_detail, res);
                return res.data;
            });
        },
        GIFT_GIVE: function GIFT_GIVE(context, _ref5) {
            var params = _ref5.params;

            return axios_default.a.get(apis["a" /* default */].gift_give, {
                params: params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].gift_give, res);
                return res.data;
            });
        },
        GIFT_RECEIVE: function GIFT_RECEIVE(context, _ref6) {
            var params = _ref6.params;

            return axios_default.a.get(apis["a" /* default */].gift_receive, {
                params: params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].gift_receive_detail, res);
                return res.data;
            });
        }
    }
});
// EXTERNAL MODULE: ./src/apis/vip.js
var vip = __webpack_require__("65qJ");

// CONCATENATED MODULE: ./src/store/modules/vip.js






/* harmony default export */ var modules_vip = ({
  state: {
    INDEXSCROLLTOP: 0
  },
  mutations: {
    setINDEXSCROLLTOP: function setINDEXSCROLLTOP(state, number) {
      state.INDEXSCROLLTOP = number;
    }
  },
  getters: {},
  actions: {
    //首页获取测评列表接口
    getHighEndIndexScales: function getHighEndIndexScales(context, params) {
      console.log(params);
      return axios_default.a.get(apis["a" /* default */].getHighEndIndexScales, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].getHighEndIndexScales, res);
        return res.data;
      });
    },

    //获取高端产品单条测评的详情接口
    getHighEndScaleDetailIntro: function getHighEndScaleDetailIntro(context, params) {
      console.log(params);
      return axios_default.a.get(apis["a" /* default */].getHighEndScaleDetailIntro, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].getHighEndScaleDetailIntro, res);
        return res.data;
      });
    },

    //获取 我的测评列表 (已购买的套餐和测评数据) 接口
    getHighEndMyScaleData: function getHighEndMyScaleData(context, params) {
      console.log(params);
      return axios_default.a.get(apis["a" /* default */].getHighEndMyScaleData, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].getHighEndMyScaleData, res);
        return res.data;
      });
    },

    //获取高价测试列表
    getProfessionalScales: function getProfessionalScales(context, params) {
      return axios_default.a.get(apis["a" /* default */].getProfessionalScales, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].getProfessionalScales, res);
        return res.data;
      });
    },

    //双12会员活动首页接口
    getVipHomePageInfo: function getVipHomePageInfo(context, params) {
      return axios_default.a.get(apis["a" /* default */].getVipHomePageInfo, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].getVipHomePageInfo, res);
        return res.data;
      });
    },

    // 购买会员购买礼包
    buyVip: function buyVip(context, params) {
      return axios_default.a.get(apis["a" /* default */].vipBuy, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].vipBuy, res);
        return res.data;
      });
    },

    //领取会员红包
    receiveVipCoupon: function receiveVipCoupon(context, params) {
      return axios_default.a.get(apis["a" /* default */].receiveVipCoupon, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].receiveVipCoupon, res);
        return res.data;
      });
    },

    //会员红包领取列表
    vipCouponList: function vipCouponList(context, params) {
      return axios_default.a.get(apis["a" /* default */].vipCouponList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].vipCouponList, res);
        return res.data;
      });
    },

    // 会员分销排行榜
    vipDistributionRankingList: function vipDistributionRankingList(context, params) {
      return axios_default.a.get(apis["a" /* default */].vipDistributionRankingList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].vipDistributionRankingList, res);
        return res.data;
      });
    },

    // vip分销活动跳转接口
    fecthVipGetUrl: function fecthVipGetUrl(context, params) {
      return axios_default.a.get(apis["a" /* default */].vipGetUrl, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].vipGetUrl, res);
        return res.data;
      });
    },

    //分销页授权接口
    fetchVipDistribution: function fetchVipDistribution(context, params) {
      return axios_default.a.get(apis["a" /* default */].authVipDistribution, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].authVipDistribution, res);
        return res.data;
      });
    },

    //分销页授权接口
    getMyReward: function getMyReward(context, params) {
      return axios_default.a.get(apis["a" /* default */].getMyReward, {
        params: params.params
      }).then(function (res) {
        // callbackHandler(APIS.getMyReward, res);
        return res;
      });
    },

    //权益页授权接口
    authVipRights: function authVipRights(context, params) {
      return axios_default.a.get(apis["a" /* default */].authVipRights, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].authVipRights, res);
        return res;
      });
    },

    //获取会员分销卡地址
    getVipDistributionCard: function getVipDistributionCard(context, params) {
      return axios_default.a.get(apis["a" /* default */].getVipDistributionCard, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].getVipDistributionCard, res);
        return res.data;
      });
    },


    // 2022 会员
    // 购买会员购买礼包
    buyVip3: function buyVip3(context, params) {
      return axios_default.a.get(apis["a" /* default */].vip3Buy, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].vip3Buy, res);
        return res.data;
      });
    },
    getKcVip: function getKcVip(context, params) {
      return axios_default.a.get(apis["a" /* default */].kcVip, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].kcVip, res);
        return res.data;
      });
    },

    // 双12会员活动首页
    getVip3HomePageInfo: function getVip3HomePageInfo(context, params) {
      return axios_default.a.get(apis["a" /* default */].getVip3HomePageInfo, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].getVip3HomePageInfo, res);
        return res.data;
      });
    },


    // 双12会员活动首页-4.0
    getVip4HomePageInfo: function getVip4HomePageInfo(context, params) {
      return axios_default.a.get(apis["a" /* default */].getVip4HomePageInfo, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].getVip4HomePageInfo, res);
        return res.data;
      });
    },
    receiveUnionVip: function receiveUnionVip(context) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref.env,
          params = _ref.params,
          callback = _ref.callback;

      return axios_default.a.post(apis["a" /* default */].receiveUnionVip, lib_default.a.stringify(params)).then(function (res) {
        // console.log(res)
        callbackHandler(apis["a" /* default */].receiveUnionVip, res, callback, true);
        return res.data;
      });
    },
    getUnionVipStatus: function getUnionVipStatus(context, params) {
      return axios_default.a.get(apis["a" /* default */].getUnionVipStatus, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].getUnionVipStatus, res);
        return res.data;
      });
    },


    // 2023 会员 vip4.0
    getV4CouponList: function getV4CouponList(context, params) {
      return axios_default.a.get(vip["a" /* default */].getV4CouponList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(vip["a" /* default */].getV4CouponList, res);
        return res.data;
      });
    },
    receiveV4Coupon: function receiveV4Coupon(context) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          params = _ref2.params,
          callback = _ref2.callback;

      return axios_default.a.post(vip["a" /* default */].receiveCoupon, lib_default.a.stringify(params)).then(function (res) {
        // console.log(res)
        callbackHandler(vip["a" /* default */].receiveCoupon, res, callback, true);
        return res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./src/apis/member.js
// 会员活动页接口
var member_env = location.host.split('.')[0].match(/(qc|box)\d?/g);
var spell = !!member_env ? member_env.length > 0 ? '-' + member_env[0] : '' : '';
var CPAPI = '//m-cpapi' + spell + '.xinli001.com/cp/service/',
    HCP = '//hcp' + spell + '.xinli001.com/',
    LXDOMAIN = spell ? '//lingxi' + spell + '.xinli001.com/lingxi/service/' : '//m-lingxi' + spell + '.xinli001.com/lingxi/service/',
    APIS = {
		friendCardMyInvite: LXDOMAIN + 'friendCard/myInvite', //  亲友卡我的邀请记录
		friendCardRank: LXDOMAIN + 'friendCard/rank', //  亲友卡排行榜
		friendReceive: LXDOMAIN + 'friendCard/receive', //  亲友卡领取接口
		consultBindPhone: LXDOMAIN + 'consult/bindPhone', //  绑定此刻心理手机号
		phoneStatusAndAutoBind: LXDOMAIN + 'consult/phoneStatusAndAutoBind', //  绑定此刻心理手机号
		friendCardReceiveStatus: LXDOMAIN + 'friendCard/receiveStatus' //  绑定此刻心理手机号

};

/* harmony default export */ var member = (APIS);
// CONCATENATED MODULE: ./src/store/modules/member.js







/* harmony default export */ var modules_member = ({
  state: {},
  mutations: {},
  getters: {},
  actions: {
    //获取会员分销卡地址
    get360DistributionCard: function get360DistributionCard(context, params) {
      return axios_default.a.get(apis["a" /* default */].get360DistributionCard, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].get360DistributionCard, res);
        return res.data;
      });
    },

    // distributionRankingList
    distributionRankingList: function distributionRankingList(context, params) {
      return axios_default.a.get(apis["a" /* default */].distributionRankingList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].distributionRankingList, res);
        return res.data;
      });
    },
    get525Qrcode: function get525Qrcode(context, params) {
      return axios_default.a.get(apis["a" /* default */].get525Qrcode, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].get525Qrcode, res);
        return res.data;
      });
    },

    //亲友卡我的邀请记录
    friendCardMyInvite: function friendCardMyInvite(context, params) {
      return new promise_default.a(function (resolve, reject) {
        axios_default.a.get(member.friendCardMyInvite, {
          params: params.params
        }).then(function (res) {
          callbackHandler(member.friendCardMyInvite, res);
          if (res.data.code == 1) {
            resolve(res.data);
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    //亲友卡领取接口
    friendReceive: function friendReceive(context) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref.env,
          params = _ref.params;

      return axios_default.a.post(member.friendReceive, lib_default.a.stringify(params)).then(function (res) {
        return callbackHandler(member.friendReceive, res);
        return res.data;
      });
    },

    //亲友卡排行榜
    friendCardRank: function friendCardRank(context, params) {
      return axios_default.a.get(member.friendCardRank, {
        params: params.params
      }).then(function (res) {
        callbackHandler(member.friendCardRank, res);
        return res.data;
      });
    },

    //绑定此刻心理手机号
    consultBindPhone: function consultBindPhone(context) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref2.env,
          params = _ref2.params;

      return axios_default.a.post(member.consultBindPhone, lib_default.a.stringify(params)).then(function (res) {
        return callbackHandler(member.consultBindPhone, res);
        return res.data;
      });
    },

    //亲友卡我的邀请记录-是否绑定手机号
    phoneStatusAndAutoBind: function phoneStatusAndAutoBind(context, params) {
      return axios_default.a.get(member.phoneStatusAndAutoBind, {
        params: params.params
      }).then(function (res) {
        callbackHandler(member.phoneStatusAndAutoBind, res);
        return res.data;
      });
    },

    //亲友卡领取状态接口
    friendCardReceiveStatus: function friendCardReceiveStatus(context, params) {
      return axios_default.a.get(member.friendCardReceiveStatus, {
        params: params.params
      }).then(function (res) {
        callbackHandler(member.friendCardReceiveStatus, res);
        return res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./src/store/modules/ceshi.js


var ceshi__actions;

// 添加趣味测试





/* harmony default export */ var ceshi = ({
    state: {},
    mutations: {},
    getters: {},
    actions: (ceshi__actions = {
        fungetDetail: function fungetDetail(context, params) {
            return axios_default.a.get(apis["a" /* default */].fungetDetail, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].fungetDetail, res);
                return res.data;
            });
        },
        funquestion: function funquestion(context, params) {
            return axios_default.a.get(apis["a" /* default */].funquestion, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].funquestion, res);
                return res.data;
            });
        },
        funsendAnswer: function funsendAnswer(context, params) {
            return axios_default.a.get(apis["a" /* default */].funsendAnswer, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].funsendAnswer, res);
                return res.data;
            });
        },
        fungetResult: function fungetResult(context, params) {
            return axios_default.a.get(apis["a" /* default */].fungetResult, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].fungetResult, res);
                return res.data;
            });
        },
        getWechatFunDetailRecommends: function getWechatFunDetailRecommends(context, params) {
            return axios_default.a.get(apis["a" /* default */].getWechatFunDetailRecommends, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].getWechatFunDetailRecommends, res);
                return res.data;
            });
        },
        getDailyFunTest: function getDailyFunTest(context, params) {
            return axios_default.a.get(apis["a" /* default */].getDailyFunTest, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].getDailyFunTest, res);
                return res.data;
            });
        },
        getFunScaleDetailList: function getFunScaleDetailList(context, params) {
            return axios_default.a.get(apis["a" /* default */].getFunScaleDetailList, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].getFunScaleDetailList, res);
                return res.data;
            });
        },
        getDailyFunTestList: function getDailyFunTestList(context, params) {
            return axios_default.a.get(apis["a" /* default */].getDailyFunTestList, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].getDailyFunTestList, res);
                return res.data;
            });
        },
        getFunTestList: function getFunTestList(context, params) {
            return axios_default.a.get(apis["a" /* default */].funScales, {
                params: params.params
            }).then(function (res) {
                callbackHandler(apis["a" /* default */].funScales, res);
                return res.data;
            });
        }
    }, defineProperty_default()(ceshi__actions, 'funsendAnswer', function funsendAnswer(context) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            env = _ref.env,
            params = _ref.params;

        return axios_default.a.post(apis["a" /* default */].funsendAnswer, lib_default.a.stringify(params)).then(function (res) {
            return callbackHandler(apis["a" /* default */].funsendAnswer, res);
            return res.data;
        });
    }), defineProperty_default()(ceshi__actions, 'setFavoriteFunScale', function setFavoriteFunScale(context, params) {
        return axios_default.a.get(apis["a" /* default */].setFavoriteFunScale, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].setFavoriteFunScale, res);
            return res.data;
        });
    }), defineProperty_default()(ceshi__actions, 'getFavoriteMessage', function getFavoriteMessage(context, params) {
        return axios_default.a.get(apis["a" /* default */].getFavoriteMessage, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getFavoriteMessage, res);
            return res.data;
        });
    }), defineProperty_default()(ceshi__actions, 'getWechatFunResultRecommends', function getWechatFunResultRecommends(context, params) {
        return axios_default.a.get(apis["a" /* default */].getWechatFunResultRecommends, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getWechatFunResultRecommends, res);
            return res.data;
        });
    }), defineProperty_default()(ceshi__actions, 'getMyFavoriteFunScaleList', function getMyFavoriteFunScaleList(context, params) {
        return axios_default.a.get(apis["a" /* default */].getMyFavoriteFunScaleList, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getMyFavoriteFunScaleList, res);
            return res.data;
        });
    }), defineProperty_default()(ceshi__actions, 'getMyEvaluationList', function getMyEvaluationList(context, params) {
        return axios_default.a.get(apis["a" /* default */].getMyEvaluationList, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getMyEvaluationList, res);
            return res.data;
        });
    }), defineProperty_default()(ceshi__actions, 'getPersonalStats', function getPersonalStats(context, params) {
        return axios_default.a.get(apis["a" /* default */].getPersonalStats, {
            params: params.params
        }).then(function (res) {
            callbackHandler(apis["a" /* default */].getPersonalStats, res);
            return res.data;
        });
    }), ceshi__actions)
});
// CONCATENATED MODULE: ./src/apis/toutiao.js
var toutiao_env = location.host.split('.')[0].match(/(qc|box)\d?/g);
var toutiao_spell = !!toutiao_env ? toutiao_env.length > 0 ? '-' + toutiao_env[0] : '' : '';
var WXDOMAIN = '//wx' + toutiao_spell + '.xinli001.com/',
    toutiao_LXDOMAIN = '//m-lingxi' + toutiao_spell + '.xinli001.com/lingxi/service/',

// 临时域名
// LXDOMAIN = `//promo-lingxi${spell}.xinli001.com/lingxi/service/`,
YIAPI = '//yiapi' + toutiao_spell + '.xinli001.com/v5/yi/',
    toutiao_APIS = {
  // 头条接口
  myRewardList: toutiao_LXDOMAIN + 'promo/myRewardList', // 推广中心-收益列表
  promoQrcodeList: toutiao_LXDOMAIN + 'promo/qrcodeList', // 推广中心-推广码列表
  promoGetUser: toutiao_LXDOMAIN + 'promo/getUser', // 推广中心-获取用户信息
  promoGetQrCode: toutiao_LXDOMAIN + 'promo/getQrCode', // 推广中心-获取推广码
  myReward: toutiao_LXDOMAIN + 'promo/myReward', // 推广中心-收益总览
  getBindToutiaoUsers: toutiao_LXDOMAIN + 'promo/getBindToutiaoUsers', // 推广中心-绑定抖音号昵称
  getRealNameInfo: toutiao_LXDOMAIN + 'promo/getRealNameInfo', // 推广中心-获取实名认证信息
  saveRealNameInfo: toutiao_LXDOMAIN + 'promo/saveRealNameInfo', // 推广中心-提交实名认证信息
  withdrawList: toutiao_LXDOMAIN + 'promo/withdrawList', // 推广中心-提现明细
  withdraw: toutiao_LXDOMAIN + 'promo/withdraw', // 推广中心-申请提现
  promoTeamRewards: toutiao_LXDOMAIN + 'promo/teamRewards', // 推广中心-我的团队收益
  promoBind: toutiao_LXDOMAIN + 'promo/bind', // 推广中心-绑定推荐人
  promoGetPromoCard: toutiao_LXDOMAIN + 'promo/getPromoCard', // 推广中心-生成分销卡
  getStatisticData: toutiao_LXDOMAIN + 'promo/getStatData', // 推广中心-统计数据
  getCooperationPdf: toutiao_LXDOMAIN + 'promo/getCooperationPdf', // 获取推广中心服务协议阅读状态、pdf链接
  promoAuthUrl: toutiao_LXDOMAIN + 'promo/authUrl', // 获取授权码链接
  promoAppList: toutiao_LXDOMAIN + 'promo/miniAppList', // 获取小程序列表

  myRewardListDay: toutiao_LXDOMAIN + 'promo/ad/myRewardList', // 推广中心-每日收益列表
  myRewardDay: toutiao_LXDOMAIN + 'promo/ad/myReward', // 推广中心-每日收益总览
  myTeamRewardDay: toutiao_LXDOMAIN + 'promo/ad/myTeamReward', // 推广中心-每日团队收益总览
  withdrawDay: toutiao_LXDOMAIN + 'promo/ad/withdraw', // 推广中心-每日申请提现
  withdrawListDay: toutiao_LXDOMAIN + 'promo/ad/withdrawList', // 推广中心-提现明细
  admyTeamRewardList: toutiao_LXDOMAIN + 'promo/ad/myTeamRewardList', // 推广中心-团队贡献排行榜

  promoSearchScale: toutiao_LXDOMAIN + 'promo/searchFunScale', // 推广中心-搜索测试
  promoSearchScaleCode: toutiao_LXDOMAIN + 'promo/getPromoCode', // 推广中心-测试生成推广码
  promoUserAuthList: toutiao_LXDOMAIN + 'promo/userAuthList', // 推广中心-多身份的身份列表

  uploadImage: toutiao_LXDOMAIN + 'uploadImg', // 上传图片

  sendValidcode: YIAPI + 'send-validcode.json', // 发送验证码
  validcodeLogin: YIAPI + 'phone-validcode-login.json', // 验证码登陆验证
  getADStatData: toutiao_LXDOMAIN + 'promo/advertReward', // 广告收益明细
  promoPackagePop: toutiao_LXDOMAIN + 'promo/packagePop' // 推广中心资料包弹窗控制

};

/* harmony default export */ var toutiao = (toutiao_APIS);
// CONCATENATED MODULE: ./src/store/modules/toutiao_app.js





/* harmony default export */ var toutiao_app = ({
  state: {
    extendPlatform: 'tiktok'
  },
  mutations: {
    switchPlatform: function switchPlatform(state, platform) {
      state.extendPlatform = platform;
    }
  },
  getters: {
    extendPlatform: function extendPlatform(state) {
      return state.extendPlatform;
    }
  },
  actions: {
    //首页头条收益列表数据
    myRewardList: function myRewardList(context, params) {
      console.log('--- myRewardList ---', params);
      return axios_default.a.get(toutiao.myRewardList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.myRewardList, res);
        return res.data;
      });
    },

    //首页头条收益总览
    myReward: function myReward(context, params) {
      console.log('--- myReward ---', params);
      return axios_default.a.get(toutiao.myReward, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.myReward, res);
        return res.data;
      });
    },

    //首页头条 推广列表
    promoQrcodeList: function promoQrcodeList(context, params) {
      console.log('--- promoQrcodeList ---', params);
      return axios_default.a.get(toutiao.promoQrcodeList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.promoQrcodeList, res);
        return res.data;
      });
    },

    //推广中心-获取用户信息
    promoGetUser: function promoGetUser(context, params) {
      console.log('--- promoGetUser ---', params);
      return axios_default.a.get(toutiao.promoGetUser, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.promoGetUser, res);
        return res.data;
      });
    },

    //推广中心-获取用户信息
    promoGetQrCode: function promoGetQrCode(context, params) {
      console.log('--- promoGetQrCode ---', params);
      return axios_default.a.get(toutiao.promoGetQrCode, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.promoGetQrCode, res);
        return res.data;
      });
    },

    // 推广中心-获取实名认证信息
    getRealNameInfo: function getRealNameInfo(context, params) {
      console.log('--- getRealNameInfo ---', params);
      return axios_default.a.get(toutiao.getRealNameInfo, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.getRealNameInfo, res);
        return res.data;
      });
    },

    // 推广中心-提交实名认证信息
    saveRealNameInfo: function saveRealNameInfo(context) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref.env,
          params = _ref.params,
          callback = _ref.callback;

      console.log('--- saveRealNameInfo ---', params);
      return axios_default.a.post(toutiao.saveRealNameInfo, lib_default.a.stringify(params)).then(function (res) {
        // callbackHandler(APIS.saveRealNameInfo, res, callback, true);
        callback(res.data);
        return res;
      });
    },


    //首页头条收益列表数据 -- 每日
    myRewardListDay: function myRewardListDay(context, params) {
      console.log('--- myRewardListDay ---', params);
      return axios_default.a.get(toutiao.myRewardListDay, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.myRewardListDay, res);
        return res.data;
      });
    },

    //首页头条收益总览 -- 每日
    myRewardDay: function myRewardDay(context, params) {
      console.log('--- myRewardDay ---', params);
      return axios_default.a.get(toutiao.myRewardDay, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.myRewardDay, res);
        return res.data;
      });
    },

    //首页头条团队收益总览 -- 每日
    myTeamRewardDay: function myTeamRewardDay(context, params) {
      console.log('--- myTeamRewardDay ---', params);
      return axios_default.a.get(toutiao.myTeamRewardDay, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.myTeamRewardDay, res);
        return res.data;
      });
    },

    //推广中心-提现列表 -- 每日
    postWithdrawDay: function postWithdrawDay(context) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref2.env,
          params = _ref2.params,
          callback = _ref2.callback;

      console.log('--- withdrawDay ---', params);
      return axios_default.a.post(toutiao.withdrawDay, lib_default.a.stringify(params)).then(function (res) {
        callbackHandler(toutiao.withdrawDay, res);
        return res.data;
      });
    },

    //推广中心-提现列表 -- 每日
    withdrawListDay: function withdrawListDay(context, params) {
      console.log('--- withdrawListDay ---', params);
      return axios_default.a.get(toutiao.withdrawListDay, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.withdrawListDay, res);
        return res.data;
      });
    },

    // 上传图片
    uploadImage: function uploadImage(context) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref3.env,
          params = _ref3.params,
          callback = _ref3.callback;

      console.log('--- uploadImage ---', params);
      return axios_default.a.post(toutiao.uploadImage, params).then(function (res) {
        // callbackHandler(APIS.uploadImage, res, callback, true);
        callback(res.data);
        return res;
      });
    },


    // 发送验证码
    sendValidcode: function sendValidcode(context) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref4.env,
          params = _ref4.params,
          callback = _ref4.callback;

      console.log('--- sendValidcode ---', params);
      return axios_default.a.post(toutiao.sendValidcode, lib_default.a.stringify(params)).then(function (res) {
        YIAPIcallbackHandler(toutiao.sendValidcode, res, callback, true);
        return res;
      });
    },

    // 验证码验证登陆
    validcodeLogin: function validcodeLogin(context) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref5.env,
          params = _ref5.params,
          callback = _ref5.callback;

      console.log('--- validcodeLogin ---', params);
      return axios_default.a.post(toutiao.validcodeLogin, lib_default.a.stringify(params)).then(function (res) {
        YIAPIcallbackHandler(toutiao.validcodeLogin, res, callback, true);
        return res;
      });
    },

    //推广中心-提现列表
    withdrawList: function withdrawList(context, params) {
      console.log('--- withdrawList ---', params);
      return axios_default.a.get(toutiao.withdrawList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.withdrawList, res);
        return res.data;
      });
    },

    //推广中心-申请提现
    postWithdraw: function postWithdraw(context) {
      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref6.env,
          params = _ref6.params,
          callback = _ref6.callback;

      console.log('--- withdraw ---', params);
      return axios_default.a.post(toutiao.withdraw, lib_default.a.stringify(params)).then(function (res) {
        callbackHandler(toutiao.withdraw, res);
        return res.data;
      });
    },

    //推广中心-我的团队收益
    promoTeamRewards: function promoTeamRewards(context, params) {
      console.log('--- promoTeamRewards ---', params);
      return axios_default.a.get(toutiao.promoTeamRewards, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.promoTeamRewards, res);
        return res.data;
      });
    },

    //推广中心-绑定推荐人
    promoBind: function promoBind(context) {
      var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref7.env,
          params = _ref7.params,
          callback = _ref7.callback;

      console.log('--- promoBind ---', params);
      return axios_default.a.post(toutiao.promoBind, lib_default.a.stringify(params)).then(function (res) {
        callbackHandler(toutiao.promoBind, res);
        return res.data;
      });
    },

    // 推广中心-绑定抖音号昵称
    getBindToutiaoUsers: function getBindToutiaoUsers(context, params) {
      console.log('--- getBindToutiaoUsers ---', params);
      return axios_default.a.get(toutiao.getBindToutiaoUsers, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.getBindToutiaoUsers, res);
        return res.data;
      });
    },

    //推广中心-生成分销卡
    promoGetPromoCard: function promoGetPromoCard(context) {
      var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref8.env,
          params = _ref8.params,
          callback = _ref8.callback;

      console.log('--- promoGetPromoCard ---', params);
      return axios_default.a.post(toutiao.promoGetPromoCard, lib_default.a.stringify(params)).then(function (res) {
        callbackHandler(toutiao.promoGetPromoCard, res);
        return res.data;
      });
    },

    //推广中心-统计数据
    getStatisticData: function getStatisticData(context, params) {
      console.log('--- getStatisticData ---', params);
      return axios_default.a.get(toutiao.getStatisticData, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.getStatisticData, res);
        return res.data;
      });
    },

    // 获取推广中心服务协议阅读状态、pdf链接
    getCooperationPdf: function getCooperationPdf(context, params) {
      console.log('--- getCooperationPdf ---', params);
      return axios_default.a.get(toutiao.getCooperationPdf, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.getCooperationPdf, res);
        return res.data;
      });
    },

    // 获取授权码链接
    promoAuthUrl: function promoAuthUrl(context, params) {
      console.log('--- promoAuthUrl ---', params);
      return axios_default.a.get(toutiao.promoAuthUrl, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.promoAuthUrl, res);
        return res.data;
      });
    },

    // 获取授权码链接
    getADStatData: function getADStatData(context, params) {
      console.log('--- getADStatData ---', params);
      return axios_default.a.get(toutiao.getADStatData, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.getADStatData, res);
        return res.data;
      });
    },

    // 获取小程序列表
    promoAppList: function promoAppList(context, params) {
      // console.log('--- promoAppList ---', params);
      return axios_default.a.get(toutiao.promoAppList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.promoAuthUrl, res);
        return res.data;
      });
    },

    //推广中心-团队贡献排行榜
    admyTeamRewardList: function admyTeamRewardList(context, params) {
      console.log('--- admyTeamRewardList ---', params);
      return axios_default.a.get(toutiao.admyTeamRewardList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.admyTeamRewardList, res);
        return res.data;
      });
    },

    //推广中心-获取资料包
    promoPackagePop: function promoPackagePop(context, params) {
      console.log('--- promoPackagePop ---', params);
      return axios_default.a.get(toutiao.promoPackagePop, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.promoPackagePop, res);
        return res.data;
      });
    },

    //推广中心-搜索测试
    promoSearchScale: function promoSearchScale(context, params) {
      console.log('--- promoSearchScale ---', params);
      return axios_default.a.get(toutiao.promoSearchScale, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.promoSearchScale, res);
        return res.data;
      });
    },

    //推广中心-测试生成推广码
    promoSearchScaleCode: function promoSearchScaleCode(context, params) {
      console.log('--- promoSearchScaleCode ---', params);
      return axios_default.a.get(toutiao.promoSearchScaleCode, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.promoSearchScaleCode, res);
        return res.data;
      });
    },

    //推广中心-测试生成推广码
    promoUserAuthList: function promoUserAuthList(context, params) {
      // console.log('--- promoUserAuthList ---', params);
      return axios_default.a.get(toutiao.promoUserAuthList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(toutiao.promoUserAuthList, res);
        return res.data;
      });
    }
  }
});
// EXTERNAL MODULE: ./src/apis/notLogin.js
var notLogin = __webpack_require__("9WgL");

// EXTERNAL MODULE: ./src/apis/weibo.js
var weibo = __webpack_require__("HFx8");

// CONCATENATED MODULE: ./src/store/modules/notLogin.js






/* harmony default export */ var modules_notLogin = ({
  state: {},
  mutations: {},
  getters: {},
  actions: {
    // 免登+先测试后付费（for微博） 获取测评价格
    notloginGetScalePrice: function notloginGetScalePrice(context, params) {
      console.log('--- getScalePrice ---', params);
      return axios_default.a.get(notLogin["a" /* default */].getScalePrice, {
        params: params.params
      }).then(function (res) {
        callbackHandler(notLogin["a" /* default */].getScalePrice, res);
        return res.data;
      });
    },

    // 免登+先测试后付费支付接口
    notloginPay: function notloginPay(context, _ref) {
      var API = _ref.API,
          params = _ref.params;

      return axios_default.a.get(API, {
        params: params
      }).then(function (res) {
        callbackHandler(notLogin["a" /* default */].payOrder, res);
        return res.data;
      });
    },
    notloginGetQrcode: function notloginGetQrcode(context, params) {
      console.log('--- getQrcode ---', params);
      return axios_default.a.get(notLogin["a" /* default */].getQrcode, {
        params: params.params
      }).then(function (res) {
        callbackHandler(notLogin["a" /* default */].getQrcode, res);
        return res.data;
      });
    },

    // 免登+先测试后付费（for微博） 获取测评价格
    availableActivityCard: function availableActivityCard(context, params) {
      return axios_default.a.get(notLogin["a" /* default */].availableActivityCard, {
        params: params.params
      }).then(function (res) {
        callbackHandler(notLogin["a" /* default */].availableActivityCard, res);
        return res.data;
      });
    },
    handleWeiboAuth: function handleWeiboAuth(context, params) {
      return axios_default.a.get(weibo["a" /* default */].weiboAuth, {
        params: params.params
      }).then(function (res) {
        callbackHandler(weibo["a" /* default */].weiboAuth, res);
        return res.data;
      });
    },
    validatePhone: function validatePhone(context, params) {
      return axios_default.a.post(notLogin["a" /* default */].validatePhone, lib_default.a.stringify(params.params)).then(function (res) {
        callbackHandler(notLogin["a" /* default */].validatePhone, res);
        return res.data;
      });
    },
    cepingVipBindPhone: function cepingVipBindPhone(context, params) {
      return axios_default.a.post(notLogin["a" /* default */].cepingVipBindPhone, lib_default.a.stringify(params.params)).then(function (res) {
        callbackHandler(notLogin["a" /* default */].cepingVipBindPhone, res);
        return res.data;
      });
    },
    cepingVipBindPhone4: function cepingVipBindPhone4(context, params) {
      return axios_default.a.post(notLogin["a" /* default */].cepingVipBindPhone4, lib_default.a.stringify(params.params)).then(function (res) {
        callbackHandler(notLogin["a" /* default */].cepingVipBindPhone4, res);
        return res.data;
      });
    },
    cepingVipBindTfPhone4: function cepingVipBindTfPhone4(context, params) {
      return axios_default.a.post(notLogin["a" /* default */].cepingVipBindTfPhone4, lib_default.a.stringify(params.params)).then(function (res) {
        callbackHandler(notLogin["a" /* default */].cepingVipBindTfPhone4, res);
        return res.data;
      });
    },
    searchOrderDoAfterBuyNew: function searchOrderDoAfterBuyNew(context, params) {
      return axios_default.a.get(notLogin["a" /* default */].searchOrderDoAfterBuyNew, { params: params.params }).then(function (res) {
        callbackHandler(notLogin["a" /* default */].searchOrderDoAfterBuyNew, res);
        return res.data;
      });
    },
    existOrder: function existOrder(context, params) {
      return axios_default.a.get(notLogin["a" /* default */].existOrder, { params: params.params }).then(function (res) {
        callbackHandler(notLogin["a" /* default */].existOrder, res);
        return res.data;
      });
    },


    // 获取投放分流类型
    getSplitFlowType: function getSplitFlowType(context, params) {
      return axios_default.a.get(notLogin["a" /* default */].splitFlowType, {
        params: params.params
      }).then(function (res) {
        callbackHandler(notLogin["a" /* default */].splitFlowType, res);
        return res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./src/apis/houseTreePeople.js
var houseTreePeople_env = location.host.split('.')[0].match(/(qc|box)\d?/g);
var houseTreePeople_spell = !!houseTreePeople_env ? houseTreePeople_env.length > 0 ? '-' + houseTreePeople_env[0] : '' : '';
var houseTreePeople_CPAPI = '//m-cpapi' + houseTreePeople_spell + '.xinli001.com/cp/service/',
    houseTreePeople_HCP = '//hcp' + houseTreePeople_spell + '.xinli001.com/',
    houseTreePeople_LXDOMAIN = houseTreePeople_spell ? '//lingxi' + houseTreePeople_spell + '.xinli001.com/lingxi/service/' : '//m-lingxi' + houseTreePeople_spell + '.xinli001.com/lingxi/service/',
    houseTreePeople_APIS = {
  htpViewReport: houseTreePeople_CPAPI + 'fsr/viewReport', // 查看房树人测评报告
  scaleModulesMsg: houseTreePeople_CPAPI + 'report/getScaleModulesMsg', // 获取报告模块 id
  htpUploadImage: houseTreePeople_HCP + 'fsr/uploadImage', //  上传房树人测评图片
  fetchPoster: houseTreePeople_HCP + 'fsr/fetchPoster', //  获取房树人分享海报
  fetchTeacher: houseTreePeople_HCP + 'fsr/fetchTeacher', //  获取房树人咨询师资料
  authHouseTreeHuman: houseTreePeople_LXDOMAIN + 'houseTreeHuman/auth', //房树人报告页授权接口
  generalUploadImage: houseTreePeople_HCP + 'common/uploadImage/bindAccountId', //  上传测试的图片
  yzrViewReport: houseTreePeople_CPAPI + 'yzr/viewReport' // 查看雨中人测评报告
};

/* harmony default export */ var houseTreePeople = (houseTreePeople_APIS);
// CONCATENATED MODULE: ./src/store/modules/houseTreePeople.js





/* harmony default export */ var modules_houseTreePeople = ({
  state: {},
  mutations: {},
  getters: {},
  actions: {
    getHtpViewReport: function getHtpViewReport(context, params) {
      return axios_default.a.get(houseTreePeople.htpViewReport, {
        params: params.params
      }).then(function (res) {
        callbackHandler(houseTreePeople.htpViewReport, res);
        return res.data;
      });
    },
    htpUploadImage: function htpUploadImage(context) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref.env,
          params = _ref.params,
          callback = _ref.callback;

      return axios_default.a.post(houseTreePeople.htpUploadImage, params).then(function (res) {
        callbackHandler(houseTreePeople.htpUploadImage, res);
        return res.data;
      });
    },
    getHtpPoster: function getHtpPoster(context, params) {
      return axios_default.a.get(houseTreePeople.fetchPoster, {
        params: params.params
      }).then(function (res) {
        callbackHandler(houseTreePeople.fetchPoster, res);
        return res.data;
      });
    },
    getHtpTeacher: function getHtpTeacher(context, params) {
      return axios_default.a.get(houseTreePeople.fetchTeacher, {
        params: params.params
      }).then(function (res) {
        callbackHandler(houseTreePeople.fetchTeacher, res);
        return res.data;
      });
    },
    getScaleModulesMsg: function getScaleModulesMsg(context) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref2.env,
          params = _ref2.params;

      var api = houseTreePeople.scaleModulesMsg;
      return axios_default.a.get(api, { params: params }).then(function (res) {
        callbackHandler(api, res);
        return res.data;
      });
    },
    fetchAuthHouseTreeHuman: function fetchAuthHouseTreeHuman(context, params) {
      return axios_default.a.get(houseTreePeople.authHouseTreeHuman, {
        params: params.params
      }).then(function (res) {
        callbackHandler(houseTreePeople.authHouseTreeHuman, res);
        return res.data;
      });
    },
    generalUploadImage: function generalUploadImage(context) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref3.env,
          params = _ref3.params,
          callback = _ref3.callback;

      return axios_default.a.post(houseTreePeople.generalUploadImage, params).then(function (res) {
        callbackHandler(houseTreePeople.generalUploadImage, res);
        return res.data;
      });
    },
    getYzrViewReport: function getYzrViewReport(context, params) {
      return axios_default.a.get(houseTreePeople.yzrViewReport, {
        params: params.params
      }).then(function (res) {
        callbackHandler(houseTreePeople.yzrViewReport, res);
        return res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./src/apis/activity.js
var activity_env = location.host.split('.')[0].match(/(qc|box)\d?/g);
var activity_spell = !!activity_env ? activity_env.length > 0 ? '-' + activity_env[0] : '' : '';
var activity_CPAPI = '//m-cpapi' + activity_spell + '.xinli001.com/cp/service/',
    activity_HCP = '//hcp' + activity_spell + '.xinli001.com/',
    activity_LXDOMAIN = activity_spell ? '//lingxi' + activity_spell + '.xinli001.com/lingxi/service/' : '//m-lingxi' + activity_spell + '.xinli001.com/lingxi/service/',
    activity_APIS = {
    // 2020双十一活动
    doubleElevenScalePackages: activity_LXDOMAIN + 'doubleEleven/getScalePackages', // 指定解决方案列表
    doubleElevenScaleCombos: activity_LXDOMAIN + 'doubleEleven/getScaleCombos', // 必测心理测评套餐
    doubleElevenScaleRankList: activity_LXDOMAIN + 'doubleEleven/getScaleRankList', // 畅销测评排行榜
    doubleElevenScalePricePlan: activity_LXDOMAIN + 'doubleEleven/getScalePricePlan', // 获取价格方案接口
    doubleElevenConsultPackages: activity_LXDOMAIN + 'doubleEleven/getConsultPackages', // 咨询师价格方案列表、购买状态
    doubleElevenReceiveCoupon: activity_LXDOMAIN + 'doubleEleven/receive' // 领优惠券接口
};

/* harmony default export */ var activity = (activity_APIS);
// CONCATENATED MODULE: ./src/store/modules/activity.js





/* harmony default export */ var modules_activity = ({
    state: {},
    mutations: {},
    getters: {},
    actions: {
        getDEConsultReceiveCoupon: function getDEConsultReceiveCoupon(context, params) {
            return axios_default.a.get(activity.doubleElevenReceiveCoupon, {
                params: params.params
            }).then(function (res) {
                callbackHandler(activity.doubleElevenReceiveCoupon, res);
                return res.data;
            });
        },
        getDEConsultPackages: function getDEConsultPackages(context, params) {
            return axios_default.a.get(activity.doubleElevenConsultPackages, {
                params: params.params
            }).then(function (res) {
                callbackHandler(activity.doubleElevenConsultPackages, res);
                return res.data;
            });
        },
        getDEScalePricePlan: function getDEScalePricePlan(context, params) {
            return axios_default.a.get(activity.doubleElevenScalePricePlan, {
                params: params.params
            }).then(function (res) {
                callbackHandler(activity.doubleElevenScalePricePlan, res);
                return res.data;
            });
        },
        getDEScaleRankList: function getDEScaleRankList(context, params) {
            return axios_default.a.get(activity.doubleElevenScaleRankList, {
                params: params.params
            }).then(function (res) {
                callbackHandler(activity.doubleElevenScaleRankList, res);
                return res.data;
            });
        },
        getDEScaleCombos: function getDEScaleCombos(context, params) {
            return axios_default.a.get(activity.doubleElevenScaleCombos, {
                params: params.params
            }).then(function (res) {
                callbackHandler(activity.doubleElevenScaleCombos, res);
                return res.data;
            });
        },
        getDEScalePackages: function getDEScalePackages(context, params) {
            return axios_default.a.get(activity.doubleElevenScalePackages, {
                params: params.params
            }).then(function (res) {
                callbackHandler(activity.doubleElevenScalePackages, res);
                return res.data;
            });
        }
    }
});
// EXTERNAL MODULE: ./src/apis/cike.js
var cike = __webpack_require__("ZQsr");

// CONCATENATED MODULE: ./src/store/modules/consult.js







/* harmony default export */ var consult = ({
  state: {
    consultWaitDays: 0, // 咨询师等待的天数
    consultWaitHours: 0, // 咨询师等待的小时数
    bindMobileStatus: undefined, // 手机号绑定状态
    bindMobileNumber: '' // 绑定手机号
  },
  mutations: {
    setConsultWaitDays: function setConsultWaitDays(state, val) {
      state.consultWaitDays = val;
    },
    setConsultWaitHours: function setConsultWaitHours(state, val) {
      state.consultWaitHours = val;
    },
    setBindMobileStatus: function setBindMobileStatus(state, val) {
      state.bindMobileStatus = val;
    },
    setBindMobileNumber: function setBindMobileNumber(state, val) {
      state.bindMobileNumber = val;
    }
  },
  getters: {
    consultWaitDays: function consultWaitDays(state) {
      return state.consultWaitDays;
    },
    consultWaitHours: function consultWaitHours(state) {
      return state.consultWaitHours;
    },
    bindMobileStatus: function bindMobileStatus(state) {
      return state.bindMobileStatus;
    },
    bindMobileNumber: function bindMobileNumber(state) {
      return state.bindMobileNumber;
    }
  },
  actions: {
    notLoginCheckBindMobile: function notLoginCheckBindMobile(context, params) {
      return axios_default.a.get(apis["a" /* default */].notLoginCheckBindMobile, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].notLoginCheckBindMobile, res);
        return res.data;
      });
    },
    checkBindMobile: function checkBindMobile(context, params) {
      return axios_default.a.get(apis["a" /* default */].checkBindMobile, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].checkBindMobile, res);
        return res.data;
      });
    },
    getConsultToken: function getConsultToken(context, params) {
      return axios_default.a.get(apis["a" /* default */].getConsultToken, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].getConsultToken, res);
        return res.data;
      });
    },
    consultSendValidcode: function consultSendValidcode(context, params) {
      return axios_default.a.get(apis["a" /* default */].consultSendValidcode, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].consultSendValidcode, res);
        return res.data;
      });
    },
    notLoginconsultBindUserMobile: function notLoginconsultBindUserMobile(context, params) {
      return axios_default.a.get(apis["a" /* default */].notLoginconsultBindUserMobile, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].notLoginconsultBindUserMobile, res);
        return res.data;
      });
    },
    consultBindUserMobile: function consultBindUserMobile(context, _ref) {
      var API = _ref.API,
          params = _ref.params;

      return axios_default.a.get(API, {
        params: params
      }).then(function (res) {
        callbackHandler(API, res);
        return res.data;
      });
    },
    syncByUserKey: function syncByUserKey(context, params) {
      return axios_default.a.post(apis["a" /* default */].syncByUserKey, lib_default.a.stringify(params.params)).then(function (res) {
        callbackHandler(apis["a" /* default */].syncByUserKey, res);
        return res.data;
      });
    },
    syncByOrder: function syncByOrder(context, params) {
      return axios_default.a.post(apis["a" /* default */].syncByOrder, lib_default.a.stringify(params.params)).then(function (res) {
        callbackHandler(apis["a" /* default */].syncByOrder, res);
        return res.data;
      });
    },
    syncByOrderNo: function syncByOrderNo(context, params) {
      return axios_default.a.post(apis["a" /* default */].syncByOrderNo, lib_default.a.stringify(params.params)).then(function (res) {
        callbackHandler(apis["a" /* default */].syncByOrderNo, res);
        return res.data;
      });
    },
    fetchConsultantInfos: function fetchConsultantInfos(context, params) {
      return new promise_default.a(function (resolve, reject) {
        axios_default.a.get(apis["a" /* default */].fetchConsultantInfos, {
          params: params.params
        }).then(function (res) {
          callbackHandler(apis["a" /* default */].fetchConsultantInfos, res);
          resolve(res.data);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    fetchConsultPrices: function fetchConsultPrices(context, params) {
      return new promise_default.a(function (resolve, reject) {
        axios_default.a.get(apis["a" /* default */].fetchConsultPrices, {
          params: params.params
        }).then(function (res) {
          callbackHandler(apis["a" /* default */].fetchConsultPrices, res);
          resolve(res.data);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    fecthNotCompleteCount: function fecthNotCompleteCount(context, params) {
      return axios_default.a.get(cike["a" /* default */].fecthNotCompleteCount, {
        params: params.params
      }).then(function (res) {
        callbackHandler(cike["a" /* default */].fecthNotCompleteCount, res);
        return res.data;
      });
    },
    fecthConsultStatus: function fecthConsultStatus(context, params) {
      return axios_default.a.get(apis["a" /* default */].consultStatus, {
        params: params.params
      }).then(function (res) {
        callbackHandler(apis["a" /* default */].consultStatus, res);
        return res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./src/apis/careerCard.js
var careerCard_env = location.host.split('.')[0].match(/(qc|box)\d?/g);
var careerCard_spell = !!careerCard_env ? careerCard_env.length > 0 ? '-' + careerCard_env[0] : '' : '';
var careerCard_WXDOMAIN = '//wx' + careerCard_spell + '.xinli001.com/',
    careerCard_LXDOMAIN = careerCard_spell ? '//lingxi' + careerCard_spell + '.xinli001.com/lingxi/service/' : '//m-lingxi' + careerCard_spell + '.xinli001.com/lingxi/service/',
    careerCard_YIAPI = '//yiapi' + careerCard_spell + '.xinli001.com/v5/yi/',
    careerCard_HCP = '//hcp' + careerCard_spell + '.xinli001.com/',
    careerCard_APIS = {
  // 生涯卡模块接口 
  lifeCardCardList: careerCard_HCP + 'lifeCard/cardList', //获取生涯卡列表
  lifeCardCommitAnswer: careerCard_HCP + 'lifeCard/commitAnswer', //生涯卡-提交答案
  lifeCardViewReport: careerCard_HCP + 'lifeCard/viewReport', //生涯卡-获取报告
  getTeacher: careerCard_HCP + 'lifeCard/getTeacher' //生涯卡-获取咨询老师
};

/* harmony default export */ var careerCard = (careerCard_APIS);
// CONCATENATED MODULE: ./src/store/modules/careercard.js





/* harmony default export */ var careercard = ({
  state: {},
  mutations: {},
  getters: {},
  actions: {
    //获取生涯卡答题页
    lifeCardCardList: function lifeCardCardList(context, params) {
      return axios_default.a.get(careerCard.lifeCardCardList, {
        params: params.params
      }).then(function (res) {
        callbackHandler(careerCard.lifeCardCardList, res);
        return res.data;
      });
    },

    //提交生涯卡答案
    lifeCardCommitAnswer: function lifeCardCommitAnswer(context) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          env = _ref.env,
          params = _ref.params;

      return axios_default.a.post(careerCard.lifeCardCommitAnswer, lib_default.a.stringify(params, { indices: false })).then(function (res) {
        callbackHandler(careerCard.lifeCardCommitAnswer, res);
        return res.data;
      });
    },

    //获取生涯卡报告
    lifeCardViewReport: function lifeCardViewReport(context, params) {
      return axios_default.a.get(careerCard.lifeCardViewReport, {
        params: params.params
      }).then(function (res) {
        callbackHandler(careerCard.lifeCardViewReport, res);
        return res.data;
      });
    },

    //获取生涯卡报告
    getTeacher: function getTeacher(context, params) {
      return axios_default.a.get(careerCard.getTeacher, {
        params: params.params
      }).then(function (res) {
        callbackHandler(careerCard.getTeacher, res);
        return res.data;
      });
    }
  }
});
// EXTERNAL MODULE: ./src/apis/datura.js
var datura = __webpack_require__("qP/X");

// CONCATENATED MODULE: ./src/store/modules/datura.js




/* harmony default export */ var modules_datura = ({
  state: {},
  mutations: {},
  getters: {},
  actions: {
    getCommitAnswers: function getCommitAnswers(context, params) {
      return axios_default.a.post(datura["a" /* default */].daturaCommitAnswers, params).then(function (res) {
        callbackHandler(datura["a" /* default */].daturaCommitAnswers, res);
        return res.data;
      });
    },
    getDaturaReport: function getDaturaReport(context, params) {
      return axios_default.a.get(datura["a" /* default */].daturaReport, {
        params: params.params
      }).then(function (res) {
        callbackHandler(datura["a" /* default */].daturaReport, res);
        return res.data;
      });
    }
  }
});
// CONCATENATED MODULE: ./src/store/store.js


var store__getters;

/*
 * @Author: hasee
 * @Date:   2016-12-12 18:22:32
 * @Last Modified by:   hasee
 * @Last Modified time: 2017-01-16 18:11:43
 */

// Vuex





vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);



// modules


















var store = new vuex_esm["a" /* default */].Store({
  modules: {
    answer: answer,
    ad: ad,
    show: show,
    search: search,
    report: report,
    comment: comment,
    gift: gift,
    vip: modules_vip,
    member: modules_member,
    ceshi: ceshi,
    toutiao_app: toutiao_app,
    notLogin: modules_notLogin,
    houseTreePeople: modules_houseTreePeople,
    activity: modules_activity,
    consult: consult,
    careercard: careercard,
    datura: modules_datura
  },

  state: {
    // 是否微信小程序
    isWxApp: false,
    // 微信小程序sessionKey
    wxMiniAppSessionKey: '',
    // 微信config数据
    wxConfig: {},
    // 渠道ID
    channelId: null,
    // 渠道信息
    channelConfig: {},
    // 用户信息
    userInfo: {},
    /**
     * vip信息
     * vipInfo.vipIdentity|0--1.0会员, 1--2.0新会员, 2--2.0续费会员（1.0续费到2.0）, 3--3.0新会员, 4--3.0续费会员（2.0续费到3.0）, 5--4.0新会员, 6--4.0续费会员（3.0续费到4.0）
     * vipInfo.status|会员状态，0=禁止，1=正常，2=过期|
     * vipInfo.vipBuyType|会员购买测评类型  0-- 0元测  1--五折测 2--普通购买类型|
     */
    vipInfo: {},
    // 用来做题和报告页的时候记录cookie的，在main.js监视router.query设置
    uid: null,
    // 全局参数
    GLOBALLOCK: false,
    LOADING: false,
    LOADINGTEXT: '',
    TOASTTEXT: '',
    TOASTSTATUS: '',
    TOASTTIME: 1300,
    // 判断报告页显示不显示各部件
    isReportRecomendShowed: '',
    isReportShareShowed: '',
    isSendEmailShowed: '',
    // isVip: 0, //0 没开通vip 1 是vip 2 vip过期
    couponDialogData: '', //全局优惠券弹窗
    durationTime: 60,
    reportCousultDialog: "",
    isVoicepaly: false,
    vipPopWindow: {},
    adsense: [],
    showPopWindowStatus: false,
    sourceId: null,
    woNiuUnique: null,
    tuiliyiKey: null
  },
  mutations: {
    setWxMiniAppSessionKey: function setWxMiniAppSessionKey(state, value) {
      state.wxMiniAppSessionKey = value;
    },
    setIsWxApp: function setIsWxApp(state, tof) {
      state.isWxApp = !!tof;
    },
    setWxConfig: function setWxConfig(state, config) {
      state.wxConfig = config;
    },

    // doWxConfig(state, errcallback) {
    //     console.info('微信config');
    //     wxConfig(state.wxConfig, errcallback);
    // },
    setChannelId: function setChannelId(state, id) {
      if (id == undefined) return;
      if (id == 'null') {
        state.channelId = 1;
      } else {
        state.channelId = id * 1;
      }
    },
    setYxyid: function setYxyid(state, id) {
      if (id == undefined) return;
      if (id == 'null') {
        state.yxyid = "";
      } else {
        state.yxyid = id * 1;
      }
    },
    setChannelConfig: function setChannelConfig(state, config) {
      state.channelConfig = config;
    },
    setUserInfo: function setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setUID: function setUID(state, uid) {
      if (uid != undefined) {
        state.uid = uid + '';
      }
    },
    setGLOBALLOCK: function setGLOBALLOCK(state, tof) {
      state.GLOBALLOCK = tof;
    },
    setLOADING: function setLOADING(state, tof) {
      state.LOADING = !!tof;
    },
    setLOADINGTEXT: function setLOADINGTEXT(state, str) {
      state.LOADINGTEXT = '' + str;
    },
    setTOASTTEXT: function setTOASTTEXT(state, payload) {
      if (typeof payload == 'string') {
        state.TOASTTEXT = '' + payload;
        state.TOASTSTATUS = '';
        state.TOASTTIME = 1300;
      } else {
        var str = payload.str,
            status = payload.status,
            time = payload.time;

        state.TOASTTEXT = str ? str : '';
        state.TOASTSTATUS = status ? status : '';
        state.TOASTTIME = time ? time : 1300;
      }
    },

    // 报告页残留
    setIsReportRecomendShowed: function setIsReportRecomendShowed(state, payload) {
      state.isReportRecomendShowed = payload;
    },
    setIsReportShareShowed: function setIsReportShareShowed(state, payload) {
      state.isReportShareShowed = payload;
    },
    setIsSendEmailShowed: function setIsSendEmailShowed(state, payload) {
      state.isSendEmailShowed = payload;
    },
    setCouponDialogData: function setCouponDialogData(state, content) {
      console.log('-----setCouponDialogData');
      console.log(content);
      state.couponDialogData = content;
    },
    setVoicepaly: function setVoicepaly(state, payload) {
      state.isVoicepaly = payload;
    },
    setDurationTime: function setDurationTime(state, payload) {
      state.durationTime = payload;
    },
    setReportCousultDialog: function setReportCousultDialog(state, payload) {
      state.reportCousultDialog = payload;
    },
    setVipInfo: function setVipInfo(state, vipInfo) {
      state.vipInfo = vipInfo;
    },
    setVipPopWindow: function setVipPopWindow(state, config) {
      state.vipPopWindow = config;
      if (!!state.vipPopWindow.pop) {
        state.showPopWindowStatus = true;
      }
    },
    setAdsense: function setAdsense(state, config) {
      state.adsense = config;
    },
    setShowPopWindowStatus: function setShowPopWindowStatus(state, payload) {
      state.showPopWindowStatus = payload;
    },
    setSourceId: function setSourceId(state, payload) {
      state.sourceId = payload;
    },
    setWoNiuUnique: function setWoNiuUnique(state, payload) {
      state.woNiuUnique = payload;
    },
    setTuiliyiKey: function setTuiliyiKey(state, payload) {
      state.tuiliyiKey = payload;
      console.log('@Store setWoNiuUnique tuiliyiKey', state.tuiliyiKey);
    }
  },
  getters: (store__getters = {}, defineProperty_default()(store__getters, 'CHANNELID', function undefined(state) {
    return state.channelId * 1;
  }), defineProperty_default()(store__getters, 'CHANNEL_YXL_STATEMENT', function undefined(state) {
    return state.channelConfig.hasBandStament;
  }), defineProperty_default()(store__getters, 'CHANNEL_ERROR_TEXT', function undefined(state) {
    return !state.channelConfig.errorPageText ? '\u70B9\u51FB\u4E0B\u65B9\u6309\u94AE\uFF0C\u5728<span class="black">\u300C\u6211\u7684\u6D4B\u8BC4\u300D-\u300C\u672A\u5B8C\u6210\u300D</span>\u627E\u56DE\u672C\u6D4B\u8BC4\u7EE7\u7EED\u7B54\u9898\uFF1B\u6216\u8005\u8FDB\u5165\u516C\u4F17\u53F7\uFF0C\u8054\u7CFB\u5BA2\u670D\u3002' : state.channelConfig.errorPageText;
  }), defineProperty_default()(store__getters, 'CHANNEL_ERROR_URL', function undefined(state) {
    return state.channelConfig.errorPageUrl;
  }), defineProperty_default()(store__getters, 'CHANNEL_USERTYPE', function undefined(state) {
    return state.channelConfig.userType;
  }), defineProperty_default()(store__getters, 'CHANNEL_REPORT_MICRO_TEST', function undefined(state) {
    return !!state.channelConfig.whetherInvokePsychoInterface;
  }), defineProperty_default()(store__getters, 'CHANNEL_REPORT_SHOW_RECOMMEND', function undefined(state) {
    return !!state.channelConfig.whetherShowRecommend;
  }), defineProperty_default()(store__getters, 'CHANNEL_REPORT_SHOW_SEND_EMAIL', function undefined(state) {
    return !!state.channelConfig.whetherShowSendEmail && state.channelId != 568;
  }), defineProperty_default()(store__getters, 'CHANNEL_REPORT_SHOW_SHARE', function undefined(state) {
    return !!state.channelConfig.whetherShowShare && state.channelId != 568;
  }), defineProperty_default()(store__getters, 'CHANNEL_DISTRIBBUTION', function undefined(state) {
    return !!state.channelConfig.channelDistribution;
  }), defineProperty_default()(store__getters, 'CHANNEL_INTERNALCHANNEL', function undefined(state) {
    return !!state.channelConfig.internalChannel;
  }), defineProperty_default()(store__getters, 'CHANNEL_EXTERNALCHANNEL', function undefined(state) {
    return state.channelConfig.channelType == 3;
  }), defineProperty_default()(store__getters, 'CHANNEL_REPORT_SHOWQRCODE', function undefined(state) {
    // 判断内容是否为空
    if (!state.channelConfig.reportPageQrcodeUrl) {
      // 二维码为空，不显示
      return false;
    } else {
      return true;
    }
  }), defineProperty_default()(store__getters, 'CHANNEL_BUYMODE', function undefined(state) {
    return state.channelConfig.buyMode ? state.channelConfig.buyMode : 0;
  }), defineProperty_default()(store__getters, 'CHANNEL_AVOID_PAY_URL', function undefined(state) {
    return state.channelConfig.registeredAddress;
  }), defineProperty_default()(store__getters, 'CHANNEL_REPORT_QRCODE_URL', function undefined(state) {
    return state.channelConfig.reportPageQrcodeUrl;
  }), defineProperty_default()(store__getters, 'CHANNEL_REPORT_QRCODE_DESC', function undefined(state) {
    return state.channelConfig.reportPageQrcodeDesc;
  }), defineProperty_default()(store__getters, 'CHANNEL_CHANNELNAME', function undefined(state) {
    return state.channelConfig.name;
  }), defineProperty_default()(store__getters, 'CHANNEL_REPORT_PSYCHOINTERFACE', function undefined(state) {
    return !!state.channelConfig.whetherInvokePsychoInterface;
  }), defineProperty_default()(store__getters, 'CHANNEL_CHANNELTYPE', function undefined(state) {
    return state.channelConfig.channelType == 1 || state.channelConfig.channelType == 2 ? true : false;
  }), defineProperty_default()(store__getters, 'CHANNEL_NOT_LOGIN', function undefined(state) {
    return state.channelConfig.channelType == 8 ? true : false;
  }), defineProperty_default()(store__getters, 'USER_NICKNAME', function undefined(state) {
    return state.userInfo.nickname ? state.userInfo.nickname : '';
  }), defineProperty_default()(store__getters, 'USER_AVATAR', function undefined(state) {
    return state.userInfo.avatar ? state.userInfo.avatar : '';
  }), defineProperty_default()(store__getters, 'USER_TRADETYPE', function undefined(state) {
    if (state.channelConfig.channelType == 8) {
      return ['ALI_PAY_WAP', 'WX_H5_PAY'];
    } else if (state.channelId === 568) {
      return state.userInfo.tradeType ? state.userInfo.tradeType.filter(function (item) {
        return item.includes('WX');
      }) : [];
    } else {
      return state.userInfo.tradeType;
    }
  }), defineProperty_default()(store__getters, 'COOKIE_UID', function undefined(state) {
    return state.uid;
  }), defineProperty_default()(store__getters, 'COUPONDIALOGDATA', function undefined(state) {
    return state.couponDialogData;
  }), defineProperty_default()(store__getters, 'isVip', function undefined(state) {
    if (!state.vipInfo.status) {
      return 0;
    } else {
      return state.vipInfo.status;
    }
  }), store__getters),
  actions: {
    // 获取微信JSSDK初始化config信息并初始化
    getWechatData: function getWechatData(context, params) {
      if (params.channelId == 2278 || params.channelId == 2310) {
        return;
      }
      var o = {
        url: location.href.split('#')[0],
        channelId: params.channelId
      };
      var query = params.query;
      // 某些渠道（后端过滤）通过 userKey 变更 sdk 的 appId
      if (query.userKey) {
        o.userKey = query.userKey;
      }
      if (query.payUserKey) {
        o.payUserKey = query.payUserKey;
      }

      return axios_default.a.get(apis["a" /* default */].wechatData, {
        params: o
      }).then(function (res) {
        if (res.data.code * 1 == 1) {
          context.commit('setWxConfig', res.data.data);
        }
      });
    },

    // 获取用户信息
    pullUserInfo: function pullUserInfo(context, params) {
      var url = void 0;
      if (context.state.isWxApp) {
        url = apis["a" /* default */].geWxAppUserInfo;
      } else if ([513, 514].includes(+context.state.channelId)) {
        url = apis["a" /* default */].getPlatformUserInfo;
        if (!params.channelId) {
          params.channelId = context.state.channelId;
        }
      } else {
        url = apis["a" /* default */].getUserInfo;
      }
      return axios_default.a.get(url, {
        params: params.params
      }).then(function (res) {
        context.commit('setUserInfo', res.data.data);
        callbackHandler(url, res, params.callback);
        try {
          if (res.data.dat) {
            zhuge.identify(res.data.data.userKey, {
              name: res.data.data.nickname
            });
          }
        } catch (err) {
          console.log(err);
        }
        return res;
      });
    },

    // 从平台userId获取用户信息
    getUserKeyFromPlatfrom: function getUserKeyFromPlatfrom(context, params) {
      return axios_default.a.get(apis["a" /* default */].getUserInfoFromPlatfrom, { params: params }).then(function (_ref) {
        var response = _ref.data;
        var code = response.code,
            data = response.data;

        if (+code === 1) {
          return data.userKey;
        }
      });
    },

    // 获取渠道信息
    getChannelMsg: function getChannelMsg(context, params) {
      if (params.params.channelId == null) {
        return;
      }

      return axios_default.a.get(apis["a" /* default */].channelConfig, {
        params: params.params
      }).then(function (res) {
        var RES = res.data;
        var DATA = RES.data ? RES.data : {};
        if (RES.code * 1 == 1 && RES.data) {
          context.commit('setChannelConfig', DATA.channelMsg);
          window.TRACKER.setChannelName(DATA.channelMsg.name);
          window.TRACKER.setInternalChannel(DATA.channelMsg.internalChannel);
          return DATA;
        } else {
          window.monitor.stat({
            level: 'error',
            error: 'API-data',
            url: apis["a" /* default */].channelConfig
          });
        }
      });
    },
    receiveCoupon: function receiveCoupon(context, _ref2) {
      var params = _ref2.params;

      return axios_default.a.get(apis["a" /* default */].receiveCoupon, {
        params: params
      }).then(function (res) {
        console.log('获取优惠券', res.data);
        if (res.data.code == 1) {
          callbackHandler(apis["a" /* default */].receiveCoupon, res.data);
          if (params.displayPlace != 4) {
            //报告页不需要窗口
            context.commit('setCouponDialogData', res.data.data);
          }
        }
        return res.data;
      });
    },
    fetchVipinfo: function fetchVipinfo(context, _ref3) {
      var params = _ref3.params;

      return axios_default.a.get(apis["a" /* default */].getVipInfo, {
        params: params
      }).then(function (res) {
        console.log('vip状态信息', res.data);
        if (res.data.code == 1 && res.data.data) {
          callbackHandler(apis["a" /* default */].getVipInfo, res.data);
          context.commit('setVipInfo', res.data.data);
        }
        return res.data;
      });
    },

    // 会员弹窗接口
    fecthVipPopWindow: function fecthVipPopWindow(context, params) {
      return axios_default.a.get(apis["a" /* default */].vipPopWindow, {
        params: params.params
      }).then(function (res) {
        if (res.data.code == 1) {
          callbackHandler(apis["a" /* default */].vipPopWindow, res);
          context.commit('setVipPopWindow', res.data.data);
          return res.data;
        }
      });
    },

    // 会员弹窗接口
    fetchAdsense: function fetchAdsense(context, params) {
      return axios_default.a.get(apis["a" /* default */].fetchAdsense, {
        params: params.params
      }).then(function (res) {
        var data = res.data;
        if (data && data.code == 200) {
          callbackHandler(apis["a" /* default */].fetchAdsense, res);
          context.commit('setAdsense', data.data);
          return data;
        }
      });
    }
  }
});

/* harmony default export */ var store_store = __webpack_exports__["a"] = (store);

/***/ }),

/***/ "wxAW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "x78i":
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),

/***/ "x9zv":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("Y1aA");
var createDesc = __webpack_require__("fU25");
var toIObject = __webpack_require__("PHqh");
var toPrimitive = __webpack_require__("s4j0");
var has = __webpack_require__("WBcL");
var IE8_DOM_DEFINE = __webpack_require__("xZa+");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("bUqO") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "xAdt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__("oeih");
var defined = __webpack_require__("/whu");

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),

/***/ "xCpI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var toObject = __webpack_require__("FryR");
var toPrimitive = __webpack_require__("s4j0");
var getPrototypeOf = __webpack_require__("KOrd");
var getOwnPropertyDescriptor = __webpack_require__("x9zv").f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__("bUqO") && $export($export.P + __webpack_require__("dm6P"), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),

/***/ "xGkn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("4mcu");
var step = __webpack_require__("EGZi");
var Iterators = __webpack_require__("/bQp");
var toIObject = __webpack_require__("TcQ7");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("vIB/")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "xH/j":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("hJx8");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "xLtR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var transformData = __webpack_require__("TNV1");
var isCancel = __webpack_require__("pBtG");
var defaults = __webpack_require__("KCLY");
var isAbsoluteURL = __webpack_require__("dIwP");
var combineURLs = __webpack_require__("qRfI");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "xMpm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("Ds5P");
var createProperty = __webpack_require__("bSML");

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__("zgIt")(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),

/***/ "xONB":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__("Ds5P");

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),

/***/ "xWsF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/qrCodeMaker.vue?vue&type=template&id=3996075a&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrCoder"})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/common/qrCodeMaker.vue?vue&type=template&id=3996075a&

// EXTERNAL MODULE: ./src/lib/qrcode.js
var qrcode = __webpack_require__("lmiR");
var qrcode_default = /*#__PURE__*/__webpack_require__.n(qrcode);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/qrCodeMaker.vue?vue&type=script&lang=js&
//
//
//
//
//



/* harmony default export */ var qrCodeMakervue_type_script_lang_js_ = ({
    name: 'QRCode',
    props: {
        propContent: {
            required: true,
            type: String,
            default: ''
        },
        size: {
            required: false,
            type: Number,
            default: 0
        }
    },
    data: function data() {
        return {
            qrcode: null,
            qrcodeIMG: ''
        };
    },
    mounted: function mounted() {
        var _this = this;

        var CorrectLevelCode = 'L';
        var size = this.size ? this.size : this.$el.parentNode.offsetWidth;
        // console.log('qrcode size is '+size)
        this.qrcode = new qrcode_default.a(this.$el, { text: this.propContent, width: size, height: size }, CorrectLevelCode);
        this.$nextTick(function () {
            var imgEl = _this.$el.querySelector('img');
            var isImgHidden = imgEl.style.display === 'none';
            // 如果二维码图片没有展示，则手动生成图片的地址
            if (isImgHidden) {
                imgEl.style.display = 'block';
                imgEl.setAttribute('src', _this.qrcode._oDrawing._elCanvas.toDataURL());
                _this.qrcode._oDrawing._elCanvas.style.display = "none";
            }
            imgEl.addEventListener('load', function () {
                _this.$emit('qrCodeLoad');
            });
        });
    },

    watch: {
        'propContent': function propContent() {
            new qrcode_default.a(this.$el, this.propContent);
        },
        qrcodeIMG: function qrcodeIMG(val) {
            console.log(val);
            console.log('qrcodeIMG');
            if (val) {
                this.$emit('setCodeImg', val);
            }
        }
    }
});
// CONCATENATED MODULE: ./src/components/common/qrCodeMaker.vue?vue&type=script&lang=js&
 /* harmony default export */ var common_qrCodeMakervue_type_script_lang_js_ = (qrCodeMakervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("K1/g");

// CONCATENATED MODULE: ./src/components/common/qrCodeMaker.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  common_qrCodeMakervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var qrCodeMaker = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "xZa+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("bUqO") && !__webpack_require__("zgIt")(function () {
  return Object.defineProperty(__webpack_require__("jhxf")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "xn9I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__("Ymdd")('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),

/***/ "xnc9":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "y325":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Ds5P");
var fails = __webpack_require__("zgIt");
var defined = __webpack_require__("/whu");
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),

/***/ "y9m4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("V3l/");
var global = __webpack_require__("OzIq");
var ctx = __webpack_require__("rFzY");
var classof = __webpack_require__("wC1N");
var $export = __webpack_require__("Ds5P");
var isObject = __webpack_require__("UKM+");
var aFunction = __webpack_require__("XSOZ");
var anInstance = __webpack_require__("9GpA");
var forOf = __webpack_require__("vmSO");
var speciesConstructor = __webpack_require__("7O1s");
var task = __webpack_require__("Sejc").set;
var microtask = __webpack_require__("g36u")();
var newPromiseCapabilityModule = __webpack_require__("w6Dh");
var perform = __webpack_require__("SDXa");
var userAgent = __webpack_require__("41xE");
var promiseResolve = __webpack_require__("nphH");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("kkCw")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("A16L")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("yYvK")($Promise, PROMISE);
__webpack_require__("CEne")(PROMISE);
Wrapper = __webpack_require__("7gX0")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("qkyc")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "yJ2x":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("wCso");
var anObject = __webpack_require__("DIVP");
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),

/***/ "yOtE":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("wCso");
var anObject = __webpack_require__("DIVP");
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),

/***/ "yYvK":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("lDLk").f;
var has = __webpack_require__("WBcL");
var TAG = __webpack_require__("kkCw")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "ydD5":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "yuXV":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__("Ds5P");
var _isFinite = __webpack_require__("OzIq").isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),

/***/ "yx1U":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__("Ds5P");
var gOPD = __webpack_require__("x9zv").f;
var anObject = __webpack_require__("DIVP");

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),

/***/ "zCYm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__("FryR");
var toAbsoluteIndex = __webpack_require__("zo/l");
var toLength = __webpack_require__("BbyF");
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "zPm4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_showIndex_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__("P2ln");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_showIndex_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_showIndex_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_9_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_9_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_lib_index_js_ref_9_3_node_modules_sass_loader_lib_loader_js_ref_9_4_node_modules_vue_loader_lib_index_js_vue_loader_options_showIndex_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ "zQR9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("h65t")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("vIB/")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "zX4R":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/page-title-1.722464a.png";

/***/ }),

/***/ "zZHq":
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__("wCso");
var anObject = __webpack_require__("DIVP");
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),

/***/ "zgIt":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "zmx7":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__("Ds5P");
var ownKeys = __webpack_require__("YUr7");
var toIObject = __webpack_require__("PHqh");
var gOPD = __webpack_require__("x9zv");
var createProperty = __webpack_require__("bSML");

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),

/***/ "zo/l":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("oeih");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "zq/X":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("UKM+");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ })

/******/ });


// WEBPACK FOOTER //
// static/js/app.9968bf58fa99c74432dc.js